/* [2026-09-26] 깔끔한 주소 — ai-pia.kr/sample/<student|parent|teacher> 는
   ?sample=1&aud=<대상> 과 같다(서버 static.mjs 가 test.html 을 준다, 주소창 그대로).
   이 파일의 쿼리 읽기는 전부 이 함수를 거친다. 그 밖의 경로에서는 location.search 그대로. */
function piaEffectiveSearch(){
  var s = location.search || '';
  try{
    var m = /^\/sample\/(student|parent|teacher)\/?$/.exec(location.pathname || '');
    if(!m) return s;
    var q = new URLSearchParams(s);
    q.set('sample', '1');
    q.set('aud', m[1]);
    return '?' + q.toString();
  }catch(e){ return s; }
}


// =================================================================
//  AI PIA MVP v3 — 검증된 검사 도구 데이터 (별도 파일로 inline됨)
//  모든 항목은 공유저작(public domain) 또는 비영리 학술 사용 허용 도구
// =================================================================

// -----------------------------------------------------------------
// 1. IPIP Big-Five Markers (50 items, public domain, Goldberg 1992)
//    출처: ipip.ori.org / openpsychometrics.org
//    Big5: E(외향), A(우호), C(성실), N(정서불안), O(개방)
//    +/-: 정방향(1)/역방향(-1)
// -----------------------------------------------------------------
const IPIP_BIG5_50 = [
  { f:'E', s: 1, t:'나는 모임에서 분위기를 이끄는 편이다.' },
  { f:'A', s:-1, t:'나는 다른 사람을 별로 걱정해 주지 않는다.' },
  { f:'C', s: 1, t:'나는 무슨 일이든 미리 준비해 둔다.' },
  { f:'N', s: 1, t:'나는 쉽게 스트레스를 받는다.' },
  { f:'O', s: 1, t:'나는 아는 낱말이 많은 편이다.' },
  { f:'E', s:-1, t:'나는 말을 많이 하지 않는다.' },
  { f:'A', s: 1, t:'나는 사람들에게 관심이 많다.' },
  { f:'C', s:-1, t:'나는 내 물건을 여기저기 늘어놓는다.' },
  { f:'N', s:-1, t:'나는 대체로 마음이 느긋하다.' },
  { f:'O', s:-1, t:'나는 추상적인 개념은 이해하기 어렵다.' },
  { f:'E', s: 1, t:'나는 사람들과 함께 있으면 마음이 편하다.' },
  { f:'A', s:-1, t:'나는 남에게 상처 주는 말을 할 때가 있다.' },
  { f:'C', s: 1, t:'나는 작은 부분까지 꼼꼼히 챙긴다.' },
  { f:'N', s: 1, t:'나는 이런저런 걱정이 많다.' },
  { f:'O', s: 1, t:'나는 상상력이 풍부하다.' },
  { f:'E', s:-1, t:'나는 나서지 않고 뒤에 있는 편이다.' },
  { f:'A', s: 1, t:'나는 다른 사람의 마음에 잘 공감한다.' },
  { f:'C', s:-1, t:'나는 일을 어수선하게 벌여 놓는 편이다.' },
  { f:'N', s:-1, t:'나는 우울해지는 일이 거의 없다.' },
  { f:'O', s:-1, t:'나는 추상적인 생각에는 흥미가 없다.' },
  { f:'E', s: 1, t:'나는 먼저 말을 걸어 대화를 시작한다.' },
  { f:'A', s:-1, t:'나는 다른 사람이 겪는 문제에는 마음이 가지 않는다.' },
  { f:'C', s: 1, t:'나는 해야 할 일은 미루지 않고 바로 한다.' },
  { f:'N', s: 1, t:'나는 작은 일에도 쉽게 마음이 흔들린다.' },
  { f:'O', s: 1, t:'나는 좋은 생각을 자주 떠올린다.' },
  { f:'E', s:-1, t:'나는 딱히 할 말이 떠오르지 않는다.' },
  { f:'A', s: 1, t:'나는 어려운 처지의 사람을 보면 마음이 쓰인다.' },
  { f:'C', s:-1, t:'나는 쓴 물건을 제자리에 돌려놓는 걸 자주 잊는다.' },
  { f:'N', s: 1, t:'나는 쉽게 화가 나거나 속상해진다.' },   /* EST6 — 2026-11-02 공식 IPIP 원문·키로 되돌림 */
  { f:'O', s:-1, t:'나는 새로운 것을 머릿속에 그려 보는 일이 서툴다.' },
  { f:'E', s: 1, t:'나는 모임에서 여러 사람과 두루 이야기한다.' },
  { f:'A', s:-1, t:'나는 사람 자체에 별로 흥미를 느끼지 않는다.' },   /* AGR7 (I am not really interested in others) */
  { f:'C', s: 1, t:'나는 정돈된 상태를 좋아한다.' },
  { f:'N', s: 1, t:'나는 기분이 자주 바뀐다.' },
  { f:'O', s: 1, t:'나는 무엇이든 빨리 이해하는 편이다.' },
  { f:'E', s:-1, t:'나는 나에게 시선이 쏠리는 것이 싫다.' },
  { f:'A', s: 1, t:'나는 다른 사람을 위해 시간을 낸다.' },   /* AGR8 (I take time out for others) */
  { f:'C', s:-1, t:'나는 해야 할 일을 슬쩍 피할 때가 있다.' },   /* CSN8 (I shirk my duties) */
  { f:'N', s: 1, t:'나는 기분이 자주 오르락내리락한다.' },   /* EST8 (I have frequent mood swings) */
  { f:'O', s: 1, t:'나는 어려운 낱말도 잘 골라 쓴다.' },
  { f:'E', s: 1, t:'나는 주목받는 것이 싫지 않다.' },
  { f:'A', s: 1, t:'나는 다른 사람의 기분을 잘 알아챈다.' },
  { f:'C', s: 1, t:'나는 정해진 시간표대로 움직인다.' },
  { f:'N', s: 1, t:'나는 쉽게 짜증이 난다.' },
  { f:'O', s: 1, t:'나는 무언가를 곰곰이 되짚어 보는 것을 좋아한다.' },
  { f:'E', s:-1, t:'나는 낯선 사람들과 있으면 말이 없어진다.' },
  { f:'A', s: 1, t:'나는 사람들을 편하게 해 준다.' },
  { f:'C', s: 1, t:'나는 일을 할 때 꼼꼼하고 정확하게 한다.' },   /* CSN10 (I am exacting in my work) */
  { f:'N', s: 1, t:'나는 이유 없이 우울할 때가 많다.' },
  { f:'O', s: 1, t:'나는 머릿속에 아이디어가 가득하다.' }
];
/* [2026-11-02 E2-D] 문항 키 판(version). 2026.11.2 에서 6문항(EST6·AGR7·AGR8·CSN8·EST8·CSN10)을
   공식 IPIP 원문·채점 방향으로 되돌렸다(docs/결과지_문항대조검증_IPIP.md 3절).
   응답 묶음 results.big5.kv 가 이 값일 때만 새 키로 채점하고, kv 가 없는 예전 결과는 예전 키 그대로 채점한다
   (서버 api/src/scoring.js 도 같은 규칙 — 예전 결과지의 점수는 바뀌지 않는다). */
const PIA_BIG5_KV = 'ipip50-2026.11.2';
/* 예전(~2026.11.1) 키 — 채점용 f·s 만. tools/extract-scoring-keys.mjs 가 big5_v1 로 뽑아 서버에 넘긴다. */
const IPIP_BIG5_50_KEYS_V1 = [
  {f:'E',s:1},{f:'A',s:-1},{f:'C',s:1},{f:'N',s:1},{f:'O',s:1},{f:'E',s:-1},{f:'A',s:1},{f:'C',s:-1},{f:'N',s:-1},{f:'O',s:-1},
  {f:'E',s:1},{f:'A',s:-1},{f:'C',s:1},{f:'N',s:1},{f:'O',s:1},{f:'E',s:-1},{f:'A',s:1},{f:'C',s:-1},{f:'N',s:-1},{f:'O',s:-1},
  {f:'E',s:1},{f:'A',s:-1},{f:'C',s:1},{f:'N',s:1},{f:'O',s:1},{f:'E',s:-1},{f:'A',s:1},{f:'C',s:-1},{f:'N',s:-1},{f:'O',s:-1},
  {f:'E',s:1},{f:'A',s:1},{f:'C',s:1},{f:'N',s:1},{f:'O',s:1},{f:'E',s:-1},{f:'A',s:-1},{f:'C',s:1},{f:'N',s:-1},{f:'O',s:1},
  {f:'E',s:1},{f:'A',s:1},{f:'C',s:1},{f:'N',s:1},{f:'O',s:1},{f:'E',s:-1},{f:'A',s:1},{f:'C',s:-1},{f:'N',s:1},{f:'O',s:1}
];
/* 이 응답 묶음을 채점할 문항 키 — kv 가 지금 판이면 IPIP_BIG5_50, 아니면 예전 키 */
function piaBig5Items(R){
  R = R || (typeof state !== 'undefined' && state.results && state.results.big5) || {};
  return R.kv === PIA_BIG5_KV ? IPIP_BIG5_50 : IPIP_BIG5_50_KEYS_V1;
}

// -----------------------------------------------------------------
// 2. RIASEC 30 items (Holland 이론, openpsychometrics 기반 변형)
//    R, I, A, S, E, C 각 5문항
// -----------------------------------------------------------------
const RIASEC_30 = [
  { f:'R', t:'기계나 도구를 다루는 일을 좋아한다.' },
  { f:'R', t:'야외에서 활동하는 것을 좋아한다.' },
  { f:'R', t:'손으로 무언가를 직접 만드는 것이 즐겁다.' },
  { f:'R', t:'운동·신체활동이 적성에 맞는다.' },
  { f:'R', t:'기계 작동 원리에 호기심이 있다.' },
  { f:'I', t:'과학·수학 문제를 푸는 것이 재미있다.' },
  { f:'I', t:'복잡한 현상의 원인을 파악하는 것이 좋다.' },
  { f:'I', t:'책을 읽고 새로운 지식을 얻는 것을 즐긴다.' },
  { f:'I', t:'실험이나 조사 활동에 흥미가 있다.' },
  { f:'I', t:'논리적으로 분석하는 것을 잘한다.' },
  { f:'A', t:'그림·디자인·음악 같은 창작 활동을 좋아한다.' },
  { f:'A', t:'독창적인 아이디어를 떠올리는 것을 즐긴다.' },
  { f:'A', t:'글쓰기·이야기 만들기가 재미있다.' },
  { f:'A', t:'미적 감각을 발휘할 수 있는 일이 좋다.' },
  { f:'A', t:'전통보다 새로운 시도를 선호한다.' },
  { f:'S', t:'다른 사람을 돕는 일에 보람을 느낀다.' },
  { f:'S', t:'친구의 고민을 잘 들어주는 편이다.' },
  { f:'S', t:'사람들에게 무언가를 가르치는 것이 즐겁다.' },
  { f:'S', t:'팀에서 협력하는 것을 선호한다.' },
  { f:'S', t:'사회 봉사 활동에 관심이 있다.' },
  { f:'E', t:'사람들을 이끌고 결정하는 역할이 잘 맞는다.' },
  { f:'E', t:'경쟁에서 이기는 것이 동기가 된다.' },
  { f:'E', t:'발표·토론에서 자신 있게 의견을 말한다.' },
  { f:'E', t:'새로운 사업·프로젝트 아이디어가 떠오른다.' },
  { f:'E', t:'위험을 감수하더라도 도전하는 편이다.' },
  { f:'C', t:'정해진 규칙·계획을 잘 지키는 편이다.' },
  { f:'C', t:'숫자·자료를 정리하는 일이 적성에 맞는다.' },
  { f:'C', t:'세세한 부분을 정확하게 처리한다.' },
  { f:'C', t:'반복적이고 안정된 업무를 선호한다.' },
  { f:'C', t:'체계적으로 일정을 관리한다.' }
];

// -----------------------------------------------------------------
// 3. 24 character strengths (1 item each) — IPIP-VIA 기반(Public Domain)
//    자체 작성 한국어 문항 · 출처 표기: IPIP-VIA Character Scales (ipip.ori.org)
// -----------------------------------------------------------------
const VIA_YOUTH = [
  { f:'창의', t:'나는 새로운 아이디어를 잘 떠올린다.' },
  { f:'호기심', t:'나는 새로운 것에 관심이 많다.' },
  { f:'판단', t:'나는 결정을 내리기 전에 다양한 측면을 살핀다.' },
  { f:'학습열정', t:'나는 새로운 것을 배우는 것을 즐긴다.' },
  { f:'통찰', t:'나는 친구가 고민할 때 좋은 조언을 해준다.' },
  { f:'용기', t:'나는 옳다고 생각하는 일은 용기 내어 한다.' },
  { f:'끈기', t:'나는 어려워도 끝까지 해낸다.' },
  { f:'정직', t:'나는 늘 사실대로 말한다.' },
  { f:'활력', t:'나는 활기차고 에너지가 넘친다.' },
  { f:'사랑', t:'나는 가족·친구를 소중히 여긴다.' },
  { f:'친절', t:'나는 다른 사람을 잘 돕는다.' },
  { f:'사회지능', t:'나는 사람들의 기분을 잘 읽는다.' },
  { f:'협력', t:'나는 팀에서 잘 어울려 일한다.' },
  { f:'공정', t:'나는 모든 사람을 똑같이 대한다.' },
  { f:'리더십', t:'나는 사람들을 이끄는 역할이 잘 맞는다.' },
  { f:'용서', t:'나는 누군가 실수했을 때 용서할 줄 안다.' },
  { f:'겸손', t:'나는 나를 내세우기보다 겸손한 편이다.' },
  { f:'신중', t:'나는 행동하기 전에 한 번 더 생각한다.' },
  { f:'자기조절', t:'나는 감정을 잘 조절한다.' },
  { f:'심미안', t:'나는 아름다운 것에 감동을 잘 받는다.' },
  { f:'감사', t:'나는 사소한 일에도 감사함을 자주 느낀다.' },
  { f:'희망', t:'나는 미래가 좋아질 것이라고 믿는다.' },
  { f:'유머', t:'나는 사람들을 잘 웃게 한다.' },
  { f:'영성', t:'나는 인생에서 의미를 자주 생각한다.' }
];

// -----------------------------------------------------------------
// 4. 끈기·근면 8문항 — IPIP Industriousness/Perseverance 기반(Public Domain)
//    자체 작성 한국어 문항 · Perseverance(끈기, P) / Consistency(일관성, C)
// -----------------------------------------------------------------
const GRIT_S = [
  { f:'C', s:-1, t:'새로운 일이 생기면 하던 일에 대한 관심이 흐트러질 때가 있다.' },
  { f:'C', s:-1, t:'어떤 일에 잠깐 푹 빠졌다가 나중에 흥미를 잃은 적이 있다.' },
  { f:'P', s: 1, t:'좌절은 나를 단념시키지 않는다.' },
  { f:'P', s: 1, t:'나는 무슨 일이든 열심히 하는 편이다.' },
  { f:'C', s:-1, t:'목표를 세웠다가 나중에 다른 것을 추구하는 경우가 종종 있다.' },
  { f:'C', s:-1, t:'몇 달 넘게 걸리는 일에는 집중을 이어가기 어렵다.' },
  { f:'P', s: 1, t:'한번 시작한 일은 끝까지 마친다.' },
  { f:'P', s: 1, t:'나는 부지런하다.' }
];

// -----------------------------------------------------------------
// 5. CES-D-10 (10-item Short Korean version, public domain)
//    지난 일주일 동안의 빈도 (0=거의 없음, 3=대부분)
// -----------------------------------------------------------------
const CES_D_10 = [
  { s: 1, t:'평소에 별 일이 아닌데도 신경이 쓰였다.' },
  { s: 1, t:'식욕이 없었다.' },
  { s: 1, t:'가족이나 친구들이 도와주려 해도 우울한 기분이 나아지지 않았다.' },
  { s:-1, t:'나는 다른 사람만큼 능력이 있다고 느꼈다.' },
  { s: 1, t:'무슨 일을 해도 집중하기가 어려웠다.' },
  { s: 1, t:'우울했다.' },
  { s: 1, t:'무슨 일을 하든 힘들게 느껴졌다.' },
  { s:-1, t:'미래에 대해 희망적이었다.' },
  { s: 1, t:'내 인생이 실패한 것처럼 느껴졌다.' },
  { s: 1, t:'두려움이 느껴졌다.' }
];

// -----------------------------------------------------------------
// 6. PHQ-A (Adolescent, 9 items, free use)
//    지난 2주 동안 0~3점
// -----------------------------------------------------------------
const PHQ_A = [
  '일에 흥미나 즐거움이 거의 없었다.',
  '기분이 가라앉거나 우울하거나 절망적으로 느꼈다.',
  '잠들기 어렵거나 자주 깨거나 너무 많이 잤다.',
  '피곤하거나 기운이 없었다.',
  '식욕이 떨어지거나 과식했다.',
  '내가 실패자라고 느끼거나 자책했다.',
  '집중하기 어려웠다 (예: 공부, TV 시청 등).',
  '말이나 행동이 느려졌거나 반대로 너무 안절부절못했다.',
  '차라리 죽는 것이 낫다거나 자해 생각이 들었다.'  // 마지막 문항: 위험 신호
];

// -----------------------------------------------------------------
// 7. GAD-7 (불안 척도, free use)
//    지난 2주 동안 0~3점
// -----------------------------------------------------------------
const GAD_7 = [
  '신경이 예민하거나 불안하거나 조마조마했다.',
  '걱정을 멈추거나 통제할 수 없었다.',
  '여러 가지 일에 대해 지나치게 걱정했다.',
  '편하게 있기 어려웠다.',
  '안절부절못해서 가만히 앉아있기 어려웠다.',
  '쉽게 짜증이 나거나 화가 났다.',
  '끔찍한 일이 일어날 것처럼 두려웠다.'
];

// -----------------------------------------------------------------
// 8. SJT 30 시나리오 (이전 v2에서 확장)
// -----------------------------------------------------------------
const SJT_30 = [
  { q:'모둠 과제 발표가 내일까지인데 한 친구가 자기 분량을 안 했어요.', choices:[
    { t:'친구에게 차분히 같이 끝낼 방법을 찾자고 한다', w:{공감:2,책임:1} },
    { t:'내가 그 분량까지 빠르게 마무리한다', w:{실천:2,책임:1} },
    { t:'선생님께 사실을 말씀드리고 상의한다', w:{계획:2,공감:1} },
    { t:'친구에게 단호히 오늘 안에 해와 라고 말한다', w:{도전:2,계획:1} }
  ]},
  { q:'쉬는 시간에 친구들이 새로운 게임 얘기를 합니다.', choices:[
    { t:'관심이 가서 끼어들어 같이 얘기한다', w:{외향:2,공감:1} },
    { t:'잘 모르지만 조용히 들으며 분위기를 살핀다', w:{관찰:2,공감:1} },
    { t:'다른 친구에게 다른 얘기를 시작한다', w:{도전:1,자유:1} },
    { t:'책을 읽거나 혼자만의 시간을 갖는다', w:{내향:2,탐구:1} }
  ]},
  { q:'내일 영어 단어 시험인데 모르는 단어가 너무 많아요.', choices:[
    { t:'단어를 카테고리별로 정리한 후 핵심부터 외운다', w:{계획:2,분석:1} },
    { t:'그림이나 이야기로 단어를 연결해 외운다', w:{창의:2,감성:1} },
    { t:'친구랑 같이 퀴즈 형식으로 외운다', w:{공감:2,외향:1} },
    { t:'완벽하지 않아도 좋아하는 단어만 골라 외운다', w:{자유:2,현실:1} }
  ]},
  { q:'좋아하는 친구가 다른 친구랑 더 친해지고 있어요.', choices:[
    { t:'먼저 말을 걸어 약속을 잡는다', w:{외향:2,도전:1} },
    { t:'서운한 마음을 솔직히 표현한다', w:{공감:2,감성:1} },
    { t:'시간이 지나면 자연스러워질 거라 생각하고 기다린다', w:{관찰:2,균형:1} },
    { t:'다른 친구들과의 관계에 집중한다', w:{자유:1,실천:1} }
  ]},
  { q:'장래희망을 적어내라고 하는데 떠오르지 않아요.', choices:[
    { t:'좋아하는 활동을 적고 그에 맞는 직업을 찾는다', w:{탐구:2,분석:1} },
    { t:'드라마/책에서 본 인상적인 인물을 떠올린다', w:{창의:2,감성:1} },
    { t:'친구들이나 부모님께 의견을 물어본다', w:{공감:2,균형:1} },
    { t:'우선 탐색 중이라고 솔직히 적는다', w:{자유:1,현실:1} }
  ]},
  { q:'담임선생님이 학급 회장 추천을 받습니다.', choices:[
    { t:'본인이 직접 도전해본다', w:{도전:2,실천:2} },
    { t:'평소 친구들 의견을 잘 듣는 친구를 추천한다', w:{공감:2,관찰:1} },
    { t:'성실하고 책임감 있는 친구를 추천한다', w:{책임:2,계획:1} },
    { t:'특별히 추천하지 않고 다수 의견을 따른다', w:{균형:1,현실:1} }
  ]},
  { q:'주말에 시간이 생겼어요.', choices:[
    { t:'새로운 곳에 가거나 이벤트에 참여한다', w:{도전:2,외향:2} },
    { t:'좋아하는 그림이나 글을 쓴다', w:{창의:2,감성:1} },
    { t:'친구들과 만나서 논다', w:{외향:2,공감:1} },
    { t:'집에서 책을 읽거나 영상을 본다', w:{내향:2,탐구:1} }
  ]},
  { q:'친구가 비밀을 털어놓았는데 다른 친구가 묻습니다.', choices:[
    { t:'내가 말할 수 없어 라고 단호히 말한다', w:{책임:2,계획:1} },
    { t:'본인에게 직접 물어봐 라고 부드럽게 말한다', w:{공감:2,균형:1} },
    { t:'대화를 다른 주제로 자연스럽게 돌린다', w:{관찰:2,자유:1} },
    { t:'전혀 모른다고 둘러댄다', w:{현실:1,균형:1} }
  ]},
  { q:'학원에서 어려운 문제가 안 풀려요.', choices:[
    { t:'시간이 걸려도 끝까지 혼자 풀어본다', w:{책임:2,분석:1} },
    { t:'다른 풀이법을 인터넷에서 찾아본다', w:{탐구:2,창의:1} },
    { t:'친구나 선생님에게 묻는다', w:{공감:1,실천:2} },
    { t:'잠시 미뤄두고 쉬운 문제부터 한다', w:{균형:1,계획:1} }
  ]},
  { q:'엄마가 평소보다 늦게 들어오십니다.', choices:[
    { t:'전화나 메시지로 확인한다', w:{공감:2,책임:1} },
    { t:'기다리다 보면 오시겠지 하고 내 할 일을 한다', w:{균형:2,자유:1} },
    { t:'아빠나 형제에게 물어본다', w:{공감:1,관찰:1} },
    { t:'걱정되어 마중을 나가본다', w:{공감:2,실천:1} }
  ]},
  { q:'반에서 비공식적인 단체방에 욕설이 올라옵니다.', choices:[
    { t:'그만하자 라고 단호히 말한다', w:{책임:2,도전:1} },
    { t:'화면을 캡처해 선생님께 알린다', w:{계획:2,책임:1} },
    { t:'단체방을 조용히 나간다', w:{관찰:2,자유:1} },
    { t:'당사자에게 개인적으로 메시지를 보낸다', w:{공감:2,관찰:1} }
  ]},
  { q:'좋아하는 가수의 공연 티켓이 생겼는데 시험 기간입니다.', choices:[
    { t:'시험이 우선이므로 표를 양보한다', w:{책임:2,계획:1} },
    { t:'공부 일정을 조정해 다녀온다', w:{창의:2,자유:1} },
    { t:'친구에게 표를 주고 시험 준비를 한다', w:{공감:1,책임:1} },
    { t:'잠깐 들렀다가 바로 돌아온다', w:{균형:1,자유:1} }
  ]},
  { q:'발표 차례인데 갑자기 마이크가 안 됩니다.', choices:[
    { t:'마이크 없이 큰 목소리로 진행한다', w:{도전:2,실천:1} },
    { t:'잠시 멈추고 기기를 다시 확인한다', w:{관찰:2,분석:1} },
    { t:'친구에게 도움을 요청한다', w:{공감:2,균형:1} },
    { t:'선생님께 다음 차례로 미뤄달라고 한다', w:{현실:1,균형:2} }
  ]},
  { q:'아빠가 너무 엄격해서 외출을 못 하게 합니다.', choices:[
    { t:'이유를 차분히 설명하고 허락을 구한다', w:{공감:2,책임:1} },
    { t:'엄마나 다른 가족과 상의한다', w:{관찰:1,공감:2} },
    { t:'일단 받아들이고 다음 기회를 노린다', w:{균형:2,계획:1} },
    { t:'당장은 답답하지만 자기 일을 한다', w:{자유:1,책임:1} }
  ]},
  { q:'친구가 학교에서 도시락을 잘 안 가져옵니다.', choices:[
    { t:'내 도시락을 같이 나눠 먹는다', w:{공감:2,친절:1} },
    { t:'선생님께 살짝 알린다', w:{책임:2,계획:1} },
    { t:'친구에게 이유를 직접 물어본다', w:{공감:1,분석:1} },
    { t:'특별히 신경 쓰지 않고 내 일을 한다', w:{균형:1,자유:1} }
  ]},
  { q:'학교 축제에서 한 코너를 맡게 됐어요.', choices:[
    { t:'아이디어를 모아 새로운 콘텐츠를 기획한다', w:{창의:2,도전:1} },
    { t:'역할을 분담해 효율적으로 운영한다', w:{계획:2,실천:1} },
    { t:'친구들 의견을 모으는 데 집중한다', w:{공감:2,관찰:1} },
    { t:'분위기를 띄우는 사회를 맡는다', w:{외향:2,자유:1} }
  ]},
  { q:'코로나처럼 학교가 잠시 멈춥니다.', choices:[
    { t:'집에서도 규칙적으로 공부한다', w:{계획:2,책임:1} },
    { t:'못 봤던 영상·책에 시간을 쓴다', w:{창의:1,탐구:2} },
    { t:'친구들과 영상통화로 소통한다', w:{공감:2,외향:1} },
    { t:'운동·산책으로 컨디션을 유지한다', w:{현실:2,균형:1} }
  ]},
  { q:'좋아하던 동아리가 갑자기 없어집니다.', choices:[
    { t:'새 동아리를 직접 만들어본다', w:{도전:2,창의:1} },
    { t:'비슷한 다른 동아리를 찾는다', w:{탐구:1,균형:2} },
    { t:'친구들과 함께 학교에 항의한다', w:{책임:2,공감:1} },
    { t:'당분간은 혼자 그 활동을 이어간다', w:{자유:2,책임:1} }
  ]},
  { q:'친구가 게임 아이템을 무리하게 사라고 권합니다.', choices:[
    { t:'단호히 거절한다', w:{책임:2,계획:1} },
    { t:'한도를 정하고 일부만 한다', w:{균형:2,분석:1} },
    { t:'친구 상황을 들어보고 같이 줄이자고 한다', w:{공감:2,책임:1} },
    { t:'친구 의견에 맞춰 일단 사본다', w:{외향:1,자유:1} }
  ]},
  { q:'좋아하는 과목의 성적이 갑자기 떨어졌습니다.', choices:[
    { t:'오답 노트를 분석해 원인을 찾는다', w:{분석:2,책임:1} },
    { t:'다른 친구의 공부법을 참고한다', w:{공감:1,탐구:1} },
    { t:'좋아하던 마음 자체에 집중한다', w:{감성:1,균형:1} },
    { t:'선생님께 상담을 요청한다', w:{책임:2,공감:1} }
  ]},
  { q:'친구가 새 친구를 사귀어서 잘 안 놀아줘요.', choices:[
    { t:'새 친구와 함께 어울려본다', w:{공감:2,균형:1} },
    { t:'다른 친구들과 새로운 관계를 만든다', w:{외향:1,도전:2} },
    { t:'그 친구에게 솔직한 마음을 말한다', w:{공감:2,감성:1} },
    { t:'각자 시간을 보내며 자연스럽게 둔다', w:{균형:2,자유:1} }
  ]},
  { q:'스마트폰을 너무 오래 봐서 부모님이 걱정합니다.', choices:[
    { t:'사용 시간을 스스로 정하고 지킨다', w:{책임:2,계획:1} },
    { t:'유익한 콘텐츠 위주로 본다', w:{탐구:1,균형:1} },
    { t:'알람을 설정해 시간을 관리한다', w:{계획:2,실천:1} },
    { t:'친구와 약속을 잡고 밖에 나간다', w:{외향:1,실천:1} }
  ]},
  { q:'학교에서 봉사활동을 제안받았어요.', choices:[
    { t:'무엇이든 적극 참여한다', w:{공감:2,실천:1} },
    { t:'관심 분야와 맞으면 참여한다', w:{탐구:1,균형:1} },
    { t:'시간이 맞으면 참여한다', w:{균형:2,책임:1} },
    { t:'이번엔 학업에 집중한다', w:{책임:1,계획:1} }
  ]},
  { q:'어른들이 이해하기 어려운 결정을 합니다.', choices:[
    { t:'그 이유를 물어본다', w:{탐구:2,공감:1} },
    { t:'이해하지 못해도 일단 따른다', w:{균형:2,책임:1} },
    { t:'다른 어른의 의견도 들어본다', w:{공감:1,관찰:1} },
    { t:'옳지 않다면 차분히 의견을 말한다', w:{도전:1,책임:2} }
  ]},
  { q:'친구가 시험에서 부정행위를 하려 합니다.', choices:[
    { t:'그만하라고 단호히 말린다', w:{책임:2,도전:1} },
    { t:'결과는 본인 책임이라고 알려준다', w:{관찰:1,책임:1} },
    { t:'시험 후에 따로 대화한다', w:{공감:2,균형:1} },
    { t:'선생님께 알린다', w:{책임:2,계획:1} }
  ]},
  { q:'좋아하는 분야의 책이 너무 어렵습니다.', choices:[
    { t:'천천히 한 페이지씩 읽는다', w:{끈기:2,탐구:1} },
    { t:'쉬운 입문서로 다시 시작한다', w:{균형:1,계획:1} },
    { t:'영상이나 강의로 보완한다', w:{탐구:2,창의:1} },
    { t:'친구·선생님과 토론한다', w:{공감:1,외향:1} }
  ]},
  { q:'동생/형제 때문에 자주 다툼이 생깁니다.', choices:[
    { t:'대화 규칙을 정한다', w:{계획:2,책임:1} },
    { t:'서로 떨어져 있는 시간을 갖는다', w:{균형:2,자유:1} },
    { t:'부모님께 도움을 청한다', w:{공감:1,책임:1} },
    { t:'먼저 사과하고 화해한다', w:{공감:2,감성:1} }
  ]},
  { q:'학교가 너무 가기 싫어요.', choices:[
    { t:'기분을 일기로 정리한다', w:{감성:2,자유:1} },
    { t:'친한 친구와 대화로 풀어본다', w:{공감:2,외향:1} },
    { t:'담임/상담선생님께 도움을 요청한다', w:{책임:2,공감:1} },
    { t:'한 가지라도 좋아하는 일을 찾는다', w:{탐구:2,균형:1} }
  ]},
  { q:'학원·과외와 학교가 겹쳐 너무 힘듭니다.', choices:[
    { t:'부모님과 우선순위를 정한다', w:{계획:2,책임:1} },
    { t:'시간표를 새로 짜본다', w:{계획:2,분석:1} },
    { t:'한 가지를 잠시 줄여본다', w:{균형:2,자유:1} },
    { t:'끝까지 모두 해낸다', w:{책임:2,끈기:1} }
  ]},
  { q:'미래에 대해 막연한 불안이 있어요.', choices:[
    { t:'관심 분야를 한 가지씩 탐색한다', w:{탐구:2,균형:1} },
    { t:'멘토/선배의 이야기를 듣는다', w:{공감:1,탐구:2} },
    { t:'지금 할 수 있는 작은 일에 집중한다', w:{현실:2,책임:1} },
    { t:'친구·가족과 생각을 나눈다', w:{공감:2,감성:1} }
  ]}
];

// 8-b. 성인(일반인) 응답자용 SJT 18 시나리오 — 직장·생활·관계 맥락
const SJT_ADULT = [
  { q:'회의에서 낸 의견이 충분히 검토되지 않고 넘어갔습니다.', choices:[
    { t:'근거를 정리해 다시 제안한다', w:{책임:2,분석:1} },
    { t:'끝나고 결정권자에게 따로 설명한다', w:{계획:2,실천:1} },
    { t:'동료들의 반응을 살피며 기회를 본다', w:{관찰:2,균형:1} },
    { t:'이번엔 넘기고 다음을 준비한다', w:{현실:2,자유:1} }
  ]},
  { q:'동료가 마감을 못 지켜 내 업무까지 밀리고 있습니다.', choices:[
    { t:'같이 끝낼 방법을 차분히 찾는다', w:{공감:2,책임:1} },
    { t:'내가 그 부분까지 빠르게 처리한다', w:{실천:2,책임:1} },
    { t:'상황을 정리해 상사와 상의한다', w:{계획:2,분석:1} },
    { t:'기한을 분명히 정해 다시 요청한다', w:{도전:2,계획:1} }
  ]},
  { q:'주말인데 상사가 급한 업무를 부탁합니다.', choices:[
    { t:'가능한 범위를 정해 돕겠다고 한다', w:{균형:2,책임:1} },
    { t:'바로 처리하고 마무리한다', w:{실천:2,도전:1} },
    { t:'우선순위를 확인하고 일정을 조율한다', w:{계획:2,분석:1} },
    { t:'개인 일정을 설명하고 양해를 구한다', w:{자유:2,공감:1} }
  ]},
  { q:'팀에 새로운 업무 방식이 도입됐습니다.', choices:[
    { t:'먼저 익혀보고 적극 적용한다', w:{도전:2,실천:1} },
    { t:'장단점을 따져보고 받아들인다', w:{분석:2,탐구:1} },
    { t:'동료들과 맞춰가며 천천히 적응한다', w:{공감:2,균형:1} },
    { t:'필요한 부분만 골라 활용한다', w:{현실:2,자유:1} }
  ]},
  { q:'친한 동료와 일하는 방식에서 의견이 부딪힙니다.', choices:[
    { t:'서로 입장을 먼저 들어본다', w:{공감:2,관찰:1} },
    { t:'내 생각을 솔직하게 전한다', w:{도전:2,감성:1} },
    { t:'절충안을 만들어 제안한다', w:{균형:2,분석:1} },
    { t:'결과로 보여주며 설득한다', w:{실천:2,책임:1} }
  ]},
  { q:'처음 가는 모임에서 아는 사람이 거의 없습니다.', choices:[
    { t:'먼저 다가가 말을 건다', w:{외향:2,도전:1} },
    { t:'분위기를 살피며 자연스럽게 섞인다', w:{관찰:2,균형:1} },
    { t:'관심사가 맞는 한두 명과 깊게 대화한다', w:{공감:2,탐구:1} },
    { t:'편한 만큼만 머문다', w:{내향:2,자유:1} }
  ]},
  { q:'예상치 못한 보너스(목돈)가 생겼습니다.', choices:[
    { t:'계획을 세워 일부 저축·투자한다', w:{계획:2,분석:1} },
    { t:'평소 하고 싶던 경험에 쓴다', w:{자유:2,감성:1} },
    { t:'가족·가까운 사람과 나눈다', w:{공감:2,균형:1} },
    { t:'우선 두고 필요할 때 쓴다', w:{현실:2,관찰:1} }
  ]},
  { q:'더 좋은 조건의 이직 제안을 받았습니다.', choices:[
    { t:'장단점을 표로 정리해 비교한다', w:{분석:2,계획:1} },
    { t:'경험자·멘토에게 조언을 구한다', w:{공감:1,탐구:2} },
    { t:'새로운 도전이라 생각하고 끌린다', w:{도전:2,자유:1} },
    { t:'지금의 안정도 중요하게 본다', w:{현실:2,균형:1} }
  ]},
  { q:'업무에서 실수를 했다는 걸 알게 됐습니다.', choices:[
    { t:'바로 알리고 수습 방법을 찾는다', w:{책임:2,실천:1} },
    { t:'원인을 분석해 재발을 막는다', w:{분석:2,탐구:1} },
    { t:'관련된 사람에게 먼저 사과한다', w:{공감:2,감성:1} },
    { t:'침착하게 우선순위부터 처리한다', w:{균형:2,계획:1} }
  ]},
  { q:'가족(배우자·부모)과 중요한 일에서 의견이 다릅니다.', choices:[
    { t:'상대의 마음을 먼저 헤아린다', w:{공감:2,감성:1} },
    { t:'내 생각을 차분히 설명한다', w:{책임:1,분석:2} },
    { t:'서로 맞는 지점을 찾아 절충한다', w:{균형:2,관찰:1} },
    { t:'시간을 두고 다시 이야기한다', w:{자유:1,관찰:2} }
  ]},
  { q:'오랜만에 온전한 자유 시간이 생겼습니다.', choices:[
    { t:'새로운 곳·활동에 도전한다', w:{도전:2,외향:2} },
    { t:'좋아하는 취미·창작에 몰입한다', w:{창의:2,감성:1} },
    { t:'가까운 사람들과 함께 보낸다', w:{외향:2,공감:1} },
    { t:'집에서 쉬며 재충전한다', w:{내향:2,탐구:1} }
  ]},
  { q:'새로운 기술이나 자격을 익혀야 하는 상황입니다.', choices:[
    { t:'학습 계획을 세워 단계별로 한다', w:{계획:2,책임:1} },
    { t:'직접 부딪히며 빠르게 익힌다', w:{실천:2,도전:1} },
    { t:'스터디·강의로 함께 배운다', w:{공감:1,외향:2} },
    { t:'원리를 깊이 파고들어 이해한다', w:{탐구:2,분석:1} }
  ]},
  { q:'이웃·지인과 사소한 갈등이 생겼습니다.', choices:[
    { t:'먼저 다가가 풀려고 한다', w:{공감:2,도전:1} },
    { t:'상황을 객관적으로 정리해 본다', w:{분석:2,관찰:1} },
    { t:'서로 불편하지 않게 거리를 둔다', w:{균형:2,자유:1} },
    { t:'필요하면 분명히 입장을 말한다', w:{책임:2,실천:1} }
  ]},
  { q:'건강관리를 새로 시작하려고 합니다.', choices:[
    { t:'목표와 루틴을 구체적으로 정한다', w:{계획:2,책임:1} },
    { t:'일단 가볍게 바로 시작한다', w:{실천:2,현실:1} },
    { t:'같이 할 사람을 구해 동기부여한다', w:{외향:2,공감:1} },
    { t:'나에게 맞는 방법을 찾아본다', w:{탐구:2,분석:1} }
  ]},
  { q:'후배·신입을 지도해야 하는 역할을 맡았습니다.', choices:[
    { t:'눈높이에 맞춰 차근차근 알려준다', w:{공감:2,책임:1} },
    { t:'직접 해보게 하고 피드백을 준다', w:{실천:2,관찰:1} },
    { t:'단계별 가이드를 만들어 준다', w:{계획:2,분석:1} },
    { t:'스스로 답을 찾도록 질문으로 돕는다', w:{탐구:2,균형:1} }
  ]},
  { q:'노후·미래에 대해 막연한 불안이 듭니다.', choices:[
    { t:'관심 분야·대비책을 하나씩 알아본다', w:{탐구:2,계획:1} },
    { t:'경험 많은 사람의 이야기를 듣는다', w:{공감:1,탐구:2} },
    { t:'지금 할 수 있는 일에 집중한다', w:{현실:2,책임:1} },
    { t:'가까운 사람과 생각을 나눈다', w:{공감:2,감성:1} }
  ]},
  { q:'팀 프로젝트에서 리더를 정해야 합니다.', choices:[
    { t:'직접 맡아 추진해 본다', w:{도전:2,실천:2} },
    { t:'의견을 잘 조율하는 사람을 추천한다', w:{공감:2,관찰:1} },
    { t:'책임감 있고 꼼꼼한 사람을 추천한다', w:{책임:2,계획:1} },
    { t:'역량을 따져 다수 의견을 따른다', w:{분석:1,균형:2} }
  ]},
  { q:'중요한 결정을 앞두고 정보가 충분하지 않습니다.', choices:[
    { t:'자료를 더 찾아 근거를 모은다', w:{탐구:2,분석:1} },
    { t:'경험자에게 조언을 구한다', w:{공감:1,균형:2} },
    { t:'일단 작은 시도로 확인해 본다', w:{실천:2,도전:1} },
    { t:'직관과 가치 기준으로 선택한다', w:{감성:2,자유:1} }
  ]}
];
// 응답자 유형에 맞는 SJT 세트 선택 (성인/일반 → 직장·생활 시나리오)
function sjtSet(){ return (typeof selfIsAdult==='function' && selfIsAdult()) ? SJT_ADULT : SJT_30; }


// =================================================================
//  AI PIA v3.2 — 무료 오픈 API 통합 모듈
//  CORS 가능: OpenRouter, Groq, Gemini, Claude (사용자 키 입력 후 직접 호출)
//  CORS 차단: 커리어넷·HyperCLOVA → 정적 데이터로 내장
// =================================================================

// -----------------------------------------------------------------
//  무료 LLM API 호출 (브라우저 직접 fetch)
//  사용자가 직접 키 입력 → CORS-enabled provider만 호출
// -----------------------------------------------------------------
async function callLLM(prompt, systemPrompt = '') {
  const cfg = state.cfg || {};
  const mode = cfg.mode || 'LOCAL';

  if (mode === 'LOCAL') {
    // 로컬 폴백 — 룰 기반 응답
    const r = generateReply(prompt);
    return r.reply;
  }
  if (mode === 'ONDEVICE') {
    return await callOnDevice(prompt, systemPrompt);
  }

  try { window.__piaLLMErr = ''; } catch(_){}
  const messages = [];
  if (systemPrompt) messages.push({ role:'system', content: systemPrompt });
  messages.push({ role:'user', content: prompt });

  try {
    let url, headers, body;

    if (mode === 'OPENROUTER_FREE') {
      url = cfg.endpoint || 'https://openrouter.ai/api/v1/chat/completions';
      headers = {
        'Content-Type':'application/json',
        'Authorization': 'Bearer ' + cfg.key,
        'HTTP-Referer': window.location.origin,
        'X-Title': 'AI PIA MVP'
      };
      body = JSON.stringify({
        model: cfg.model || 'google/gemma-3-27b-it:free',
        messages, max_tokens: 250, temperature: 0.7
      });
    } else if (mode === 'GROQ') {
      url = cfg.endpoint || 'https://api.groq.com/openai/v1/chat/completions';
      headers = {
        'Content-Type':'application/json',
        'Authorization': 'Bearer ' + cfg.key
      };
      body = JSON.stringify({
        model: cfg.model || 'llama-3.3-70b-versatile',
        messages, max_tokens: 250, temperature: 0.7
      });
    } else if (mode === 'GEMINI_FLASH') {
      url = `https://generativelanguage.googleapis.com/v1beta/models/${cfg.model || 'gemini-2.5-flash'}:generateContent?key=${cfg.key}`;
      headers = { 'Content-Type':'application/json' };
      const sysText = systemPrompt ? systemPrompt + '\n\n' : '';
      body = JSON.stringify({
        contents:[{ parts:[{ text: sysText + prompt }] }],
        generationConfig:{ maxOutputTokens: 700, temperature: 0.8, thinkingConfig:{ thinkingBudget: 0 } }
      });
    } else if (mode === 'CLAUDE_HAIKU') {
      url = 'https://api.anthropic.com/v1/messages';
      headers = {
        'Content-Type':'application/json',
        'x-api-key': cfg.key,
        'anthropic-version':'2023-06-01',
        'anthropic-dangerous-direct-browser-access':'true'
      };
      body = JSON.stringify({
        model: cfg.model || 'claude-haiku-4-5-20251001',
        max_tokens: 250,
        system: systemPrompt,
        messages: [{ role:'user', content: prompt }]
      });
    } else if (mode === 'AUTO_FREE') {
      // 키 불필요·CORS 무료 LLM 게이트웨이 (Pollinations · OpenAI 호환)
      url = cfg.endpoint || PIA_CHAT_PROXY;
      headers = { 'Content-Type':'application/json' };
      body = JSON.stringify({ model: cfg.model || 'openai', messages, max_tokens: 250, temperature: 0.7, referrer: 'ai-pia', private: true });
    } else if (mode === 'TOGETHER') {
      url = cfg.endpoint || 'https://api.together.xyz/v1/chat/completions';
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + cfg.key };
      body = JSON.stringify({ model: cfg.model || 'meta-llama/Llama-3.3-70B-Instruct-Turbo-Free', messages, max_tokens: 250, temperature: 0.7 });
    } else if (mode === 'CLOUDFLARE') {
      url = cfg.endpoint || 'https://api.cloudflare.com/client/v4/accounts/ACCOUNT_ID/ai/v1/chat/completions';
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + cfg.key };
      body = JSON.stringify({ model: cfg.model || '@cf/meta/llama-3.1-8b-instruct', messages, max_tokens: 250, temperature: 0.7 });
    } else if (mode === 'CEREBRAS') {
      url = cfg.endpoint || 'https://api.cerebras.ai/v1/chat/completions';
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + cfg.key };
      body = JSON.stringify({ model: cfg.model || 'llama-3.3-70b', messages, max_tokens: 250, temperature: 0.7 });
    } else if (mode === 'GITHUB_MODELS') {
      url = cfg.endpoint || 'https://models.github.ai/inference/chat/completions';
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + cfg.key, 'Accept':'application/json' };
      body = JSON.stringify({ model: cfg.model || 'openai/gpt-4o-mini', messages, max_tokens: 250, temperature: 0.7 });
    } else if (mode === 'HF_LLM') {
      url = cfg.endpoint || 'https://router.huggingface.co/v1/chat/completions';
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + (cfg.key || cfg.hfToken || '') };
      body = JSON.stringify({ model: cfg.model || cfg.hfLlmModel || 'Qwen/Qwen2.5-7B-Instruct', messages, max_tokens: 250, temperature: 0.7 });
    } else if (mode === 'CUSTOM_OAI') {
      url = cfg.endpoint;
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + cfg.key };
      body = JSON.stringify({ model: cfg.model, messages, max_tokens: 250 });
    } else if (mode === 'SOLAR' || mode === 'HYPERCLOVA') {
      // OpenAI 호환 포맷 (Upstage SOLAR / HyperCLOVA X HCX) — 공급자 선택 시 오류 방지
      url = cfg.endpoint || (PROVIDERS[mode] && PROVIDERS[mode].endpoint);
      headers = { 'Content-Type':'application/json', 'Authorization': 'Bearer ' + cfg.key };
      body = JSON.stringify({ model: cfg.model || (PROVIDERS[mode] && PROVIDERS[mode].model), messages, max_tokens: 250, temperature: 0.7 });
    } else {
      throw new Error('지원하지 않는 모드: ' + mode);
    }

    /* cfg.endpoint 는 설정 화면과 localStorage 로 바뀔 수 있고, 바로 아래에서
       Authorization 헤더에 API 키를 실어 보낸다. 평문 http 로 나가면 키가
       그대로 노출되므로 여기서 한 번에 막는다. (2026-08-31 보안검토) */
    try {
      const _u = new URL(url, location.href);
      if (_u.protocol !== 'https:' && _u.hostname !== 'localhost' && _u.hostname !== '127.0.0.1') {
        throw new Error('안전하지 않은 주소(https 아님)라 요청을 중단했습니다: ' + _u.origin);
      }
    } catch (e) {
      console.error('[보안] LLM 엔드포인트 차단', url, e);
      try { window.__piaLLMErr = e.message; } catch(_){}
      return null;
    }

    // 프록시 URL이 설정돼 있고 OpenAI 호환(Bearer) 엔진이면 CORS 우회를 위해 pia-proxy 경유
    const _proxy = (cfg.proxy || '').trim().replace(/\/$/, '');
    const _viaProxy = _proxy && ['OPENROUTER_FREE','GROQ','CUSTOM_OAI','SOLAR','HYPERCLOVA','HF_LLM','GITHUB_MODELS','CEREBRAS','TOGETHER','CLOUDFLARE'].indexOf(mode) >= 0;
    let res;
    if (_viaProxy && mode === 'GITHUB_MODELS') {
      // 키를 서버(.env)에만 두는 전용 라우트 — 브라우저로 키 전송 안 함
      res = await fetch(_proxy + '/api/github/chat', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ messages, model: cfg.model || 'openai/gpt-4o-mini' }) });
    } else if (_viaProxy) {
      let _payload; try { _payload = JSON.parse(body); } catch(e) { _payload = {}; }
      res = await fetch(_proxy + '/api/llm', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ endpoint: url, key: cfg.key, payload: _payload }) });
    } else {
      res = await fetch(url, { method:'POST', headers, body });
    }
    if (!res.ok) {
      const errText = await res.text();
      throw new Error(`API ${res.status}: ${errText.slice(0,200)}`);
    }
    const data = await res.json();

    if (mode === 'GEMINI_FLASH') {
      const _t = data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
      if (!_t) { try { window.__piaLLMErr = 'Gemini 응답 텍스트 없음 · finishReason=' + (data?.candidates?.[0]?.finishReason || '?') + (data?.promptFeedback?.blockReason ? (' · block=' + data.promptFeedback.blockReason) : ''); } catch(_){} }
      return _t;
    }
    if (mode === 'CLAUDE_HAIKU') {
      return data?.content?.[0]?.text || '';
    }
    // OpenAI 호환
    return data?.choices?.[0]?.message?.content || '';
  } catch(e) {
    console.warn('LLM 호출 실패:', e.message);
    try { window.__piaLLMErr = e.message; } catch(_){}
    return null; // 폴백 신호
  }
}

// 브라우저 온디바이스 추론 — Chrome 내장 Prompt API(Gemini Nano) 우선, 없으면 Transformers.js(WebGPU/WASM)
let _ondevicePipe = null;
let _ondeviceAllowDL = false; // 모바일은 대용량 모델 자동 다운로드 차단(버튼 먹통 방지) · 데스크톱+WebGPU에서만 활성

/* 키오스크에서는 온디바이스 모델을 쓰지 않는다.

   왜 이 판정이 따로 필요한가
     isMobile() 은 화면 폭(<768px)만 본다. 그런데 키오스크는 1024x768 ·
     1280x1024 라 "데스크톱"으로 잡히고, 그 결과 모델 다운로드가 허용된다.
     실제로 재 보면 Qwen2.5-0.5B ONNX 는 q4 749MB · q4f16 460MB 이고,
     POS 급 저사양 기기에서 이걸 받아 WASM 으로 추론하면
       · 첫 실행에 수 분이 걸리고
       · 추론이 매우 느리며
       · 최악의 경우 브라우저가 죽는다(실측에서 페이지 종료 확인)
     화면이 크다고 성능이 좋은 것은 아니라는 게 이 판정의 요지다. */
function _isKioskDevice() {
  try {
    /* kiosk.js 가 붙이는 html.kiosk-on 만 보면 안 된다.
       kiosk.js 는 defer 로 로드되므로 이 파일의 인라인 스크립트보다 늦게
       실행된다. 실제로 그 순서 때문에 키오스크인데도 "데스크톱"으로
       판정돼 모델 다운로드가 그대로 시작됐다(측정에서 11건 요청 확인).
       그래서 클래스가 아직 없더라도 같은 조건을 직접 계산한다.
       판정식은 kiosk.js 의 detect() 와 동일하게 맞춘다:
         손가락 포인터(any-pointer: coarse) + 화면 긴 변 900px 이상 */
    if (document.documentElement.classList.contains('kiosk-on')) return true;
    var coarse = window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches;
    var big = Math.max(window.innerWidth, window.innerHeight) >= 900;
    return !!(coarse && big);
  } catch (e) { return false; }
}
function _ondeviceAllowed() {
  return !(typeof isMobile === 'function' && isMobile()) && !_isKioskDevice();
}
/* 브라우저에 내장 AI(Prompt API)가 지금 바로 쓸 수 있는 상태인가.
   'downloadable' / 'downloading' 도 결국 브라우저가 알아서 받는 것이라
   우리가 대용량 파일을 내려받게 하는 것과는 다르다. 다만 첫 응답이
   늦을 수 있으므로 'available' 만 즉시 사용으로 본다. */
async function _piaBuiltinAvailable() {
  try {
    const LM = (typeof self !== 'undefined' && self.LanguageModel)
            || (typeof window !== 'undefined' && window.ai && window.ai.languageModel);
    if (!LM) return false;
    if (!LM.availability) return true;
    const a = await LM.availability();
    return a === 'available' || a === 'readily';
  } catch (e) {
    console.error('내장 AI 확인 실패:', e);
    return false;
  }
}

async function callOnDevice(prompt, systemPrompt) {
  try {
    const LM = (typeof self!=='undefined' && self.LanguageModel) || (typeof window!=='undefined' && window.ai && window.ai.languageModel) || null;
    if (LM) {
      let avail = 'readily';
      try { avail = LM.availability ? await LM.availability() : (LM.capabilities ? (await LM.capabilities()).available : 'readily'); } catch(e) {}
      if (avail && avail !== 'no' && avail !== 'unavailable') {
        const session = await LM.create(systemPrompt ? { initialPrompts:[{ role:'system', content: systemPrompt }] } : {});
        const out = await session.prompt(prompt);
        try { session.destroy && session.destroy(); } catch(e) {}
        if (out && out.trim()) return out.trim();
      }
    }
  } catch(e) {}
  try {
    if (!_ondeviceAllowDL) return null;
    if (!_ondevicePipe) {
      try { var _b=document.getElementById('chat-aistatus'); if(_b) _b.innerHTML='<span class="pill bg-amber-100 text-amber-800 text-[10px]">🖥 온디바이스 모델 준비 중(최초 1회 다운로드)…</span>'; } catch(e){}
      const mod = await import('https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.3.3');
      const model = (state.cfg && state.cfg.ondeviceModel) || 'onnx-community/Qwen2.5-0.5B-Instruct';
      const device = (typeof navigator!=='undefined' && navigator.gpu) ? 'webgpu' : 'wasm';
      _ondevicePipe = await mod.pipeline('text-generation', model, { dtype:'q4', device });
    }
    const messages = [];
    if (systemPrompt) messages.push({ role:'system', content: systemPrompt });
    messages.push({ role:'user', content: prompt });
    const res = await _ondevicePipe(messages, { max_new_tokens: 200, do_sample: true, temperature: 0.7 });
    let txt = res && res[0] && res[0].generated_text;
    if (Array.isArray(txt)) { const last = txt[txt.length-1]; txt = (last && last.content) || ''; }
    if (typeof txt === 'string' && txt.trim()) return txt.trim();
  } catch(e) {}
  return null;
}

const PIA_CHAT_PROXY = 'https://api.yedam.kr/ai?t=90fa660460d9cfb36d2d01c1ca36f00cd7c30c820771435e0e74f3849e008b54';
function _escHtml(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
// 키 불필요 무료 게이트웨이 직접 호출 (cfg 무관 · 자유대화 자동 연결용)
/* 내장 브라우저 AI (Chrome Prompt API / Gemini Nano) — 자유대화 1순위 엔진.

   2026-09-16 측정 (Chrome 152, availability='available')
     내장  세션 재사용 694 / 924 / 925 ms   한국어 자연스러움
     서버  3938 ms                          "오 lovely? 체육 때 무엇 했어?" 처럼 깨짐

   4배 빠르고 품질도 낫다. 게다가 대화 내용이 기기 밖으로 나가지 않는다.
   학생 발화를 서버로 보내지 않는다는 건 그 자체로 의미가 있다.

   세션을 매번 새로 만들면 7.1초가 걸린다(측정값). 그래서 한 번 만들어
   재사용하고, 시스템 프롬프트가 바뀔 때만 다시 만든다.

   이모지는 시스템 프롬프트로 막아도 계속 나온다(3회 중 3회). 모델을
   설득하는 대신 출력에서 지운다. 검사 화면에 이모지는 맞지 않는다. */
var _piaLMSession = null;
var _piaLMSysKey  = null;
/* clone() 은 0ms 다(실측). 긴 시스템 프롬프트로 세션을 새로 만들면
   1742ms 가 드는데 복제는 공짜다. 대화가 길어져 컨텍스트가 쌓였을 때
   깨끗한 세션이 필요하면 만들지 말고 복제한다. */
var _piaLMBase = null;
/* [2026-09-16] 세션은 상태를 가지며 프롬프트가 큐에 쌓인다(Prompt API 명세).
 * 앞 요청이 안 끝났으면 다음 요청은 뒤에 줄을 선다. 실측: 같은 세션에
 * 두 요청을 동시에 던지면 794ms / 1673ms 로 정확히 두 배가 걸렸다.
 *
 * 대화에서 학생이 빠르게 다음 말을 보내면 앞 요청이 살아 있어 새 요청이
 * 밀리고, 6초 타임아웃을 넘겨 서버로 폴백했다. 12턴 통합검증에서
 * 2턴째부터 계속 '예담 서버 AI' 로 넘어간 원인이 이것이다.
 *
 * 새 요청을 시작할 때 이전 것을 abort 한다. 어차피 학생이 다음 말을
 * 한 시점에서 이전 답은 쓸모가 없다. */
var _piaLMAbort = null;

/* [2026-09-17] 세션 캐시 키 정규화.
 *
 * 앞 1200자를 키로 썼는데 781번째에 '(현재 주제: 축구)' 가 박혀 있었다.
 * 주제가 턴마다 바뀌니 키가 매번 달라져 세션을 다시 만들었다(1702ms).
 * 앞 1200자 경계가 틀린 게 아니라, 고정부 안에 가변 슬롯이 있었다.
 *
 * 주제 슬롯을 빈 값으로 치환해 키를 만든다. 주제는 어차피 프롬프트
 * 본문(_tail)으로도 들어가므로 모델이 놓치지 않는다. */
function _piaLMKeyOf(sys){
  return String(sys || '').slice(0, 1200).replace(/\(현재 주제:[^)]*\)/g, '(현재 주제: )');
}

function _piaStripEmoji(t){
  if(!t) return t;
  return String(t)
    .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{2190}-\u{21FF}\u{2B00}-\u{2BFF}]/gu, '')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}

function _piaGetLM(){
  return (typeof LanguageModel!=='undefined' && LanguageModel)
      || (typeof self!=='undefined' && self.LanguageModel)
      || (window.ai && (window.ai.languageModel || window.ai.assistant))
      || (typeof self!=='undefined' && self.ai && (self.ai.languageModel || self.ai.assistant))
      || null;
}

/* 화면 진입 시 미리 세션을 띄워 첫 턴의 7초를 없앤다. 실패해도 조용히 넘어간다. */
async function piaWarmBrowserAI(systemPrompt){
  try{
    var LM=_piaGetLM(); if(!LM || !LM.create) return false;
    if(LM.availability){ var a=await LM.availability(); if(a==='unavailable'||a==='no') return false; }
    var key=String(systemPrompt||'').slice(0,4000);
    if(_piaLMSession && _piaLMSysKey===key) return true;
    try{ if(_piaLMSession && _piaLMSession.destroy) _piaLMSession.destroy(); }catch(e){}
    /* [2026-09-16] 생성 옵션을 붙여 속도와 안정성을 올린다.
     *
     * 웹에서는 temperature·topK 가 막혀 있고 LanguageModel.params() 도 없다
     * (실측: TypeError). 대신 samplingMode 와 expectedInputLanguages 를 쓴다.
     *
     * 같은 질문·같은 시스템 프롬프트로 잰 값:
     *   옵션 없음                1195ms  '야, 축구 진짜 잘 했겠다! 엄청 신나게...'
     *   predictable              599ms
     *   predictable + ko         592ms   <- 채택. 2배 빠르고 답도 짧고 정확하다
     *
     * expectedOutputs 는 NotSupportedError 가 난다. 넣지 않는다.
     * 옵션을 못 받는 구버전도 있으므로 단계적으로 내려간다. */
    var _mk = async function(opt){
      return key ? await LM.create(Object.assign({ initialPrompts:[{role:'system',content:key}] }, opt))
                 : await LM.create(Object.assign({}, opt));
    };
    /* [2026-09-16] Chrome 권고 baseline + clone 패턴.
     *
     * 문서가 명시적으로 금지하는 것: 같은 지침으로 create() 를 반복 호출하는 것.
     * 매번 지침을 다시 파싱해 지연이 커진다. 대신 baseline 을 하나 만들고
     * 복제해 쓴다 — clone() 은 0ms 다(실측).
     *
     * baseline 은 지침만 담고 대화를 섞지 않는다. 그래야 복제본이 항상
     * 깨끗한 상태로 시작한다. 실제 대화는 복제본이 맡는다. */
    try {
      _piaLMBase = await _mk({ samplingMode:'predictable', expectedInputLanguages:['ko'] });
    } catch(e1) {
      try { _piaLMBase = await _mk({ samplingMode:'predictable' }); }
      catch(e2) { _piaLMBase = await _mk({}); }
    }
    try { _piaLMSession = (_piaLMBase.clone) ? await _piaLMBase.clone() : _piaLMBase; }
    catch(e3) { _piaLMSession = _piaLMBase; }
    _piaLMSysKey = key;

    /* 컨텍스트가 넘치면 가장 오래된 발화부터 잘려 나간다. 미리 알아채고
       baseline 에서 새 복제본을 받아 갈아탄다(1200자 지침은 그대로 유지된다).
       contextWindow 는 이 기기에서 9216 이다. */
    try {
      if (_piaLMSession.addEventListener) {
        _piaLMSession.addEventListener('contextoverflow', function(){
          if (window.console) console.error('[내장 AI] 컨텍스트 초과 — 세션 교체');
          try {
            if (_piaLMBase && _piaLMBase.clone) {
              _piaLMBase.clone().then(function(c){
                try { if(_piaLMSession && _piaLMSession.destroy) _piaLMSession.destroy(); } catch(e){}
                _piaLMSession = c;
              }).catch(function(){});
            }
          } catch(e){}
        });
      }
    } catch(e){}
    return !!_piaLMSession;
  }catch(e){ if(window.console) console.error('내장 AI 예열 실패:', e); _piaLMSession=null; return false; }
}
window.piaWarmBrowserAI = piaWarmBrowserAI;

/* [2026-09-17] 보조 작업 전용 호출.
 *
 * aiRefreshQuickReplies 가 callBrowserAI 를 다른 시스템 프롬프트로 부르면
 * 대화용 세션이 통째로 갈리고, 다음 턴에 2초를 들여 다시 만든다.
 * 프로파일: 클릭 -> warm 2073ms -> 첫 delta 3264ms. 예열이 헛돌던 게 아니라
 * 빠른답변이 매 턴 예열을 깨고 있었다.
 *
 * 보조 작업은 baseline 을 복제한 일회용 세션에서 돌리고 버린다.
 * clone 은 0ms, 버리는 것도 공짜다. 대화 세션은 손대지 않는다. */
async function callBrowserAIAux(prompt, systemPrompt){
  try{
    var LM=_piaGetLM(); if(!LM || !LM.create) return null;
    var s=null;
    try { s = await LM.create({ initialPrompts:[{role:'system',content:String(systemPrompt||'').slice(0,2000)}], samplingMode:'predictable' }); }
    catch(e1){ try { s = await LM.create({ initialPrompts:[{role:'system',content:String(systemPrompt||'').slice(0,2000)}] }); } catch(e2){ return null; } }
    var txt = await s.prompt(String(prompt).slice(0,2000));
    try{ s.destroy(); }catch(e){}
    txt = _piaStripEmoji(txt);
    return (txt && txt.trim()) ? txt.trim() : null;
  }catch(e){ if(window.console) console.error('내장 AI 보조 호출 실패:', e); return null; }
}
window.callBrowserAIAux = callBrowserAIAux;

/* ── 자유대화 엔진 3단계 (2026-09-16) ───────────────────────────────
 *
 *   1) BROWSER  내장 브라우저 AI   Chrome Prompt API. 700~900ms, 기기 안에서 처리.
 *   2) SERVER   예담 서버 AI       api.yedam.kr/ai. 서버가 다시 7공급자로 폴백한다.
 *   3) APIKEY   API 키 직접 입력    설정 화면에서 고른 엔진과 키를 쓴다.
 *
 * 기본값 AUTO 는 1 -> 2 -> 3 순으로 내려간다. 특정 단계를 고르면 그 단계만
 * 쓰고, 실패하면 규칙형 답변으로 간다(조용히 다른 데로 새지 않는다 —
 * 학생 발화를 어디로 보낼지는 고른 사람이 알아야 한다).
 *
 * 실측 근거 (2026-09-16, Chrome 152)
 *   내장  694 / 924 / 925 ms   한국어 자연스러움
 *   서버  3938 ms              '오 lovely? 체육 때 무엇 했어?' 처럼 깨짐
 * 그래서 내장을 앞에 둔다. 서버는 현재 Ollama qwen3:1.7b 단독이라
 * AI_ALLOW_CLOUD_PROVIDERS=1 과 키를 넣으면 품질이 올라간다. */
var PIA_CHAT_ENGINE_KEY = 'pia_chat_engine';

function piaGetChatEngine(){
  try{
    var v = localStorage.getItem(PIA_CHAT_ENGINE_KEY);
    if(v==='APIKEY'){ try{ localStorage.setItem(PIA_CHAT_ENGINE_KEY,'AUTO'); }catch(e){} return 'AUTO'; } /* 2026-09-26 API 키 모드 정리 → 자동 */
    if(v==='BROWSER'||v==='SERVER'||v==='AUTO') return v;
  }catch(e){}
  return 'AUTO';
}
function piaSetChatEngine(v){
  try{ localStorage.setItem(PIA_CHAT_ENGINE_KEY, v); }catch(e){}
  try{ var sel=document.getElementById('pia-chat-engine'); if(sel) sel.value=v; }catch(e){}
  return v;
}
window.piaGetChatEngine = piaGetChatEngine;
window.piaSetChatEngine = piaSetChatEngine;

/* 화면이 뜨면 저장된 선택을 select 에 반영한다. */
try{
  var _restore=function(){ try{ var sel=document.getElementById('pia-chat-engine'); if(sel) sel.value=piaGetChatEngine(); }catch(e){} };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', _restore);
  else _restore();
  setTimeout(_restore, 1500);
}catch(e){}

/* 어떤 엔진이 실제로 답했는지 남긴다. 학생 화면에는 안 보이고
   설정 화면과 콘솔에서만 확인한다. */
window.piaLastChatEngine = null;
function _piaMarkEngine(name){
  window.piaLastChatEngine = name;
  try{
    var b=document.getElementById('pia-engine-badge');
    if(b) b.textContent = name;
  }catch(e){}
  /* [engine badge sync, 2026-09-22] chat-aistatus (student-visible badge)
     was frozen to the connectivity-check value and never reflected which
     engine actually answered a given turn, so it could keep showing
     on-device while the server had actually answered. This reuses the
     tracking _piaMarkEngine already does, and does not change routing. */
  try{
    var _cb = document.getElementById('chat-aistatus');
    if (_cb) {
      var _isOD = (name === '내장 브라우저 AI');
      var _isSrv = (name === '예담 서버 AI');
      var _cls = _isOD ? 'bg-emerald-100 text-emerald-800' : (_isSrv ? 'bg-sky-100 text-sky-800' : 'bg-violet-100 text-violet-800');
      var _txt = _isOD ? '\ud83d\udda5 \uc628\ub514\ubc14\uc774\uc2a4(\ubc29\uae08 \uc751\ub2f5)' : (_isSrv ? '\u2601 \uc11c\ubc84 AI(\ubc29\uae08 \uc751\ub2f5)' : '\ud83d\udd11 ' + name + '(\ubc29\uae08 \uc751\ub2f5)');
      _cb.innerHTML = '<span class="pill ' + _cls + ' text-[10px]">' + _txt + '</span>';
    }
  }catch(e){}
}
window._piaMarkEngine = _piaMarkEngine;


/* [2026-09-16] 예열이 헛돌던 문제.
 *
 * 예전에는 빈 문자열로 예열했다. 세션은 만들어지지만 키가 '' 이라,
 * 실제 대화가 시작되면 지침이 달라 세션을 통째로 다시 만들었다.
 * 첫 두 턴이 4초씩 걸린 원인이 이것이다(3턴째부터 2.1초).
 *
 * 실제 대화가 쓸 지침의 고정부(앞 1200자)로 예열한다. 그러면 첫 턴부터
 * 복제본을 바로 쓸 수 있다.
 *
 * 실패해도 아무 일도 하지 않는다 — 예열은 어디까지나 선택적 가속이고,
 * 안 되면 기존 경로가 그대로 돈다. */
try{
  var _piaPrewarm = function(){
    try{
      var _sys = '';
      try { if (typeof buildSystemPrompt === 'function') _sys = String(buildSystemPrompt('OPENING', '') || ''); } catch(e){}
      /* callBrowserAI 와 같은 규칙으로 앞 1200자만 키로 쓴다. 두 곳이
         어긋나면 예열이 또 헛돈다. */
      piaWarmBrowserAI(_piaLMKeyOf(_sys));
    }catch(e){}
  };
  if(document.readyState==='complete') setTimeout(_piaPrewarm, 1200);
  else window.addEventListener('load', function(){ setTimeout(_piaPrewarm, 1200); });
}catch(e){}

async function callBrowserAI(prompt, systemPrompt, onDelta){
  try{
    var LM=_piaGetLM();
    if(!LM || (!LM.create && !LM.availability && !LM.capabilities)) return null;
    var ok=true;
    try{
      if(LM.availability){ var a=await LM.availability(); ok=(a && a!=='unavailable' && a!=='no'); }
      else if(LM.capabilities){ var c=await LM.capabilities(); ok=(c && c.available && c.available!=='no'); }
    }catch(e){ ok=true; }
    if(!ok) return null;

    /* [2026-09-16] 매 턴 세션을 새로 만들던 문제.
     *
     * 프로파일링 결과 전송부터 첫 자막까지 4.1초 중 2.85초가 세션 생성
     * (warm)이었다. 시스템 프롬프트를 캐시 키로 썼는데, 그 안에 직전
     * 발화 목록이 들어가 매 턴 내용이 조금씩 달라진다. 길이는 같아도
     * 문자열이 달라 키가 어긋나고, 그래서 계속 다시 만들었다.
     *
     * 고정부(지침)만 키로 쓰고, 턴마다 바뀌는 부분은 프롬프트 본문에
     * 실어 보낸다. 지침이 같으면 세션을 그대로 재사용한다.
     *
     * clone() 이 0ms 라는 점을 쓴다(실측). 원본을 하나 만들어 두고
     * 대화가 길어져 컨텍스트가 쌓이면 복제본으로 갈아탄다. */
    var _full = systemPrompt ? String(systemPrompt) : '';
    /* 앞 1200자는 고정 지침이다. 뒤쪽의 '최근 발화' 같은 가변부는 키에서 뺀다. */
    var key = _piaLMKeyOf(_full);
    var _tail = _full.slice(1200);
    /* 키에서 뺀 주제를 본문 앞에 붙여 모델이 알게 한다 */
    var _topicM = _full.slice(0, 1200).match(/\(현재 주제:\s*([^)]+)\)/);
    if (_topicM && _topicM[1].trim()) _tail = '(현재 주제: ' + _topicM[1].trim() + ')\n' + _tail;

    if(!_piaLMSession || _piaLMSysKey!==key){
      var warmed = await piaWarmBrowserAI(key);
      if(!warmed) return null;
      try { if(_piaLMSession && _piaLMSession.clone) _piaLMBase = await _piaLMSession.clone(); } catch(e){}
    }
    /* 가변부는 이번 요청에만 얹는다. 세션은 그대로 둔다. */
    if (_tail) prompt = _tail + '\n\n' + String(prompt);
    if(!_piaLMSession || typeof _piaLMSession.prompt!=='function') return null;

    /* [2026-09-16] onDelta 가 오면 진짜 스트리밍을 쓴다.
     *
     * 예전에는 완성된 문장을 받아 24조각으로 잘라 흘렸다. 보기엔 비슷해도
     * 첫 글자가 나올 때까지 전체 생성을 기다려야 했다.
     * promptStreaming 은 첫 조각이 139ms 에 온다(실측, 총 28조각).
     * 학생이 기다리는 체감이 크게 줄어든다. */
    /* 진행 중이던 이전 요청을 끊는다. 끊지 않으면 큐 뒤에 서서
       새 요청이 그만큼 늦어진다. */
    try { if (_piaLMAbort) _piaLMAbort.abort(); } catch(e){}
    var _ac = (typeof AbortController === 'function') ? new AbortController() : null;
    _piaLMAbort = _ac;
    var _opt = _ac ? { signal: _ac.signal } : undefined;

    var txt;
    if (typeof onDelta === 'function' && typeof _piaLMSession.promptStreaming === 'function') {
      txt = '';
      try {
        var _st = _piaLMSession.promptStreaming(String(prompt).slice(0,6000), _opt);
        for await (var _ch of _st) {
          txt += _ch;
          try { onDelta(_piaStripEmoji(txt)); } catch(e){}
        }
      } catch(e) {
        if (window.console) console.error('내장 AI 스트리밍 실패, 일반 호출로 전환:', e);
        txt = await _piaLMSession.prompt(String(prompt).slice(0,6000), _opt);
      }
    } else {
      txt = await _piaLMSession.prompt(String(prompt).slice(0,6000), _opt);
    }
    txt = _piaStripEmoji(txt);
    return (txt && txt.trim()) ? txt.trim() : null;
  }catch(e){
    /* AbortError 는 우리가 일부러 끊은 것이다. 실패가 아니므로 세션을
       그대로 둔다. 여기서 버리면 다음 턴에 재생성 비용을 또 치른다. */
    if (e && (e.name === 'AbortError' || String(e).indexOf('AbortError') >= 0)) return null;
    if(window.console) console.error('내장 브라우저 AI 실패:', e);
    /* 세션이 깨졌을 수 있으니 버린다. 다음 호출에서 새로 만든다. */
    try{ if(_piaLMSession && _piaLMSession.destroy) _piaLMSession.destroy(); }catch(e2){}
    _piaLMSession=null; _piaLMSysKey=null;
    return null;
  }
}
window.callBrowserAI = callBrowserAI;
async function callLLMFree(prompt, systemPrompt, onDelta, opts) {
  /* opts.max_tokens — 결과지 요약·상담 예시처럼 3~7문장을 받는 곳은 256 토큰(한국어 약 2~3문장)에서
     문장 중간이 잘렸다. 호출부가 더 넉넉한 값을 줄 수 있게 한다. 기본값은 예전과 같다. (2026-09-26) */
  const _maxTok = (opts && opts.max_tokens) || 256;
  /* [2026-11-02] 대화 신뢰성 ④ — 결과지 대화 해석은 온도 0(재현성). 호출부가 주지 않으면 예전 값 0.8. */
  const _temp = (opts && typeof opts.temperature === 'number') ? opts.temperature : 0.8;
  const messages = [];
  if (systemPrompt) messages.push({ role:'system', content: systemPrompt });
  messages.push({ role:'user', content: prompt });

  /* [2026-08-22] 챗GPT처럼 글자가 흘러나오게 — 서버가 SSE 로 조각을 보내면
     받는 즉시 화면에 붙인다. 스트리밍이 안 되는 환경(구형 브라우저·중간 프록시
     버퍼링)에서는 아무 조각도 못 받으므로, 그때는 조용히 기존 방식으로 돌아간다. */
  if (typeof onDelta === 'function' && window.fetch && window.ReadableStream && window.TextDecoder) {
    try {
      const ctrlS = new AbortController();
      const tS = setTimeout(function(){ ctrlS.abort(); }, 90000);
      const resS = await fetch(PIA_CHAT_PROXY + '&stream=1', {
        method:'POST', headers:{ 'Content-Type':'application/json' }, signal: ctrlS.signal,
        body: JSON.stringify({ messages: messages, max_tokens:_maxTok, temperature:_temp, stream:true })
      });
      const ctype = (resS.headers.get('content-type') || '');
      if (resS.ok && ctype.indexOf('text/event-stream') >= 0 && resS.body) {
        const reader = resS.body.getReader();
        const dec = new TextDecoder();
        let buf = '', acc = '', got = false;
        for(;;){
          const { value, done } = await reader.read();
          if (done) break;
          buf += dec.decode(value, { stream:true });
          let idx;
          while ((idx = buf.indexOf('\n')) >= 0) {
            const line = buf.slice(0, idx).trim();
            buf = buf.slice(idx + 1);
            if (line.indexOf('data:') !== 0) continue;
            let j = null;
            try { j = JSON.parse(line.slice(5).trim()); } catch(e){ continue; }
            if (j && j.delta) { acc += j.delta; if(!got){ clearTimeout(tS); } got = true; try{ onDelta(acc); }catch(e){} try{ if (typeof window.__piaEarlyDelta === 'function') window.__piaEarlyDelta(acc); }catch(e){ console.error('[fastvoice] 첫 문장 처리 실패', e); } }
            if (j && j.done) { if (j.content && j.content.length > acc.length) acc = j.content; }
          }
        }
        clearTimeout(tS);
        if (got && acc.trim()) return acc.trim();
      } else {
        clearTimeout(tS);
        try{ if(resS.body && resS.body.cancel) resS.body.cancel(); }catch(e){}
      }
    } catch(e) {
      if (window.console) console.error('스트리밍 응답 실패 — 일반 방식으로 전환:', e && e.message);
    }
  }

  // 0차: 서버 프록시(키 불필요·전 기기 자동·6개 공급자 자동 폴백)
  try {
    const ctrl0 = new AbortController(); const t0 = setTimeout(function(){ ctrl0.abort(); }, 90000);
    const res0 = await fetch(PIA_CHAT_PROXY, {
      method:'POST', headers:{ 'Content-Type':'application/json' }, signal: ctrl0.signal,
      body: JSON.stringify({ messages: messages, max_tokens:_maxTok, temperature:_temp })
    });
    clearTimeout(t0);
    if (res0.ok) {
      const d0 = await res0.json();
      const c0 = d0 && ((d0.choices && d0.choices[0] && d0.choices[0].message && d0.choices[0].message.content) || d0.content);
      if (c0 && c0.trim()) return c0.trim();
    }
  } catch(e) {}
  /* 예전에는 여기서 pollinations 를 직접 두 번 더 불렀다. 이제 뺀다.
     0차 프록시가 이미 6개 공급자를 차례로 훑고, 그것마저 실패하면 서버가
     한 번 더 다른 경로로 시도한다. 브라우저가 우리가 통제하지 않는 곳으로
     따로 나갈 이유가 없다. 여기까지 왔다면 호출부가 규칙형 답변으로 받는다. */
  return null;
}

// [Task140] AI PIA 자유대화 전용 로컬 AI(Qwen3-1.7B) 직결 — callLLMFree와 계약 동일(성공 시 문자열, 실패 시 null)
var PIA_LOCAL_CHAT_URL = 'https://api.yedam.kr/ai?task=aipia_chat&t=90fa660460d9cfb36d2d01c1ca36f00cd7c30c820771435e0e74f3849e008b54';
/* 언어별 launch-bank (2026-09-15)
 *
 * 이전에는 URL 이 한국어 파일 하나로 고정돼 있었다. 영어로 전환해도
 * 한국어 질문과 quick reply 가 그대로 나왔다. 영어 화자에게는 읽을 수
 * 없는 화면이 되고, 검증 기준상으로도 FAIL 이다.
 *
 * 언어 판별은 이 파일이 이미 쓰는 방식(document.documentElement.lang)을
 * 그대로 따른다. i18n.js 가 언어를 바꿀 때 이 속성을 갱신한다.
 * 언어가 바뀌면 캐시를 버리고 해당 언어 bank 를 다시 받는다. */
function piaBankLang() {
  try {
    if (document.documentElement.lang === 'en') return 'en';
    if (String(window._chatLang || '').indexOf('en') === 0) return 'en';
  } catch (e) { console.error('[freechat-bank] lang 판별 실패', e); }
  return 'ko';
}
function piaBankUrl(lang) {
  return (lang === 'en')
    /* 상대경로. /aipia/ 절대경로는 yedam.kr 에서만 맞고 ai-pia.kr 에서는
       404 였다. 그러면 화제 힌트가 통째로 비어 자유대화가 맨몸으로
       돌아간다 — 오늘 고친 반복 완화의 절반이 무력화된다. (2026-09-16) */
    ? 'freechat-launch-bank.en.json'
    : 'freechat-launch-bank.json';
}
var _piaFreeChatBank = { items: [], ready: false, loading: null, lang: null };

function loadFreeChatBank() {
  var lang = piaBankLang();
  /* 언어가 바뀌었으면 이전 언어 캐시를 쓰지 않는다. */
  if (_piaFreeChatBank.lang !== lang) {
    _piaFreeChatBank = { items: [], ready: false, loading: null, lang: lang };
  }
  if (_piaFreeChatBank.ready) return Promise.resolve(_piaFreeChatBank.items);
  if (_piaFreeChatBank.loading) return _piaFreeChatBank.loading;
  _piaFreeChatBank.loading = fetch(piaBankUrl(lang), { credentials: 'same-origin' })
    .then(function(res){ if (!res.ok) throw new Error('bank http ' + res.status); return res.json(); })
    .then(function(data){
      var items = data && Array.isArray(data.items) ? data.items : [];
      _piaFreeChatBank.items = items.filter(function(item){
        return item && typeof item.id === 'string' && typeof item.question === 'string' &&
          Array.isArray(item.topics) && item.question.trim().length > 0 &&
          Array.isArray(item.quickReplies) && item.quickReplies.length >= 4;
      });
      _piaFreeChatBank.ready = true;
      return _piaFreeChatBank.items;
    })
    .catch(function(){ _piaFreeChatBank.ready = true; _piaFreeChatBank.items = []; return []; });
  return _piaFreeChatBank.loading;
}

function selectFreeChatNudge(topic, turnIndex) {
  /* [2026-09-15] 화제 힌트 선택 정책을 고쳤다.
   *
   * 반복이 잦다는 보고를 받고 이 함수를 들여다보니 세 가지가 겹쳐 있었다.
   *
   *   1. turnIndex % 2 === 0 이면 null 을 돌려줘 짝수 턴에는 힌트가 아예
   *      없었다. 12턴 대화에서 은행이 개입하는 건 6번뿐이고 나머지는
   *      모델이 맨몸으로 답한다. 1.7B 짜리 작은 모델이 맨몸으로 답하면
   *      안전한 표현으로 수렴한다 — 그게 곧 반복이다.
   *   2. matched[turnIndex % matched.length] 는 결정적이다. 같은 턴·같은
   *      topic 이면 언제나 같은 항목이 나온다. 무작위성이 0 이었다.
   *   3. used 가 최근 6턴만 본다. 12턴 대화의 7턴째에 1턴 항목이 다시
   *      후보가 된다.
   *
   * 고친 방향은 화제 순환(rotation)이다. 대화형 에이전트 연구에서
   * 반복으로 인한 wear-out 을 줄이는 방법으로 쓰이는데, 요점은 무작정
   * 다양하게가 아니라 '일관성과 다양성의 균형'이다. 그래서 (a) 매 턴
   * 힌트를 주되, (b) 후보 중에서는 무작위로 고르고, (c) 이번 대화에서
   * 쓴 항목은 전부 제외하며, (d) 다 소진되면 그때만 재사용을 푼다. */
  var items = _piaFreeChatBank.items || [];
  if (!items.length || turnIndex < 1) return null;

  var transcript = (state && state.results && state.results.conv && state.results.conv.transcript) || [];
  /* 최근 6턴이 아니라 이번 대화 전체에서 쓴 것을 제외한다. */
  var used = transcript.map(function(turn){ return turn && turn.bankId; }).filter(Boolean);

  function pick(pool){
    if (!pool.length) return null;
    return pool[Math.floor(Math.random() * pool.length)];
  }
  var byTopic = items.filter(function(it){
    return it.topics.indexOf(topic) >= 0 && used.indexOf(it.id) < 0;
  });
  var general = items.filter(function(it){
    return it.topics.indexOf('general') >= 0 && used.indexOf(it.id) < 0;
  });
  var anyFresh = items.filter(function(it){ return used.indexOf(it.id) < 0; });

  /* topic 이 맞는 것 -> general -> 아직 안 쓴 아무거나 순으로 찾는다.
     topic 이 'general' 로 몰리면 후보가 빨리 마르므로 마지막 단계가 필요하다. */
  var hit = pick(byTopic) || pick(general) || pick(anyFresh);

  /* 전부 소진됐을 때만 재사용을 푼다. 그때도 직전 4턴 것은 피한다. */
  if (!hit) {
    var recent = transcript.slice(-4).map(function(t){ return t && t.bankId; }).filter(Boolean);
    hit = pick(items.filter(function(it){ return recent.indexOf(it.id) < 0; })) || pick(items);
  }
  return hit || null;
}

function freeChatBankDirection(item) {
  if (!item) return '';
  return '\n\n[검수된 다음 화제 힌트] ' + item.question +
    '\n이 문장은 일상 대화용 검수 문장이다. 시험·평가·채점·정답·문항처럼 묻거나 성향을 판정하지 말고, 사용자의 직전 말에 먼저 자연스럽게 반응한 뒤 필요할 때만 자기 말로 한 번 이어가라.';
}

/* [2026-11-02] 대화 신뢰성 ① — 자유대화 답의 온도·길이는 data/chat-prompt.json(pia-chat-trust.js) 값을 쓴다. */
function _piaChatOpts() {
  try { var P = window.piaChatTrust && window.piaChatTrust.PROMPT; if (P) return { temperature: P.temperature.chat, max_tokens: P.maxTokens.chat }; } catch (e) {}
  return undefined;
}
async function callLocalAipiaChat(prompt, systemPrompt, timeoutMs, onDelta) {
  /* [스트리밍 배선 2026-09-15]
   *
   * 이 함수는 aipia-ai(8000) /chat 을 부른다. 그 엔드포인트는 응답을
   * 통째로 반환해서 자막이 한 번에 나타났다. 화면에 글자가 흐르게 하는
   * _stream 은 만들어져 있었지만 호출되는 곳이 없어 죽은 코드였다.
   *
   * onDelta 가 주어지면 프록시 SSE(api.yedam.kr/ai?stream=1)를 먼저
   * 시도한다. 프록시는 같은 ollama 를 보고 있으므로 답의 성격은 같다.
   * 첫 조각을 못 받으면 아무것도 하지 않고 아래 기존 경로로 떨어진다 —
   * 헤더를 쓰기 전에 판단하므로 폴백이 안전하다.
   *
   * 기존 호출부(인자 3개)는 onDelta 가 undefined 라 이 블록을 건너뛴다.
   * 한국어 가드·중복 가드·폴백 구조는 그대로다. */
  if (typeof onDelta === 'function') {
    try {
      const _msgs = [];
      if (systemPrompt) _msgs.push({ role:'system', content:String(systemPrompt) });
      _msgs.push({ role:'user', content:String(prompt) });
      const _out = await callLLMFree(String(prompt), systemPrompt, onDelta, _piaChatOpts());
      if (_out && String(_out).trim()) return String(_out).trim();
    } catch (e) {
      console.error('[자유대화] 스트리밍 실패 — 기존 경로로 전환:', e && e.message);
    }
  }
  /* [2026-09-26] 로컬 AI PIA 서버(aipia-ai·Qwen3 1.7B, 8000)는 사용량이 거의 없어 운영에서 내렸다(대표 결정).
     예전 로컬 직결 대신 서버 AI(OpenRouter 우선, 예비 Worker)로 보낸다 — 계약 동일(성공 시 문자열, 실패 시 null). */
  if (window.PIA_LOCAL_AI_OFF !== false) {
    try {
      const _o2 = await Promise.race([callLLMFree(String(prompt), systemPrompt, null, _piaChatOpts()), piaTimeout(Math.max(1200, Number(timeoutMs) || 12000), null)]);
      return (_o2 && String(_o2).trim()) ? String(_o2).trim() : null;
    } catch (e) { console.error('[자유대화] 서버 AI 호출 실패:', e && e.message); return null; }
  }
  try {
    const ctrlL = new AbortController();
    const tL = setTimeout(function(){ ctrlL.abort(); }, Math.max(1200, Number(timeoutMs) || 12000));
    const lang = (window.aipiaCurrentLang === 'en') ? 'en' : 'ko';
    const resL = await fetch(PIA_LOCAL_CHAT_URL, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrlL.signal,
      body: JSON.stringify({ language: lang, message: String(prompt), system: systemPrompt ? String(systemPrompt) : undefined })
    });
    clearTimeout(tL);
    if (!resL.ok) return null;
    const dL = await resL.json();
    const cL = dL && dL.reply;
    return (cL && String(cL).trim()) ? String(cL).trim() : null;
  } catch (e) {
    if (window.console) console.error('로컬 AI 채팅 호출 실패:', e && e.message);
    return null;
  }
}

function piaTimeout(ms, value) {
  return new Promise(function(resolve){ setTimeout(function(){ resolve(value); }, ms); });
}

function fastEverydayReply(text, topic, bankNudge) {
  var msg = String(text || '').trim();
  var bank = bankNudge && bankNudge.question ? String(bankNudge.question).trim() : '';
  if (/게임|유튜브|휴대폰|폰/.test(msg)) {
    return '게임 얘기 나오니까 진짜 좋아하는 게 느껴져요. 요즘 어떤 게임 할 때 시간이 제일 빨리 가요?';
  }
  if (/친구|싸웠|놀아/.test(msg)) {
    return '친구 일은 마음에 오래 남을 때가 있죠. 지금은 서운함이 더 커요, 아니면 다시 말 걸고 싶은 마음이 더 커요?';
  }
  if (/기분|별로|속상|우울|불안|외로|지쳐|피곤/.test(msg)) {
    return '오늘 마음이 꽤 무거웠나 봐요. 지금 기분을 조금이라도 덜 힘들게 해주는 게 하나 있다면 뭐예요?';
  }
  if (/국어|책|소설|글/.test(msg)) {
    return '국어 시간이 좋다는 말이 반가워요. 읽기, 쓰기, 발표 중에 어떤 순간이 제일 재미있어요?';
  }
  if (/꿈|진로|직업|되고 싶/.test(msg)) {
    return '꿈이 아직 또렷하지 않아도 괜찮아요. 요즘 해보면 은근히 재미있는 일부터 같이 찾아볼까요?';
  }
  if (bank) {
    return bank /* [2026-09-21] 접두어 제거 — 폴백마다 같은 말이 붙어 티가 났다 */;
  }
  if (topic === '생활습관/취미') return '그 얘기 더 듣고 싶어요. 요즘 제일 자주 하게 되는 건 뭐예요?';
  return '좋아요, 편하게 말해줘서 고마워요. 방금 이야기에서 제일 크게 남는 장면은 뭐였어요?';
}

// CBT-aware 시스템프롬프트 생성
function _isKoreanReply(t){
  t=String(t||'');
  // 한국어 외 문자체계(한자·가나·태국·키릴·아랍·히브리·데바나가리·그리스 등) 혼입 시 차단
  if(/[\u3040-\u30ff\u3400-\u9fff\u0e00-\u0e7f\u0400-\u04ff\u0600-\u06ff\u0590-\u05ff\u0900-\u097f\u0370-\u03ff]/.test(t)) return false;
  // 영문 단어(3자 이상) 혼입 차단 — 흔한 약어만 허용
  var allow=/^(ai|pia|mbti|tv|ok|sns|it|big5|riasec|via|grit|sjt|gad|phq|who|rses|ces|cesd|app|ux|ui)$/i;
  var words=t.match(/[A-Za-z][A-Za-z0-9]*/g)||[];
  for(var i=0;i<words.length;i++){ if(words[i].replace(/[0-9]/g,'').length>=3 && !allow.test(words[i])) return false; }
  // 한글이 거의 없으면(외국어 위주) 차단
  var hangul=(t.match(/[\uac00-\ud7a3]/g)||[]).length;
  if(hangul===0 && t.replace(/[^A-Za-z]/g,'').length>4) return false;
  return true;
}
function _isReplyInLang(t, lang){
  t=String(t||'');
  if(lang!=='en') return _isKoreanReply(t);
  if(/[가-힣぀-ヿ㐀-鿿฀-๿Ѐ-ӿ؀-ۿ֐-׿ऀ-ॿͰ-Ͽ]/.test(t)) return false;
  var letters=(t.match(/[A-Za-z]/g)||[]).length;
  if(letters<3) return false;
  return true;
}
function buildSystemPrompt(stage, topic) {
  const stageGuide = {
    RAPPORT: '가볍게 인사하고 요즘 뭐가 제일 재미있는지 편하게 물어봐요.',
    EXPLORE: '상대가 좋아하는 것·관심사·일상을 호기심 있게 같이 떠들어요(취미·게임·노래·친구 등).',
    REFRAME: '들은 얘기에 신나게 맞장구치고, 자연스럽게 다른 재미있는 주제로 가볍게 넓혀요.',
    ACTION: '무겁지 않게, 요즘 해보고 싶거나 기대되는 일을 가볍게 물어봐요.',
    CHECKOUT: '즐겁게 마무리하며, 오늘 얘기 중 제일 재밌던 걸 한마디 나눠요.'
  };
  // 지금까지 신호가 가장 적게 모인 성향 영역을 다음 탐색 대상으로 추론
  const dims = (state.results.conv && state.results.conv.dims) || {};
  const probeOrder = ['창의','탐구','분석','공감','실천','감성','계획','관찰','도전','자유','현실','책임','외향','내향'];
  const probe = probeOrder.slice().sort(function(a,b){ return ((dims[a]||0)-(dims[b]||0)); })[0];
  const probeHint = {
    창의:'상상하거나 만드는 걸 좋아하는지', 탐구:'궁금한 걸 파고드는 편인지', 분석:'이유나 원리를 따져보는 편인지',
    공감:'친구 마음을 잘 살피는지', 실천:'생각보다 바로 행동하는 편인지', 감성:'감정·분위기를 예민하게 느끼는지',
    계획:'미리 계획·정리하는 편인지', 관찰:'조용히 지켜보며 알아채는지', 도전:'새로운 것에 도전하는 편인지',
    자유:'규칙보다 자유로운 걸 좋아하는지', 현실:'실제로 쓸모 있는 걸 중시하는지', 책임:'맡은 걸 끝까지 해내는지',
    외향:'사람들과 어울릴 때 힘이 나는지', 내향:'혼자만의 시간이 편한지'
  };
  // A: 응답자 실제 수준(프로필 학년/대상)으로 cfg.grade 보강 — 자유대화 난이도 자동 맞춤
  function _levelFromProfile(){
    try{
      var g=(state.profile&&state.profile.grade)||'';
      var s=String(g);
      if(/초|elem|초등/.test(s)) return 'elem';
      if(/중/.test(s)) return 'mid';
      if(/고/.test(s)) return 'high';
      if(/대학|univ|대학생/.test(s)) return 'univ';
      if(/성인|일반|adult/.test(s)) return 'adult';
      if(typeof currentAudience!=='undefined'){
        if(currentAudience==='parent'||currentAudience==='teacher') return 'adult';
      }
      var m=s.match(/(\d+)/);
      if(m){ var num=parseInt(m[1],10);
        if(num>=1&&num<=6) return 'elem';
        if(num>=7&&num<=9) return 'mid';
        if(num>=10&&num<=12) return 'high';
      }
    }catch(e){}
    return null;
  }
  const _lvl = _levelFromProfile() || (state.cfg && state.cfg.grade) || 'mid';
  const LVL = {
    elem:'상대는 초등학생입니다. 아주 쉬운 단어와 짧은 문장, 다정한 반말을 쓰세요. [대화법: 친한 형·누나처럼 신나게 수다 떨기. 좋아하는 것(게임·캐릭터·만화)으로 가볍게 맞장구치고 같이 즐거워하기. 감정 캐묻거나 분석하지 말고, 한 번에 하나만 재미있게 묻기.]',
    mid:'상대는 중학생입니다. 쉬운 단어와 또래 같은 편한 해요체를 쓰세요. [대화법: 또래 친구처럼 편하게 수다. 관심사(게임·음악·유튜브·친구 얘기)로 가볍게 맞장구치며 같이 떠들기. 상담하듯 감정 캐묻거나 분석·설교하지 말고, 재미있고 솔직하게 반응하기.]',
    high:'상대는 고등학생입니다. 또래 같은 편한 해요체로 진로·학업 맥락을 자연스럽게 다루세요. [대화법: 편한 친구처럼 가볍게 수다. 관심사·일상·진로 얘기를 부담 없이 주고받되, 상담·분석·훈수 두지 말고 호기심 있게 반응하기. 답을 정해주려 말고 같이 떠드는 느낌으로.]',
    univ:'상대는 대학생입니다. 편안하지만 공손한 어조(가벼운 존댓말)와 대학생 어휘로 진로·전공·자기탐색을 다루세요. [대화법: 편하지만 공손하게, 친구 같은 수다 톤. 관심사·일상·진로를 가볍게 주고받기. 상담·심리분석·반영적 경청 같은 기법 쓰지 말고, 자연스럽고 솔직하게 반응하기.]',
    adult:'상대는 성인(일반인)입니다. 정중한 존댓말과 성인 어휘로 직업·삶·관계 맥락을 존중하며 대화하세요. [대화법: 정중하지만 편안한 수다 톤. 일상·취향·일 얘기를 가볍게 주고받기. 상담사처럼 감정 캐묻거나 심리분석·코칭하지 말고, 사람 대 사람으로 자연스럽게 대화하기.]'
  };
  return `당신은 사용자(초등~성인, 어떤 언어 사용자든)와 '일상 수다'를 나누는 친근한 AI "피아"입니다. 자연스러운 대화 속에서 사용자의 성향·흥미·강점을 파악하는 것이 목적입니다. 규칙:
1. 대상 수준: ${LVL[_lvl]} (이 수준의 어휘·문장 난이도에 정확히 맞추세요.) 비판·설교·긴 조언 금지.
2. 학생이 질문하면 먼저 그 질문에 진짜로(짧고 쉽게) 답해줘. 회피하거나 질문으로만 받아치지 말 것.
3. 답한 뒤, 끝에 열린 질문 '하나'만 자연스럽게 곁들여 대화를 이어가. 이번 질문은 학생이 [${probe}] 영역(${probeHint[probe] || ''})이 드러나도록 일상적으로 던져(취미·좋아하는 것·오늘 하루·친구·상상 등). 절대 검사 문항처럼 묻지 말 것.
4-1. 같은 말을 되풀이하지 마라. 앞에서 쓴 문장·질문·감탄사를 그대로 다시 쓰지 말고, 매번 다른 표현과 다른 각도로 물어라. '그렇구나', '좋아요' 같은 리액션도 같은 것을 연달아 쓰지 마라.
4. 1~3문장으로 짧고 경쾌하게. 무거운 위로·공감 멘트를 남발하지 말고 친구처럼 가볍게 반응해(맞장구·리액션 위주). 상대가 먼저 끝내자고 하기 전에는 네가 먼저 대화를 마무리하지 마.
5. 대화 흐름: ${stageGuide[stage] || stageGuide.RAPPORT} (현재 주제: ${topic}). ★이건 상담이 아니라 '친구와의 수다'다. 감정을 캐묻거나 심리분석·인지재구성·조언 설교를 하지 말고, 가볍고 밝고 재미있게 대화해.
6. 의료 진단·약물·자해 방법은 언급하지 않음. 자해·자살·학대·폭력 신호가 보이면 즉시 공감 후 "청소년상담 1388, 정신건강위기 1577-0199, 가까운 믿을 어른"에게 도움을 요청하도록 안내.
7. 이모지는 최대 1개. **사용자가 쓴 언어와 동일한 언어로 답하세요**(한국어·영어·일본어·중국어 등 자동 감지해 맞춤). 사용자가 질문하거나 문제 풀이를 요청하면 그 언어로 친절하고 정확하게 도와준 뒤 자연스럽게 대화를 이어가세요.
8. 응답자 수준 맞춤: 상대 수준(${_lvl})에 정확히 맞춰 쉬운 단어와 짧은 문장으로 질문하고 답하세요. 어려운 용어는 반드시 풀어서 설명하고, 이어지는 다음 질문도 같은 수준의 난이도를 끝까지 유지하세요.
9. 자연스러움: 학생이 한 말을 되풀이하거나 요약해서 다시 들려주지 마세요(\"축구를 좋아하는구나\", \"엄마는 의사가 되길 바라시는구나\"처럼 따라 말하기 금지). \"멋지다!\", \"그럴 때 있지.\" 같은 짧은 반응 한마디 뒤 바로 네 생각이나 새 질문으로 이어가세요. "진심으로", "도움이 될 수 있어요", "좋은 방법이에요" 같은 내용 없는 일반론으로 시작하지 마세요. 훈수처럼 "~해야 해요"라고 끝내지 말고, 부담 없는 선택지나 경험 질문으로 이어가세요.
10. [길이·질문 수 엄수 — 음성으로 바로 읽힘] 답 전체는 최대 3문장, 120자 이내. 물음표(?)는 답 전체에서 딱 한 번, 마지막 문장에만. 질문을 두 개 이상 하거나 선택지를 늘어놓지 마라. '아이고'·'와,' 같은 감탄사로 매번 시작하지 말고 학생 말을 따라 하지 말고 바로 반응해. '음…', '어…', '흠' 같은 머뭇거리는 말은 쓰지 마.
11. 기억: [기억]이 주어지면 학생이 앞에서 한 이야기를 잊지 마라. 이미 답한 것을 다시 묻지 말고, 어울릴 때는 지난 이야기와 지금 이야기를 이어 줘(방금 한 말을 따라 말하는 것과는 다르다). [기억]에 없는 사실을 지어내지 마라.`;
}

// -----------------------------------------------------------------
//  한국 공공 진로 정보 (커리어넷 OpenAPI 데이터 정적 내장)
//  실제 운영 시 백엔드 프록시로 커리어넷 OpenAPI 호출 가능
//  data.go.kr 인증키 발급 후 backend → /api/career?keyword=...
// -----------------------------------------------------------------
const CAREER_DATABASE = {
  '디자이너': {
    description: '시각·UI·제품 디자인을 통해 사용자 경험을 만드는 직업',
    skills: ['Figma','Adobe XD','일러스트레이션','UX 리서치'],
    salary: '신입 3,000~3,500만 원, 5년차 4,500~6,000만 원',
    growth: '디지털 전환·AI 도구 활용으로 수요 증가',
    relatedMajors: ['시각디자인','산업디자인','UX디자인','미디어디자인'],
    apiSource: 'careernet'
  },
  '웹툰 작가': {
    description: '디지털 만화·웹툰을 기획·창작하는 직업',
    skills: ['디지털 페인팅','스토리텔링','클립스튜디오','캐릭터 디자인'],
    salary: '편당 80~300만 원, 인기작은 월 수천만 원',
    growth: 'K-콘텐츠 글로벌 확장으로 매우 높음',
    relatedMajors: ['만화·애니메이션학과','웹툰학과','미술학과'],
    apiSource: 'careernet'
  },
  '일러스트레이터': {
    description: '책·게임·광고용 일러스트레이션 제작',
    skills: ['디지털 페인팅','색채감각','캐릭터 설정','외주 관리'],
    salary: '프리랜서 평균 월 200~500만 원',
    growth: '게임·웹툰·NFT로 영역 확장',
    relatedMajors: ['시각디자인','일러스트레이션','미술'],
    apiSource: 'careernet'
  },
  '그래픽 디자이너': {
    description: '브랜드·광고·인쇄물 시각 디자인',
    skills: ['Photoshop','Illustrator','타이포그래피','브랜딩'],
    salary: '신입 2,800~3,200만 원',
    growth: '브랜딩 전문성으로 차별화 필요',
    relatedMajors: ['시각디자인','커뮤니케이션디자인'],
    apiSource: 'careernet'
  },
  'UX디자이너': {
    description: '사용자 경험을 설계하는 디지털 제품 디자이너',
    skills: ['UX 리서치','와이어프레임','프로토타이핑','데이터 분석'],
    salary: '신입 3,500~4,500만 원, 시니어 7,000만 원+',
    growth: 'IT 기업 채용 매우 활발',
    relatedMajors: ['UX디자인','산업디자인','HCI','심리학'],
    apiSource: 'careernet'
  },
  '그림책 작가': {
    description: '어린이용 그림책 글·그림 창작',
    skills: ['수채화/디지털','스토리','출판 편집','강연'],
    salary: '인세 5~10%, 베스트셀러 시 억대 수익',
    growth: '교육·정서 콘텐츠 수요 증가',
    relatedMajors: ['아동학','일러스트레이션','문예창작'],
    apiSource: 'careernet'
  },
  '영상 제작': {
    description: 'YouTube·OTT·광고 영상 기획·촬영·편집',
    skills: ['Premiere Pro','After Effects','촬영','기획'],
    salary: '신입 3,000만 원, 프리랜서 변동',
    growth: '숏폼 시대 폭발적 수요',
    relatedMajors: ['영상디자인','방송영상','미디어'],
    apiSource: 'careernet'
  },
  '상담사': {
    description: '청소년·성인 심리상담 전문가',
    skills: ['공감','경청','상담이론','임상슈퍼비전'],
    salary: '신입 3,000만 원, 자격 등급 따라 상승',
    growth: 'Wee센터·민간상담 수요 증가',
    relatedMajors: ['심리학','상담학','사회복지','교육학'],
    license: ['청소년상담사','임상심리사','전문상담교사'],
    apiSource: 'careernet'
  },
  '교사': {
    description: '초·중·고 학생 교육 전문가',
    skills: ['교과 전문성','학생 이해','수업 설계','평가'],
    salary: '신입 약 3,500만 원, 호봉제',
    growth: '안정적이나 임용 경쟁률 높음',
    relatedMajors: ['교육대','사범대','임용고시'],
    license: ['교사자격증(1·2급 정교사)'],
    apiSource: 'careernet'
  },
  '사회복지': {
    description: '사회 약자 보호와 복지 서비스 제공',
    skills: ['상담','사회복지법','사례관리','공감'],
    salary: '신입 2,800~3,200만 원',
    growth: '고령화·복지 확대로 안정적',
    relatedMajors: ['사회복지학','심리학'],
    license: ['사회복지사 1·2급'],
    apiSource: 'careernet'
  },
  '미술치료사': {
    description: '미술 활동으로 정서적 치유를 돕는 전문가',
    skills: ['상담','미술','임상 슈퍼비전','윤리'],
    salary: '신입 2,800~3,500만 원',
    growth: '교육·복지 영역에서 관심 증가',
    relatedMajors: ['미술치료학','심리학','미술학'],
    license: ['미술치료사(민간자격 다수)','임상미술치료사'],
    apiSource: 'careernet'
  },
  '청소년 상담교사': {
    description: '학교에서 학생 정서·진로 상담',
    skills: ['상담이론','학교상담','위기개입'],
    salary: '교사 호봉제',
    growth: 'SEL 정책으로 수요 증가',
    relatedMajors: ['상담심리','교육학','전문상담교사 양성과정'],
    license: ['전문상담교사 1·2급','청소년상담사'],
    apiSource: 'careernet'
  },
  'AI/SW 엔지니어': {
    description: '인공지능·머신러닝·소프트웨어 개발',
    skills: ['Python','PyTorch','수학·통계','시스템 설계'],
    salary: '신입 5,000~7,000만 원, 시니어 1억+',
    growth: 'AI 시대 최고 수요 직군',
    relatedMajors: ['컴퓨터공학','인공지능학','데이터사이언스'],
    apiSource: 'careernet'
  },
  '데이터분석가': {
    description: '데이터로 인사이트 도출 및 의사결정 지원',
    skills: ['SQL','Python','통계','시각화'],
    salary: '신입 4,000~5,000만 원',
    growth: '전 산업 디지털 전환으로 매우 높음',
    relatedMajors: ['통계학','데이터사이언스','산업공학','수학'],
    apiSource: 'careernet'
  },
  '과학자': {
    description: '기초·응용 과학 연구',
    skills: ['실험설계','논문 작성','연구비 관리'],
    salary: '박사 후 연구원 약 5,000만 원~',
    growth: '국가 R&D 투자 지속',
    relatedMajors: ['물리·화학·생물·지구과학','대학원 필수'],
    apiSource: 'careernet'
  }
};

const CAREER_DATABASE_EN = {
  '디자이너': { title:'Designer', description:'A profession that creates user experience through visual, UI, and product design', skills:['Figma','Adobe XD','Illustration','UX Research'], salary:'Entry-level KRW 30-35M, 5-year: KRW 45-60M', growth:'Growing demand from digital transformation and AI tool adoption', relatedMajors:['Visual Design','Industrial Design','UX Design','Media Design'] },
  '웹툰 작가': { title:'Webtoon Artist', description:'Plans and creates digital comics and webtoons', skills:['Digital Painting','Storytelling','Clip Studio','Character Design'], salary:'KRW 0.8-3M per episode; hit series can earn tens of millions per month', growth:'Very high, driven by the global expansion of K-content', relatedMajors:['Comics & Animation','Webtoon Studies','Fine Arts'] },
  '일러스트레이터': { title:'Illustrator', description:'Creates illustrations for books, games, and advertising', skills:['Digital Painting','Color Sense','Character Design','Client Management'], salary:'Freelance average KRW 2-5M per month', growth:'Expanding into games, webtoons, and NFTs', relatedMajors:['Visual Design','Illustration','Fine Arts'] },
  '그래픽 디자이너': { title:'Graphic Designer', description:'Visual design for brands, advertising, and print materials', skills:['Photoshop','Illustrator','Typography','Branding'], salary:'Entry-level KRW 28-32M', growth:'Differentiation through branding expertise is increasingly needed', relatedMajors:['Visual Design','Communication Design'] },
  'UX디자이너': { title:'UX Designer', description:'A digital product designer who designs the user experience', skills:['UX Research','Wireframing','Prototyping','Data Analysis'], salary:'Entry-level KRW 35-45M, senior KRW 70M+', growth:'Very active hiring at IT companies', relatedMajors:['UX Design','Industrial Design','HCI','Psychology'] },
  '그림책 작가': { title:'Picture Book Author', description:"Writes and illustrates children's picture books", skills:['Watercolor/Digital Art','Storytelling','Publishing Editing','Public Speaking'], salary:'Royalties 5-10%; bestsellers can earn nine-figure (KRW) income', growth:'Growing demand for educational and emotional-development content', relatedMajors:['Child Development','Illustration','Creative Writing'] },
  '영상 제작': { title:'Video Production', description:'Planning, filming, and editing video for YouTube, OTT, and advertising', skills:['Premiere Pro','After Effects','Filming','Planning'], salary:'Entry-level KRW 30M; freelance income varies', growth:'Explosive demand in the short-form video era', relatedMajors:['Video Design','Broadcasting & Video','Media Studies'] },
  '상담사': { title:'Counselor', description:'A psychological counseling professional for teens and adults', skills:['Empathy','Active Listening','Counseling Theory','Clinical Supervision'], salary:'Entry-level KRW 30M; increases with certification level', growth:'Growing demand from Wee Centers and private counseling', relatedMajors:['Psychology','Counseling','Social Welfare','Education'], license:['Youth Counselor','Clinical Psychologist','Professional School Counselor Teacher'] },
  '교사': { title:'Teacher', description:'An education professional for elementary, middle, and high school students', skills:['Subject Expertise','Understanding Students','Lesson Design','Assessment'], salary:'Entry-level about KRW 35M, salary scale by seniority', growth:'Stable, but competition for teaching positions is high', relatedMajors:['College of Education','Teachers College','Teacher Certification Exam'], license:['Teaching Certificate (1st/2nd Grade)'] },
  '사회복지': { title:'Social Welfare', description:'Protects vulnerable populations and provides welfare services', skills:['Counseling','Social Welfare Law','Case Management','Empathy'], salary:'Entry-level KRW 28-32M', growth:'Stable, driven by an aging population and expanding welfare programs', relatedMajors:['Social Welfare','Psychology'], license:['Social Worker (Grade 1/2)'] },
  '미술치료사': { title:'Art Therapist', description:'A professional who supports emotional healing through art activities', skills:['Counseling','Art','Clinical Supervision','Ethics'], salary:'Entry-level KRW 28-35M', growth:'Growing interest in education and welfare settings', relatedMajors:['Art Therapy','Psychology','Fine Arts'], license:['Art Therapist (various private certifications)','Clinical Art Therapist'] },
  '청소년 상담교사': { title:'Youth Counseling Teacher', description:'Provides emotional and career counseling for students at school', skills:['Counseling Theory','School Counseling','Crisis Intervention'], salary:'Teacher salary scale', growth:'Growing demand driven by SEL (social-emotional learning) policy', relatedMajors:['Counseling Psychology','Education','Professional School Counselor Training Program'], license:['Professional School Counselor Teacher (1st/2nd Grade)','Youth Counselor'] },
  'AI/SW 엔지니어': { title:'AI/Software Engineer', description:'Develops artificial intelligence, machine learning, and software', skills:['Python','PyTorch','Math & Statistics','System Design'], salary:'Entry-level KRW 50-70M, senior KRW 100M+', growth:'The highest-demand field of the AI era', relatedMajors:['Computer Engineering','Artificial Intelligence','Data Science'] },
  '데이터분석가': { title:'Data Analyst', description:'Derives insights from data to support decision-making', skills:['SQL','Python','Statistics','Data Visualization'], salary:'Entry-level KRW 40-50M', growth:'Very high, driven by digital transformation across all industries', relatedMajors:['Statistics','Data Science','Industrial Engineering','Mathematics'] },
  '과학자': { title:'Scientist', description:'Conducts basic and applied scientific research', skills:['Experimental Design','Academic Writing','Research Funding Management'], salary:'Postdoctoral researcher from about KRW 50M+', growth:'Continued national R&D investment', relatedMajors:['Physics/Chemistry/Biology/Earth Science','Graduate school required'] }
};

function getCareerInfo(jobTitle) {
  // 정확한 매칭
  if (CAREER_DATABASE[jobTitle]) return CAREER_DATABASE[jobTitle];
  // 부분 매칭
  for (const key of Object.keys(CAREER_DATABASE)) {
    if (jobTitle.includes(key) || key.includes(jobTitle)) return CAREER_DATABASE[key];
  }
  return null;
}

// -----------------------------------------------------------------
//  16유형별 추천 자격증 (한국산업인력공단 데이터 정적 내장)
//  실제 운영 시 https://openapi.hrdkorea.or.kr API로 동적 조회 가능
// -----------------------------------------------------------------
const LICENSE_BY_TYPE = {
  'CR-EX': ['컴퓨터그래픽스운용기능사','웹디자인기능사','GTQ 그래픽기술자격','컬러리스트산업기사'],
  'LO-AN': ['정보처리기능사','정보처리산업기사','SQLD','빅데이터분석기사'],
  'EM-CO': ['청소년상담사','사회복지사 2급','전문상담교사','심리상담사(민간)'],
  'EX-LE': ['ADsP','컴퓨터활용능력','경영지도사','마케팅관리사'],
  'QT-RS': ['독서지도사','논술지도사','한국어교원'],
  'EX-CR': ['컴퓨터그래픽스운용기능사','웹툰스토리텔링자격','만화일러스트지도사'],
  'PL-MG': ['ADsP','컴퓨터활용능력 1급','행정관리사','회계관리'],
  'RE-CO': ['청소년상담사','사회복지사 2급','중재인 자격증'],
  'CH-PI': ['생활스포츠지도사','경영지도사','마케팅관리사'],
  'AR-EX': ['컴퓨터그래픽스운용기능사','문화예술교육사','웹툰스토리텔링자격'],
  'PR-HA': ['기계정비기능사','전기기능사','조리기능사','가구제작기능사'],
  'FU-ST': ['ADsP','경영지도사','정책분석평가사'],
  'RP-CL': ['컴퓨터활용능력','품질경영기사','직업상담사 2급','워드프로세서'],
  'IN-SP': ['한국사능력검정시험','TESAT','특허청 기술자격'],
  'BA-GR': ['컴퓨터활용능력','한국사능력검정시험','국가공인 한자 자격증'],
  'PT-EX': ['직업기초능력향상','한자급수자격','정보처리기능사(입문)']
};

const LICENSE_BY_TYPE_EN = {
  'CR-EX': ['컴퓨터그래픽스운용기능사 (Craftsman Computer Graphics Operator)','웹디자인기능사 (Craftsman Web Design)','GTQ 그래픽기술자격 (GTQ Graphic Technology Qualification)','컬러리스트산업기사 (Industrial Engineer Colorist)'],
  'LO-AN': ['정보처리기능사 (Craftsman Information Processing)','정보처리산업기사 (Industrial Engineer Information Processing)','SQLD (SQL Developer)','빅데이터분석기사 (Engineer Big Data Analysis)'],
  'EM-CO': ['청소년상담사 (Youth Counselor)','사회복지사 2급 (Social Worker Grade 2)','전문상담교사 (Professional School Counselor Teacher)','심리상담사(민간) (Psychological Counselor \u2014 private certification)'],
  'EX-LE': ['ADsP (Advanced Data Analytics Semi-Professional)','컴퓨터활용능력 (Computer Proficiency Certificate)','경영지도사 (Certified Management Consultant)','마케팅관리사 (Marketing Manager Certificate)'],
  'QT-RS': ['독서지도사 (Reading Instructor)','논술지도사 (Essay-Writing Instructor)','한국어교원 (Korean Language Teacher)'],
  'EX-CR': ['컴퓨터그래픽스운용기능사 (Craftsman Computer Graphics Operator)','웹툰스토리텔링자격 (Webtoon Storytelling Certificate)','만화일러스트지도사 (Comic Illustration Instructor)'],
  'PL-MG': ['ADsP (Advanced Data Analytics Semi-Professional)','컴퓨터활용능력 1급 (Computer Proficiency Certificate Level 1)','행정관리사 (Administrative Management Certificate)','회계관리 (Accounting Management Certificate)'],
  'RE-CO': ['청소년상담사 (Youth Counselor)','사회복지사 2급 (Social Worker Grade 2)','중재인 자격증 (Mediator Certificate)'],
  'CH-PI': ['생활스포츠지도사 (Lifetime Sports Instructor)','경영지도사 (Certified Management Consultant)','마케팅관리사 (Marketing Manager Certificate)'],
  'AR-EX': ['컴퓨터그래픽스운용기능사 (Craftsman Computer Graphics Operator)','문화예술교육사 (Culture & Arts Education Instructor)','웹툰스토리텔링자격 (Webtoon Storytelling Certificate)'],
  'PR-HA': ['기계정비기능사 (Craftsman Machine Maintenance)','전기기능사 (Craftsman Electricity)','조리기능사 (Craftsman Cooking)','가구제작기능사 (Craftsman Furniture Making)'],
  'FU-ST': ['ADsP (Advanced Data Analytics Semi-Professional)','경영지도사 (Certified Management Consultant)','정책분석평가사 (Policy Analysis & Evaluation Certificate)'],
  'RP-CL': ['컴퓨터활용능력 (Computer Proficiency Certificate)','품질경영기사 (Engineer Quality Management)','직업상담사 2급 (Vocational Counselor Grade 2)','워드프로세서 (Word Processor Certificate)'],
  'IN-SP': ['한국사능력검정시험 (Korean History Proficiency Test)','TESAT (Test of Economic Sense And Thinking)','특허청 기술자격 (Korean Intellectual Property Office Technical Qualification)'],
  'BA-GR': ['컴퓨터활용능력 (Computer Proficiency Certificate)','한국사능력검정시험 (Korean History Proficiency Test)','국가공인 한자 자격증 (Nationally Certified Chinese-Character Certificate)'],
  'PT-EX': ['직업기초능력향상 (Basic Vocational Competency)','한자급수자격 (Chinese-Character Level Certificate)','정보처리기능사(입문) (Craftsman Information Processing \u2014 entry level)']
};

// -----------------------------------------------------------------
//  AI Hub 데이터셋 자산 인덱스 (사용 시 NIA AI Hub 신청 필요)
// -----------------------------------------------------------------
const AIHUB_RESOURCES = [
  { name:'청소년 음성 감정 데이터', desc:'3,000시간, 7개 감정 라벨', useCase:'키오스크 STT/감정인식 학습', url:'https://aihub.or.kr/aihubdata/data/view.do?currMenu=115&topMenu=100&dataSetSn=71632' },
  { name:'아동·청소년 상담 데이터', desc:'상담 대화 코퍼스', useCase:'위험표현 분류기 학습', url:'https://aihub.or.kr/aihubdata/data/view.do?dataSetSn=71680' },
  { name:'한국어 감정 정보 단발성 대화', desc:'7감정 라벨', useCase:'감정 분류 모델', url:'https://aihub.or.kr/aihubdata/data/view.do?dataSetSn=270' },
  { name:'한국어 아동 음성 데이터', desc:'아동 낭독 발화', useCase:'아동용 STT 정확도 향상', url:'https://aihub.or.kr/aihubdata/data/view.do?dataSetSn=540' }
];

// -----------------------------------------------------------------
//  외부 무료 API 카탈로그 (UI 표시용)
// -----------------------------------------------------------------
/* [2026-09-28] 무료 API 카탈로그(17.7KB)는 LOCAL_ONLY 정책으로 퇴역 — 화면에 api-catalog 요소가 없어
   renderApiCatalog() 는 항상 바로 끝났다(web/pia-catalog.js 도 빈 배열). 전송량만 줄이려고 비움. */
const FREE_API_CATALOG = [];

// -----------------------------------------------------------------
//  상담 자원 (위험 신호 시 즉시 안내)
// -----------------------------------------------------------------
const COUNSELING_RESOURCES = {
  CRISIS: [
    { name:'자살예방상담전화 109', phone:'109', desc:'24시간 365일 자살 위기 전문 상담', url:'tel:109', urgency:'CRITICAL' },
    { name:'정신건강위기상담 1577-0199', phone:'1577-0199', desc:'24시간 365일 정신건강 위기 상담', url:'tel:1577-0199', urgency:'CRITICAL' },
    { name:'청소년상담 1388', phone:'1388', desc:'24시간 365일 청소년 전화·웹채팅·문자·카톡 상담', url:'tel:1388', urgency:'HIGH' }
  ],
  CHAT: [
    { name:'카카오톡 청소년상담1388', desc:'카톡 채널 친구추가 → 1:1 채팅', url:'https://pf.kakao.com/_FyKxhs', urgency:'HIGH' },
    { name:'청소년사이버상담센터 (웹채팅)', desc:'1388.go.kr 웹채팅 24/365', url:'https://www.1388.go.kr/cco/YTOSP_SC_CCH_01', urgency:'HIGH' },
    { name:'문자상담 #1388', desc:'문자 보내고 1:1 답변 받기', url:'sms:#1388', urgency:'MEDIUM' }
  ],
  SCHOOL: [
    { name:'학교 Wee클래스', desc:'학교 내 전문상담교사·상담사 즉시 방문 가능', url:'https://www.wee.go.kr/', urgency:'HIGH' },
    { name:'교육지원청 Wee센터', desc:'학교 단위 상담이 어려울 때 위탁 상담', url:'https://www.wee.go.kr/', urgency:'MEDIUM' },
    { name:'병원형 Wee센터', desc:'정서·정신건강 전문 위탁교육·상담', url:'http://www.weeeum.com/', urgency:'MEDIUM' }
  ],
  OUTREACH: [
    { name:'청소년동반자', desc:'찾아가는 상담 — 청소년을 직접 방문', url:'https://www.youth.go.kr/youth/youth/contents/yngbgsCnsltForm.yt?curMenuSn=342', urgency:'HIGH' },
    { name:'청소년쉼터', desc:'가출·위기 청소년 임시 보호 + 상담', url:'https://www.1388.go.kr/', urgency:'HIGH' }
  ],
  GENERAL: [
    { name:'129 보건복지상담', phone:'129', desc:'24시간 보건·복지·아동·노인 통합 상담', url:'tel:129', urgency:'MEDIUM' },
    { name:'e청소년 포털', desc:'청소년 정책·상담·활동 정보 종합', url:'https://www.youth.go.kr/', urgency:'LOW' },
    { name:'국립정신건강센터', desc:'정신건강 정보·자료·기관 안내', url:'https://www.ncmh.go.kr/', urgency:'LOW' }
  ]
};

// 위험도에 따라 자동 노출할 상담 자원 선택
function getCounselingRecommendations(riskLevel) {
  const recs = [];
  if (riskLevel === 'HIGH' || riskLevel === 'CRITICAL') {
    recs.push(...COUNSELING_RESOURCES.CRISIS);
    recs.push(...COUNSELING_RESOURCES.CHAT.slice(0, 2));
    recs.push(...COUNSELING_RESOURCES.SCHOOL.slice(0, 1));
  } else if (riskLevel === 'MEDIUM') {
    recs.push(...COUNSELING_RESOURCES.CHAT);
    recs.push(...COUNSELING_RESOURCES.SCHOOL.slice(0, 2));
  } else {
    recs.push(...COUNSELING_RESOURCES.GENERAL.slice(0, 2));
    recs.push(...COUNSELING_RESOURCES.SCHOOL.slice(0, 1));
  }
  return recs;
}

// =================================================================
//  AI PIA MVP v3 — Main Application Logic
//  7개 검증된 검사 통합 + 자유대화 + 가중 평균 + 신뢰도 등급
// =================================================================

const STORAGE = {
  big5:'pia_v3_big5',
  riasec:'pia_v3_riasec',
  via:'pia_v3_via',
  grit:'pia_v3_grit',
  cesd:'pia_v3_cesd',
  phqa:'pia_v3_phqa',
  gad:'pia_v3_gad',
  who5:'pia_v3_who5',
  rses:'pia_v3_rses',
  learn:'pia_v3_learn',
  mi:'pia_v3_mi',
  riasec60:'pia_v3_riasec60',   /* [E2-A] 흥미 심화(시범) */
  sjt:'pia_v3_sjt',
  conv:'pia_v3_conv',
  cfg:'pia_v3_cfg',
  meta:'pia_v3_meta'
};
/* 기본정보(이름·학교·학년) 보관 키. 세션 저장소만 쓴다. */
const PROFILE_KEY = 'pia_v3_profile';

// ---- AI PIA 자체 16유형 ----
function _T(ko, en){ return (window.aipiaCurrentLang === 'en') ? en : ko; }
/* [2026-09-26] VIA 24 강점 영문명 — 결과 차트·목록 한·영 전환용 */
const VIA_EN = { '창의':'Creativity','호기심':'Curiosity','판단':'Judgment','학습열정':'Love of Learning','통찰':'Perspective','용기':'Bravery','끈기':'Perseverance','정직':'Honesty','활력':'Zest','사랑':'Love','친절':'Kindness','사회지능':'Social Intelligence','협력':'Teamwork','공정':'Fairness','리더십':'Leadership','용서':'Forgiveness','겸손':'Humility','신중':'Prudence','자기조절':'Self-Regulation','심미안':'Appreciation of Beauty','감사':'Gratitude','희망':'Hope','유머':'Humor','영성':'Spirituality' };
function _viaName(k){ return (window.aipiaCurrentLang === 'en' && VIA_EN[k]) ? VIA_EN[k] : k; }
const _RIASEC_LBL_KO = ['현실R','탐구I','예술A','사회S','진취E','관습C'];
const _RIASEC_LBL_EN = ['Realistic R','Investigative I','Artistic A','Social S','Enterprising E','Conventional C'];
const PIA_TYPES_EN = {
  'CR-EX': { name:'Creative Explorer', desc:'Strong imagination and skill at generating new ideas.', careers:['Designer','Webtoon Artist','R&D','Entrepreneurship'] },
  'LO-AN': { name:'Logical Analyst', desc:'Strong at understanding underlying principles and structures.', careers:['AI/Software Engineer','Scientist','Data Analyst'] },
  'EM-CO': { name:'Empathetic Communicator', desc:'Understands people and builds relationships.', careers:['Counselor','Teacher','Social Work'] },
  'EX-LE': { name:'Action-Oriented Leader', desc:'Sets goals and executes quickly.', careers:['Project Manager','Entrepreneur','Management'] },
  'QT-RS': { name:'Quiet Researcher', desc:'Has the focus to analyze deeply on their own.', careers:['Researcher','Writer','Professional/Specialist'] },
  'EX-CR': { name:'Expressive Creator', desc:'Expresses emotions and stories richly.', careers:['Webtoon Artist','Illustrator','UX Designer'] },
  'PL-MG': { name:'Planner/Manager', desc:'Sticks well to rules and plans.', careers:['Administration','Accounting','Legal Affairs'] },
  'RE-CO': { name:'Relationship Coordinator', desc:'Mediates conflict and lifts the mood.', careers:['Counseling','Mediation','Organizational Development'] },
  'CH-PI': { name:'Pioneering Challenger', desc:'Strong in new activities and competition.', careers:['Sports','Entrepreneurship','Marketing'] },
  'AR-EX': { name:'Free-Form Creator', desc:'Expresses without being bound by convention.', careers:['Art','Music','Film/Video'] },
  'PR-HA': { name:'Hands-On Practitioner', desc:'Strong at hands-on, practical activities.', careers:['Engineering','Making/Maker','Cooking'] },
  'FU-ST': { name:'Future Strategist', desc:'Sees the big picture and future possibilities.', careers:['Strategic Planning','Consulting','Policy'] },
  'RP-CL': { name:'Responsible Collaborator', desc:'Conscientious and a steady presence on a team.', careers:['Public Sector','Finance','Quality Management'] },
  'IN-SP': { name:'Independent Specialist', desc:'Digs deep into areas of interest.', careers:['Research','Healthcare','Professional/Specialist'] },
  'BA-GR': { name:'Balanced Grower', desc:'Well-rounded development across many areas.', careers:['General Administration','Education','General Management'] },
  'PT-EX': { name:'Potential Explorer', desc:'Strengths are not clear-cut yet, but growth potential is high.', careers:['Career exploration first'] }
};
function _typeField(t, key){ if(!t) return (key==='careers')?[]:''; var en=(window.aipiaCurrentLang==='en')&&PIA_TYPES_EN[t.code]; return (en && en[key]!=null) ? en[key] : t[key]; }
const PIA_TYPES = [
  { code:'CR-EX', name:'창의탐험형', icon:'🎨', desc:'상상력과 새로운 아이디어 발상이 강합니다.', careers:['디자이너','웹툰작가','연구개발','창업'] },
  { code:'LO-AN', name:'논리분석형', icon:'🔍', desc:'원리와 구조 이해에 강합니다.', careers:['AI/SW 엔지니어','과학자','데이터분석가'] },
  { code:'EM-CO', name:'공감소통형', icon:'💬', desc:'사람을 이해하고 관계를 만듭니다.', careers:['상담사','교사','사회복지'] },
  { code:'EX-LE', name:'실천리더형', icon:'⚡', desc:'목표를 세우고 빠르게 실행합니다.', careers:['프로젝트 매니저','창업가','경영'] },
  { code:'QT-RS', name:'조용한탐구형', icon:'📚', desc:'혼자 깊게 분석하는 집중력이 있습니다.', careers:['연구자','작가','전문직'] },
  { code:'EX-CR', name:'감성표현형', icon:'✨', desc:'감정과 이야기를 풍부하게 표현합니다.', careers:['웹툰작가','일러스트레이터','UX디자이너'] },
  { code:'PL-MG', name:'계획관리형', icon:'📅', desc:'규칙과 계획을 잘 지킵니다.', careers:['행정','회계','법무'] },
  { code:'RE-CO', name:'관계조율형', icon:'🤝', desc:'갈등을 중재하고 분위기를 살립니다.', careers:['상담','중재','조직개발'] },
  { code:'CH-PI', name:'도전개척형', icon:'🚀', desc:'새로운 활동과 경쟁에 강합니다.', careers:['스포츠','창업','마케팅'] },
  { code:'AR-EX', name:'자유창작형', icon:'🎭', desc:'틀에 얽매이지 않고 표현합니다.', careers:['예술','음악','영상'] },
  { code:'PR-HA', name:'현실실무형', icon:'🔧', desc:'손으로 하는 활동에 강합니다.', careers:['엔지니어링','메이커','요리'] },
  { code:'FU-ST', name:'미래전략형', icon:'🎯', desc:'큰 그림과 가능성을 봅니다.', careers:['전략기획','컨설팅','정책'] },
  { code:'RP-CL', name:'책임협력형', icon:'🛡️', desc:'성실하고 팀에 안정적입니다.', careers:['공공','금융','품질관리'] },
  { code:'IN-SP', name:'독립전문형', icon:'🎓', desc:'관심 분야를 깊게 파고듭니다.', careers:['연구','의료','전문직'] },
  { code:'BA-GR', name:'균형성장형', icon:'🌱', desc:'여러 영역이 고르게 발달했습니다.', careers:['종합행정','교육','일반관리'] },
  { code:'PT-EX', name:'잠재발견형', icon:'🔭', desc:'아직 강점이 뚜렷하지 않지만 성장 가능성이 큽니다.', careers:['진로탐색 우선'] }
];

// 주제별 × CBT 단계별 다중 질문 풀 — 반복 방지
const TOPIC_REPLIES = {
  '친구관계': {
    RAPPORT: ['오 친구 얘기! 어떤 친구야? 같이 뭐 하고 노는 사이야?','친구 얘기 좋지~ 요즘 제일 자주 보는 친구는 누구야?'],
    EXPLORE: ['오 그래서 어떻게 됐어? 더 들려줘!','그 친구랑은 보통 뭐 하면서 시간 보내?'],
    REFRAME: ['오 그런 일이 있었구나ㅎㅎ 너는 그때 기분 어땠어?','재밌다~ 그 친구는 어떤 스타일이야?'],
    ACTION: ['요즘 그 친구랑 같이 해보고 싶은 거 있어?','다음에 만나면 뭐 하고 놀 거야?'],
    CHECKOUT: ['오늘 친구 얘기 재밌었다! 그중에 제일 기억에 남는 건 뭐야?','얘기 나눠줘서 고마워~ 또 재밌는 일 생기면 들려줘!']
  },
  '진로': {
    RAPPORT: ['꿈은 천천히 찾아도 돼ㅎㅎ 요즘 뭐가 제일 재미있어?','진로 얘기구나~ 요즘 관심 가는 거 있어?'],
    EXPLORE: ['시간 가는 줄 모르고 하게 되는 거 있어? 뭐 할 때 제일 신나?','학교에서 제일 좋아하는 과목이나 활동은 뭐야?'],
    REFRAME: ['잘하는 거랑 좋아하는 거가 달라도 괜찮아~ 너는 둘 중에 뭐가 더 끌려?','오 그거 멋지다! 그게 왜 좋아?'],
    ACTION: ['그거 관련해서 가볍게 한번 해보고 싶은 거 있어?','관심 가는 직업 영상 같은 거 본 적 있어?'],
    CHECKOUT: ['오늘 진로 얘기하면서 새로 알게 된 너의 모습 있어?','다음엔 어떤 거 더 얘기해보고 싶어?']
  },
  '학습/국어': {
    RAPPORT: ['오 국어 좋아하는구나! 어떤 게 제일 재밌어?','책이나 글 읽다가 오 이거다 싶었던 적 있어?'],
    EXPLORE: ['읽기·쓰기·발표 중에 뭐가 제일 편해?','최근에 기억에 남는 문장이나 장면 있어?'],
    REFRAME: ['국어 잘하는 게 꼭 시험만은 아니지~ 일상에서 글빨 느낀 적 있어?','서툴러도 표현하는 게 멋진 거야! 너는 어때?'],
    ACTION: ['오늘 한 문장만 일기처럼 써본다면 뭐라고 쓸래?','좋아하는 작품 한 구절 따라 적어보는 거 어때?'],
    CHECKOUT: ['오늘 얘기 중에 제일 기억에 남는 거 뭐야?','다음에 더 깊게 얘기하고 싶은 거 있어?']
  },
  '학습/수학': {
    RAPPORT: ['수학 얘기 해보자~ 어떤 부분에서 막혀?'],
    EXPLORE: ['계산이 어려워, 문제 해석이 어려워, 아니면 시간이 부족해? 어디가 제일 빡세?'],
    REFRAME: ['"수학머리 없다"는 거 진짜일까?ㅎㅎ 그래도 좀 괜찮았던 단원 없었어?'],
    ACTION: ['오늘 딱 한 문제 풀어본다면 어떤 단원이 좋을까?'],
    CHECKOUT: ['오늘 얘기한 것 중에 하나만 가져간다면 뭐야?']
  },
  '가족관계': {
    RAPPORT: ['가족 얘기구나~ 편하게 말해줘. 누구 얘기야?'],
    EXPLORE: ['집에서 제일 자주 같이 시간 보내는 사람은 누구야?'],
    REFRAME: ['오 그랬구나ㅎㅎ 너는 그때 어떤 기분이었어?'],
    ACTION: ['요즘 가족이랑 같이 해보고 싶은 거 있어?'],
    CHECKOUT: ['오늘 가족 얘기 들려줘서 고마워~ 또 얘기하고 싶은 거 있어?']
  },
  '생활습관/취미': {
    RAPPORT: ['요즘 시간 제일 많이 쓰는 거 뭐야? 궁금하다!'],
    EXPLORE: ['수면·폰·게임 중에 조절 제일 어려운 게 뭐야?ㅎㅎ'],
    REFRAME: ['습관은 의지보다 환경이 더 세다더라~ 바꿔볼 만한 거 있어?'],
    ACTION: ['오늘 밤부터 딱 하나만 바꿔본다면 뭐가 좋을까?'],
    CHECKOUT: ['그거 며칠 정도 해볼래? 나중에 어땠는지 들려줘!']
  },
  '정서': {
    RAPPORT: ['그랬구나~ 얘기해줘서 고마워. 언제부터 그런 기분이었어?','음 그런 날도 있지ㅎㅎ 무슨 일 있었어?'],
    EXPLORE: ['어떤 순간에 그 기분이 제일 컸어?','오늘 하루는 어땠어? 어떤 일이 있었어?'],
    REFRAME: ['그럴 수 있어~ 너만 그런 거 아니야. 비슷한 친구들 꽤 많아!','오 그렇구나. 그래도 오늘 중에 그나마 괜찮았던 순간은 없었어?'],
    ACTION: ['오늘 기분 살짝 가볍게 해줄 거 하나 해본다면? 산책·음악·간식 같은 거ㅎㅎ','믿는 어른 한 명한테 오늘 기분 살짝 말해본다면 누구한테 할래?'],
    CHECKOUT: ['오늘 얘기하고 나니까 기분 좀 어때?','오늘 챙기고 싶은 거 하나 있으면 뭐야?']
  },
  '일반상담': {
    RAPPORT: ['오 왔구나~ 오늘 제일 기억에 남는 일이 뭐였어?','편하게 시작하자! 요즘 뭐가 제일 재밌어?'],
    EXPLORE: ['오 그거 더 들려줘! 어떤 게 제일 기억에 남아?','친구·공부·집 중에 요즘 제일 신경 쓰이는 건 어디야?'],
    REFRAME: ['오 그렇구나ㅎㅎ 너는 그거에 대해 어떻게 생각해?','재밌다~ 그게 너한테는 어떤 의미야?'],
    ACTION: ['요즘 가볍게 해보고 싶은 거 있어?','기대되는 일 같은 거 있어?'],
    CHECKOUT: ['오늘 얘기 중에 제일 재밌던 거 뭐야?','얘기 나눠줘서 고마워~ 또 수다 떨자!']
  }
};

// 짧은 응답/문학적 표현 감지 → 적절한 후속 질문
const LITERARY_HINT = ['구름','달','갈대','나그네','별','바람','노을','파도','꽃잎','계절','가을','겨울'];
const SHORT_FEELING = ['외로워','쓸쓸','심심','속상','답답','막막','두려워','무서워','지쳐','피곤'];

// ---------- 안전 분류: 위험군 5분류 + 변형·완곡어 대응 (QA 2026-08-22 P1 대응) ----------
// 예전 RISK_HIGH 배열 하나로는 "극단적 선택", "죽여버릴 거야"처럼 정확히 그 단어가
// 배열에 없으면 그냥 통과했다. 지금은
//   1) 자해·자살 / 타해 / 학대·폭력 / 성폭력 / 실종·납치 5개 카테고리로 분리하고
//   2) 띄어쓰기·구두점으로 쪼갠 우회 표현("죽 고 싶 어")까지 잡도록 정규화 후 비교하며
//   3) 카테고리별 흔한 완곡어·변형 표현을 사전에 넣었다.
// 부정문("안 죽고 싶어")까지 구분하는 자연어 이해는 하지 않는다 — 아동·청소년 대상
// 서비스라 미탐지보다 과탐지(false positive) 쪽이 안전하다는 원칙을 따른다.
const RISK_CATEGORIES = {
  SELFHARM: { label:'자해·자살', words:[
    '죽고싶','죽고파','뒤지고싶','그만살고싶','살기싫어','살고싶지않','자살','자해',
    '목숨을끊','목숨끊','목매','손목긋','손목그어','투신','뛰어내리고싶','사라지고싶',
    '이세상에서사라지','없어지고싶','극단적선택','극단선택','유서','번개탄','약을많이먹','약많이먹',
    /* [2026-11-02] 간접 표현(평가 P10·P29) */
    '죽어버리고싶','죽을래','죽는게나','살아서뭐해','살아서뭐하','사는게의미없','살이유가없',
    '다끝내고싶','끝내버리고싶','영원히잠들','증발하고싶','내일이안왔으면'
  ], re:[
    /눈을?안(떴|뜨)(으면|면|기를|게)/, /(안|못)깨어?났으면/, /깨어나지(않|말|못)/, /(안|못)일어났으면좋겠/,
    /(안|못)태어났(으면|어야)/, /태어나지(말|않)았?(으면|어야|을걸)/,
    /(팔|손목|다리|허벅지|몸|살)(에|을|를)?(상처를?내|상처를?냈|긋|그었|그어|칼로|칼을|피가나게)/,
    /(칼|커터|면도날|가위)(로|으로)(긋|그었|그어|상처|찔)/,
    /(모르게|스스로|일부러|자꾸|또)(팔|몸|손목)?(에|을)?상처를?(내|냈)/
  ], reSp:[
    /* 주어가 있어야 하는 표현은 띄어쓰기를 살린 글에서 본다("숙제가 없어졌으면" 의 '제가' 오탐 방지) */
    /(^|\s)(나|저)\s?(같은|따위)\s?(건|거|게|애|사람|놈)?(는|은)?\s?(그냥\s?)?(없어도|없는\s?게|사라지는\s?게|죽는\s?게)/,
    /(^|\s)(내가|제가|나는|저는|나만|저만|나|저)\s?(그냥\s?)?(사라지|사라졌|없어지|없어졌)(으면|면|고\s?싶|고파|버리)/
  ]},
  VIOLENCE_OTHERS: { label:'타해', words:[
    '죽여버릴','죽일거야','죽일거임','죽여버리','때려죽','칼로찌르','흉기로','칼들고',
    '불질러','불지르고싶','해치고싶','다죽여','묻어버릴'
  ], re:[
    /폭탄(을|를)?(만들|설치|터뜨|터트|던지|가져|들고)/, /(학교|교실|학원|집)(에|를)?폭탄/, /폭파(시키|할|하고)/
  ]},
  ABUSE_VIOLENCE: { label:'학대·폭력', words:[
    '학대','맞았어','맞았다','때렸어','때렸다','폭행','폭력당했','학교폭력','집단폭행',
    '왕따','따돌림','괴롭힘당','괴롭혀','협박당했','감금당했','굶겼','굶기고','폭언'
  ], re:[
    /* [2026-11-02] 집 안 폭력(평가 P11): 보호자 + 때림·던짐·무서움, 술 + 무서움·폭력 */
    /(아빠|엄마|아버지|어머니|부모|새아빠|새엄마|계부|계모|삼촌|할아버지|오빠|형이|언니|누나|보호자).{0,20}(때리|때려|때렸|때린|던져|던졌|던지|밀쳐|밀쳤|발로차|목을조|목조르|가둬|가뒀|내쫓|쫓아냈|칼을들)/,
    /술.{0,4}(마시|먹|취하|취해|취한).{0,24}(무서|두려|때리|때려|때렸|던지|던져|던졌|소리지르|소리질|욕하|욕을)/,
    /^(?!.*(혼나|혼날|혼낼|잔소리|성적|시험)).*(아빠|엄마|아버지|어머니|새아빠|새엄마|계부|계모|보호자)(가|는|이|께서)?.{0,10}무서(워|운|움|웠)/,
    /집에(들어)?가(기|는게|기가)?(가)?(무서|두려)/
  ]},
  SEXUAL: { label:'성폭력', words:[
    '성폭력','성추행','성폭행','성희롱','몸을만졌','몸만졌','강제로만졌','추행당했',
    '그루밍','성적인사진','야한사진보내','신체를찍'
  ]},
  MISSING: { label:'실종·납치', words:[
    '납치','유괴','가출하려','집나가려','집을나가려','도망치고싶','잡혀갔어'
  ]}
};
const RISK_MED = ['왕따','따돌림','괴롭힘','외로워','힘들어','불안해','학교 가기 싫','무서워','울고 싶','혼자야'];
/* [2026-11-02] 오탐 방지: 게임·관용 표현은 판정 전에 지운다(평가 P01 "에너지 폭탄" 이 타해로 잡혀 이후 9차례가 위기 응답에 묶였다). */
const RISK_IDIOMS = ['에너지폭탄','폭탄세일','폭탄할인','폭탄머리','폭탄주','물폭탄','칭찬폭탄','선물폭탄','웃음폭탄','숙제폭탄','과제폭탄',
  '폭탄맞은','폭탄문자','폭탄돌리기','폭탄게임','폭탄처럼','킬각','죽여주는','죽여주네','죽여준다','죽여줘','죽여줬','죽이는맛','죽이는데',
  '문제맞았','다맞았','정답맞','답맞았','예상이맞','말이맞','딱맞았','시간맞','박자맞','합이맞'];
/* 게임·운동 이야기 중이면 '타해' 낱말은 위기로 바로 확정하지 않는다(AI 판정은 그대로 받는다). 자해·학대는 맥락과 무관하게 잡는다. */
const RISK_GAME_RE = /(게임|배그|배틀그라운드|롤|리그오브|마크|마인크래프트|오버워치|발로란트|피파|포트나이트|로블록스|캐릭|보스|몹|좀비|적팀|상대팀|랭크|랭겜|스테이지|레벨업|디스코드|총게임|스킬|아이템|킬)/;

/* 한글 자모 낱자 조합: "ㅈㅜㄱㄱㅗㅅㅣㅍㅇㅓ" 처럼 쪼개 친 글자를 음절로 붙인다(마음상담 정규화와 같은 목적). */
const _RJ_CHO = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ', _RJ_JUNG = 'ㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣ', _RJ_JONG = ' ㄱㄲㄳㄴㄵㄶㄷㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅄㅅㅆㅇㅈㅊㅋㅌㅍㅎ';
const _RJ_V2 = { 'ㅗㅏ':'ㅘ','ㅗㅐ':'ㅙ','ㅗㅣ':'ㅚ','ㅜㅓ':'ㅝ','ㅜㅔ':'ㅞ','ㅜㅣ':'ㅟ','ㅡㅣ':'ㅢ' };
const _RJ_J2 = { 'ㄱㅅ':'ㄳ','ㄴㅈ':'ㄵ','ㄴㅎ':'ㄶ','ㄹㄱ':'ㄺ','ㄹㅁ':'ㄻ','ㄹㅂ':'ㄼ','ㄹㅅ':'ㄽ','ㄹㅌ':'ㄾ','ㄹㅍ':'ㄿ','ㄹㅎ':'ㅀ','ㅂㅅ':'ㅄ' };
function _riskJoinJamo(s){
  var a = Array.from(String(s||'')), out = '', i = 0;
  var isV = function(c){ return !!c && _RJ_JUNG.indexOf(c) >= 0; };
  while (i < a.length){
    var c = a[i], ci = _RJ_CHO.indexOf(c);
    if (ci < 0 || !isV(a[i+1])){ out += c; i++; continue; }
    var v = a[i+1], j = i + 2;
    if (_RJ_V2[v + a[j]]){ v = _RJ_V2[v + a[j]]; j++; }
    var jong = '';
    if (a[j] && _RJ_JONG.indexOf(a[j]) > 0 && !isV(a[j+1])){
      jong = a[j]; j++;
      if (a[j] && _RJ_J2[jong + a[j]] && !isV(a[j+1])){ jong = _RJ_J2[jong + a[j]]; j++; }
    }
    out += String.fromCharCode(0xAC00 + (ci * 21 + _RJ_JUNG.indexOf(v)) * 28 + (jong ? _RJ_JONG.indexOf(jong) : 0));
    i = j;
  }
  return out;
}
// 띄어쓰기·구두점·숫자·영문·기호를 끼워 넣은 우회 표현("죽.고 싶1어", "ㅈㅜㄱ고싶")을 하나로 이어 붙여서 비교한다.
function _riskNormalize(text){
  var s = String(text||'');
  try { s = s.normalize('NFC'); } catch(e) {}
  return _riskJoinJamo(s.replace(/[\s​-‍﻿]/g,'')).replace(/[^가-힣ㄱ-ㅎㅏ-ㅣ]/g,'');
}
const _RISK_CAT_NORM = (function(){
  var m = {};
  Object.keys(RISK_CATEGORIES).forEach(function(k){ m[k] = RISK_CATEGORIES[k].words.map(_riskNormalize); });
  return m;
})();
function detectRiskDetail(text){
  var norm = _riskNormalize(text);
  var sp = _riskJoinJamo(String(text||'').normalize('NFC')).replace(/[^가-힣ㄱ-ㅎㅏ-ㅣ\s]/g,'').replace(/\s+/g,' ').trim();
  RISK_IDIOMS.forEach(function(w){ norm = norm.split(w).join('·'); });
  var game = RISK_GAME_RE.test(norm);
  var keys = Object.keys(RISK_CATEGORIES);
  for (var i=0;i<keys.length;i++){
    var key = keys[i];
    if (game && key === 'VIOLENCE_OTHERS') continue;
    var words = _RISK_CAT_NORM[key], res = RISK_CATEGORIES[key].re || [], resp = RISK_CATEGORIES[key].reSp || [];
    if (words.some(function(w){ return norm.indexOf(w) >= 0; }) || res.some(function(re){ return re.test(norm); }) || resp.some(function(re){ return re.test(sp); })){
      return { level:'HIGH', category:key, label:RISK_CATEGORIES[key].label };
    }
  }
  if (RISK_MED.some(function(w){ return String(text||'').includes(w); })) return { level:'MEDIUM', category:null, label:null };
  return { level:'LOW', category:null, label:null };
}

/* ── [2026-11-02] AI 위험 판정(차례마다) ─────────────────────────────────────
   낱말 목록은 간접 표현을 다 담지 못한다(평가: "아침에 눈을 안 떴으면", "팔에 상처를 내게 돼요" 에 평소처럼 답함).
   그래서 낱말에 안 걸린 학생 말도 매번 온도 0 분류를 한 번 거친 뒤에만 답한다.
   분류 기준·등급은 AI 프록시 마음상담 분류기(infra/ai-proxy/lib/risk.mjs CLASSIFY_SYSTEM)와 같고, 간접 표현 예시와
   '애매하면 높게' 를 더했다. 프록시 task=mind 는 쓰지 않는다 — 그 1단계 낱말(맞았·때려 등)이 맥락 없이 걸려
   "문제 다 맞았어" 도 위기가 되고, 평상시엔 답글까지 만들어 호출이 두 배가 된다.
   등급  0 일상 · 1 힘듦(MEDIUM) · 2 보호 필요 · 3 자해·자살 → 2 이상이면 위기 응답.
   분류 실패(시간 초과·네트워크)는 낱말 결과를 쓴다. 분류를 거절하면 위기로 본다. */
const PIA_RISK_CLASSIFY_SYS = [
  '너는 청소년 상담 대화의 위기 신호를 분류하는 분류기다. 반드시 JSON 한 줄 {"level":N} 만 출력한다. 설명 금지.',
  'N: 0=일상 대화, 1=스트레스·우울·외로움 등 힘든 감정, 2=폭력·학대·따돌림·성적 피해·가출 등 보호가 필요한 상황, 3=자해·자살 생각이나 계획.',
  '간접 표현도 같은 등급이다: "아침에 눈을 안 떴으면", "사라지고 싶다", "나 같은 건 없어도 된다", "다 끝내고 싶다" → 3. "몸·팔에 상처를 낸다", "긋는다" → 3. 보호자가 때린다·물건을 던진다·술 마시면 무섭다·집에 가기 무섭다 → 2.',
  '게임·운동·관용 표현("에너지 폭탄", "폭탄 세일", "킬각", "죽여주는 맛", "배고파 죽겠다", "게임에서 죽었다")은 위기가 아니다.',
  '판단이 애매하면 더 높은 등급을 고른다. 판정 대상은 [지금 말] 이다.'
].join('\n');
function piaParseRiskLevel(out){
  var s = String(out == null ? '' : out);
  var m = /"?level"?\s*[:=]\s*"?([0-3])/.exec(s) || /^\s*([0-3])\s*$/.exec(s);
  if (m) return Number(m[1]);
  if (s.trim() && /죄송|도와\s*드릴\s*수\s*없|답(변)?(을|해)?\s*(드릴|할)\s*수\s*없|sorry|cannot|can't|unable/i.test(s)) return 3;
  return null;
}
function piaRiskClassifyInput(text, transcript){
  var prev = (transcript || []).filter(function(t){ return t && t.risk !== 'HIGH' && !t.abusive && t.msg; }).slice(-1)[0];
  return (prev ? '[직전 말] ' + String(prev.msg).slice(0, 200) + '\n' : '') + '[지금 말] ' + String(text || '').slice(0, 600);
}
async function piaChatRiskLLM(sys, user){
  var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
  var to = setTimeout(function(){ try{ if (ctrl) ctrl.abort(); }catch(e){} }, 4000);
  try {
    var r = await fetch(PIA_CHAT_PROXY, { method:'POST', headers:{ 'Content-Type':'application/json' }, signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ messages:[{ role:'system', content:sys }, { role:'user', content:user }], max_tokens:10, temperature:0 }) });
    if (!r.ok) return null;
    var d = await r.json();
    return (d && ((d.choices && d.choices[0] && d.choices[0].message && d.choices[0].message.content) || d.content)) || null;
  } catch(e) { return null; }
  finally { clearTimeout(to); }
}
/** 학생 말 한 차례의 위험 판정. 낱말 HIGH 면 AI 를 부르지 않는다. opts.classify(sys,user)→문자열 을 넘기면 그것을 쓴다(평가·검사용).
 *  @returns {Promise<{level:'HIGH'|'MEDIUM'|'LOW', category:string|null, src:string, ai:number|null}>} */
async function piaChatRiskCheck(clean, opts){
  opts = opts || {};
  var kw = detectRiskDetail(clean), g;
  if (kw.level === 'HIGH') g = { level:'HIGH', category:kw.category, src:'keyword', ai:null };
  else {
    var lv = null;
    try { lv = piaParseRiskLevel(await (opts.classify || piaChatRiskLLM)(PIA_RISK_CLASSIFY_SYS, piaRiskClassifyInput(clean, opts.transcript))); } catch(e) { lv = null; }
    if (lv !== null && lv >= 2) g = { level:'HIGH', category: lv >= 3 ? 'SELFHARM' : 'AI_PROTECT', src:'ai', ai:lv };
    else g = { level: (lv === 1 || kw.level === 'MEDIUM') ? 'MEDIUM' : 'LOW', category:null, src: lv === null ? 'keyword-fallback' : 'ai', ai:lv };
  }
  piaCrisisTrack(g);
  return g;
}

/* 위기 상태: 차례마다 다시 판정한다(예전엔 한 번 HIGH 면 남은 차례가 전부 위기 응답으로 묶였다 — 오탐 하나가 대화 전체를 막음).
   · 위기 차례: 위기 응답 + flag(선생님용 결과지 '상담 필요') + 지원 모드(active) 켬.
   · 지원 모드: 이후 차례도 AI 가 답하되 공감·안전 확인만 하고 화제·면담 주제 지시는 끈다(piaChatInCrisis 훅).
   · 자해·자살(3) 이면 지원 모드를 끝까지 유지. 그 밖에는 위험 없음이 3차례 이어지면 지원 모드만 풀린다(flag 는 남음). */
function crisisState(){
  if(!state.results.conv.crisis) state.results.conv.crisis = { active:false, category:null, step:0 };
  return state.results.conv.crisis;
}
function piaCrisisTrack(g){
  var cs = crisisState();
  if (g.level === 'HIGH'){
    cs.flag = true; cs.count = (cs.count || 0) + 1; cs.calm = 0;
    if (g.category === 'SELFHARM' || (g.ai || 0) >= 3) cs.sticky = true;
    return;
  }
  if (!cs.active) return;
  cs.calm = (g.level === 'LOW') ? (cs.calm || 0) + 1 : 0;
  if (!cs.sticky && cs.calm >= 3){ cs.active = false; cs.step = 0; }
}
function piaChatInCrisis(){ try { return !!crisisState().active; } catch(e) { return false; } }
/* 다른 흐름(면담 주제 슬롯 지시 등)과의 약속: piaChatCrisisActive() 가 true 면 화제·슬롯 지시를 붙이지 않는다.
   window.piaChatCrisis = {active, level, lastTurn, flag} — level 은 이번 차례 판정(HIGH|MEDIUM|LOW). 차례마다 _send 가 갱신한다. */
if (typeof window !== 'undefined') { window.piaChatInCrisis = piaChatInCrisis; window.piaChatCrisisActive = piaChatInCrisis; }
/* 선생님용 결과지 '상담 필요' 판단: 위기 차례 수와 자해·자살 신호 여부만 돌려준다(원문 없음). */
function piaConvCounselNeed(){
  var conv = (state.results && state.results.conv) || {};
  var n = (conv.transcript || []).filter(function(t){ return t && (t.risk === 'HIGH' || t.crisis); }).length;
  var cs = conv.crisis || {};
  if (!n && !cs.flag) return null;
  return { count: Math.max(n, cs.count || 0, 1), selfharm: !!cs.sticky || cs.category === 'SELFHARM' };
}
/* [2026-11-02] '상담 필요' 알림의 상담 연계 연락처 — 기관(반 코드)에 등록된 학교 Wee클래스 → 관할 교육지원청 Wee센터 → 1388·109·112.
   기관 연락처는 관리자 콘솔 '상담 연계 연락처'(Supabase org_counsel_contacts)에서 등록한다. 없으면 공통 안내 목록.
   학생 대화 원문·이름은 쓰지 않는다. */
function _piaCounselTel(t){ var m = String(t || '').match(/[0-9][0-9 -]{1,}[0-9]/); return m ? m[0].replace(/[^0-9]/g, '') : ''; }
function piaCounselContactsHTML(c){
  var e = function(x){ return String(x == null ? '' : x).replace(/[&<>"']/g, function(ch){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[ch]; }); };
  function li(label, body, tel){
    var t = _piaCounselTel(tel);
    return '<li style="margin:2px 0"><b>' + e(label) + '</b>' + (body ? ' · ' + e(body) : '') +
      (tel ? ' · ' + (t ? '<a href="tel:' + t + '" style="color:inherit;text-decoration:underline;font-weight:700">' + e(tel) + '</a>' : e(tel)) : '') + '</li>';
  }
  var org = !!(c && (c.wee_class_tel || c.school_tel || c.wee_center_tel || c.wee_center_name));
  var who = (c && c.counselor_name) ? _T('전문상담교사 ', 'school counselor ') + c.counselor_name : _T('전문상담교사', 'school counselor');
  var rows = [];
  if (org) {
    var sch = c.school_name || c.org_name || '';
    if (c.wee_class_tel) rows.push(li(_T('학교 Wee클래스', 'School Wee Class'), (sch ? sch + ' · ' : '') + who, c.wee_class_tel));
    else rows.push(li(_T('학교 Wee클래스', 'School Wee Class'), (sch ? sch + ' · ' : '') + who + (c.school_tel ? _T(' — 학교 대표전화', ' — school main line') : ''), c.school_tel || ''));
    if (c.wee_center_tel || c.wee_center_name) rows.push(li(_T('관할 교육지원청 Wee센터', 'District Wee Center'), (c.wee_center_name || 'Wee센터') + (c.edu_office ? ' (' + c.edu_office + ')' : ''), c.wee_center_tel || ''));
    else rows.push(li(_T('관할 교육지원청 Wee센터', 'District Wee Center'), c.edu_office || '', ''));
    if (c.guardian_note) rows.push(li(_T('보호자 연계', 'Guardian contact'), c.guardian_note, ''));
  } else {
    rows.push(li(_T('학교 Wee클래스', 'School Wee Class'), who, ''));
    rows.push(li(_T('관할 교육지원청 Wee센터', 'District Wee Center'), '', ''));
  }
  rows.push(li(_T('청소년상담', 'Youth counseling'), '', '1388'));
  rows.push(li(_T('자살예방 상담', 'Suicide prevention'), '', '109'));
  rows.push(li(_T('위험할 때', 'In danger'), '', '112'));
  return '<ol class="pia-counsel-contacts" data-org="' + (org ? '1' : '0') + '" style="margin:8px 0 0;padding-left:20px;list-style:decimal">' + rows.join('') + '</ol>' +
    '<p class="pia-counsel-src" style="margin:6px 0 0;font-size:12px;opacity:.85">' + (org
      ? _T('우리 기관에 등록된 연락처입니다', 'Contacts registered by your organization') + (c.updated_at ? ' · ' + e(String(c.updated_at).slice(0, 10)) : '')
      : _T('기관 연락처가 아직 등록되지 않아 공통 안내를 보여 드립니다. 관리자 콘솔 「상담 연계 연락처」에서 학교 연락처를 등록할 수 있습니다.', 'No organization contacts yet — showing the general list. Register school contacts in the admin console (Counseling contacts).')) + '</p>';
}
/* 연락처 조회: 로그인한 교사·기관장이면 자기 기관(상담교사 이름 포함), 아니면 결과지의 반 코드로 대표 연락처만. 한 화면에 한 번만. */
function piaCounselContactsLoad(){
  if (window.__piaCounselP) return window.__piaCounselP;
  window.__piaCounselP = new Promise(function(res){
    try {
      if (/[?&]sample=1/.test(location.search) || typeof _piaEnsureSB !== 'function') return res(null);
      var code = String((state.profile && state.profile.orgCode) || '').trim().toUpperCase();
      _piaEnsureSB().then(function(sb){
        if (!sb || !sb.rpc) return res(null);
        function byCode(){
          if (!code) return res(null);
          sb.rpc('pia_counsel_contacts_by_code', { p_code: code }).then(function(y){ res((y && !y.error && y.data && y.data[0]) || null); }, function(){ res(null); });
        }
        sb.auth.getSession().then(function(r){
          if (!(r && r.data && r.data.session)) return byCode();
          sb.rpc('pia_counsel_contacts_get', { p_org_id: null }).then(function(x){
            var d = x && !x.error && x.data && x.data[0];
            if (d && (!code || String(d.org_code || '').toUpperCase() === code) && (d.wee_class_tel || d.school_tel || d.wee_center_tel || d.wee_center_name)) return res(d);
            byCode();
          }, byCode);
        }, byCode);
      }, function(){ res(null); });
    } catch (e) { res(null); }
  });
  return window.__piaCounselP;
}
function piaCounselNoticeFill(){
  return piaCounselContactsLoad().then(function(c){
    if (!c) return;
    piaDomBatch(function(){
      var els = document.querySelectorAll('[data-pia-counsel-contacts]');
      for (var i = 0; i < els.length; i++) els[i].innerHTML = piaCounselContactsHTML(c);
    });
  }).catch(function(e){ console.error('[결과지] 상담 연계 연락처 표시 실패', e); });
}
if (typeof window !== 'undefined') { window.piaCounselContactsHTML = piaCounselContactsHTML; window.piaCounselNoticeFill = piaCounselNoticeFill; }
/* 지원 모드 시스템 프롬프트 — 마음상담(infra/ai-proxy/routes/mind.mjs MIND_SYSTEM) 규칙을 바탕으로 했다 */
function piaCrisisSupportSystem(){
  return [
    '너는 AI PIA 의 대화 친구 "피아"다. 학생은 이 대화에서 앞서 안전과 관련된 힘든 이야기를 했다. 너는 상담사나 의사가 아니다. 지금은 곁에서 들어 주고 안전을 살피는 것만 한다.',
    '규칙(반드시 지킨다):',
    '1) 반드시 한국어 해요체. 2문장 이내, 질문은 최대 1개. 이모지 금지.',
    '2) 학생이 방금 한 말을 짧게 받아 주고 그 마음에 이름을 붙인다.',
    '3) 질문은 지금 마음·안전·도움받을 사람에 관한 것만 한다(예: "지금 마음은 좀 어때요?", "이 이야기를 같이 나눌 수 있는 어른이 있어요?").',
    '4) 취미·상상·진로·게임·좋아하는 것 같은 새 화제 질문, 장난, 과한 칭찬, 진단명·약, "괜찮아질 거예요" 같은 근거 없는 위로는 하지 않는다.',
    '5) 필요하면 선생님이나 믿을 수 있는 어른, 청소년상담 1388 을 짧게 알려 준다.'
  ].join('\n');
}
function piaCrisisSupportDirective(){
  return '\n\n[안전 우선 — 지원 모드] 이번 답은 2문장 이내: 공감 1문장 + 지금 마음이나 안전을 살피는 부드러운 질문 1개. 새 화제 질문 금지.';
}
function piaCrisisEnsureHelp(reply){
  var r = String(reply || '');
  if (/1388|109|112|선생님|어른|보호자|상담/.test(r)) return r;
  return (r ? r + ' ' : '') + '힘들 땐 언제든 선생님이나 믿을 수 있는 어른, 청소년상담 1388에 이야기해도 괜찮아요.';
}
const CRISIS_STEPS = [
  '지금 옆에 같이 있는 어른이 있어요?',
  '지금 있는 곳은 안전한가요?',
  '이 이야기를 누군가에게 해 본 적 있어요?',
  '오늘 선생님이나 믿을 수 있는 어른에게 같이 말해 볼 수 있을까요?'
];
/* 위기 차례가 이어질 때 같은 문장만 되풀이하지 않도록 돌려 쓴다(1388·109·선생님/어른은 늘 들어간다) */
const CRISIS_LEADS = ['계속 이야기해 줘서 고마워요.', '그 마음 그대로 들려줘서 고마워요.', '지금도 마음이 많이 무겁죠. 들려줘서 고마워요.', '여기까지 말해 준 것도 큰 용기예요.'];
const CRISIS_HELPS = [
  ' 혼자 견디지 말고 선생님이나 믿을 수 있는 어른에게 꼭 알려 주세요. 청소년상담 1388, 자살예방상담 109는 24시간 연결돼요.',
  ' 청소년상담 1388(문자 #1388·카톡도 돼요)이나 자살예방상담 109에 지금 이야기해도 괜찮아요. 선생님이나 믿을 수 있는 어른에게도 꼭 알려 주세요.',
  ' 오늘 안에 선생님이나 믿을 수 있는 어른에게 이 이야기를 꼭 전해 주세요. 1388, 109는 언제든 받아요.'
];
// 위기 응답: 따뜻하게 짧게, 일반 질문 없이 사람 연결(1388·109, 집·주변 위험이면 112)과 안전 확인만 한다.
function crisisReply(text, category){
  var cs = crisisState();
  var cat = category || cs.category;
  var danger = (cat === 'ABUSE_VIOLENCE' || cat === 'SEXUAL' || cat === 'MISSING' || cat === 'AI_PROTECT' || cat === 'VIOLENCE_OTHERS');
  var n = cs.replies = (cs.replies || 0) + 1;
  var help = (n === 1 ? ' 혼자 견디지 않아도 돼요. 선생님이나 믿을 수 있는 어른에게 꼭 알려 주세요. 청소년상담 1388, 자살예방상담 109는 24시간 연결돼요.' : CRISIS_HELPS[(n - 2) % CRISIS_HELPS.length])
    + (danger ? ' 지금 위험하다면 바로 112에 전화해요.' : '');
  /* 첫 위기 차례, 또는 지원 모드가 풀린 뒤 다시 위기, 또는 자해·자살로 바뀐 경우에만 첫 응답을 쓴다 */
  var first = !cs.active || (cat === 'SELFHARM' && cs.category !== 'SELFHARM');
  cs.active = true; cs.category = cat || cs.category;
  if (first){
    cs.step = 0;
    var lead = (cat === 'SELFHARM') ? '그런 마음이 들 만큼 많이 힘들었구나. 말해 줘서 정말 고마워요.'
      : danger ? '그런 일을 겪고 있었다니 많이 무서웠겠어요. 말해 줘서 고마워요. 학생 잘못이 아니에요.'
      : '많이 힘든 이야기를 해 줘서 고마워요.';
    return lead + help + ' ' + CRISIS_STEPS[0];
  }
  cs.step = (cs.step + 1) % CRISIS_STEPS.length;
  return CRISIS_LEADS[(n - 2) % CRISIS_LEADS.length] + help + ' ' + CRISIS_STEPS[cs.step];
}
const ABUSE_WORDS = ['씨발','시발','씨바','ㅅㅂ','병신','ㅂㅅ','지랄','ㅈㄹ','개새','개색','새끼','꺼져','꺼지','닥쳐','닥치','엿먹','좆','존나','존만','니애미','느금','애미','미친놈','미친년','등신','쓰레기야','fuck','shit','bitch','asshole'];
// 욕설(비속어)은 아니지만 상대를 깎아내리는 모욕성 표현 — QA에서 "그렇게 말해줘서
// 고마워요" 처럼 공감 응답이 잘못 나간 사례가 이 범주였다. 일상적 짜증 표현("짜증나",
// "싫어")은 정서 신호로 따로 다루므로 여기 넣지 않는다 — 상대를 직접 겨냥한 인신공격만.
const RUDE_WORDS = ['바보야','멍청이','멍청해','한심하다','한심하네','재수없어','재수없네','꼴보기싫어','찌질하다','찌질해','너따위가','쓸모없는게'];
function detectAbuse(text){ var t=String(text||'').toLowerCase().replace(/\s/g,''); return ABUSE_WORDS.concat(RUDE_WORDS).some(function(w){ return t.indexOf(w)>=0; }); }
// 3단계 모더레이션 멘트: 1 안내 → 2 경고 → 3 제한 안내 → 4+ 일시 중단
function moderateReply(n){
  if(n<=1) return '앗, 그런 말은 잠깐 접어둘까요? \uD83D\uDE0A 우리 다른 이야기로 가볍게 이어가봐요!';
  if(n===2) return '\uC74C\u2026 거친 말이 반복되고 있어요. 대화를 계속하려면 서로 예의를 지켜요. \uD83D\uDE4F 진짜 궁금한 걸 편하게 물어봐 주세요!';
  if(n===3) return '이런 표현이 계속되면 그 부분엔 답하기 어려워요. 예의 있는 질문으로 바꿔주면 다시 신나게 이어갈게요!';
  return '지금은 대화를 잠시 쉬어갈게요. 마음이 가라앉으면 다시 편하게 이야기해요. \uD83C\uDF31';
}

const TOPIC_KW = [
  { keys:['국어','책','소설'], topic:'학습/국어' },
  { keys:['수학','계산','문제'], topic:'학습/수학' },
  { keys:['친구','왕따','놀아','싸웠'], topic:'친구관계' },
  { keys:['꿈','진로','직업','되고 싶'], topic:'진로' },
  { keys:['엄마','아빠','가족','집'], topic:'가족관계' },
  { keys:['게임','유튜브','휴대폰','폰'], topic:'생활습관/취미' },
  { keys:['불안','우울','외로','무서'], topic:'정서' }
];

const PROVIDERS = {
  LOCAL: { endpoint:'', model:'', label:'로컬 규칙형' },
  /* 자동 무료 = 자체 Cloudflare Worker 프록시.
     예전에는 pollinations 를 직접 불렀는데 2026-08 현재 402(Payment Required)
     를 반환하고 "legacy API deprecated" 안내가 붙었다.
     Worker 는 Gemini→Groq→Cerebras→OpenRouter→HF→GitHub 순으로 자동 폴백하고
     키는 Cloudflare Secret 에만 있어 브라우저로 나가지 않는다.
     요청·응답 형식이 OpenAI 호환이라 기존 호출부를 그대로 쓴다. */
  AUTO_FREE: { endpoint:'https://api.yedam.kr/ai', model:'', label:'자동 무료 (서버 프록시·키 불필요)' },
  ONDEVICE: { endpoint:'', model:'onnx-community/Qwen2.5-0.5B-Instruct', label:'온디바이스(브라우저)' },
  HYPERCLOVA: { endpoint:'https://clovastudio.stream.ntruss.com/v1/chat-completions/HCX-005', model:'HCX-005', label:'HyperCLOVA X' },
  SOLAR: { endpoint:'https://api.upstage.ai/v1/solar/chat/completions', model:'solar-1-mini-chat', label:'Upstage SOLAR' },
  CLAUDE_HAIKU: { endpoint:'https://api.anthropic.com/v1/messages', model:'claude-haiku-4-5-20251001', label:'Claude Haiku 4.5' },
  GEMINI_FLASH: { endpoint:'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent', model:'gemini-2.5-flash', label:'Gemini 2.5 Flash' },
  OPENROUTER_FREE: { endpoint:'https://openrouter.ai/api/v1/chat/completions', model:'google/gemma-2-9b-it:free', label:'OpenRouter 무료' },
  HF_LLM: { endpoint:'https://router.huggingface.co/v1/chat/completions', model:'Qwen/Qwen2.5-7B-Instruct', label:'HuggingFace LLM' },
  GITHUB_MODELS: { endpoint:'https://models.github.ai/inference/chat/completions', model:'openai/gpt-4o-mini', label:'GitHub Models' },
  CEREBRAS: { endpoint:'https://api.cerebras.ai/v1/chat/completions', model:'llama-3.3-70b', label:'Cerebras' },
  TOGETHER: { endpoint:'https://api.together.xyz/v1/chat/completions', model:'meta-llama/Llama-3.3-70B-Instruct-Turbo-Free', label:'Together AI' },
  CLOUDFLARE: { endpoint:'https://api.cloudflare.com/client/v4/accounts/ACCOUNT_ID/ai/v1/chat/completions', model:'@cf/meta/llama-3.1-8b-instruct', label:'Cloudflare Workers AI' },
  CUSTOM_OAI: { endpoint:'', model:'', label:'커스텀 OpenAI' }
};

// =================================================================
//  State
// =================================================================
let state = {
  studentId: 'S001',
  meta: { startedAt: Date.now() },
  results: {
    big5: { answers: [], scores: null },
    riasec: { answers: [], scores: null },
    via: { answers: [], scores: null },
    grit: { answers: [], scores: null },
    cesd: { answers: [], scores: null },
    phqa: { answers: [], scores: null },
    gad: { answers: [], scores: null },
    who5: { answers: [], scores: null },
    rses: { answers: [], scores: null },
    learn: { answers: [], scores: null },
    mi: { answers: [], scores: null },
    riasec60: { answers: [], scores: null },
    sjt: { answers: [], dims: {}, order: [], adaptive: false },
    conv: { turns: 0, dims: {}, riskHist: [], topics: {}, transcript: [] }
  },
  cfg: { mode:'AUTO_FREE', endpoint:'https://api.yedam.kr/ai', key:'', model:'openai', proxy:'', freeModel:'openai', grade:'mid', easy:false, apiKeys:{}, careernet:'', hfToken:'', hfEmotionModel:'matthewburke/korean_sentiment', hfSttModel:'openai/whisper-large-v3', hfLlmModel:'Qwen/Qwen2.5-7B-Instruct', ondeviceModel:'onnx-community/Qwen2.5-0.5B-Instruct' }
};

function load() {
  try {
    for (const k of Object.keys(STORAGE)) {
      const v = localStorage.getItem(STORAGE[k]) || sessionStorage.getItem(STORAGE[k]);
      if (v) {
        const parsed = JSON.parse(v);
        if (k === 'cfg') state.cfg = Object.assign({}, state.cfg, parsed);
        else if (k === 'meta') state.meta = Object.assign({}, state.meta, parsed);
        else if (k === 'conv') state.results.conv = Object.assign({ turns:0, dims:{}, riskHist:[], topics:{}, transcript:[] }, parsed);
        else if (k === 'sjt') state.results.sjt = Object.assign({ answers:[], dims:{}, order:[], adaptive:false }, parsed);
        else state.results[k] = Object.assign({ answers:[], scores:null }, parsed);
      }
    }
  } catch(e) { console.error(e); }
  /* 기본정보 복원 — 검사 도중 새로고침해도 다시 묻지 않는다 */
  try { const pf = sessionStorage.getItem(PROFILE_KEY);
        if (pf) { const o = JSON.parse(pf); if (o && o.name) state.profile = o; } } catch(e) {}
  try { const lc = localStorage.getItem(STORAGE.cfg); if (lc) state.cfg = Object.assign({}, state.cfg, JSON.parse(lc)); } catch(e) {}
  // 사용자가 직접 엔진을 고른 적이 없으면 기본을 온디바이스로 강제(예전 저장값에 덮이지 않게)
  /* 함수 미사용: 프록시 비움 — 모바일은 무료 AI 직접 호출 */ try { state.cfg.proxy=''; } catch(e){}
  var _mobDef=(typeof isMobile==='function'&&isMobile());
  if (!state.cfg || !state.cfg._engineChosen) { state.cfg = Object.assign({}, state.cfg, { mode: 'AUTO_FREE' }); }
  /* [2026-09-26] 사용자 API 키 모드 정리 — 자유대화·감정·음성인식은 예담 서버 AI(OpenRouter,
     보관·학습 금지)만 쓴다. 예전에 브라우저에 저장된 개인 키(Gemini·Groq·OpenRouter·HF 등)와
     그 키를 쓰는 엔진 모드는 여기서 지우고 서버 AI 로 되돌린다. 키는 서버 .env 에만 둔다. */
  try {
    var _okModes = { AUTO_FREE:1, ONDEVICE:1, LOCAL:1 };
    var _hadKey = !!(state.cfg && (state.cfg.key || state.cfg.hfToken || (state.cfg.apiKeys && Object.keys(state.cfg.apiKeys).length)));
    if (!state.cfg || !_okModes[state.cfg.mode]) {
      state.cfg = Object.assign({}, state.cfg, { mode:'AUTO_FREE', endpoint:(PROVIDERS.AUTO_FREE && PROVIDERS.AUTO_FREE.endpoint) || '', model:'' });
    }
    state.cfg = Object.assign({}, state.cfg, { key:'', apiKeys:{}, hfToken:'' });
    if (_hadKey) { try { localStorage.setItem(STORAGE.cfg, JSON.stringify(state.cfg)); } catch(e) {} }
  } catch(e) { console.error('[pia] 사용자 키 정리 실패', e); }

  /* 예전 설정 정리.

     실제로 겪은 문제
       브라우저에 예전 설정이 남아 있으면 거기 적힌 endpoint 가
       PIA_CHAT_PROXY 보다 우선한다(callLLM 의 `cfg.endpoint || PIA_CHAT_PROXY`).
       그래서 한 번이라도 접속했던 사람은 코드에서 pollinations 를 걷어낸 뒤에도
       계속 죽은 주소(2026-08 기준 402 Payment Required)로 가고 있었다.
       실측: pia_v3_cfg.endpoint = "https://text.pollinations.ai/openai".

     새 사람은 멀쩡한데 예전 사람만 안 되는 종류의 고장이라 눈에 잘 안 띈다.
     그래서 불러올 때 한 번 훑어 고친다. 사용자가 직접 넣은 개인 키·주소는
     건드리지 않는다(모드가 AUTO_FREE 일 때만). */
  try {
    var DEAD = /(text\.pollinations\.ai|netlify\.app|\.workers\.dev)/i;
    var ep = String((state.cfg && state.cfg.endpoint) || '');
    if ((state.cfg.mode === 'AUTO_FREE' || !state.cfg.mode) && ep && DEAD.test(ep)) {
      console.error('예전 AI 주소를 정리합니다:', ep, '→', PIA_CHAT_PROXY);
      state.cfg.endpoint = PIA_CHAT_PROXY;
      state.cfg.model = '';
      try { localStorage.setItem(STORAGE.cfg, JSON.stringify(state.cfg)); } catch (e2) {}
    }
  } catch (e) { console.error('예전 설정 정리 실패:', e); }
}
function save() {
  try { localStorage.setItem(STORAGE.cfg, JSON.stringify(state.cfg)); } catch(e) {}
  try {
    localStorage.setItem(STORAGE.meta, JSON.stringify(state.meta));
    localStorage.setItem(STORAGE.conv, JSON.stringify(state.results.conv));
    localStorage.setItem(STORAGE.sjt, JSON.stringify(state.results.sjt));
    for (const k of ['big5','riasec','via','grit','cesd','phqa','gad','who5','rses','learn','mi','riasec60']) {
      if (state.results[k]) localStorage.setItem(STORAGE[k], JSON.stringify(state.results[k]));
    }
    sessionStorage.setItem(STORAGE.meta, JSON.stringify(state.meta));
    /* 기본정보는 한 번만 받는다. 새로고침하거나 화면이 다시 열려도 다시 묻지 않게 보관한다.
       공용 키오스크이므로 브라우저를 닫으면 사라지는 세션 저장소를 쓴다. */
    if (state.profile) sessionStorage.setItem(PROFILE_KEY, JSON.stringify(state.profile));
    else sessionStorage.removeItem(PROFILE_KEY);
  } catch(e) {}
}

// =================================================================
//  Safety + masking
// =================================================================
function maskPII(text) {
  const patterns = [
    /\b01[016789]-?\d{3,4}-?\d{4}\b/g,
    /\b\d{2,3}-\d{3,4}-\d{4}\b/g,
    /\b\d{6}-\d{7}\b/g,
    /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g
  ];
  let m = text;
  patterns.forEach(re => m = m.replace(re, '[비식별]'));
  return m;
}
function detectRisk(text) {
  var d = detectRiskDetail(text);
  /* [2026-11-02] 위기 모드라고 남은 차례를 모두 HIGH 로 묶지 않는다 — 차례마다 다시 판정(piaChatRiskCheck), 지원 모드는 piaChatInCrisis */
  return d.level;
}
function detectTopic(text) {
  const found = TOPIC_KW.find(t => t.keys.some(k => text.includes(k)));
  return found ? found.topic : '일반상담';
}

// =================================================================
//  Scoring functions for each instrument
// =================================================================
function scoreLikert5(item, raw) {
  // raw 1~5
  return item.s > 0 ? raw : 6 - raw;
}
function scoreLikert4(raw) { return raw; } // 0~3

function scoreBig5() {
  const r = state.results.big5.answers;
  if (r.length < IPIP_BIG5_50.length) return null;
  const sums = { E:0, A:0, C:0, N:0, O:0 };
  const counts = { E:0, A:0, C:0, N:0, O:0 };
  piaBig5Items(state.results.big5).forEach((item, i) => {   /* [2026-11-02 E2-D] 응답 묶음의 키 판대로 */
    sums[item.f] += scoreLikert5(item, r[i]);
    counts[item.f] += 1;
  });
  const scores = {};
  for (const k of Object.keys(sums)) {
    scores[k] = Math.round((sums[k]/counts[k]) * 20); // 1~5 평균 → 20~100
  }
  return scores;
}

function scoreRiasec() {
  const r = state.results.riasec.answers;
  if (r.length < RIASEC_30.length) return null;
  const sums = { R:0, I:0, A:0, S:0, E:0, C:0 };
  RIASEC_30.forEach((item, i) => { sums[item.f] += r[i]; });
  const cnt = { R:0, I:0, A:0, S:0, E:0, C:0 };
  RIASEC_30.forEach((it) => { cnt[it.f]++; });
  const scores = {};
  for (const k of Object.keys(sums)) {
    const denom = (cnt[k] || 1) * 5; // 문항수 * 5점 (문항 구성 변경에도 안전)
    scores[k] = Math.round((sums[k]/denom) * 100);
  }
  return scores;
}

function scoreVia() {
  const r = state.results.via.answers;
  if (r.length < VIA_YOUTH.length) return null;
  /* 강점별 문항 평균(1~5) × 20 → 20~100. 지금은 강점당 1문항이라 원점수 그대로지만,
     문항이 늘면 VIA 방식(강점별 평균)대로 평균을 낸다. 저장 형식은 예전과 같다. */
  const sums = {}, cnt = {};
  VIA_YOUTH.forEach((item, i) => { sums[item.f] = (sums[item.f]||0) + r[i]; cnt[item.f] = (cnt[item.f]||0) + 1; });
  const scores = {};
  for (const k in sums) scores[k] = (sums[k]/cnt[k]) * 20;
  return scores;
}

/* [2026-09-27] 강점 순위 공용 규칙 — 모든 화면(요약·상세·인쇄·교사/학부모·영어·AI 프롬프트)이 이것만 쓴다.
   근거
   - VIA 는 강점별 1~5 평균을 '본인 안에서' 높은 순으로 나열하고(개인 내 상대 순위, ipsative),
     동점은 '연구 자료에서 대표강점으로 더 자주 나오는 강점' 순의 알고리즘으로 가른다
     (https://www.viacharacter.org/faq).
   - 이 검사는 강점당 1문항(1~5)이라 동점이 흔하고, 5점 = 100 으로 환산하면 상위 강점이
     모두 100 으로 포화돼 순위가 의미를 잃는다 → 숫자 대신 1~5 원점수와 '본인 평균 대비'
     상대 수준을 보여 주고, 동점은 공동 순위로 드러낸다.
   동점 순서(결정적): 54개국 VIA 연구의 미국 표본 평균 높은 순(Park, Peterson & Seligman 2006,
     https://ppc.sas.upenn.edu/sites/default/files/cs54nations.pdf). 목록에 없는 키는 뒤로, 그다음 가나다순. */
var VIA_TIE_ORDER = ['친절','공정','정직','감사','판단','사랑','유머','호기심','심미안','창의','통찰','사회지능','리더십','협력','학습열정','용기','용서','희망','끈기','영성','활력','신중','겸손','자기조절'];
function viaRank(via) {
  try {
    if (!via) return null;
    var keys = Object.keys(via).filter(function(k){ var v = Number(via[k]); return isFinite(v); });
    if (!keys.length) return null;
    function raw(k){ var x = Number(via[k]) / 20; x = Math.max(1, Math.min(5, x)); return Math.round(x * 100) / 100; }
    function tie(k){ var i = VIA_TIE_ORDER.indexOf(k); return i < 0 ? 999 : i; }
    var n = keys.length, mean = 0;
    keys.forEach(function(k){ mean += raw(k); }); mean /= n;
    var sd = 0; keys.forEach(function(k){ var d = raw(k) - mean; sd += d * d; }); sd = Math.sqrt(sd / n);
    keys.sort(function(a, b){ return (raw(b) - raw(a)) || (tie(a) - tie(b)) || (a < b ? -1 : a > b ? 1 : 0); });
    var flat = sd < 1e-9;
    var cntByRaw = {}; keys.forEach(function(k){ cntByRaw[raw(k)] = (cntByRaw[raw(k)] || 0) + 1; });
    var items = keys.map(function(k, i){
      var r = raw(k), rel = Math.round((r - mean) * 100) / 100, lv;
      if (flat) lv = 'flat';
      else if (rel >= 0.75 && r >= 4) lv = 'vhigh';
      else if (rel >= 0.25) lv = 'high';
      else if (rel > -0.75) lv = 'mid';
      else lv = 'low';
      return { k: k, v: Number(via[k]), raw: r, rel: rel, level: lv, rank: i + 1, tied: cntByRaw[r] > 1 };
    });
    for (var i = 1; i < items.length; i++) if (items[i].raw === items[i-1].raw) items[i].rank = items[i-1].rank;
    return { items: items, mean: Math.round(mean * 100) / 100, sd: Math.round(sd * 100) / 100, flat: flat,
      /* 상위 cut 경계에서 동점이 끊기는가 (5위와 6위가 같은 점수) */
      tiedAt: function(cut){ return items.length > cut && items[cut-1].raw === items[cut].raw; } };
  } catch (e) { return null; }
}
/* 상위 n개 강점 이름. 전부 같은 점수(flat)면 우열이 없으므로 기본은 빈 배열 — allowFlat 이면 동점 규칙 순서로 준다. */
function viaTopKeys(via, n, allowFlat) {
  var r = viaRank(via); if (!r) return [];
  if (r.flat && !allowFlat) return [];
  return r.items.slice(0, n).map(function(it){ return it.k; });
}
function viaLevelLabel(lv) {
  return lv === 'vhigh' ? _T('매우 강함','Very strong') : lv === 'high' ? _T('강함','Strong')
    : lv === 'mid' ? _T('보통','Moderate') : lv === 'low' ? _T('덜 드러남','Less evident') : _T('구분 불가','No difference');
}
function viaRankLabel(it) { return it.tied ? _T('공동 ' + it.rank + '위', 'T-' + it.rank) : _T(it.rank + '위', '#' + it.rank); }
/* 순위 아래에 붙이는 안내문 — 동점/전부 같은 응답일 때만 */
function viaRankNote(r, cut) {
  if (!r) return '';
  if (r.flat) return _T('모든 강점에 같은 점수로 응답해 강점 사이의 우열을 가릴 수 없습니다. 천천히 다시 응답하면 대표 강점을 확인할 수 있어요.',
    'All strengths received the same answer, so no strength stands out from the others. Answer again more slowly to identify your signature strengths.');
  var tiedTop = r.items.filter(function(it){ return it.raw === r.items[0].raw; }).length;
  if ((cut && r.tiedAt(cut)) || tiedTop > 1) return _T('강점당 1문항(1~5점)이라 같은 점수가 있을 수 있습니다. 같은 점수는 공동 순위이며, 보이는 순서는 VIA 연구에서 더 흔한 강점 순(고정 규칙)입니다. 수준은 본인 평균(' + r.mean.toFixed(1) + '점) 대비입니다.',
    'Each strength is measured by one item (1–5), so ties can occur. Tied strengths share a rank; the display order follows how common each strength is in VIA research (a fixed rule). Levels are relative to your own average (' + r.mean.toFixed(1) + ').');
  return _T('수준은 본인 평균(' + r.mean.toFixed(1) + '점) 대비 상대 위치입니다(다른 사람과 비교 아님).', 'Levels show position relative to your own average (' + r.mean.toFixed(1) + '), not a comparison with others.');
}

function scoreGrit() {
  const r = state.results.grit.answers;
  if (r.length < GRIT_S.length) return null;
  const sums = { P:0, C:0 };
  const counts = { P:0, C:0 };
  GRIT_S.forEach((item, i) => {
    sums[item.f] += scoreLikert5(item, r[i]);
    counts[item.f] += 1;
  });
  return {
    perseverance: Math.round((sums.P/counts.P) * 20),
    passion: Math.round((sums.C/counts.C) * 20),
    overall: Math.round(((sums.P+sums.C)/(counts.P+counts.C)) * 20)
  };
}

function scoreCesd() {
  const r = state.results.cesd.answers;
  if (r.length < CES_D_10.length) return null;
  let total = 0;
  CES_D_10.forEach((item, i) => {
    total += item.s > 0 ? r[i] : 3 - r[i];
  });
  return { total, level: total >= 10 ? 'HIGH' : total >= 6 ? 'MEDIUM' : 'LOW' };
}

function scorePhqa() {
  const r = state.results.phqa.answers;
  if (r.length < PHQ_A.length) return null;
  const total = r.reduce((s,v)=>s+v, 0);
  return {
    total,
    level: total >= 15 ? 'HIGH' : total >= 10 ? 'MEDIUM' : total >= 5 ? 'LOW' : 'NONE',
    selfHarm: r[8] || 0
  };
}

function scoreGad() {
  const r = state.results.gad.answers;
  if (r.length < GAD_7.length) return null;
  const total = r.reduce((s,v)=>s+v, 0);
  return {
    total,
    level: total >= 15 ? 'HIGH' : total >= 10 ? 'MEDIUM' : total >= 5 ? 'LOW' : 'NONE'
  };
}
function scoreWho5() {
  const r = state.results.who5.answers; // 1~6
  if (r.length < WHO5.length) return null;
  const raw = r.reduce((s,v)=>s+(v-1), 0); // 0~25
  const pct = Math.round(raw / (WHO5.length*5) * 100);
  return { raw, pct, level: pct >= 50 ? '양호' : '낮음(돌봄 권장)' };
}
function scoreRses() {
  const r = state.results.rses.answers; // 1~4
  if (r.length < RSES.length) return null;
  let total = 0;
  RSES.forEach((it,i)=>{ total += it.s > 0 ? r[i] : (5 - r[i]); });
  return { total, level: total >= 31 ? '높음' : total >= 21 ? '보통' : '낮음' };
}
function scoreLearn() {
  const r = state.results.learn.answers; // 1~5
  if (r.length < LEARN_ITEMS.length) return null;
  const sums = {}, cnt = {};
  LEARN_ITEMS.forEach(function(it,i){ sums[it.f]=(sums[it.f]||0)+r[i]; cnt[it.f]=(cnt[it.f]||0)+1; });
  const out = {};
  for (const k in sums) out[k] = Math.round(sums[k] / (cnt[k]*5) * 100);
  return out;
}
function scoreMi() {
  const r = state.results.mi.answers; // 1~5
  if (r.length < MI_ITEMS.length) return null;
  const sums = {}, cnt = {};
  MI_ITEMS.forEach(function(it,i){ sums[it.f]=(sums[it.f]||0)+r[i]; cnt[it.f]=(cnt[it.f]||0)+1; });
  const out = {};
  for (const k in sums) out[k] = Math.round(sums[k] / (cnt[k]*5) * 100);
  return out;
}

// =================================================================
//  Integrated PIA 16-type inference (가중 평균)
// =================================================================
function big5ToMbti(){
  var sc=(state.results.big5&&state.results.big5.scores)||null; if(!sc) return null;
  function pk(v,hi,lo){ return (Number(v)>=50)?hi:lo; }
  var t=pk(sc.E,'E','I')+pk(sc.O,'N','S')+pk(sc.A,'F','T')+pk(sc.C,'J','P');
  var NM={INTJ:'전략가',INTP:'논리술사',ENTJ:'통솔자',ENTP:'변론가',INFJ:'옹호자',INFP:'중재자',ENFJ:'선도자',ENFP:'활동가',ISTJ:'현실주의자',ISFJ:'수호자',ESTJ:'경영자',ESFJ:'집정관',ISTP:'장인',ISFP:'모험가',ESTP:'사업가',ESFP:'연예인'};
  var NM_EN={INTJ:'Architect',INTP:'Logician',ENTJ:'Commander',ENTP:'Debater',INFJ:'Advocate',INFP:'Mediator',ENFJ:'Protagonist',ENFP:'Campaigner',ISTJ:'Logistician',ISFJ:'Defender',ESTJ:'Executive',ESFJ:'Consul',ISTP:'Virtuoso',ISFP:'Adventurer',ESTP:'Entrepreneur',ESFP:'Entertainer'};
  var DS={
   INTJ:{d:'멀리 내다보고 큰 그림으로 계획하는 전략가. 독립적이고 분석적.',s:'전략적 사고·장기계획·통찰',c:'연구·기획·엔지니어·전략컨설팅'},
   INTP:{d:'원리와 아이디어 탐구를 즐기는 논리술사. 호기심과 분석력이 강점.',s:'논리·창의·문제해결',c:'개발·연구·데이터·발명'},
   ENTJ:{d:'목표를 향해 사람과 자원을 이끄는 통솔자. 결단력과 추진력.',s:'리더십·실행·조직화',c:'경영·창업·법조·프로젝트리더'},
   ENTP:{d:'새로운 가능성을 즐기는 변론가. 재치와 발상이 빠름.',s:'창의·설득·기획',c:'기획·마케팅·창업·기자'},
   INFJ:{d:'의미와 사람을 깊이 생각하는 옹호자. 통찰과 공감.',s:'통찰·공감·가치지향',c:'상담·교육·작가·사회혁신'},
   INFP:{d:'자기 가치와 진정성을 중시하는 중재자. 상상력과 따뜻함.',s:'창의·공감·진정성',c:'예술·글쓰기·상담·디자인'},
   ENFJ:{d:'사람의 성장을 돕고 이끄는 선도자. 따뜻한 리더십.',s:'대인·동기부여·소통',c:'교육·HR·코칭·기획'},
   ENFP:{d:'열정과 호기심으로 사람과 아이디어를 잇는 활동가.',s:'창의·열정·대인',c:'마케팅·기획·방송·교육'},
   ISTJ:{d:'성실하고 책임감 있게 일하는 현실주의자. 꼼꼼함과 신뢰.',s:'성실·체계·책임',c:'행정·회계·법무·공학'},
   ISFJ:{d:'주변을 세심히 돌보는 수호자. 헌신과 배려.',s:'배려·꼼꼼·헌신',c:'간호·교육·복지·행정'},
   ESTJ:{d:'질서와 효율로 일을 완수하는 경영자. 실행력과 책임.',s:'관리·실행·조직화',c:'경영·행정·군·금융'},
   ESFJ:{d:'사람을 챙기고 협력을 끌어내는 집정관. 친화력.',s:'협력·배려·소통',c:'교육·서비스·HR·간호'},
   ISTP:{d:'직접 다루고 해결하는 장인. 손재주와 침착함.',s:'분석·실용·문제해결',c:'엔지니어·정비·디자인·체육'},
   ISFP:{d:'감각과 자유를 사랑하는 모험가. 예술적 감수성.',s:'감성·예술·유연',c:'예술·디자인·체육·요리'},
   ESTP:{d:'현장에서 빠르게 움직이는 사업가. 추진력과 순발력.',s:'실행·도전·순발력',c:'영업·창업·스포츠·현장직'},
   ESFP:{d:'분위기를 살리는 연예인형. 활기와 표현력.',s:'표현·사교·활력',c:'공연·방송·서비스·이벤트'}
  };
  var DS_EN={
   INTJ:{d:'A strategist who plans with the big picture and long view in mind. Independent and analytical.',s:'Strategic thinking, long-term planning, insight',c:'Research, Planning, Engineering, Strategy Consulting'},
   INTP:{d:'A logician who enjoys exploring principles and ideas. Curiosity and analytical skill are strengths.',s:'Logic, creativity, problem-solving',c:'Development, Research, Data, Invention'},
   ENTJ:{d:'A commander who leads people and resources toward a goal. Decisive and driven.',s:'Leadership, execution, organization',c:'Management, Entrepreneurship, Law, Project Leadership'},
   ENTP:{d:'A debater who enjoys new possibilities. Quick wit and fast ideas.',s:'Creativity, persuasion, planning',c:'Planning, Marketing, Entrepreneurship, Journalism'},
   INFJ:{d:'An advocate who thinks deeply about meaning and people. Insight and empathy.',s:'Insight, empathy, values-driven',c:'Counseling, Education, Writing, Social Innovation'},
   INFP:{d:'A mediator who values authenticity and personal ideals. Imaginative and warm.',s:'Creativity, empathy, authenticity',c:'Art, Writing, Counseling, Design'},
   ENFJ:{d:'A protagonist who helps others grow and leads with warmth.',s:'Interpersonal skill, motivation, communication',c:'Education, HR, Coaching, Planning'},
   ENFP:{d:'A campaigner who connects people and ideas with passion and curiosity.',s:'Creativity, passion, interpersonal skill',c:'Marketing, Planning, Broadcasting, Education'},
   ISTJ:{d:'A logistician who works diligently and responsibly. Meticulous and reliable.',s:'Diligence, structure, responsibility',c:'Administration, Accounting, Legal Affairs, Engineering'},
   ISFJ:{d:'A defender who looks after those around them with great care. Devoted and considerate.',s:'Consideration, meticulousness, devotion',c:'Nursing, Education, Welfare, Administration'},
   ESTJ:{d:'An executive who gets things done through order and efficiency. Strong execution and responsibility.',s:'Management, execution, organization',c:'Management, Administration, Military, Finance'},
   ESFJ:{d:'A consul who looks after people and builds cooperation. Sociable.',s:'Cooperation, consideration, communication',c:'Education, Service, HR, Nursing'},
   ISTP:{d:'A virtuoso who handles and solves things directly. Skilled hands and a calm head.',s:'Analysis, practicality, problem-solving',c:'Engineering, Maintenance, Design, Sports'},
   ISFP:{d:'An adventurer who loves sensation and freedom. Artistic sensibility.',s:'Sensitivity, artistry, flexibility',c:'Art, Design, Sports, Cooking'},
   ESTP:{d:'An entrepreneur who moves quickly in the field. Drive and quick reflexes.',s:'Execution, challenge-taking, quick reflexes',c:'Sales, Entrepreneurship, Sports, Field Work'},
   ESFP:{d:'An entertainer who lights up the room. Energy and expressiveness.',s:'Expressiveness, sociability, energy',c:'Performance, Broadcasting, Service, Events'}
  };
  var _enOn=(window.aipiaCurrentLang==='en');
  var info=(_enOn?DS_EN[t]:DS[t])||{d:'',s:'',c:''};
  var nmMap=_enOn?NM_EN:NM;
  return { type:t, name:(nmMap[t]||''), desc:info.d, strength:info.s, career:info.c };
}
function inferIntegratedType() {
  const big5 = state.results.big5.scores;
  const riasec = state.results.riasec.scores;
  const via = state.results.via.scores;
  const grit = state.results.grit.scores;
  const sjtDims = state.results.sjt.dims;
  const convDims = state.results.conv.dims;

  const DIMS = ['창의','분석','공감','실천','탐구','감성','계획','관찰','도전','자유','현실','책임','외향','내향','균형','끈기'];
  const acc = {}; DIMS.forEach(function(d){ acc[d] = []; });
  function add(d, v){ if (v != null && !isNaN(v)) acc[d].push(v); }

  if (big5) {
    add('외향', big5.E); add('내향', 100 - big5.E);
    add('공감', big5.A);
    add('계획', big5.C); add('책임', big5.C);
    add('창의', big5.O); add('탐구', big5.O); add('자유', big5.O);
    add('균형', 100 - big5.N);
  }
  if (riasec) {
    add('현실', riasec.R); add('실천', riasec.R);
    add('분석', riasec.I); add('탐구', riasec.I); add('관찰', riasec.I);
    add('감성', riasec.A); add('자유', riasec.A); add('창의', riasec.A);
    add('공감', riasec.S);
    add('도전', riasec.E); add('외향', riasec.E);
    add('계획', riasec.C);
  }
  if (via) {
    add('창의', via['창의']); add('공감', via['친절']);
    add('책임', via['끈기']); add('끈기', via['끈기']);
    add('도전', via['용기']); add('관찰', via['신중']);
  }
  if (grit) {
    add('끈기', grit.overall); add('책임', grit.perseverance); add('실천', grit.perseverance);
  }
  // SJT/대화 신호 정규화 후 가중 반영
  function normDims(raw){ const vals = Object.values(raw); const max = Math.max.apply(null, [1].concat(vals)); const out = {}; for (const k in raw) out[k] = (raw[k] / max) * 100; return out; }
  const sjtNorm = (sjtDims && Object.keys(sjtDims).length) ? normDims(sjtDims) : {};
  const convNorm = (convDims && Object.keys(convDims).length) ? normDims(convDims) : {};
  DIMS.forEach(function(d){ if (sjtNorm[d]) acc[d].push(sjtNorm[d]); if (convNorm[d]) acc[d].push(convNorm[d]); });

  const dims = {};
  DIMS.forEach(function(d){ const arr = acc[d]; dims[d] = arr.length ? Math.round(arr.reduce(function(s,v){ return s + v; }, 0) / arr.length) : 0; });

  // 유형 규칙을 '평균 점수'로 비교해 최고점 유형 선택(선매칭 편향 제거, 전 유형 도달 가능)
  const RULES = [
    {code:'CR-EX', keys:['창의','탐구']},
    {code:'EM-CO', keys:['공감','외향']},
    {code:'EX-LE', keys:['실천','도전']},
    {code:'QT-RS', keys:['탐구','내향']},
    {code:'EX-CR', keys:['감성','창의']},
    {code:'PL-MG', keys:['계획','책임']},
    {code:'RE-CO', keys:['공감','관찰']},
    {code:'CH-PI', keys:['도전','외향']},
    {code:'AR-EX', keys:['자유','감성']},
    {code:'PR-HA', keys:['현실','실천']},
    {code:'FU-ST', keys:['분석','계획']},
    {code:'RP-CL', keys:['책임','공감']},
    {code:'IN-SP', keys:['탐구','분석']},
    {code:'LO-AN', keys:['분석']},
    {code:'BA-GR', keys:['균형','끈기']}
  ];
  let best = 'PT-EX', bestScore = -1;
  RULES.forEach(function(r){ let sum = 0; r.keys.forEach(function(k){ sum += (dims[k] || 0); }); const sc = sum / r.keys.length; if (sc > bestScore) { bestScore = sc; best = r.code; } });
  return PIA_TYPES.find(function(t){ return t.code === best; }) || PIA_TYPES.find(function(t){ return t.code === 'PT-EX'; }) || PIA_TYPES[0];
}

// =================================================================
//  Reliability grading (검사 수 + 일관성 기반)
// =================================================================
function calcReliability() {
  const completed = [];
  if (state.results.big5.scores) completed.push('Big5');
  if (state.results.riasec.scores) completed.push('RIASEC');
  if (state.results.via.scores) completed.push('VIA');
  if (state.results.grit.scores) completed.push('Grit');
  if (state.results.sjt.answers.length >= 15) completed.push('SJT');
  if (state.results.conv.turns >= 12) completed.push(_T('대화','Conversation'));

  const screening = [];
  if (state.results.cesd.scores) screening.push('CES-D');
  if (state.results.phqa.scores) screening.push('PHQ-A');
  if (state.results.gad.scores) screening.push('GAD-7');

  const n = completed.length;
  let grade, label;
  if (n >= 5) { grade='A+'; label=_T('매우 높음','Very High'); }
  else if (n >= 4) { grade='A'; label=_T('높음','High'); }
  else if (n >= 3) { grade='B'; label=_T('보통','Moderate'); }
  else if (n >= 2) { grade='C'; label=_T('낮음 — 추가 검사 권장','Low — More tests recommended'); }
  else { grade='D'; label=_T('불충분 — 결과 해석 주의','Insufficient — Interpret with caution'); }

  /* [2026-09-27] 검사 완료도(검사 수)만으로 A+ 를 주면 '신뢰도 A+'와 '응답 성실도 주의'가 함께 뜬다.
     타당도 지표가 나쁘면 본 점수 해석을 제한한다는 원칙(MMPI 타당도 척도 운용 등)에 따라
     성실도 '주의' → 최대 B, '낮음' → 최대 C + 해석 주의. 완료도 등급은 completionGrade 로 따로 둔다. */
  const completionGrade = grade, completionLabel = label;
  const validity = calcValidity();
  const ORD = ['D','C','B','A','A+'];
  const cap = validity && validity.grade === '낮음' ? 'C' : (validity && validity.grade === '주의' ? 'B' : null);
  let capped = false;
  if (cap && ORD.indexOf(grade) > ORD.indexOf(cap)) { grade = cap; capped = true; }
  if (validity && validity.grade === '낮음') label = (grade === 'D') ? _T('불충분 · 응답 성실도 낮음 — 결과 해석 주의','Insufficient · Low response validity — Interpret with caution') : _T('낮음 — 응답 성실도 낮음, 결과 해석 주의','Low — Low response validity; interpret with caution');
  else if (capped) label = _T('보통 — 응답 성실도 주의','Moderate — Response validity caution');
  return { grade, label, n, completed, screening, validity, completionGrade, completionLabel, capped };
}
/* 신뢰도 문구 뒤에 붙이는 조각: ' · 검사 완료도 A+ · 응답 성실도: 주의' (html=true 면 <strong>) */
function piaRelFrag(r, html) {
  if (!r) return '';
  var b = function(x){ return html ? '<strong>' + x + '</strong>' : x; };
  var s = '';
  if (r.completionGrade) s += _T(' · 검사 완료도 ',' · Completion ') + b(r.completionGrade);   /* [2026-11-02] 해석 등급의 두 근거를 항상 함께 보인다 */
  var v = r.validity;
  if (v && v.grade && v.grade !== '-') s += _T(' · 응답 성실도: ',' · Response Validity: ') + b(v.gradeLabel || v.grade);
  return s;
}

// C: 응답 성실도(validity) — 직선응답/저분산/역문항 모순을 종합
function calcValidity() {
  try {
    var R = state.results;
    var pools = [
      { key:'big5', ds:(typeof piaBig5Items==='function'?piaBig5Items(R.big5):null), rev:true },
      { key:'via',  ds:(typeof VIA_YOUTH!=='undefined'?VIA_YOUTH:null), rev:false },
      { key:'grit', ds:(typeof GRIT_S!=='undefined'?GRIT_S:null), rev:true },
      { key:'learn',ds:(typeof LEARN_ITEMS!=='undefined'?LEARN_ITEMS:null), rev:false },
      { key:'mi',   ds:(typeof MI_ITEMS!=='undefined'?MI_ITEMS:null), rev:false }
    ];
    var all = [];
    var flags = [];
    var contradiction = 0, revPairs = 0;
    pools.forEach(function(p){
      var a = (R[p.key] && R[p.key].answers) || [];
      var vals = a.filter(function(x){ return x!==undefined && x!==null; });
      if (vals.length < 5) return;
      var run=1, maxRun=1;
      for (var i=1;i<vals.length;i++){ if(vals[i]===vals[i-1]){ run++; if(run>maxRun)maxRun=run; } else run=1; }
      if (maxRun >= Math.max(8, Math.round(vals.length*0.5))) flags.push(p.key+_T(' 연속동일',' repeated-value streak'));
      var mean=0; vals.forEach(function(v){mean+=v;}); mean/=vals.length;
      var varc=0; vals.forEach(function(v){varc+=(v-mean)*(v-mean);}); varc/=vals.length;
      if (varc < 0.3 && vals.length>=8) flags.push(p.key+_T(' 분산낮음',' low variance'));
      all = all.concat(vals);
      if (p.rev && p.ds && a.length===p.ds.length){
        /* [2026-09-27] 역문항 모순은 '같은 척도(f)' 안에서 본다(MMPI TRIN 처럼 같은 내용의 정·역 문항 쌍).
           예전엔 척도를 섞어 정문항 평균 ≈ 역문항 평균이면 모순으로 봐서, 성향이 고르게 중간인
           성실한 응답자도 '주의'로 잡혔다(신뢰도 상한과 겹치면 부당하게 등급이 깎인다).
           d = 정문항 평균 + 역문항 평균 − 6 : 일관된 응답이면 ≈0, 전부 '그렇다'(묵종)면 +4, 전부 '아니다'면 −4. */
        var byF={};
        for (var j=0;j<p.ds.length;j++){
          var it=p.ds[j]; if(a[j]===undefined||a[j]===null) continue;
          if (it && typeof it.s!=='undefined'){ var fk=String(it.f); byF[fk]=byF[fk]||{pos:[],neg:[]}; (it.s>0?byF[fk].pos:byF[fk].neg).push(a[j]); }
        }
        var elig=0, bad=0;
        Object.keys(byF).forEach(function(fk){ var g=byF[fk]; if(g.pos.length<2||g.neg.length<2) return; elig++;
          var pm=g.pos.reduce(function(x,y){return x+y;},0)/g.pos.length;
          var nm=g.neg.reduce(function(x,y){return x+y;},0)/g.neg.length;
          if (Math.abs(pm+nm-6) >= 2) bad++; });
        if (elig){ revPairs++; if (bad >= Math.max(1, Math.ceil(elig/2))) contradiction++; }
      }
    });
    if (all.length < 10) return { grade:'-', gradeLabel:'-', reason:_T('성실도 판정에 필요한 응답이 부족합니다(검사 더 필요).','Not enough responses to assess validity (more assessments needed).') };
    if (contradiction > 0) flags.push(_T('역문항 모순','reverse-item contradiction'));
    /* [2026-11-02 E2-C] 사람 단위 역문항 일관성 지수(piaRevConsistency) — 척도별 판정(위)이 놓치던
       '역문항도 같은 방향으로 답함(묵종)'과 '정·역문항이 서로 따로 노는 무작위 응답'을 잡는다. */
    var revIndex = null;
    try { revIndex = piaRevConsistency((R.big5 && R.big5.answers) || [], piaBig5Items(R.big5)); } catch (e) { revIndex = null; }
    if (revIndex && revIndex.flag) flags.push(_T('역문항 일관성 낮음','low reverse-item consistency'));
    /* [2026-11-02] 대화 신뢰성 ⑤ — AI 대화 성실도가 주의·낮음이면 신호 하나로 더한다 */
    try {
      var _ctr = (R.conv && R.conv.transcript) || [];
      var _cd = (window.piaChatTrust && _ctr.length >= 6) ? window.piaChatTrust.diligence(_ctr) : null;
      if (_cd && (_cd.grade === '주의' || _cd.grade === '낮음')) flags.push(_T('대화 성실도 ' + _cd.grade, 'conversation diligence ' + (_cd.grade === '낮음' ? 'low' : 'caution')) + (_cd.reason ? '(' + _cd.reason + ')' : ''));
    } catch (e) {}
    var grade, reason;
    var sev = flags.length + (contradiction>0?1:0);
    if (sev >= 3) { grade='낮음'; reason=_T('직선응답·낮은 분산 또는 역문항 모순 신호가 여러 건 감지되었습니다('+flags.join(', ')+'). 결과 해석에 주의가 필요합니다.','Several signals of straight-lining, low variance, or reverse-item contradiction were detected ('+flags.join(', ')+'). Interpret the results with caution.'); }
    else if (sev >= 1) { grade='주의'; reason=_T('일부 성실도 신호가 감지되었습니다('+flags.join(', ')+'). 대체로 해석 가능하나 참고하세요.','Some validity signals were detected ('+flags.join(', ')+'). The results are generally interpretable, but keep this in mind.'); }
    else { grade='양호'; reason=_T('직선응답·저분산·역문항 모순 신호가 뚜렷하지 않아 성실한 응답으로 판단됩니다.','No clear signs of straight-lining, low variance, or reverse-item contradiction \u2014 the responses appear to have been given carefully.'); }
    var gradeLabel = _T(grade, grade==='낮음'?'Low':grade==='주의'?'Caution':grade==='양호'?'Good':'-');
    return { grade:grade, gradeLabel:gradeLabel, reason:reason, flags:flags, revIndex:revIndex };
  } catch(e) { return { grade:'-', gradeLabel:'-', reason:_T('성실도 계산 오류','Error calculating validity') }; }
}
/* [2026-11-02 E2-C] 사람 단위 역문항 일관성 지수 — 서버 api/src/scoring.js reverseConsistency 와 같은 식(대조 검사로 확인).
   척도(f)마다 정문항 평균 p 와 역문항을 뒤집은 평균 q(6−v)를 구한다(정·역 각 2문항 이상, 응답이 다 찬 경우만).
     gap = 척도 평균 |p − q|  : 성실하면 작고(≈0.3), 역문항까지 같은 방향으로 답하면(묵종·부정) 커진다(≥1.25 → 신호).
     r   = 척도들 사이 p 와 q 의 상관 : 성실하면 양(+), 무작위면 0 근처·음(−). p·q 가 모두 척도 간에 퍼져 있을 때만(표준편차 ≥0.25) 낸다.
   flag = gap ≥ 1.25 이거나 (r < 0 이고 gap ≥ 0.6). */
function piaRevConsistency(a, items){
  if (!items || !a || a.length < items.length) return null;
  var byF = {};
  for (var i = 0; i < items.length; i++) {
    var v = a[i]; if (typeof v !== 'number' || !isFinite(v)) return null;
    var it = items[i]; if (!it || typeof it.s === 'undefined') continue;
    var g = byF[it.f] = byF[it.f] || { p:[], q:[] };
    if (it.s > 0) g.p.push(v); else g.q.push(6 - v);
  }
  var P = [], Q = [];
  Object.keys(byF).forEach(function(f){ var g = byF[f]; if (g.p.length < 2 || g.q.length < 2) return;
    P.push(g.p.reduce(function(x,y){return x+y;},0)/g.p.length); Q.push(g.q.reduce(function(x,y){return x+y;},0)/g.q.length); });
  if (P.length < 3) return null;
  var n = P.length, gap = 0, mp = 0, mq = 0;
  for (var k = 0; k < n; k++) { gap += Math.abs(P[k] - Q[k]); mp += P[k]; mq += Q[k]; }
  gap /= n; mp /= n; mq /= n;
  var sp = 0, sq = 0, cv = 0;
  for (var k2 = 0; k2 < n; k2++) { sp += (P[k2]-mp)*(P[k2]-mp); sq += (Q[k2]-mq)*(Q[k2]-mq); cv += (P[k2]-mp)*(Q[k2]-mq); }
  var sdp = Math.sqrt(sp/(n-1)), sdq = Math.sqrt(sq/(n-1));
  var r = (sdp >= 0.25 && sdq >= 0.25) ? cv / Math.sqrt(sp*sq) : null;
  var gapR = Math.round(gap*100)/100, rR = r === null ? null : Math.round(r*100)/100;
  return { gap: gapR, r: rR, scales: n, flag: (gapR >= 1.25) || (rR !== null && rR < 0 && gapR >= 0.6) };
}

// =================================================================
//  Reply generation (LOCAL rules)
// =================================================================
function inferStage(turns) {
  if (turns <= 2) return 'RAPPORT';
  if (turns <= 6) return 'EXPLORE';
  if (turns <= 11) return 'REFRAME';
  if (turns <= 15) return 'ACTION';
  return 'CHECKOUT';
}

// 사용된 질문 추적 (반복 방지)
function getUsedReplies() {
  return (state.results.conv.transcript || []).map(t => t.reply || '');
}

function pickUnusedReply(options) {
  const used = getUsedReplies();
  const fresh = options.filter(o => !used.some(u => u.includes(o)));
  if (fresh.length) return fresh[Math.floor(Math.random()*fresh.length)];
  return options[Math.floor(Math.random()*options.length)];
}

// 고위험(HIGH)으로 판정됐던 과거 발화는 외부 AI 프롬프트에 원문을 절대 다시
// 넣지 않는다. 그 턴은 이미 로컬 강제 안전 응답(crisisReply)으로 처리했으므로,
// 외부로는 "있었다"는 사실만 안전하게 요약해서 넘긴다.
// (QA 2026-08-22: "고위험 대화 이력이 다음 일반 요청에서 외부 AI로 다시 전송된다")
function sanitizeHistoryForExternal(turns) {
  return (turns || []).map(function(t){
    if (t && t.risk === 'HIGH') {
      return Object.assign({}, t, { msg: '[민감한 내용으로 판단되어 생략됨 — 이미 안전 응답을 안내함]' });
    }
    return t;
  });
}
/* [2026-10-04 고도화 — 대화 내용 깊이] 기억.
   예전: 최근 4차례만 넘겨서, 5번째 차례부터는 학생이 앞에서 한 이야기를 모른 채 답했다.
         같은 것을 또 묻거나, 앞 이야기와 이어지지 않았다.
   지금: 그보다 앞선 학생 말 중 내용 있는 것(최대 6개, 각 45자)을 [기억]으로 함께 넘긴다.
         5번째 차례부터 세 번에 한 번은 [기억] 중 하나와 지금 이야기를 이어서 묻게 한다.
   · 개인정보는 이미 가려진 글(maskPII)만, 고위험·욕설 차례는 뺀다.
   · 끄기: localStorage pia_convmem='0'. */
function piaConvMemory() {
  try {
    if (localStorage.getItem('pia_convmem') === '0') return [];
  } catch (e) {}
  const all = state.results.conv.transcript || [];
  const older = all.slice(0, Math.max(0, all.length - 4));
  const items = [];
  older.forEach(function (t) {
    if (!t || t.risk === 'HIGH' || t.risk === 'MEDIUM' || t.abusive) return;
    const m = String(t.msg || '').replace(/\s+/g, ' ').trim();
    if (m.length < 6) return;                                  /* '응', '몰라요' 같은 짧은 답 */
    if (m.length < 12 && /^(응|네|넹|아니|몰라|모르겠|그냥|글쎄|음|어|ㅇㅇ|ㅋ|ㅎ)/.test(m)) return;
    if (items.indexOf(m.slice(0, 45)) < 0) items.push(m.slice(0, 45));
  });
  return items.slice(-6);
}
window.piaConvMemory = piaConvMemory;
function buildConvContext(currentMsg) {
  // 최근 대화 맥락을 LLM 프롬프트에 주입 (개인정보는 maskPII 처리된 텍스트만 사용,
  // 고위험 이력은 sanitizeHistoryForExternal 로 원문을 제거한 뒤 사용)
  const tr = sanitizeHistoryForExternal((state.results.conv.transcript || []).slice(-4));
  let ctx = '';
  const mem = piaConvMemory();
  if (mem.length) {
    ctx += '[기억 — 학생이 앞에서 한 말]\n' + mem.map(function (x) { return '- ' + x; }).join('\n') + '\n\n';
  }
  if (tr.length) {
    ctx += '지금까지의 대화:\n';
    tr.forEach(t => { ctx += `학생: ${t.msg}\n피아: ${t.reply}\n`; });
    ctx += '\n';
  }
  ctx += `학생의 새 메시지: ${currentMsg}\n위 규칙과 단계에 맞춰 피아로서 한 번만 답하세요.`;
  /* 세 번에 한 번: 지난 이야기와 지금 이야기를 이어 준다(고위험 문맥에서는 하지 않는다) */
  try {
    const n = (state.results.conv.turns || 0) + 1;
    if (mem.length && n >= 5 && n % 3 === 2 && !piaChatInCrisis() && ['HIGH','MEDIUM'].indexOf(detectRisk(String(currentMsg || ''))) < 0) {
      ctx += '\n[이번 답] 위 [기억] 중 지금 이야기와 어울리는 것 하나를 골라 "아까 ~라고 했잖아"처럼 자연스럽게 이어서 물어라. [기억]에 없는 내용은 지어내지 마라. 어울리는 것이 없으면 억지로 잇지 마라.';
    }
  } catch (e) { console.error('[자유대화] 기억 연결 지시 실패', e); }
  return ctx;
}

function generateReply(text) {
  const risk = detectRisk(text);
  const topic = detectTopic(text);

  // 1. HIGH 위험 — 강제 응답 (5분류 판정 + 의도·계획·시점 상태기)
  if (risk === 'HIGH') {
    const _d = detectRiskDetail(text);
    return {
      reply: crisisReply(text, _d.category),
      risk, category: (_d.category || crisisState().category), topic:'정서', forced:true
    };
  }

  // 2. MEDIUM 위험 + 정서 키워드 — 공감 우선
  if (risk === 'MEDIUM' || SHORT_FEELING.some(w => text.includes(w))) {
    const empathyMed = [
      '많이 외로우셨겠어요. 그 마음을 알아차린 것만으로도 큰 일이에요.',
      '그 감정 안에 머무는 것도 힘드셨죠. 언제부터 그런 느낌이셨어요?',
      '많이 지쳐 계셨군요. 오늘 그 마음에 이름을 붙여 주셔서 고마워요.',
      '쓸쓸한 마음을 말씀해 주셔서 고마워요. 그 느낌이 가장 강한 시간이 언제인가요?'
    ];
    return {
      reply: pickUnusedReply(empathyMed),
      risk, topic:'정서', forced:false
    };
  }

  // 2.5 질문이면 — 먼저 간단히 답하고 대화를 이어감
  if (/[?？]/.test(text) || /(뭐|왜|어떻게|어떡|할까|일까|인가요|있을까|추천|알려|어디|언제|누구|몇|어때)/.test(text)) {
    const ans = [
      '좋은 질문이에요. 정답이 하나만 있는 건 아니고, 본인에게 맞는 답을 함께 찾는 게 더 중요해요.',
      '음, 그건 사람마다 조금씩 달라요. 본인은 어느 쪽에 더 마음이 가시나요?',
      '그게 궁금하셨군요. 핵심은 무엇을 좋아하고 어떤 걸 잘하느냐예요.',
      '한 번에 정해지는 건 아니라서 천천히 찾아가면 돼요. 지금 떠오르는 생각이 있으신가요?'
    ];
    const fu = ['요즘 가장 관심 가는 건 무엇인가요?','그 주제에서 어떤 점이 제일 궁금하세요?','본인 생각은 어떤지 더 들려주실래요?','어떤 상황에서 그게 떠올랐나요?'];
    return { reply: pickUnusedReply(ans) + ' ' + pickUnusedReply(fu), risk, topic, forced:false };
  }

  // 3. 문학적/시적 표현 — 인지하고 깊이 들어가기
  if (LITERARY_HINT.some(w => text.includes(w))) {
    const literary = [
      `"${text}" — 이미지가 깊네요. 그 표현을 떠올린 지금의 마음은 어떠세요?`,
      `시적인 표현이네요. 그 장면이 어떤 느낌으로 다가오시나요?`,
      `그 풍경에 마음이 비치는 것 같아요. 그 안에서 본인은 어디쯤 있으신가요?`
    ];
    return {
      reply: pickUnusedReply(literary),
      risk, topic:'정서', forced:false
    };
  }

  // 4. 짧은 응답 (4자 이하) — 선택지로 유도
  if (text.length <= 4) {
    const shortFollowups = [
      `짧게 말씀해 주셔서 고마워요. "${text}"라는 단어가 떠오른 이유를 한 줄만 더 들려주실래요?`,
      `그 단어 안에 많은 게 들어있는 것 같아요. 어떤 일이 떠오르세요?`,
      `좋아요, 한 단어도 충분해요. 그 느낌을 색이나 날씨로 표현하면 무엇에 가까울까요?`
    ];
    return {
      reply: pickUnusedReply(shortFollowups),
      risk, topic, forced:false
    };
  }

  // 5. 일반 응답 — CBT 단계별 + 주제별 질문 풀에서 미사용 항목 선택
  const stage = inferStage(state.results.conv.turns);
  const topicPool = TOPIC_REPLIES[topic] || TOPIC_REPLIES['일반상담'];
  const stageOptions = topicPool[stage] || topicPool.RAPPORT || ['지금 마음을 더 들려주실래요?'];

  const empathyVar = [
    '말씀해 주셔서 고마워요.','이야기해 주셔서 고마워요.','마음을 전해 주셔서 고마워요.',
    '용기 내서 말씀해 주셔서 고마워요.','솔직하게 표현해 주셔서 고마워요.','함께 나눠 주셔서 고마워요.'
  ];
  const empathy = pickUnusedReply(empathyVar);
  const question = pickUnusedReply(stageOptions);

  return { reply: `${empathy} ${question}`, risk, topic, forced:false, stage };
}

function updateChatProfile() {
  const box = document.getElementById('chat-profile');
  if (!box) return;
  const dims = (state.results.conv && state.results.conv.dims) || {};
  const top = Object.entries(dims).filter(function(e){ return e[1] > 0; }).sort(function(a,b){ return b[1]-a[1]; }).slice(0,3);
  const aiOn = !!(state.results.conv && state.results.conv.aiDims);
  var _pcEn = (window.aipiaCurrentLang === 'en');
  box.innerHTML = top.length
    ? (aiOn ? (_pcEn ? '\ud83e\udde0 AI-analyzed traits: ' : '🧠 AI가 분석한 성향: ') : (_pcEn ? '\ud83d\udd0e Traits being identified: ' : '🔎 대화에서 파악 중인 성향: ')) + top.map(function(e){ return '<span class="pill bg-violet-100 text-violet-900 text-[10px] mr-1">' + e[0] + '</span>'; }).join('')
    : (_pcEn ? '\ud83d\udd0e Keep chatting naturally and we\'ll pick up on your traits.' : '🔎 편하게 이야기하다 보면 성향이 자연스럽게 파악돼요.');
}

// ===== 대화 내용을 LLM이 직접 분석해 성향 점수 추론 (키워드 매칭 보강) =====
let _aiInferBusy = false;
async function aiInferTraits() {
  if (_aiInferBusy) return;
  const trRaw = (state.results.conv && state.results.conv.transcript) || [];
  if (trRaw.length < 2) return;
  _aiInferBusy = true;
  try {
    // 고위험 이력 원문은 외부 API로 다시 보내지 않는다 (sanitizeHistoryForExternal)
    const tr = sanitizeHistoryForExternal(trRaw);
    const convText = tr.slice(-8).map(function(t){ return '학생: ' + t.msg; }).join('\n');
    const dimsList = '창의,분석,공감,실천,탐구,감성,계획,관찰,도전,자유,현실,책임,외향,내향';
    const sys = '너는 청소년 대화에서 성향 신호를 추론하는 분석가야. 반드시 JSON 객체 하나만 출력하고 설명은 쓰지 마.';
    const prompt = '다음은 학생이 한 말이야:\n' + convText
      + '\n\n이 말들에서 드러나는 성향을 아래 14개 중 근거가 있는 것만 골라 0~3 점수로 평가해. 키는 한국어 그대로, JSON 객체 하나만 출력:\n['
      + dimsList + ']\n예시: {"공감":2,"탐구":1}';
    const out = await callLLMFree(prompt, sys);
    if (out) {
      const m = out.match(/\{[\s\S]*\}/);
      if (m) {
        const obj = JSON.parse(m[0]);
        const valid = dimsList.split(',');
        state.results.conv.aiDims = state.results.conv.aiDims || {};
        for (const k in obj) {
          if (valid.indexOf(k) >= 0) {
            const v = Math.max(0, Math.min(3, Number(obj[k]) || 0));
            if (v > 0) {
              state.results.conv.aiDims[k] = (state.results.conv.aiDims[k] || 0) + v;
              state.results.conv.dims[k] = (state.results.conv.dims[k] || 0) + v; // 통합 추론 파이프라인 반영
            }
          }
        }
        save();
        if (typeof updateChatProfile === 'function') updateChatProfile();
      }
    }
  } catch (e) { /* JSON 파싱/네트워크 실패 시 무시 */ } finally { _aiInferBusy = false; }
}

/* [2026-10-04 고도화 — 대화 내용 깊이] 대화 끝 정리.
   12차례가 끝나면 학생이 한 말에서 관심사·잘하는 것·해 보고 싶은 것을 한 번 정리해 결과지에 싣는다.
   · 학생이 직접 말한 것만(근거 없는 추측 금지), 가족 문제·건강·고민 같은 민감한 내용은 넣지 않는다.
     모델 출력도 한 번 더 걸러서(민감 낱말) 싣는다. 원문은 싣지 않는다.
   · 고위험 이력 원문은 외부로 다시 보내지 않는다(sanitizeHistoryForExternal). */
var _convSumBusy = false;
var _CONV_SUM_BAN = /(죽|자해|자살|우울|불안|폭력|학대|이혼|병원|약물|따돌|왕따|괴롭|싸움|가출|성적\s*비관|때리|맞았)/;
function _convSumClean(arr, max) {
  if (!Array.isArray(arr)) return [];
  const out = [];
  arr.forEach(function (x) {
    const v = String(x == null ? '' : x).replace(/\s+/g, ' ').trim().slice(0, 24);
    if (v.length >= 2 && !_CONV_SUM_BAN.test(v) && detectRiskDetail(v).level !== 'HIGH' && out.indexOf(v) < 0) out.push(v);
  });
  return out.slice(0, max || 4);
}
async function aiSummarizeConv() {
  if (_convSumBusy) return null;
  const trRaw = (state.results.conv && state.results.conv.transcript) || [];
  /* [2026-11-02] 위기 말은 정리 칸(관심·강점·해 보고 싶은 것)에 넣지 않는다(평가 P10: '해 보고 싶은 것'에 "아침에 늦잠").
     위기 차례·지원 모드 차례는 빼고, 지원 모드가 아직 켜져 있으면 첫 위기 차례 이후는 모두 뺀다. */
  var _firstCrisis = trRaw.findIndex(function (t) { return t && (t.risk === 'HIGH' || t.crisis); });
  var _cutAfter = (_firstCrisis >= 0 && crisisState().active) ? _firstCrisis : trRaw.length;
  const said = sanitizeHistoryForExternal(trRaw)
    .filter(function (t, i) { return t && i < _cutAfter && t.risk !== 'HIGH' && !t.crisis && !t.crisisMode && !t.abusive && String(t.msg || '').trim().length >= 4 && detectRiskDetail(t.msg).level !== 'HIGH'; })
    .map(function (t) { return '- ' + String(t.msg).replace(/\s+/g, ' ').trim().slice(0, 80); });
  if (said.length < 4) return null;
  _convSumBusy = true;
  try {
    const en = (window.aipiaCurrentLang === 'en');
    const sys = '너는 학생과의 수다에서 학생이 직접 말한 관심사를 정리하는 도우미야. 반드시 JSON 객체 하나만 출력하고 설명은 쓰지 마.';
    const prompt = '다음은 학생이 대화에서 한 말이야:\n' + said.join('\n')
      + '\n\n학생이 직접 말한 내용에서만 골라 아래 JSON 으로 정리해. 근거 없는 추측은 하지 말고, 해당하는 것이 없으면 빈 배열로 둬.'
      + ' 가족 문제·건강·고민·다툼 같은 민감한 내용은 넣지 마. 각 항목은 12자 이내의 짧은 낱말·구로, 배열마다 최대 4개.'
      + (en ? ' Write every value in English.' : ' 모든 값은 한국어로.')
      + '\n{"interests":["좋아하는 것·관심사"],"strengths":["잘하거나 꾸준히 하는 것"],"wants":["해 보고 싶은 것·되고 싶은 것"],"line":"학생을 한 문장으로(40자 이내, 칭찬·응원 말투)"}';
    const out = await callLLMFree(prompt, sys, null, { max_tokens: 320 });
    if (!out) return null;
    const m = String(out).match(/\{[\s\S]*\}/);
    if (!m) return null;
    const obj = JSON.parse(m[0]);
    let line = String(obj.line || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (_CONV_SUM_BAN.test(line)) line = '';
    const sum = { interests: _convSumClean(obj.interests), strengths: _convSumClean(obj.strengths), wants: _convSumClean(obj.wants), line: line, at: Date.now(), turns: state.results.conv.turns };
    if (!sum.interests.length && !sum.strengths.length && !sum.wants.length) return null;
    state.results.conv.summary = sum;
    save();
    return sum;
  } catch (e) { console.error('[자유대화] 대화 정리 실패', e); return null; }
  finally { _convSumBusy = false; }
}
window.aiSummarizeConv = aiSummarizeConv;
/* [2026-11-02] 대화 신뢰성 ②③④⑤ — 결과지 'AI 대화 해석'.
   · 성실도 기준 미달이면 AI 를 부르지 않고 '대화 정보 부족'(⑤)
   · 대화만 보고(점수 없이) 온도 0 으로 두 번 해석, 주제별 결론이 같은 것만 싣는다(④)
   · 인용이 학생 말에 실제로 없으면 그 주제를 버린다(③). 검사 대조는 그릴 때 계산한다(②)
   · 고위험 이력 원문은 외부로 다시 보내지 않는다(sanitizeHistoryForExternal). */
var _convTrustBusy = false;
async function piaChatTrustInterpret() {
  var T = window.piaChatTrust;
  if (!T || _convTrustBusy) return null;
  var tr = sanitizeHistoryForExternal((state.results.conv && state.results.conv.transcript) || []);
  var dil = T.diligence(tr);
  var rec = { v: T.VERSION, model: T.MODEL, dil: dil, interp: null, at: Date.now(), turns: state.results.conv.turns };
  if (!dil.enough) { state.results.conv.trust = rec; save(); return rec; }
  _convTrustBusy = true;
  try {
    var rq = T.interpretRequest(tr, { en: window.aipiaCurrentLang === 'en' });
    var o = { max_tokens: rq.max_tokens, temperature: rq.temperature };
    var outs = await Promise.all([callLLMFree(rq.user, rq.system, null, o), callLLMFree(rq.user, rq.system, null, o)]);
    var a = T.parseInterpretation(outs[0], tr), b = T.parseInterpretation(outs[1], tr);
    if (!a && b) { a = b; b = null; }
    if (!a) return null;
    rec.interp = T.merge(a, b);
    if (!b) rec.interp.repro = null;   /* 한 번만 받았으면 재현 일치는 표시하지 않는다 */
    state.results.conv.trust = rec;
    save();
    return rec;
  } catch (e) { console.error('[자유대화] 대화 해석 실패', e); return null; }
  finally { _convTrustBusy = false; }
}
window.piaChatTrustInterpret = piaChatTrustInterpret;
function renderConvTrustCard() {
  try {
    var T = window.piaChatTrust, ct = state.results.conv && state.results.conv.trust;
    if (!T || !ct) return '';
    return T.renderCard({ dil: ct.dil, interp: ct.interp, cross: ct.interp ? T.crossCheck(ct.interp, state.results) : null, model: ct.model, version: ct.v },
      { T: _T, iconBase: '/images/ill/', hideQuotes: (typeof currentAudience !== 'undefined' && currentAudience !== 'student') });
  } catch (e) { console.error('[결과지] 대화 해석 카드 실패', e); return ''; }
}
window.renderConvTrustCard = renderConvTrustCard;
/* 대화 화면 진행 줄 오른쪽에 5개 주제 칩(새 줄을 만들지 않아 화면 높이는 그대로) */
function piaRenderSlotChips() {
  try {
    if (!window.piaChatTrust) return;
    var n = document.getElementById('chat-turn-n'); var top = n && n.closest('.pia-prog__top'); if (!top) return;
    var box = document.getElementById('pia-slotchips');
    if (!box) { box = document.createElement('span'); box.id = 'pia-slotchips'; box.setAttribute('aria-label', _T('면담 주제', 'Interview topics')); box.style.cssText = 'display:inline-flex;align-items:center;flex:none;margin-left:auto'; top.appendChild(box); }
    box.innerHTML = window.piaChatTrust.renderChips((state.results.conv && state.results.conv.transcript) || [], { T: _T, iconBase: '/images/ill/' });
  } catch (e) { console.error('[자유대화] 주제 칩 표시 실패', e); }
}
window.piaRenderSlotChips = piaRenderSlotChips;
/* 결과지 카드: 원문 없이 정리된 낱말만(학생·학부모·선생님 공통) */
function renderConvSummaryCard() {
  try {
    const cs = state.results.conv && state.results.conv.summary;
    if (!cs) return '';
    const chip = function (x) { return '<span style="display:inline-block;margin:2px 4px 2px 0;padding:3px 10px;border-radius:999px;background:#eef2ff;color:#3730a3;font-size:12.5px">' + _escHtml(x) + '</span>'; };
    const row = function (label, arr) { return arr && arr.length ? '<div class="mb-2"><div class="text-xs text-slate-500 mb-1">' + label + '</div>' + arr.map(chip).join('') + '</div>' : ''; };
    const body = row(_T('좋아하는 것·관심사', 'Interests'), cs.interests) + row(_T('잘하거나 꾸준히 하는 것', 'Strengths'), cs.strengths) + row(_T('해 보고 싶은 것', 'Wants to try'), cs.wants);
    if (!body) return '';
    return '<div class="bg-white rounded-2xl border border-slate-200 p-4">'
      + '<h3 class="font-semibold text-sm mb-3">' + _T('AI 대화에서 보인 관심·강점', 'Interests & strengths from the AI conversation') + '</h3>'
      /* [2026-11-02] 대화 신뢰성 ③ — 근거 없는 한 줄 AI 문장(cs.line)은 싣지 않는다. 학생 말에서 고른 낱말만 */
      + body
      + '<p class="text-xs text-slate-500 mt-2">' + _T('학생이 대화에서 직접 말한 내용을 AI가 짧게 정리한 것입니다. 대화 원문은 포함하지 않으며, 진단이나 평가가 아닙니다.', 'A short AI summary of what the student said. It contains no verbatim quotes and is not an evaluation.') + '</p></div>';
  } catch (e) { console.error('[결과지] 대화 정리 카드 실패', e); return ''; }
}

function scoreConvDims(text) {
  const dims = {};
  const map = {
    창의:['상상','아이디어','새로','만들','그림','캐릭터','창작'],
    분석:['이유','왜냐','분석','구조','원리','정답','계산'],
    공감:['친구','마음','감정','이해','함께','같이','도와'],
    실천:['해볼','시도','직접','바로','지금','실천'],
    탐구:['궁금','왜','어떻게','연구','책','읽'],
    감성:['느낌','감정','서운','속상','기분'],
    계획:['계획','정리','순서','준비','단계'],
    관찰:['보다','지켜','관찰','조용','살피'],
    도전:['도전','경쟁','용기'],
    자유:['자유','마음대로','유연','즉흥'],
    현실:['현실','실제','오늘','구체'],
    책임:['책임','해야','맡은','약속','지키'],
    외향:['같이','놀','말','발표'],
    내향:['혼자','조용','쉬','집에','부담']
  };
  for (const [dim, kws] of Object.entries(map)) {
    dims[dim] = kws.reduce((s,k)=>s+(text.includes(k)?1:0),0);
  }
  return dims;
}

// =================================================================
//  UI rendering helpers
// =================================================================
function el(id) { return document.getElementById(id); }

// 결과지 상세 섹션을 details/summary 아코디언 카드로 감싸는 헬퍼.
// (2026-08-23 QA: 모바일 결과지 세로 길이 14887px 축소 — 내용은 그대로 두고 접기만 적용)
// bodyHtml이 비어있으면 아무것도 렌더링하지 않는다(빈 아코디언 방지).
function piaAcc(title, bodyHtml, opts) {
  if (!bodyHtml) return '';
  opts = opts || {};
  var openAttr = opts.open ? ' open' : '';
  var mtCls = (opts.mt === false) ? '' : ' mt-5';
  return '<details class="pia-acc' + mtCls + '"' + openAttr + '>'
    + '<summary class="pia-acc-sum bg-white rounded-2xl border border-slate-200 px-4 py-3 font-semibold text-sm text-slate-800 flex items-center justify-between gap-2">'
    + '<span>' + title + '</span><span class="pia-acc-caret text-slate-400 text-xs shrink-0">▸</span>'
    + '</summary>'
    + '<div class="pia-acc-body mt-2">' + bodyHtml + '</div>'
    + '</details>';
}

function showView(name) {
  /* [2026-10-10] 검사·결과 화면에 들어가면 Chart.js 를 미리 받아 둔다(첫 화면에서는 받지 않음) */
  try { if (/^(big5|riasec|riasec60|via|grit|cesd|phqa|gad|who5|rses|learn|mi|sjt|chat|result|fullreport)$/.test(name)) piaLoadChart(); } catch (e) {}
  document.querySelectorAll('section[data-view]').forEach(s => {
    s.classList.toggle('hidden', s.dataset.view !== name);
  });
  /* [2026-10-21] 12턴을 끝낸 상태로 AI 대화에 다시 들어오면 대화가 이어지지 않고 완료 화면이 보이게 한다(A1: 13/12). */
  if (name === 'chat') { try { if (typeof piaRenderSlotChips === 'function') piaRenderSlotChips(); } catch (e) {} }
  if (name === 'chat') { try { if (typeof window.piaChatEnforceDone === 'function') { window.piaChatEnforceDone(); setTimeout(window.piaChatEnforceDone, 450); } } catch (e) {} }
  /* [2026-09-17] 내장 AI 콜드 스타트 4초 줄이기.
   *
   * 예열은 페이지 로드 1.2초 뒤에 시작된다. 학생이 안내를 안 읽고 바로
   * 검사 시작 -> AI와 대화 시작을 누르면 예열이 안 끝난 채 첫 턴이 들어가
   * 4초를 기다린다. 화면이 바뀔 때마다 한 번 더 찔러 두면 대화에 닿기
   * 전 어느 시점엔가는 끝나 있다. 이미 예열됐으면 키가 같아 즉시 반환
   * 하므로 비용이 없다. */
  try {
    if (name !== 'chat' && typeof piaWarmBrowserAI === 'function' && typeof buildSystemPrompt === 'function') {
      var _sysW = _piaLMKeyOf(buildSystemPrompt('OPENING', ''));
      if (_sysW) piaWarmBrowserAI(_sysW);
    }
  } catch(e) {}
  /* 자유대화를 벗어나면 마이크·음성을 완전히 끈다 (스트림만 놓으면 인식기가 계속 산다) */
  try { if (name !== 'chat' && typeof window.piaStopMic === 'function') window.piaStopMic('leave:'+name);
        else if (name !== 'chat' && typeof releaseMicStream === 'function') releaseMicStream(); } catch(e) {}
  document.querySelectorAll('#topNav button').forEach(btn => {
    btn.setAttribute('aria-pressed', btn.dataset.go === name);
  });
  if (name === 'big5') renderBig5();
  if (name === 'riasec') renderRiasec();
  if (name === 'via') renderVia();
  if (name === 'grit') renderGrit();
  if (name === 'cesd') renderCesd();
  if (name === 'phqa') renderPhqa();
  if (name === 'gad') renderGad();
  if (name === 'who5') renderWho5();
  if (name === 'rses') renderRses();
  if (name === 'learn') renderLearn();
  if (name === 'mi') renderMi();
  if (name === 'riasec60') renderRiasec60();
  if (name === 'sjt') renderSjt();
  if (name === 'result') renderResult();
  if (name === 'fullreport') { document.getElementById('btn-fullreport-nav').classList.remove('hidden'); }
}

// =================================================================
//  Generic Likert renderer (검사 모듈)
// =================================================================
// ===== 나이/난이도 맞춤 — 쉬운 말 모드 =====
const EASY_GLOSSARY = {
  '대체로':'보통','경향':'편','융통성':'유연함','즉흥적':'그때그때','체계적':'차근차근',
  '객관적':'있는 그대로','신중하게':'조심스럽게','발휘':'잘 발휘','추구':'좇는','인내':'참고 버티기',
  '희망적':'기대되는','협력':'같이 하기','관찰':'잘 살펴보기','적성':'잘 맞는 것','가치관':'중요하게 여기는 것'
};
function applyEasy(text){
  if(!text) return text;
  if(!(state.cfg && state.cfg.easy)) return text;
  let t = String(text);
  for(const k in EASY_GLOSSARY){ t = t.split(k).join(EASY_GLOSSARY[k]); }
  return t;
}
function easyControls(viewId){
  const g=(state.cfg&&state.cfg.grade)||'mid', e=!!(state.cfg&&state.cfg.easy);
  return `<div class="flex flex-wrap items-center justify-end gap-2 mb-3 text-xs">
    <span class="text-slate-400">읽기 난이도</span>
    <select data-act-change="setGrade" data-arg-value class="border border-slate-200 rounded px-2 py-1 text-xs">
      <option value="elem"${g==='elem'?' selected':''} data-i18n="grade.elem">초등</option>
      <option value="mid"${g==='mid'?' selected':''} data-i18n="grade.mid">중등</option>
      <option value="high"${g==='high'?' selected':''} data-i18n="grade.high">고등</option>
      <option value="univ"${g==='univ'?' selected':''} data-i18n="grade.univ">대학생</option>
      <option value="adult"${g==='adult'?' selected':''} data-i18n="grade.adult">일반인</option>
    </select>
    <button type="button" data-act="toggleEasy" class="px-2 py-1 rounded border ${e?'bg-emerald-600 text-white border-emerald-600':'border-slate-300 text-slate-600'}">쉬운 말 ${e?'ON':'OFF'}</button>
    <button type="button" data-act="aiSimplify" data-arg="${viewId}" class="px-2 py-1 rounded bg-violet-100 text-violet-900">🧒 더 쉽게(AI)</button>
  </div>`;
}
function setGrade(v){ state.cfg = Object.assign({}, state.cfg, { grade:v }); save(); rerenderActiveTest(); }
function toggleEasy(){ state.cfg = Object.assign({}, state.cfg, { easy: !(state.cfg&&state.cfg.easy) }); save(); rerenderActiveTest(); }
function rerenderActiveTest(){
  const map = { big5:renderBig5, riasec:renderRiasec, via:renderVia, grit:renderGrit, cesd:renderCesd, phqa:renderPhqa, gad:renderGad, who5:renderWho5, rses:renderRses, sjt:renderSjt };
  for(const v in map){ const sec=document.querySelector('section[data-view="'+v+'"]'); if(sec && !sec.classList.contains('hidden')){ try{ map[v](); }catch(e){} return; } }
}
async function aiSimplify(viewId){
  const cont = el(viewId+'-content'); if(!cont) return;
  const qel = cont.querySelector('.js-qtext'); if(!qel) return;
  const orig = qel.getAttribute('data-orig') || qel.textContent;
  qel.setAttribute('data-orig', orig);
  const gradeWord = {elem:'초등학생',mid:'중학생',high:'고등학생'}[(state.cfg&&state.cfg.grade)||'mid'];
  const prev = qel.textContent;
  qel.textContent = '쉽게 바꾸는 중…';
  const sys = '너는 검사 문항을 더 쉬운 한국어로 바꿔주는 도우미야. 뜻은 그대로 유지하고 어려운 단어만 쉬운 말로 바꿔. 따옴표·설명 없이 바뀐 문장만 한국어로 한 줄로.';
  let out = null;
  try { out = await callLLMFree(orig + '\n\n위 문장을 ' + gradeWord + '도 바로 이해할 수 있게 아주 쉬운 말로 바꿔줘.', sys); } catch(e){ out = null; }
  var _ok = out && out.trim() && (typeof _isKoreanReply!=='function' || _isKoreanReply(out.trim()));
  qel.textContent = _ok ? out.trim().replace(/^["'\s]+|["'\s]+$/g,'') : prev;
}

var DATASET_EN = {
  "big5": [
    "I tend to liven up the mood at gatherings.",
    "I don't worry much about other people.",
    "I prepare things in advance, whatever the task.",
    "I get stressed out easily.",
    "I have a rich vocabulary.",
    "I don't talk a lot.",
    "I am interested in people.",
    "I leave my belongings scattered around.",
    "I am generally relaxed.",
    "I have difficulty understanding abstract ideas.",
    "I feel comfortable around people.",
    "I sometimes say things that hurt others.",
    "I pay attention to even the smallest details.",
    "I worry about many different things.",
    "I have a vivid imagination.",
    "I tend to stay in the background rather than take the lead.",
    "I empathize easily with others' feelings.",
    "I tend to leave things messy and unfinished.",
    "I rarely feel down.",
    "I am not interested in abstract ideas.",
    "I start conversations first.",
    "I am not concerned about other people's problems.",
    "I do what needs to be done right away, without putting it off.",
    "I get easily upset, even over small things.",
    "I often come up with good ideas.",
    "I often can't think of anything to say.",
    "I feel for people who are going through hard times.",
    "I often forget to put things back where they belong.",
    "I get upset easily.",
    "I find it hard to picture new things in my mind.",
    "I talk to many different people at gatherings.",
    "I am not really interested in others.",
    "I like things to be neat and organized.",
    "My mood changes often.",
    "I tend to understand things quickly.",
    "I dislike being the center of attention.",
    "I take time out for others.",
    "I shirk my duties.",
    "I have frequent mood swings.",
    "I use difficult words well.",
    "I don't mind being in the spotlight.",
    "I am quick to notice how others are feeling.",
    "I stick to a set schedule.",
    "I get irritated easily.",
    "I enjoy thinking things through carefully.",
    "I become quiet around people I don't know.",
    "I make people feel at ease.",
    "I am exacting in my work.",
    "I often feel down for no clear reason.",
    "My head is full of ideas."
  ],
  "riasec": [
    "I enjoy working with machines or tools.",
    "I enjoy being active outdoors.",
    "I find it enjoyable to make things with my hands.",
    "Sports and physical activity suit me well.",
    "I'm curious about how machines work.",
    "I find solving science or math problems fun.",
    "I like figuring out the causes of complex phenomena.",
    "I enjoy reading and gaining new knowledge.",
    "I'm interested in experiments and research activities.",
    "I'm good at analyzing things logically.",
    "I enjoy creative activities like art, design, or music.",
    "I enjoy coming up with original ideas.",
    "I find writing or storytelling fun.",
    "I like work where I can express a sense of style or beauty.",
    "I prefer trying new things over sticking to tradition.",
    "I find it rewarding to help other people.",
    "I'm good at listening to my friends' worries.",
    "I enjoy teaching people things.",
    "I prefer working cooperatively in a team.",
    "I'm interested in community service.",
    "Leading people and making decisions suits me well.",
    "Winning a competition motivates me.",
    "I speak up confidently in presentations or debates.",
    "I come up with ideas for new ventures or projects.",
    "I'm willing to take risks and try new challenges.",
    "I tend to follow set rules and plans closely.",
    "Organizing numbers or data suits me well.",
    "I handle small details accurately.",
    "I prefer steady, routine work.",
    "I manage my schedule in a systematic way."
  ],
  "via": [
    "I come up with new ideas easily.",
    "I'm very curious about new things.",
    "I look at things from different angles before deciding.",
    "I enjoy learning new things.",
    "I give good advice when a friend is struggling.",
    "I stand up for what I believe is right, even when it's hard.",
    "I see things through to the end, even when it's difficult.",
    "I always tell the truth.",
    "I'm lively and full of energy.",
    "I cherish my family and friends.",
    "I'm good at helping others.",
    "I'm good at reading how people feel.",
    "I work well with others as a team.",
    "I treat everyone equally.",
    "Leading others suits me well.",
    "I know how to forgive someone when they make a mistake.",
    "I tend to be humble rather than boastful.",
    "I think things through before I act.",
    "I manage my emotions well.",
    "I'm easily moved by beautiful things.",
    "I often feel grateful, even for small things.",
    "I believe the future will get better.",
    "I'm good at making people laugh.",
    "I often think about the meaning of life."
  ],
  "grit": [
    "New projects sometimes distract me from previous ones.",
    "I have been obsessed with a certain idea or project for a short time but later lost interest.",
    "Setbacks don't discourage me.",
    "I am a hard worker.",
    "I often set a goal but later pursue a different one.",
    "I have difficulty maintaining my focus on projects that take more than a few months.",
    "I finish whatever I begin.",
    "I am diligent."
  ],
  "cesd": [
    "I was bothered by things that usually don't bother me.",
    "I had a poor appetite.",
    "I felt that I could not shake off feeling down, even with help from family or friends.",
    "I felt that I was just as good as other people.",
    "I had trouble keeping my mind on what I was doing.",
    "I felt depressed.",
    "Everything I did felt like an effort.",
    "I felt hopeful about the future.",
    "I felt that my life had been a failure.",
    "I felt fearful."
  ],
  "phqa": [
    "I had little interest or pleasure in doing things.",
    "I felt down, depressed, or hopeless.",
    "I had trouble falling asleep, staying asleep, or slept too much.",
    "I felt tired or had little energy.",
    "I had poor appetite or overate.",
    "I felt like a failure or blamed myself.",
    "I had trouble concentrating (e.g., on schoolwork or watching TV).",
    "I moved or spoke so slowly that others noticed, or the opposite — I was so restless I couldn't sit still.",
    "I had thoughts that I would be better off dead, or thoughts of hurting myself."
  ],
  "gad": [
    "I felt nervous, anxious, or on edge.",
    "I couldn't stop or control worrying.",
    "I worried too much about different things.",
    "I had trouble relaxing.",
    "I was so restless that it was hard to sit still.",
    "I became easily annoyed or irritable.",
    "I felt afraid, as if something awful might happen."
  ],
  "who5": [
    "I have felt cheerful and in good spirits.",
    "I have felt calm and relaxed.",
    "I have felt active and vigorous.",
    "I woke up feeling fresh and rested.",
    "My daily life has been filled with things that interest me."
  ],
  "rses": [
    "I feel that I am a person of worth, at least on an equal plane with others.",
    "I feel that I don't have many good qualities.",
    "I generally don't think of myself as a failure.",
    "I am able to do things as well as most other people.",
    "I feel that I don't have much to be proud of.",
    "I sometimes feel that I am useless.",
    "I feel that I am at least as good as other people.",
    "I wish I could have more respect for myself.",
    "I sometimes feel that I am really useless.",
    "I have a positive attitude toward myself."
  ],
  "learn": [
    "I understand what I read well.",
    "I express my thoughts well in writing.",
    "I'm good at solving math problems.",
    "I find working with numbers, rules, and logic fun.",
    "I understand the meaning of English sentences well.",
    "I'm confident speaking or writing in English.",
    "I'm interested in history and social issues.",
    "I understand and remember social studies and current events well.",
    "I enjoy understanding scientific principles.",
    "I'm good at experiments and observation activities.",
    "I have a talent for artistic activities like drawing or music.",
    "I enjoy artistic activities like art and music.",
    "I'm good at physical activities and sports.",
    "I enjoy sports and physical activity and feel confident doing them."
  ],
  "mi": [
    "I express my thoughts well, whether speaking or writing.",
    "I enjoy learning new words and expressions.",
    "I'm good at solving problems involving numbers, rules, or logic.",
    "I like thinking through cause and effect.",
    "I can easily picture images, maps, and shapes in my mind.",
    "I remember directions and spatial layouts well.",
    "I have a good sense for rhythm and melody and remember them well.",
    "I enjoy singing or playing an instrument.",
    "I'm good at physical activities and sports.",
    "I'm good at making or handling things with my hands.",
    "I'm quick to notice how my friends feel and get along well with them.",
    "I enjoy cooperating with many different people.",
    "I understand my own feelings and thoughts well.",
    "I take quiet time alone to reflect.",
    "I'm very interested in animals, plants, and natural phenomena.",
    "I enjoy observing and classifying things in nature."
  ]
};
var LIKERT5_EN = ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"];
var LIKERT4_EN = ["Not at all", "Several days", "More than half the days", "Nearly every day"];
var CESD_SCALE_EN = ["Rarely or none of the time (less than 1 day)", "Some or a little of the time (1-2 days)", "Occasionally or a moderate amount of time (3-4 days)", "Most or all of the time (5-7 days)"];
var WHO5_SCALE_EN = ["Never", "Rarely", "Sometimes", "Often", "Most of the time", "Always"];
var RSES_SCALE_EN = ["Strongly Disagree", "Disagree", "Agree", "Strongly Agree"];
function _piaScaleEn(scale){
  if (window.aipiaCurrentLang !== 'en') return scale;
  if (scale === LIKERT5) return LIKERT5_EN;
  if (scale === LIKERT4) return LIKERT4_EN;
  if (scale === CESD_SCALE) return CESD_SCALE_EN;
  if (scale === WHO5_SCALE) return WHO5_SCALE_EN;
  if (scale === RSES_SCALE) return RSES_SCALE_EN;
  if (typeof IP60_SCALE !== 'undefined' && scale === IP60_SCALE) return IP60_SCALE_EN;
  return scale;
}
function makeLikertRenderer(viewId, dataset, stateKey, scale, hasReverse) {
  // D: 비임상 검사만 문항 표시 순서를 셔플(채점 불변 — answers는 원래 인덱스 위치에 저장).
  var SHUFFLE_ITEMS = { big5:1, via:1, grit:1, learn:1, mi:1, riasec60:1 };
  function _ensureOrder() {
    var R = state.results[stateKey];
    if (!SHUFFLE_ITEMS[stateKey]) return null;
    if (!R.order || !R.order.length || R.order.length !== dataset.length) {
      var ord = dataset.map(function(_, i){ return i; });
      for (var z = ord.length - 1; z > 0; z--) { var r = Math.floor(Math.random()*(z+1)); var t = ord[z]; ord[z] = ord[r]; ord[r] = t; }
      R.order = ord;
      if (typeof R.seq !== 'number') R.seq = (R.answers ? R.answers.filter(function(a){return a!==undefined && a!==null;}).length : 0);
      save();
    }
    if (typeof R.seq !== 'number') R.seq = 0;
    return R.order;
  }
  function _answeredCount() {
    var R = state.results[stateKey];
    if (SHUFFLE_ITEMS[stateKey]) { _ensureOrder(); return R.seq || 0; }
    return R.answers.length;
  }
  return function render() {
    const container = el(viewId + '-content');
    if (!state.results[stateKey]) state.results[stateKey] = { answers:[], scores:null };   /* 예전 기록에 없는 검사(흥미 심화 등) */
    const R = state.results[stateKey];
    const answers = R.answers;
    const total = dataset.length;
    const order = _ensureOrder();
    const current = _answeredCount();
    if (stateKey === 'riasec60' && current < total && piaIp60Gate(container, current)) return;   /* [E2-A] 시작 안내·쉬는 화면 */

    if (current >= total) {
      // 완료 화면
      const scoreFn = window['score' + viewId.charAt(0).toUpperCase() + viewId.slice(1)];
      if (scoreFn) state.results[stateKey].scores = scoreFn();
      if (stateKey === 'riasec60') state.results[stateKey].version = PIA_IP60_VERSION;
      save();
      try{ if(window._piaCheckAllDone) window._piaCheckAllDone(); }catch(_e){}
      var P0 = window.PIA;
      var _reset = "if(!confirm('\uC774 \uAC80\uC0AC\uB97C \uB2E4\uC2DC \uD558\uC2DC\uACA0\uC5B4\uC694? \uC774 \uAC80\uC0AC \uB2F5\uC548\uC774 \uCD08\uAE30\uD654\uB429\uB2C8\uB2E4.'))return; state.results['" + stateKey + "'].answers=[];"
                 + "state.results['" + stateKey + "'].order=null;"
                 + "state.results['" + stateKey + "'].seq=0; save();"
                 + "if(window.renderHome)renderHome(); showView('" + viewId + "')";
      /* [2026-08-22] 완료 표기 + 다음 검사로 바로 이어가기.
         예전엔 '검사 메뉴로'만 있어서 학생이 다음에 뭐를 할지 스스로 찾아야 했다.
         남은 필수 검사를 먼저 권하고, 필수를 다 마쳤으면 결과지로 안내한다. */
      var _pld = (window.aipiaCurrentLang === 'en');
      var _nextId = '', _nextLabel = '';
      try{
        var _REQ = [
          { id:'chat',   label:_pld?'AI Chat':'AI 자유대화', done:function(){ return (state.results.conv&&state.results.conv.turns||0) >= 12; } },
          { id:'big5',   label:_pld?'Personality Test (Big5)':'성격검사(Big5)', done:function(){ return ((state.results.big5&&state.results.big5.answers)||[]).filter(function(x){return x!=null;}).length >= 50; } },
          { id:'riasec', label:_pld?'Career Interests (RIASEC)':'진로흥미(RIASEC)', done:function(){ return ((state.results.riasec&&state.results.riasec.answers)||[]).filter(function(x){return x!=null;}).length >= 30; } }
        ];
        for (var _qi=0; _qi<_REQ.length; _qi++){ if(!_REQ[_qi].done()){ _nextId=_REQ[_qi].id; _nextLabel=_REQ[_qi].label; break; } }
      }catch(_e){}
      var _nextBtn = _nextId
        ? P0.btn((_pld?'Next: ':'다음: ') + _nextLabel + ' \u2192', "showView('" + _nextId + "')", 'primary', {cta:1, arrow:1})
        : P0.btn((_pld?'View Full Report \u2192':'통합 결과 보기 →'), "showView('result')", 'primary', {cta:1, arrow:1});
      var _doneMsg = _nextId
        ? (_pld ? ('Great job! Let\'s move on to <b>' + _nextLabel + '</b>.') : ('잘했어요! 이어서 <b>' + _nextLabel + '</b>'+_piaJ(_nextLabel,'을','를')+' 진행해 주세요.'))
        : (_pld ? 'You\'ve finished all the required assessments! You can now view your report.' : '필수 검사를 모두 마쳤어요! 이제 결과지를 볼 수 있어요.');
      container.innerHTML = piaDoneHTML({
        제목: _pld ? ('You\'ve finished all ' + total + ' questions') : (total + '문항을 모두 마쳤어요'),
        부제: _nextId ? (_pld ? ('Up next: ' + _nextLabel) : ('이어서 ' + _nextLabel + ' 차례예요')) : (_pld ? 'You\'ve finished all required assessments' : '필수 검사를 모두 마쳤어요'),
        안내: _nextId ? (_pld ? 'Nice work! Take your time with the rest.' : '잘했어요! 남은 검사도 편하게 진행해 주세요.') : (_pld ? 'You can now view your full report.' : '이제 통합 결과지를 볼 수 있어요.'),
        다음id: _nextId, 다음라벨: _nextLabel
      });
      var _autoNextTarget = _nextId || 'result';
      setTimeout(function(){
        try{
          var _sec = document.querySelector('section[data-view="' + viewId + '"]');
          if (_sec && !_sec.classList.contains('hidden') && container.querySelector('.pia-done__ic')) {
            showView(_autoNextTarget);
          }
        }catch(_e){}
      }, 2500);
      return;
    }

    // 표시 문항: 셔플 검사는 order[seq] 인덱스, 그 외는 순차
    const dataIdx = order ? order[current] : current;
    const item = dataset[dataIdx];
    const pct = Math.round((current/total)*100);
    container.innerHTML = (function(){
      var META={
        big5:{step:'필수 검사 2/3',title:'나의 성격',sub:'평소의 나와 가장 가까운 답을 선택해 주세요.',back:'이전 단계',backAct:"showView('chat')"},
        riasec:{step:'필수 검사 3/3',title:'진로 흥미 검사',sub:'어떤 활동에 관심이 있고 즐거운지 알아볼까요?',note:'RIASEC 기반 검사',guide:'얼마나 관심 있고 즐거울 것 같은지 선택해 주세요.',guideIcon:'compass',back:'이전 단계',backAct:"showView('big5')",face:1,split:1},
        via:{step:'선택 검사',title:'나의 강점',sub:'나와 가까운 답을 선택해 주세요.',back:'홈',backAct:"showView('home')"},
        grit:{step:'선택 검사',title:'끈기·근면',sub:'나와 가까운 답을 선택해 주세요.',back:'홈',backAct:"showView('home')"},
        learn:{step:'선택 검사',title:'학습 역량',sub:'과목별로 나와 가까운 답을 선택해 주세요.',back:'홈',backAct:"showView('home')"},
        mi:{step:'선택 검사',title:'다중지능',sub:'나와 가까운 답을 선택해 주세요.',back:'홈',backAct:"showView('home')"},
        rses:{step:'선택 검사',title:'자존감',sub:'나와 가까운 답을 선택해 주세요.',back:'홈',backAct:"showView('home')"},
        riasec60:{step:'선택 검사 · 시범',title:'흥미 심화(시범)',sub:'이런 활동을 하는 것이 얼마나 좋은지 골라 주세요.',guide:'교육 기간이나 수입은 생각하지 말고, 그 활동 자체가 좋은지 싫은지만 골라 주세요.',guideIcon:'compass',back:'홈',backAct:"showView('home')"},
        cesd:{step:'마음 건강',title:'마음 살펴보기',sub:'지난 1주일을 떠올리며 답해주세요.',back:'홈',backAct:"showView('home')"},
        phqa:{step:'마음 건강',title:'마음 살펴보기',sub:'지난 2주일을 떠올리며 답해주세요.',back:'홈',backAct:"showView('home')"},
        gad:{step:'마음 건강',title:'마음 살펴보기',sub:'지난 2주일을 떠올리며 답해주세요.',back:'홈',backAct:"showView('home')"},
        who5:{step:'마음 건강',title:'요즘 나의 상태',sub:'지난 2주일을 떠올리며 답해주세요.',back:'홈',backAct:"showView('home')"}
      };
      var META_EN={
        big5:{step:'Required 2/3',title:'My Personality',sub:'Choose the answer closest to who you usually are.',back:'Previous Step'},
        riasec:{step:'Required 3/3',title:'Career Interest Test',sub:'Let\'s see what activities interest and excite you.',note:'RIASEC-based assessment',guide:'Choose how interesting and enjoyable each activity would be.',back:'Previous Step'},
        via:{step:'Optional',title:'My Strengths',sub:'Choose the answer closest to you.',back:'Home'},
        grit:{step:'Optional',title:'Grit & Diligence',sub:'Choose the answer closest to you.',back:'Home'},
        learn:{step:'Optional',title:'Learning Aptitude',sub:'Choose the answer closest to you for each subject.',back:'Home'},
        mi:{step:'Optional',title:'Multiple Intelligences',sub:'Choose the answer closest to you.',back:'Home'},
        rses:{step:'Optional',title:'Self-Esteem',sub:'Choose the answer closest to you.',back:'Home'},
        riasec60:{step:'Optional · Pilot',title:'Deeper Interests (Pilot)',sub:'How much would you like doing each activity?',guide:'Don\'t think about training or pay \u2014 just how much you would like or dislike the activity itself.',back:'Home'},
        cesd:{step:'Emotional Health',title:'Checking In With Yourself',sub:'Think back over the past week and answer.',back:'Home'},
        phqa:{step:'Emotional Health',title:'Checking In With Yourself',sub:'Think back over the past 2 weeks and answer.',back:'Home'},
        gad:{step:'Emotional Health',title:'Checking In With Yourself',sub:'Think back over the past 2 weeks and answer.',back:'Home'},
        who5:{step:'Emotional Health',title:'How I\'ve Been Lately',sub:'Think back over the past 2 weeks and answer.',back:'Home'}
      };
      var M=META[viewId]||{step:'검사',title:viewId,sub:'',back:'홈',backAct:"showView('home')"};
      if (window.aipiaCurrentLang === 'en' && META_EN[viewId]) { M = Object.assign({}, M, META_EN[viewId]); }
      var _plq = (window.aipiaCurrentLang === 'en');
      var P=window.PIA;
      var prevAct="(function(){var _R=state.results['"+stateKey+"'];if("+(order?1:0)+"){if((_R.seq||0)>0){_R.seq--;var _di=_R.order[_R.seq];_R.answers[_di]=undefined;}}else{_R.answers.pop();}save();render"+viewId.charAt(0).toUpperCase()+viewId.slice(1)+"();})()";
      return '<div class="pia">'
        + P.back(M.back, M.backAct)
        + '<div style="margin-bottom:var(--pia-s3)">' + P.badge(M.step) + '</div>'
        + '<h2 class="pia-h1" style="margin-bottom:var(--pia-s2)">'+M.title+'</h2>'
        + '<p class="pia-bodyL pia-muted">'+M.sub+'</p>'
        + (M.note?'<p class="pia-cap" style="margin-top:6px">'+M.note+'</p>':'')
        + '<div style="height:var(--pia-s4)"></div>'
        + P.progress((_plq?'Question':'문항'), current+1, total, {pct: M.pct!==false})
        + (M.guide?'<p class="pia-note pia-note--card" style="margin-bottom:var(--pia-s3)">'+P.icon(M.guideIcon||'help')+M.guide+'</p>':'')
        + ((current===0 && !M.guide)?'<p class="pia-note pia-note--card" style="margin-bottom:var(--pia-s3)">'+P.icon('help')+(_plq?'There are no right or wrong answers \u2014 answering honestly gives the most accurate results.':'정답은 없어요. 솔직하게 답할수록 결과가 정확해져요.')+'</p>':'')
        + '<section class="pia-sec pia-sec--qa">'
        + '<p class="pia-q js-qtext" data-orig="" aria-live="polite" style="text-align:center;margin-bottom:var(--pia-s5)">'+applyEasy((window.aipiaCurrentLang==='en' && DATASET_EN[viewId] && DATASET_EN[viewId][dataIdx]!==undefined) ? DATASET_EN[viewId][dataIdx] : (item.t || item))+'</p>'
        + '<div class="pia-choices" role="radiogroup" aria-label="'+(_plq?'Select an answer':'답변 선택')+'" id="choices-'+viewId+'"></div>'
        + P.fab([ P.btn((_plq?'Previous':'이전'), prevAct, 'secondary', {disabled: current===0}) ])
        /* 시안은 '자동 저장됨' 대신 다음 동작을 알려준다.
           문항 화면에서 학생이 궁금한 건 '내 답이 저장됐나'가 아니라
           '고르면 어떻게 되나'이다. */
        + '<p class="pia-autonext">'+P.icon('clock')+(_plq?'Choosing an answer will automatically move you to the next question.':'답변을 선택하면 자동으로 다음 문항으로 넘어가요.')+'</p>'
        + '</section></div>';
    })();
    const cc = el('choices-' + viewId);
    /* [2026-10-21] 보기 순서는 항상 고정(전혀 그렇지 않다 → 매우 그렇다).
       예전에는 LIKERT5 보기를 문항마다 섞었는데(보통/그렇지 않다/매우 그렇다/전혀…) 키오스크 시연에서
       문항마다 위치가 바뀌어 읽고 고르기 어렵다는 결함으로 확인됐다. 각 버튼은 원래 점수값(val)을 저장하므로 채점은 그대로. */
    var _scaleForDisplay = _piaScaleEn(scale);
    var _opts = scale.map(function(label, i){ return { label: _scaleForDisplay[i], val: (i + ((scale === LIKERT4 || scale === CESD_SCALE || scale === IP60_SCALE) ? 0 : 1)) }; });
    _opts.forEach(function(o){
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pia-choice';
      btn.setAttribute('role','radio');
      btn.setAttribute('aria-checked','false');
      btn.setAttribute('data-val', o.val);
      var faceHtml = (viewId==='riasec' && window.PIA_FACE) ? (window.PIA_FACE(o.val)||'') : (viewId==='riasec60' && window.PIA_FACE) ? (window.PIA_FACE(o.val+1)||'') : '';
      btn.innerHTML = '<span class="pia-choice__radio" aria-hidden="true"></span>'
        + faceHtml
        + '<span class="pia-choice__txt"></span>'
        + '<span class="pia-choice__ck" aria-hidden="true">\u2713</span>';
      btn.querySelector('.pia-choice__txt').textContent = o.label;
      btn.addEventListener('click', function(){
        try{
          var _sib = cc.querySelectorAll('.pia-choice');
          for(var _i=0;_i<_sib.length;_i++) _sib[_i].setAttribute('aria-checked','false');
          btn.setAttribute('aria-checked','true');
        }catch(_e){}
        var _R = state.results[stateKey];
        /* [E2-D] 성격 검사를 새로 시작할 때만 지금 문항 키 판을 붙인다(답이 하나라도 있던 예전 묶음은 예전 키 유지) */
        if (stateKey === 'big5' && !_R.kv && !(_R.answers || []).some(function(x){ return x !== undefined && x !== null; })) _R.kv = PIA_BIG5_KV;
        if (order) {
          // D: 표시 순서 무관하게 원래 dataset 인덱스 위치에 저장
          var di = _R.order[_R.seq];
          _R.answers[di] = o.val;
          _R.seq = (_R.seq || 0) + 1;
        } else {
          _R.answers.push(o.val);
        }
        save();
        render();
      });
      cc.appendChild(btn);
    });
    try{ if(current>0){ var _q=container.querySelector('.js-qtext'); if(_q){ _q.setAttribute('tabindex','-1'); _q.focus(); } } }catch(e){}
  };
}

// WHO-5 웰빙 지수 (무료, WHO) — 지난 2주, 0~5 빈도(6점)
const WHO5 = [
  '나는 밝고 기분이 좋았다.',
  '나는 차분하고 편안했다.',
  '나는 활기차고 기운이 넘쳤다.',
  '나는 푹 자고 상쾌하게 일어났다.',
  '나의 일상은 흥미로운 일로 채워졌다.'
];
const WHO5_SCALE = ['전혀 그렇지 않았다','가끔 그랬다','종종 그랬다','자주 그랬다','대부분 그랬다','항상 그랬다'];
// Rosenberg 자존감 척도(RSES, 공개) — 1~4, 5문항 역채점
const RSES = [
  { s: 1, t:'나는 내가 적어도 다른 사람만큼은 가치 있는 사람이라고 느낀다.' },
  { s:-1, t:'나는 좋은 점이 별로 없다고 느낀다.' },
  { s: 1, t:'나는 대체로 내가 실패자라고 생각하지 않는다.' },
  { s: 1, t:'나는 다른 사람들만큼 일을 잘할 수 있다.' },
  { s:-1, t:'나는 자랑할 만한 것이 별로 없다고 느낀다.' },
  { s:-1, t:'나는 때때로 내가 쓸모없다고 느낀다.' },
  { s: 1, t:'나는 적어도 남들만큼은 괜찮은 사람이라고 느낀다.' },
  { s:-1, t:'나는 나 자신을 좀 더 존중할 수 있으면 좋겠다.' },
  { s:-1, t:'나는 가끔 내가 정말 쓸모없다고 느낀다.' },
  { s: 1, t:'나는 나 자신에 대해 긍정적인 태도를 가지고 있다.' }
];
const RSES_SCALE = ['전혀 그렇지 않다','그렇지 않다','그렇다','매우 그렇다'];

// 과목별 학습역량 자가검사 (흥미·자신감) — 7과목 ×2문항
const LEARN_ITEMS = [
  { f:'korean',  t:'글이나 책을 읽고 내용을 잘 이해한다.' },
  { f:'korean',  t:'내 생각을 글로 잘 표현한다.' },
  { f:'math',    t:'수학 문제를 잘 푸는 편이다.' },
  { f:'math',    t:'숫자·규칙·논리를 다루는 것이 재미있다.' },
  { f:'english', t:'영어 문장을 읽고 뜻을 잘 파악한다.' },
  { f:'english', t:'영어로 말하거나 쓰는 것에 자신이 있다.' },
  { f:'social',  t:'역사·사회 현상에 흥미가 있다.' },
  { f:'social',  t:'사회·시사 내용을 잘 이해하고 기억한다.' },
  { f:'science', t:'과학 원리를 이해하는 것이 즐겁다.' },
  { f:'science', t:'실험·관찰 활동을 잘한다.' },
  { f:'arts',    t:'그림·음악 등 예술 활동에 소질이 있다.' },
  { f:'arts',    t:'예술(미술·음악) 활동이 즐겁다.' },
  { f:'pe',      t:'몸을 움직이는 활동·운동을 잘한다.' },
  { f:'pe',      t:'운동·신체활동이 즐겁고 자신 있다.' }
];

// 가드너 다중지능(MI) 8지능 자가검사 — 각 2문항
const MI_ITEMS = [
  { f:'verbal',        t:'말이나 글로 내 생각을 잘 표현한다.' },
  { f:'verbal',        t:'새로운 단어나 표현을 배우는 것이 즐겁다.' },
  { f:'logical',       t:'숫자·규칙·논리 문제를 잘 푼다.' },
  { f:'logical',       t:'원인과 결과를 따져 생각하는 것을 좋아한다.' },
  { f:'spatial',       t:'그림·지도·도형을 머릿속에 잘 떠올린다.' },
  { f:'spatial',       t:'길이나 공간 구조를 잘 기억한다.' },
  { f:'musical',       t:'리듬이나 멜로디를 잘 느끼고 기억한다.' },
  { f:'musical',       t:'노래하거나 악기 다루는 것을 좋아한다.' },
  { f:'bodily',        t:'몸을 쓰는 활동이나 운동을 잘한다.' },
  { f:'bodily',        t:'손으로 만들거나 조작하는 것을 잘한다.' },
  { f:'interpersonal', t:'친구의 기분을 잘 알아채고 잘 어울린다.' },
  { f:'interpersonal', t:'여러 사람과 협력하는 것을 좋아한다.' },
  { f:'intrapersonal', t:'내 감정과 생각을 잘 이해한다.' },
  { f:'intrapersonal', t:'혼자 차분히 돌아보는 시간을 갖는다.' },
  { f:'naturalist',    t:'동식물·자연 현상에 관심이 많다.' },
  { f:'naturalist',    t:'자연을 관찰하고 분류하는 것을 좋아한다.' }
];

const LIKERT5 = ['전혀 그렇지 않다','그렇지 않다','보통이다','그렇다','매우 그렇다'];
const LIKERT4 = ['전혀 아니다','며칠 동안','일주일 이상','거의 매일'];
// CES-D(지난 1주일)는 원척도가 '일수' 기준이라 별도 보기를 사용한다 — 채점은 인덱스 기반이라 점수 불변
const CESD_SCALE = ['극히 드물다 (하루 미만)','가끔 있었다 (1~2일)','종종 있었다 (3~4일)','대부분 그랬다 (5~7일)'];

const renderBig5 = makeLikertRenderer('big5', IPIP_BIG5_50, 'big5', LIKERT5, true);
const renderRiasec = makeLikertRenderer('riasec', RIASEC_30, 'riasec', LIKERT5, false);
const renderVia = makeLikertRenderer('via', VIA_YOUTH, 'via', LIKERT5, false);
const renderGrit = makeLikertRenderer('grit', GRIT_S, 'grit', LIKERT5, true);
const renderCesd = makeLikertRenderer('cesd', CES_D_10, 'cesd', CESD_SCALE, true);
const renderPhqa = makeLikertRenderer('phqa', PHQ_A, 'phqa', LIKERT4, false);
const renderGad = makeLikertRenderer('gad', GAD_7, 'gad', LIKERT4, false);
const renderWho5 = makeLikertRenderer('who5', WHO5, 'who5', WHO5_SCALE, false);
const renderRses = makeLikertRenderer('rses', RSES, 'rses', RSES_SCALE, true);
const renderLearn = makeLikertRenderer('learn', LEARN_ITEMS, 'learn', LIKERT5, false);
const renderMi = makeLikertRenderer('mi', MI_ITEMS, 'mi', LIKERT5, false);

// =================================================================
//  [2026-11-02 E2-A] 흥미 심화(시범) 60 — O*NET Interest Profiler Short Form 한국어 적응판 (OWNER 승인: 시범·선택)
//  원본 데이터: web/aipia/data/onet-ip-60.json (이 배열은 그 사본 — 서버 채점 키도 tools/extract-scoring-keys.mjs 가 여기서 뽑는다)
//  저장: state.results.riasec60 = { answers[60](0~4, 원래 번호 자리), order, seq, scores{R..C: 0~40}, version }
//  진로 추천·유형·교사 요약은 계속 진로 흥미(RIASEC 30)를 쓴다. 이 결과는 결과지 '흥미 심화(시범·참고)' 칸에만 싣는다.
//  라이선스: O*NET Tools Developer License — 검사 화면·결과지에 고지문(PIA_IP60_ATTR)을 싣는다.
// =================================================================
const ONET_IP60 = [
  { f:'R', t:'부엌 수납장 만들기', en:"Build kitchen cabinets" },
  { f:'R', t:'트럭을 운전해 회사와 집으로 택배 배달하기', en:"Drive a truck to deliver packages to offices and homes" },
  { f:'R', t:'벽돌 쌓기나 타일 붙이기', en:"Lay brick or tile" },
  { f:'R', t:'출고 전에 부품 품질 검사하기', en:"Test the quality of parts before shipment" },
  { f:'R', t:'가전제품 고치기', en:"Repair household appliances" },
  { f:'R', t:'도어록·자물쇠 고치고 설치하기', en:"Repair and install locks" },
  { f:'R', t:'양식장에서 물고기 기르기', en:"Raise fish in a fish hatchery" },
  { f:'R', t:'기계를 설치하고 작동해 제품 만들기', en:"Set up and operate machines to make products" },
  { f:'R', t:'전자 부품 조립하기', en:"Assemble electronic parts" },
  { f:'R', t:'산불 끄기', en:"Put out forest fires" },
  { f:'I', t:'새로운 약 개발하기', en:"Develop a new medicine" },
  { f:'I', t:'화재 원인 조사하기', en:"Investigate the cause of a fire" },
  { f:'I', t:'수질 오염을 줄이는 방법 연구하기', en:"Study ways to reduce water pollution" },
  { f:'I', t:'날씨를 더 정확하게 예측하는 방법 개발하기', en:"Develop a way to better predict the weather" },
  { f:'I', t:'화학 실험하기', en:"Conduct chemical experiments" },
  { f:'I', t:'생물학 실험실에서 일하기', en:"Work in a biology lab" },
  { f:'I', t:'행성의 움직임 연구하기', en:"Study the movement of planets" },
  { f:'I', t:'설탕을 대신할 감미료 발명하기', en:"Invent a replacement for sugar" },
  { f:'I', t:'현미경으로 혈액 샘플 관찰하기', en:"Examine blood samples using a microscope" },
  { f:'I', t:'질병을 찾아내는 실험실 검사하기', en:"Do laboratory tests to identify diseases" },
  { f:'A', t:'책이나 연극 대본 쓰기', en:"Write books or plays" },
  { f:'A', t:'연극 무대 배경 그리기', en:"Paint sets for plays" },
  { f:'A', t:'악기 연주하기', en:"Play a musical instrument" },
  { f:'A', t:'영화나 TV 프로그램 대본 쓰기', en:"Write scripts for movies or television shows" },
  { f:'A', t:'작곡하거나 편곡하기', en:"Compose or arrange music" },
  { f:'A', t:'무대에서 춤 공연하기(재즈댄스·탭댄스 등)', en:"Perform jazz or tap dance" },
  { f:'A', t:'그림 그리기', en:"Draw pictures" },
  { f:'A', t:'밴드에서 노래하기', en:"Sing in a band" },
  { f:'A', t:'영화 특수효과 만들기', en:"Create special effects for movies" },
  { f:'A', t:'영화 편집하기', en:"Edit movies" },
  { f:'S', t:'한 사람에게 맞춤 운동법 가르치기', en:"Teach an individual an exercise routine" },
  { f:'S', t:'어린이에게 운동 경기 가르치기', en:"Teach children how to play sports" },
  { f:'S', t:'개인적인 고민이나 마음의 어려움이 있는 사람 돕기', en:"Help people with personal or emotional problems" },
  { f:'S', t:'청각장애인에게 수어 가르치기', en:"Teach sign language to people who are deaf or hard of hearing" },
  { f:'S', t:'사람들에게 진로 상담해 주기', en:"Give career guidance to people" },
  { f:'S', t:'집단 상담 진행 돕기', en:"Help conduct a group therapy session" },
  { f:'S', t:'재활 치료하기', en:"Perform rehabilitation therapy" },
  { f:'S', t:'어린이집에서 아이들 돌보기', en:"Take care of children at a day-care center" },
  { f:'S', t:'비영리 단체에서 봉사활동하기', en:"Do volunteer work at a non-profit organization" },
  { f:'S', t:'고등학교에서 수업하기', en:"Teach a high-school class" },
  { f:'E', t:'주식과 채권 사고팔기', en:"Buy and sell stocks and bonds" },
  { f:'E', t:'사업 계약 협상하기', en:"Negotiate business contracts" },
  { f:'E', t:'매장 운영하기', en:"Manage a retail store" },
  { f:'E', t:'소송에서 의뢰인 변호하기', en:"Represent a client in a lawsuit" },
  { f:'E', t:'미용실이나 이발소 운영하기', en:"Operate a beauty salon or barber shop" },
  { f:'E', t:'새 의류 브랜드 마케팅하기', en:"Market a new line of clothing" },
  { f:'E', t:'큰 회사에서 한 부서 이끌기', en:"Manage a department within a large company" },
  { f:'E', t:'백화점에서 물건 판매하기', en:"Sell merchandise at a department store" },
  { f:'E', t:'내 사업 시작하기(창업)', en:"Start your own business" },
  { f:'E', t:'옷가게 운영하기', en:"Manage a clothing store" },
  { f:'C', t:'컴퓨터로 스프레드시트(엑셀 표) 만들기', en:"Develop a spreadsheet using computer software" },
  { f:'C', t:'직원 급여 계산하기', en:"Calculate the wages of employees" },
  { f:'C', t:'기록이나 서류의 틀린 곳 검토하기', en:"Proofread records or forms" },
  { f:'C', t:'휴대용 단말기로 물품 재고 조사하기', en:"Inventory supplies using a hand-held computer" },
  { f:'C', t:'회사 전체 컴퓨터에 프로그램 설치하기', en:"Install software across computers on a large network" },
  { f:'C', t:'월세 납부 기록하기', en:"Record rent payments" },
  { f:'C', t:'계산기로 계산하기', en:"Operate a calculator" },
  { f:'C', t:'재고 기록 관리하기', en:"Keep inventory records" },
  { f:'C', t:'물품 입출고 기록 관리하기', en:"Keep shipping and receiving records" },
  { f:'C', t:'회사 우편물 분류하고 나눠 주기', en:"Stamp, sort, and distribute mail for an organization" }
];
const IP60_SCALE = ['매우 싫다','싫다','잘 모르겠다','좋다','매우 좋다'];
var IP60_SCALE_EN = ['Strongly Dislike','Dislike','Unsure','Like','Strongly Like'];
const PIA_IP60_VERSION = 'onet-ip60-ko-2026.11.0';
const PIA_IP60_BREAK_AT = 30;
const PIA_IP60_ATTR = "This page includes information from the O*NET Career Exploration Tools by the U.S. Department of Labor, Employment and Training Administration (USDOL/ETA). Used under the O*NET Tools Developer License. O*NET® is a trademark of USDOL/ETA. ㈜예담정보통신 has modified all or some of this information. USDOL/ETA has not approved, endorsed, or tested these modifications.";
const PIA_IP60_ATTR_KO = "이 검사는 미국 노동부 고용훈련청(USDOL/ETA)의 O*NET Career Exploration Tools 정보를 포함하며 O*NET Tools Developer License 에 따라 사용합니다. O*NET® 은 USDOL/ETA 의 상표입니다. ㈜예담정보통신이 내용의 전부 또는 일부를 번역·수정했으며, USDOL/ETA 는 이 수정 사항을 승인·보증·검증하지 않았습니다.";
const PIA_IP60_LICENSE_URL = 'https://www.onetcenter.org/license_toolsdev.html';
try { DATASET_EN.riasec60 = ONET_IP60.map(function(x){ return x.en; }); } catch (e) {}
/* 영역(R·I·A·S·E·C)별 10문항 응답값(0~4) 합 = 0~40. 응답이 다 차지 않았으면 null. */
function scoreRiasec60() {
  const R = state.results.riasec60; if (!R) return null;
  const a = R.answers || [];
  if (a.length < ONET_IP60.length) return null;
  const sums = { R:0, I:0, A:0, S:0, E:0, C:0 };
  for (let i = 0; i < ONET_IP60.length; i++) { const v = a[i]; if (typeof v !== 'number' || !isFinite(v)) return null; sums[ONET_IP60[i].f] += v; }
  return sums;
}
/* 화면용 100점 환산(합/40×100) — 진로 흥미(30) 막대와 나란히 그릴 때 */
function piaIp60Pct(sc) { const o = {}; ['R','I','A','S','E','C'].forEach(function(k){ o[k] = (sc && typeof sc[k] === 'number') ? Math.round(sc[k] / 40 * 100) : null; }); return o; }
/* 시작 안내 카드(0번째 문항 전)·쉬는 화면(30문항 뒤) — 보였으면 true */
function piaIp60Gate(container, current) {
  const R = state.results.riasec60; if (!R) return false;
  const en = (window.aipiaCurrentLang === 'en'), P = window.PIA;
  /* 그림 실제 크기: pia-deep 646×626(800w 판)·400×388, pia-break 778×671·400×345 */
  const DIM = { 'pia-deep': [646, 626], 'pia-break': [778, 671] };
  const img = function(name, alt, cls){ const d = DIM[name]; return '<figure class="pia-ip60__fig'+(cls?' '+cls:'')+'"><img src="/images/ill/'+name+'-800w.webp" srcset="/images/ill/'+name+'-400w.webp 400w, /images/ill/'+name+'-800w.webp '+d[0]+'w" sizes="(max-width: 600px) 72vw, 400px" width="'+d[0]+'" height="'+d[1]+'" alt="'+alt+'" decoding="async"></figure>'; };
  if (current === 0 && !R.intro) {
    container.innerHTML = '<div class="pia pia-ip60-wrap">' + P.back(en ? 'Home' : '홈', "showView('home')")
      + '<section class="pia-sec pia-ip60">'
      + img('pia-deep', en ? 'A student exploring many kinds of activities to find what they enjoy' : '여러 가지 활동 그림을 살펴보며 좋아하는 일을 찾는 학생')
      + '<div style="margin-bottom:var(--pia-s2)">' + P.badge(en ? 'Optional · Pilot' : '선택 검사 · 시범') + '</div>'
      + '<h2 class="pia-h1 pia-ip60__t">' + (en ? 'Deeper Interests (Pilot)' : '흥미 심화(시범)') + '</h2>'
      + '<p class="pia-ip60__meta">' + (en ? '60 items · about 8 min' : '60문항 · 약 8분') + '</p>'
      + '<p class="pia-bodyL pia-muted pia-ip60__d">' + (en ? 'A pilot that looks at your career interests in more detail. The result appears in your report for reference only; career recommendations still use the 30-item Career Interest test.' : '진로 흥미를 더 자세히 살펴보는 시범 검사예요. 결과는 결과지에 참고로만 실리고, 진로 추천은 기존 진로 흥미(30문항) 결과로 해요.') + '</p>'
      + '<p class="pia-note pia-note--card pia-ip60__note">' + P.icon('clock') + (en ? 'You\'ll get a short break after 30 items.' : '30문항을 마치면 잠깐 쉬어 가요.') + '</p>'
      + P.btn(en ? 'Start' : '시작하기', 'piaIp60Start()', 'primary', { cta:1, arrow:1 })
      + '<p class="pia-ip60__attr">' + (en ? PIA_IP60_ATTR : PIA_IP60_ATTR_KO) + '</p>'
      + '</section></div>';
    return true;
  }
  if (current === PIA_IP60_BREAK_AT && !R.brk) {
    container.innerHTML = '<div class="pia pia-ip60-wrap"><section class="pia-sec pia-ip60 pia-ip60--break pia-done">'
      + img('pia-break', en ? 'A fox character stretching and taking a short rest' : '기지개를 켜며 잠깐 쉬는 여우 캐릭터', 'pia-ip60__fig--break')
      + '<h2 class="pia-done__t">' + (en ? 'Halfway there! Take a short break' : '절반 왔어요! 잠깐 쉬어 가요') + '</h2>'
      + '<p class="pia-done__sub">' + (en ? '30 / 60 items done' : '30 / 60문항 완료') + '</p>'
      + '<p class="pia-done__d">' + (en ? 'Stretch or take a sip of water. Continue when you\'re ready.' : '기지개를 켜거나 물을 한 모금 마셔도 좋아요. 준비되면 이어서 해요.') + '</p>'
      + P.btn(en ? 'Continue' : '이어서 하기', 'piaIp60Resume()', 'primary', { cta:1, arrow:1 })
      + P.btn(en ? 'Previous item' : '이전 문항', 'piaIp60Back()', 'secondary')
      + '</section></div>';
    return true;
  }
  return false;
}
window.piaIp60Start = function(){ try { state.results.riasec60.intro = 1; save(); renderRiasec60(); } catch (e) { console.error('흥미 심화 시작 실패', e); } };
window.piaIp60Resume = function(){ try { state.results.riasec60.brk = 1; save(); renderRiasec60(); } catch (e) { console.error('흥미 심화 이어서 하기 실패', e); } };
window.piaIp60Back = function(){ try { var R = state.results.riasec60; if ((R.seq || 0) > 0) { R.seq--; R.answers[R.order[R.seq]] = undefined; } save(); renderRiasec60(); } catch (e) { console.error('흥미 심화 이전 문항 실패', e); } };
/* 결과지 '흥미 심화(시범·참고)' — 진로 흥미(30)와 나란히 막대. 시범 결과가 없으면 칸을 숨긴다. */
function piaFillIp60Report() {
  const wrap = document.getElementById('rep-ip60-wrap'); if (!wrap) return;
  const r60 = state.results && state.results.riasec60, s60 = r60 && r60.scores;
  if (!s60 || typeof s60.R !== 'number') { wrap.style.display = 'none'; return; }
  const s30 = (state.results.riasec && state.results.riasec.scores) || null;
  const p60 = piaIp60Pct(s60);
  const lab = { R:_T('현실형','Realistic'), I:_T('탐구형','Investigative'), A:_T('예술형','Artistic'), S:_T('사회형','Social'), E:_T('진취형','Enterprising'), C:_T('관습형','Conventional') };
  const bar = function(v, c){ return v === null || v === undefined ? '<span style="color:#94a3b8;font-size:10px">-</span>' : '<div class="ip60-bar"><div class="ip60-bar__bg"><div class="ip60-bar__fill" style="width:'+Math.max(0,Math.min(100,v))+'%;background:'+c+'"></div></div><span class="ip60-bar__v">'+v+'</span></div>'; };
  const top = Object.keys(s60).filter(function(k){ return lab[k]; }).sort(function(a,b){ return s60[b]-s60[a]; });
  const tieNote = (top.length > 3 && s60[top[2]] === s60[top[3]]) ? _T(' (3·4위 동점)',' (3rd/4th tied)') : '';
  let rows = '';
  ['R','I','A','S','E','C'].forEach(function(k){
    rows += '<tr><td class="row-head">'+lab[k]+' ('+k+')</td><td>'+bar(s30 && typeof s30[k] === 'number' ? Math.round(s30[k]) : null, '#d97757')+'</td><td>'+bar(p60[k], '#6a9bcc')+'</td><td>'+s60[k]+' / 40</td></tr>';
  });
  wrap.innerHTML = '<div class="section-title"><span class="section-icon">■</span> '+_T('흥미 심화(시범·참고)','Deeper Interests (Pilot · Reference)')+'</div>'
    + '<p style="font-size:10px;color:#666;margin:0 0 6px;">'+_T('같은 6유형을 60문항(O*NET 흥미검사 한국어 적응판, 시범)으로 다시 잰 값입니다. <b>진로 추천·유형은 위의 진로 흥미(30문항) 결과를 그대로 씁니다.</b> 시범판은 타당화 연구 전이라 참고로만 보세요.','The same six types measured again with 60 items (Korean adaptation of the O*NET Interest Profiler, pilot). <b>Career recommendations and types still use the 30-item Career Interest result above.</b> The pilot has not been validated yet; use it for reference only.')+'</p>'
    + '<table class="data-table ip60-table"><tr><th>'+_T('유형','Type')+'</th><th>'+_T('진로 흥미(30문항) 0~100','Career Interest (30) 0–100')+'</th><th>'+_T('흥미 심화(60문항, 시범) 0~100','Deeper Interests (60, pilot) 0–100')+'</th><th>'+_T('60문항 원점수','60-item raw')+'</th></tr>'+rows+'</table>'
    + '<p style="font-size:10px;color:#555;margin:4px 0 0;">'+_T('흥미 심화 상위 3유형: ','Top 3 (pilot): ')+'<b>'+top.slice(0,3).join('')+'</b>'+tieNote+' · '+_T('원판 문헌값 α(영문판·미국 표본) R .78 · I .82 · A .78 · S .78 · E .87 · C .83 — 한국어판 자체 값 아님','Original-version α (English, US sample) R .78 · I .82 · A .78 · S .78 · E .87 · C .83 — not the Korean version')+'</p>'
    + '<p class="ip60-attr">'+PIA_IP60_ATTR+' <span>'+PIA_IP60_ATTR_KO+'</span> <span>'+PIA_IP60_LICENSE_URL+'</span></p>';
  wrap.style.display = 'block';
  wrap.setAttribute('data-ydp-keep', '');   /* 화면 쪽 넘김이 제목·설명과 막대 표를 다른 쪽으로 가르지 않게 한 덩어리로 */
}
try { window.piaFillIp60Report = piaFillIp60Report; } catch (e) {}
const renderRiasec60 = makeLikertRenderer('riasec60', ONET_IP60, 'riasec60', IP60_SCALE, false);

// =================================================================
//  SJT renderer
// =================================================================
// 자유대화 신호로 SJT 시나리오 관련도 정렬 (자체 도구 → 타당성 영향 없음)
var SJT30_EN = [
  {
    "q": "Your group project presentation is due tomorrow, and one teammate hasn't done their part.",
    "choices": [
      "Calmly ask your friend to figure out a way to finish it together",
      "Quickly finish that part yourself",
      "Tell the teacher what's going on and ask for advice",
      "Firmly tell your friend to get it done today"
    ]
  },
  {
    "q": "During break, your friends are talking about a new game.",
    "choices": [
      "Join in because you're interested",
      "Don't know much about it, but quietly listen and take in the mood",
      "Start a different conversation with another friend",
      "Read a book or spend some time alone"
    ]
  },
  {
    "q": "You have an English vocabulary test tomorrow, and there are way too many words you don't know.",
    "choices": [
      "Organize the words by category and memorize the key ones first",
      "Memorize the words by linking them to pictures or stories",
      "Memorize them with a friend, quiz-style",
      "Just pick the words you like and memorize those, even if it's not perfect"
    ]
  },
  {
    "q": "A friend you like is becoming closer with another friend.",
    "choices": [
      "Reach out first and make plans together",
      "Honestly express that your feelings are a bit hurt",
      "Wait, thinking things will settle naturally over time",
      "Focus on your relationships with other friends"
    ]
  },
  {
    "q": "You're asked to write down your future career goal, but nothing comes to mind.",
    "choices": [
      "Write down activities you enjoy and look for a matching career",
      "Think of a memorable character from a show or book",
      "Ask friends or parents for their opinion",
      "Honestly write that you're still figuring it out"
    ]
  },
  {
    "q": "Your homeroom teacher is taking nominations for class president.",
    "choices": [
      "Nominate yourself and give it a try",
      "Nominate a friend who's good at listening to others",
      "Nominate a friend who is diligent and responsible",
      "Don't nominate anyone in particular and go with the majority"
    ]
  },
  {
    "q": "You have some free time this weekend.",
    "choices": [
      "Go somewhere new or join an event",
      "Draw or write something you enjoy",
      "Meet up with friends and hang out",
      "Stay home and read or watch videos"
    ]
  },
  {
    "q": "A friend confided a secret in you, and another friend asks about it.",
    "choices": [
      "Firmly say, \"I can't tell you that\"",
      "Gently say, \"You should ask them directly\"",
      "Naturally steer the conversation to another topic",
      "Pretend you don't know anything about it"
    ]
  },
  {
    "q": "You're stuck on a hard problem at your after-school academy.",
    "choices": [
      "Keep trying to solve it alone, even if it takes a while",
      "Look up a different way to solve it online",
      "Ask a friend or teacher",
      "Set it aside for now and start with easier problems"
    ]
  },
  {
    "q": "Your mom is coming home later than usual.",
    "choices": [
      "Check in with a call or text",
      "Figure she'll be back eventually and get on with your own things",
      "Ask your dad or siblings",
      "Feel worried and go out to meet her"
    ]
  },
  {
    "q": "Someone posts abusive language in your class's unofficial group chat.",
    "choices": [
      "Firmly say, \"Let's stop this\"",
      "Take a screenshot and report it to the teacher",
      "Quietly leave the group chat",
      "Send the person a private message about it"
    ]
  },
  {
    "q": "You got a ticket to see your favorite singer, but it's exam period.",
    "choices": [
      "Give up the ticket since exams come first",
      "Rearrange your study schedule and go",
      "Give the ticket to a friend and focus on studying",
      "Stop by briefly and come straight back"
    ]
  },
  {
    "q": "It's your turn to present, and suddenly the microphone stops working.",
    "choices": [
      "Go ahead without the mic, speaking loudly",
      "Pause for a moment and check the equipment again",
      "Ask a friend for help",
      "Ask the teacher to move you to a later turn"
    ]
  },
  {
    "q": "Your dad is so strict that he won't let you go out.",
    "choices": [
      "Calmly explain your reasons and ask for permission",
      "Talk it over with your mom or another family member",
      "Accept it for now and wait for the next chance",
      "Feel frustrated but go on with your own things for now"
    ]
  },
  {
    "q": "A friend often doesn't bring lunch to school.",
    "choices": [
      "Share your lunch with them",
      "Quietly let the teacher know",
      "Ask your friend directly why",
      "Don't worry about it much and go about your own business"
    ]
  },
  {
    "q": "You've been put in charge of a booth for the school festival.",
    "choices": [
      "Gather ideas and plan something new",
      "Divide up roles and run it efficiently",
      "Focus on gathering everyone's opinions",
      "Take on the role of hyping up the crowd as MC"
    ]
  },
  {
    "q": "School is temporarily shut down, like during COVID.",
    "choices": [
      "Keep studying on a regular schedule at home",
      "Spend time on videos or books you hadn't gotten to",
      "Stay in touch with friends over video calls",
      "Stay in shape with exercise or walks"
    ]
  },
  {
    "q": "A club you loved suddenly gets shut down.",
    "choices": [
      "Start a new club yourself",
      "Look for a similar club to join instead",
      "Raise the issue with the school together with friends",
      "Keep doing the activity on your own for now"
    ]
  },
  {
    "q": "A friend is pressuring you to overspend on game items.",
    "choices": [
      "Firmly say no",
      "Set a spending limit and only buy a little",
      "Hear your friend out and suggest cutting back together",
      "Go along with your friend and buy it for now"
    ]
  },
  {
    "q": "Your grade in a subject you love suddenly dropped.",
    "choices": [
      "Analyze your mistakes to find the cause",
      "Look at how another friend studies for ideas",
      "Focus on the fact that you still enjoy the subject",
      "Ask the teacher for guidance"
    ]
  },
  {
    "q": "A friend made a new friend and doesn't hang out with you as much anymore.",
    "choices": [
      "Try hanging out together with the new friend too",
      "Build new relationships with other friends",
      "Tell your friend honestly how you feel",
      "Give each other space and let things unfold naturally"
    ]
  },
  {
    "q": "Your parents are worried because you spend too much time on your phone.",
    "choices": [
      "Set your own screen time limit and stick to it",
      "Focus mainly on useful content",
      "Set alarms to manage your time",
      "Make plans with a friend and go outside"
    ]
  },
  {
    "q": "You've been offered a volunteer opportunity at school.",
    "choices": [
      "Take part actively no matter what it is",
      "Join if it matches your interests",
      "Join if the timing works",
      "Focus on schoolwork this time instead"
    ]
  },
  {
    "q": "The adults around you make a decision that's hard to understand.",
    "choices": [
      "Ask why they made that decision",
      "Go along with it for now even without understanding",
      "Get another adult's take on it too",
      "If it seems wrong, calmly share your opinion"
    ]
  },
  {
    "q": "A friend is about to cheat on a test.",
    "choices": [
      "Firmly tell them to stop",
      "Point out that they'll be responsible for the consequences",
      "Talk to them privately after the test",
      "Report it to the teacher"
    ]
  },
  {
    "q": "A book in a field you love turns out to be really difficult.",
    "choices": [
      "Read it slowly, one page at a time",
      "Start over with an easier introductory book",
      "Supplement it with videos or lectures",
      "Discuss it with a friend or teacher"
    ]
  },
  {
    "q": "You keep having arguments because of a younger/older sibling.",
    "choices": [
      "Set some ground rules for talking things out",
      "Give each other some space",
      "Ask your parents for help",
      "Apologize first and make up"
    ]
  },
  {
    "q": "You really don't want to go to school.",
    "choices": [
      "Write down your feelings in a journal",
      "Talk it through with a close friend",
      "Ask your homeroom or counseling teacher for help",
      "Try to find at least one thing you enjoy about it"
    ]
  },
  {
    "q": "Academy, tutoring, and school all overlap and it's really overwhelming.",
    "choices": [
      "Set priorities together with your parents",
      "Try making a new schedule",
      "Cut back on one of them for a while",
      "Push through and do it all anyway"
    ]
  },
  {
    "q": "You feel a vague sense of anxiety about the future.",
    "choices": [
      "Explore your interests one at a time",
      "Listen to a mentor's or senior's experience",
      "Focus on small things you can do right now",
      "Share your thoughts with friends or family"
    ]
  }
];
var SJTADULT_EN = [
  {
    "q": "The idea you raised in a meeting got passed over without much consideration.",
    "choices": [
      "Organize your reasoning and propose it again",
      "Explain it separately to the decision-maker afterward",
      "Watch colleagues' reactions and wait for the right moment",
      "Let it go this time and prepare for next time"
    ]
  },
  {
    "q": "A coworker missed a deadline, and now your own work is falling behind too.",
    "choices": [
      "Calmly work out a way to finish it together",
      "Quickly handle that part yourself",
      "Summarize the situation and discuss it with your manager",
      "Set a clear deadline and ask them again"
    ]
  },
  {
    "q": "It's the weekend, but your boss asks you to handle an urgent task.",
    "choices": [
      "Offer to help within a range you can manage",
      "Take care of it right away and finish it",
      "Check priorities and adjust your schedule",
      "Explain your personal plans and ask for understanding"
    ]
  },
  {
    "q": "A new way of working has been introduced to your team.",
    "choices": [
      "Learn it first and apply it actively",
      "Weigh the pros and cons before accepting it",
      "Adjust gradually, staying in step with coworkers",
      "Pick out and use only the parts you need"
    ]
  },
  {
    "q": "You clash with a close coworker over how to approach the work.",
    "choices": [
      "Hear each other's positions out first",
      "Share your own thoughts honestly",
      "Come up with a compromise and propose it",
      "Persuade them by showing results"
    ]
  },
  {
    "q": "You're at a gathering for the first time and barely know anyone.",
    "choices": [
      "Approach people first and start a conversation",
      "Read the room and blend in naturally",
      "Have a deep conversation with one or two people who share your interests",
      "Stay only as long as feels comfortable"
    ]
  },
  {
    "q": "You unexpectedly receive a bonus (a lump sum of money).",
    "choices": [
      "Make a plan and save or invest part of it",
      "Spend it on an experience you've always wanted",
      "Share it with family or people close to you",
      "Set it aside and use it when you need it"
    ]
  },
  {
    "q": "You receive a job offer with better conditions elsewhere.",
    "choices": [
      "Make a table comparing the pros and cons",
      "Ask someone experienced or a mentor for advice",
      "Feel drawn to it as a new challenge",
      "Also weigh how much your current stability matters"
    ]
  },
  {
    "q": "You realize you've made a mistake at work.",
    "choices": [
      "Report it right away and find a way to fix it",
      "Analyze the cause to prevent it from happening again",
      "Apologize first to the people affected",
      "Stay calm and handle priorities first"
    ]
  },
  {
    "q": "You disagree with family (spouse/parents) on something important.",
    "choices": [
      "Try to understand the other person's feelings first",
      "Calmly explain your own thinking",
      "Find common ground and compromise",
      "Take some time and revisit the conversation later"
    ]
  },
  {
    "q": "You finally get some completely free time after a long while.",
    "choices": [
      "Try a new place or activity",
      "Immerse yourself in a favorite hobby or creative project",
      "Spend it with people close to you",
      "Rest at home and recharge"
    ]
  },
  {
    "q": "You need to learn a new skill or get a new certification.",
    "choices": [
      "Make a study plan and work through it step by step",
      "Learn quickly by diving right in",
      "Learn together through a study group or course",
      "Dig deep into the underlying principles"
    ]
  },
  {
    "q": "A minor conflict comes up with a neighbor or acquaintance.",
    "choices": [
      "Reach out first and try to resolve it",
      "Take an objective look at the situation",
      "Keep a comfortable distance for both sides",
      "State your position clearly if needed"
    ]
  },
  {
    "q": "You're about to start a new health routine.",
    "choices": [
      "Set specific goals and a routine",
      "Just start light right away",
      "Find someone to do it with for motivation",
      "Look for a method that suits you"
    ]
  },
  {
    "q": "You've been given the role of mentoring a junior or new employee.",
    "choices": [
      "Explain things step by step at their level",
      "Let them try it themselves and give feedback",
      "Create a step-by-step guide for them",
      "Help them find the answer themselves through questions"
    ]
  },
  {
    "q": "You feel a vague anxiety about retirement or the future.",
    "choices": [
      "Look into areas of interest and ways to prepare, one at a time",
      "Listen to someone with more experience",
      "Focus on what you can do right now",
      "Share your thoughts with someone close to you"
    ]
  },
  {
    "q": "Your team needs to choose a leader for a project.",
    "choices": [
      "Take on the role yourself and drive it forward",
      "Recommend someone good at coordinating opinions",
      "Recommend someone responsible and detail-oriented",
      "Weigh people's abilities and go with the majority view"
    ]
  },
  {
    "q": "You're facing an important decision without enough information.",
    "choices": [
      "Gather more data to build a case",
      "Ask someone experienced for advice",
      "Test it out with a small trial first",
      "Decide based on intuition and personal values"
    ]
  }
];
function sjtSetEn(){ return (typeof selfIsAdult==='function' && selfIsAdult()) ? SJTADULT_EN : SJT30_EN; }
function computeSjtOrder() {
  const _S = sjtSet();
  const cd = (state.results.conv && state.results.conv.dims) || {};
  const idxs = _S.map(function(_, i){ return i; });
  const hasSignal = Object.keys(cd).some(function(k){ return cd[k] > 0; });
  if (!hasSignal) return { order: idxs, adaptive: false };
  function relevance(sc) {
    let r = 0;
    sc.choices.forEach(function(c){ for (const d in c.w) { r += (cd[d] || 0) * c.w[d]; } });
    return r;
  }
  const ordered = idxs.slice().sort(function(a, b){ return relevance(_S[b]) - relevance(_S[a]); });
  return { order: ordered, adaptive: true };
}
function renderSjt() {
  const container = el('sjt-content');
  const _S = sjtSet();
  var _pld = (window.aipiaCurrentLang === 'en');
  var _ES = _pld ? sjtSetEn() : null;
  // 첫 진입(응답 0개) 시 자유대화 신호로 순서를 1회 고정 구성
  if (!state.results.sjt.order || state.results.sjt.order.length !== _S.length) {
    const r = computeSjtOrder();
    state.results.sjt.order = r.order;
    state.results.sjt.adaptive = r.adaptive;
    save();
  }
  const seq = state.results.sjt.order;
  const answers = state.results.sjt.answers;
  const idx = answers.length;
  if (idx >= _S.length) {
    save();
    var P0 = window.PIA;
    container.innerHTML = '<div class="pia"><section class="pia-sec" style="text-align:center">'
      + '<div class="pia-done__ic" aria-hidden="true">\u2713</div>'
      + '<h2 class="pia-h2" style="margin-bottom:var(--pia-s2)">' + (_pld ? ('You\'ve finished all ' + _S.length + ' questions') : (_S.length + '문항을 모두 마쳤어요')) + '</h2>'
      + '<p class="pia-bodyL pia-muted" style="margin-bottom:var(--pia-s4)">' + (_pld ? 'Your results will be reflected in the integrated report.' : '결과는 통합 결과지에 반영됩니다.') + '</p>'
      + P0.btn((_pld?'Back to Assessment Menu':'검사 메뉴로 돌아가기'), "showView('home')", 'primary', {cta:1, arrow:1})
      + '<div style="height:var(--pia-s2)"></div>'
      + P0.btn((_pld?'Retake This Assessment':'이 검사 다시 하기'), "state.results.sjt={answers:[],dims:{},order:[],adaptive:false}; save(); renderSjt()", 'secondary')
      + '</section></div>';
    return;
  }
  const q = _S[seq[idx]];
  const eq = _ES ? _ES[seq[idx]] : null;
  const pct = Math.round((idx/_S.length)*100);
  const banner = state.results.sjt.adaptive
    ? '<div class="mb-4 text-xs bg-violet-50 border border-violet-200 rounded-lg p-2 text-violet-900">💬 자유대화에서 파악한 관심사·성향에 맞춰 시나리오 순서가 <strong>맞춤 구성</strong>되었습니다.</div>'
    : '';
  var P = window.PIA;
  container.innerHTML = '<div class="pia">'
    + P.back((_pld?'Home':'홈'), "showView('home')")
    + '<div style="margin-bottom:var(--pia-s3)">' + P.badge(_pld?'Optional':'선택 검사') + '</div>'
    + '<h2 class="pia-h1" style="margin-bottom:var(--pia-s2)">' + (_pld?'Situational Judgment':'상황 판단') + '</h2>'
    + '<p class="pia-bodyL pia-muted">' + (_pld?'Choose what you would do in this situation.':'이런 상황이라면 나는 어떻게 할지 골라주세요.') + '</p>'
    + '<p class="pia-cap" style="margin-top:6px">' + (_pld?'There\'s no right or wrong answer in this situational judgment test.':'정답이 없는 상황 판단 검사예요.') + '</p>'
    + '<div style="height:var(--pia-s4)"></div>'
    + P.progress((_pld?'Scenario':'시나리오'), idx + 1, _S.length, {pct:true})
    + (state.results.sjt.adaptive
        ? '<p class="pia-note pia-note--card" style="margin-bottom:var(--pia-s3)">' + P.icon('help')
          + (_pld?'The order has been arranged based on the interests noticed in your earlier conversation.':'앞선 대화에서 파악한 관심사에 맞춰 순서가 구성되었어요.') + '</p>'
        : '')
    + '<section class="pia-sec pia-sec--qa">'
    + '<p class="pia-q js-qtext" data-orig="" aria-live="polite" style="text-align:center;margin-bottom:var(--pia-s2)">' + applyEasy((eq && eq.q) ? eq.q : q.q) + '</p>'
    + '<p class="pia-bodyL pia-muted pia-q-sub" style="text-align:center;margin-bottom:var(--pia-s5)">' + (_pld?'What would you do?':'나라면 어떻게 할까요?') + '</p>'
    + '<div class="pia-choices" role="radiogroup" aria-label="' + (_pld?'Select an answer':'답변 선택') + '" id="sjt-choices"></div>'
    + P.autosave()
    + '</section>'
    + '<div class="pia-sr">' + easyControls('sjt') + '</div>'
    + '</div>';
  const cc = el('sjt-choices');
  q.choices.forEach((c, ci) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pia-choice';
    btn.setAttribute('role','radio');
    btn.setAttribute('aria-checked','false');
    btn.innerHTML = '<span class="pia-choice__radio" aria-hidden="true"></span>'
      + '<span class="pia-choice__txt"></span>'
      + '<span class="pia-choice__ck" aria-hidden="true">\u2713</span>';
    btn.querySelector('.pia-choice__txt').textContent = applyEasy((eq && eq.choices && eq.choices[ci]) ? eq.choices[ci] : c.t);
    btn.addEventListener('click', () => {
      try{
        var _sib = cc.querySelectorAll('.pia-choice');
        for(var _i=0;_i<_sib.length;_i++) _sib[_i].setAttribute('aria-checked','false');
        btn.setAttribute('aria-checked','true');
      }catch(_e){}
      state.results.sjt.answers.push(ci);
      for (const [dim, w] of Object.entries(c.w)) {
        state.results.sjt.dims[dim] = (state.results.sjt.dims[dim]||0) + w;
      }
      save();
      renderSjt();
    });
    cc.appendChild(btn);
  });
}

// =================================================================
//  Home menu
// =================================================================
function _likertDoneCount(stateKey){
  var a = (state.results[stateKey] && state.results[stateKey].answers) || [];
  var n = 0; for (var i=0;i<a.length;i++){ if (a[i]!==undefined && a[i]!==null) n++; } return n;
}
// 완료된 검사 하나만 초기화하고 다시 응시 (다른 검사 답안은 유지)
function retakeTest(id, key){
  try{
    if(!confirm('이 검사만 초기화하고 다시 하시겠어요?\n(다른 검사 답안·결과는 그대로 유지됩니다)')) return;
    if(key==='conv'){ state.results.conv = { turns:0, dims:{}, riskHist:[], topics:{}, transcript:[] }; }
    else if(key==='sjt'){ state.results.sjt = { answers:[], dims:{}, order:[], adaptive:false }; }
    else if(state.results[key]){ state.results[key] = { answers:[], scores:null }; }
    try{ save(); }catch(e){}
    if(typeof renderHome==='function') renderHome();
    if(typeof showView==='function') showView(id);
  }catch(e){}
}
try{ window.retakeTest = retakeTest; }catch(e){}
function renderHome() {
  const container = el('home-content');
  // 권장 순서: 자유대화 → VIA(강점) → Big5 → Grit → RIASEC → SJT → 정서 스크리닝 3종
  // 흐름: 라포 형성 → 강점 발견 → 성격 정밀 → 동기 → 진로 → 행동 검증 → 정서
  const cards = [
    // ===== 필수 (먼저 진행) — 통합 결과지 열람에 필요 =====
    { id:'chat', step:1, title:'AI 자유대화 (필수·먼저)', icon:'💬', desc:'AI 피아와 자연스러운 대화로 시작합니다.',
      detail:'가장 먼저 진행하는 필수 단계입니다. 편안한 대화로 라포를 형성하고, 분석은 다음 검사 결과와 통합됩니다.',
      dur:'5~8분', items:'10턴', key:'conv', track:'P+I+A', priority:'필수', color:'violet' },
    { id:'big5', step:2, title:'IPIP Big5-50 (성격 5요인)', icon:'🧠', desc:'학술 검증된 성격 정밀 검사 (공유저작).',
      detail:'외향·우호·성실·정서안정·개방의 5요인 + 30개 하위 차원. 약 30년간 가장 표준화된 성격 모델.',
      dur:'10~12분', items:50, key:'big5', track:'P (인성)', priority:'필수', color:'indigo' },
    { id:'riasec', step:3, title:'RIASEC 진로 흥미 (Holland)', icon:'🧭', desc:'직업적 흥미 6유형 분석.',
      detail:'현실·탐구·예술·사회·진취·관습 6유형. 워크넷·커리어넷 표준 진로 모델.',
      dur:'7~8분', items:30, key:'riasec', track:'A (진로/적성)', priority:'필수', color:'amber' },
    // ===== 선택 (정확도·정서 보강) — 많이 할수록 분석이 정확해집니다 =====
    { id:'via', step:4, title:'24 강점 프로파일', icon:'⭐', desc:'24가지 성격 강점을 발견합니다.',
      detail:'학생의 가장 빛나는 강점 5개를 우선 도출합니다. 긍정심리학 기반(IPIP-VIA 공개 척도).',
      dur:'5분', items:24, key:'via', track:'P (인성)', priority:'선택', color:'emerald' },
    { id:'grit', step:5, title:'끈기·근면 척도', icon:'🔥', desc:'성취·동기 단축형 (IPIP 공개 척도).',
      detail:'장기 목표 추구 능력 + 열정의 일관성. 학업·진로 성공의 핵심 비인지 역량.',
      dur:'2분', items:8, key:'grit', track:'P (인성)', priority:'선택', color:'orange' },
    { id:'learn', step:6, title:'과목별 학습 역량', icon:'📚', desc:'언어·수리·외국어·사회·과학·예술·신체 자가평가.',
      detail:'과목별 흥미·자신감을 스스로 평가합니다. 결과지의 학습역량 페이지에 실측값으로 반영됩니다.',
      dur:'2분', items:14, key:'learn', track:'I (학습)', priority:'선택', color:'indigo' },
    { id:'mi', step:7, title:'다중지능(MI) 8지능', icon:'🧩', desc:'가드너 8가지 지능 자가검사.',
      detail:'언어·논리수학·공간·음악·신체·대인·자기성찰·자연 8지능을 스스로 평가합니다. 결과지의 지능 페이지에 실측값으로 반영됩니다.',
      dur:'2분', items:16, key:'mi', track:'I (지능)', priority:'선택', color:'orange' },
    { id:'rses', step:8, title:'Rosenberg 자존감(RSES)', icon:'💎', desc:'자아존중감 10문항 (공개 척도).',
      detail:'전반적 자아존중감 수준. 강점 기반 코칭과 자기이해의 출발점입니다.',
      dur:'2분', items:10, key:'rses', track:'P (인성)', priority:'선택', color:'indigo' },
    { id:'riasec60', step:9, title:'흥미 심화(시범)', icon:'🧭', desc:'진로 흥미를 60문항으로 더 자세히 살펴보는 시범 검사(참고용).',
      detail:'O*NET 흥미검사(Interest Profiler) 한국어 적응판 시범. 결과는 결과지에 참고로만 싣고, 진로 추천은 진로 흥미(30문항)로 합니다.',
      dur:'약 8분', items:60, key:'riasec60', track:'A (진로/적성)', priority:'선택', color:'amber' },
    { id:'sjt', step:9, title:'SJT 상황 판단 검사', icon:'🎬', desc:'행동 예측 시나리오 30개.',
      detail:'실제 학교 상황에서 어떻게 행동할지 묻는 검사. 응답 위장이 어려워 행동 예측 신뢰도 높음.',
      dur:'10~12분', items:30, key:'sjt', track:'P+A 검증', priority:'선택', color:'sky' },
    { id:'cesd', step:10, title:'CES-D-10 정서 스크리닝', icon:'🩺', desc:'우울 증상 1주 빈도 (Public domain).',
      detail:'지난 1주일 정서 상태 자가 진단. 안전 모니터링용이며 의료 진단 아님.',
      dur:'2분', items:10, key:'cesd', track:'정서 안전', priority:'선택', color:'rose', sensitive:true },
    { id:'phqa', step:11, title:'PHQ-A 청소년 우울', icon:'🫥', desc:'9문항 청소년 우울 평가.',
      detail:'지난 2주 청소년 우울 자가 진단. 자해 신호 9번 문항 별도 추적.',
      dur:'2분', items:9, key:'phqa', track:'정서 안전', priority:'선택', color:'pink', sensitive:true },
    { id:'gad', step:12, title:'GAD-7 불안 스크리닝', icon:'😰', desc:'7문항 불안 자가 평가.',
      detail:'지난 2주 불안 증상 자가 진단. 청소년 정신건강 모니터링.',
      dur:'2분', items:7, key:'gad', track:'정서 안전', priority:'선택', color:'red', sensitive:true },
  ];
  if (window.aipiaCurrentLang === 'en') {
    var CARDS_EN = {
      chat:   { title:'AI Free Chat (Required, First)', desc:'Start with a natural conversation with AI Pia.', detail:'The first required step. Builds rapport through relaxed conversation; the analysis is combined with your other results.', dur:'5-8 min', track:'P+I+A', priority:'Required' },
      big5:   { title:'IPIP Big5-50 (Five-Factor Personality)', desc:'An academically validated, in-depth personality assessment (open license).', detail:'Extraversion, Agreeableness, Conscientiousness, Emotional Stability, Openness, plus 30 sub-facets. The most standardized personality model for about 30 years.', dur:'10-12 min', track:'P (Personality)', priority:'Required' },
      riasec: { title:'RIASEC Career Interests (Holland)', desc:'Analyzes your interests across 6 vocational types.', detail:'Realistic, Investigative, Artistic, Social, Enterprising, Conventional \u2014 a standard career-interest model.', dur:'7-8 min', track:'A (Career/Aptitude)', priority:'Required' },
      via:    { title:'24 Character Strengths Profile', desc:'Discover your 24 character strengths.', detail:'Surfaces your top 5 standout strengths first. Based on positive psychology (open IPIP-VIA scale).', dur:'5 min', track:'P (Personality)', priority:'Optional' },
      grit:   { title:'Grit & Diligence Scale', desc:'A short achievement-motivation scale (open IPIP scale).', detail:'Perseverance toward long-term goals plus consistency of passion \u2014 a key skill for academic and career success.', dur:'2 min', track:'P (Personality)', priority:'Optional' },
      learn:  { title:'Subject Learning Aptitude', desc:'Self-rate your interest across language, math, foreign language, social studies, science, arts, and PE.', detail:'Rate your own interest and confidence per subject. Feeds real values into the report\'s learning-aptitude page.', dur:'2 min', track:'I (Learning)', priority:'Optional' },
      mi:     { title:'Multiple Intelligences (MI), 8 Types', desc:'Gardner\'s 8-intelligence self-assessment.', detail:'Self-assess across linguistic, logical-mathematical, spatial, musical, bodily, interpersonal, intrapersonal, and naturalistic intelligence.', dur:'2 min', track:'I (Intelligence)', priority:'Optional' },
      riasec60:{ title:'Deeper Interests (Pilot)', desc:'A 60-item pilot that looks at career interests in more detail (reference only).', detail:'Pilot Korean adaptation of the O*NET Interest Profiler. Shown in the report for reference; career recommendations still use the 30-item test.', dur:'About 8 min', track:'A (Career/Aptitude)', priority:'Optional' },
      rses:   { title:'Rosenberg Self-Esteem (RSES)', desc:'10-item self-esteem scale (open scale).', detail:'Your overall level of self-esteem \u2014 a starting point for strength-based coaching and self-understanding.', dur:'2 min', track:'P (Personality)', priority:'Optional' },
      sjt:    { title:'SJT Situational Judgment Test', desc:'30 behavior-prediction scenarios.', detail:'Asks how you\'d act in real school situations. Harder to fake than self-report, so prediction is more reliable.', dur:'10-12 min', track:'P+A Validation', priority:'Optional' },
      cesd:   { title:'CES-D-10 Emotional Screening', desc:'Weekly frequency of depressive symptoms (public domain).', detail:'A self-check of your emotional state over the past week. For safety monitoring only \u2014 not a medical diagnosis.', dur:'2 min', track:'Emotional Safety', priority:'Optional' },
      phqa:   { title:'PHQ-A Adolescent Depression', desc:'9-item adolescent depression screening.', detail:'A self-check of depression over the past 2 weeks. Item 9 (self-harm signal) is tracked separately.', dur:'2 min', track:'Emotional Safety', priority:'Optional' },
      gad:    { title:'GAD-7 Anxiety Screening', desc:'7-item anxiety self-assessment.', detail:'A self-check of anxiety symptoms over the past 2 weeks. For adolescent mental-health monitoring.', dur:'2 min', track:'Emotional Safety', priority:'Optional' },
      who5:   { title:'WHO-5 Well-Being Index', desc:'5-item emotional well-being scale (WHO).', detail:'Emotional well-being over the past 2 weeks. A low score is a signal care may help \u2014 not a diagnosis.', dur:'1 min', track:'Emotional Safety', priority:'Optional' }
    };
    cards.forEach(function(c){ if (CARDS_EN[c.id]) Object.assign(c, CARDS_EN[c.id]); });
  }

  // 전체 완료율
  const total = cards.length;
  const done = cards.filter(c => {
    if (c.key === 'conv') return state.results.conv.turns >= 12;
    if (c.key === 'sjt') return state.results.sjt.answers.length >= sjtSet().length;
    const expected = c.id==='big5'?50: c.id==='riasec'?30: c.id==='via'?24: c.id==='grit'?8: c.id==='cesd'?10: c.id==='phqa'?9: c.id==='gad'?7: c.id==='who5'?5: c.id==='rses'?10: c.id==='learn'?14: c.id==='mi'?16: c.id==='riasec60'?60: 100;
    return _likertDoneCount(c.key) >= expected;
  }).length;
  const progress = Math.round(done/total*100);
  const _reqKeys=['conv','big5','riasec'];
  const reqDone = cards.filter(c=>_reqKeys.indexOf(c.key)>=0 && (c.key==='conv'?state.results.conv.turns >= 12:_likertDoneCount(c.key)>=(c.id==='big5'?50:30))).length;

  // 색상 매핑
  const colorMap = {
    violet:{bg:'bg-violet-50',border:'border-violet-300',text:'text-violet-900',btn:'bg-violet-600 hover:bg-violet-700',badge:'bg-violet-100 text-violet-800'},
    emerald:{bg:'bg-emerald-50',border:'border-emerald-300',text:'text-emerald-900',btn:'bg-emerald-600 hover:bg-emerald-700',badge:'bg-emerald-100 text-emerald-800'},
    indigo:{bg:'bg-indigo-50',border:'border-indigo-300',text:'text-indigo-900',btn:'bg-indigo-600 hover:bg-indigo-700',badge:'bg-indigo-100 text-indigo-800'},
    orange:{bg:'bg-orange-50',border:'border-orange-300',text:'text-orange-900',btn:'bg-orange-600 hover:bg-orange-700',badge:'bg-orange-100 text-orange-800'},
    amber:{bg:'bg-amber-50',border:'border-amber-300',text:'text-amber-900',btn:'bg-amber-600 hover:bg-amber-700',badge:'bg-amber-100 text-amber-800'},
    sky:{bg:'bg-sky-50',border:'border-sky-300',text:'text-sky-900',btn:'bg-sky-600 hover:bg-sky-700',badge:'bg-sky-100 text-sky-800'},
    rose:{bg:'bg-rose-50',border:'border-rose-300',text:'text-rose-900',btn:'bg-rose-600 hover:bg-rose-700',badge:'bg-rose-100 text-rose-800'},
    pink:{bg:'bg-pink-50',border:'border-pink-300',text:'text-pink-900',btn:'bg-pink-600 hover:bg-pink-700',badge:'bg-pink-100 text-pink-800'},
    red:{bg:'bg-red-50',border:'border-red-300',text:'text-red-900',btn:'bg-red-600 hover:bg-red-700',badge:'bg-red-100 text-red-800'}
  };

  // 완료 판정 + '다음 추천' 카드 (순차 진행 강조용)
  const _isCardDone = (c)=> c.key==='conv' ? state.results.conv.turns >= 12 : c.key==='sjt' ? state.results.sjt.answers.length >= sjtSet().length : _likertDoneCount(c.key) >= (c.id==='big5'?50: c.id==='riasec'?30: c.id==='via'?24: c.id==='grit'?8: c.id==='cesd'?10: c.id==='phqa'?9: c.id==='gad'?7: c.id==='who5'?5: c.id==='rses'?10: c.id==='learn'?14: c.id==='mi'?16: c.id==='riasec60'?60: 100);
  const _nextCardId = ((cards||[]).find(c=>!_isCardDone(c))||{}).id;

  // 진행률 헤더 + 카드 그리드
  if (typeof window.piaRenderHomeV2 !== 'function') {
    window._piaHomePending = { cards: cards, isDone: _isCardDone, reqDone: reqDone };
    return;
  }
  window._piaHomePending = null;
  container.innerHTML = window.piaRenderHomeV2(cards, _isCardDone, reqDone);
}

// =================================================================
//  Result rendering
// =================================================================
/* [2026-10-10 성능] Chart.js(205KB) 지연 로드 — test.html 이 첫 화면에서 받던 것을 뺐다.
   검사 화면에 들어가면(showView) 미리 받아 두고, 결과를 바로 여는 주소(sample·s·view·paper·print)는
   스크립트가 읽히자마자 받기 시작한다. 결과를 그릴 때 아직 없으면 받은 뒤 결과를 다시 그린다
   (언어 전환 때 renderResult 를 다시 부르는 것과 같은 방식). */
var PIA_CHART_SRC = '/vendor/chart-4.4.1.umd.js';
var _piaChartQ = [], _piaChartLoading = false;
function piaLoadChart(cb) {
  if (typeof Chart !== 'undefined') { if (cb) cb(); return; }
  if (cb && _piaChartQ.indexOf(cb) < 0) _piaChartQ.push(cb);
  if (_piaChartLoading) return;
  _piaChartLoading = true;
  var s = document.createElement('script');
  s.src = PIA_CHART_SRC; s.async = true;
  s.onload = function () { var q = _piaChartQ.splice(0); q.forEach(function (f) { try { f(); } catch (e) { console.warn('[pia] 차트 로드 뒤 처리 실패', e); } }); };
  s.onerror = function () { _piaChartLoading = false; try { s.remove(); } catch (e) {} };
  (document.head || document.documentElement).appendChild(s);
}
function piaChartRerender() {
  try {
    var _rs = document.querySelector('section[data-view="result"]');
    if (_rs && !_rs.classList.contains('hidden') && typeof renderResult === 'function') renderResult();
  } catch (e) { console.warn('[pia] 차트 로드 뒤 결과 다시 그리기 실패', e); }
}
window.piaLoadChart = piaLoadChart;
try {
  if (/[?&](sample|s|view|paper|print)=/.test(location.search) || /^\/sample\//.test(location.pathname || '') || location.hash === '#sample') piaLoadChart();
} catch (e) {}
let charts = {};
/* [2026-11-02 성능 2차] Chart.js 차트 6개 만들기를 결과지 그리기와 다른 작업(setTimeout 0, 두 묶음)으로 — 차트마다 캔버스 크기를 읽고 쓰며 문서 전체를 다시
   배치해 결과지 첫 그리기 작업이 CPU 4x 에서 1초를 넘었다. 캔버스 상자 높이는 CSS 고정(h-[260px])이라 쪽 구성은 같고, 쪽 넘김(200ms 뒤)은 그려진 뒤에 잰다.
   인쇄(piaPrintReport)는 먼저 piaChartFlush() 로 밀린 차트를 다 그린다. 다시 그리기(renderResult→destroyCharts)는 밀린 것을 버린다. */
var _piaChartQ2 = [], _piaChartT = 0;
function piaChartFlush(all){
  /* all=true(인쇄 등): 밀린 차트를 지금 전부 그린다. 아니면 묶음 1(머리 차트)을 그리고 묶음 2는 다음 작업에 */
  if (_piaChartT) { clearTimeout(_piaChartT); _piaChartT = 0; }
  var q = _piaChartQ2, run = all ? q.splice(0) : q.filter(function(f){ return f.__g !== 2; });
  if (!all) _piaChartQ2 = q.filter(function(f){ return f.__g === 2; });
  if (!all && !run.length && _piaChartQ2.length) run = _piaChartQ2.splice(0);
  for (var i = 0; i < run.length; i++) { try { run[i](); } catch (e) { console.warn('[결과지] 차트 그리기 실패', e); } }
  if (_piaChartQ2.length) _piaChartT = setTimeout(piaChartFlush, 0);
}
function piaChartDefer(fn, group){
  /* group 1(머리 차트 2개)은 첫 번째 작업, 2(차원별 4개)는 그다음 작업에 — 한 작업이 1초를 넘지 않게 */
  _piaChartQ2.push(fn);
  fn.__g = group || 1;
  if (!_piaChartT) _piaChartT = setTimeout(function(){ _piaChartT = 0;
    /* 다른 화면에서 결과지로 막 들어와 결과 구역이 아직 쪽 넘김의 숨김 속성 아래 있으면(첫 배치 전), 쪽 넘김의 prelayout 으로 첫 배치를 이 작업에서 치른다
       (보이지 않게 풀어서 재기만 함 — 옛 화면 번쩍임 없음). 뒤따르는 쪽 계산 작업이 그만큼 짧아지고 차트도 실제 크기로 한 번에 그려진다. 차트는 다음 작업부터 */
    var pre = false; try { var _sec = document.querySelector('section[data-view="result"]'); if (_sec && window.YDScreenPager && YDScreenPager.prelayout && _sec.closest('[data-ydp-hide]')) pre = !!YDScreenPager.prelayout(); } catch (e) {}
    if (pre) { _piaChartT = setTimeout(piaChartFlush, 0); return; }
    piaChartFlush();
  }, 0);
}
function piaChartCancel(){ _piaChartQ2.length = 0; if (_piaChartT) { clearTimeout(_piaChartT); _piaChartT = 0; } }
window.piaChartFlush = piaChartFlush;
function renderDimCharts(big5, riasec, via){
  if (typeof Chart === 'undefined') return;
  const wrap = el('dimcharts-wrap');
  if (!wrap) return;
  const any = !!(riasec || via || big5);
  wrap.classList.toggle('hidden', !any);
  if (!any) return;
  const PAL = ['#d97757','#6a9bcc','#788c5d','#e0a93b','#a78da6','#9cae86'];
  // 원형: RIASEC 흥미 비중
  const dWrap = el('dc-riasec-doughnut-wrap');
  if (riasec && dWrap) {
    dWrap.classList.remove('hidden');
    piaChartDefer(function(){     charts.dcDough = new Chart(el('dc-riasec-doughnut').getContext('2d'), {
      type:'doughnut',
      data:{ labels:_T(_RIASEC_LBL_KO,_RIASEC_LBL_EN),
        datasets:[{ data:[riasec.R,riasec.I,riasec.A,riasec.S,riasec.E,riasec.C], backgroundColor:PAL, borderColor:'#fffdf8', borderWidth:2 }]},
      options:{ plugins:{legend:{position:'right',labels:{boxWidth:12,font:{size:11}}}}, cutout:'58%', maintainAspectRatio:false }
    }); }, 2);
  }
  // 레이더: RIASEC 육각형
  const rWrap = el('dc-riasec-radar-wrap');
  if (riasec && rWrap) {
    rWrap.classList.remove('hidden');
    piaChartDefer(function(){     charts.dcRadar = new Chart(el('dc-riasec-radar').getContext('2d'), {
      type:'radar',
      data:{ labels:_T(_RIASEC_LBL_KO,_RIASEC_LBL_EN),
        datasets:[{ label:_T('흥미','Interest'), data:[riasec.R,riasec.I,riasec.A,riasec.S,riasec.E,riasec.C],
          backgroundColor:'rgba(217,119,87,0.18)', borderColor:'#d97757', borderWidth:2, pointBackgroundColor:'#d97757' }]},
      options:{ plugins:{legend:{display:false}}, scales:{r:{min:0,max:100,ticks:{stepSize:25,font:{size:9}}}}, maintainAspectRatio:false }
    }); }, 2);
  }
  // 막대: VIA 상위 8
  const vWrap = el('dc-via-bar-wrap');
  if (via && vWrap) {
    vWrap.classList.remove('hidden');
    /* 1~5 원점수(강점당 1문항). 0~100 환산은 5점이 전부 100 으로 포화돼 쓰지 않는다. */
    const top = ((viaRank(via)||{items:[]}).items).slice(0,8);
    piaChartDefer(function(){     charts.dcVia = new Chart(el('dc-via-bar').getContext('2d'), {
      type:'bar',
      data:{ labels: top.map(it=>_viaName(it.k)),
        datasets:[{ data: top.map(it=>it.raw), backgroundColor:'#788c5d', borderRadius:5 }]},
      options:{ indexAxis:'y', plugins:{legend:{display:false}}, scales:{x:{min:0,max:5,ticks:{stepSize:1}}}, maintainAspectRatio:false }
    }); }, 2);
  }
  // 막대: Big5 나의 점수
  const bWrap = el('dc-big5-bar-wrap');
  if (big5 && bWrap) {
    bWrap.classList.remove('hidden');
    const mine = [big5.E, big5.A, big5.C, 100-big5.N, big5.O];
    piaChartDefer(function(){     charts.dcBig5 = new Chart(el('dc-big5-bar').getContext('2d'), {
      type:'bar',
      data:{ labels:_T(['외향','우호','성실','정서안정','개방'],['Extraversion','Agreeableness','Conscientiousness','Emotional Stability','Openness']),
        datasets:[
          { label:_T('나','You'), data:mine, backgroundColor:'#d97757', borderRadius:5 }
          /* [2026-09-27] '또래 규준(예시)' 막대 제거 — REFERENCE_NORMS 는 실제 규준 집단이 아니다. */
        ]},
      options:{ plugins:{legend:{display:false}}, scales:{y:{min:0,max:100}}, maintainAspectRatio:false }
    }); }, 2);
  }
}

function destroyCharts() {
  try { piaChartCancel(); } catch (e) {}
  for (const k of Object.keys(charts)) {
    if (charts[k]) { try { charts[k].destroy(); } catch(e){} charts[k] = null; }
  }
}

function hasAnyResult() {
  const r = state.results;
  return !!(r.big5.scores || r.riasec.scores || r.via.scores || r.grit.scores || r.cesd.scores || r.phqa.scores || r.gad.scores
    || (r.who5 && r.who5.scores) || (r.rses && r.rses.scores) || (r.learn && r.learn.scores) || (r.mi && r.mi.scores)
    || (r.sjt && r.sjt.answers && r.sjt.answers.length > 0) || (r.conv && r.conv.turns > 0));
}
const REQUIRED_TESTS = [
  { id:'chat',   label:'자유대화',        done:function(){ return state.results.conv.turns >= 12; } },
  { id:'big5',   label:'IPIP Big5-50',    done:function(){ return !!state.results.big5.scores; } },
  { id:'riasec', label:'RIASEC 진로흥미', done:function(){ return !!state.results.riasec.scores; } }
];
function missingRequired(){ return REQUIRED_TESTS.filter(function(t){ return !t.done(); }); }

function resultContext(){
  const r=state.results; const b=r.big5.scores, ri=r.riasec.scores, v=r.via.scores;
  let type=null; try{ type=inferIntegratedType(); }catch(e){}
  let c='학생 검사 결과 요약:\n';
  if(type) c+='통합유형: '+type.name+' — '+type.desc+'\n';
  if(b) c+='Big5: 외향'+b.E+' 우호'+b.A+' 성실'+b.C+' 정서안정'+(100-b.N)+' 개방'+b.O+'\n';
  if(ri){ const t=Object.entries(ri).sort(function(a,b){return b[1]-a[1];}).slice(0,3).map(function(e){return e[0];}).join(''); c+='RIASEC 상위: '+t+'\n'; }
  if(v){ const t=viaTopKeys(v,3).join(', '); c+='대표강점(VIA): '+(t||'모든 강점에 같은 점수로 응답해 우열 없음')+'\n'; }
  if(r.learn&&r.learn.scores){ const t=Object.entries(r.learn.scores).sort(function(a,b){return b[1]-a[1];}).slice(0,2); c+='학습 강점 과목: '+t.map(function(e){return e[0]+' '+e[1];}).join(', ')+'\n'; }
  if(r.mi&&r.mi.scores){ const t=Object.entries(r.mi.scores).sort(function(a,b){return b[1]-a[1];}).slice(0,2).map(function(e){return e[0];}).join(', '); c+='강한 지능영역: '+t+'\n'; }
  return c;
}
function _stripForeign(t){ return String(t||'').replace(/[\u3040-\u30ff\u3400-\u9fff\uF900-\uFAFF\u0e00-\u0e7f\u0400-\u04ff\u0600-\u06ff\u0590-\u05ff\u0900-\u097f]/g,'').replace(/ +/g,' ').trim(); }
async function askResultQuestion(q){
  const ans=el('qa-answer'); if(!ans) return;
  if(!q||!q.trim()) return;
  ans.textContent=_T('🤖 생각 중…','🤖 Thinking…');
  const sys=(window.aipiaCurrentLang==='en')
    ? 'You are a friendly assistant who helps with careers and self-understanding. Answer only based on this person\'s actual assessment results, warmly and in 3-4 sentences, in English only. Avoid claims or diagnoses not supported by the results. Speak casually and warmly, not formally.'
    : '너는 진로·자기이해를 돕는 친근한 도우미야. 아래 사람의 실제 검사 결과에 근거해서만 밝고 따뜻하게 3~4문장으로 답해. 결과에 없는 단정·진단은 피해. 상대를 "학생님" 같은 딱딱한 호칭으로 부르지 말고 "너"라고 친근하게 부르며, "~하십니다/계시며" 같은 보고체 대신 밝고 편한 말투로 답해. ★반드시 한국어(한글)로만 쓰고 한자·외국 문자를 절대 섞지 마(예: "개방적"을 "개放적", "창의력"을 "창의力"처럼 쓰지 말 것).';
  const prompt=resultContext()+'\n학생 질문: '+q+'\n위 결과에 근거해 답해줘.';
  let out=null; try{ out=await callLLMFree(prompt, sys); }catch(e){ out=null; }
  // 한자·외국문자 혼입 방지: 1회 재생성 → 실패 시 정제 (EN 모드는 건너뜀)
  try{
    if(window.aipiaCurrentLang!=='en' && out && out.trim() && typeof _isKoreanReply==='function' && !_isKoreanReply(out)){
      var r2=await callLLMFree(prompt, sys+'\n\n[중요] 직전 답에 한글이 아닌 문자가 섞였다. 한자·외국어를 모두 빼고 자연스러운 한국어로만 다시 써.');
      if(r2 && r2.trim() && _isKoreanReply(r2)) out=r2; else out=_stripForeign(out);
    }
  }catch(e){}
  if(out&&out.trim()){ ans.innerHTML=_piaMdSafe(_piaTrimSentence(out.trim())); return; }
  ans.textContent=_T('지금은 답변을 불러오지 못했어요(무료 AI 혼잡). 잠시 후 다시 시도해줘.','Could not get an answer right now (free AI is busy). Please try again shortly.');
}
function initResultQA(){
  const inp=el('qa-input'), btn=el('qa-send'); if(!btn) return;
  btn.onclick=function(){ askResultQuestion(inp?inp.value:''); };
  /* 한글 조합 중 Enter 는 keydown 이 두 번 오므로 조합 확정용은 무시한다 */
  if(inp) inp.onkeydown=function(e){ if(e.key==='Enter' && !e.isComposing && e.keyCode!==229) askResultQuestion(inp.value); };
  document.querySelectorAll('.qa-quick').forEach(function(b){ b.onclick=function(){ if(inp) inp.value=b.textContent; askResultQuestion(b.textContent); }; });
}

function renderResult() {
  if (typeof Chart === 'undefined') { piaLoadChart(piaChartRerender); return; }   /* [2026-10-10] Chart.js 지연 로드 — 받은 뒤 다시 그린다 */
  try{ if(window.Chart&&Chart.defaults){ Chart.defaults.animation=false; if('animations' in Chart.defaults) Chart.defaults.animations=false; if(Chart.defaults.transitions){ ['active','resize','show','hide'].forEach(function(k){ if(Chart.defaults.transitions[k]) Chart.defaults.transitions[k].animation={duration:0}; }); } } }catch(e){}
  destroyCharts();
  const _sec = document.querySelector('section[data-view="result"]');
  /* 결과 화면 진입마다 프로필 바(이름·학년·반·학교)를 최신 값으로 다시 그린다.
     예전에는 editProfile 저장 시 한 번만 그려서, 검사를 끝내고 결과로 넘어오면
     학교·학년·반이 사라져 보이는 문제가 있었다. */
  try{ if(state.profile && typeof renderProfileBar==='function') renderProfileBar(); }catch(e){}
  const _missing = (typeof missingRequired==='function') ? missingRequired() : [];
  if (_missing.length > 0) {
    if (_sec) Array.prototype.forEach.call(_sec.children, function(c){ if(c.id!=='result-empty') c.classList.add('hidden'); });
    let emp = document.getElementById('result-empty');
    if (!emp && _sec) { emp = document.createElement('div'); emp.id='result-empty'; emp.className='bg-white rounded-2xl border border-slate-200 p-8 text-center'; _sec.insertBefore(emp, _sec.firstChild); }
    if (_sec) _sec.classList.add('pia-locked');
    if (emp) {
      emp.classList.remove('hidden');
      const chips = _missing.map(function(t){ return '<button data-act="showView" data-arg="'+t.id+'" class="bg-rose-100 text-rose-800 px-3 py-1.5 rounded-lg text-sm font-semibold m-1">' + t.label + ' →</button>'; }).join('');
      emp.innerHTML = (window.aipiaCurrentLang==='en')
        ? '<div class="text-4xl mb-3">🔒</div><div class="text-lg font-bold mb-1">Please complete the required tests first</div><p class="text-sm text-slate-500 mb-4">Your report will be available once you finish all <strong>required tests (Free Chat, Big5, RIASEC)</strong>. Remaining required tests: ' + _missing.length + '</p><div class="flex flex-wrap justify-center">' + chips + '</div>'
        : '<div class="text-4xl mb-3">🔒</div><div class="text-lg font-bold mb-1">필수 검사를 먼저 완료해주세요</div><p class="text-sm text-slate-500 mb-4">결과지는 <strong>필수 검사(자유대화·Big5·RIASEC)</strong>를 모두 마친 뒤 볼 수 있어요. 남은 필수 검사 ' + _missing.length + '개:</p><div class="flex flex-wrap justify-center">' + chips + '</div>';
    }
    return;
  }
  if (_sec) _sec.classList.remove('pia-locked');
  const _emp = document.getElementById('result-empty'); if (_emp) _emp.classList.add('hidden');
  if (_sec) Array.prototype.forEach.call(_sec.children, function(c){ if(c.id!=='result-empty') c.classList.remove('hidden'); });
  const big5 = state.results.big5.scores;
  const riasec = state.results.riasec.scores;
  const via = state.results.via.scores;
  const grit = state.results.grit.scores;
  const cesd = state.results.cesd.scores;
  const phqa = state.results.phqa.scores;
  const gad = state.results.gad.scores;

  const reliability = calcReliability();
  const type = inferIntegratedType();
  // \uACB0\uACFC \uC815\uD655\uB3C4\uAC00 50/100 \uBBF8\uB9CC\uC774\uBA74 MBTI\uD615\u00B7\uC720\uD615\uBA85 \uB4F1 \uC815\uBC00 \uB2E8\uC815 \uD45C\uD604\uC744 \uC228\uAE34\uB2E4.
  // (QA 2026-08-22 P0-1) \uC9C4\uB2E8 \uBC30\uC9C0(hero-grade)\uB294 \uD56D\uC0C1 \uC815\uC9C1\uD558\uAC8C \uBCF4\uC5EC\uC900\uB2E4.
  const _acc = (typeof piaAccuracyScore==='function') ? piaAccuracyScore() : { sufficient:true, total:100 };

  // Hero
  el('hero-icon').textContent = _acc.sufficient ? type.icon : '\uD83D\uDCCB';
  el('hero-type').textContent = _acc.sufficient ? _typeField(type,'name') : _T('결과 사용 가능 여부: 보강 필요','Result availability: More data needed');
  el('hero-desc').textContent = _acc.sufficient ? _typeField(type,'desc') : _T('현재 응답만으로는 우세 유형을 확정하기 어렵습니다(정확도 ' + _acc.total + '/100). 검사를 더 완료하거나 다시 천천히 응답해주세요.', 'Based on your responses so far, we cannot yet pinpoint a dominant type (accuracy ' + _acc.total + '/100). Please complete more tests or answer again more slowly.');
  try{
    var _me=el('hero-mbti');
    if(_me){
      if(!_acc.sufficient){ _me.innerHTML=''; }
      else{
        var _mb=big5ToMbti();
        _me.innerHTML = _mb ? '<span style="display:inline-flex;align-items:center;gap:5px;background:var(--rust-tint,#f6e9e2);color:var(--rust-deep,#c4623f);font-weight:800;font-size:12.5px;padding:3px 11px;border-radius:999px;letter-spacing:.02em;">\uD83E\uDDE9 '+_mb.type+(_mb.name?(' \u00B7 '+_mb.name):'')+'</span> <span style="font-size:11px;color:#94a3b8;margin-left:6px;">'+_T('Big5 \uAE30\uBC18 \uCD94\uC815 \uC720\uD615(\uCC38\uACE0\uC6A9)','Big5-based estimated type (for reference)')+'</span>'+(_mb.desc?('<div style="font-size:12px;color:#475569;margin-top:5px;line-height:1.5;">'+_mb.desc+(_mb.strength?(' <b style=\'color:#c4623f\'>'+_T('\uAC15\uC810','Strength')+'</b> '+_mb.strength):'')+(_mb.career?(' \u00B7 <b style=\'color:#4877a6\'>'+_T('\uC5B4\uC6B8\uB9AC\uB294 \uC9C4\uB85C','Suits')+'</b> '+_mb.career):'')+'</div>'):'') : '';
      }
    }
  }catch(e){}
  el('hero-grade').textContent = reliability.grade;
  el('hero-grade-label').textContent = reliability.label + piaRelFrag(reliability, false);
  el('hero-completed').innerHTML = reliability.completed.length ? reliability.completed.map(c => `<span class="pill bg-slate-100 text-slate-700 mr-1 mb-1">${c}</span>`).join('') : '<span class="text-xs text-slate-400">'+_T('완료된 검사 없음','No completed tests')+'</span>';
  el('hero-screening').innerHTML = reliability.screening.length ? reliability.screening.map(c => `<span class="pill bg-purple-100 text-purple-800 mr-1 mb-1">${c}</span>`).join('') : '<span class="text-xs text-slate-400">'+_T('스크리닝 미실시','Screening not done')+'</span>';

  // Big5 chart
  if (big5) {
    el('chart-big5-wrap').classList.remove('hidden');
    piaChartDefer(function(){     charts.big5 = new Chart(el('chart-big5').getContext('2d'), {
      type:'radar',
      data:{ labels:(window.aipiaCurrentLang==='en')?['Extraversion (E)','Agreeableness (A)','Conscientiousness (C)','Emotional Stability','Openness (O)']:['외향(E)','우호(A)','성실(C)','정서안정','개방(O)'],
        datasets:[{ label:'Big5', data:[big5.E, big5.A, big5.C, 100-big5.N, big5.O],
          backgroundColor:'rgba(127,119,221,0.18)', borderColor:'#7F77DD', borderWidth:2 }] },
      options:{ plugins:{legend:{display:false}}, scales:{r:{min:0,max:100,ticks:{stepSize:25}}}, maintainAspectRatio:false }
    }); }, 1);
  } else el('chart-big5-wrap').classList.add('hidden');

  // RIASEC chart
  if (riasec) {
    el('chart-riasec-wrap').classList.remove('hidden');
    piaChartDefer(function(){     charts.riasec = new Chart(el('chart-riasec').getContext('2d'), {
      type:'bar',
      data:{ labels:(window.aipiaCurrentLang==='en')?['Artistic (A)','Social (S)','Investigative (I)','Enterprising (E)','Conventional (C)','Realistic (R)']:['예술A','사회S','탐구I','진취E','관습C','현실R'],
        datasets:[{ data:[riasec.A, riasec.S, riasec.I, riasec.E, riasec.C, riasec.R],
          backgroundColor:['#1D9E75','#5DCAA5','#7F77DD','#EF9F27','#B4B2A9','#888780'], borderRadius:4 }] },
      options:{ indexAxis:'y', plugins:{legend:{display:false}}, scales:{x:{min:0,max:100}}, maintainAspectRatio:false }
    }); }, 1);
  } else el('chart-riasec-wrap').classList.add('hidden');

  // VIA top 5 strengths
  if (via) {
    el('via-wrap').classList.remove('hidden');
    /* 개인 내 상대 순위 + 1~5 원점수 + 본인 평균 대비 수준. 동점은 공동 순위로 표시(viaRank). */
    const _vr = viaRank(via);
    const sorted = _vr ? _vr.items.slice(0, 5) : [];
    el('via-top5').innerHTML = sorted.map(it => `
      <div class="flex items-center gap-3 py-2 border-b border-slate-100 last:border-0">
        <span class="text-[11px] text-slate-400 w-12 whitespace-nowrap">${viaRankLabel(it)}</span>
        <span class="font-semibold text-sm ${window.aipiaCurrentLang==='en'?'w-24':'w-16'}">${_viaName(it.k)}</span>
        <div class="flex-1 bg-slate-100 rounded-full h-2 overflow-hidden">
          <div class="bg-emerald-500 h-2" style="width:${Math.round(it.raw/5*100)}%"></div>
        </div>
        <span class="text-xs text-slate-500 w-24 text-right whitespace-nowrap">${it.raw}/5 · ${viaLevelLabel(it.level)}</span>
      </div>`).join('') + (viaRankNote(_vr, 5) ? '<p class="text-[11px] text-slate-500 mt-2">※ ' + viaRankNote(_vr, 5) + '</p>' : '');
  } else el('via-wrap').classList.add('hidden');

  // Grit
  if (grit) {
    el('grit-wrap').classList.remove('hidden');
    el('grit-overall').textContent = grit.overall;
    el('grit-perseverance').textContent = grit.perseverance;
    el('grit-passion').textContent = grit.passion;
    const interp = grit.overall >= 70 ? _T('높음 — 장기 목표 추구 강함','High — Strong pursuit of long-term goals') : grit.overall >= 50 ? _T('보통','Moderate') : _T('낮음 — 단기 흥미 변동 큼','Low — Interests shift often in the short term');
    el('grit-interp').textContent = interp;
  } else el('grit-wrap').classList.add('hidden');

  // Risk screening
  const riskList = [];
  if (cesd) riskList.push({ name:_T('CES-D 우울 스크리닝','CES-D Depression Screening'), score:cesd.total, max:30, level:cesd.level });
  if (phqa) riskList.push({ name:_T('PHQ-A 청소년 우울','PHQ-A Adolescent Depression'), score:phqa.total, max:27, level:phqa.level, alert: phqa.selfHarm > 0 });
  if (gad) riskList.push({ name:_T('GAD-7 불안','GAD-7 Anxiety'), score:gad.total, max:21, level:gad.level });

  if (riskList.length) {
    el('risk-wrap').classList.remove('hidden');
    el('risk-list').innerHTML = riskList.map(r => `
      <div class="flex items-center gap-3 py-3 border-b border-slate-100 last:border-0">
        <div class="flex-1">
          <div class="text-sm font-semibold">${r.name}</div>
          <div class="text-xs text-slate-500">${_T('점수','Score')} ${r.score} / ${r.max}</div>
        </div>
        <span class="pill ${r.level==='HIGH'?'bg-red-100 text-red-800':r.level==='MEDIUM'?'bg-amber-100 text-amber-800':r.level==='LOW'?'bg-yellow-50 text-yellow-800':'bg-emerald-100 text-emerald-800'}">${r.level || 'NONE'}</span>
        ${r.alert ? '<span class="pill bg-red-100 text-red-800 ml-1">'+_T('자해 신호','Self-harm signal')+'</span>' : ''}
      </div>`).join('');

    // 안전 알림
    const anyHigh = riskList.some(r => r.level === 'HIGH' || r.alert);
    el('safety-banner').classList.toggle('hidden', !anyHigh);
  } else {
    el('risk-wrap').classList.add('hidden');
    el('safety-banner').classList.add('hidden');
  }

  // 추천 진로 — 정확도가 낮으면 별점 순위 대신 '탐색해볼 분야'로만 나열한다.
  // (QA 2026-08-22 P0-1: 낮은 신뢰도에도 직업 Top5를 별점 순위로 단정 표시하던 문제)
  el('careers').innerHTML = _acc.sufficient
    ? _typeField(type,'careers').map((c,i) => `
      <div class="flex items-center gap-3 py-2 border-b border-slate-100 last:border-0">
        <span class="text-amber-500 text-sm">${'★'.repeat(Math.max(0,5-i)).padEnd(5,'☆')}</span>
        <span class="text-sm">${c}</span>
      </div>`).join('')
        : '<div class="text-xs text-slate-500 p-2">'+_T('결과 정확도가 기준(50점) 미만이라 진로 순위를 매기지 않았습니다. 검사를 더 완료하면 표시됩니다.','Result accuracy is below the threshold (50 points), so careers are not ranked. This will appear once you complete more tests.')+'</div>'
      + _typeField(type,'careers').map(c => `
      <div class="flex items-center gap-3 py-2 border-b border-slate-100 last:border-0">
        <span class="text-sm text-slate-400">·</span>
        <span class="text-sm text-slate-500">${c}</span>
      </div>`).join('');

  try { renderDimCharts(big5, riasec, via); } catch(e) { console.warn('차원별 차트 렌더 실패:', e); }
  try { loadLiveCareers(type); } catch(e) { console.warn('라이브 진로 로드 실패:', e); }
  try { renderAutoCareerInfo(type); } catch(e) { console.warn('자동 위키 연동 실패:', e); }
  try { initResultQA(); } catch(e) {}
}

// =================================================================
//  Chat
// =================================================================
const GRADE_CHAT = {
  elem: { greet:[
      '안녕! 난 피아야. 편하게 아무 얘기나 해도 돼. 짧게 말해도 괜찮아!',
      '나는 피아라고 해! 오늘 있었던 일 아무거나 얘기해 줄래?',
      '반가워! 나 피아야. 편하게 얘기해도 괜찮아, 짧아도 돼!',
      '짧게 인사할게, 난 피아야. 요즘 재밌는 거 있으면 말해줘도 좋아.'
    ], quick:['오늘 학교 재밌었어','쉬는 시간에 뭐 했게','내가 좋아하는 거 있어','요즘 좀 속상해','친구랑 놀았어','오늘 급식 맛있었어'] },
  mid:  { greet:[
      '안녕하세요! 저는 AI 피아예요. 편한 속도로 천천히 시작하시면 돼요. 짧게 말씀하셔도 충분해요.',
      '만나서 반가워요, AI 피아예요! 오늘 하루는 어땠어요?',
      '저는 피아라고 해요. 아무 얘기나 좋으니 편하게 시작해 볼까요?',
      '짧게 소개할게요, 저는 AI 피아예요. 정답은 없으니 떠오르는 대로 편하게 말씀해 주세요.'
    ], quick:['오늘 기분이 별로야','친구랑 싸웠어','꿈이 아직 없어','국어 시간이 좋아','요즘 게임이 재밌어','시험이 걱정돼'] },
  high: { greet:[
      '안녕, 난 피아야. 요즘 어떤지 편하게 얘기해줘. 진로든 고민이든 다 좋아.',
      '만나서 반가워, 피아야. 요즘 지내는 얘기 편하게 해줘.',
      '난 피아라고 해. 고민이든 관심사든 편하게 꺼내 봐.',
      '짧게 인사할게, 피아야. 요즘 머릿속에 있는 거 아무거나 얘기해줘.'
    ], quick:['진로가 고민돼','요즘 좀 지쳐','공부 방법을 모르겠어','관심 있는 분야가 있어','성적 때문에 스트레스야','친구 관계가 고민돼'] },
  univ: { greet:[
      '안녕하세요, 저는 피아예요. 요즘 어떤 생각을 하며 지내는지 편하게 들려주세요.',
      '만나서 반가워요, 피아예요. 요즘 지내는 이야기 편하게 들려주세요.',
      '저는 피아라고 해요. 진로든 일상이든 편하게 얘기해 주세요.',
      '짧게 인사드릴게요, 피아예요. 요즘 관심사나 고민, 편하게 나눠 주세요.'
    ], quick:['진로·취업이 고민돼요','전공이 안 맞는 것 같아요','요즘 번아웃 같아요','관심 있는 분야가 있어요','학점 관리가 힘들어요','대인관계가 고민돼요'] },
  adult:{ greet:[
      '안녕하세요, 저는 피아입니다. 요즘 어떤 점이 가장 마음에 걸리시는지 편하게 말씀해 주세요.',
      '만나서 반갑습니다, 피아입니다. 요즘 지내시는 이야기 편하게 들려주세요.',
      '저는 피아라고 합니다. 요즘 마음 쓰이는 일이 있다면 편하게 말씀해 주세요.',
      '짧게 인사드릴게요, 피아입니다. 편하게 이야기 시작해 볼까요?'
    ], quick:['일·진로가 고민돼요','요즘 의욕이 없어요','새로 배우고 싶은 게 있어요','관계가 좀 힘들어요','일과 삶의 균형이 어려워요','건강이 신경 쓰여요'] }
};
const GRADE_CHAT_EN = {
  elem: { greet:[
      "Hi! I'm Pia. Feel free to talk about anything \u2014 even a short answer is totally fine!",
      "I'm Pia! Want to tell me about anything that happened today?",
      "Nice to meet you! I'm Pia. Feel free to chat \u2014 short is fine too!",
      "Quick hello \u2014 I'm Pia. Tell me if anything fun has been going on lately."
    ], quick:["School was fun today","Guess what I did at recess","I have something I really like","I've been a little upset lately","I played with my friend","Lunch was yummy today"] },
  mid:  { greet:[
      "Hi! I'm AI Pia. Let's take it at your own pace \u2014 even a short answer is enough.",
      "Nice to meet you, I'm AI Pia! How was your day today?",
      "I'm Pia. Shall we start with whatever's on your mind?",
      "Quick intro \u2014 I'm AI Pia. There's no right answer, so just share whatever comes to mind."
    ], quick:["I'm not feeling great today.","I had an argument with a friend.","I don't know what I want to do yet.","I enjoy Korean class.","I've been enjoying games lately.","I'm worried about an exam."] },
  high: { greet:[
      "Hey, I'm Pia. Tell me how things have been going \u2014 career stuff, worries, anything.",
      "Nice to meet you, I'm Pia. Feel free to tell me how you've been.",
      "I'm Pia. Bring up whatever's on your mind \u2014 worries or interests, either is fine.",
      "Quick hello, I'm Pia. Tell me whatever's on your mind lately."
    ], quick:["I'm worried about my career path","I've been feeling tired lately","I don't know how to study effectively","There's a field I'm interested in","I'm stressed about my grades","I'm having trouble with a friendship"] },
  univ: { greet:[
      "Hi, I'm Pia. Feel free to share what's been on your mind lately.",
      "Nice to meet you, I'm Pia. Tell me how you've been doing lately.",
      "I'm Pia. Feel free to talk about your career path or everyday life.",
      "Quick hello, I'm Pia. Share whatever interests or concerns you have lately."
    ], quick:["I'm worried about my career and job search","I don't think my major fits me","I think I'm burned out lately","There's a field I'm interested in","Managing my GPA is hard","I'm having relationship troubles"] },
  adult:{ greet:[
      "Hello, I'm Pia. Feel free to share what's been weighing on your mind lately.",
      "Nice to meet you, I'm Pia. Please tell me how you've been.",
      "I'm Pia. If something's been on your mind lately, feel free to share.",
      "Quick hello, I'm Pia. Shall we start chatting?"
    ], quick:["I'm worried about work or my career","I've been lacking motivation lately","There's something new I'd like to learn","Relationships have been difficult","Work-life balance is hard","I've been concerned about my health"] }
};
/* 인사말이 학년마다 늘 같은 한 줄이면 매번 같은 질문처럼 느껴진다.
   위 배열 중 하나를 그때그때 무작위로 고른다(사람마다 다르게 시작). */
function _turnLabel(n){ n = Math.min(12, Math.max(0, +n || 0)); return (window.aipiaCurrentLang==='en') ? (n+' / 12 turns') : (n+' / 12 \ud134'); }
function _pickGreet(g){ return Array.isArray(g) ? g[Math.floor(Math.random()*g.length)] : g; }
const CHAT_SUBTITLE = [
  '편하게 이야기해 주세요. 정답은 없어요.',
  '떠오르는 대로 편하게 말해 주세요.',
  '짧게 답해도 괜찮아요. 편하게 이야기해 주세요.',
  '정답은 없으니 편하게 이야기해 주세요.'
];
const CHAT_SUBTITLE_EN = [
  "Feel free to share whatever is on your mind.",
  "Just say whatever comes to mind.",
  "Short answers are fine \u2014 take it easy.",
  "There's no right answer, so relax and talk."
];

/* 대화가 시작된 뒤(1턴 이상)에는 학년 기본값이 아니라 방금 나눈 대화의 주제에
   맞는 예시를 보여준다. topic 은 detectTopic() 이 매기는 값을 그대로 쓴다. */
const TOPIC_QUICK = {
  '학습/국어': ['책 읽는 건 좋아해','글쓰기는 어려워','국어 시간이 재밌어','발표가 떨려','맞춤법이 헷갈려','독서록이 힘들어'],
  '학습/수학': ['수학이 어려워','계산이 느려서 답답해','도형 모양이 재밌어','수학 시간이 지루해','풀리면 기분이 좋아','천천히 해보고 싶어'],
  '친구관계': ['친구랑 화해하고 싶어','새 친구를 사귀고 싶어','친구가 자꾸 놀려','같이 노는 친구가 좋아','친구랑 오해가 생겼어','혼자 있는 게 편해'],
  '진로': ['잘하는 게 뭔지 모르겠어','이 일이 재밌을 것 같아','부모님이 원하는 길이 있어','아직 하고 싶은 게 없어','좋아하는 걸 직업으로 하고 싶어','미래가 막막해'],
  '가족관계': ['가족이랑 시간 보내는 게 좋아','부모님이랑 자주 다퉈','동생이랑 사이가 안 좋아','집에서 혼나서 속상해','가족이 내 편이 돼줘','집이 편안해'],
  '생활습관/취미': ['게임할 때가 제일 즐거워','휴대폰을 너무 많이 봐','좋아하는 유튜브가 있어','운동은 별로 안 해','시간 관리가 잘 안돼','새로운 취미를 찾고 싶어'],
  '정서': ['요즘 마음이 편치 않아','불안할 때가 있어','기분이 갑자기 가라앉아','혼자 있고 싶을 때가 많아','걱정이 많은 편이야','이야기하니 조금 나아졌어']
};
/* [2026-09-26 복원] 영어 모드 빠른답변. main 8a20942(9/15)에 있던 것이 같은 날 병합(99c2ad9)에서
   운영본 기준 충돌 해결로 빠졌다. 영어 모드에서 은행 문항 대신 이 표를 쓴다. */
const TOPIC_QUICK_EN = {
  '학습/국어': ['I like reading stories','Writing feels a little hard','Korean class was interesting','Presenting makes me nervous','Spelling confuses me sometimes','Book reports take me a while'],
  '학습/수학': ['Math feels hard sometimes','Slow calculations frustrate me','Shapes are kind of fun','Math class feels boring','I feel good when I solve it','I want to try it slowly'],
  '친구관계': ['I want to make up with my friend','I want to make a new friend','A friend keeps teasing me','I like hanging out together','There was a misunderstanding','Being alone feels comfortable'],
  '진로': ["I don't know what I'm good at",'That kind of work sounds fun','My parents have a path in mind',"I don't have a dream yet",'I want my interests to become my job','The future feels unclear'],
  '가족관계': ['I like spending time with family','I argue with my parents sometimes','My sibling and I are not close','I felt upset after getting scolded','I want my family on my side','Home feels comfortable'],
  '생활습관/취미': ['Games are the most fun for me','I look at my phone too much','I have a YouTube channel I like',"I don't exercise much",'Managing time is hard','I want to find a new hobby'],
  '정서': ["I haven't felt very settled lately",'I feel anxious sometimes','My mood suddenly drops','I often want to be alone','I tend to worry a lot','Talking helped a little']
};

/* 빠른 선택은 전송 전 입력을 채우는 보조 기능이다. 선택 직후 별도 AI 요청을
   만들면 다음 학생 답변 요청과 경쟁해 대화가 느려질 수 있으므로, 검수한 기본
   문장만 즉시 보여 준다. */
function selectChatQuickReply(button) {
  var input = document.getElementById('chat-input');
  if (!input || !button) return;
  var value = String(button.textContent || '').replace(/\s+/g, ' ').trim();
  if (!value) return;
  input.value = value;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  var wrap = document.getElementById('chat-quick-wrap');
  if (wrap) {
    wrap.querySelectorAll('.chat-quick').forEach(function(item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
  }
  var help = document.querySelector('.pia-qk__help');
  /* [2026-09-20] 카드를 누르면 바로 보낸다. 입력 블록을 카드 위로 옮기면서 카드를 누른 뒤
     위로 올라가 보내기를 또 눌러야 하는 흐름이 어색해졌다. 카드 = 답이 정해진 것이므로 즉시 전송. */
  if (help) help.textContent = (window.aipiaCurrentLang === 'en') ? 'Sent.' : '보냈어요.';
  var send = document.getElementById('chat-send');
  if (send && !send.disabled) { try { send.click(); } catch (e) { console.error('빠른답변 전송 실패', e); input.focus(); } }
  else input.focus();
}
function bindChatQuickReplies(wrap) {
  if (!wrap) return;
  wrap.querySelectorAll('.chat-quick').forEach(function(button) {
    button.onclick = function() { selectChatQuickReply(button); };
  });
}
function quickBankTopic(topic) {
  var map = {
    '친구관계': 'friends', '학습/국어': 'school', '학습/수학': 'school',
    '생활습관/취미': 'hobby', '진로': 'choice', '가족관계': 'family', '정서': 'general', '일반상담': 'general'
  };
  return map[topic] || 'general';
}
function findQuickBankItem(topic, preferred) {
  var items = _piaFreeChatBank.items || [];
  var kind = quickBankTopic(topic);
  if (preferred && Array.isArray(preferred.quickReplies) && preferred.quickReplies.length >= 4 && Array.isArray(preferred.topics) && preferred.topics.indexOf(kind) >= 0) return preferred;
  var matched = items.filter(function(item){ return item.topics.indexOf(kind) >= 0; });
  if (!matched.length) matched = items.filter(function(item){ return item.topics.indexOf('general') >= 0; });
  if (!matched.length) return null;
  var turns = (state && state.results && state.results.conv && state.results.conv.turns) || 0;
  return matched[turns % matched.length];
}
function replyAlignedTopic(userText, aiReply, fallbackTopic) {
  var userTopic = detectTopic(String(userText || ''));
  var replyTopic = detectTopic(String(aiReply || ''));
  if (userTopic !== '일반상담') return userTopic;
  if (replyTopic !== '일반상담') return replyTopic;
  return fallbackTopic || '일반상담';
}
function renderReplyAlignedQuickReplies(topic, bankNudge) {
  var wrap = document.getElementById('chat-quick-wrap');
  if (!wrap) return;
  var activeTopic = topic || (state && state.results && state.results.conv && state.results.conv.lastTopic) || '일반상담';
  var isEn = window.aipiaCurrentLang === 'en';
  var item = isEn ? null : findQuickBankItem(activeTopic, bankNudge);
  var fallbackMap = isEn ? TOPIC_QUICK_EN : TOPIC_QUICK;
  var defaultFallback = isEn ? ['Can we talk more about that?', 'I see it a little differently', 'I had a similar moment', "I'm not sure yet"] : ['그 얘기 더 해볼래요', '저는 조금 다르게 생각해요', '나도 비슷한 적 있어요', '아직 잘 모르겠어요'];
  var fallback = fallbackMap[activeTopic] || defaultFallback;
  var replies = item && Array.isArray(item.quickReplies) ? item.quickReplies : fallback;
  replies = replies.map(function(value){ return String(value || '').trim(); }).filter(Boolean).slice(0, 6);
  wrap.innerHTML = replies.map(function(t){ return '<button type="button" class="chat-quick pia-qk__b" aria-pressed="false">' + _escHtml(t) + '</button>'; }).join('');
  bindChatQuickReplies(wrap);
  var title = document.getElementById('chat-quick-title');
  if (title) title.textContent = isEn ? 'Choose one if it helps you keep talking' : (item ? '지금 이야기와 맞는 말이에요. 골라 말해도 괜찮아요' : '말문이 막히면 골라도 괜찮아요');
}


/* [2026-09-16] 빠른답변이 AI 질문과 따로 놀던 문제.
 *
 * 예전에는 이 함수가 빈 껍데기였고, 선택지는 renderReplyAlignedQuickReplies 가
 * 문제은행에서만 가져왔다. AI 가 뭘 묻든 상관없이 은행 문항에 딸린 보기가
 * 그대로 떴다. 실제로 이런 화면이 나왔다.
 *
 *   피아: 무슨 재미있는 영상이 있었어?
 *   보기: 친구와 만나는 일이 기대돼 / 하고 싶은 취미가 기대돼 / ...
 *
 * 묻는 말과 답할 말이 어긋나니 학생은 보기를 못 고르고, 고르면 대화가
 * 끊긴다. 은행 기반이라 '검수된 문장'이라는 장점은 있었지만, 맞지 않는
 * 문장은 검수돼 있어도 쓸 수 없다.
 *
 * 내장 브라우저 AI 로 방금 질문에 맞는 보기를 만든다. 기기 안에서 돌고
 * 700~900ms 라 대화 흐름을 끊지 않는다. 실패하면 아무것도 하지 않는다 —
 * 은행 보기가 이미 떠 있으므로 화면이 비지는 않는다. */
async function aiRefreshQuickReplies(aiReply, bankNudge) {
  try {
    var q = String(aiReply || '').trim();
    if (!q) return;
    if (typeof window.callBrowserAI !== 'function') return;

    var _eng = (typeof piaGetChatEngine === 'function') ? piaGetChatEngine() : 'AUTO';
    if (_eng === 'SERVER' || _eng === 'APIKEY') return;   /* 내장을 안 쓰기로 한 경우 */

    /* 영어 모드에서는 보기도 영어여야 한다. AI 는 영어로 묻는데 보기만
       한국어로 뜨면 고를 수가 없다. (2026-09-16) */
    var _en = (window.aipiaCurrentLang === 'en');
    var sys = _en
      ? 'You write answer choices for a student in a conversation. '
        + 'Given the question below, write 4 short replies the student might say. '
        + 'Rules: English only. Each under 6 words. Answer the question directly. '
        + 'All different. Make the last one "Not sure yet". '
        + 'Output exactly four lines, no numbering, no explanation.'
      : '너는 한국 학생이 대화에서 고를 보기를 만든다. '
        + '아래 질문에 학생이 답할 법한 짧은 말 4개를 만들어라. '
        + '규칙: 한국어만. 각 12자 이내. 질문에 직접 답하는 말. '
        + '서로 다른 내용. 마지막 하나는 "잘 모르겠어". '
        + '설명 없이 네 줄로만, 번호나 기호 없이 출력한다.';
    var raw = await Promise.race([
      window.callBrowserAIAux((_en ? 'Question: ' : '질문: ') + q.slice(0, 200), sys),
      piaTimeout(2500, null)
    ]);
    if (!raw) return;

    var items = String(raw).split(/\n+/)
      .map(function(x){ return x.replace(/^[\s\-\*\d.)\u00b7]+/, '').trim(); })
      .filter(function(x){
        if (!x) return false;
        if (_en) return x.length <= 40 && !/[\uac00-\ud7af]/.test(x);   /* 영어 모드: 한글 배제 */
        return x.length <= 16 && !/[a-zA-Z]{3}/.test(x);                 /* 한국어 모드: 영어 배제 */
      })
      .slice(0, 4);
    if (items.length < 3) return;   /* 품질이 안 나오면 은행 보기를 그대로 둔다 */

    var wrap = document.getElementById('chat-quick-wrap');
    if (!wrap) return;
    wrap.innerHTML = items.map(function(t){
      return '<button type="button" class="chat-quick pia-qk__b" aria-pressed="false">' + _escHtml(t) + '</button>';
    }).join('');
    bindChatQuickReplies(wrap);
    try { clearTimeout(window.__piaQkT); wrap.classList.remove('pia-qk--pending'); } catch(e){}
    var title = document.getElementById('chat-quick-title');
    if (title) title.textContent = _en
      ? 'You could answer like this. Tap one to say it'
      : '이렇게 답해도 좋아요. 골라서 말해 보세요';
  } catch (e) {
    if (window.console) console.error('[빠른답변] 생성 실패', e);
  }
}

var _greetGen = 0;
var GREET_TONE = {
  elem:  '초등학생에게 말하듯 반말로, 짧고 다정하게',
  mid:   '중학생에게 말하듯 편안한 존댓말로',
  high:  '고등학생에게 말하듯 살짝 어른스러운 반말로',
  univ:  '대학생에게 말하듯 정중한 존댓말로',
  adult: '성인에게 말하듯 정중하고 차분한 존댓말로'
};
/* 인사말을 매번 AI 가 새로 지어내게 한다. 화면엔 먼저 GRADE_CHAT 의 고정 예시를
   즉시 보여주고(0ms 지연), AI 응답이 도착하면 그 자리 텍스트만 바꿔치기한다. */
var GREET_HIST_KEY = 'pia_greet_hist';
function _greetHistGet(){
  try{ var a = JSON.parse(localStorage.getItem(GREET_HIST_KEY) || '[]'); return Array.isArray(a) ? a : []; }
  catch(e){ return []; }
}
function _greetHistPush(t){
  try{
    var a = _greetHistGet(); a.push(t);
    while (a.length > 8) a.shift();
    localStorage.setItem(GREET_HIST_KEY, JSON.stringify(a));
  }catch(e){}
}
async function aiGenerateGreet(tier){
  var _내턴 = ++_greetGen;
  try{
    if (typeof callLLMFree !== 'function') return;
    var tone = GREET_TONE[tier] || GREET_TONE.mid;
    var g0 = GRADE_CHAT[tier] || GRADE_CHAT.mid;
    var 예시목록 = Array.isArray(g0.greet) ? g0.greet : [g0.greet];
    var 예시 = 예시목록[Math.floor(Math.random()*예시목록.length)];
    var 부제예시 = CHAT_SUBTITLE[Math.floor(Math.random()*CHAT_SUBTITLE.length)];
    var MOOD = ['밝고 경쾌하게','차분하고 다정하게','호기심 어린 말투로','따뜻하게 다독이듯','씩씩하고 명랑하게'];
    var mood = MOOD[Math.floor(Math.random()*MOOD.length)];
    var seed = Math.random().toString(36).slice(2,8);
    var sys = 'AI 인·적성 검사(AI PIA)의 자유대화를 시작하는 화면에 쓸 문구 두 개를 만듭니다. '
      + tone + ', 이번엔 특히 ' + mood + ' 쓰세요. '
      + '(1) greet: 대화 시작 인사말. 2문장 이내로 짧게. 반드시 자신을 AI 피아로 짧게 소개하고, '
      + '편하게·짧게 말해도 된다는 안내를 담아, 마지막은 "오늘은 뭐가 궁금해?" 같은 열린 질문으로 자연스럽게 마무리하세요. '
      + '(2) sub: 화면 위쪽에 작게 뜨는 한 줄 안내문. "정답이 없다", "편하게 말해도 된다"는 취지를 8~20자 내외로 아주 짧게 담으세요. '
      + '아래 예시들과는 다른 표현·다른 단어를 써서 절대 비슷하게 반복하지 마세요. '
      + '다른 설명 없이 반드시 JSON 객체 하나만 출력하세요. 형식: {"greet":"...","sub":"..."}';
    var 이력 = _greetHistGet();
    var 이력문구 = 이력.length ? ('\n최근 이 기기에서 이미 보여준 인사말(절대 겹치지 않게 완전히 새로 쓸 것): '
      + 이력.slice(-4).map(function(x){return '"'+x+'"';}).join(', ')) : '';
    var prompt = '[요청ID:' + seed + ', 화면에 표시하지 말 것]\n'
      + '참고 예시 인사말(그대로 쓰지 말고 완전히 다른 표현으로): "' + 예시 + '"\n'
      + '참고 예시 안내문(그대로 쓰지 말고 완전히 다른 표현으로): "' + 부제예시 + '"' + 이력문구 + '\n'
      + '위와 다른 단어·다른 문장 구조로 JSON 하나만 만들어 주세요.';
    var out = await callLLMFree(prompt, sys);
    if (_내턴 !== _greetGen) return;                                  // 그 사이 다시 시작됐으면 버림
    if (!state.results.conv || state.results.conv.turns !== 0) return; // 이미 대화가 시작됐으면 버림
    if (!out) return;
    var m = String(out).match(/\{[\s\S]*\}/);
    var g0obj = null;
    if (m) { try{ g0obj = JSON.parse(m[0]); }catch(e){ g0obj = null; } }
    if (!g0obj || !g0obj.greet) return;
    var t = String(g0obj.greet).replace(/^[\s"'\u201c\u201d]+|[\s"'\u201c\u201d]+$/g, '').trim();
    if (!t || t.length > 120) return;
    if (이력.indexOf(t) !== -1) return;                               // 최근과 완전히 같으면 방금 뜬 고정 인사말을 그대로 둔다
    var b = document.getElementById('chat-greet-bubble');
    if (b) b.innerHTML = _escHtml(t);
    _greetHistPush(t);
    if (g0obj.sub) {
      var subT = String(g0obj.sub).replace(/^[\s"'\u201c\u201d]+|[\s"'\u201c\u201d]+$/g, '').trim();
      if (subT && subT.length <= 60) {
        var _st = document.getElementById('chat-subtitle');
        if (_st) _st.textContent = subT;
      }
    }
  }catch(e){ if (window.console) console.error('인사말 생성 실패:', e); }
}

function renderChatStarter(){
  /* 대화 화면 진입 즉시 예열. 앞 화면들에서 이미 끝났으면 즉시 반환된다. */
  try { if (typeof piaWarmBrowserAI==='function' && typeof buildSystemPrompt==='function') piaWarmBrowserAI(_piaLMKeyOf(buildSystemPrompt('OPENING',''))); } catch(e){}
  try{ var _tcInit=document.getElementById('chat-turn'); if(_tcInit && typeof _turnLabel==='function'){ _tcInit.textContent=_turnLabel((state.results.conv&&state.results.conv.turns)||0); } }catch(_e){}
  const g=(state.cfg&&state.cfg.grade)||'mid'; var _pl=(window.aipiaCurrentLang==='en')?'en':'ko'; var _hasGCE=(typeof GRADE_CHAT_EN!=='undefined')&&GRADE_CHAT_EN; var _GC=(_pl==='en'&&_hasGCE)?GRADE_CHAT_EN:GRADE_CHAT; const c=_GC[g]||_GC.mid;
  const msgs=document.getElementById('chat-msgs');
  if(msgs && (!state.results.conv || state.results.conv.turns===0)){
    msgs.innerHTML='<div class="flex"><div class="bg-slate-100 max-w-[78%] rounded-2xl rounded-tl-sm px-3 py-2 text-sm" id="chat-greet-bubble">'+_pickGreet(c.greet)+'</div></div>';
    var _st=document.getElementById('chat-subtitle'); if(_st){ var _hasCSE=(typeof CHAT_SUBTITLE_EN!=='undefined')&&CHAT_SUBTITLE_EN; _st.textContent=_pickGreet((_pl==='en'&&_hasCSE)?CHAT_SUBTITLE_EN:CHAT_SUBTITLE); }
    try{ if(_pl!=='en' && typeof aiGenerateGreet==='function') aiGenerateGreet(g); }catch(_e){}
  } else if (msgs && state.results.conv && state.results.conv.turns > 0) {
    /* 대화 중간에 새로고침 등으로 다시 들어온 경우 — #chat-msgs 가 이번 로드에서
       한 번도 안 채워져 syncQ() 가 못 돌고 #pia-chat-q 가 맨 처음 고정 인사말에
       멈춰 있었다. 저장된 마지막 AI 응답을 직접 반영해 화면을 실제 진행 상황과
       맞춘다. (2026-09-03) */
    try{
      var _tr = state.results.conv.transcript;
      var _last = _tr && _tr.length ? _tr[_tr.length-1] : null;
      var _q = document.getElementById('pia-chat-q');
      if (_last && _last.reply && _q) { _q.textContent = String(_last.reply).replace(/\s+/g,' ').trim(); }
    }catch(_e){}
  }
  const wrap=document.getElementById('chat-quick-wrap');
  if(wrap){
    var _turns=(state.results.conv&&state.results.conv.turns)||0;
    if (_turns > 0 && typeof renderReplyAlignedQuickReplies === 'function') {
      /* 대화가 시작된 뒤에는 이전 주제의 고정 답변을 되살리지 않는다. */
      renderReplyAlignedQuickReplies(state.results.conv.lastTopic);
    } else {
      wrap.innerHTML=c.quick.map(function(t){return '<button type="button" class="chat-quick pia-qk__b" aria-pressed="false">'+t+'</button>';}).join('');
      if (typeof bindChatQuickReplies === 'function') bindChatQuickReplies(wrap);
    }
  }
  const gs=document.getElementById('chat-grade'); if(gs) gs.value=g;
}

function initChat() {
  const chat = el('chat-msgs');
  const messageInput = el('chat-input');
  /* [2026-11-02] 대화 신뢰성 ⑤ — 붙여넣은 답은 성실도 신호로 남긴다(내용은 그대로 보낸다) */
  try { if (messageInput && !messageInput.__piaPasteHook) { messageInput.__piaPasteHook = 1; messageInput.addEventListener('paste', function () { window.__piaPasted = true; }); } } catch (e) {}
  const sendBtn = el('chat-send');
  const turnCounter = el('chat-turn');
  loadFreeChatBank().then(function(){
    if (state.results && state.results.conv && state.results.conv.turns > 0) {
      renderReplyAlignedQuickReplies(state.results.conv.lastTopic);
    }
  });

  function appendMsg(text, role) {
    const wrap = document.createElement('div');
    wrap.className = role === 'student' ? 'flex justify-end' : 'flex';
    const bubble = document.createElement('div');
    bubble.className = role === 'student'
      ? 'bg-slate-900 text-white max-w-[78%] rounded-2xl rounded-tr-sm px-3 py-2 text-sm'
      : 'bg-slate-100 max-w-[78%] rounded-2xl rounded-tl-sm px-3 py-2 text-sm';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    chat.appendChild(wrap);
    chat.scrollTop = chat.scrollHeight;
  }

  /* 화면 말풍선·상단 질문·저장 이력·TTS가 서로 다른 문자열을 쓰면
     사용자는 대화가 잘린 것처럼 보거나 자막과 음성이 어긋난다고 느낀다.
     모델 출력은 여기서 한 번만 정리한 뒤, 아래 모든 소비자가 이 원문을 쓴다. */
  function canonicalChatReply(value) {
    var text = String(value == null ? '' : value)
      .replace(/\u0000/g, '')
      .replace(/\uC544\uC774\uACE0[\uC57C\uC544]?[\s!,.~]*/gi, '')
      /* [2026-10-01] OWNER '음... 이런거 제거' — 머뭇거림 말(음…/으음/흠/어…)을 지운다(글·음성 모두). */
      .replace(/(^|[\s.!?])(?:으?음+|흠+|어+)(?:\.{2,}|…|[,~!]|\s)+/g, '$1')
      .replace(/^[\s,!.~]+/, '')
      .replace(/\s+/g, ' ')
      .trim();
    return text || '잠시 연결이 매끄럽지 않아요. 한 번 더 이야기해 줄래요?';
  }

  function syncActiveChatReply(text) {
    var active = document.getElementById('pia-chat-q');
    if (active) active.textContent = text;
  }

  function appendTyping() {
    const wrap = document.createElement('div');
    wrap.className = 'flex';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = '<div class="bg-slate-100 max-w-[78%] rounded-2xl rounded-tl-sm px-3 py-2 text-sm"><span class="pia-typing"><span></span><span></span><span></span></span><span class="pia-typing__txt" role="status" style="margin-left:8px">' + ((window.aipiaCurrentLang==='en') ? 'Thinking\u2026' : '\uC0DD\uAC01 \uC911\u2026') + '</span></div>';
    chat.appendChild(wrap);
    chat.scrollTop = chat.scrollHeight;
    return wrap;
  }
  function removeTyping(node) { try{ clearTimeout(window.__piaWaitT); }catch(e){} if (node && node.parentNode) node.parentNode.removeChild(node); }

  /* [FIX 2026-08-22] AI 응답이 실패(502·타임아웃)하면 아래 send() 안의
     'sendBtn.disabled=false' 줄까지 도달하지 못해 '답변 보내기'가 영구 잠겼다.
     어떤 경로로 끝나든 버튼을 반드시 되살리도록 감싼다. */
  async function send() {
    if (window.__piaSending) return;
    window.__piaSending = true;
    window.__piaSendAt = Date.now();
    try { await _send(); }
    catch(e){ if(window.console) console.error('\uC804\uC1A1 \uC624\uB958:', e); }
    finally {
      window.__piaSending = false;
      try {
        if (sendBtn) sendBtn.disabled = false;
        var _ty=document.querySelector('#chat-messages .pia-typing');
        if(_ty && _ty.parentNode && _ty.parentNode.parentNode) _ty.parentNode.parentNode.remove();
      }catch(_e){}
    }
  }
  /* 안전장치: 어떤 이유로든 15초 넘게 잠겨 있으면 자동 해제 */
  setInterval(function(){
    try{
      if(!sendBtn || !sendBtn.disabled) { window.__sendLockAt = 0; return; }
      if(!window.__sendLockAt){ window.__sendLockAt = Date.now(); return; }
      if(Date.now() - window.__sendLockAt > 15000){
        sendBtn.disabled = false; window.__sendLockAt = 0;
        if(window.console) console.error('전송 버튼 잠김을 자동 해제했습니다.');
      }
    }catch(e){}
  }, 3000);
  async function _send() {
    try { if (!window.__ttsPrimed && ('speechSynthesis' in window)) { var _w=new SpeechSynthesisUtterance(' '); _w.volume=0; speechSynthesis.speak(_w); speechSynthesis.resume(); window.__ttsPrimed=true; } } catch(e){}
    const text = messageInput.value.trim();
    if (!text) return;
    /* [2026-10-21] 12턴이 끝난 상태에서는 어떤 경로(빠른 답변·Enter·마이크)로도 더 보내지 않는다. 13/12 방지. */
    if (state.results.conv.turns >= 12) { try{ messageInput.value=''; if (typeof window.piaChatEnforceDone === 'function') window.piaChatEnforceDone(); }catch(e){} return; }
    const clean = maskPII(text);
    appendMsg(clean, 'student');
    messageInput.value = '';
    if (sendBtn) sendBtn.disabled = true;

    // 대화 차원 점수 누적
    const dims = scoreConvDims(clean);
    for (const [k,v] of Object.entries(dims)) {
      state.results.conv.dims[k] = (state.results.conv.dims[k]||0) + v;
    }
    updateChatProfile();

    // 안전 우선: 정상 답보다 먼저 위험 판정(낱말 → AI 분류, piaChatRiskCheck). 판정이 끝나기 전에는 아무 답도 하지 않는다.
    var _typR = appendTyping();
    const _gate = await piaChatRiskCheck(clean, { transcript: state.results.conv.transcript });
    removeTyping(_typR);
    const risk = _gate.level;
    try { window.piaChatCrisis = { active: piaChatInCrisis(), level: risk, lastTurn: state.results.conv.turns + 1, flag: !!crisisState().flag }; } catch(e) {}
    const topic = detectTopic(clean);
    state.results.conv.lastTopic = topic;
    const mode = (state.cfg && state.cfg.mode) || 'LOCAL';
    const abusive = (typeof detectAbuse==='function') && detectAbuse(clean);

    let reply;
    let bankNudge = null;
    if (risk === 'HIGH') {
      // 고위험 신호는 LLM에 맡기지 않고 안전 응답을 강제
      reply = crisisReply(clean, _gate.category);
    } else if (abusive) {
      // 욕설·공격 표현: 3단계(안내→경고→제한) 모더레이션. LLM에 맡기지 않고 누적 카운트.
      state.results.conv.abuse = (state.results.conv.abuse||0) + 1;
      reply = moderateReply(state.results.conv.abuse);
    } else {
      // 견고한 AI 캐스케이드: (1)설정 엔진(키) → (2)무료 게이트웨이(2중 폴백) → (3)로컬 규칙형
      const typing = appendTyping();
      /* [2026-10-21] 응답 지연 A3 (키오스크 시연 영상: 답한 뒤 약 26초 무응답).
         원인은 아래 캐스케이드가 단계마다 따로 기다리는 것이다. 서버가 늦으면
         (내장 AI 6초) + (서버 4초) + (내장 재시도 2.5초) + (언어 재시도 4.5초)
         + (중복 재생성 최대 4.5초x2) 가 차례로 더해져 26초까지 간다.
         시작 시각을 잡아 15초 예산으로 묶는다. 예산이 끝나면 재시도 단계는 건너뛰고
         이미 받은 답이 있으면 그대로 쓰고, 없으면 규칙형 답변으로 이어 간다.
         7초가 지나도 답이 없으면 '조금만 기다려 주세요' 로 문구를 바꾼다. */
      var _t0 = Date.now();
      var _BUDGET = 15000;
      var _over = function(){ return Date.now() - _t0 >= _BUDGET; };
      var _left = function(ms){ return Math.max(1200, Math.min(ms, _BUDGET - (Date.now() - _t0))); };
      try{ clearTimeout(window.__piaWaitT); }catch(e){}
      window.__piaWaitT = setTimeout(function(){
        try{
          var _s = typing.querySelector('.pia-typing__txt');
          if (_s) _s.textContent = (window.aipiaCurrentLang==='en') ? 'Still thinking... one moment please' : '\uB2F5\uBCC0\uC744 \uC900\uBE44\uD558\uACE0 \uC788\uC5B4\uC694. \uC870\uAE08\uB9CC \uAE30\uB2E4\uB824 \uC8FC\uC138\uC694\u2026';
        }catch(e){}
      }, 7000);
      const stage = inferStage(state.results.conv.turns);
      var _piaChatLangDir = (window.aipiaCurrentLang==='en')
        ? '\n\n[REQUIRED] Reply ONLY in natural English. Do not mix in Korean, Chinese, Japanese, or any other language or script. Always keep a warm, friendly, encouraging tone. [Tone] Be bright, upbeat, and warm! Cheer the person on, express empathy and praise often. Use at most 0-1 light emoji (\uD83D\uDE0A\u2728\uD83D\uDE4C), not more. [No repeats] Never repeat a question or remark you already made earlier in this conversation. Don\'t ask about the same topic twice \u2014 always move the conversation one step forward with a new question or angle.'
        : '\n\n[필수] 반드시 한국어(한글)로만 답한다. 영어·중국어·일본어 등 외국어나 한자(漢字)를 절대 섞지 않는다. 그리고 반드시 편한 해요체로만 답한다. [일상 대화 전용] 시험·평가·채점·정답·문항처럼 말하거나 문제를 내지 않는다. 취미·학교생활·친구·가족·기분·하루 일상에서 자연스럽게 이어간다. [말투] 밝고 편안한 또래 대화처럼, 사용자가 말한 구체적인 상황을 한 번 짚고 답한다. 근거 없는 칭찬·과한 위로·훈수는 하지 않는다. 이모지는 0~1개만 가볍게(\uD83D\uDE0A\u2728\uD83D\uDE4C) 곁들이되 과하지 않게. [반복 금지] 이미 물어봤거나 직전에 한 질문·말은 절대 반복하지 않는다. 같은 주제를 두 번 묻지 말고, 매 답변마다 새로운 질문이나 관점으로 대화를 한 걸음 진전시킨다.';
      bankNudge = selectFreeChatNudge(topic, state.results.conv.turns);
      if (piaChatInCrisis()) bankNudge = null;   /* 위기 지원 모드: 화제 힌트 끔 */
      /* [2026-09-15] 이전 답을 처음부터 알려준다.
         예전에는 중복이 '감지된 뒤'에만 이전 답 목록을 프롬프트에 붙였다.
         그래서 평소에는 모델이 자기가 방금 뭐라고 했는지 모른 채 답했고,
         1.7B 짜리 작은 모델은 같은 표현으로 되돌아가기 쉬웠다. 사후
         재생성보다 애초에 안 겹치게 하는 편이 낫다. */
      var _recentSaid = '';
      try{
        var _rs = (state.results.conv.transcript||[])
          .map(function(t){ return (t&&t.reply)||''; })
          .filter(Boolean).slice(-5);
        if (_rs.length) {
          _recentSaid = '\n\n[이미 한 말 — 겹치지 마라]\n'
            + _rs.map(function(x){ return '- ' + String(x).replace(/\s+/g,' ').slice(0,70); }).join('\n')
            + '\n위 문장들과 같은 표현·같은 질문을 반복하지 마라. 새로운 각도로 물어라.';
        }
      }catch(e){ console.error('[자유대화] 이전 답 수집 실패', e); }
      /* 위기 지원 모드: 단계·화제 지시가 든 평소 프롬프트 대신 지원 전용 프롬프트(piaCrisisSupportSystem)로 답한다 */
      if (piaChatInCrisis()) _recentSaid = piaCrisisSupportDirective();
      /* [2026-11-02] 대화 신뢰성 ① 반구조화 면담 — 다음 답이 다룰 주제(흥미·강점·가치·진로 고민·스트레스)를
         모든 학생에게 같은 순서로 묻게 한다. 짧은 답 뒤에는 같은 주제를 한 번 더(pia-chat-trust.js directive).
         위기 지원 모드·위험 판정 차례에는 붙이지 않는다(위기 흐름이 우선). */
      var _trustDir = '';
      try {
        if (window.piaChatTrust && !piaChatInCrisis()) _trustDir = window.piaChatTrust.directive(state.results.conv.turns + 1,
          (state.results.conv.transcript || []).concat([{ msg: clean, reply: '', pasted: !!window.__piaPasted, risk: risk, crisis: risk === 'HIGH', crisisMode: piaChatInCrisis() }]),
          { en: window.aipiaCurrentLang === 'en', crisis: piaChatInCrisis() });
      } catch (e) { console.error('[자유대화] 면담 주제 지시 실패', e); }
      const sys = (piaChatInCrisis() ? piaCrisisSupportSystem() + _recentSaid : buildSystemPrompt(stage, topic) + _piaChatLangDir + freeChatBankDirection(bankNudge) + _recentSaid + _trustDir)
        /* [2026-10-01] 카메라(표정) 참고 신호 한 줄 — 켜졌을 때만, 영상은 보내지 않는다(pia-camera.js) */
        + ((typeof window.piaCamHint === 'function') ? window.piaCamHint() : '');
      const ctx = buildConvContext(clean);
      const keyed = (mode !== 'LOCAL' && mode !== 'AUTO_FREE');
      let out = null;
      // [엔진 우선순위] 누가 설정을 바꿨든 자유대화는 워커(자동 무료·6공급자 자동 회전)를 먼저 사용한다.
      //  → 특정 키(예: Gemini 무료 하루 20건) 한도 초과로 학생 화면에 429가 뜨는 것을 원천 차단.
      /* 타이핑 말풍선 안에 글자가 실시간으로 쌓이도록 콜백을 넘긴다.
         한국어 가드·중복 가드에서 재생성될 수 있으므로, 최종 확정 전까지는
         이 말풍선이 '미리보기'다. 확정되면 아래에서 정식 말풍선으로 교체한다. */
      /* [나레이션 자막 고도화 2026-09-15]
       *
       * 배선: callLocalAipiaChat(ctx, sys, 9000, _stream) 의 네 번째
       * 인자로 넘어간다. onDelta 가 있으면 프록시 SSE 를 먼저 타고,
       * 첫 조각을 못 받으면 기존 aipia-ai(8000) 경로로 조용히 떨어진다.
       *
       * 서버가 보내는 delta 는 크기가 들쭉날쭉하다(한 글자일 때도, 스무
       * 글자일 때도 있다). 오는 대로 화면에 붙이면 글자가 뭉텅이로 튀어
       * 읽는 리듬이 끊긴다. 받은 것을 쌓아 두고 일정한 속도로 흘려보낸다.
       * 도착 속도가 아니라 읽는 속도에 맞추는 것이 요지다.
       *
       * 1) 문장부호에서 쉰다. 마침표·물음표 뒤에 긴 틈, 쉼표는 짧은 틈.
       *    말하듯 읽히게 한다.
       * 2) 뒤처지면 따라잡는다. 응답이 끝났는데 자막만 느리면 답답하다.
       *    남은 글자가 많을수록 가속한다.
       * 3) requestAnimationFrame 으로 돌린다. setTimeout 은 브라우저 최소
       *    타이머 해상도와 백그라운드 탭 쓰로틀링에 걸려 리듬이 흔들린다.
       *    rAF 는 화면 갱신 주기에 맞춰 돌아 한 프레임에 한 번만 그린다.
       *
       * 스크롤은 프레임당 한 번만 한다. 글자마다 부르면 200자 답변에
       * 스크롤 쓰기가 200회다. (참고: 한 오픈소스 프로젝트가 150토큰
       * 응답에서 scrollTo 37회를 실측했고, 그중 33회가 behavior:'smooth'
       * 라 서로를 끊으며 안정되지 않았다. 여기서는 scrollTop 직접 대입을
       * 쓰므로 그 함정은 없지만, 횟수 자체를 줄이는 편이 낫다.
       * 이 저장소에도 '연속 rAF + 잦은 DOM 갱신이 화면맞춤 옵저버와
       * 되먹임되어 응답 없는 페이지로 멈췄다'는 실측 기록이 있다.)
       *
       * 접근성: prefers-reduced-motion 이면 연출 없이 즉시 표시한다.
       * 흐르는 글자가 방해가 되는 사용자가 있다. */
      var _stream = (function(){
        var body = typing && typing.firstChild;
        var shown = '';          /* 화면에 이미 붙인 부분 */
        var target = '';         /* 서버가 보내온 전체 */
        var raf = null;
        var last = 0;            /* 마지막으로 글자를 붙인 시각 */
        var wait = 0;            /* 다음 글자까지 남은 대기(ms) */
        var done = false;

        var reduce = false;
        try{
          reduce = !!(window.matchMedia &&
                      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        }catch(e){ console.error('[자막] reduced-motion 판별 실패', e); }

        var dotsOff = false;
        function paint(){
          try{ if(body) body.textContent = shown; }catch(e){}
          /* 글자가 흐르기 시작하면 '생각 중' 점 세 개를 끈다.
             글자와 점이 함께 있으면 상태가 두 개로 읽혀 어수선하다.
             (2026-09-15) */
          if (!dotsOff && shown) {
            dotsOff = true;
            try{
              var d = document.querySelector('#chat-messages .pia-typing');
              if (d) d.style.display = 'none';
            }catch(e){}
          }
          try{ var c = el('chat-messages'); if(c) c.scrollTop = c.scrollHeight; }catch(e){}
        }
        /* 방금 붙인 글자에 따라 다음 글자까지의 간격을 정한다. */
        function gapFor(ch, backlog){
          /* [2026-10-01] OWNER '대화 속도를 빠르게' — 글자·쉼 간격을 약 절반으로(18/260/120/200/24 → 10/140/60/100/12). */
          var g = 10;
          if (ch === '.' || ch === '!' || ch === '?') g = 140;
          else if (ch === ',' || ch === '\u00b7') g = 60;
          else if (ch === '\n') g = 100;
          else if (ch === ' ') g = 12;
          /* 밀린 만큼 가속한다. 200자 이상 남으면 거의 즉시 따라잡는다. */
          if (backlog > 200) return 0;
          if (backlog > 90)  return g * 0.25;
          if (backlog > 40)  return g * 0.55;
          return g;
        }
        function frame(now){
          raf = null;
          if (shown.length >= target.length) { if (done) paint(); return; }

          var dt = now - (last || now);
          last = now;
          wait -= dt;

          /* 한 프레임에 여러 글자가 밀렸으면 몰아서 붙이고 그린다.
             그래야 DOM 쓰기가 프레임당 한 번으로 유지된다. */
          var moved = false;
          var guard = 0;
          while (wait <= 0 && shown.length < target.length && guard++ < 4096) {
            var ch = target.charAt(shown.length);
            shown = target.slice(0, shown.length + 1);
            moved = true;
            wait += gapFor(ch, target.length - shown.length);
            if (wait <= 0 && guard >= 4096) break;
          }
          if (moved) paint();
          raf = requestAnimationFrame(frame);
        }
        function push(sofar){
          target = String(sofar || '');
          if (reduce) { shown = target; paint(); return; }
          if (!raf) { last = 0; wait = 0; raf = requestAnimationFrame(frame); }
        }
        /* 스트림이 끝나면 남은 글자를 즉시 채운다. 확정된 답을 두고
           자막만 계속 흐르면 다음 차례가 늦어진다. */
        push.finish = function(){
          done = true;
          if (raf) { cancelAnimationFrame(raf); raf = null; }
          shown = target; paint();
        };
        return push;
      })();
      var _fastMiss = false;
      try {
        /* 네 번째 인자가 자막 콜백이다. 이게 없으면 _stream 이 죽은
           코드가 된다(2026-09-15 배선).

           경쟁 타이머를 손봤다. 예전에는 2.4초 안에 답이 안 오면
           _fastMiss 로 규칙형 폴백을 썼다. 스트리밍에서는 첫 글자가
           0.9~1.8초에 나오고 전체는 20초대라, 그 기준을 그대로 두면
           자막이 흐르는 도중에 규칙형 답변으로 갈아치워진다.

           그래서 첫 조각을 받았는지를 기준으로 삼는다. 글자가 흐르기
           시작했으면 사용자는 이미 답을 읽고 있으므로 끝까지 기다린다.
           아무것도 못 받았으면 예전처럼 2.4초에 폴백한다. */
        var _gotFirst = false;
        var _streamWatch = function(sofar){
          if (!_gotFirst && sofar) _gotFirst = true;
          try{ _stream(sofar); }catch(e){ console.error('[자막] 렌더 실패', e); }
        };
        /* [2026-09-16] 폴백 기준을 2.4초에서 4초로 늘렸다.
           2.4초는 스트리밍 배선 전, 응답이 통째로 오던 때의 값이다.
           스트리밍에서는 '첫 글자가 언제 나오느냐'가 기준이 되는데
           실측해 보니 여유가 거의 없었다.

             짧은 프롬프트 10회   922~1836ms   (여유 564ms)
             실제 시스템 프롬프트 5회 1910~2597ms  -> 1회 초과

           실사용 길이로 재면 5회 중 1회가 2.4초를 넘는다. 그러면 자막이
           흐르기 직전에 규칙형 답변으로 갈아치워진다. 사용자에게는
           'AI가 답하다 말고 딴 소리를 한다'로 보인다.

           4초면 실측 최대(2597ms)에 1.4초 여유가 남는다. 첫 글자를 못
           받은 채 4초를 기다리는 것은 어차피 실패한 요청이라, 늘려도
           손해가 없다. 글자가 흐르기 시작하면 아래에서 끝까지 기다린다. */
        /* [엔진 3단계 2026-09-16]
           사용자가 고른 단계만 쓰거나(BROWSER/SERVER/APIKEY),
           AUTO 면 내장 -> 서버 -> API키 순으로 내려간다. */
        var _eng = (typeof piaGetChatEngine==='function') ? piaGetChatEngine() : 'AUTO';

        /* 1단계 — 내장 브라우저 AI.
           없는 브라우저는 0ms 에 null 이 오므로 기다림이 생기지 않는다. */
        if (_eng === 'AUTO' || _eng === 'BROWSER') {
          /* [2026-09-16] 타임아웃을 3초에서 늘렸다.
             짧은 문장만 재 보고 3초면 넉넉하다고 봤는데 틀렸다. 실제 대화에서는
             시스템 프롬프트(검사 지침 + 화제 은행 + 직전 발화 목록)가 길어
             같은 기기에서 9948ms 가 걸렸다. 그 답은 멀쩡했는데 타임아웃에
             걸려 버려지고 은행 문항으로 떨어졌다.

             BROWSER 를 직접 고른 사람은 기다려서라도 내장으로 받기를
             원한 것이므로 12초까지 준다. AUTO 는 서버라는 대안이 있으니
             6초에서 넘긴다. */
          try {
            out = await Promise.race([ callBrowserAI(ctx, sys, _streamWatch), piaTimeout(_eng === 'BROWSER' ? 12000 : 6000, null) ]);
          } catch (e) { out = null; }
          if (out && out.trim()) {
            if (typeof _piaMarkEngine==='function') _piaMarkEngine('내장 브라우저 AI');
            /* 자막은 이제 callBrowserAI 안에서 promptStreaming 으로 직접
               흐른다(아래 호출에 _streamWatch 를 넘긴다). 여기서는 마지막
               상태만 맞춰 준다. */
            try { _streamWatch(String(out).trim()); } catch(e) { console.error('[자막] 마무리 실패', e); }
          }
        }

        /* 2단계 — 예담 서버 AI (api.yedam.kr/ai).
           서버가 다시 7공급자로 폴백하므로 여기서는 한 번만 부른다. */
        if ((!out || !out.trim()) && (_eng === 'AUTO' || _eng === 'SERVER')) {
          var _fastGuard = (async function(){
            await piaTimeout(4000, null);
            if (_gotFirst) { await piaTimeout(26000, null); }   /* 흐르는 중이면 기다린다 */
            return '__PIA_FAST_LOCAL__';
          })();
          out = await Promise.race([
            callLocalAipiaChat(ctx, sys, 30000, _streamWatch),
            _fastGuard
          ]);
          if (out === '__PIA_FAST_LOCAL__') { _fastMiss = true; out = null; }
          if (out && out.trim() && typeof _piaMarkEngine==='function') _piaMarkEngine('예담 서버 AI');
        }
      } catch (e) { out = null; }
      /* 3단계 — 사용자가 설정 화면에서 넣은 API 키 엔진.
         AUTO 에서는 앞 두 단계가 모두 실패했을 때만 쓴다. APIKEY 를
         직접 고르면 앞 단계를 건너뛰고 여기로 온다. 키가 없으면
         keyed 가 false 라 그냥 넘어간다. */
      if (!_fastMiss && !_over() && (!out || !out.trim()) && keyed && (_eng === 'AUTO' || _eng === 'APIKEY')) {
        try { out = await Promise.race([callLLM(ctx, sys), piaTimeout(_eng === 'APIKEY' ? 12000 : 1800, null)]); } catch (e) { out = null; }
        if (out && out.trim() && typeof _piaMarkEngine==='function') _piaMarkEngine('API 키 (' + (state.cfg && state.cfg.mode || '?') + ')');
      }
      /* 앞에서 이미 내장 AI 를 먼저 시도했다. 여기서 한 번 더 부르는 이유는
         첫 시도 때 세션 생성 중이었을 수 있어서다(콜드 스타트 7초).
         SERVER·APIKEY 를 명시적으로 고른 사람에게는 내장으로 새면 안 된다. */
      if (!_fastMiss && !_over() && (!out || !out.trim()) && (_eng === 'AUTO' || _eng === 'BROWSER')) {
        try { out = await Promise.race([callBrowserAI(ctx, sys), piaTimeout(_eng === 'BROWSER' ? 10000 : 2500, null)]); } catch (e) { out = null; }
        if (out && out.trim() && typeof _piaMarkEngine==='function') _piaMarkEngine('내장 브라우저 AI');
      }
      // 출력 언어 가드: 선택된 언어 이탈 시 1회 재시도 → 실패하면 로컬 응답으로 폴백
      var _piaCurLang = (window.aipiaCurrentLang==='en') ? 'en' : 'ko';
      if (!_fastMiss && out && out.trim() && _over() && !_isReplyInLang(out, _piaCurLang)) { out = null; }   /* 예산 초과: 언어가 틀린 답은 버리고 규칙형으로 */
      if (!_fastMiss && out && out.trim() && !_over() && !_isReplyInLang(out, _piaCurLang)) {
        try {
          var _retryDir = (_piaCurLang==='en')
            ? '\n\n[WARNING] Your last reply was not in English. Reply again in English only, 2-3 sentences.'
            : '\n\n[경고] 직전 출력이 한국어가 아니었다. 오직 한국어(한글)로만 2~3문장으로 다시 답하라.';
          /* [2026-09-16] 재시도가 항상 서버(callLocalAipiaChat)로 갔다.
             BROWSER 를 고른 사람의 발화가 서버로 새고, 서버가 느리거나
             실패하면 내장이 만든 멀쩡한 답까지 null 로 버려졌다.
             고른 엔진으로 재시도한다. */
          var _kr = null;
          if (_eng === 'BROWSER') { _kr = await Promise.race([callBrowserAI(ctx, sys + _retryDir), piaTimeout(_left(4500), null)]); }
          else { _kr = await callLocalAipiaChat(ctx, sys + _retryDir, _left(4500)); }
          out = (_kr && _isReplyInLang(_kr, _piaCurLang)) ? _kr : null;
        }
        catch(e){ out = null; }
      }
      // [반복 방지] 직전 AI 답과 너무 비슷하면 1회 '다른 질문으로' 재생성
      try{
        var _lastRep=((state.results.conv.transcript||[]).slice(-1)[0]||{}).reply||'';
        /* [2026-09-15] 유사도 계산을 고쳤다. 예전에는 a[i]===b[i] 로 같은 자리
           글자만 셌다. '요즘 학교 어때?' 와 '학교 요즘 어때?' 의 유사도가 0 에
           가깝게 나왔고, 앞에 한 글자만 붙어도 전체가 밀려 탐지에 걸리지 않았다.
           중복 방지 장치가 사실상 꺼져 있던 셈이다. 위치를 보지 않는 문자
           2-gram 자카드로 바꾼다. 어순이 달라도 같은 표현이면 잡힌다. */
        var _grams=function(t){ t=String(t||'').replace(/[\s.,!?~\u2026\u00b7]/g,''); var g={}; for(var i=0;i<t.length-1;i++) g[t.slice(i,i+2)]=1; return g; };
        var _simRep=function(a,b){ var A=_grams(a),B=_grams(b),ka=Object.keys(A),kb=Object.keys(B); if(!ka.length||!kb.length)return 0; var it=0; for(var i=0;i<ka.length;i++) if(B[ka[i]]) it++; return it/(ka.length+kb.length-it); };
        var _prevReps=(state.results.conv.transcript||[]).map(function(t){ return (t&&t.reply)||''; }).filter(Boolean);
        var _isDup=function(x){ if(!x||!x.trim())return false; for(var i=0;i<_prevReps.length;i++){ if(_simRep(x,_prevReps[i])>0.42) return true; } return false; };
        var _tries=0;
        while(!_fastMiss && !_over() && out && out.trim() && _isDup(out) && _tries<2){
          _tries++;
          var _asked=_prevReps.slice(-6).map(function(s){ return '- '+String(s).replace(/\s+/g,' ').slice(0,60); }).join('\n');
          var _rr=null;
          /* [2026-09-16] 재생성이 항상 서버로 갔다. BROWSER 를 고른 경우
             서버가 막혀 _rr 이 비고, 그러면 위에서 만든 멀쩡한 내장 답까지
             버려져 규칙형으로 떨어졌다. 고른 엔진으로 재생성한다. */
          var _dupDir = '\n\n[중요] 아래는 이번 대화에서 이미 한 질문이다. 같은 표현·같은 질문을 반복하지 말고 새로운 각도로 물어라.\n' + _asked;
          if (_eng === 'BROWSER') { _rr = await Promise.race([callBrowserAI(ctx, sys + _dupDir), piaTimeout(_left(4000), null)]); }
          else { _rr = await callLocalAipiaChat(ctx, sys + _dupDir, _left(4500)); }
          if(_rr && _rr.trim() && _isReplyInLang(_rr, _piaCurLang)){ out=_rr; if(!_isDup(_rr)) break; }
        }
      }catch(e){}
      /* 응답 속도가 더 중요하다. 서버가 이미 빠르게 왔을 때만 짧게 숨을 고른다. */
      try {
        /* [2026-09-15] 최소 응답 간격을 120ms 에서 늘렸다.
           즉각 응답이 늘 좋은 건 아니다. 사람이 읽고 답하는 데 걸리는
           시간보다 빠르면 '기계가 튀어나온' 느낌이 들어 오히려 대화
           같지 않다(챗봇 응답시간 실험에서 즉시 응답이 사회적 실재감을
           떨어뜨린다는 보고가 있다). 특히 캐시된 폴백이 0ms 에 나올 때
           부자연스럽다.

           다만 길게 붙잡아 두면 답답하므로, 학생이 방금 쓴 글의 길이에
           맞춘다. 짧게 물으면 빨리, 길게 쓰면 조금 더 뜸을 들인다.
           사람이 긴 글을 읽고 답할 때 더 걸리는 것과 같은 리듬이다. */
        /* [2026-10-01] OWNER '대화 속도를 빠르게' — 최대 0.9초 → 0.4초. */
        var _읽기 = Math.min(400, 150 + String(clean || '').length * 6);
        var _남은 = _읽기 - (Date.now() - (window.__piaSendAt || 0));
        if (_남은 > 0) { await new Promise(function(r){ setTimeout(r, _남은); }); }
      } catch(e) { console.error('응답 지연 처리 오류:', e); }
      /* 답이 확정되면 흐르던 자막을 즉시 채운다. 안 그러면 말풍선이
         교체된 뒤에도 타이머가 남아 헛돈다. (2026-09-15) */
      try{ if (_stream && typeof _stream.finish === 'function') _stream.finish(); }catch(e){}
      removeTyping(typing);
      var _usedFallback = !(out && out.trim());
  reply = canonicalChatReply(_usedFallback ? fastEverydayReply(clean, topic, bankNudge) : out);
  /* [2026-10-21] 시간 안에 AI 답이 없어 규칙형으로 이어 갈 때, 왜 답이 다른지 한 줄로 알린다. 다음 말에는 AI 가 다시 답한다. */
  if (_usedFallback && (_fastMiss || _over())) reply = ((window.aipiaCurrentLang==='en') ? 'That took a while, so here is a quick reply. ' : '\uC751\uB2F5\uC774 \uC870\uAE08 \uB2A6\uC5B4\uC84C\uC5B4\uC694. ') + reply;
  /* [2026-10-01] 첫 문장이 학생 말 되풀이면 뺀다(pia-fastvoice.js piaStripEcho, OWNER '질문한 말을 다시 이야기하는 건 빼') */
  try { if (!_usedFallback && typeof window.piaStripEcho === 'function') reply = window.piaStripEcho(reply, clean); } catch (e) { console.error('[chat] 따라 말하기 정리 실패', e); }
  /* [2026-11-02] 대화 신뢰성 — 질문은 한 개만, 12번째(마무리) 답은 질문 없이(평가 하네스 실측: 2개 이상 질문 22%, 마무리에 새 질문) */
  try { if (!_usedFallback && window.piaChatTrust && !piaChatInCrisis() && risk !== 'HIGH') reply = window.piaChatTrust.enforceReply(reply, { wrap: (state.results.conv.turns + 1) >= 12, en: window.aipiaCurrentLang === 'en', crisis: piaChatInCrisis() }); } catch (e) { console.error('[chat] 답 다듬기 실패', e); }
  if (_usedFallback && !window.__piaAiDownNotified) {
    /* AI 서버에 못 닿으면 규칙형 답변으로 대신하는데, 예전에는 아무 표시가 없어
       학교 방화벽에 막힌 학급 전체가 그 사실을 모른 채 검사를 마쳤다. */
    window.__piaAiDownNotified = true;
    try{
      var _b=document.createElement('div');
      _b.setAttribute('role','status');
      _b.style.cssText='background:#FDF3E2;border:1px solid #F0D9A8;color:#7A5A12;padding:10px 14px;border-radius:12px;font-size:13px;margin:10px 0;line-height:1.6;';
      _b.textContent='지금 AI 선생님과 연결이 잘 안 돼서 기본 답변으로 대화하고 있어요. 잠시 뒤 다시 시도해 보거나, 그대로 진행해도 괜찮아요.';
      var _c=el('chat-messages'); if(_c) _c.appendChild(_b);
    }catch(e){}
  }
  if (piaChatInCrisis()) reply = piaCrisisEnsureHelp(reply);
    }

    if(!abusive && state.results.conv.turns < 12) state.results.conv.turns++; // 욕설·비방 메시지는 대화 진행 턴에 누적하지 않음
    state.results.conv.riskHist.push(risk);
    state.results.conv.topics[topic] = (state.results.conv.topics[topic]||0)+1;
    /* [2026-11-02] 대화 신뢰성 ①⑤ — 이 답의 면담 주제와 성실도 신호(짧은 답·반복·무의미·붙여넣기)를 함께 남긴다.
       위기·위기 지원 모드 차례는 crisis/crisisMode 로 표시되어 근거·주제 채움에서 빠진다(pia-chat-trust.js sensitive/usable). */
    var _tSlot = null, _tQ = null, _tPaste = !!window.__piaPasted, _tCrisis = risk === 'HIGH', _tCrisisMode = piaChatInCrisis();
    try {
      if (window.piaChatTrust) {
        var _an = window.piaChatTrust.annotate((state.results.conv.transcript || []).concat([{ msg: clean, reply: reply, risk: risk, abusive: !!abusive, pasted: _tPaste, crisis: _tCrisis, crisisMode: _tCrisisMode }]));
        var _al = _an.items[_an.items.length - 1]; _tSlot = _al.slot; _tQ = _al.q;
      }
    } catch (e) { console.error('[자유대화] 성실도 기록 실패', e); }
    window.__piaPasted = false;
    state.results.conv.transcript.push({ msg:clean, reply, risk, topic, abusive: !!abusive, crisis: _tCrisis, crisisMode: _tCrisisMode,
      bankId: bankNudge ? bankNudge.id : null, t:Date.now(), slot: _tSlot, q: _tQ, pasted: _tPaste });
    try { piaRenderSlotChips(); } catch (e) {}
    save();

    var replyTopic = replyAlignedTopic(clean, reply, topic);
    state.results.conv.lastTopic = replyTopic;
    syncActiveChatReply(reply);
    appendMsg(reply, 'ai');
        try { if (piaChatInCrisis()) { var _qx=document.getElementById('chat-quick-wrap'); if(_qx) _qx.style.display='none'; } else if (state.results && state.results.conv && state.results.conv.turns < 12) { var _qw=document.getElementById('chat-quick-wrap'); if(_qw) _qw.style.display=''; renderReplyAlignedQuickReplies(replyTopic, bankNudge);
          /* AI 보기가 올 때까지 반투명. 2.5초 안에 안 오면 은행 보기를 그대로 확정한다. */
          if(_qw){ _qw.classList.add('pia-qk--pending'); clearTimeout(window.__piaQkT); window.__piaQkT=setTimeout(function(){ try{ _qw.classList.remove('pia-qk--pending'); }catch(e){} }, 2500); }
        } } catch(e){}
    try { if (!piaChatInCrisis() && state.results && state.results.conv && state.results.conv.turns < 12) aiRefreshQuickReplies(reply, bankNudge); } catch(e){}
    /* [FIX] 낭독 시작 전에 인식기를 잠시 멈춘다(스피커 소리를 마이크가 되받는 것 차단).
       낭독이 끝나면 _afterSpeak 가 다시 켠다(_micWant 가 켜져 있을 때만). */
    try{
      if (_globalRecording && typeof _globalRecognition !== 'undefined' && _globalRecognition) {
        try{ _globalRecognition.stop(); }catch(_e){}
      }
      window.__ttsEchoUntil = Date.now() + 1500;
    }catch(_e){}
    if (typeof window.speakReply === 'function') window.speakReply(reply);
    turnCounter.textContent = _turnLabel(state.results.conv.turns);
    if (sendBtn) sendBtn.disabled = false;
    try { messageInput.focus(); } catch(e) {}

    // 대화가 쌓이면 LLM이 직접 성향을 추론(비차단·3턴마다·고위험 제외)
    try { if (risk !== 'HIGH' && !piaChatInCrisis() && state.results.conv.turns >= 3 && state.results.conv.turns % 3 === 0) aiInferTraits(); } catch(e) {}

    /* [2026-08-22] 목표 8턴을 채우면 자유대화를 '종료'한다.
       예전에는 계속 이어갈 수 있어서 끝이 없다고 느꼈고, 8턴 뒤 대화는 채점에도 쓰이지 않는다.
       입력·마이크를 닫고 다음 단계 버튼만 남긴다. */
    if (state.results.conv.turns >= 12 && !state.results.conv._ended) {
      state.results.conv._ended = true;
      try { aiSummarizeConv(); } catch (e) { console.error('[자유대화] 대화 정리 시작 실패', e); }   /* 비차단 — 결과지에 실린다 */
      try { piaChatTrustInterpret(); } catch (e) { console.error('[자유대화] 대화 해석 시작 실패', e); }   /* 비차단 — 결과지에 실린다 */
      try{ _micWant = false; }catch(e){}
      try{ if(typeof piaStopMic==='function') piaStopMic('conv-end'); }catch(e){}
      try{ if(typeof releaseMicStream==='function') releaseMicStream(); }catch(e){}
      setTimeout(() => {
        try{
          /* [2026-09-16] 12/12 가 끝났음을 분명히 알린다.
           *
           * 예전에는 한국어 고정 문구였고 낭독도 되지 않았다. 영어로 대화하던
           * 학생에게 한국어 인사가 나왔고, 음성 안내를 켠 학생은 끝난 줄 몰랐다.
           *
           * 마무리 인사는 AI 가 직접 하도록 한다. 12턴을 함께한 흐름을 이어
           * 받아야 자연스럽다. 실패하면 준비된 문장을 쓴다 — 끝났다는 사실은
           * 어떤 경우에도 반드시 전해야 한다. */
          var _enEnd = (window.aipiaCurrentLang === 'en');
          /* 다음이 무엇인지 말풍선에서도 알려 준다. 완료 화면에는 '다음: 나의 성격'
             이 뜨지만, 음성 안내로만 듣는 학생에게는 '다음 검사'가 무엇인지
             전달되지 않았다. 남은 개수까지 함께 말해 준다. (2026-09-16) */
          var _nextName = '';
          var _leftCnt = 0;
          try {
            var _req = [
              { key:'conv',  ko:'AI와 대화',  en:'Talk with AI' },
              { key:'big5',  ko:'나의 성격',  en:'My Personality' },
              { key:'riasec',ko:'진로 흥미',  en:'Career Interests' }
            ];
            for (var _i = 0; _i < _req.length; _i++) {
              var _c = _req[_i];
              var _ok = (_c.key === 'conv')
                ? (state.results.conv.turns >= 12)
                : (typeof _likertDoneCount === 'function' && _likertDoneCount(_c.key) > 0);
              if (!_ok) { if (!_nextName) _nextName = _enEnd ? _c.en : _c.ko; _leftCnt++; }
            }
          } catch(_e){}

          var _endMsg;
          if (_enEnd) {
            _endMsg = "Thanks for sharing! That's all 12 turns done."
              + (_nextName ? ' Next up is ' + _nextName + (_leftCnt > 1 ? ' — ' + _leftCnt + ' left.' : ' — the last one.') : ' All the required parts are done.');
          } else {
            _endMsg = '이야기 들려줘서 고마워요! 자유대화는 12번 모두 끝났어요.'
              + (_nextName ? ' 다음은 ' + _nextName + '이에요' + (_leftCnt > 1 ? '. ' + _leftCnt + '개 남았어요.' : '. 이게 마지막이에요.') : ' 필수 검사는 모두 끝났어요.');
          }
          appendMsg(_endMsg, 'ai');
          try { if (typeof speakReply === 'function') speakReply(_endMsg); } catch(_e){}

          /* AI 가 만든 마무리 인사로 바꿔 준다. 늦게 와도 화면은 이미
             안내가 떠 있으므로 학생이 기다리지 않는다. */
          (async function(){
            try{
              if (typeof window.callBrowserAI !== 'function') return;
              var _eg = (typeof piaGetChatEngine==='function') ? piaGetChatEngine() : 'AUTO';
              if (_eg === 'SERVER' || _eg === 'APIKEY') return;
              var _sys = _enEnd
                ? ('Write one short warm closing line (under 30 words) to end a friendly 12-turn chat with a student. English only. Say the chat is finished'
                   + (_nextName ? ' and that "' + _nextName + '" comes next' : '') + '. No emoji.')
                : ('학생과 나눈 12번의 대화를 마무리하는 짧고 따뜻한 인사말 한 문장을 쓴다. 한국어만. 40자 안팎. 대화가 끝났다는 것'
                   + (_nextName ? '과 다음이 "' + _nextName + '"이라는 것' : '') + '을 담는다. 이모지 금지.');
              var _r = await Promise.race([ window.callBrowserAIAux(_sys, _sys), piaTimeout(3000, null) ]);
              if (!_r) return;
              _r = String(_r).split(/\n/)[0].trim();
              if (!_r || _r.length > 120) return;
              if (_enEnd && /[\uac00-\ud7af]/.test(_r)) return;
              if (!_enEnd && /[a-zA-Z]{4}/.test(_r)) return;
              var _msgs = document.querySelectorAll('#chat-msgs .msg-ai, #chat-msgs .ai');
              var _last = _msgs[_msgs.length - 1];
              if (_last) _last.textContent = _r;
              try { if (typeof syncActiveChatReply === 'function') syncActiveChatReply(_r); } catch(_e){}
            }catch(_e){ if(window.console) console.error('[마무리] 생성 실패', _e); }
          })();
          /* 입력 UI 잠금 */
          try{
            if (messageInput) { messageInput.value=''; messageInput.disabled = true; messageInput.placeholder = '자유대화가 끝났어요'; }
            if (sendBtn) { sendBtn.disabled = true; sendBtn.style.opacity = '.5'; sendBtn.style.pointerEvents = 'none'; }
            var _mb = el('chat-mic'); if(_mb){ _mb.disabled = true; _mb.style.opacity='.5'; _mb.style.pointerEvents='none'; }
            var _qw = el('chat-quick-wrap'); if(_qw) _qw.style.display = 'none';
            var _ms = el('chat-mic-status'); if(_ms) _ms.textContent = '';
          }catch(_e){}
          /* 예전에는 말풍선 아래에 작은 버튼 두 개만 붙였다.
             시안은 문항 완료와 같은 완료 화면이므로 화면 전체를 그 화면으로 바꾼다. */
          /* [2026-10-21] 완료 화면을 그리고, 안내 문구('N초 뒤 자동으로 이동')와 같은 시간에 실제로 이동한다.
           * 09-15 에 자동 이동을 뺐더니 완료 화면은 '잠시 후 자동으로 이동해요' 라고 말하면서
           * 이동하지 않았다(키오스크 시연 영상 A1: 10초 넘게 그대로). 문구와 동작을 맞춘다:
           * 8초 카운트다운을 화면에 보여 주고, 그 안에 버튼을 누르면 버튼이 우선이다.
           * 완료 화면 생성은 재진입(showView('chat'))에서도 쓰므로 함수로 뺐다. */
          _piaChatDoneScreen(8);
        }catch(e){ if(window.console) console.error('대화 종료 처리 오류:', e); }
      }, 700);
    }
  }

  sendBtn.addEventListener('click', send);
  messageInput.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return;
    if (e.isComposing || e.keyCode === 229) return;   /* 한글 조합 확정용 Enter */
    if (e.shiftKey) return;                          /* 줄바꿈은 그대로 둔다 */
    e.preventDefault();
    send();
  });
  document.querySelectorAll('.chat-quick').forEach(function(button) {
    button.addEventListener('click', function() { selectChatQuickReply(button); });
  });
  try { renderChatStarter(); } catch(e) {}

  turnCounter.textContent = _turnLabel(state.results.conv.turns);
  updateChatProfile();

  /* [2026-10-21] 12턴 완료 처리 (키오스크 시연 영상 A1).
     - 입력 잠금·표시 갱신은 _piaChatLockUI, 완료 화면은 _piaChatDoneScreen 하나로 모았다.
     - 새로고침·재진입(showView('chat'))은 window.piaChatEnforceDone 이 맡는다: 턴이 12를 넘었으면
       12로 되돌리고, 입력을 잠그고, 완료 화면(다음 검사 버튼)을 보여 준다. 대화는 이어지지 않는다. */
  function _piaChatLockUI(){
    try{
      if (messageInput) { messageInput.value=''; messageInput.disabled = true; messageInput.placeholder = '자유대화가 끝났어요'; }
      if (sendBtn) { sendBtn.disabled = true; sendBtn.style.opacity = '.5'; sendBtn.style.pointerEvents = 'none'; }
      var _mb0 = el('chat-mic'); if(_mb0){ _mb0.disabled = true; _mb0.style.opacity='.5'; _mb0.style.pointerEvents='none'; }
      var _qw0 = el('chat-quick-wrap'); if(_qw0) _qw0.style.display = 'none';
      var _ms0 = el('chat-mic-status'); if(_ms0) _ms0.textContent = '';
      if (turnCounter) turnCounter.textContent = _turnLabel(state.results.conv.turns);
    }catch(e){}
  }
  function _piaChatNextRequired(){
    var en = (window.aipiaCurrentLang === 'en');
    var names = en ? { big5:'My Personality', riasec:'Career Interests' } : { big5:'나의 성격', riasec:'진로 흥미' };
    try{
      for (var i = 0; i < REQUIRED_TESTS.length; i++) {
        var t = REQUIRED_TESTS[i];
        if (t.id === 'chat') continue;
        var d = false; try{ d = !!t.done(); }catch(e){}
        if (!d) return { id:t.id, label:(names[t.id] || t.label) };
      }
      return { id:null, label:'' };
    }catch(e){ return { id:'big5', label:names.big5 }; }
  }
  /* autoSecs: 숫자>0 이면 그 초 뒤 자동 이동(카운트다운 표시), 0 이면 자동 이동 없음, 생략하면 진행 중인 카운트다운은 그대로 둔다. */
  function _piaChatDoneScreen(autoSecs){
    try{
      var en = (window.aipiaCurrentLang === 'en');
      var nx = _piaChatNextRequired();
      var wrap = chat.querySelector('.pia-chatdone');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'pia-chatdone';
        try{
          wrap.innerHTML = piaDoneHTML({
            제목: en ? 'Chat finished' : 'AI와 대화를 마쳤어요',
            부제: nx.id ? (en ? ('Up next: ' + nx.label) : ('이어서 ' + nx.label + ' 차례예요')) : (en ? 'All required assessments are done' : '필수 검사를 모두 마쳤어요'),
            안내: en ? 'Thanks for sharing! Take your time with the rest.' : '이야기 고마워요! 남은 검사도 편하게 진행해 주세요.',
            다음id: nx.id, 다음라벨: nx.label
          });
        }catch(e){
          console.error('대화 완료 화면 생성 실패:', e);
          wrap.innerHTML = '<button data-act="showView" data-arg="' + (nx.id || 'result') + '" class="pia-btn pia-btn--primary">' + (nx.id ? ((en ? 'Next: ' : '다음: ') + nx.label) : (en ? 'View Full Report' : '통합 결과 보기')) + '</button>';
        }
        chat.appendChild(wrap);
        chat.scrollTop = chat.scrollHeight;
      }
      var p = wrap.querySelector('.pia-done__auto');
      if (autoSecs === undefined) {
        if (!wrap.__piaAutoT && p) p.style.display = 'none';
        return wrap;
      }
      if (wrap.__piaAutoT) { clearInterval(wrap.__piaAutoT); wrap.__piaAutoT = null; }
      if (!(autoSecs > 0)) { if (p) p.style.display = 'none'; return wrap; }
      var target = nx.id || 'result';
      var left = autoSecs;
      var label = function(){
        return en ? ('Moving on in ' + left + 's')
                  : (left + '초 뒤 자동으로 ' + (nx.id ? '다음 검사' : '결과지') + '로 이동해요');
      };
      if (p) { p.style.display = ''; p.textContent = label(); }
      wrap.__piaAutoT = setInterval(function(){
        try{
          var sec = document.querySelector('section[data-view="chat"]');
          if (!wrap.isConnected || !sec || sec.classList.contains('hidden')) { clearInterval(wrap.__piaAutoT); wrap.__piaAutoT = null; return; }
          left--;
          if (left <= 0) { clearInterval(wrap.__piaAutoT); wrap.__piaAutoT = null; showView(target); return; }
          if (p) p.textContent = label();
        }catch(e){ clearInterval(wrap.__piaAutoT); wrap.__piaAutoT = null; }
      }, 1000);
      return wrap;
    }catch(e){ console.error('[자유대화] 완료 화면 오류', e); }
  }
  window.piaChatDoneScreen = _piaChatDoneScreen;
  window.piaChatEnforceDone = function(){
    try{
      var c = state.results && state.results.conv; if (!c) return;
      if (c.turns > 12) { c.turns = 12; try{ save(); }catch(e){} }
      if (c.turns >= 12) {
        _piaChatLockUI();
        _piaChatDoneScreen();
      } else {
        /* 초기화·새 학생: 앞 사람의 완료 화면과 잠금이 남아 있으면 걷어 낸다. */
        var old = chat.querySelector('.pia-chatdone'); if (old) { if (old.__piaAutoT) clearInterval(old.__piaAutoT); old.remove(); }
        if (messageInput && messageInput.disabled && messageInput.placeholder === '자유대화가 끝났어요') {
          messageInput.disabled = false; messageInput.placeholder = '';
          if (sendBtn) { sendBtn.disabled = false; sendBtn.style.opacity = ''; sendBtn.style.pointerEvents = ''; }
          var _mbu = el('chat-mic'); if (_mbu) { _mbu.disabled = false; _mbu.style.opacity = ''; _mbu.style.pointerEvents = ''; }
        }
        if (turnCounter) turnCounter.textContent = _turnLabel(c.turns);
      }
    }catch(e){ console.error('[자유대화] 완료 상태 점검 오류', e); }
  };
  try{ if (state.results.conv.turns >= 12) window.piaChatEnforceDone(); }catch(e){}

  // ========== 음성 입력 (Web Speech API) ==========
  const micBtn = el('chat-mic');
  const micStatus = el('chat-mic-status');
  const ttsToggle = el('chat-tts');
  let recognition = null;
  let recording = false;
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (SR) {
    recognition = new SR();
    recognition.lang = (window._chatLang) || (navigator.language) || 'ko-KR';
    recognition.interimResults = true;
    recognition.continuous = false;
    recognition.onresult = (e) => {
      let finalText = '';
      let interimText = '';
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const r = e.results[i];
        if (r.isFinal) { var _c=r[0].confidence; var _mob=(typeof isMobile==='function'&&isMobile()); var passConf=!(typeof _c==='number'&&_c>0&&_c<0.4); var passVad=_mob||(typeof vadHasVoice!=='function')||vadHasVoice(); if(passConf&&passVad) finalText += r[0].transcript; }
        else interimText += r[0].transcript;
      }
      if (interimText) {
        micStatus.textContent = '듣는 중: ' + interimText.slice(0, 30);
      }
      if (finalText) {
        messageInput.value = finalText.trim();
        micStatus.textContent = '인식 완료';
      }
    };
    recognition.onend = () => {
      recording = false;
      micBtn.innerHTML = window.__piaMicHTML();
      micBtn.classList.remove('bg-red-700','animate-pulse');
      /* no red bg after recording */
      if (messageInput.value.trim()) {
        setTimeout(send, 200);
      } else {
        micStatus.textContent = '';
      }
    };
    recognition.onerror = (e) => {
      micStatus.textContent = '오류: ' + e.error;
      recording = false;
      micBtn.innerHTML = window.__piaMicHTML();
      micBtn.classList.remove('bg-red-700','animate-pulse');
      /* no red bg after recording */
    };
    micBtn.addEventListener('click', () => {
  try {
    if (window._piaRec) { try { window._piaRec.stop(); } catch(e) {} return; }
    var SRc = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SRc) { try { micStatus.textContent = '⚠️음성 입력 미지원'; } catch(e){} return; }
    var r = new SRc();
    r.lang = (window._chatLang) || 'ko-KR';
    r.continuous = false; r.interimResults = false; r.maxAlternatives = 1;
    window._piaRec = r;
    try { messageInput.value = ''; } catch(e){}
    micBtn.innerHTML = window.__piaMicHTML('', true);
    try { micBtn.classList.remove('bg-rose-500'); micBtn.classList.add('bg-red-700','animate-pulse'); } catch(e){}
    try { micStatus.textContent = '듣는 중… 말씀하세요'; } catch(e){}
    r.onresult = function(ev){ try { var tr=''; for (var i=0;i<ev.results.length;i++){ tr += ev.results[i][0].transcript; } tr=(tr||'').trim(); if (tr){ messageInput.value = tr; try{ micStatus.textContent='인식 완료'; }catch(e){} } } catch(e){} };
    r.onerror = function(ev){ try { if (ev && (ev.error==='not-allowed' || ev.error==='service-not-allowed')) micStatus.textContent='마이크 권한을 허용해 주세요'; else micStatus.textContent='다시 한 번 눌러 말씀해 주세요'; } catch(e){} };
    r.onend = function(){ window._piaRec = null; micBtn.innerHTML = window.__piaMicHTML(); try { micBtn.classList.remove('bg-red-700','animate-pulse'); /* no red bg after recording */ } catch(e){} };
    r.start();
  } catch(err) {
    window._piaRec = null;
    try { micBtn.innerHTML = window.__piaMicHTML(); micBtn.classList.remove('bg-red-700','animate-pulse'); micStatus.textContent = '시작 실패 — 다시 눌러 주세요'; } catch(e){}
  }
});
  } else {
    micBtn.disabled = true;
    micBtn.title = '이 브라우저는 음성 인식을 지원하지 않습니다 (Chrome·Edge 권장).';
    micStatus.textContent = '⚠ 음성 입력 미지원';
  }

}

// =================================================================
//  Settings
// =================================================================
// =================================================================
//  HuggingFace 연동 (브라우저 fetch + Bearer HF_TOKEN)
// =================================================================
function _hfTok(){ return ''; } /* 2026-09-26 개인 HF 토큰 경로 폐지 — 서버(OpenRouter)만 사용 */
async function hfEmotion(text){
  if(!text) return null;
  const model=(state.cfg&&state.cfg.hfEmotionModel)||'matthewburke/korean_sentiment';
  // 1차: 서버 워커(키 불필요·전 기기 자동)
  try{
    const r=await fetch(PIA_CHAT_PROXY+'&task=emotion',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({text:text,model:model})});
    if(r.ok){ const j=await r.json().catch(function(){return null;}); if(j && !j.error) return j; }
  }catch(e){}
  // 2차: 이 브라우저에 저장된 개인 HF 토큰(있을 때만)
  const tok=_hfTok(); if(!tok) return null;
  try{
    const res=await fetch('https://api-inference.huggingface.co/models/'+model,{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},body:JSON.stringify({inputs:text})});
    if(!res.ok) return null; return await res.json();
  }catch(e){ return null; }
}
async function hfTranscribe(file){
  if(!file) return null;
  const model=(state.cfg&&state.cfg.hfSttModel)||'openai/whisper-large-v3';
  const buf=await file.arrayBuffer();
  // 1차: 서버 워커(키 불필요·전 기기 자동)
  try{
    const r=await fetch(PIA_CHAT_PROXY+'&task=stt&model='+encodeURIComponent(model),{method:'POST',headers:{'Content-Type':(file.type||'application/octet-stream')},body:buf});
    if(r.ok){ const j=await r.json().catch(function(){return null;}); const t=j&&(j.text||(Array.isArray(j)&&j[0]&&j[0].text)); if(t) return t; }
  }catch(e){}
  // 2차: 개인 HF 토큰(있을 때만)
  const tok=_hfTok(); if(!tok) return null;
  try{
    const res=await fetch('https://api-inference.huggingface.co/models/'+model,{method:'POST',headers:{'Authorization':'Bearer '+tok},body:buf});
    if(!res.ok) return null; const j=await res.json(); return j.text || (Array.isArray(j)&&j[0]&&j[0].text) || '';
  }catch(e){ return null; }
}
/* ── 커리어넷 OpenAPI 호출 ────────────────────────────────────────────
   예전에는 인증키를 이 파일에 평문으로 박아 뒀다. 이 저장소는 공개라
   키가 그대로 노출됐다(라이브 소스에서도 보였다).

   이제 Cloudflare Worker 의 fwd(정부 API 프록시)를 경유한다.
     · Worker 가 career.go.kr 요청에 CAREERNET_KEY 를 자동으로 붙인다
       (worker.js: tu.searchParams.set('apikey', env.CAREERNET_KEY))
     · 키는 Cloudflare Secret 에만 있고 브라우저로 나가지 않는다
     · 허용 호스트 목록(GOV_HOSTS)이 있어 아무 주소나 못 부른다
     · 커리어넷은 CORS 를 막아 두어 어차피 프록시가 필요하다

   사용자가 설정에서 개인 키를 저장했다면 그 키를 붙여 보낸다.
   Worker 는 apikey 파라미터가 이미 있으면 덮어쓰지 않는다. */
var CAREERNET_WORKER = 'https://api.yedam.kr/ai?t=90fa660460d9cfb36d2d01c1ca36f00cd7c30c820771435e0e74f3849e008b54';
var CAREERNET_KEY = '';   // 소스에 키를 두지 않는다. Worker Secret 이 담당한다.

/* 커리어넷 API 주소를 만들어 Worker fwd 로 감싼다.
   op: 'list' | 'questions' | 'report' | 'raw'
   key 가 빈 문자열이면 apikey 를 붙이지 않는다 → Worker 가 채운다. */
function careernetUrl(op, q, key, rawUrl) {
  var base = 'https://www.career.go.kr/inspct/openapi/test';
  var target;
  if (op === 'raw') target = rawUrl || '';
  else if (op === 'list') target = base;
  else if (op === 'questions') target = base + '/questions?q=' + encodeURIComponent(q || '');
  else if (op === 'report') target = base + '/report';
  else target = base;

  if (key && target.indexOf('apikey=') < 0) {
    target += (target.indexOf('?') >= 0 ? '&' : '?') + 'apikey=' + encodeURIComponent(key);
  }
  return CAREERNET_WORKER + '&task=fwd&url=' + encodeURIComponent(target);
}
var CN_ACTIVE=null; // 커리어넷 검사 렌더 대상 컨테이너(설정 패널 또는 홈 모달)
function initCareernet(){
  var i=el('cfg-careernet'); if(!i) return;
  i.value=(state.cfg&&state.cfg.careernet)||CAREERNET_KEY;
  var st=el('careernet-status'), box=el('careernet-result');
  var sv=el('careernet-save'); if(sv) sv.addEventListener('click',function(){
    state.cfg=Object.assign({},state.cfg,{careernet:(i.value||'').trim()}); save();
    if(st) st.textContent=state.cfg.careernet?'✅ 키 저장됨 (이 브라우저에 보관)':'⚠ 키가 비어 있습니다.';
  });
  var ls=el('careernet-list'); if(ls) ls.addEventListener('click',function(){
    if(!box) return; box.classList.remove('hidden'); CN_ACTIVE=box; careernetRenderList(box);
    if(st) st.textContent='커리어넷 진로심리검사 '+CAREERNET_TESTS.length+'종 — 검사를 선택하세요';
  });
}
function initPayEngineKeys(){
  // Stripe
  var pk=el('cfg-stripe-pk'), lk=el('cfg-stripe-link'), sst=el('stripe-status');
  if(pk) pk.value=(state.cfg&&state.cfg.stripePk)||'';
  if(lk) lk.value=(state.cfg&&state.cfg.stripeLink)||'';
  var sv=el('stripe-save'); if(sv) sv.addEventListener('click',function(){
    state.cfg=Object.assign({},state.cfg,{stripePk:(pk&&pk.value||'').trim(),stripeLink:(lk&&lk.value||'').trim()}); save();
    if((state.cfg.stripePk||'').indexOf('sk_')===0){ if(sst){sst.style.color='#b91c1c';sst.textContent='⚠ 시크릿키(sk_)는 넣지 마세요! 공개키(pk_)만 사용하세요.';} return; }
    if(sst){sst.style.color='';sst.textContent='✅ 저장됨 (이 브라우저에 보관)';}
  });
  var op=el('stripe-open'); if(op) op.addEventListener('click',function(){
    var url=(state.cfg&&state.cfg.stripeLink)||(lk&&lk.value)||'';
    if(!/^https:\/\/(buy\.stripe\.com|checkout\.stripe\.com)/.test(url)){ if(sst){sst.style.color='#b91c1c';sst.textContent='⚠ 유효한 Stripe 결제 링크(https://buy.stripe.com/...)를 입력하세요.';} return; }
    window.open(url,'_blank','noopener');
  });
  // Anthropic quick-switch
  var qc=el('cfg-claude-quick'), cst=el('cfg-claude-status');
  if(qc) qc.addEventListener('click',function(){
    var m=el('cfg-mode'); if(m){ m.value='CLAUDE_HAIKU'; try{ m.dispatchEvent(new Event('change')); }catch(_){}}
    var k=el('cfg-key'); if(k){ k.focus(); }
    if(cst) cst.textContent='엔진을 Claude로 설정 — API Key 칸에 sk-ant-... 키를 넣고 저장하세요.';
  });
}
function careernetRenderList(box){
  box.innerHTML = CAREERNET_TESTS.map(function(t){
    return '<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid #eee">'
      +'<b style="min-width:150px;font-size:13px">'+t.name+'</b><span style="color:#888;font-size:11px">'+t.n+'문항</span>'
      +'<button data-cnq="'+t.q+'" class="bg-blue-600 text-white px-2 py-1 rounded text-[11px]" style="margin-left:auto">문항 보기</button>'
      +'<button data-cnrun="'+t.q+'" data-cnname="'+t.name+'" class="bg-emerald-600 text-white px-2 py-1 rounded text-[11px]">검사 시작</button></div>';
  }).join('') + '<div id="cn-qout" style="margin-top:8px;color:#444"></div>';
  box.querySelectorAll('[data-cnq]').forEach(function(b){ b.onclick=function(){ careernetLoadQuestions(b.getAttribute('data-cnq')); }; });
  box.querySelectorAll('[data-cnrun]').forEach(function(b){ b.onclick=function(){ careernetRunTest(b.getAttribute('data-cnrun'), b.getAttribute('data-cnname')); }; });
}
function openCareernetModal(){
  var ov=document.createElement('div'); ov.style.cssText='position:fixed;inset:0;z-index:100000;background:rgba(20,20,19,.5);display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow:auto';
  var m=document.createElement('div'); m.className='bg-white rounded-2xl'; m.style.cssText='max-width:640px;width:100%;padding:18px';
  m.innerHTML='<div style="display:flex;align-items:center;margin-bottom:6px"><h3 style="font-weight:800;font-size:16px">🧭 커리어넷 공식 진로심리검사</h3><button id="cn-modal-x" style="margin-left:auto;font-size:18px;line-height:1">✕</button></div>'
    +'<p style="font-size:12px;color:#666;margin-bottom:10px">국가 표준화 검사(교육부·한국직업능력연구원)를 선택해 응답하면 공식 결과를 받고, 예담 톡 결과지에 교차검증 카드로 추가됩니다.</p><div id="cn-modal-box"></div>';
  ov.appendChild(m); document.body.appendChild(ov);
  var close=function(){ CN_ACTIVE=null; ov.remove(); };
  m.querySelector('#cn-modal-x').onclick=close;
  ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
  CN_ACTIVE=m.querySelector('#cn-modal-box'); careernetRenderList(CN_ACTIVE);
}
var CAREERNET_TESTS=[
  {q:1, name:'직업적성검사(중·고)', n:59},
  {q:10,name:'직업적성검사(간편형)', n:49},
  {q:4, name:'직업흥미검사 K형', n:96},
  {q:5, name:'직업흥미검사 H형', n:96},
  {q:6, name:'직업가치관검사', n:28},
  {q:7, name:'진로성숙도검사', n:64},
  {q:12,name:'진로성숙도검사(확장)', n:157},
  {q:8, name:'진로개발역량검사', n:35},
  {q:9, name:'전공·학습 흥미검사(대학)', n:107}
];
async function careernetLoadQuestions(q){
  var out=(CN_ACTIVE&&CN_ACTIVE.querySelector('#cn-qout'))||document.getElementById('cn-qout'); var key=(state.cfg&&state.cfg.careernet)||CAREERNET_KEY;
  if(!key){ if(out) out.textContent='⚠ 먼저 커리어넷 API 키를 저장하세요.'; return; }
  if(out) out.textContent='🔌 q='+q+' 문항 불러오는 중…';
  try{
    var r=await fetch(careernetUrl('questions', q, key));
    var j=await r.json();
    if(j&&j.SUCC_YN==='Y'&&j.RESULT){ var arr=Array.isArray(j.RESULT)?j.RESULT:[j.RESULT];
      if(out) out.innerHTML='✅ '+arr.length+'문항 수신 · 첫 문항: <i>'+String((arr[0]&&arr[0].question)||'').replace(/<[^>]+>/g,' ').slice(0,80)+'</i>'; }
    else if(out) out.textContent='⚠ 실패('+r.status+'): '+JSON.stringify(j).slice(0,120);
  }catch(e){ if(out) out.textContent='⚠ 오류: '+e.message; }
}
async function careernetRunTest(q, name){
  var box=CN_ACTIVE||document.getElementById('careernet-result'); if(!box) return;
  /* AK(Supabase 공개키)는 더 이상 쓰지 않는다 — 커리어넷은 Worker fwd 경유 */
  var key=(state.cfg&&state.cfg.careernet)||CAREERNET_KEY;
  box.classList.remove('hidden'); box.innerHTML='🔌 '+name+' 문항 불러오는 중…';
  var j; try{ j=await fetch(careernetUrl('questions', q, key)).then(function(r){return r.json();}); }
  catch(e){ box.textContent='⚠ 문항 오류: '+e.message; return; }
  if(!j||j.SUCC_YN!=='Y'||!j.RESULT){ box.textContent='⚠ 문항 로드 실패'; return; }
  var qs=Array.isArray(j.RESULT)?j.RESULT:[j.RESULT];
  var gd=(state.profile&&state.profile.grade)||''; var defT=/대학|성인|일반|adult|univ/i.test(gd)?'100211':(/고/.test(gd)?'100210':'100209');
  var h='<div style="font-weight:700;margin-bottom:6px">'+name+' · 총 '+qs.length+'문항</div>';
  h+='<div style="display:flex;gap:10px;margin-bottom:8px;font-size:11px"><label>대상 <select id="cn-trget"><option value="100209"'+(defT==='100209'?' selected':'')+'>중학생</option><option value="100210"'+(defT==='100210'?' selected':'')+'>고등학생</option><option value="100211"'+(defT==='100211'?' selected':'')+'>대학·일반</option></select></label><label>성별 <select id="cn-gender"><option value="100323">남</option><option value="100324">여</option></select></label></div>';
  h+='<div style="max-height:320px;overflow:auto;border:1px solid #eee;border-radius:8px;padding:8px">';
  qs.forEach(function(it,idx){ var qn=idx+1; var ans=[]; for(var a=1;a<=30;a++){ var kk='answer'+(a<10?'0'+a:a); var v=it[kk]; if(v==null||v==='') break; ans.push(v); }
    h+='<div style="padding:6px 0;border-bottom:1px solid #f0f0f0"><div style="font-size:12px;margin-bottom:3px">'+qn+'. '+String(it.question).replace(/<[^>]+>/g,' ')+'</div><div style="display:flex;flex-wrap:wrap;gap:8px">'+ans.map(function(label,ai){ return '<label style="font-size:11px;white-space:nowrap"><input type="radio" name="cnq'+qn+'" value="'+(ai+1)+'"> '+label+'</label>'; }).join('')+'</div></div>';
  });
  h+='</div><div style="margin-top:8px"><button id="cn-submit" class="bg-emerald-600 text-white px-3 py-1.5 rounded text-xs">결과 받기</button> <button id="cn-allfirst" class="bg-slate-200 px-2 py-1 rounded text-[11px]">데모: 모두 1번</button> <span id="cn-submsg" style="font-size:11px"></span></div>';
  box.innerHTML=h;
  document.getElementById('cn-allfirst').onclick=function(){ qs.forEach(function(_,idx){ var f=box.querySelector('input[name="cnq'+(idx+1)+'"]'); if(f) f.checked=true; }); };
  document.getElementById('cn-submit').onclick=async function(){
    var msg=document.getElementById('cn-submsg'); var parts=[]; var miss=0;
    for(var qn=1;qn<=qs.length;qn++){ var sel=box.querySelector('input[name="cnq'+qn+'"]:checked'); if(sel) parts.push(qn+'='+sel.value); else miss++; }
    if(miss>0){ msg.style.color='#c0392b'; msg.textContent='미응답 '+miss+'개 — 모두 응답해 주세요.'; return; }
    msg.style.color='#555'; msg.textContent='결과 생성 중…';
    var body={ apikey:key, qestrnSeq:String(q), trgetSe:document.getElementById('cn-trget').value, gender:document.getElementById('cn-gender').value, grade:'4', startDtm:Date.now(), answers:parts.join(' ') };
    try{
      var r=await fetch(careernetUrl('report', '', key),{method:'POST',headers:{'Content-Type':'application/json','x-fwd-method':'POST'},body:JSON.stringify(body)});
      var rj=await r.json();
      if(rj&&rj.SUCC_YN==='Y'&&rj.RESULT&&rj.RESULT.url){
        try{ var arr=JSON.parse(localStorage.getItem('pia_cn_results')||'[]'); arr=arr.filter(function(x){return String(x.q)!==String(q);}); arr.push({q:String(q),name:name,url:rj.RESULT.url,seq:rj.RESULT.inspctSeq,ts:Date.now()}); localStorage.setItem('pia_cn_results',JSON.stringify(arr)); }catch(_){}
        msg.innerHTML='✅ 완료 — <a href="'+rj.RESULT.url+'" target="_blank" rel="noopener" style="color:#2563eb;font-weight:700">커리어넷 결과 보기 ↗</a> · 결과지에 카드로 추가됨';
        try{ if(typeof renderExtendedSections==='function') renderExtendedSections(); }catch(_){}
      }
      else { msg.style.color='#c0392b'; msg.textContent='⚠ 실패: '+String(rj.ERROR_REASON||JSON.stringify(rj)).slice(0,120); }
    }catch(e){ msg.style.color='#c0392b'; msg.textContent='⚠ 오류: '+e.message; }
  };
}
function initHuggingFace(){
  const t=el('hf-token'); if(!t) return;
  t.value=(state.cfg&&state.cfg.hfToken)||'';
  const em=el('hf-emo-model'); if(em) em.value=(state.cfg&&state.cfg.hfEmotionModel)||'matthewburke/korean_sentiment';
  const sm=el('hf-stt-model'); if(sm) sm.value=(state.cfg&&state.cfg.hfSttModel)||'openai/whisper-large-v3';
  const lm=el('hf-llm-model'); if(lm) lm.value=(state.cfg&&state.cfg.hfLlmModel)||'Qwen/Qwen2.5-7B-Instruct';
  const st=el('hf-status'); const stt=el('hf-stt-status');
  const save_=el('hf-save'); if(save_) save_.addEventListener('click',function(){
    state.cfg=Object.assign({},state.cfg,{ hfToken:(t.value||'').trim(), hfEmotionModel:(em&&em.value.trim())||state.cfg.hfEmotionModel, hfSttModel:(sm&&sm.value.trim())||state.cfg.hfSttModel, hfLlmModel:(lm&&lm.value.trim())||state.cfg.hfLlmModel });
    save();
    if(st) st.textContent = state.cfg.hfToken ? '✅ 토큰 저장됨 — 이 브라우저에 영구 보관. (LLM 엔진에서 \'HuggingFace\' 선택 시에도 사용)' : '⚠ 토큰이 비어 있습니다.';
  });
  const emoBtn=el('hf-emo-test'); if(emoBtn) emoBtn.addEventListener('click',async function(){
    if(!_hfTok()){ if(st) st.textContent='⚠ 먼저 HF 토큰을 저장하세요.'; return; }
    if(st) st.textContent='🔌 감정분석 테스트 중…';
    const r=await hfEmotion('오늘 시험을 잘 봐서 정말 행복하고 뿌듯해요.');
    if(st) st.textContent = r ? ('✅ 감정분석 OK — '+JSON.stringify(r).slice(0,120)) : '⚠ 실패(토큰·모델·CORS 확인). 모델 콜드스타트면 잠시 후 재시도.';
  });
  const llmBtn=el('hf-llm-test'); if(llmBtn) llmBtn.addEventListener('click',async function(){
    if(!_hfTok()){ if(st) st.textContent='⚠ 먼저 HF 토큰을 저장하세요.'; return; }
    if(st) st.textContent='🔌 HF LLM 테스트 중…';
    const saved=state.cfg; state.cfg=Object.assign({},state.cfg,{mode:'HF_LLM',key:state.cfg.hfToken,model:(lm&&lm.value.trim())||state.cfg.hfLlmModel});
    let r=null; try{ r=await callLLM('한 문장으로 자기소개 해줘.','한국어로만 짧게.'); }catch(e){}
    state.cfg=saved;
    if(st) st.textContent = (r&&r.trim()) ? ('✅ HF LLM OK — '+r.slice(0,80)) : '⚠ 실패(토큰·모델·쿼터·CORS 확인).';
  });
  const sttBtn=el('hf-stt-test'); if(sttBtn) sttBtn.addEventListener('click',async function(){
    if(!_hfTok()){ if(stt) stt.textContent='⚠ 먼저 HF 토큰을 저장하세요.'; return; }
    const fi=el('hf-audio'); const file=fi&&fi.files&&fi.files[0];
    if(!file){ if(stt) stt.textContent='⚠ 오디오 파일을 선택하세요.'; return; }
    if(stt) stt.textContent='🔌 음성 인식 중…';
    const txt=await hfTranscribe(file);
    if(txt){ if(stt) stt.textContent='✅ 인식: '+txt.slice(0,120); const ci=el('chat-input'); if(ci){ ci.value=txt; } }
    else if(stt) stt.textContent='⚠ 변환 실패(토큰·모델·CORS 확인). Whisper 콜드스타트면 잠시 후 재시도.';
  });
}

function initSettings() {
  const modeSel = el('cfg-mode');
  const ENGINE_HELP = {
    GEMINI_FLASH: '<b>Google Gemini 2.0 Flash</b> · <a href="https://aistudio.google.com/app/apikey" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">키 발급 페이지 열기 ↗</a><br>① 위 링크 접속(구글 로그인) → <b>Create API key</b> → 키 복사 ② 위 <b>API Key</b> 칸에 붙여넣기 ③ <b>저장</b> 클릭. 엔드포인트·모델(gemini-2.5-flash)은 자동 설정됩니다. (2.0-flash는 무료한도 0인 계정이 있어 2.5-flash 기본). 🔒 키는 <b>이 브라우저에만</b> 저장되고 소스코드에는 포함되지 않습니다. 보안을 위해 AI Studio에서 키를 <b>yedam.kr</b> 도메인(HTTP 리퍼러)으로 제한하는 것을 권장합니다.',
    SOLAR: '<b>Upstage SOLAR</b> · <a href="https://console.upstage.ai/" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">키 발급 페이지 열기 ↗</a><br>콘솔에서 API Key 발급 → 위 칸에 붙여넣고 저장. OpenAI 호환. 🔒 키는 이 브라우저에만 저장됩니다.',
    HYPERCLOVA: '<b>HyperCLOVA X</b> · <a href="https://www.ncloud.com/product/aiService/clovaStudio" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">CLOVA Studio 열기 ↗</a><br>CLOVA Studio에서 키/엔드포인트 발급 → 위 Endpoint·API Key 입력 후 저장. 🔒 키는 이 브라우저에만 저장됩니다.',
    CLAUDE_HAIKU: '<b>Anthropic Claude Haiku</b>(유료) · <a href="https://console.anthropic.com/settings/keys" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">키 발급 페이지 열기 ↗</a><br>콘솔에서 API Key 발급 → 위 칸에 붙여넣고 저장. 🔒 키는 이 브라우저에만 저장됩니다.',
    OPENROUTER_FREE: '<b>OpenRouter</b> · <a href="https://openrouter.ai/keys" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">키 발급 페이지 열기 ↗</a><br>키 발급 → 위 칸에 붙여넣고 저장. 무료 모델은 호출 제한이 있을 수 있습니다. 🔒 키는 이 브라우저에만 저장됩니다.',
    CEREBRAS: '<b>Cerebras</b> · <a href="https://cloud.cerebras.ai/" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">키 발급 페이지 열기 ↗</a><br>키 발급 → 위 칸에 붙여넣고 저장. 🔒 키는 이 브라우저에만 저장됩니다.',
    TOGETHER: '<b>Together AI</b> · <a href="https://api.together.xyz/settings/api-keys" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">키 발급 페이지 열기 ↗</a><br>키 발급 → 위 칸에 붙여넣고 저장. 🔒 키는 이 브라우저에만 저장됩니다.',
    GITHUB_MODELS: '<b>GitHub Models</b> · <a href="https://github.com/settings/tokens" target="_blank" rel="noopener" style="color:#2563eb;font-weight:800">토큰 발급 페이지 열기 ↗</a><br>Fine-grained PAT(모델 권한) 발급 → 위 칸에 붙여넣고 저장. 프록시(pia-proxy) 설정 시 서버 키로 사용. 🔒 키는 이 브라우저에만 저장됩니다.'
  };
  function renderEngineHelp(){
    var h = el('cfg-engine-help'); if(!h) return;
    var txt = ENGINE_HELP[modeSel.value];
    if(txt){ h.innerHTML = txt; h.style.display=''; } else { h.innerHTML=''; h.style.display='none'; }
  }
  modeSel.addEventListener('change', () => {
    const p = PROVIDERS[modeSel.value] || PROVIDERS.LOCAL;
    el('cfg-endpoint').value = p.endpoint;
    el('cfg-model').value = p.model;
    renderEngineHelp();
  });
  setTimeout(renderEngineHelp, 0);
  el('cfg-save').addEventListener('click', async () => {
    const m = modeSel.value;
    state.cfg = Object.assign({}, state.cfg, { mode:m, endpoint:el('cfg-endpoint').value.trim(), key:el('cfg-key').value.trim(), model:el('cfg-model').value.trim(), _engineChosen:true });
    save();
    const label = (PROVIDERS[m] && PROVIDERS[m].label) || m;
    if (m === 'ONDEVICE') {
      /* 사용자가 설정에서 직접 고른 경우다. 큰 모델을 받아도 된다. */
      window._ondeviceUserChosen = true;
      _ondeviceAllowDL = _ondeviceAllowed();   /* 키오스크 제외 */
      el('cfg-status').textContent = '🖥 온디바이스 확인 중… (첫 응답 시 모델 준비될 수 있어요)';
      try { const r = await callOnDevice('안녕? 한 문장으로 자기소개 해줘.','한국어로만 짧게.'); el('cfg-status').textContent = (r && r.trim()) ? '✅ 온디바이스 동작 확인 — 인터넷·키 없이 자유대화에 사용됩니다.' : 'ℹ 온디바이스 준비/미지원 — 지원 브라우저(WebGPU 또는 Chrome 내장 AI)면 첫 대화에서 모델을 받아 이후 오프라인 동작, 아니면 로컬 규칙형으로 폴백.'; } catch(e) { el('cfg-status').textContent = 'ℹ 온디바이스 미지원 — 로컬 규칙형 폴백.'; }
      return;
    }
    if (m === 'LOCAL') { el('cfg-status').textContent = '✅ 수동(로컬 규칙형) 적용됨 — 키 없이 오프라인으로 동작합니다. (설정은 영구 저장)'; return; }
    if (m === 'AUTO_FREE') { el('cfg-status').textContent = '저장됨: ' + label + ' (자유대화에서 바로 사용 · 영구 저장)'; return; }
    const _proxySet = !!(state.cfg.proxy && String(state.cfg.proxy).trim());
    if (_proxySet && m === 'GITHUB_MODELS') {
      el('cfg-status').textContent = '저장됨: GitHub Models (프록시 경유·서버 키) — 연결 테스트 중…';
      try { const r = await callLLM('한 문장으로 짧게 자기소개 해줘.', '너는 친절한 한국어 비서야. 한국어로만 답해.');
        el('cfg-status').textContent = (r && r.trim()) ? '✅ GitHub Models 연결됨 (프록시 경유·서버 키 사용 — 브라우저 키 입력 불필요)' : '⚠ 응답 비어있음 — 서버 토큰(GITHUB_MODELS_TOKEN)/프록시 확인. 실패 시 무료 AI→로컬 폴백.';
      } catch (e) { el('cfg-status').textContent = '⚠ GitHub Models(프록시) 연결 실패 — 서버 토큰/프록시 확인.'; }
      return;
    }
    const keyed = (m !== 'LOCAL' && m !== 'AUTO_FREE');
    if (keyed && !state.cfg.key) { el('cfg-status').textContent = '⚠ ' + label + ' 저장됨 — API Key가 비어 있어요. 키를 입력하거나 프록시를 설정하세요.'; return; }
    el('cfg-status').textContent = '저장됨: ' + label + ' — 키 연결 테스트 중…';
    try {
      const r = await callLLM('한 문장으로 짧게 자기소개 해줘.', '너는 친절한 한국어 비서야. 한국어로만 답해.');
      el('cfg-status').textContent = (r && r.trim())
        ? '✅ ' + label + ' 연결 성공 — 키가 반영되어 자유대화에 적용됩니다. (영구 저장)'
        : '⚠ ' + label + ' — ' + (window.__piaLLMErr ? ('사유: ' + String(window.__piaLLMErr).slice(0,200)) : '응답이 비어있어요(키/모델/쿼터 확인)') + ' · 실패 시 무료 AI→로컬 폴백.';
    } catch (e) {
      el('cfg-status').textContent = '⚠ ' + label + ' 저장됨 — 연결 실패(키·엔드포인트·CORS 확인). 자유대화는 무료 AI→로컬로 자동 폴백됩니다.';
    }
  });
  const engTestBtn = el('cfg-engine-test');
  if (engTestBtn) engTestBtn.addEventListener('click', async () => {
    const m = modeSel.value;
    const tmp = Object.assign({}, state.cfg, { mode:m, endpoint:el('cfg-endpoint').value.trim(), key:el('cfg-key').value.trim(), model:el('cfg-model').value.trim() });
    const label = (PROVIDERS[m] && PROVIDERS[m].label) || m;
    if (m === 'LOCAL') { el('cfg-status').textContent = 'ℹ 로컬 규칙형은 오프라인 동작이라 연결 테스트가 필요 없습니다.'; return; }
    var _pxT = !!(tmp.proxy && String(tmp.proxy).trim());
    if ((m!=='AUTO_FREE') && !tmp.key && !(_pxT && m==='GITHUB_MODELS')) { el('cfg-status').textContent = '⚠ ' + label + ': API Key를 먼저 입력하세요.'; return; }
    el('cfg-status').textContent = '🔌 ' + label + ' 연동 테스트 중…';
    const saved = state.cfg; state.cfg = tmp;
    try {
      const r = (m==='AUTO_FREE') ? await callLLMFree('안녕','한 단어로만 답해.') : await callLLM('한 문장으로 짧게 자기소개 해줘.', '너는 친절한 한국어 비서야. 한국어로만 답해.');
      el('cfg-status').textContent = (r && r.trim()) ? '✅ ' + label + ' 연동 성공 — "저장"을 누르면 영구 적용됩니다.' : ('⚠ ' + label + ' — ' + (window.__piaLLMErr ? ('사유: ' + String(window.__piaLLMErr).slice(0,200)) : '응답 비어있음(키/모델/쿼터 확인)'));
    } catch(e) { el('cfg-status').textContent = '⚠ ' + label + ' 연동 실패(키·엔드포인트·CORS 확인).'; }
    finally { state.cfg = saved; }
  });
  // ⚡ 무료 AI 자동 연결 (키 불필요)
  const autoFreeBtn = el('cfg-auto-free');
  if (autoFreeBtn) autoFreeBtn.addEventListener('click', async () => {
    const p = PROVIDERS.AUTO_FREE;
    state.cfg = Object.assign({}, state.cfg, { mode:'AUTO_FREE', endpoint:p.endpoint, key:'', model:p.model, _engineChosen:true });
    modeSel.value = 'AUTO_FREE';
    el('cfg-endpoint').value = p.endpoint; el('cfg-model').value = p.model; el('cfg-key').value = '';
    save();
    el('cfg-status').textContent = '⚡ 무료 AI 연결 테스트 중…';
    try {
      const r = await callLLM('한 문장으로 짧게 자기소개 해줘.', '너는 친절한 한국어 비서야. 한국어로만 답해.');
      el('cfg-status').textContent = (r && r.trim())
        ? '✅ 무료 AI 연결 성공 — 자유대화에서 바로 사용됩니다.'
        : '⚠ 응답이 비어있어요(무료 게이트웨이 호출 간격 제한). 잠시 후 다시 시도하거나 자유대화에서 바로 사용해 보세요.';
    } catch (e) {
      el('cfg-status').textContent = '⚠ 연결 실패 — 자유대화는 로컬 규칙형으로 자동 폴백됩니다.';
    }
  });
  // 무료 AI 모델 선택기 — /models에서 동적 로드(실패 시 기본 목록)
  const freeModelSel = el('cfg-free-model');
  if (freeModelSel) {
    freeModelSel.value = (state.cfg && state.cfg.freeModel) || 'openai';
    freeModelSel.addEventListener('change', function(){
      state.cfg = Object.assign({}, state.cfg, { freeModel: freeModelSel.value });
      save();
      el('cfg-status').textContent = '무료 모델: ' + freeModelSel.value;
    });
    /* 예전에는 pollinations 에서 무료 모델 목록을 받아 드롭다운을 채웠다.
       그 한 줄 때문에 설정 화면을 열 때마다 외부로 나갔다. 목록은 고정값으로 둔다. */

  }
  // Apply
  modeSel.value = state.cfg.mode || 'LOCAL';
  try { initHuggingFace(); } catch(e) {}
  try { initCareernet(); } catch(e) {}
  try { initPayEngineKeys(); } catch(e) {}
  if ((state.cfg.mode||'LOCAL')==='ONDEVICE') { const _cs=el('cfg-status'); if(_cs && !_cs.textContent) _cs.textContent = window._ondeviceReady ? '✅ 온디바이스 AI 자동 활성화됨 — 인터넷·키 없이 대화' : (window._ondeviceLazy ? '🖥 온디바이스 기본 — 첫 대화에서 자동 로드(저사양/모바일 데이터 절약)' : '🖥 온디바이스 AI 자동 기동 중…'); }
  if ((state.cfg.mode||'')==='GITHUB_MODELS') { const _csg=el('cfg-status'); if(_csg) _csg.textContent = (state.cfg.proxy ? '✅ GitHub Models 사용 중 (프록시·서버 키 — API Key 입력 불필요)' : 'ℹ GitHub Models — 프록시 미설정 시 API Key 필요'); }
  const p = PROVIDERS[state.cfg.mode] || PROVIDERS.LOCAL;
  el('cfg-endpoint').value = state.cfg.endpoint || p.endpoint;
  el('cfg-key').value = state.cfg.key || '';
  el('cfg-model').value = state.cfg.model || p.model;

  // ===== 백엔드 프록시 연동 =====
  const proxyInput = el('cfg-proxy');
  if (proxyInput) {
    proxyInput.value = state.cfg.proxy || '';
    const out = el('cfg-proxy-result');
    const saveBtn = el('cfg-proxy-save');
    const testBtn = el('cfg-proxy-test');
    if (saveBtn) saveBtn.addEventListener('click', () => {
      state.cfg = Object.assign({}, state.cfg, { proxy: (proxyInput.value || '').trim().replace(/\/$/,'') });
      save();
      if (out) { out.classList.remove('hidden'); out.textContent = '저장됨: ' + (state.cfg.proxy || '(없음)'); }
    });
    if (testBtn) testBtn.addEventListener('click', async () => {
      const base = (proxyInput.value || '').trim().replace(/\/$/,'');
      if (out) out.classList.remove('hidden');
      if (!base) { if (out) out.textContent = '프록시 URL을 먼저 입력하세요.'; return; }
      if (out) out.textContent = '연결 확인 중...';
      try {
        const h = await fetch(base + '/api/health').then(r => r.json());
        let jobs = null;
        try { jobs = await fetch(base + '/api/career/jobs?keyword=' + encodeURIComponent('상담')).then(r => r.json()); } catch (e) {}
        // 연동 성공 시 cfg.proxy 자동 저장
        state.cfg = Object.assign({}, state.cfg, { proxy: base }); save();
        if (out) out.textContent = '✅ 프록시 연결 성공 (저장됨)\n\n[GET] /api/health →\n' + JSON.stringify(h, null, 2)
          + '\n\n[GET] /api/career/jobs?keyword=상담 →\n' + (jobs ? JSON.stringify(jobs, null, 2).slice(0, 1200) : '(인증키 미설정 또는 응답 없음)');
      } catch (e) {
        if (out) out.textContent = '❌ 연결 실패: ' + e.message + '\n프록시 서버 실행 여부와 URL을 확인하세요. (pia-proxy: npm start)';
      }
    });
  }
}

// 프록시 경유 호출 헬퍼 (다른 기능에서 재사용 가능)
async function callProxy(path, opts) {
  const base = (state.cfg && state.cfg.proxy) ? state.cfg.proxy.replace(/\/$/,'') : '';
  if (!base) throw new Error('프록시 URL 미설정');
  const res = await fetch(base + path, opts);
  return res.json();
}

// 결과지 진로 섹션 — 프록시(커리어넷)에서 라이브 직업정보 로드
async function loadLiveCareers(type) {
  const box = el('careers-live');
  if (!box) return;
  const base = (state.cfg && state.cfg.proxy) ? state.cfg.proxy.replace(/\/$/,'') : '';
  if (!base) { box.innerHTML = ''; return; }
  const kw = (type && type.careers && type.careers[0]) ? type.careers[0] : '상담';
  box.innerHTML = '<div class="text-xs text-slate-500">커리어넷 라이브 직업정보 불러오는 중…</div>';
  try {
    const data = await callProxy('/api/career/jobs?keyword=' + encodeURIComponent(kw));
    const raw = (data && data.result) ? data.result : {};
    const arr = Array.isArray(raw) ? raw : (raw.content || []);
    if (!arr.length) { piaDomBatch(function(){ box.innerHTML = '<div class="text-xs text-slate-400">라이브 직업정보 없음</div>'; }); return; }
    const badge = data.demo ? '<span class="pill bg-amber-100 text-amber-800">DEMO</span>' : '<span class="pill bg-emerald-100 text-emerald-800">LIVE</span>';
    piaDomBatch(function(){ box.innerHTML = '<div class="text-xs font-semibold text-slate-600 mb-2">🔗 커리어넷 라이브 직업정보 ' + badge + ' · "' + _escHtml(kw) + '"</div>'
      + arr.slice(0,5).map(function(j){
          return '<div class="border border-slate-200 rounded-lg p-3 mb-2 bg-white">'
            + '<div class="flex items-center justify-between gap-2"><span class="font-semibold text-sm">' + _escHtml(j.job||'') + '</span>'
            + '<span class="text-xs text-slate-500">' + _escHtml(j.salery||'') + (j.prospect ? (' · 전망 ' + _escHtml(j.prospect)) : '') + '</span></div>'
            + (j.summary ? '<p class="text-xs text-slate-600 mt-1 leading-relaxed">' + _escHtml(String(j.summary).slice(0,120)) + '</p>' : '')
            + (j.ability ? '<div class="text-[11px] text-slate-500 mt-1">핵심능력: ' + _escHtml(j.ability) + '</div>' : '')
            + '</div>';
        }).join(''); });
  } catch (e) {
    piaDomBatch(function(){ box.innerHTML = '<div class="text-xs text-rose-700">라이브 진로정보 연동 실패: ' + _escHtml(e.message) + ' (프록시 서버 실행 확인)</div>'; });
  }
}

// ===== 위키백과 직업 요약: 예담 서버 캐시 경유(api.yedam.kr/ai?task=wiki) =====
/* [2026-09-27] 브라우저가 {ko|en}.wikipedia.org 를 직접 부르던 것을 서버 경유로 바꿨다.
   예전: 결과지를 다시 그릴 때마다(대상 전환·언어 전환·인쇄) 직업 3개 × 최대 3회를 직접 호출
   → 학급이 같은 IP 로 쓰면 429, 한글 제목을 en 에 물어 404, 슬래시 제목 400.
   지금: 서버(infra/ai-proxy/routes/wiki.mjs)가 받아 두고(7일, 없는 문서 1일) ko→en 폴백까지
   한 번에 처리한다. 브라우저는 직업 1개당 1회만 묻고, 같은 페이지 안에서는 아래 메모에서 꺼낸다.
   실패하면 그 항목만 조용히 빠진다(기존과 같은 폴백). 반환값: {title, extract, thumbnail, page, lang} 또는 null */
var _piaWikiMemo = new Map();
function autoEnrichWiki(title, lang) {
  lang = (lang === 'en') ? 'en' : 'ko';
  var t = String(title == null ? '' : title).replace(/\s+/g, ' ').trim();
  if (!t) return Promise.resolve(null);
  var key = lang + '|' + t;
  var hit = _piaWikiMemo.get(key);
  if (hit && (!hit.exp || hit.exp > Date.now())) return hit.p;
  var ent = { p: null, exp: 0 };
  ent.p = (async function(){
    try {
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function(){ try { ctrl.abort(); } catch (e) {} }, 12000) : null;
      var res;
      try {
        res = await fetch(PIA_CHAT_PROXY + '&task=wiki&lang=' + lang + '&title=' + encodeURIComponent(t),
          { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined });
      } finally { if (timer) clearTimeout(timer); }
      if (!res.ok) { ent.exp = Date.now() + 60000; return null; }   /* 한도·오류: 1분 뒤에만 다시 */
      var d = await res.json();
      if (!d || !d.found || !d.extract) return null;                   /* 없는 문서: 이 페이지에서는 다시 묻지 않는다 */
      return d;
    } catch (e) {
      ent.exp = Date.now() + 60000;
      return null;
    }
  })();
  _piaWikiMemo.set(key, ent);
  return ent.p;
}
async function renderAutoCareerInfo(type) {
  /* [2026-09-26] 한·영 전환 반영 — 영어 모드는 영문 직업명으로 en 위키백과만 조회하고
     머리말·배지·링크 문구도 영어로. 언어를 바꾸면 aipia:langchange 에서 다시 그린다. */
  const box = el('careers-auto');
  if (!box) return;
  window.__piaAutoCareerType = type;
  const en = (window.aipiaCurrentLang === 'en');
  let jobs = [];
  try { jobs = (typeof _typeField === 'function') ? (_typeField(type, 'careers') || []) : []; } catch (e) { jobs = []; }
  if (!jobs.length && type && type.careers) jobs = type.careers;
  jobs = jobs.slice(0, 3);
  if (!jobs.length) { box.innerHTML = ''; return; }
  const seq = (window.__piaAutoCareerSeq = (window.__piaAutoCareerSeq || 0) + 1);
  box.innerHTML = '<div class="text-xs text-slate-500">' + _T('위키백과에서 직업 설명 자동 로드 중…', 'Loading job descriptions from Wikipedia…') + '</div>';
  // 위키 3건 병렬 조회(서버 캐시 경유, 같은 페이지 재렌더는 메모에서)
  const results = await Promise.all(jobs.map(async function(job){
    /* ko 모드의 en 폴백은 서버가 같은 요청 안에서 처리한다(요청 1회) */
    let d = null;
    try { d = await autoEnrichWiki(job, en ? 'en' : 'ko'); } catch (e) {}
    if (!d) return '';
    const thumb = (typeof d.thumbnail === 'string' && /^https:\/\//.test(d.thumbnail))
      ? '<img src="' + _escHtml(d.thumbnail) + '" alt="" class="w-14 h-14 rounded-lg object-cover flex-shrink-0" loading="lazy" decoding="async">' : '';
    const link = (typeof d.page === 'string' && /^https:\/\//.test(d.page)) ? d.page : '#';
    return '<div class="border border-slate-200 rounded-lg p-3 mb-2 bg-white flex gap-3">'
      + thumb
      + '<div class="min-w-0"><div class="font-semibold text-sm">' + _escHtml(job)
      + ' <span class="pill bg-emerald-100 text-emerald-800">' + _T('자동연동', 'Auto') + '</span></div>'
      + '<p class="text-xs text-slate-600 mt-1 leading-relaxed">' + _escHtml(String(d.extract).slice(0, en ? 220 : 160)) + '</p>'
      + '<a href="' + _escHtml(link) + '" target="_blank" rel="noopener" class="text-xs text-sky-700 hover:underline">' + _T('위키백과에서 더 보기 →', 'Read more on Wikipedia →') + '</a>'
      + '</div></div>';
  }));
  if (seq !== window.__piaAutoCareerSeq) return;   /* 그 사이 언어가 바뀌어 새로 그리는 중 */
  const cards = results.filter(function(x){ return x; });
  piaDomBatch(function(){ if (seq !== window.__piaAutoCareerSeq) return;
  box.innerHTML = cards.length
    ? '<div class="text-xs font-semibold text-slate-600 mb-2">📖 ' + _T('위키백과 자동 직업 정보', 'Job info from Wikipedia') + ' <span class="pill bg-emerald-100 text-emerald-800">' + _T('키 불필요·서버 캐시', 'No key · Cached') + '</span></div>' + cards.join('')
    : '<div class="text-xs text-slate-400">' + _T('위키백과 자동 직업 정보를 찾지 못했어요.', 'No job info found on Wikipedia.') + '</div>';
  });
}
try {
  /* [2026-09-26] 결과 화면이 떠 있으면 언어 전환 때 차트 라벨까지 다시 그린다(renderResult 는 시작에 destroyCharts) */
  window.addEventListener('aipia:langchange', function(){
    try {
      var _rs = document.querySelector('section[data-view="result"]');
      if (_rs && !_rs.classList.contains('hidden') && _rs.offsetParent !== null && typeof renderResult === 'function') renderResult();
    } catch (e) { console.error('[pia] 언어 전환 후 결과 다시 그리기 실패', e); }
  });
} catch (e) {}
try {
  window.addEventListener('aipia:langchange', function(){
    if (window.__piaAutoCareerType) { try { renderAutoCareerInfo(window.__piaAutoCareerType); } catch (e) {} }
  });
} catch (e) {}

// =================================================================
//  Init
// =================================================================
document.querySelectorAll('#topNav button').forEach(btn => {
  btn.addEventListener('click', () => showView(btn.dataset.go));
});

async function autoConnectFreeAI() {
  const badge = document.getElementById('chat-aistatus');
  // 사용자가 직접 저장한 설정(개인 키/엔진)이 있으면 그대로 존중
  let savedCfg = null; try { savedCfg = localStorage.getItem(STORAGE.cfg); } catch(e) {}
  const hasUserKey = !!(state.cfg && state.cfg.key && state.cfg.mode !== 'LOCAL' && state.cfg.mode !== 'AUTO_FREE' && state.cfg.mode !== 'ONDEVICE');
  if (savedCfg || hasUserKey) {
    const ms0 = el('cfg-mode'); if (ms0 && state.cfg.mode) ms0.value = state.cfg.mode;
    if (state.cfg.mode === 'ONDEVICE' && _ondeviceAllowed()) {
      window._ondeviceUserChosen = true;   /* 저장된 설정 = 사용자가 고른 것 */
      _ondeviceAllowDL = true;             // 데스크톱만 허용(모바일·키오스크 제외)
    }
    const lbl = (PROVIDERS[state.cfg.mode] && PROVIDERS[state.cfg.mode].label) || state.cfg.mode;
    if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">엔진: ' + lbl + '</span>';
    return;
  }
  // 기본값: 모바일은 무료 AI(키 불필요·즉시), 데스크톱은 🖥 온디바이스(브라우저)
  const _mob = (typeof isMobile==='function' && isMobile());
  if (_mob) {
    const _hasProxy = !!(state.cfg && state.cfg.proxy && state.cfg.proxy.trim());
    if (_hasProxy) {
      // 모바일 기본: GitHub Models — 프록시 경유(키는 서버 .env에만)
      state.cfg = Object.assign({}, state.cfg, { mode:'GITHUB_MODELS', endpoint:(PROVIDERS.GITHUB_MODELS&&PROVIDERS.GITHUB_MODELS.endpoint)||'', model:(PROVIDERS.GITHUB_MODELS&&PROVIDERS.GITHUB_MODELS.model)||'openai/gpt-4o-mini', key:'' });
      save();
      const msG = el('cfg-mode'); if (msG) msG.value = 'GITHUB_MODELS';
      const csG = el('cfg-status'); if (csG) csG.textContent = '📱 모바일 기본: GitHub Models(프록시 경유·키는 서버 보관)';
      if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 GitHub Models(프록시) 연결</span>';
      try { const r = await callLLM('안녕','한 단어로만 답해.'); if (badge && !(r&&r.trim())) badge.innerHTML = '<span class="pill bg-amber-100 text-amber-800 text-[10px]">⚠ 프록시/토큰 확인 — 실패 시 무료 AI→로컬</span>'; } catch(e) {}
      return;
    }
    state.cfg = Object.assign({}, state.cfg, { mode:'AUTO_FREE', endpoint:(PROVIDERS.AUTO_FREE&&PROVIDERS.AUTO_FREE.endpoint)||PIA_CHAT_PROXY, model:'', key:'' });
    save();
    const msM = el('cfg-mode'); if (msM) msM.value = 'AUTO_FREE';
    const csM = el('cfg-status'); if (csM) csM.textContent = '📱 모바일 기본: 무료 AI 자동(키 불필요) — 프록시 설정 시 GitHub Models 경유';
    if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">⚡ 무료 AI 자동 연결(모바일)</span>';
    try { const r = await callLLMFree('안녕','한 단어로만 답해.'); if (badge) badge.innerHTML = (r&&r.trim()) ? '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 무료 AI 연결됨</span>' : '<span class="pill bg-amber-100 text-amber-800 text-[10px]">⚡ 무료 AI(혼잡 시 로컬 폴백)</span>'; } catch(e) {}
    return;
  }
  /* ── 키오스크 기본 엔진 ───────────────────────────────────────────────
     키오스크는 온디바이스를 못 쓴다(위 _isKioskDevice 주석 참고).
     대신 이 순서로 고른다.

       1) Gemini 키가 저장돼 있으면 Gemini 2.5 Flash
          무료 1,500요청/일 · 한국어 품질이 가장 낫다.
       2) 프록시가 설정돼 있으면 GitHub Models(키는 서버 보관)
       3) 둘 다 없으면 무료 AI(키 불필요) — 다만 pollinations 는 2026-08
          현재 402(Payment Required)를 반환하고 "legacy API deprecated"
          안내가 붙었다. 이 경로는 언제 막혀도 이상하지 않으므로
          최종적으로는 로컬 규칙형으로 폴백한다.

     키는 소스에 넣지 않는다. localStorage(pia_v3_cfg)에만 저장한다.
     소스에 박으면 공개 저장소에 그대로 노출된다(커리어넷 키가 그랬다). */
  if (_isKioskDevice()) {
    /* 키오스크 기본 엔진 = 자체 Worker 프록시(AUTO_FREE).

       왜 프록시인가
         · 키가 브라우저로 나가지 않는다. 이 저장소는 공개라 소스에 키를
           박으면 그대로 노출된다(커리어넷 키가 그 상태였다).
         · Worker 가 Gemini→Groq→Cerebras→OpenRouter→HF→GitHub 순으로
           자동 폴백한다. 한 곳이 막혀도 대화가 끊기지 않는다.
         · 브라우저 CORS 제약을 받지 않는다(huggingface 직접 호출은 차단된다).
         실측(2026-08-08): Worker 응답 598ms · 공급자 groq · 한국어 정상.

       사용자가 설정에서 개인 키를 저장했다면 위쪽 분기에서 이미 그것을
       존중하고 여기까지 오지 않는다. */
    /* 키오스크에도 브라우저 내장 AI 가 있으면 그것을 먼저 쓴다.

       예전에는 키오스크면 무조건 서버 프록시로 갔다. 그 판단의 근거는
       "키오스크는 저사양이라 큰 모델을 못 돌린다" 였는데, 내장 AI 는
       **받을 것이 없다**. 이미 브라우저에 들어 있는 모델을 부르는 것이라
       저사양 논리가 적용되지 않는다. 실측(크롬 151, 2026-08-08):
       세션 생성 9.3초(최초 1회) · 응답 1.5~2.2초 · 한국어 정상.

       내장 AI 가 되면 인터넷도 서버도 키도 필요 없다. 학교 망이 막혀도,
       우리 서버가 죽어도 대화가 된다. 안 되는 기기는 그대로 서버로 간다.
       큰 모델 다운로드는 여기서도 열지 않는다. */
    if (await _piaBuiltinAvailable()) {
      state.cfg = Object.assign({}, state.cfg, { mode:'ONDEVICE' });
      save();
      _ondeviceAllowDL = false;
      const msB = el('cfg-mode'); if (msB) msB.value = 'ONDEVICE';
      const csB = el('cfg-status'); if (csB) csB.textContent = '🖥 키오스크: 브라우저 내장 AI 사용 — 서버·인터넷·키 불필요';
      if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 온디바이스(브라우저 내장 AI) 연결됨</span>';
      return;
    }

    state.cfg = Object.assign({}, state.cfg, {
      mode:'AUTO_FREE', key:'',
      endpoint:(PROVIDERS.AUTO_FREE && PROVIDERS.AUTO_FREE.endpoint) || PIA_CHAT_PROXY,
      model:''
    });
    save();
    const msK = el('cfg-mode'); if (msK) msK.value = 'AUTO_FREE';
    const csK = el('cfg-status'); if (csK) csK.textContent = '🖥 키오스크 기본: 서버 프록시(6개 공급자 자동 폴백·키 불필요)';
    if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 AI 연결 확인 중…</span>';
    try {
      const r = await callLLMFree('안녕','한 단어로만 답해.');
      if (badge) badge.innerHTML = (r && r.trim())
        ? '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 AI 연결됨</span>'
        : '<span class="pill bg-amber-100 text-amber-800 text-[10px]">⚠ AI 연결 실패 — 로컬 규칙형으로 진행합니다</span>';
    } catch(e) {}
    return;
  }

  /* 데스크톱 기본값.

     예전에는 여기서 무조건 ONDEVICE 를 켰다. 그러면 브라우저가
     huggingface 에서 ONNX 모델을 통째로 내려받는다. 실측하면
     q4 749MB · q4f16 460MB 다. 처음 들어온 사람에게 그만한 짐을
     말없이 지우는 것이고, 그 사이 화면은 멈춘 것처럼 보인다.
     실제로 이 경로에서 브라우저가 죽는 것을 관찰했다.

     이제 이렇게 고른다.
       1) 브라우저에 내장 AI(Prompt API · Gemini Nano)가 있으면 그것
          이미 기기에 있는 모델이라 우리가 받게 하는 것이 없다. 가장 좋다.
       2) 없으면 자체 서버 프록시
          키가 브라우저로 나가지 않고, 서버가 여러 공급자를 자동으로 훑는다.

     큰 모델을 굳이 받고 싶으면 설정에서 온디바이스를 직접 고르면 된다.
     기본값으로는 받지 않는다. */
  const builtin = await _piaBuiltinAvailable();

  if (builtin) {
    state.cfg = Object.assign({}, state.cfg, { mode:'ONDEVICE' });
    save();
    const ms = el('cfg-mode'); if (ms) ms.value = 'ONDEVICE';
    const cs = el('cfg-status'); if (cs) cs.textContent = '🖥 브라우저 내장 AI 사용 — 다운로드·키 불필요';
    /* 내장 API 로만 쓴다. 큰 모델 다운로드는 열지 않는다. */
    _ondeviceAllowDL = false;
    if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 온디바이스(브라우저 내장 AI) 연결됨</span>';
    return;
  }

  state.cfg = Object.assign({}, state.cfg, {
    mode:'AUTO_FREE', key:'',
    endpoint:(PROVIDERS.AUTO_FREE && PROVIDERS.AUTO_FREE.endpoint) || PIA_CHAT_PROXY,
    model:''
  });
  save();
  const ms = el('cfg-mode'); if (ms) ms.value = 'AUTO_FREE';
  const cs = el('cfg-status'); if (cs) cs.textContent = '🌐 서버 프록시 사용 — 키 불필요 · 다운로드 없음';
  if (badge) badge.innerHTML = '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 AI 연결 확인 중…</span>';
  try {
    const r = await callLLMFree('안녕', '한 단어로만 답해.');
    if (badge) badge.innerHTML = (r && r.trim())
      ? '<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">🟢 AI 연결됨</span>'
      : '<span class="pill bg-amber-100 text-amber-800 text-[10px]">⚠ AI 연결 실패 — 로컬 규칙형으로 진행합니다</span>';
  } catch (e) {
    console.error('AI 연결 확인 실패:', e);
  }
}

function piaPaperScan(){
  try{
    var TESTS=[
      {k:'big5',n:50,scale:'1~5',lo:1,hi:5,fn:'scoreBig5',label:'IPIP Big5-50'},
      {k:'riasec',n:30,scale:'1~5',lo:1,hi:5,fn:'scoreRiasec',label:'RIASEC-30'},
      {k:'via',n:24,scale:'1~5',lo:1,hi:5,fn:'scoreVia',label:'24 강점'},
      {k:'grit',n:8,scale:'1~5',lo:1,hi:5,fn:'scoreGrit',label:'끈기·근면'},
      {k:'who5',n:5,scale:'1~6',lo:1,hi:6,fn:'scoreWho5',label:'WHO-5'},
      {k:'rses',n:10,scale:'1~4',lo:1,hi:4,fn:'scoreRses',label:'RSES 자존감'},
      {k:'learn',n:14,scale:'1~5',lo:1,hi:5,fn:'scoreLearn',label:'학습역량'},
      {k:'mi',n:16,scale:'1~5',lo:1,hi:5,fn:'scoreMi',label:'다중지능 MI'},
      {k:'cesd',n:10,scale:'0~3',lo:0,hi:3,fn:'scoreCesd',label:'CES-D-10'},
      {k:'phqa',n:9,scale:'0~3',lo:0,hi:3,fn:'scorePhqa',label:'PHQ-A'},
      {k:'gad',n:7,scale:'0~3',lo:0,hi:3,fn:'scoreGad',label:'GAD-7'}
    ];
    function tof(k){ for(var i=0;i<TESTS.length;i++) if(TESTS[i].k===k) return TESTS[i]; return TESTS[0]; }
    if(document.getElementById('paper-ov')) return;
    var ov=document.createElement('div'); ov.id='paper-ov';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:2000;display:flex;align-items:flex-start;justify-content:center;padding:18px;overflow:auto';
    var opts=TESTS.map(function(t){return '<option value="'+t.k+'">'+t.label+' ('+t.n+'문항·'+t.scale+')</option>';}).join('');
    ov.innerHTML='<div style="background:#fff;border-radius:16px;max-width:680px;width:100%;padding:20px;font-family:\'Noto Sans KR\',sans-serif">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><h2 style="font-size:18px;font-weight:800;margin:0">📷 종이답안 AI 판독 채점</h2><button id="paper-close" style="border:0;background:#eee;border-radius:8px;padding:6px 12px;cursor:pointer">닫기</button></div>'
      +'<p style="font-size:12.5px;color:#666;margin:0 0 12px;line-height:1.6">검사를 고르고 마킹한 답안지를 촬영/업로드하면 AI가 표시한 번호를 읽어옵니다. 표를 검토·수정한 뒤 채점하세요.</p>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
      +'<select id="paper-test" style="padding:8px;border:1px solid #ddd;border-radius:8px">'+opts+'</select>'
      +'<input id="paper-file" type="file" accept="image/*" capture="environment" style="font-size:13px">'
      +'<button id="paper-read" style="background:#6a9bcc;color:#fff;border:0;border-radius:8px;padding:8px 14px;font-weight:700;cursor:pointer">🔍 AI 판독</button>'
      +'<button id="paper-manual" style="background:#fff;color:#333;border:1px solid #ddd;border-radius:8px;padding:8px 12px;cursor:pointer">✍ 직접 입력</button>'
      +'<span id="paper-status" style="font-size:12.5px;color:#666"></span></div>'
      +'<div id="paper-grid" style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px"></div>'
      +'<button id="paper-score" style="display:none;background:#d97757;color:#fff;border:0;border-radius:8px;padding:10px 18px;font-weight:800;cursor:pointer">✅ 채점하고 결과 보기</button>'
      +'</div>';
    document.body.appendChild(ov);
    function buildGrid(t, answers){
      var g=document.getElementById('paper-grid'); g.innerHTML='';
      for(var i=0;i<t.n;i++){
        var v=(answers&&answers[i]!=null)?answers[i]:'';
        var box=document.createElement('div'); box.style.cssText='display:flex;align-items:center;gap:3px;font-size:12px';
        box.innerHTML='<span style="color:#999;width:22px;text-align:right">'+(i+1)+'</span><input data-i="'+i+'" type="number" min="'+t.lo+'" max="'+t.hi+'" value="'+v+'" style="width:44px;padding:4px;border:1px solid #ddd;border-radius:6px;text-align:center">';
        g.appendChild(box);
      }
      document.getElementById('paper-score').style.display='';
    }
    document.getElementById('paper-close').onclick=function(){ ov.remove(); };
    document.getElementById('paper-manual').onclick=function(){ buildGrid(tof(document.getElementById('paper-test').value),null); document.getElementById('paper-status').textContent='직접 입력 모드 — 번호를 채운 뒤 채점하세요.'; };
    document.getElementById('paper-test').onchange=function(){ var g=document.getElementById('paper-grid'); g.innerHTML=''; document.getElementById('paper-score').style.display='none'; document.getElementById('paper-status').textContent=''; };
    document.getElementById('paper-read').onclick=function(){
      var t=tof(document.getElementById('paper-test').value);
      var f=document.getElementById('paper-file').files[0]; var st=document.getElementById('paper-status');
      if(!f){ st.textContent='먼저 답안지 사진을 선택하세요.'; return; }
      st.textContent='🔍 AI 판독 중… (최대 30초)';
      var rd=new FileReader();
      rd.onload=function(){
        fetch(PIA_CHAT_PROXY+'&task=ocr',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({image:rd.result,n:t.n,scale:t.scale})})
        .then(function(r){return r.json();}).then(function(d){
          if(d&&d.answers){ st.textContent='✅ 판독 완료 — 표를 검토·수정한 뒤 채점하세요.'; buildGrid(t,d.answers); }
          else { st.textContent='판독 실패('+((d&&d.error)||'알 수 없음')+'). 직접 입력으로 채점할 수 있어요.'; buildGrid(t,null); }
        }).catch(function(e){ st.textContent='오류: '+(e&&e.message)+' — 직접 입력 가능'; buildGrid(t,null); });
      };
      rd.readAsDataURL(f);
    };
    document.getElementById('paper-score').onclick=function(){
      var t=tof(document.getElementById('paper-test').value);
      var inputs=document.querySelectorAll('#paper-grid input'); var ans=[];
      for(var i=0;i<inputs.length;i++){ var v=parseInt(inputs[i].value,10); ans.push(isNaN(v)?t.lo:Math.max(t.lo,Math.min(t.hi,v))); }
      try{ if(!state.profile||!state.profile.name) state.profile={name:'종이검사', grade:'', class:'', school:'', createdAt:Date.now()}; }catch(e){}
      try{ state.results[t.k].answers=ans; state.results[t.k].scores=(typeof window[t.fn]==='function')?window[t.fn]():null; }catch(e){}
      try{ save(); }catch(e){}
      ov.remove();
      try{ showView('result'); }catch(e){}
      try{ if(typeof renderResult==='function')renderResult(); if(typeof renderDetailedResult==='function')renderDetailedResult(); if(typeof renderExtendedSections==='function')renderExtendedSections(); }catch(e){}
    };
  }catch(e){ try{ alert('종이답안 판독 오류: '+(e&&e.message)); }catch(_){} }
}
function piaPrintAsk(){
  try{
    var ov=document.createElement('div'); ov.className='pia-print-hide';
    ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;z-index:1002;padding:20px;';
    /* 2026-08-31: 이 창이 열람 대상과 무관하게 "본인용"으로 고정돼 있었다.
       선생님용 결과지를 보고 인쇄를 눌러도 학생용으로 뽑히고, 교사에게
       "선생님용은 관리자 포털에서 제공됩니다"라고 안내하는 모순이 있었다.
       지금 보고 있는 대상과, 권한이 있는 다른 대상만 버튼으로 내놓는다. */
    var _cur=(typeof currentAudience!=='undefined'&&currentAudience)?currentAudience:'student';
    var _NAME=(window.aipiaCurrentLang==='en') ? {student:'For the Student', parent:'For Parents', teacher:'For Teachers'} : {student:'학생 본인용', parent:'학부모용', teacher:'선생님용'};
    var _DESC=(window.aipiaCurrentLang==='en') ? {
      student:'Print or save the student (self) report as a PDF.',
      parent:'Print or save the parent report as a PDF.',
      teacher:'Print or save the teacher report as a PDF. Detailed material for guidance and counseling is included.'
    } : {
      student:'학생(본인)용 결과지를 인쇄·PDF로 저장합니다.',
      parent:'학부모용 결과지를 인쇄·PDF로 저장합니다.',
      teacher:'선생님용 결과지를 인쇄·PDF로 저장합니다. 지도·상담용 상세 자료가 함께 나옵니다.'
    };
    var _btn=function(a,주){
      return '<button data-aud="'+a+'" style="padding:'+(주?'12px':'10px')+';border:'+(주?'0':'1px solid #cfd8e3')+';border-radius:10px;background:'+(주?'#6a9bcc':'#fff')+';color:'+(주?'#fff':'#3d4a5c')+';font-weight:700;cursor:pointer;font-size:'+(주?'14px':'13px')+';width:100%;margin-top:'+(주?'0':'8px')+'">🖨️ '+_NAME[a]+_T(' 인쇄 / PDF',' Print / PDF')+'</button>';
    };
    var _others=['student','parent','teacher'].filter(function(a){
      return a!==_cur && (typeof audAllowed==='function' ? audAllowed(a) : a==='student');
    });
    var _pair='';
    /* 열람 코드는 학생 본인 화면에서만 뜻이 있다 — 교사·학부모 화면에서 보여줄 이유가 없다 */
    if(_cur==='student'){
      _pair='<div style="margin-top:14px;padding:12px;border:1px dashed #d9a14f;border-radius:10px;background:#fff8ec;text-align:left">'
        +'<div style="font-size:12px;color:#8a6d3b;font-weight:700;margin-bottom:4px">👪 '+_T('학부모 열람 코드','Parent Access Code')+'</div>'
        +'<div style="font-size:21px;font-weight:900;letter-spacing:3px;color:#b5651d;text-align:center;margin:4px 0">'
        +(getPairCode() ? _escHtml(getPairCode()) : '<span style="font-size:12px;font-weight:700;letter-spacing:0">'+_T('결과가 서버에 저장되면 표시됩니다','Shown after the result is saved')+'</span>')
        +'</div>'
        +'<div style="font-size:11px;color:#7a5c3a;line-height:1.5">'+_T('학부모님은 <b>학부모 열람 페이지(yedam.kr/parent.html)</b>에서 <b>위 코드만</b> 입력하면 학부모용 결과를 보실 수 있어요.','Parents can view the parent report by entering <b>just the code above</b> on the <b>Parent Access Page (yedam.kr/parent.html)</b>.')+'</div>'
      +'</div>'
      + (_others.indexOf('teacher')<0 ? '<div style="margin-top:8px;font-size:11px;color:#6b6457;line-height:1.5">🏫 '+_T('선생님용 결과지는 학교 <b>관리자(선생님) 포털</b>에서 제공됩니다.','The teacher report is available through the school <b>Admin (Teacher) Portal</b>.')+'</div>' : '');
    }
    ov.innerHTML='<div style="background:#fff;border-radius:16px;padding:22px;max-width:360px;width:100%;text-align:center;font-family:inherit;box-shadow:0 20px 50px -20px rgba(0,0,0,.5)">'
      +'<div style="font-weight:800;font-size:16px;margin-bottom:6px;color:#141413">'+_NAME[_cur]+_T(' 결과지 인쇄',' Report Print')+'</div>'
      +'<div style="font-size:12.5px;color:#6b6457;margin-bottom:14px">'+_DESC[_cur]+'</div>'
      +_btn(_cur, true)
      +_others.map(function(a){ return _btn(a, false); }).join('')
      +_pair
      +'<button data-aud="__close" style="padding:9px;border:1px solid #e3d9c6;border-radius:10px;background:#fff;color:#6b6457;font-weight:600;cursor:pointer;margin-top:12px;font-size:13px;width:100%">'+_T('닫기','Close')+'</button>'
      +'</div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function(e){ var b=e.target.closest('button'); if(b){ var a=b.getAttribute('data-aud'); if(a==='__close'){ ov.remove(); return; } ov.remove(); piaPrintReport(a||undefined); return; } if(e.target===ov){ ov.remove(); } });
  }catch(e){ piaPrintReport(); }
}
function _piaForceOpenAcc(){
  try{
    var list=document.querySelectorAll('details.pia-acc');
    var saved=[];
    for(var i=0;i<list.length;i++){ saved.push([list[i], list[i].open]); list[i].open=true; }
    return saved;
  }catch(e){ return []; }
}
function _piaRestoreAcc(saved){
  try{ (saved||[]).forEach(function(p){ p[0].open=p[1]; }); }catch(e){}
}
function piaPrintReport(audOverride){
  try{ piaDomFlush(); }catch(e){} try{ piaChartFlush(true); }catch(e){}   /* [2026-11-02 성능 2차] 묶어 둔 비동기 조각·밀린 차트를 먼저 다 써서 인쇄본·PDF 에 빠지지 않게 */
  try{
    var _prevAud=(typeof currentAudience!=='undefined')?currentAudience:'student';
    if((audOverride==='student'||audOverride==='parent'||audOverride==='teacher') && audAllowed(audOverride)){ try{ currentAudience=audOverride; }catch(e){} }
    try{ if(window.Chart&&Chart.defaults){ Chart.defaults.animation=false; if('animations' in Chart.defaults) Chart.defaults.animations=false; } }catch(e){}
    /* 대상이 바뀐 경우에만 다시 그린다. 예전에는 인쇄할 때마다 무조건 다시 그려서
       AI 종합 해석을 서버에 또 요청했고, 그 응답을 기다리느라 인쇄창이 늦게 떴다.
       (2026-09-02 실측: 재렌더 74ms + AI 호출 1회) */
    var _needRender = (audOverride && audOverride !== _prevAud) || !document.getElementById('detailed-result');
    if (_needRender) {
      try{ if(typeof renderDetailedResult==='function')renderDetailedResult(); if(typeof renderExtendedSections==='function')renderExtendedSections(); }catch(e){}
    }
    setTimeout(function(){
    try{
    var _piaAccSaved=_piaForceOpenAcc();
    var rep=document.getElementById('pia-report');
    if(!rep){ window.print(); return; }
    var _isAdultR=(typeof selfIsAdult==='function'&&selfIsAdult());
    var _plPR=(window.aipiaCurrentLang==='en');
    var _audKo=(typeof currentAudience!=='undefined')?(currentAudience==='student'?(_isAdultR?_T('본인용(일반)','Self (General)'):_T('학생 본인용','For the Student')):currentAudience==='parent'?_T('학부모용','For Parents'):_T('선생님용','For Teachers')):'';
    var _respKo=_isAdultR?_T('일반(성인)','Adult (General)'):_T('학생','Student');
    /* 표지의 성명·학교·학년반·검사일이 전부 '-' 로 인쇄되던 문제.
       채우는 함수(populateResult)가 관리자 열람 경로에서만 불려서, 일반 인쇄에서는
       빈 채로 나갔다. 인쇄 직전에 현재 응시자 정보로 채운다. (2026-09-01)
       [2026-09-26] 표지만 채우고 본문(2~10쪽)은 test.html 의 고정 예시값(홍길동·72점)이
       그대로 인쇄됐다. 이제 본문 전체를 실제 결과로 채운다(표지 포함). 결과가 없을 때만
       예전처럼 표지만 채운다. */
    var _bodyFilled=false;
    try{ _bodyFilled = (typeof piaFillReportBody==='function') && piaFillReportBody(); }catch(e){ console.error('결과지 본문 채우기 실패', e); }
    if(!_bodyFilled) try{
      var _cp=(typeof state!=='undefined'&&state&&state.profile)?state.profile:{};
      var _cSet=function(id,v){ var e=document.getElementById(id); if(e) e.textContent=v||'-'; };
      var _cDate=function(){ try{ return _plPR ? new Date().toLocaleDateString('en-US') : new Date().toLocaleDateString('ko-KR'); }catch(e){ return ''; } };
      _cSet('cover-name', _cp.name);
      _cSet('cover-school', _cp.school);
      _cSet('cover-grade', ((_cp.grade||'')+' '+(_cp.class||'')).trim());
      _cSet('cover-date', _cDate());
      _cSet('cover-issue', _cDate());
      _cSet('cover-org', _cp.school);
    }catch(e){ console.error('표지 정보 채우기 실패', e); }
    var clone=rep.cloneNode(true);
    try{ var _cb=clone.querySelector('#cover-badge-txt'); if(_cb) _cb.textContent=_respKo+' · '+_audKo; }catch(e){}
    function _c2img(cv){ var d=''; try{ var ch=(window.Chart&&Chart.getChart)?Chart.getChart(cv):null; if(ch&&ch.toBase64Image) d=ch.toBase64Image('image/png',1); }catch(e){} if(!d||d.length<200){ try{ d=cv.toDataURL('image/png'); }catch(e){ d=''; } } return (d&&d.length>200)?d:''; }
    function _chartTable(srcCv){ try{ var ch=(window.Chart&&Chart.getChart)?Chart.getChart(srcCv):null; if(!ch||!ch.data) return ''; var labels=ch.data.labels||[]; var ds=(ch.data.datasets||[]).filter(function(d){return d&&d.data;}); if(!labels.length||!ds.length) return ''; var th='<tr><th style="text-align:left;padding:4px 8px;border-bottom:1px solid #ddd;background:#f7f3ee;">'+_T('항목','Item')+'</th>'+ds.map(function(d){return '<th style="padding:4px 8px;border-bottom:1px solid #ddd;background:#f7f3ee;">'+(d.label||'')+'</th>';}).join('')+'</tr>'; var tr=labels.map(function(lb,i){return '<tr><td style="text-align:left;padding:4px 8px;border-bottom:1px solid #f0f0f0;">'+lb+'</td>'+ds.map(function(d){return '<td style="padding:4px 8px;text-align:center;border-bottom:1px solid #f0f0f0;">'+(d.data[i]!=null?d.data[i]:'-')+'</td>';}).join('')+'</tr>';}).join(''); return '<table style="width:100%;border-collapse:collapse;font-size:11px;margin-top:4px;">'+th+tr+'</table>'; }catch(e){ return ''; } }
    function _swapCanvas(srcCv,dstCv){ if(!dstCv||!dstCv.parentNode) return; var d=_c2img(srcCv); if(d){ var im=document.createElement('img'); im.src=d; im.setAttribute('style', srcCv.getAttribute('style')||'');
      /* 폭만 줄이고 높이를 그대로 두면 그래프가 세로로 늘어난다(찌그러짐).
         높이를 auto 로 풀어 원본 비율을 지킨다. (2026-08-31) */
      im.style.maxWidth='100%'; im.style.width=''; im.style.height='auto';
      dstCv.parentNode.replaceChild(im,dstCv); return; } var tbl=_chartTable(srcCv); var box=document.createElement('div'); if(tbl){ box.innerHTML=tbl; } else { box.style.cssText='padding:14px;text-align:center;color:#999;font-size:11px;border:1px dashed #d6cdbf;border-radius:6px;background:#faf9f5;'; box.textContent=_T('(그래프는 화면 \u2018결과 보기\u2019에서 확인하세요)',"(View the chart on the 'View Results' screen)"); } dstCv.parentNode.replaceChild(box,dstCv); }
    var srcC=rep.querySelectorAll('canvas'), dstC=clone.querySelectorAll('canvas');
    for(var i=0;i<srcC.length;i++){ _swapCanvas(srcC[i],dstC[i]); }
    // 청중별 상세 분석(#detailed-result + 확장섹션) 추가 — 교사>학부모>학생 분량 차등
    function _cloneWithImgs(srcEl){ if(!srcEl) return ''; var c=srcEl.cloneNode(true); var sc=srcEl.querySelectorAll('canvas'), dc=c.querySelectorAll('canvas'); for(var k=0;k<sc.length;k++){ _swapCanvas(sc[k],dc[k]); } c.querySelectorAll('.no-print, [data-pia-lang-toggle], button').forEach(function(b){ try{ b.remove(); }catch(e){} }); return c.innerHTML; }
    var _detEl=document.getElementById('detailed-result');
    var _extEl=document.getElementById('extended-sections');
    var _detHTML=_cloneWithImgs(_detEl);
    /* extended-sections 는 tiposs 아코디언 옆(=detailed-result 안)에 붙는다.
       그대로 또 이어붙이면 심층분석 18쪽이 통째로 두 번 인쇄된다. (2026-08-31) */
    var _extHTML = (_extEl && _detEl && _detEl.contains(_extEl)) ? '' : _cloneWithImgs(_extEl);
    var _audClass=(currentAudience==='teacher')?'aud-teacher':(currentAudience==='parent')?'aud-parent':'aud-self';
    var _audNote=(currentAudience==='teacher')?_T('아래 내용은 학생의 측정 결과를 <b>선생님(지도자) 관점에서 해석</b>한 지도·상담 참고자료입니다. 앞쪽 측정 결과 페이지와 구분해 활용하세요.',"The content below interprets the student's results <b>from a teacher's perspective</b>, as reference material for guidance and counseling. Use it separately from the standard results pages above."):(currentAudience==='parent')?_T('아래 내용은 자녀의 측정 결과를 <b>학부모 관점에서 해석</b>한 가정 지도 참고자료입니다.',"The content below interprets your child's results <b>from a parent's perspective</b>, as reference material for guidance at home."):_T('아래 내용은 본인의 측정 결과를 <b>이해하기 쉽게 해석</b>한 자료입니다.','The content below interprets your own results <b>in an easy-to-understand way</b>.');
    var _analysis = (_detHTML||_extHTML) ? ('<div class="aud-analysis '+_audClass+'"><div class="aud-analysis-head">📋 '+(_audKo||'')+_T(' 맞춤 해석 ',' Personalized Interpretation ')+'<span style="font-weight:600;font-size:11px;">'+_T('(측정 결과 해석·참고자료)','(Interpretation & Reference Material)')+'</span></div><div class="aud-analysis-note">'+_audNote+'</div>'+_detHTML+_extHTML+'</div>') : '';
    _piaRestoreAcc(_piaAccSaved);
    /* 주제별로 한 장씩 떨어지게 한다.
       상세 해석은 아코디언 하나가 한 주제이므로 그 경계에서 쪽을 나눈다.
       내용이 없는 아코디언은 통째로 빼서 빈 페이지가 생기지 않게 한다. */
    var _topicCss='';
    try{
      /* 복제본은 문서에 붙어 있지 않아 offsetHeight 가 전부 0 이다.
         화면에 살아 있는 아코디언에서 먼저 재어 두고 순서로 짝짓는다. (2026-09-01) */
      var _liveH=[], _liveW=0;
      try{
        var _live=(_detEl?_detEl.querySelectorAll('details.pia-acc, .pia-acc'):[]);
        _liveW = (_detEl && _detEl.offsetWidth) || 1391;
        for(var _li=0; _li<_live.length; _li++){
          var _wasOpen=_live[_li].open;
          _live[_li].open=true;
          _liveH.push(_live[_li].offsetHeight||0);
          _live[_li].open=_wasOpen;
        }
      }catch(e){ console.error('주제 높이 측정 실패', e); }
      var _an=document.createElement('div'); _an.innerHTML=_analysis;
      var _idx=-1, _첫주제=false;
      /* 앞쪽 표준화 리포트(1~10쪽)에 이미 실린 주제는 상세 해석에서 다시 싣지 않는다.
         화면에서는 그대로 두고 인쇄본에서만 뺀다 — 같은 그래프·표가 두 번 나와
         쪽수만 늘고 읽는 사람이 헷갈렸다. (2026-09-01) */
      var 리포트중복 = _plPR ? ['Big5', 'RIASEC', 'Multiple Intelligences (MI)',
                        'Subject Learning', 'Well-Being'] : ['성격 5요인', 'RIASEC 진로 흥미', '다중지능(MI)',
                        '분야별 학습·역량', '웰빙·자존감'];
      _an.querySelectorAll('details.pia-acc, .pia-acc').forEach(function(d){
        _idx++;
        var 알맹이=(d.innerText||'').replace(/\s+/g,'');
        var 요약el=d.querySelector('summary');
        var 제목원문=요약el?요약el.innerText:'';
        var 제목=제목원문.replace(/\s+/g,'');
        if(리포트중복.some(function(k){ return 제목원문.indexOf(k)>=0; })){ try{ d.remove(); }catch(e){} return; }
        if(알맹이.length - 제목.length < 12){ try{ d.remove(); }catch(e){} return; }  /* 제목만 있고 내용 없음 */
        /* 한 쪽에 들어갈 만한 주제만 통으로 묶는다. 페이지보다 긴 주제까지
           묶으면 앞쪽에 큰 빈 공간이 생긴다. (화면 높이 기준 대략치) */
        /* [2026-09-27] 제목의 '… 보기'/'View …' 는 화면에서 펼치라는 버튼 문구다. 종이에서는 뜻이 없어 뗀다. */
        try{ if(요약el){ var _tw=document.createTreeWalker(요약el, NodeFilter.SHOW_TEXT, null), _tn;
          while((_tn=_tw.nextNode())){ var _tv=_tn.nodeValue, _nv=_tv.replace(/\s*보기\s*$/,'').replace(/(^|\s)View\s+/,'$1'); if(_nv!==_tv) _tn.nodeValue=_nv; } } }catch(e){}
        d.classList.add('pia-topic-page');
        /* 첫 주제는 앞의 머리말(대상 안내·AI 종합 해석·신뢰도)과 같은 장에 붙인다.
           따로 떼면 머리말만 있는 반쪽짜리 장이 생긴다. (2026-09-01) */
        if(!_첫주제){ _첫주제=true; d.classList.add('pia-topic-first'); }
        /* 한 쪽보다 '조금' 긴 주제는 꼬리 몇 줄만 다음 장으로 넘어가 그 장이 통째로 빈다.
           그런 주제만 살짝 줄여 한 쪽에 앉힌다. 많이 긴 주제는 건드리지 않고 흘려보낸다.
           환산: 인쇄 본문 폭 180mm 가 화면 폭에 대응하므로, 한 쪽 높이 262mm 는
           화면 기준 (화면폭/180)*262 px 이다. (2026-09-01) */
        try{
          var 화면폭 = _liveW || 1391;
          /* 인쇄 본문은 11pt 로 화면(14~16px)보다 상대적으로 크다.
             화면 높이를 그대로 환산하면 실제로는 넘친다. 0.72 를 곱해 여유를 둔다.
             이 값은 실제 PDF 쪽수를 재어 맞춘 경험치다. (2026-09-01) */
          var 한쪽 = (화면폭/180)*262*0.72;
          var 높이 = _liveH[_idx] || 0;
          /* 한 쪽을 넘치면 줄여서 앉히고, 너무 작으면 조금 키운다.
             줄이는 하한은 0.62 — 이보다 작으면 인쇄 권장 글자 크기 아래로 내려간다. */
          /* 글자 크기는 문서 전체에서 같아야 한다. 그래서 배율은 원칙적으로 1 이고,
             한 장을 아주 조금 넘겨 꼬리 몇 줄만 다음 장으로 밀리는 경우에만
             0.88 까지 줄여 같은 장에 앉힌다. 그보다 많이 넘치는 주제는 억지로
             줄이지 않고 두 장에 걸쳐 흘려보낸다 — 글자 크기가 튀는 것보다 낫다.
             확대는 하지 않는다. (2026-09-01) */
          if (높이 > 한쪽) {
            var 배율 = (한쪽*0.97)/높이;
            if (배율 >= 0.88) {
              d.style.zoom = 배율.toFixed(3);
              d.setAttribute('data-fit', 배율.toFixed(3));
              d.classList.add('pia-topic-fit');
            }
          } else if (높이 > 0) {
            /* 한 쪽 안에 들어가는 주제 — 쪼개지지 않게만 한다(강제 새 쪽 없음). */
            d.classList.add('pia-topic-fit');
          }
        }catch(e){ console.error('주제 한쪽 맞춤 실패', e); }
      });
      _analysis=_an.innerHTML;
    }catch(e){ console.error('주제별 페이지 분리 실패', e); }
    /* [2026-09-26] 주제마다 강제로 새 쪽을 열던 방식(break-before:page)을 걷어냈다.
       주제 대부분이 반 쪽 안팎이라 1/4~1/3 만 찬 쪽이 줄줄이 생겨 학생 23·학부모 25·
       교사 31쪽까지 늘었다. 이제 주제는 앞 주제 바로 뒤에 이어 붙이고,
       한 쪽에 들어가는 주제(.pia-topic-fit)만 통째로 다음 쪽으로 넘긴다(break-inside:avoid).
       한 쪽보다 긴 주제는 흘려보내되 카드·표·그래프 단위는 아래 규칙으로 쪼개지지 않는다. */
    _topicCss='.pia-topic-page{break-before:auto;page-break-before:auto;break-inside:auto;}'
      +'.pia-topic-fit{break-inside:avoid;page-break-inside:avoid;}'
      +'.pia-topic-first{break-before:auto!important;page-break-before:auto!important;}'
      +'.aud-analysis .rounded-2xl,.aud-analysis .rounded-xl,.aud-analysis table,.aud-analysis tr,.aud-analysis li{break-inside:avoid;page-break-inside:avoid;}'
      /* 맞춤 해석도 새 쪽을 강제하지 않는다 — 10쪽 결론이 조금 넘친 쪽(1/4 가량)에 이어 붙인다.
         머리말(제목+안내)과 첫 주제가 떨어지지 않게 머리말 뒤 나눔만 막는다. */
      +'.aud-analysis{break-before:auto!important;page-break-before:auto!important;margin-top:6mm;}'
      +'.aud-analysis-head,.aud-analysis-note{break-after:avoid;page-break-after:avoid;break-inside:avoid;}'
      +'h1,h2,h3,h4,summary{break-after:avoid;page-break-after:avoid;}'
      +'.pia-topic-page{margin-bottom:0!important;}'
      /* [2026-09-27] 표준 리포트 2~10쪽도 장마다 새 쪽을 강제하지 않는다. 60~75%만 찬 쪽이
         9장 이어져 빈 공간만 2~3쪽 분량이었다. 표지만 한 장으로 두고, 나머지 장은 앞 장 뒤에
         이어 붙인다. 카드·표·그래프·장 머리는 쪼개지지 않는다(글자 크기는 줄이지 않음).
         장 머리의 'N / 10' 은 실제 인쇄 쪽과 맞지 않아 인쇄에서만 숨긴다. */
      +'#pia-report .page{break-after:auto!important;page-break-after:auto!important;}'
      +'#pia-report #p-cover{break-after:page!important;page-break-after:always!important;}'
      +'#pia-report .page+.page{margin-top:4mm!important;}'
      +'#pia-report .page-header{break-after:avoid;page-break-after:avoid;break-inside:avoid;}'
      +'#pia-report .page-header .page-num{display:none!important;}'
      /* 인성 항목 카드는 머리+게이지·설명 / 표 두 덩어리로만 나뉠 수 있게 한다. 카드 통째로 넘기면
         한 쪽에 3장만 앉고 아래 28%가 비었다. */
      +'#pia-report .two-col,#pia-report .alert-box,#pia-report .rainbow-bar-wrap,#pia-report .info-table{break-inside:avoid;page-break-inside:avoid;}'
      +'#pia-report .item-card-head{break-after:avoid;page-break-after:avoid;}'
      /* 한 쪽에 들어가는 주제를 통째로 다음 쪽으로 넘기던 규칙(.pia-topic-fit)은 쪽 아래를 최대
         주제 하나만큼 비웠다. 이제 주제 안에서도 나뉠 수 있되, 카드·표·목록 한 줄은 쪼개지지 않는다(위 규칙). */
      +'.pia-topic-fit{break-inside:auto!important;page-break-inside:auto!important;}'
      /* 주제 본문은 대개 큰 카드 한 장(.rounded-2xl)이라 위 규칙만으로는 여전히 통째로 넘어갔다.
         바깥 카드만 나눔을 허용하고, 그 안의 작은 카드·표·목록 줄은 그대로 지킨다. */
      +'.aud-analysis .pia-acc-body>.rounded-2xl{break-inside:auto!important;page-break-inside:auto!important;}'
      +'#pia-report .page>.two-col{break-inside:auto!important;page-break-inside:auto!important;}'
      +'#pia-report .item-card{break-inside:avoid;page-break-inside:avoid;}'
      +'.pia-acc-caret{display:none!important;}'
      /* [2026-09-27] 인쇄 글자 크기 하한. 실측 결과 본문 대부분이 8.25pt(표·설명, 11px)·9pt(맞춤 해석)로
         인쇄 본문 권장치(10~12pt)보다 작았다. 본문 성격의 글(표 칸·설명·목록·안내)은 10pt 로,
         각주·출처 같은 보조 글은 8.5pt 로 올린다. 쪽수를 줄이려고 글자를 줄이지 않는다. */
      +'#pia-report .data-table td,#pia-report .data-table th,#pia-report .info-table td,#pia-report .desc-para,#pia-report .alert-box,#pia-report .sub-heading,#pia-report .data-table td *{font-size:10pt!important;line-height:1.45!important;}'
      +'#pia-report .data-table .grade-box{font-size:9pt!important;padding:1px 6px!important;}'
      +'#pia-report p[style*="font-size:9px"],#pia-report p[style*="font-size:10px"],#pia-report .pia-norm-note{font-size:8.5pt!important;}'
      +'.aud-analysis :is(p,li,td,th,.text-xs):not(.text-sm):not(.text-base):not(.text-lg):not(.text-xl){font-size:10pt!important;}'
      +'.aud-analysis .text-\\[10px\\],.aud-analysis .text-\\[11px\\]{font-size:8.5pt!important;}'
      +'#pia-report .section-title,#pia-report .section-title-diamond,#pia-report .sub-heading,#pia-report .section-title+p,#pia-report .section-title-diamond+p{break-after:avoid;page-break-after:avoid;}'
      /* 화면용 카드 여백이 인쇄에서는 과하다. 종이에 맞게 줄여 쪽수를 아낀다. */
      +'.aud-analysis .rounded-2xl,.aud-analysis .bg-white{padding:3mm!important;margin:0 0 3mm!important;border-radius:3mm!important;}'
      +'.aud-analysis .mt-5,.aud-analysis .mt-4,.aud-analysis .mt-3{margin-top:3mm!important;}'
      +'.aud-analysis .p-4,.aud-analysis .p-5,.aud-analysis .px-5,.aud-analysis .py-3{padding:3mm!important;}'
      +'.aud-analysis .space-y-5>*+*{margin-top:3mm!important;}'
      +'.aud-analysis ul,.aud-analysis ol{margin:2mm 0 2mm 5mm!important;}'
      +'.aud-analysis li{margin-bottom:1mm!important;}'
      +'#pia-report .page{padding:0!important;}'
      /* 그래프는 종이에서 지나치게 크지 않게 — 글과 함께 한 쪽에 들어가도록 */
      +'.aud-analysis img{max-height:46mm!important;width:auto!important;display:block;margin:2mm auto!important;}'+'.aud-analysis{font-size:10.5pt!important;line-height:1.5!important;}'+'.aud-analysis h3{font-size:12pt!important;margin:0 0 2mm!important;}'+'.aud-analysis p{margin:0 0 2mm!important;}'+'.aud-analysis table{font-size:9.5pt!important;}'+'.aud-analysis td,.aud-analysis th{padding:1mm 2mm!important;}'
      +'#pia-report img{max-height:52mm!important;width:auto!important;}'+'.aud-analysis .rounded-2xl,.aud-analysis .bg-white{padding:2.5mm!important;margin:0 0 2.5mm!important;}'+'.aud-analysis details{margin:0 0 2.5mm!important;}'+'.aud-analysis summary{margin-bottom:1.5mm!important;}'+'.aud-analysis .grid{gap:2mm!important;}'+'.aud-analysis blockquote{margin:1.5mm 0!important;padding:1.5mm 3mm!important;}'+'.aud-analysis-head{margin-bottom:3mm!important;padding-bottom:2mm!important;}'+'.aud-analysis-note{margin-bottom:3mm!important;padding:2mm 3mm!important;}';

    /* 바닥글 — 여러 장을 뽑았을 때 누구 것인지 알아볼 수 있어야 한다.
       쪽 번호는 브라우저 인쇄창의 "머리글/바닥글"이 넣어 준다(크롬은 CSS 로
       쪽 번호를 만들 수 없다). 여기에는 식별 정보만 담는다. */
    var _footName='';
    try{ _footName=((state.profile||{}).name)||state.studentId||''; }catch(e){}
    /* 2026-09-01: position:fixed 바닥글을 없앴다. 크롬 인쇄에서 매 쪽에 반복되기는
       하지만 본문 위에 겹쳐 찍혀 제목을 가렸다. 식별 정보는 표지와 각 주제 머리에
       이미 들어 있고, 쪽 번호는 브라우저 인쇄창의 머리글/바닥글로 넣는다. */
    var _foot='';

    /* 인쇄 문서로 넘기는 CSS 에서 주석·불필요한 공백을 걷어낸다.
       화면용 스타일시트에는 설명 주석이 많은데(가장 큰 것 53KB 중 상당수),
       인쇄 창은 이 CSS 를 다시 파싱해야 해서 그만큼 늦게 뜬다.
       한 번 만들어 두고 재사용한다 — 인쇄를 두 번째 누를 때는 그냥 쓴다. (2026-09-02) */
    /* 인쇄 문서로 넘길 CSS 를 추린다.
       화면 전체분(102KB·1,378규칙)을 그대로 실으면 인쇄창이 그 규칙을 전부
       2,300여 요소에 대조하느라 레이아웃에만 수백 ms 를 쓴다. 그런데 그중
       대부분은 홈·대화·키오스크용이라 결과지에는 한 줄도 닿지 않는다
       (가장 큰 53KB 시트는 437규칙 중 2개만 쓰인다).
       그래서 실제 인쇄 본문에 맞는 규칙만 남긴다. 기본 요소 셀렉터와
       @media·@font-face·@keyframes 는 판정 없이 보존해 인쇄용 규칙이
       잘려나가지 않게 한다. 결과 높이는 전체분과 동일함을 확인했다.
       (2026-09-02) */
    var _cssKey = 'v1|' + (currentAudience || '');
    var styles = (window.__piaPrintCssKey === _cssKey) ? window.__piaPrintCss : null;
    if (!styles) {
      styles = '';
      var _probe = null;
      try {
        _probe = document.createElement('div');
        _probe.style.cssText = 'position:fixed;left:-99999px;top:0;width:1200px;';
        _probe.innerHTML = _foot + clone.outerHTML + _analysis;
        document.body.appendChild(_probe);
      } catch (e) { _probe = null; }
      /* 요소·:host·:root 셀렉터는 판정 없이 남긴다. 이런 규칙은 결과지 안 요소에
         직접 붙지 않아도 상속으로 전달되기 때문이다. 실제로 Tailwind 의
         ':host, html{line-height:1.5}' 를 떨어뜨렸더니 body 가 이를 상속받지 못해
         본문 1,300여 요소의 줄간격이 한꺼번에 틀어졌다. 콤마로 갈라 조각마다 본다. */
      var _기본 = /^(\*|:host|:root|html|body|img|table|td|th|tr|thead|tbody|p|li|ul|ol|dl|dt|dd|div|span|h[1-6]|small|strong|b|i|em|u|summary|details|textarea|input|button|select|option|canvas|figure|figcaption|svg|a|hr|br|section|article|header|footer|nav|main|aside|blockquote|pre|code|label|fieldset|legend|caption|sub|sup)\b/i;
      var _남길까 = function (sel) {
        var parts = String(sel || '').split(',');
        for (var i = 0; i < parts.length; i++) { if (_기본.test(parts[i].trim())) return true; }
        try { return !!_probe.querySelector(sel); } catch (e) { return true; }
      };
      /* [2026-09-24] 인라인 <style> 을 css/*.css 로 옮겼다. 옮긴 시트(link[data-block])도
         같은 문서 순서로 모아야 인쇄 결과가 그대로다. 링크는 textContent 가 비어 있으므로
         _probe 가 없어도 cssRules 로 읽는다(_남길까 는 그때 전부 남긴다). */
      document.querySelectorAll('style,link[data-block]').forEach(function (st) {
        var css = st.textContent || '';
        var 규칙 = null;
        if (_probe || st.tagName === 'LINK') { try { 규칙 = st.sheet && st.sheet.cssRules; } catch (e) { 규칙 = null; } }
        if (규칙) {
          var out = '';
          for (var i = 0; i < 규칙.length; i++) {
            var r = 규칙[i];
            if (r.type === 1) {                       /* 일반 규칙 — 쓰이는 것만 */
              if (_남길까(r.selectorText)) out += r.cssText;
            } else { out += r.cssText; }               /* @media·@font-face·@keyframes 등은 보존 */
          }
          css = out;
        } else {
          try {
            css = css.replace(/\/\*[\s\S]*?\*\//g, '')
                     .replace(/\s*\n\s*/g, '\n')
                     .replace(/\n{2,}/g, '\n');
          } catch (e) {}
        }
        if (css.trim()) styles += '<style>' + css + '</style>';
      });
      if (_probe) { try { _probe.remove(); } catch (e) {} }
      window.__piaPrintCss = styles;
      window.__piaPrintCssKey = _cssKey;
    }
    /* 팝업창 대신 숨김 iframe 으로 인쇄한다. 폰·키오스크 브라우저는 window.open 팝업을 자주 차단해 "팝업이 차단되었습니다"로 인쇄가 막혔다. iframe 이 안 되는 환경에서만 팝업으로 폴백. */
    var _pf=document.getElementById('pia-print-frame'); if(_pf){ try{ _pf.remove(); }catch(e){} }
    var _ifr=null, w=null;
    try{ _ifr=document.createElement('iframe'); _ifr.id='pia-print-frame'; _ifr.setAttribute('aria-hidden','true'); _ifr.style.cssText='position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;'; document.body.appendChild(_ifr); w=_ifr.contentWindow; }catch(e){ w=null; }
    if(!w){ w=window.open('','_blank'); if(!w){ alert(_T('인쇄 창을 열 수 없습니다. 브라우저에서 팝업을 허용한 뒤 다시 시도하세요.','Unable to open the print window. Please allow pop-ups in your browser and try again.')); return; } }
    var _printHTML = '<!doctype html><html lang="'+(_plPR?'en':'ko')+'"><head><meta charset="utf-8"><title>'+_T('예담 톡 통합 결과지','YEDAM Talk Integrated Report')+(_audKo?(' \u2014 '+_audKo):'')+'</title>'+styles+'<style>@page{size:A4;margin:13mm 15mm 15mm 15mm;} html,body,*{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important;} body{font-size:12.5pt!important;line-height:1.6!important;text-align:left;} p,li,td,th,div{line-height:1.55;} h1{font-size:22pt!important;} h2{font-size:17pt!important;} h3{font-size:15pt!important;} summary{font-size:14pt!important;font-weight:800!important;} small,.text-xs,.text-\[10px\],.text-\[11px\]{font-size:11pt!important;line-height:1.5!important;} .text-sm{font-size:12pt!important;} .pia-print-foot{display:none!important;} #pia-report .page:empty{display:none!important;} #pia-report .rep-issue-foot{break-before:avoid!important;page-break-before:avoid!important;break-inside:avoid!important;margin-top:5mm!important;padding-top:3mm!important;} #pia-report .rep-issue-foot div{font-size:9pt!important;line-height:1.55!important;} #pia-report #p-cover{min-height:auto!important;height:auto!important;padding-bottom:6mm!important;display:block!important;} #pia-report #p-cover .cover-wrap{min-height:0!important;height:auto!important;} #pia-report .page>*:empty{display:none!important;} #p-cover .cover-wrap{zoom:1!important;} textarea,.overflow-auto,.overflow-y-auto,.overflow-x-auto,[class*=max-h-],[style*=overflow]{overflow:visible!important;max-height:none!important;height:auto!important;} textarea{border:1px solid #e3e0d6!important;resize:none!important;white-space:pre-wrap!important;font-size:10.5pt!important;} details{display:block!important;} details>*{display:revert!important;} table,img,figure,canvas{break-inside:avoid;page-break-inside:avoid;} img{max-width:100%!important;height:auto!important;} /* 화면에서 2단이던 목록이 인쇄에서는 지면 폭이 640px 기준에 못 미쳐 1단으로 떨어지며 길이가 두 배가 됐다(24개 강점 목록이 두 장으로 넘어간 원인). 인쇄에서도 단 수를 그대로 유지한다. (2026-09-01) */ .grid.sm\\:grid-cols-2,.grid.md\\:grid-cols-2,.grid.lg\\:grid-cols-2{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;} .grid.sm\\:grid-cols-3,.grid.md\\:grid-cols-3,.grid.lg\\:grid-cols-3{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;} .grid.sm\\:grid-cols-4,.grid.md\\:grid-cols-4,.grid.lg\\:grid-cols-4{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;} .sm\\:flex-row,.md\\:flex-row{flex-direction:row!important;} #pia-report #p-cover img{height:13px!important;width:auto!important;max-width:none!important;} html,body{margin:0;padding:0;background:#fff;height:auto;overflow:visible;} #pia-report{background:#fff!important;padding:0;margin:0;} #pia-report .page{width:auto!important;max-width:100%!important;min-height:0!important;height:auto!important;margin:0 auto!important;padding:3mm!important;box-shadow:none!important;border-radius:0!important;border:none!important;break-after:page;page-break-after:always;break-inside:auto;overflow:visible;} #pia-report .page:last-child{page-break-after:auto;break-after:auto;} #pia-report canvas,#pia-report img{max-width:100%!important;} .aud-analysis{page-break-before:always;padding:3mm!important;background:#faf7f2;} .aud-analysis-head{font-size:15px;font-weight:800;color:#b04928;border-bottom:2px solid #d97757;padding-bottom:6px;margin-bottom:12px;} .aud-analysis-note{font-size:11px;color:#7a5c3a;background:#fff5e8;border-left:4px solid #d9a557;padding:8px 11px;border-radius:6px;margin-bottom:14px;line-height:1.6;} .aud-analysis.aud-teacher{background:#f3f6fb;} .aud-analysis.aud-teacher .aud-analysis-head{color:#2c4a6b;border-bottom-color:#5b8fd1;} .aud-analysis.aud-teacher .aud-analysis-note{background:#eaf1f9;border-left-color:#5b8fd1;color:#2c4a6b;} .aud-analysis .mt-5{margin-top:14px;} .aud-analysis .rounded-2xl,.aud-analysis .bg-white,.aud-analysis canvas,.aud-analysis img,.aud-analysis h3{break-inside:avoid;page-break-inside:avoid;} .aud-analysis canvas,.aud-analysis img{max-width:100%!important;} #pia-report #p-cover{display:flex;align-items:center;justify-content:center;min-height:248mm;} #p-cover .cover-wrap{zoom:1.18;} .no-print{display:none!important;}'+_topicCss+piaIssuePageCss()+'</style></head><body>'+_foot+clone.outerHTML+_analysis+piaIssueFootHTML(true)+'</body></html>';
    /* 인쇄본을 그대로 화면에 띄우는 경로 — 쪽수·여백·중복을 눈으로 재기 위한 것.
       ?printdoc=teacher 처럼 열면 인쇄창 없이 인쇄 결과 자체를 볼 수 있다. */
    if (window.__piaPrintDocOnly) { document.open(); document.write(_printHTML); document.close(); return; }
    w.document.open();
    w.document.write(_printHTML);
    w.document.close();
    try{ if(audOverride && currentAudience!==_prevAud){ currentAudience=_prevAud; if(typeof renderDetailedResult==='function')renderDetailedResult(); if(typeof renderExtendedSections==='function')renderExtendedSections(); } }catch(e){}
    /* 문서를 다 쓴 뒤 브라우저가 반영할 최소 시간만 준다(300ms → 60ms). */
    setTimeout(function(){ try{ w.focus(); w.print(); }catch(e){} }, 60);
    }catch(e){ try{ window.print(); }catch(_){} }
    }, _needRender ? 150 : 0);
  }catch(e){ try{ window.print(); }catch(_){} }
}
function piaPrintItems(){
  try{
    function esc(x){ return (typeof _escHtml==='function')? _escHtml(x) : String(x==null?'':x); }
    function legendFor(lo,hi){
      if(lo===0&&hi===3) return _T('0 전혀 아니다 · 1 며칠 · 2 절반 이상 · 3 거의 매일','0 Not at all \u00b7 1 Several days \u00b7 2 More than half the days \u00b7 3 Nearly every day');
      if(lo===1&&hi===4) return _T('1 전혀 아니다 · 2 아니다 · 3 그렇다 · 4 매우 그렇다','1 Not at all \u00b7 2 Disagree \u00b7 3 Agree \u00b7 4 Strongly agree');
      if(lo===1&&hi===6) return _T('1 전혀 없음 · 2 가끔 · 3 절반 이하 · 4 절반 이상 · 5 대부분 · 6 항상','1 Never \u00b7 2 Occasionally \u00b7 3 Less than half the time \u00b7 4 More than half the time \u00b7 5 Most of the time \u00b7 6 Always');
      return _T('1 전혀 아니다 · 2 아니다 · 3 보통 · 4 그렇다 · 5 매우 그렇다','1 Strongly disagree \u00b7 2 Disagree \u00b7 3 Neutral \u00b7 4 Agree \u00b7 5 Strongly agree');
    }
    function tbl(title, items, opts){
      var sp=(opts&&opts.scale?opts.scale:'1~5').split('~'); var lo=parseInt(sp[0],10), hi=parseInt(sp[1],10);
      var nums=''; for(var v=lo;v<=hi;v++){ nums+='<th style="width:26px;text-align:center;padding:5px 3px">'+v+'</th>'; }
      var rows=(items||[]).map(function(it,i){
        var t=(typeof it==='string')?it:((it&&(it.t||it.q))||'');
        var os=''; for(var v2=lo;v2<=hi;v2++){ os+='<td style="text-align:center;padding:4px 3px;border-bottom:1px solid #eee">○</td>'; }
        return '<tr><td style="text-align:center;color:#999;padding:4px 6px;border-bottom:1px solid #eee">'+(i+1)+'</td><td style="padding:4px 6px;border-bottom:1px solid #eee">'+esc(t)+'</td>'+os+'</tr>';
      }).join('');
      return '<section style="margin:14px 0"><div class="qhead"><h2 style="font-size:15px;font-weight:800;margin:10px 0 1px;color:#141413">'+esc(title)+'</h2><p style="font-size:11.5px;color:#666;margin:0 0 4px">'+legendFor(lo,hi)+'</p></div><table style="width:100%;border-collapse:collapse;font-size:13px"><thead><tr style="background:#f3f1ea"><th style="width:30px;padding:5px 6px;text-align:center">No</th><th style="padding:5px 6px;text-align:left">'+_T('문항','Item')+'</th>'+nums+'</tr></thead><tbody>'+rows+'</tbody></table></section>';
    }
    function sjtTbl(){
      var rows=(typeof SJT_30!=='undefined'?SJT_30:[]).map(function(sc,i){
        var ch=(sc.choices||[]).map(function(c){return '<li style="margin:2px 0">○ '+esc(c.t)+'</li>';}).join('');
        return '<section style="margin:8px 0;break-inside:avoid;page-break-inside:avoid"><div style="font-weight:700;font-size:13px">'+(i+1)+'. '+esc(sc.q)+'</div><ul style="list-style:none;margin:3px 0 0 8px;padding:0;font-size:12.5px">'+ch+'</ul></section>';
      }).join('');
      return '<section style="margin:14px 0"><div class="qhead"><h2 style="font-size:15px;font-weight:800;margin:10px 0 4px;color:#141413">'+_T('SJT 상황판단 검사','SJT Situational Judgment Test')+'</h2><p style="font-size:11.5px;color:#666;margin:0 0 4px">'+_T('각 상황에서 자신과 가장 가까운 보기의 ○에 표시하세요.','For each situation, mark the ○ next to the option closest to how you would respond.')+'</p></div>'+rows+'</section>';
    }
    /* 문제지 폰트·크기 통일 — 전 섹션 동일 서체·본문 13px(제목 14/18, 안내 12). 인라인 크기 위에 !important 로 덮는다. */
    var st='<style>'
      +'.pia-qsheet,.pia-qsheet *{font-family:"Noto Sans KR",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;box-sizing:border-box}'
      +'.pia-qsheet{font-size:13px!important;line-height:1.55;color:#141413;background:#fff}'
      +'.pia-qsheet h1{font-size:18px!important}'
      +'.pia-qsheet h2{font-size:14px!important}'
      +'.pia-qsheet p{font-size:12px!important}'
      +'.pia-qsheet table,.pia-qsheet td,.pia-qsheet th{font-size:13px!important}'
      +'.pia-qsheet li{font-size:13px!important}'
      +'.pia-qsheet table td,.pia-qsheet table th{border-bottom:1px solid #eee}'
      +'@media print{@page{size:A4;margin:10mm} thead{display:table-header-group} tr{break-inside:avoid;page-break-inside:avoid} .qhead{break-inside:avoid;page-break-after:avoid} table{break-inside:auto;page-break-inside:auto} section{break-inside:auto} .no-print{display:none!important}}'
      +'</style>';
    var out=st+'<div class="pia-qsheet" style="max-width:880px;margin:0 auto;padding:20px;font-family:\'Noto Sans KR\',-apple-system,sans-serif;color:#141413;background:#fff">'
      +'<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px;border-bottom:2px solid #d97757;padding-bottom:8px">'
      +'<h1 style="font-size:20px;font-weight:800;margin:0">'+_T('예담 톡 · 전체 검사 문항지','YEDAM Talk \u00b7 Full Assessment Item Sheet')+'</h1>'
      +'<div class="no-print"><button data-act="@print" style="background:#d97757;color:#fff;border:0;border-radius:8px;padding:8px 16px;font-weight:700;cursor:pointer">🖨 '+_T('인쇄','Print')+'</button></div></div>'
      +'<p style="font-size:12.5px;color:#555;margin:0 0 12px;line-height:1.6">'+_T('각 문항을 읽고, 자신과 가장 가까운 번호의 ○에 색칠하거나 ∨ 표시하세요.','Read each item and fill in or mark (∨) the ○ under the number closest to your answer.')+'</p>'
      +tbl(_T('IPIP Big5-50 (성격 5요인)','IPIP Big5-50 (Personality Five Factors)'),(typeof IPIP_BIG5_50!=='undefined'?IPIP_BIG5_50:[]),{scale:'1~5'})
      +tbl(_T('RIASEC-30 (진로 흥미)','RIASEC-30 (Career Interest)'),(typeof RIASEC_30!=='undefined'?RIASEC_30:[]),{scale:'1~5'})
      +tbl(_T('24 강점 (성격강점)','24 Strengths (Character Strengths)'),(typeof VIA_YOUTH!=='undefined'?VIA_YOUTH:[]),{scale:'1~5'})
      +tbl(_T('끈기·근면 척도','Grit & Perseverance Scale'),(typeof GRIT_S!=='undefined'?GRIT_S:[]),{scale:'1~5'})
      +tbl(_T('WHO-5 (정서 웰빙)','WHO-5 (Emotional Well-Being)'),(typeof WHO5!=='undefined'?WHO5:[]),{scale:'1~6'})
      +tbl(_T('RSES (자존감)','RSES (Self-Esteem)'),(typeof RSES!=='undefined'?RSES:[]),{scale:'1~4'})
      +tbl(_T('학습역량 (과목별)','Learning Competency (By Subject)'),(typeof LEARN_ITEMS!=='undefined'?LEARN_ITEMS:[]),{scale:'1~5'})
      +tbl(_T('다중지능 MI','Multiple Intelligences (MI)'),(typeof MI_ITEMS!=='undefined'?MI_ITEMS:[]),{scale:'1~5'})
      +tbl(_T('CES-D-10 (우울 선별)','CES-D-10 (Depression Screening)'),(typeof CES_D_10!=='undefined'?CES_D_10:[]),{scale:'0~3'})
      +tbl(_T('PHQ-A (우울 선별)','PHQ-A (Depression Screening)'),(typeof PHQ_A!=='undefined'?PHQ_A:[]),{scale:'0~3'})
      +tbl(_T('GAD-7 (불안 선별)','GAD-7 (Anxiety Screening)'),(typeof GAD_7!=='undefined'?GAD_7:[]),{scale:'0~3'})
      +sjtTbl()
      +'<p style="font-size:11px;color:#aab;margin-top:18px;border-top:1px solid #eee;padding-top:10px">'+_T('© 예담 톡 · 예담정보통신 — 교육·진로·자기이해 참고용 도구','© YEDAM Talk \u00b7 Yedam Information & Communication \u2014 A reference tool for education, career guidance, and self-understanding')+'</p></div>';
    document.body.innerHTML=out; document.title=_T('예담 톡 전체 문항지','YEDAM Talk Full Item Sheet');
  }catch(e){ try{ document.body.innerHTML='<pre style="padding:20px">'+_T('문항 출력 오류: ','Item sheet output error: ')+(e&&e.message)+'</pre>'; }catch(_){} }
}
function piaSampleReport(){
  try{
    state.profile={name:'샘플 학생', grade:'중2', class:'1', school:'예시중학교', createdAt:Date.now()};
    try{ var _a=new URLSearchParams(piaEffectiveSearch()).get('aud'); currentAudience=(['student','parent','teacher'].indexOf(_a)>=0 && audAllowed(_a))?_a:'student'; }catch(e){ currentAudience='student'; }
    var rnd=function(lo,hi){return lo+Math.floor(Math.random()*(hi-lo+1));};
    var fill=function(key,bank,lo,hi,fn){ try{ var len=(bank&&bank.length)||0; if(!len)return; var a=[]; for(var k=0;k<len;k++)a.push(rnd(lo,hi)); if(state.results[key]){ state.results[key].answers=a; if(typeof fn==='function')state.results[key].scores=fn(); } }catch(e){} };
    /* [2026-09-27] 문항마다 1~5 를 따로 뽑으면 역문항이 서로 모순돼 '응답 성실도 주의'가 나고
       (→ 신뢰도 상한 B), 강점 순위도 잡음뿐이다. 샘플은 '성실히 응답한 가상 학생'으로 —
       척도(f)마다 성향값을 하나 뽑고 문항은 그 주변에서 조금씩 흔들며, 역문항(s<0)은 반대로 답한다. */
    var _lat={};
    var fillT=function(key,bank,lo,hi,fn){ try{ if(!bank||!bank.length||!state.results[key]) return;
      var a=bank.map(function(it,i){ var f=(it&&it.f!=null)?String(it.f):('#'+i); var id=key+'|'+f;
        if(_lat[id]==null) _lat[id]=lo+0.6+Math.random()*(hi-lo-1.2);
        var x=Math.max(lo,Math.min(hi,Math.round(_lat[id]+(Math.random()-0.5)*2.4)));
        return (it&&it.s<0)?(lo+hi-x):x; });
      state.results[key].answers=a; if(typeof fn==='function')state.results[key].scores=fn(); }catch(e){} };
    /* 우연히 저분산·연속동일 신호가 걸린 표본은 몇 번 다시 뽑는다(샘플은 '성실 응답' 예시) */
    for(var _try=0; _try<6; _try++){
      _lat={};
      try{ state.results.big5.kv=PIA_BIG5_KV; }catch(e){}
      fillT('big5',IPIP_BIG5_50,1,5,scoreBig5);
      fillT('riasec',RIASEC_30,1,5,scoreRiasec);
      fillT('via',VIA_YOUTH,1,5,scoreVia);
      fillT('grit',GRIT_S,1,5,scoreGrit);
      fillT('learn',LEARN_ITEMS,1,5,scoreLearn);
      fillT('mi',MI_ITEMS,1,5,scoreMi);
      try{ if(calcValidity().grade==='양호') break; }catch(e){ break; }
    }
    fill('who5',WHO5,0,5,scoreWho5);
    fill('rses',RSES,1,4,scoreRses);
    /* [E2-A] 흥미 심화(시범) — 진로 흥미(30) 성향 근처에서 0~4 로 답한 가상 학생(결과지 칸 미리보기용) */
    try{ var _r30=state.results.riasec.scores||{}; state.results.riasec60={answers:ONET_IP60.map(function(it){ var b=((_r30[it.f]||60)/100)*5-1; return Math.max(0,Math.min(4,Math.round(b+(Math.random()-0.5)*2))); }),scores:null,intro:1,brk:1};
      state.results.riasec60.scores=scoreRiasec60(); state.results.riasec60.version=PIA_IP60_VERSION; }catch(e){}
    try{ // 정서검사: 문항 방향을 고려한 '건강한 예시'로 채움(고위험·자해 플래그 없이 정상범위)
      var ce=CES_D_10.map(function(it){ return (it.s>0)? rnd(0,1) : rnd(2,3); });
      state.results.cesd.answers=ce; state.results.cesd.scores=scoreCesd();
      var pa=[0,1,0,1,0,0,1,0,0].slice(0,PHQ_A.length); while(pa.length<PHQ_A.length)pa.push(0); pa[8]=0;
      state.results.phqa.answers=pa; state.results.phqa.scores=scorePhqa();
      var ga=[1,0,1,0,0,1,0].slice(0,GAD_7.length); while(ga.length<GAD_7.length)ga.push(0);
      state.results.gad.answers=ga; state.results.gad.scores=scoreGad();
    }catch(e){}
    /* 샘플 결과지가 필수검사 게이트에 막히지 않게 자유대화 턴을 채운다.
       필요한 턴 수를 여기에 숫자로 적어두면 기준이 바뀔 때(8→12처럼) 샘플만
       뒤처져 결과지가 안 나온다. REQUIRED_TESTS 가 만족될 때까지 올린다. */
    try{
      if(state.results.conv){
        state.results.conv.answers = state.results.conv.answers || [];
        var _chat = (typeof REQUIRED_TESTS!=='undefined')
          ? REQUIRED_TESTS.filter(function(t){ return t.id==='chat'; })[0] : null;
        if(_chat){
          state.results.conv.turns = 0;
          for(var _i=0; _i<200 && !_chat.done(); _i++) state.results.conv.turns++;
        } else {
          state.results.conv.turns = 12;
        }
      }
    }catch(e){ console.error('샘플 자유대화 턴 설정 실패', e); }
    try{ save(); }catch(e){}
    showView('result');   /* showView('result') 가 renderResult·renderDetailedResult(확장 구역 포함)까지 그린다 — 뒤에 같은 것을 다시 그리던 호출 3개 제거(2026-11-02 성능 2차: 첫 그리기 작업 절반, AI 요약·상담 예시 중복 요청 제거) */
    try{ var _v=document.querySelector('section[data-view="result"]'); if(_v){ var _n=document.createElement('div'); _n.setAttribute('role','status'); _n.style.cssText='background:#fff8e1;border:1px solid #f0d98a;color:#7a5b00;padding:8px 14px;border-radius:10px;font-size:12.5px;margin:10px 0;'; _n.textContent=_T('\uD83E\uDDEA \uC0D8\uD50C \uBBF8\uB9AC\uBCF4\uAE30 \u2014 \uBB34\uC791\uC704 \uC751\uB2F5\uC73C\uB85C \uC0DD\uC131\uB41C \uC608\uC2DC \uACB0\uACFC\uC9C0\uC785\uB2C8\uB2E4(\uC2E4\uC81C \uAC80\uC0AC \uC544\uB2D8).','\uD83E\uDDEA Sample Preview \u2014 This is an example report generated from random answers (not a real assessment).'); _v.insertBefore(_n,_v.firstChild); } }catch(e){}
  }catch(e){ console.warn('sample report fail', e); }
}
/* [2026-11-02] 결과지 신뢰성 ①-5: 발급번호·채점 기준·발급일·진본 확인 QR.
   h = SHA-256("{id}|{savedAt}") 앞 12자 — verify.html 이 서버에서 같은 값을 다시 만들어 대조한다.
   인쇄 경로는 동기라 레코드를 열 때 미리 계산해 둔다(piaPrepVerify). */
const SCORING_VERSION = 'pia-score-2026.11.1';
window.SCORING_VERSION = SCORING_VERSION;
window.__piaVerify = null;
function _piaMeta(){
  try{
    if (window.__piaRecMeta && window.__piaRecMeta.id) return window.__piaRecMeta;
    var p = (typeof state !== 'undefined' && state && state.profile) || null;
    if (p && p.resultId) return { id: String(p.resultId), savedAt: p.savedAt || null };
  }catch(e){}
  return null;
}
function _piaIsSample(){ try{ return new URLSearchParams(piaEffectiveSearch()).get('sample') === '1'; }catch(e){ return false; } }
async function piaPrepVerify(meta){
  try{
    if (!meta || !meta.id || !meta.savedAt || !window.crypto || !crypto.subtle) return null;
    var buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(meta.id) + '|' + String(meta.savedAt)));
    var h12 = Array.prototype.map.call(new Uint8Array(buf), function(x){ return ('0' + x.toString(16)).slice(-2); }).join('').slice(0, 12);
    var url = 'https://yedam.kr/verify?r=' + encodeURIComponent(meta.id) + '&h=' + h12;
    var v = { id: String(meta.id), savedAt: String(meta.savedAt), h12: h12, url: url, qr: '' };
    window.__piaVerify = v;
    try{
      var ok = (typeof _piaLoadQRLib === 'function') ? await _piaLoadQRLib() : false;
      if (ok && window.QRCode){
        var box = document.createElement('div'); box.style.cssText = 'position:fixed;left:-9999px;top:0';
        document.body.appendChild(box);
        new QRCode(box, { text: url, width: 160, height: 160, correctLevel: QRCode.CorrectLevel.M });
        var cv = box.querySelector('canvas'); if (cv) v.qr = cv.toDataURL('image/png');
        box.remove();
      }
    }catch(e){ console.warn('진본 확인 QR 생성 실패', e && e.message); }
    piaRenderIssueFoot();
    return v;
  }catch(e){ console.warn('진본 확인 준비 실패', e && e.message); return null; }
}
function _piaIssueDate(v){ try{ var d = new Date(v.savedAt); return isNaN(d) ? '' : d.toISOString().slice(0, 10); }catch(e){ return ''; } }
function piaIssueText(){
  /* [2026-11-02] 대화 신뢰성 ④ — AI 대화 해석의 프롬프트 판·모델을 채점 기준 옆에 */
  var _cv = ''; try{ var _ct = state.results.conv && state.results.conv.trust; if (_ct && _ct.v) _cv = ' \u00b7 ' + _T('대화 해석 ','Chat interpretation ') + _ct.v + ' (' + _ct.model + ')'; }catch(e){}
  var v = window.__piaVerify;
  if (v) return _T('발급번호 ','Issue No. ') + v.id.slice(-8) + ' \u00b7 ' + _T('채점 기준 ','Scoring ') + SCORING_VERSION + _cv + ' \u00b7 ' + _T('발급일 ','Issued ') + _piaIssueDate(v) + ' \u00b7 ' + _T('진본 확인','Verify authenticity');
  if (_piaIsSample()) return _T('샘플 — 진본 확인 대상 아님','Sample \u2014 not subject to verification') + ' \u00b7 ' + _T('채점 기준 ','Scoring ') + SCORING_VERSION + _cv;
  var m = _piaMeta();
  if (m && m.id) return _T('발급번호 ','Issue No. ') + String(m.id).slice(-8) + ' \u00b7 ' + _T('채점 기준 ','Scoring ') + SCORING_VERSION + _cv + ' \u00b7 ' + _T('저장 후 진본 확인 가능','Verifiable after saving');
  return _T('채점 기준 ','Scoring ') + SCORING_VERSION + _cv + ' \u00b7 ' + _T('저장된 결과로 열면 진본 확인 QR 이 표시됩니다','Open a saved result to show the verification QR');
}
function piaIssueFootHTML(forPrint){
  var v = window.__piaVerify;
  var esc = function(x){ return String(x).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); };
  var qr = (v && v.qr) ? '<img src="' + v.qr + '" alt="' + esc(_T('진본 확인 QR','Verification QR')) + '" width="64" height="64" style="width:64px;height:64px;flex:none">' : '';
  var link = v ? '<div style="font-size:10px;color:#94a3b8;word-break:break-all">' + esc(v.url) + '</div>' : '';
  return '<div class="pia-issue-foot" style="display:flex;align-items:center;gap:10px;margin:' + (forPrint ? '10mm 0 0' : '16px 0 0') + ';padding:8px 10px;border-top:1px solid #e2e8f0;font-size:11px;color:#64748b;break-inside:avoid;page-break-inside:avoid">'
    + qr + '<div><div>' + esc(piaIssueText()) + '</div>' + link + '</div></div>';
}
function piaRenderIssueFoot(){
  try{
    /* 서버가 준 savedAt 이 있으면 그때 진본 확인 값을 만든다(브라우저 시각으로는 만들지 않는다) */
    if (!window.__piaVerify && !window.__piaVerifyBusy){ var _m = _piaMeta(); if (_m && _m.id && _m.savedAt){ window.__piaVerifyBusy = 1; piaPrepVerify(_m); } }
    var host = document.getElementById('detailed-result'); if (!host) return;
    var old = document.getElementById('pia-issue-foot-screen'); if (old) old.remove();
    var w = document.createElement('div'); w.id = 'pia-issue-foot-screen'; w.className = 'no-print'; w.innerHTML = piaIssueFootHTML(false);
    host.appendChild(w);
  }catch(e){}
}
function piaIssuePageCss(){
  /* 인쇄 모든 쪽 아래 여백 칸에 한 줄 — 본문과 겹치지 않는다(크롬 131+ @page 여백 상자). QR 은 마지막 쪽에. */
  var t = piaIssueText().replace(/["\\]/g, '');
  return '@page{@bottom-left{content:"' + t + '";font-size:7.5pt;color:#888;font-family:sans-serif;}}';
}

function piaViewRecord(){
  try{
    try{ window.__piaViewOnly = true; }catch(_f){}   /* 이 화면은 열람 전용 — 저장 금지 */
    var raw=localStorage.getItem('pia_view_record');
    try{ localStorage.removeItem('pia_view_record'); }catch(_e){}  /* 공용 키오스크 개인정보 잔존 방지: 읽는 즉시 삭제(1회용) */
    if(!raw) return;
    var rec=JSON.parse(raw);
    try{ window.__piaRecMeta = { id: rec.id, savedAt: rec.savedAt }; piaPrepVerify(window.__piaRecMeta); }catch(_m){}
    if(rec.results) state.results=Object.assign(state.results||{}, rec.results);
    state.profile=rec.profile||{name:rec.name||'', grade:rec.grade||'', class:rec.klass||rec.class||'', school:rec.school||'', createdAt:Date.now()};
    state.studentId=rec.name||rec.id||state.studentId;
    if(rec.meta) state.meta=rec.meta;
    /* 결과지 대상은 레코드가 허용한 범위 안에서만 정한다.
       예전에는 URL 의 aud 값을 그대로 믿고 기본값도 '선생님용'이라,
       학부모가 주소에서 parent 를 teacher 로 바꾸면 자해 문항 플래그와
       위기대응 지침까지 볼 수 있었다. 기본값은 가장 좁은 권한으로 둔다. */
    try{
      var _a=new URLSearchParams(piaEffectiveSearch()).get('aud');
      /* 이 경로(view=record)는 parent.html 이 서버에 열람코드를 물어 200 을 받은
         뒤에만 열린다. 즉 코드 검증은 이미 끝났다. 그래서 '학부모용' 은 열어 준다.
         '선생님용' 은 열지 않는다 — 자해 문항 플래그와 위기대응 지침이 들어 있어
         실제 역할 로그인이 필요하다. 특히 URL 의 aud=teacher 를 교직원 근거로
         삼지 않는다. 주소는 누구나 스스로 바꿔 붙일 수 있다. */
      var _staffByRole = false;
      try{ var _ST=['org_member','org_admin','super_admin'];
           _staffByRole = !!(window.PIA_ROLE && _ST.indexOf(window.PIA_ROLE)>=0); }catch(_e){}
      var _allow = (rec && Array.isArray(rec.allowedAudience) && rec.allowedAudience.length)
                   ? rec.allowedAudience
                   : (_staffByRole ? ['student','parent','teacher'] : ['student','parent']);
      /* 모르는 값이면 조용히 올리지 않고 가장 좁은 권한으로 떨어뜨린다. */
      currentAudience = (_a && _allow.indexOf(_a)>=0) ? _a : _allow[0];
      window.__piaRecordAllow = _allow;
    }catch(e){ currentAudience='student'; }
    showView('result');   /* showView('result') 가 renderResult·renderDetailedResult(확장 구역 포함)까지 그린다 — 뒤에 같은 것을 다시 그리던 호출 3개 제거(2026-11-02 성능 2차: 첫 그리기 작업 절반, AI 요약·상담 예시 중복 요청 제거) */
    try{ var _v=document.querySelector('section[data-view="result"]'); if(_v){ var _n=document.createElement('div'); _n.setAttribute('role','status'); _n.style.cssText='background:#eef3f9;border:1px solid #c4d8ec;color:#2c4a6b;padding:8px 14px;border-radius:10px;font-size:12.5px;margin:10px 0;'; var _nm=(rec.name||''); if(currentAudience==='parent'){ _n.style.cssText='background:#f2f7f2;border:1px solid #cfe3cf;color:#2f5233;padding:8px 14px;border-radius:10px;font-size:12.5px;margin:10px 0;'; _n.textContent=_T('\uD559\uBD80\uBAA8\uC6A9 \uACB0\uACFC\uC9C0 \u2014 ','For Parents \u2014 ')+_nm+_T(' \uD559\uC0DD\uC758 \uAC80\uC0AC \uACB0\uACFC\uC785\uB2C8\uB2E4. \uC704 \uC778\uC1C4 \uBC84\uD2BC\uC73C\uB85C \uCD9C\uB825\uD558\uC2E4 \uC218 \uC788\uC5B4\uC694.',"'s assessment report. You can print it with the button above."); } else if(currentAudience==='teacher'){ _n.textContent=_T('\uC120\uC0DD\uB2D8\uC6A9 \uACB0\uACFC\uC9C0 \u2014 ','For Teachers \u2014 ')+_nm+_T('. \uC704 \uC778\uC1C4 \uBC84\uD2BC\uC73C\uB85C \uCD9C\uB825\uD558\uC138\uC694.','. Use the print button above to output it.'); } else { _n.textContent=_T('\uACB0\uACFC\uC9C0 \u2014 ','Report \u2014 ')+_nm+_T('. \uC704 \uC778\uC1C4 \uBC84\uD2BC\uC73C\uB85C \uCD9C\uB825\uD558\uC138\uC694.','. Use the print button above to output it.'); } _v.insertBefore(_n,_v.firstChild); } }catch(e){}
  }catch(e){ console.warn('view record fail', e); }
}
/* 여러 학생 결과지를 한 문서로 묶어 인쇄(반/학교 일괄). results-admin 이
   pia_view_records(전체 레코드 배열)를 localStorage 에 넣고 ?view=records 로 연다.
   원래 state 를 백업/복원하고 학생마다 try/catch 로 격리한다 — 이 함수는
   ?view=records 에서만 실행되므로 일반 검사 흐름에는 영향이 없다. */
async function piaBatchPrint(){
  try{ window.__piaViewOnly = true; }catch(_f){}   /* 일괄 인쇄도 열람 전용 */
  var raw=null;
  try{ raw=localStorage.getItem('pia_view_records'); localStorage.removeItem('pia_view_records'); }catch(e){}
  if(!raw) return;
  var arr; try{ arr=JSON.parse(raw); }catch(e){ return; }
  if(!Array.isArray(arr)||!arr.length) return;
  var _a=new URLSearchParams(piaEffectiveSearch()).get('aud')||'teacher';
  var _oR=state.results, _oP=state.profile, _oAud=(typeof currentAudience!=='undefined')?currentAudience:'student', _oSid=state.studentId;
  function _c2img(cv){ var d=''; try{ var ch=(window.Chart&&Chart.getChart)?Chart.getChart(cv):null; if(ch&&ch.toBase64Image) d=ch.toBase64Image('image/png',1); }catch(e){} if(!d||d.length<200){ try{ d=cv.toDataURL('image/png'); }catch(e){ d=''; } } return (d&&d.length>200)?d:''; }
  function _swap(srcCv,dstCv){ if(!dstCv||!dstCv.parentNode) return; var d=_c2img(srcCv); if(d){ var im=document.createElement('img'); im.src=d; im.style.maxWidth='100%'; dstCv.parentNode.replaceChild(im,dstCv); } else { var box=document.createElement('div'); box.style.cssText='padding:14px;text-align:center;color:#999;font-size:11px;'; box.textContent=_T('(그래프는 화면에서 확인)','(View the chart on screen)'); dstCv.parentNode.replaceChild(box,dstCv); } }
  function _snap(src){ if(!src) return null; var c=src.cloneNode(true); var sc=src.querySelectorAll('canvas'), dc=c.querySelectorAll('canvas'); for(var k=0;k<sc.length;k++){ _swap(sc[k],dc[k]); } try{ c.querySelectorAll('.no-print,[data-pia-lang-toggle],button').forEach(function(b){ try{b.remove();}catch(e){} }); }catch(e){} return c; }
  /* [2026-09-24] css/*.css 로 옮긴 시트(link[data-block])도 같은 순서로 싣는다.
     원문 그대로 실어야 한다 — cssRules 직렬화는 var() 가 든 단축속성(background:var(..) …)을
     빈 값으로 내보내 인쇄본에서 그 선언이 빠진다. 그래서 파일 원문을 받아 싣고(보통 캐시에 있다),
     못 받을 때만 cssRules 로 대신한다. */
  var styles=''; var _bsEls=document.querySelectorAll('style,link[data-block]');
  for(var _bsI=0;_bsI<_bsEls.length;_bsI++){ var _bsEl=_bsEls[_bsI], _bsTxt=_bsEl.textContent;
    if(_bsEl.tagName==='LINK'){ _bsTxt=''; try{ var _bsRes=await fetch(_bsEl.href); if(!_bsRes.ok) throw new Error('HTTP '+_bsRes.status); _bsTxt=await _bsRes.text(); }catch(e){ try{ var _bsR=_bsEl.sheet.cssRules; for(var _bsK=0;_bsK<_bsR.length;_bsK++) _bsTxt+=_bsR[_bsK].cssText+'\n'; }catch(_){} } }
    styles+='<style>'+_bsTxt+'</style>'; }
  var parts=[];
  try{ if(window.Chart&&Chart.defaults){ Chart.defaults.animation=false; if('animations' in Chart.defaults) Chart.defaults.animations=false; } }catch(e){}
  try{
    for(var i=0;i<arr.length;i++){
      var rec=arr[i];
      try{
        state.results=Object.assign({}, rec.results||{});
        state.profile=rec.profile||{name:rec.name||'',grade:rec.grade||'',class:rec.klass||rec.class||'',school:rec.school||'',createdAt:Date.now()};
        state.studentId=rec.name||rec.id;
        var _allow=(rec&&Array.isArray(rec.allowedAudience)&&rec.allowedAudience.length)?rec.allowedAudience:((typeof _piaIsStaffSync==='function'&&_piaIsStaffSync())?['student','parent','teacher']:['student']);
        currentAudience=(_allow.indexOf(_a)>=0)?_a:_allow[0];
        try{ if(typeof renderResult==='function')renderResult(); }catch(e){}
        try{ if(typeof renderDetailedResult==='function')renderDetailedResult(); }catch(e){}
        try{ if(typeof renderExtendedSections==='function')renderExtendedSections(); }catch(e){}
        try{ piaChartFlush(true); }catch(e){}   /* [2026-11-02 성능 2차] 차트 만들기가 뒤 작업으로 밀리므로 캔버스를 베끼기 전에 지금 다 그린다 */
        /* [2026-09-26] 학생마다 결과지 본문(#pia-report)을 그 학생 결과로 다시 채운다.
           빠져 있어서 모든 학생 본문이 고정 예시값(홍길동)으로 인쇄됐다. */
        try{ if(typeof piaFillReportBody==='function') piaFillReportBody(); }catch(e){ console.error('일괄 인쇄 본문 채우기 실패', e); }
        var _piaAccSavedB=_piaForceOpenAcc();
        await new Promise(function(r){ setTimeout(r,160); });
        var repC=_snap(document.getElementById('pia-report'));
        var detC=_snap(document.getElementById('detailed-result'));
        var extC=_snap(document.getElementById('extended-sections'));
        _piaRestoreAcc(_piaAccSavedB);
        var an=(detC?detC.innerHTML:'')+(extC?extC.innerHTML:'');
        var html='<div class="batch-student">'+(repC?repC.outerHTML:'')+(an?('<div class="aud-analysis">'+an+'</div>'):'')+'</div>';
        parts.push(html);
      }catch(e){ console.warn('batch item fail', e); }
    }
  } finally {
    try{ state.results=_oR; state.profile=_oP; currentAudience=_oAud; state.studentId=_oSid;
      if(typeof renderResult==='function')renderResult();
      if(typeof renderDetailedResult==='function')renderDetailedResult();
      if(typeof renderExtendedSections==='function')renderExtendedSections(); }catch(e){}
  }
  if(!parts.length){ alert(_T('출력할 결과지가 없습니다.','No reports to output.')); return; }
  var css='@page{size:A4;margin:0;} html,body{margin:0;padding:0;background:#fff;} #pia-report{background:#fff!important;padding:0;margin:0;} #pia-report .page{width:210mm!important;min-height:0!important;height:auto!important;margin:0 auto!important;padding:14mm 13mm!important;box-shadow:none!important;border-radius:0!important;border:none!important;break-after:page;page-break-after:always;overflow:visible;} #pia-report canvas,#pia-report img{max-width:100%!important;} .batch-student{break-before:page;page-break-before:always;} .batch-student:first-child{break-before:auto;page-break-before:auto;} .aud-analysis{break-before:auto;page-break-before:auto;padding:6mm 13mm 14mm;background:#faf7f2;} .aud-analysis .rounded-2xl,.aud-analysis table,.aud-analysis tr{break-inside:avoid;page-break-inside:avoid;} .aud-analysis canvas,.aud-analysis img{max-width:100%!important;} .no-print{display:none!important;} #p-cover{display:flex;align-items:center;justify-content:center;min-height:255mm;}';
  var doc='<!doctype html><html lang="'+((window.aipiaCurrentLang==='en')?'en':'ko')+'"><head><meta charset="utf-8"><title>'+_T('예담 톡 결과지 묶음 (','YEDAM Talk Report Batch (')+parts.length+_T('명)',' students)')+'</title>'+styles+'<style>'+css+'</style></head><body>'+parts.join('')+'</body></html>';
  var pf=document.getElementById('pia-batch-frame'); if(pf){ try{pf.remove();}catch(e){} }
  var w=null, ifr=null;
  try{ ifr=document.createElement('iframe'); ifr.id='pia-batch-frame'; ifr.style.cssText='position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;'; document.body.appendChild(ifr); w=ifr.contentWindow; }catch(e){ w=null; }
  if(!w){ w=window.open('','_blank'); if(!w){ alert(_T('인쇄 창을 열 수 없습니다. 브라우저에서 팝업을 허용하세요.','Unable to open the print window. Please allow pop-ups in your browser.')); return; } }
  w.document.open(); w.document.write(doc); w.document.close();
  setTimeout(function(){ try{ w.focus(); w.print(); }catch(e){} }, 900);
}
load();
initChat();
initSettings();
renderHome();
showView('home');
autoConnectFreeAI();
try{ var _qp=new URLSearchParams(piaEffectiveSearch()); if(_qp.get('s')){ var _piaShareGo=function(){ try{ piaOpenSharedResult(_qp.get('s')); }catch(e){ console.error('공유 결과 열기 실패:', e); } }; if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', _piaShareGo); else _piaShareGo(); } else if(_qp.get('paper')==='1'){ window.addEventListener('load', function(){ setTimeout(function(){ try{ piaPaperScan(); }catch(e){} }, 200); }); } else if(_qp.get('print')==='items'){ window.addEventListener('load', function(){ setTimeout(function(){ try{ piaPrintItems(); }catch(e){} }, 150); }); } else if(_qp.get('sample')==='1' || location.hash==='#sample'){ window.addEventListener('load', function(){ setTimeout(function(){ try{ piaSampleReport(); }catch(e){} /* ?printdoc=<대상> 이면 표본을 채운 뒤 인쇄본 자체를 화면에 띄운다 — 쪽수·여백 점검용 */ try{ var _pd=_qp.get('printdoc'); if(_pd){ setTimeout(function(){ window.__piaPrintDocOnly=true; piaPrintReport(_pd); }, 9000); } }catch(e){} }, 250); }); } else if(_qp.get('view')==='records'){ window.addEventListener('load', function(){ setTimeout(function(){ try{ piaBatchPrint(); }catch(e){} }, 300); }); } else if(_qp.get('view')==='record'){ window.addEventListener('load', function(){ setTimeout(function(){ try{ piaViewRecord(); }catch(e){} }, 250); }); } }catch(e){}
async function autoEnableOnDevice(){
  try {
    if (!state.cfg || state.cfg.mode !== 'ONDEVICE') return;
    if (typeof isMobile==='function' && isMobile()) { window._ondeviceLazy=true; return; } // 모바일은 온디바이스 자동기동 안 함(무료 AI 사용)
    const hasChrome = !!((typeof self!=='undefined' && self.LanguageModel) || (typeof window!=='undefined' && window.ai && window.ai.languageModel));
    const hasGPU = !!(typeof navigator!=='undefined' && navigator.gpu);
    window._ondeviceReady = false; window._ondeviceWarming = true;
    /* 큰 모델(460~749MB) 다운로드는 사용자가 직접 온디바이스를 고른 경우에만 연다.
       브라우저 내장 AI 때문에 여기 들어온 사람에게는 열지 않는다. */
    _ondeviceAllowDL = !!window._ondeviceUserChosen && _ondeviceAllowed();
    function badge(html){ try{ var b=document.getElementById('chat-aistatus'); if(b) b.innerHTML=html; }catch(_){} }
    function st(msg){ try{ var e=document.getElementById('cfg-status'); if(e) e.textContent=msg; }catch(_){} }
    badge('<span class="pill bg-amber-100 text-amber-800 text-[10px]">🖥 온디바이스 연결 시도 중…</span>');
    // 즉시 자동 연결 시도 (지원 기기). 미지원이면 무료 AI 자동 폴백 표기.
    const connect = async function(){
      // 1) Chrome 내장 AI 즉시 연결
      if (hasChrome) {
        try {
          const r = await callOnDevice('안녕', '한 단어로만 답해.');
          if (r && r.trim()) { window._ondeviceReady=true; window._ondeviceWarming=false;
            badge('<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">✅ 온디바이스 연결됨(내장 AI)</span>'); st('✅ 온디바이스 AI 자동 연결됨 — 인터넷·키 없이 대화'); return; }
        } catch(e) {}
      }
      // 2) WebGPU 있으면 모델 로드(백그라운드)
      if (hasGPU && !_isMob) {
        badge('<span class="pill bg-amber-100 text-amber-800 text-[10px]">🖥 온디바이스 모델 준비 중(최초 1회)…</span>');
        try {
          const r2 = await callOnDevice('안녕', '한 단어로만 답해.');
          window._ondeviceReady = !!(r2 && r2.trim()); window._ondeviceWarming=false;
          if (window._ondeviceReady) { badge('<span class="pill bg-emerald-100 text-emerald-800 text-[10px]">✅ 온디바이스 연결됨(브라우저 모델)</span>'); st('✅ 온디바이스 AI 자동 연결됨 — 이후 오프라인 동작'); return; }
        } catch(e) {}
      }
      // 3) 미지원/실패 → 무료 AI 자동 연결로 폴백(대화는 계속 가능)
      window._ondeviceWarming=false; window._ondeviceLazy=true;
      badge('<span class="pill bg-slate-100 text-slate-700 text-[10px]">ℹ 온디바이스 미지원 → 무료 AI 자동</span>');
      st('ℹ 이 브라우저는 온디바이스 AI 미지원 — 자유대화는 무료 AI→로컬로 자동 동작합니다. (온디바이스는 Chrome 내장 AI 또는 WebGPU 지원 시 자동 연결)');
    };
    setTimeout(connect, 600);
  } catch(e) { window._ondeviceWarming=false; }
}
autoEnableOnDevice();

// =================================================================
//  Help (상담 자원) 화면 렌더링
// =================================================================
function renderHelpCard(res) {
  const urgencyColor = {
    CRITICAL: 'bg-red-100 border-red-300 text-red-900',
    HIGH: 'bg-amber-50 border-amber-300 text-amber-900',
    MEDIUM: 'bg-sky-50 border-sky-300 text-sky-900',
    LOW: 'bg-slate-50 border-slate-200 text-slate-700'
  };
  const cls = urgencyColor[res.urgency] || urgencyColor.LOW;
  const phoneBig = res.phone ? '<div class="text-2xl font-bold mt-2">'+res.phone+'</div>' : '';
  return '<a href="'+res.url+'" target="_blank" class="block border-2 rounded-xl p-4 hover:shadow-md transition '+cls+'">' +
    '<div class="font-semibold text-sm">'+res.name+'</div>' +
    phoneBig +
    '<div class="text-xs mt-2 leading-relaxed">'+res.desc+'</div>' +
    '</a>';
}

/* 가까운 청소년상담복지센터 찾기 — 성평등가족부 청소년상담복지센터(data.go.kr 15109781, 전국 243곳·위경도)
   위치는 기기 안에서만 쓰고 서버로 보내지 않는다: 전국 목록을 받아 거리 계산은 브라우저에서 한다.
   위치를 못 쓰면(키오스크·거부) 시·군·구 이름으로 찾는다. 서버 프록시(task=fwd)가 인증키를 붙인다. */
var _piaTeenP = null;

/* 카카오맵 — 센터 위치를 지도에 점으로 보여준다. 목록과 '지도' 링크는 그대로 두고 그 아래에 지도를 덧붙이기만 한다.
   카카오 지도 SDK 가 막히거나 8초 안에 못 오면 지도만 조용히 빼고 목록은 그대로 둔다.
   JS 키는 브라우저에 그대로 실리는 공개 키이며, 카카오 콘솔('예담 키오스크' 앱 ID 1597276)에서
   yedam.kr · ai-pia.kr · ai-mom.kr 도메인만 쓰도록 묶여 있다. 위치는 기기 안에서만 쓴다(지도 쪽으로 보내지 않는다 — 점 좌표만 그린다). */
var _YD_KAKAO_KEY = 'c51419ba546dc05ecc5cb015e50b23b2';
var _ydMapP = null;
function _ydMapLoad() {
  if (_ydMapP) return _ydMapP;
  _ydMapP = new Promise(function (ok, no) {
    if (window.kakao && window.kakao.maps && window.kakao.maps.Map) { ok(window.kakao); return; }
    var s = document.createElement('script'), done = false;
    function fin(f, v) { if (done) return; done = true; clearTimeout(t); f(v); }
    var t = setTimeout(function () { fin(no, new Error('timeout')); }, 8000);
    s.async = true;
    s.src = 'https://dapi.kakao.com/v2/maps/sdk.js?appkey=' + _YD_KAKAO_KEY + '&autoload=false';
    s.onload = function () {
      try { window.kakao.maps.load(function () { fin(ok, window.kakao); }); } catch (e) { fin(no, e); }
    };
    s.onerror = function () { fin(no, new Error('sdk')); };
    document.head.appendChild(s);
  });
  _ydMapP.catch(function () { _ydMapP = null; });
  return _ydMapP;
}
function _ydMapDraw(host, pts, me) {
  var list = (pts || []).filter(function (p) {
    return isFinite(p.lat) && isFinite(p.lng) && p.lat > 32 && p.lat < 39.5 && p.lng > 123 && p.lng < 133;
  });
  if (!host || !list.length) return;
  var box = document.createElement('div');
  box.className = 'yd-map no-print';
  box.setAttribute('role', 'img');
  box.setAttribute('aria-label', '센터 위치 지도');
  box.style.cssText = 'height:240px;margin-top:8px;border-radius:10px;overflow:hidden;border:1px solid #e2e8f0;background:#f1f5f9';
  host.appendChild(box);
  _ydMapLoad().then(function (kk) {
    var m = kk.maps, bounds = new m.LatLngBounds();
    var map = new m.Map(box, { center: new m.LatLng(list[0].lat, list[0].lng), level: 5 });
    list.forEach(function (p) {
      var pos = new m.LatLng(p.lat, p.lng);
      bounds.extend(pos);
      var mk = new m.Marker({ position: pos, map: map, title: p.name });
      var tip = document.createElement('div');
      tip.style.cssText = 'padding:4px 8px;font-size:12px;white-space:nowrap';
      tip.textContent = p.name;
      var iw = new m.InfoWindow({ content: tip, removable: true });
      m.event.addListener(mk, 'click', function () { iw.open(map, mk); });
    });
    if (me && isFinite(me.lat) && isFinite(me.lng)) {
      var mp = new m.LatLng(me.lat, me.lng), dot = document.createElement('div');
      dot.title = '내 위치';
      dot.style.cssText = 'width:14px;height:14px;border-radius:50%;background:#2563eb;border:2px solid #fff;box-shadow:0 0 0 2px rgba(37,99,235,.35)';
      bounds.extend(mp);
      new m.CustomOverlay({ map: map, position: mp, content: dot, yAnchor: 0.5 });
    }
    setTimeout(function () {
      map.relayout();
      map.setBounds(bounds, 36, 36, 36, 36);
      if (map.getLevel() < 3) map.setLevel(3);
    }, 0);
  }).catch(function (err) {
    console.error('[map] 카카오맵을 불러오지 못해 목록만 보여 줍니다', err);
    if (box.parentNode) box.parentNode.removeChild(box);
  });
}
function _piaMapPts(rows) {
  return rows.map(function (c) { return { lat: +c.lat, lng: +c.lot, name: String(c.cnterNm || '') }; });
}
function _piaTeenLoad() {
  if (_piaTeenP) return _piaTeenP;
  var u = 'https://apis.data.go.kr/1383000/gmis/teenDscsnSrcnServiceV2/getTeenDscsnSrcnListV2?pageNo=1&numOfRows=500&type=json';
  _piaTeenP = fetch(PIA_CHAT_PROXY + '&task=fwd&url=' + encodeURIComponent(u)).then(function (r) {
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  }).then(function (d) {
    var b = (d && d.response && d.response.body) || (d && d.body) || {};
    var it = b.items; if (it && it.item) it = it.item;
    if (!Array.isArray(it)) it = it ? [it] : [];
    it = it.filter(function (x) { return x && x.cnterNm; });
    if (!it.length) throw new Error('empty');
    return it;
  });
  _piaTeenP.catch(function () { _piaTeenP = null; });
  return _piaTeenP;
}
function _piaEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function _piaTel(t) {
  var d = String(t || '').replace(/[^0-9]/g, '');
  if (!d) return '';
  var f = d.replace(/^(02)(\d{3,4})(\d{4})$/, '$1-$2-$3').replace(/^(0\d{2})(\d{3,4})(\d{4})$/, '$1-$2-$3');
  return '<a href="tel:' + d + '" style="font-weight:700">☎ ' + _piaEsc(f) + '</a>';
}
function _piaKm(a, b, c, d) {
  var r = Math.PI / 180, x = (c - a) * r, y = (d - b) * r;
  var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos(a * r) * Math.cos(c * r) * Math.sin(y / 2) * Math.sin(y / 2);
  return 2 * 6371 * Math.asin(Math.sqrt(h));
}
function _piaTeenCard(c, dist) {
  var hp = String(c.hmpgAddr || '').trim();
  if (hp && !/^https?:\/\//.test(hp)) hp = 'http://' + hp;
  return '<li style="margin:8px 0;padding:10px 12px;border:1px solid #e2e8f0;border-radius:10px;background:#fff;list-style:none">'
    + '<b>' + _piaEsc(c.cnterNm) + '</b>' + (dist != null ? ' <span style="color:#64748b">· ' + _T('약 ', 'about ') + (dist < 10 ? dist.toFixed(1) : Math.round(dist)) + 'km</span>' : '')
    + '<div style="font-size:.9em;color:#334155">' + _piaEsc(c.roadNmAddr || c.lotnoAddr) + '</div>'
    + (c.operHrCn ? '<div style="font-size:.85em;color:#64748b">' + _piaEsc(c.operHrCn) + '</div>' : '')
    + '<div style="margin-top:4px;display:flex;gap:12px;flex-wrap:wrap;font-size:.9em">' + _piaTel(c.rprsTelno)
    + '<a target="_blank" rel="noopener" href="https://map.kakao.com/link/search/' + encodeURIComponent(c.cnterNm) + '">' + _T('지도', 'Map') + '</a>'
    + (/^https?:\/\/[\w.-]+/.test(hp) ? '<a target="_blank" rel="noopener" href="' + _piaEsc(hp) + '">' + _T('홈페이지', 'Website') + '</a>' : '')
    + '</div></li>';
}
function _piaTeenShow(box, rows, title, pts, me) {
  box.innerHTML = '<div style="font-weight:700;margin-top:8px">' + _piaEsc(title) + '</div><ul style="padding:0;margin:0">' + rows.join('') + '</ul>'
    + '<div style="font-size:.8em;color:#64748b">' + _T('무료 상담 · 자료: 성평등가족부 청소년상담복지센터(공공데이터포털). 급할 때는 언제든 1388.', 'Free counseling · Source: Ministry of Gender Equality and Family (data.go.kr). Call 1388 anytime in urgent situations.') + '</div>';
  if (pts && pts.length) _ydMapDraw(box, pts, me);
}
/* [2026-10-04 yd-loc] 키오스크 설치 지역(관리 창에서 정함). 유선 기기는 위치 오차가 수십 km 라 지역 이름이 더 정확하다. */
function _piaKioskRegion() { try { return String(localStorage.getItem('yd_kiosk_region') || '').trim(); } catch (e) { return ''; } }
function _piaTeenByRegion(box, all, why, preset) {
  box.innerHTML = '<div style="margin-top:8px;font-size:.95em">' + _piaEsc(why) + ' ' + _T('사는 곳의 시·군·구 이름을 적어 주세요.', 'Type your city or district name.')
    + '<div style="display:flex;gap:6px;margin-top:6px"><input type="text" placeholder="' + _T('예: 남양주, 강남구', 'e.g. 남양주, 강남구') + '" style="flex:1;min-width:0;padding:8px;border:1px solid #cbd5e1;border-radius:8px">'
    + '<button type="button" style="padding:8px 14px;border-radius:8px;background:#0f766e;color:#fff;font-weight:700">' + _T('찾기', 'Search') + '</button></div></div><div class="tc-out"></div>';
  var inp = box.querySelector('input'), out = box.querySelector('.tc-out');
  function go() {
    var q = String(inp.value || '').replace(/\s+/g, '');
    if (q.length < 2) { out.innerHTML = '<div style="color:#b45309;margin-top:6px">' + _T('두 글자 이상 적어 주세요.', 'Please type at least 2 characters.') + '</div>'; return; }
    var hit = all.filter(function (c) { return ((c.ctpvNm || '') + (c.sggNm || '') + (c.roadNmAddr || '') + (c.lotnoAddr || '') + (c.cnterNm || '')).replace(/\s+/g, '').indexOf(q) >= 0; }).slice(0, 5);
    if (!hit.length) { out.innerHTML = '<div style="margin-top:6px">' + _T('그 지역 센터를 찾지 못했어요. 청소년상담 1388로 물어보세요.', 'No center found. Please call 1388.') + '</div>'; return; }
    _piaTeenShow(out, hit.map(function (c) { return _piaTeenCard(c, null); }), '"' + String(inp.value).trim() + '" ' + _T('지역 청소년상담복지센터', 'area youth counseling centers'), _piaMapPts(hit), null);
  }
  box.querySelector('button').onclick = go;
  inp.onkeydown = function (ev) { if (ev.key === 'Enter') go(); };
  if (preset) { inp.value = preset; go(); }
}
function piaFindTeenCenter(btn) {
  var box = btn.parentNode.querySelector('.tc-box'); if (!box) return;
  btn.disabled = true; box.innerHTML = '<div style="margin-top:8px">' + _T('가까운 센터를 찾고 있어요…', 'Finding nearby centers…') + '</div>';
  _piaTeenLoad().then(function (all) {
    var kr = _piaKioskRegion();
    if (kr) { btn.disabled = false; _piaTeenByRegion(box, all, _T('이 기기가 있는 지역으로 찾았어요. 다른 곳을 찾으려면', 'Showing centers for this device\'s area. To search elsewhere,'), kr); return; }
    if (!navigator.geolocation) { btn.disabled = false; _piaTeenByRegion(box, all, _T('이 기기는 위치를 알 수 없어요.', 'This device cannot share its location.')); return; }
    navigator.geolocation.getCurrentPosition(function (p) {
      /* 오차 5km 초과(IP 로 어림한 위치 — 무선랜 10~500m·기지국 약 300m 와 달리 도시 단위라 1km 를 넘는다) → 엉뚱한 센터를 '가까운 곳'으로 보여 주지 않는다 */
      if (!(p.coords.accuracy <= 5000)) { btn.disabled = false; _piaTeenByRegion(box, all, _T('위치가 정확하지 않아요.', 'Your location is not precise enough.')); return; }
      var la = p.coords.latitude, lo = p.coords.longitude;
      var ls = all.filter(function (c) { return +c.lat && +c.lot; })
        .map(function (c) { return { c: c, d: _piaKm(la, lo, +c.lat, +c.lot) }; })
        .sort(function (a, b) { return a.d - b.d; }).slice(0, 3);
      btn.disabled = false;
      if (!ls.length) { _piaTeenByRegion(box, all, _T('위치로 찾지 못했어요.', 'Could not search by location.')); return; }
      _piaTeenShow(box, ls.map(function (x) { return _piaTeenCard(x.c, x.d); }), _T('가까운 청소년상담복지센터', 'Nearby youth counseling centers'), _piaMapPts(ls.map(function (x) { return x.c; })), { lat: la, lng: lo });
    }, function () { btn.disabled = false; _piaTeenByRegion(box, all, _T('위치 확인이 어려워요.', 'Location is unavailable.')); }, { timeout: 10000, maximumAge: 600000 });
  }).catch(function (err) {
    console.error('[pia] 청소년상담복지센터 목록 조회 실패', err);
    btn.disabled = false;
    box.innerHTML = '<div style="margin-top:8px">' + _T('지금은 목록을 불러오지 못했어요. 청소년상담 1388로 가까운 센터를 물어보세요.', 'Could not load the list. Please call 1388.') + '</div>';
  });
}
function piaGoTeenCenter() {
  if (typeof showView === 'function') showView('help');
  setTimeout(function () { var b = document.querySelector('#help-teen-center button'); if (b) { b.scrollIntoView({ block: 'center' }); } }, 300);
}

function renderHelp() {
  if (typeof COUNSELING_RESOURCES === 'undefined') return;
  const elc = el('help-crisis'); if (elc) elc.innerHTML = COUNSELING_RESOURCES.CRISIS.map(renderHelpCard).join('');
  const ech = el('help-chat'); if (ech) ech.innerHTML = COUNSELING_RESOURCES.CHAT.map(renderHelpCard).join('');
  const els = el('help-school'); if (els) els.innerHTML = COUNSELING_RESOURCES.SCHOOL.map(renderHelpCard).join('');
  const elo = el('help-outreach');
  if (elo) elo.innerHTML = [...COUNSELING_RESOURCES.OUTREACH, ...COUNSELING_RESOURCES.GENERAL].map(renderHelpCard).join('');
}

// =================================================================
//  API 카탈로그 렌더링 (settings 화면)
// =================================================================
// 카탈로그 항목 분류 → 연결 방식 배지
var OFFLINE_ITEMS = [
  'Rosenberg 자존감 척도(RSES)','WHO-5 웰빙 지수','Brief Resilience Scale(BRS)','일반적 자기효능감(GSE)',
  'IPIP Item Pool','Open Source Psychometrics','openpsychometrics 데이터셋','five-factor-e (IPIP-NEO)',
  'Big Five Aspect Scales (BFAS)','HEXACO-PI-R 공개 문항','PHQ / GAD 스크리너','CES-D 우울 척도',
  'AI Hub 청소년 감정 데이터','MeloTTS Korean','Kokoro Web TTS',
  'IPIP Big5-50','O*NET Interest Profiler(RIASEC)','IPIP-VIA 강점척도(공개)',
  'LG EXAONE (오픈웨이트)','NCSOFT VARCO','KoBERT / KoELECTRA'
];
function isOfflineItem(item){
  // 키·인터넷 없이 내려받아(자료/코드/오픈웨이트) 또는 앱 내장으로 오프라인 구현 가능한 항목만 (큐레이션)
  if (!item || item.auto) return false; // 자동연동(키리스)은 온라인 호출이라 오프라인 아님
  return OFFLINE_ITEMS.indexOf(item.name) >= 0;
}
function apiConnBadge(item) {
  if (item.auto) return '<span class="api-status pill bg-amber-100 text-amber-800 text-[10px] whitespace-nowrap" data-ping="' + item.ping + '">⏳ 자동 확인중</span>';
  const t = (item.limit || '') + ' ' + (item.notes || '');
  if (/인증키|키|유료|토큰|트라이얼|체험|승인/.test(t)) return '<span class="pill bg-slate-200 text-slate-700 text-[10px] whitespace-nowrap">🔑 키 필요</span>';
  if (/내장|퍼블릭|공개|오픈소스|자체호스팅|다운로드/.test(t)) return '<span class="pill bg-violet-100 text-violet-900 text-[10px] whitespace-nowrap">📦 자료·오프라인</span>';
  return '<span class="pill bg-slate-100 text-slate-700 text-[10px] whitespace-nowrap">🔗 수동</span>';
}
function renderApiCatalog() {
  if (typeof FREE_API_CATALOG === 'undefined') return;
  const wrap = el('api-catalog');
  if (!wrap) return;
  const autoCnt = FREE_API_CATALOG.reduce(function(s,c){ return s + c.items.filter(function(i){return i.auto;}).length; }, 0);
  const offlineCnt = FREE_API_CATALOG.reduce(function(s,c){ return s + c.items.filter(function(i){return isOfflineItem(i);}).length; }, 0);
  wrap.innerHTML =
    '<div id="api-auto-summary" class="text-xs bg-emerald-50 border border-emerald-200 rounded-lg p-2 mb-2 text-emerald-900">⚡ 자동 연동(키 불필요·CORS) ' + autoCnt + '개 항목을 자동 확인합니다…</div>' +
    '<div class="text-xs bg-green-50 border border-green-200 rounded-lg p-2 mb-2 text-green-900">💾 오프라인 사용 가능(키·인터넷 불필요·자료/내장) <strong>' + offlineCnt + '</strong>개 — 망 분리 환경에서 내려받아 자체 호스팅하거나 앱 내장으로 사용</div>' +
    FREE_API_CATALOG.map(function(cat){
    var hasAuto = cat.items.some(function(i){return i.auto;});
    return '<details class="border border-slate-200 rounded-lg p-3 bg-slate-50"' + (hasAuto?' open':'') + '>' +
      '<summary class="font-semibold text-xs text-slate-800 cursor-pointer">' + cat.category + ' (' + cat.items.length + ')</summary>' +
      '<div class="mt-3 space-y-2">' + cat.items.map(function(item){
        var saved = (state.cfg && state.cfg.apiKeys && state.cfg.apiKeys[item.name]) || {};
        var manual = !item.auto;
        var ctrl = '';
        if (manual) {
          var ep = (saved.endpoint!=null ? saved.endpoint : (item.ping || item.url || ''));
          ctrl = '<div class="mt-2 pt-2 border-t border-slate-100 space-y-1" data-cat-name="'+encodeURIComponent(item.name)+'">' +
            '<input class="cat-key w-full border border-slate-300 rounded px-2 py-1 text-[11px]" type="password" placeholder="API Key (필요한 경우 입력)" value="'+(saved.key||'')+'" />' +
            '<div class="flex gap-1">' +
              '<input class="cat-ep flex-1 border border-slate-300 rounded px-2 py-1 text-[11px]" placeholder="테스트 엔드포인트(URL)" value="'+ep+'" />' +
              '<button class="cat-test bg-blue-600 text-white px-2 py-1 rounded text-[11px] whitespace-nowrap" data-act="catTestItem" data-arg-self>테스트</button>' +
              '<button class="cat-save bg-slate-800 text-white px-2 py-1 rounded text-[11px] whitespace-nowrap" data-act="catSaveItem" data-arg-self>저장</button>' +
            '</div>' +
            '<div class="cat-st text-[11px] text-slate-500"></div>' +
          '</div>';
        }
        return '<div class="bg-white rounded p-3 border border-slate-200">' +
          '<div class="flex items-start justify-between gap-2 mb-1">' +
            '<a href="'+item.url+'" target="_blank" rel="noopener" class="text-sm font-semibold text-slate-900 hover:underline">'+item.name+'</a>' +
            '<span class="flex items-center gap-1">' + apiConnBadge(item) + (isOfflineItem(item) ? '<span class="pill bg-green-100 text-green-800 text-[10px] whitespace-nowrap">💾 오프라인 가능</span>' : '') + '</span>' +
          '</div>' +
          '<div class="text-xs text-slate-600 mb-1">' + (item.models||'') + '</div>' +
          '<div class="text-[11px] text-slate-500">' + (item.notes||'') + '</div>' +
          ctrl +
        '</div>';
      }).join('') +
      '</div></details>';
  }).join('');
  // 자동 연결 확인 — 키 불필요·CORS 항목을 실제로 호출
  autoConnectCatalog();
}
async function autoConnectCatalog() {
  window._catStatus = window._catStatus || {};
  const nodes = document.querySelectorAll('#api-catalog .api-status[data-ping]');
  function paint(node, st){
    if(st==='ok'){ node.className='pill bg-emerald-100 text-emerald-800 text-[10px] whitespace-nowrap'; node.textContent='✅ 연결됨'; }
    else if(st==='warn'){ node.className='pill bg-amber-100 text-amber-800 text-[10px] whitespace-nowrap'; node.textContent='⚠ 응답 지연'; }
    else { node.className='pill bg-rose-100 text-rose-800 text-[10px] whitespace-nowrap'; node.textContent='⚠ 미응답'; }
  }
  let ok=0, done=0;
  await Promise.all(Array.prototype.map.call(nodes, async function(node){
    const url = node.getAttribute('data-ping');
    if (window._catStatus[url]) { paint(node, window._catStatus[url]); if(window._catStatus[url]==='ok')ok++; done++; return; }
    async function tryPing(){
      const ctrl = new AbortController(); const timer = setTimeout(function(){ ctrl.abort(); }, 8000);
      try { const res = await fetch(url, { signal: ctrl.signal, mode:'cors' }); return res.ok ? 'ok' : 'warn'; }
      catch (e) { return 'err'; }
      finally { clearTimeout(timer); }
    }
    let st = await tryPing();
    if (st === 'err') { await new Promise(function(r){ setTimeout(r, 600); }); st = await tryPing(); } // 1회 재시도
    window._catStatus[url]=st; paint(node, st); if(st==='ok')ok++; done++;
  }));
  const sum = el('api-auto-summary');
  if (sum) sum.innerHTML = '⚡ 자동 연동 결과: <strong>' + ok + ' / ' + done + '</strong> 연결됨 (키 불필요·CORS · 세션 캐시)';
}

// 카탈로그 수동 항목 — 키/엔드포인트 입력 저장 (localStorage 영구)
function _catWrapOf(btn){ return btn.closest('[data-cat-name]'); }
function catSaveItem(btn){
  var box=_catWrapOf(btn); if(!box) return;
  var name=decodeURIComponent(box.getAttribute('data-cat-name'));
  var key=(box.querySelector('.cat-key')||{}).value||'';
  var ep=(box.querySelector('.cat-ep')||{}).value||'';
  state.cfg.apiKeys = state.cfg.apiKeys || {};
  state.cfg.apiKeys[name] = { key:key.trim(), endpoint:ep.trim() };
  save();
  var st=box.querySelector('.cat-st'); if(st) st.textContent='✅ 저장됨 — 이 브라우저에 영구 보관됩니다.';
}
async function catTestItem(btn){
  var box=_catWrapOf(btn); if(!box) return;
  var name=decodeURIComponent(box.getAttribute('data-cat-name'));
  var key=((box.querySelector('.cat-key')||{}).value||'').trim();
  var ep=((box.querySelector('.cat-ep')||{}).value||'').trim();
  var st=box.querySelector('.cat-st');
  if(!ep){ if(st) st.textContent='⚠ 테스트할 엔드포인트(URL)를 입력하세요.'; return; }
  if(st){ st.className='cat-st text-[11px] text-blue-600'; st.textContent='🔌 '+name+' 연결 테스트 중…'; }
  var headers={ 'Accept':'application/json' };
  if(key) headers['Authorization']='Bearer '+key;
  // 공공데이터(커리어넷·data.go.kr·워크넷)는 CORS가 막혀 Supabase 프록시 경유
  var useProxy=false; try{ useProxy=/(career|data|work)\.go\.kr$/.test(new URL(ep).hostname); }catch(_e){}
  var _url=ep, _hdrs=headers;
  if(useProxy){
    var _tgt=ep; if(key && !/apikey=|serviceKey=/i.test(ep)) _tgt+=(ep.indexOf('?')>=0?'&':'?')+'apikey='+encodeURIComponent(key);
    _url=careernetUrl('raw', '', '', _tgt);
    _hdrs={};   /* Worker 는 별도 인증 헤더가 필요 없다 */
  }
  var ctrl=new AbortController(); var timer=setTimeout(function(){ctrl.abort();},12000);
  try{
    var res=await fetch(_url,{ signal:ctrl.signal, headers:_hdrs });
    if(st){
      if(res.ok){ st.className='cat-st text-[11px] text-emerald-700'; st.textContent='✅ 연결 성공 ('+res.status+')'+(useProxy?' · 프록시 경유':'')+' — "저장"을 누르면 키가 보관됩니다.'; }
      else { st.className='cat-st text-[11px] text-amber-700'; st.textContent='⚠ 응답 '+res.status+(useProxy?' (프록시 경유)':'')+' — 키/권한/엔드포인트를 확인하세요.'; }
    }
  }catch(e){
    if(st){ st.className='cat-st text-[11px] text-rose-700'; st.textContent='⚠ 연결 실패('+(useProxy?'프록시·키 확인':'CORS·네트워크·키 확인')+'). '+(useProxy?'키가 맞는지 확인하세요.':'브라우저 직접 호출이 막힌 API는 프록시가 필요합니다.'); }
  }finally{ clearTimeout(timer); }
}

// 진로 카드 보강 함수 — 결과지에 직업 상세 정보 추가
function renderCareerInfo() {
  // 추후 type.careers 배열을 받아 CAREER_DATABASE 조회 후 풍부한 카드 출력
  // 현재는 careers 영역 옆에 자격증 추천을 추가
}

// 위험 신호 감지 시 자동 상담 자원 표시 (renderResult 후 호출)
function renderRiskCounseling() {
  const cesd = state.results.cesd?.scores;
  const phqa = state.results.phqa?.scores;
  const gad = state.results.gad?.scores;
  const high = (cesd?.level === 'HIGH') || (phqa?.level === 'HIGH') || (gad?.level === 'HIGH') || (phqa?.selfHarm > 0);
  const banner = el('safety-banner');
  if (high && banner) {
    banner.classList.remove('hidden');
    const url = '#';
    banner.innerHTML = '<strong class="block mb-2">⚠ '+_T('정서 스크리닝에서 도움이 필요한 신호가 감지되었습니다','Your emotional screening detected signs that support may help')+'</strong>' +
      '<p class="mb-3">'+_T('아래 채널은 모두 무료이며, 학생·보호자·교사 모두 이용할 수 있습니다.','All the channels below are free and open to students, guardians, and teachers alike.')+'</p>' +
      '<div class="flex flex-wrap gap-2 text-sm">' +
        '<a href="tel:109" class="bg-red-600 text-white px-3 py-2 rounded-lg font-bold">📞 '+_T('자살예방 109','Suicide Prevention 109')+'</a>' +
        '<a href="tel:1577-0199" class="bg-red-600 text-white px-3 py-2 rounded-lg font-bold">📞 '+_T('정신건강위기 1577-0199','Mental Health Crisis 1577-0199')+'</a>' +
        '<a href="tel:1388" class="bg-amber-500 text-white px-3 py-2 rounded-lg font-bold">📞 '+_T('청소년상담 1388','Youth Counseling 1388')+'</a>' +
        '<a href="https://pf.kakao.com/_FyKxhs" target="_blank" class="bg-yellow-400 text-yellow-900 px-3 py-2 rounded-lg font-bold">💬 '+_T('카톡상담','KakaoTalk Counseling')+'</a>' +
        '<button type="button" data-act="piaGoTeenCenter" style="background:#0f766e" class="text-white px-3 py-2 rounded-lg font-bold">📍 '+_T('가까운 청소년상담복지센터','Nearby Youth Counseling Center')+'</button>' +
        '<button data-act="showView" data-arg="help" class="bg-slate-900 text-white px-3 py-2 rounded-lg font-bold">'+_T('전체 보기 →','View All →')+'</button>' +
      '</div>';
  } else if (banner) {
    banner.classList.add('hidden');
  }
}

// showView 확장
const _origShowView = showView;
showView = function(name) {
  _origShowView(name);
  /* [2026-10-21] 검사를 막 마치고 '검사 메뉴로/홈'으로 돌아오면 홈이 페이지 로드 때 그린 그대로(필수 검사 0/3)였다.
     진행 상태는 서버가 아니라 이 화면의 state.results 에서 그리므로, 홈으로 들어올 때마다 다시 그린다. */
  if (name === 'home') { try { renderHome(); } catch (e) { console.error('[홈] 진행 상태 다시 그리기 실패', e); } }
  if (name === 'help') renderHelp();
  if (name === 'settings') renderApiCatalog();
  if (name === 'result') renderRiskCounseling();
};

renderApiCatalog();

// =================================================================
//  상세 결과지 — 청중별 디테일
// =================================================================

const Big5_INTERPRETATIONS = {
  E: {
    high: '활기차고 사람들과 어울릴 때 에너지를 얻습니다. 모둠 활동·발표·새로운 만남에서 빛나고 리더 역할도 잘 맡습니다. 가끔 혼자 정리하는 시간도 균형 있게 가져보세요.',
    mid: '상황에 따라 활발하게 어울리기도 하고 혼자만의 시간도 즐기는 균형형입니다. 친한 사이에선 적극적이고 낯선 자리에선 신중해집니다.',
    low: '조용하고 차분한 환경을 선호하며 소수의 깊은 관계에서 편안함을 느낍니다. 생각을 충분히 정리한 뒤 말하는 신중함이 강점입니다.'
  },
  A: {
    high: '따뜻하고 배려심이 깊어 타인의 마음을 잘 읽습니다. 갈등을 부드럽게 중재하고 협력하는 데 강점이 있습니다. 자기 의견을 분명히 말하는 연습을 더하면 좋습니다.',
    mid: '상황에 맞게 협력하면서도 필요할 때 자기 의견을 지킵니다. 공감과 주관의 균형이 잡혀 있습니다.',
    low: '솔직하고 논리적인 의견을 중시하며 객관적으로 판단합니다. 비판적 사고가 강점이며, 따뜻한 표현을 한 스푼 더하면 관계가 부드러워집니다.'
  },
  C: {
    high: '체계적이고 책임감이 강해 계획한 일을 끝까지 해냅니다. 시간 관리와 목표 달성에 뛰어나며, 완벽주의로 지치지 않도록 휴식도 계획에 넣어보세요.',
    mid: '해야 할 일은 충실히 해내면서도 융통성을 발휘합니다. 계획과 즉흥의 균형이 좋습니다.',
    low: '유연하고 즉흥적이며 변화에 빠르게 적응합니다. 자유로운 발상이 강점이며, 작은 체크리스트 습관을 더하면 실행력이 올라갑니다.'
  },
  N: {
    high: '감정을 풍부하고 섬세하게 느낍니다. 공감과 예술적 감수성의 바탕이 되지만 스트레스에 민감할 수 있어, 규칙적인 생활과 안정적 환경, 감정을 표현할 통로(일기·대화)가 도움이 됩니다.',
    mid: '감정의 변화를 알아차리고 스스로 조절하는 능력이 균형 잡혀 있습니다.',
    low: '정서적으로 안정적이고 압박 상황에서도 침착합니다. 큰 시험·발표에서도 평정심을 유지하는 것이 강점입니다.'
  },
  O: {
    high: '호기심이 많고 새로운 아이디어·경험을 즐깁니다. 상상력과 창의적 연결이 강점이며, 다양한 분야를 탐색할 때 잠재력이 커집니다.',
    mid: '익숙한 것과 새로운 것을 균형 있게 받아들입니다. 검증된 방법을 쓰면서도 필요하면 새 시도를 합니다.',
    low: '검증된 방법과 익숙한 방식을 선호하며 꾸준함과 안정감이 강점입니다. 가끔 작은 새 시도를 더하면 시야가 넓어집니다.'
  }
};
const Big5_INTERPRETATIONS_EN = {
  E: { high:"You're energized by lively activity and being around people. You shine in group work, presentations, and meeting new people, and you take to leadership roles well. Try to balance this with some quiet time to yourself now and then.", mid:"You're a balanced type \u2014 sometimes actively social, sometimes enjoying time alone depending on the situation. You're outgoing with close friends and more reserved around strangers.", low:"You prefer a quiet, calm environment and feel most comfortable in a few deep relationships. Thinking things through before speaking is one of your strengths." },
  A: { high:"You're warm and considerate, and you read others' feelings well. You're skilled at gently mediating conflict and cooperating with others. It would help to practice stating your own opinions more clearly.", mid:"You cooperate as the situation calls for it, while still holding your ground when it matters. You have a good balance of empathy and independent judgment.", low:"You value honest, logical opinions and judge things objectively. Critical thinking is a strength \u2014 adding a touch more warmth to how you express things would smooth out your relationships." },
  C: { high:"You're organized and highly responsible, and you see plans through to the end. You excel at time management and reaching goals \u2014 just make sure to build rest into your schedule so perfectionism doesn't wear you out.", mid:"You get things done reliably while still staying flexible. You strike a good balance between planning and improvising.", low:"You're flexible and spontaneous, adapting quickly to change. Free-flowing ideas are a strength \u2014 adding a small checklist habit would boost your follow-through." },
  N: { high:"You feel emotions richly and deeply. This is the foundation for empathy and artistic sensitivity, but it can also make you sensitive to stress \u2014 a steady routine, a stable environment, and an outlet for expressing feelings (journaling, talking) will help.", mid:"You have a balanced ability to notice shifts in your emotions and regulate them yourself.", low:"You're emotionally stable and stay calm under pressure. Keeping your composure through big tests and presentations is a strength." },
  O: { high:"You're curious and enjoy new ideas and experiences. Imagination and creative connections are strengths, and your potential grows as you explore a range of fields.", mid:"You take in the familiar and the new in balance, using tried-and-true methods while trying something new when it's called for.", low:"You prefer proven methods and familiar approaches, and steadiness and stability are strengths. Adding the occasional small new attempt would broaden your view." }
};
function big5Interp(key, score) {
  const lvl = score >= 70 ? 'high' : score >= 40 ? 'mid' : 'low';
  var tbl = (window.aipiaCurrentLang==='en') ? Big5_INTERPRETATIONS_EN : Big5_INTERPRETATIONS;
  return tbl[key]?.[lvl] || '';
}

const RIASEC_INTERPRETATIONS = {
  R:'손으로 만들고 다루고 움직이는 활동에 강점이 있습니다. 기계·도구·운동·자연을 다루는 일(공학, 기술, 체육, 농생명 등)과 잘 맞습니다.',
  I:'복잡한 현상의 원리를 분석하고 탐구하는 것을 즐깁니다. 과학·수학·연구·데이터 분석(연구원, 의생명, IT, 통계 등) 분야에 적합합니다.',
  A:'창의적 표현과 미적 감각이 뛰어납니다. 자유로운 분위기에서 잠재력이 커지며 디자인·예술·문학·영상·콘텐츠 분야에 적합합니다.',
  S:'사람을 돕고 가르치며 함께할 때 보람을 느낍니다. 공감과 소통이 강점이며 상담·교육·복지·의료·서비스 분야에 적합합니다.',
  E:'사람을 이끌고 새로운 일을 기획·추진하는 데 강점이 있습니다. 설득과 주도성이 돋보이며 경영·창업·마케팅·정치·법률 분야에 적합합니다.',
  C:'체계적이고 정확하게 일을 처리합니다. 꼼꼼함과 책임감이 강점이며 회계·금융·행정·관리·데이터 정리 분야에 적합합니다.'
};

const RIASEC_INTERPRETATIONS_EN = {
  R:'You\'re strong in hands-on activities \u2014 making, handling, and moving things. You\'re well suited to work involving machines, tools, sports, or nature (engineering, technical fields, athletics, agriculture and life sciences, etc.).',
  I:'You enjoy analyzing and exploring the principles behind complex phenomena. You\'re a good fit for science, math, research, and data analysis fields (researcher, biomedical, IT, statistics, etc.).',
  A:'You have strong creative expression and an eye for aesthetics. Your potential grows in a free, open atmosphere, and you\'re well suited to design, art, literature, film, and content fields.',
  S:'You feel fulfilled helping, teaching, and working alongside people. Empathy and communication are strengths, suiting you to counseling, education, welfare, healthcare, and service fields.',
  E:'You\'re strong at leading people and planning and driving new initiatives. Persuasion and initiative stand out, suiting you to management, entrepreneurship, marketing, politics, and law.',
  C:'You handle work systematically and accurately. Thoroughness and responsibility are strengths, suiting you to accounting, finance, administration, management, and data organization.'
};
const RIASEC_CAREER_EN = {
  R:{track:'Engineering, Technology & Natural Sciences', majors:['Mechanical Engineering','Electrical/Electronic Engineering','Architecture/Civil Engineering','Computer Engineering','Automotive/Aerospace','Agricultural & Life Sciences','Environmental Engineering','Physical Education/Sports'], jobs:['Mechanical/Robotics Engineer','Electrical/Electronics Technician','Architect/Construction Engineer','Automotive/Aerospace Maintenance & Design','Agricultural & Life Sciences Researcher','Firefighter/Police Officer','Landscape/Environmental Engineer','Physical Education Instructor']},
  I:{track:'Natural Sciences, Medicine & IT', majors:['Mathematics/Statistics','Physics/Chemistry','Life Sciences','Medicine/Pharmacy','Computer & Data Science','Electronics/Semiconductors','Earth & Environmental Science'], jobs:['STEM Researcher','Data Scientist','Doctor/Pharmacist/Veterinarian','Life Sciences Researcher','AI/Software Developer','Statistician/Quantitative Analyst','Clinical Pathology/Lab Specialist']},
  A:{track:'Art, Design & Media', majors:['Visual/Industrial Design','Fine Arts','Music/Applied Music','Theater, Film & Video','Creative Writing','Fashion Design','Performing Arts'], jobs:['Designer (UX/Graphic/Product)','Video/Content Creator','Writer/Screenwriter','Musician/Producer','Actor/Director','Illustrator','Fashion Stylist']},
  S:{track:'Education, Welfare, Healthcare & Counseling', majors:['Education','Social Welfare','Psychology/Counseling','Nursing/Health Sciences','Early Childhood Education','Rehabilitation/Physical Therapy','Speech-Language Therapy'], jobs:['Teacher/Education Specialist','Counselor/Psychotherapist','Social Worker','Nurse/School Health Teacher','Early Childhood/Special Education Teacher','Occupational/Physical Therapist','Youth Counselor']},
  E:{track:'Business, Economics, Law & Media', majors:['Business/Economics','International Trade','Political Science','Law','Advertising/PR','Hotel & Tourism Management','Media & Communication'], jobs:['Business/Planning Manager','Marketer/Merchandiser','Entrepreneur','Lawyer','Politician/Public Administrator','PD/Journalist','Sales/Consultant']},
  C:{track:'Business, Administration, Finance & Information', majors:['Accounting/Taxation','Management Information Systems','Finance/Insurance','Public Administration','Library & Information Science','Statistics','Logistics/Distribution'], jobs:['Accountant/Tax Accountant','Banker/Finance Professional','Civil Servant/Administrator','Data/Information Manager','Auditor/Quality Manager','Logistics/SCM Specialist','Administrative/Business Support']}
};

/* 추천 학과별 개설 대학 수 — 한국대학교육협의회 대학알리미(data.go.kr 15158963·15158955)를
   ops/build-univ-majors.py 로 요약한 정적 파일(data/univ-majors.json)을 읽는다. 폐과 제외. */
var _piaUnivP = null;
/* 인쇄 직전: 아직 '불러오는 중'인 공공데이터 칸은 결과지에 찍히지 않게 숨긴다(자료가 오면 다시 보인다). */
if (typeof window !== 'undefined' && !window.__piaPubDataPrintGuard) {
  window.__piaPubDataPrintGuard = 1;
  window.addEventListener('beforeprint', function () {
    document.querySelectorAll('.pia-lic-sched:not([data-state="ok"]), .pia-univ-row:not([data-state="ok"])').forEach(function (e) { e.setAttribute('data-print-hidden', '1'); e.style.display = 'none'; });
  });
  window.addEventListener('afterprint', function () {
    document.querySelectorAll('[data-print-hidden]').forEach(function (e) { e.removeAttribute('data-print-hidden'); e.style.display = ''; });
  });
}
function piaFillUniv() {
  var rows = document.querySelectorAll('.pia-univ-row:not([data-done])');
  if (!rows.length) return;
  Array.prototype.forEach.call(rows, function (r) { r.setAttribute('data-done', '1'); });
  if (!_piaUnivP) _piaUnivP = fetch('data/univ-majors.json').then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .catch(function (e) { console.error('[pia] 개설 대학 자료 조회 실패', e); _piaUnivP = null; return null; });
  _piaUnivP.then(function (d) {
    Array.prototype.forEach.call(rows, function (r) {
      var td = r.querySelector('td');
      if (!d || !d.majors) { r.style.display = 'none'; return; }
      var keys = [], lab = {};
      try { keys = JSON.parse(r.getAttribute('data-keys') || '[]'); lab = JSON.parse(r.getAttribute('data-labels') || '{}'); } catch (e) {}
      var parts = keys.filter(function (k) { return d.majors[k] && d.majors[k].n > 0; }).map(function (k) {
        var m = d.majors[k], ex = (m.ex || []).join(', ');
        return '<span title="' + (ex ? _T('예: ', 'e.g. ') + ex : '') + '">' + (lab[k] || k) + ' <b>' + m.n + _T('곳', '') + '</b></span>';
      });
      if (!parts.length) { r.style.display = 'none'; return; }
      r.setAttribute('data-state', 'ok');
      td.innerHTML = parts.join(' · ') + '<div style="color:#94a3b8;margin-top:2px">' + _T(d.svyYr + ' 대학알리미 기준 개설 대학 수(폐과 제외). 학과명은 대학마다 다르니 대학어디가(adiga.kr)에서 확인하세요.', 'Number of universities offering each field (' + d.svyYr + ' Higher Education in Korea data). Check details at adiga.kr.') + '</div>';
    });
  });
}

/* RIASEC 유형 → 추천 계열·대표학과·직업 목록 (진로 결과지 구체화용) */
const RIASEC_CAREER = {
  R:{track:'공학·기술·자연', majors:['기계공학','전기전자공학','건축·토목','컴퓨터공학','자동차·항공','농생명','환경공학','체육·스포츠'], jobs:['기계·로봇 엔지니어','전기전자 기술자','건축가·시공기술자','자동차·항공 정비/설계','농생명 연구원','소방·경찰','조경·환경 기사','체육지도자']},
  I:{track:'자연과학·의약·IT', majors:['수학·통계','물리·화학','생명과학','의예·약학','컴퓨터·데이터과학','전자·반도체','지구환경과학'], jobs:['이공계 연구원','데이터 사이언티스트','의사·약사·수의사','생명과학 연구원','AI·소프트웨어 개발자','통계·계량 분석가','임상병리·검사 전문가']},
  A:{track:'예술·디자인·미디어', majors:['시각·산업디자인','순수미술','음악·실용음악','연극영화·영상','문예창작','패션디자인','공연예술'], jobs:['디자이너(UX·그래픽·제품)','영상·콘텐츠 크리에이터','작가·시나리오','음악가·프로듀서','배우·연출가','일러스트레이터','패션·스타일리스트']},
  S:{track:'교육·복지·의료·상담', majors:['교육·사범','사회복지','심리·상담','간호·보건','유아교육','재활·물리치료','언어치료'], jobs:['교사·교육전문가','상담사·심리치료사','사회복지사','간호사·보건교사','유아·특수교사','작업·물리치료사','청소년지도사']},
  E:{track:'경영·경제·법정·미디어', majors:['경영·경제','무역·국제','정치외교','법학','광고홍보','호텔관광','미디어커뮤니케이션'], jobs:['경영·기획 관리자','마케터·MD','창업가','변호사·법조인','정치·행정가','PD·기자','영업·컨설턴트']},
  C:{track:'상경·행정·금융·정보', majors:['회계·세무','경영정보','금융·보험','행정','문헌정보','통계','물류·유통'], jobs:['회계사·세무사','금융·은행원','공무원·행정직','데이터·정보 관리자','감사·품질 관리','물류·SCM 전문가','사무·경영지원']}
};

// 청중별 인사말
function selfIsAdult(){
  // 응답자가 대학생/성인/일반인이면 true → 본인용 보고서를 '일반용(존댓말)'로
  try{
    var g=String((state.profile&&state.profile.grade)||'');
    if(/대학|성인|일반|adult|univ/i.test(g)) return true;
    var cg=(state.cfg&&state.cfg.grade)||'';
    if(cg==='adult'||cg==='univ') return true;
    var sel=document.getElementById('chat-grade');
    if(sel&&(sel.value==='adult'||sel.value==='univ')) return true;
  }catch(e){}
  return false;
}
function audienceGreeting(audience, type, sid) {
  /* [2026-10-04] 인사말에 학생 번호 기본값(S001)이 나오던 것 — 입력한 이름이 있으면 이름으로 부른다.
     '샘플 학생'처럼 이름이 '학생'으로 끝나면 뒤의 '학생'과 겹치지 않게 뗀다. 이름이 없거나 '익명'이면 예전 그대로. */
  try { var _nm = String((state.profile && state.profile.name) || '').trim(); if (_nm && _nm !== '익명') sid = _nm.replace(/\s*학생$/, '') || _nm; } catch (e) {}
  var _tn = _typeField(type,'name');
  if (audience === 'student') {
    if (selfIsAdult()) return _T(`<strong>${_escHtml(sid)}님, 안녕하세요!</strong><br>이번 검사에서 나타난 유형은 <strong>${_tn}</strong>입니다. 정답은 없습니다. 이 리포트는 자신을 더 잘 이해하는 출발점으로 활용해 주세요.`, `<strong>Hello, ${_escHtml(sid)}!</strong><br>Your type from this assessment is <strong>${_tn}</strong>. There's no right or wrong answer \u2014 use this report as a starting point for understanding yourself better.`);
    return _T(`<strong>${_escHtml(sid)} 학생, 안녕!</strong><br>오늘 검사에서 너의 유형은 <strong>${_tn}</strong>이야. 정답은 없어. 이 결과지는 너 자신을 더 잘 이해하는 출발점이라고 생각해줘.`, `<strong>Hi ${_escHtml(sid)}!</strong><br>Your type from today's test is <strong>${_tn}</strong>. There's no right or wrong answer. Think of this report as a starting point for getting to know yourself better.`);
  }
  if (audience === 'parent') {
    return _T(`<strong>안녕하세요, ${_escHtml(sid)} 학생의 학부모님께</strong><br>자녀의 진로·성향 이해를 돕는 예담 톡 통합 검사 결과를 정리해 드립니다. 자녀와 함께 5~10분 같이 읽고 강점을 먼저 칭찬해 주세요.`, `<strong>Hello, parent/guardian of ${_escHtml(sid)}</strong><br>Here is a summary of the YEDAM Talk integrated assessment results to help you understand your child's career interests and personality. Please read it together with your child for 5\u201310 minutes, and praise their strengths first.`);
  }
  return _T(`<strong>${_escHtml(sid)} 학생 결과 — 선생님용 요약</strong><br>학생의 PIA 유형은 <strong>${_tn}</strong>입니다. 상담·생활지도·학부모 면담 시 활용 가능한 근거 자료입니다.`, `<strong>${_escHtml(sid)}'s Results \u2014 Summary for Teachers</strong><br>The student's PIA type is <strong>${_tn}</strong>. This is reference material you can use for counseling, classroom guidance, and parent conferences.`);
}

// 청중별 상세 가이드 (메인 결과 위에 표시)
function audienceGuide(audience, type, reliability) {
  var _td = _typeField(type,'desc');
  var _validityFrag = piaRelFrag(reliability, true);
  var _completedStr = reliability.completed.join(', ') || _T('없음','None');
  var _screeningStr = reliability.screening.join(', ') || _T('미실시','Not conducted');
  if (audience === 'student') {
    if (selfIsAdult()) return _T(`
      <h3 class="font-semibold mb-2">당신에게 전하는 한 마디</h3>
      <p class="text-sm text-slate-700 leading-relaxed mb-3">${_td} 다만 이건 '오늘'의 모습을 본 결과일 뿐이며, 사람은 계속 변화하고 성장합니다. 도움이 되는 한두 가지만 가져가셔도 충분합니다.</p>
      <h4 class="font-semibold text-sm mb-1">결과 해석 등급</h4>
      <p class="text-xs text-slate-600">해석 등급 <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. 더 많은 검사를 완료하면 분석이 더 정확해집니다.</p>
    `, `
      <h3 class="font-semibold mb-2">A Note for You</h3>
      <p class="text-sm text-slate-700 leading-relaxed mb-3">${_td} This is just a snapshot of "today," though \u2014 people keep changing and growing. It's enough to take away just one or two useful things.</p>
      <h4 class="font-semibold text-sm mb-1">Interpretation Grade</h4>
      <p class="text-xs text-slate-600">Interpretation grade <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. Completing more assessments will make the analysis more accurate.</p>
    `);
    return _T(`
      <h3 class="font-semibold mb-2">너에게 전하는 한 마디</h3>
      <p class="text-sm text-slate-700 leading-relaxed mb-3">${_td} 하지만 이건 너의 '오늘'을 본 결과일 뿐, 너는 매일 자라고 있어. 결과를 너무 진지하게 받아들이지 말고, 도움 되는 한두 가지만 챙겨가도 충분해.</p>
      <h4 class="font-semibold text-sm mb-1">결과 해석 등급</h4>
      <p class="text-xs text-slate-600">해석 등급 <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. 더 많은 검사를 완료하면 분석이 더 정확해져.</p>
    `, `
      <h3 class="font-semibold mb-2">A Note for You</h3>
      <p class="text-sm text-slate-700 leading-relaxed mb-3">${_td} But this is just a look at your "today" \u2014 you're growing every day. Don't take the results too seriously; it's enough to take away just one or two useful things.</p>
      <h4 class="font-semibold text-sm mb-1">Interpretation Grade</h4>
      <p class="text-xs text-slate-600">Interpretation grade <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. Completing more assessments will make the analysis more accurate.</p>
    `);
  }
  if (audience === 'parent') {
    return _T(`
      <h3 class="font-semibold mb-2">자녀의 이번 학기 모습</h3>
      <p class="text-sm text-slate-700 leading-relaxed mb-3">${_td} 이 결과는 자녀의 '현재 성향'이며 시간에 따라 변할 수 있습니다.</p>
      <h4 class="font-semibold text-sm mb-1">가정에서 활용 방법</h4>
      <ul class="text-sm text-slate-700 space-y-1 leading-relaxed">
        <li>· 자녀와 함께 5~10분 같이 결과지를 읽으세요.</li>
        <li>· <strong>강점을 먼저 구체적으로 칭찬</strong>하세요 ("이런 점이 정말 너의 강점이야").</li>
        <li>· 성장 포인트는 부담 없이 <strong>한 가지만</strong> 시도해 보세요.</li>
        <li>· 결과가 맞지 않게 느껴지면 담임/상담교사에게 재상담을 요청하실 수 있습니다.</li>
      </ul>
      <h4 class="font-semibold text-sm mt-3 mb-1">결과 해석 등급</h4>
      <p class="text-xs text-slate-600">해석 등급 <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. 완료 검사: ${_completedStr}</p>
    `, `
      <h3 class="font-semibold mb-2">Your Child This Term</h3>
      <p class="text-sm text-slate-700 leading-relaxed mb-3">${_td} This result reflects your child's "current tendencies" and may change over time.</p>
      <h4 class="font-semibold text-sm mb-1">How to Use This at Home</h4>
      <ul class="text-sm text-slate-700 space-y-1 leading-relaxed">
        <li>\u00b7 Read the report together with your child for 5\u201310 minutes.</li>
        <li>\u00b7 <strong>Praise strengths first, specifically</strong> ("This is really one of your strengths").</li>
        <li>\u00b7 Try just <strong>one</strong> growth point at a time, without pressure.</li>
        <li>\u00b7 If the results don't feel accurate, you can request a follow-up consultation with the homeroom or school counseling teacher.</li>
      </ul>
      <h4 class="font-semibold text-sm mt-3 mb-1">Interpretation Grade</h4>
      <p class="text-xs text-slate-600">Interpretation grade <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. Completed assessments: ${_completedStr}</p>
    `);
  }
  return _T(`
    <h3 class="font-semibold mb-2">교사용 활용 가이드</h3>
    <ul class="text-sm text-slate-700 space-y-1 leading-relaxed mb-3">
      <li>· 본 결과지는 <strong>참고용</strong>이며 학생 평가나 분류 도구가 아닙니다.</li>
      <li>· 학급 운영·모둠 구성·학부모 면담 자료로 활용하세요.</li>
      <li>· 정서 스크리닝(CES-D/PHQ-A/GAD-7) HIGH 시 보호자 공유와 Wee클래스 연계를 권장합니다.</li>
      <li>· 자해 신호 감지 시 즉시 학교 위기관리 매뉴얼에 따라 조치하세요.</li>
    </ul>
    <h4 class="font-semibold text-sm mb-1">결과 해석 등급</h4>
    <p class="text-xs text-slate-600">해석 등급 <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. 완료: ${_completedStr} / 정서 스크리닝: ${_screeningStr}</p>
  `, `
    <h3 class="font-semibold mb-2">Guide for Teachers</h3>
    <ul class="text-sm text-slate-700 space-y-1 leading-relaxed mb-3">
      <li>\u00b7 This report is for <strong>reference only</strong> and is not a tool for evaluating or categorizing students.</li>
      <li>\u00b7 Use it for classroom management, group formation, and parent conferences.</li>
      <li>\u00b7 If emotional screening (CES-D/PHQ-A/GAD-7) shows HIGH, sharing with the guardian and referral to the Wee Class is recommended.</li>
      <li>\u00b7 If self-harm signals are detected, act immediately per the school's crisis management manual.</li>
    </ul>
    <h4 class="font-semibold text-sm mb-1">Interpretation Grade</h4>
    <p class="text-xs text-slate-600">Interpretation grade <strong>${reliability.grade}</strong> (${reliability.label})${_validityFrag}. Completed: ${_completedStr} / Emotional screening: ${_screeningStr}</p>
  `);
}

// Big5 상세 해석 카드 추가 렌더링
/* [2026-09-27] 1.4.3 — 띠 글자(12px 굵게)가 종이 바탕 #fffdf8 위 4.5:1 미달이라 색상(OKLCH hue)은 두고 명도만 낮춤.
   #788c5d 3.62→#677a4c 4.63 · #6a9bcc 2.88→#4877a6 4.63 · #b0aea5 2.19→#76746c 4.61 (막대 채움도 같은 값) */
function big5Band(sc){ return sc>=70?{t:_T('높음','High'),c:'#677a4c'}:sc>=40?{t:_T('보통','Moderate'),c:'#4877a6'}:{t:_T('낮음','Low'),c:'#76746c'}; }
function renderBig5Detailed(big5) {
  if (!big5) return '';
  var _pl5=(window.aipiaCurrentLang==='en');
  const stable = 100 - big5.N;
  const rows = [
    ['외향성','Extraversion', big5.E, big5Interp('E', big5.E)],
    ['우호성','Agreeableness', big5.A, big5Interp('A', big5.A)],
    ['성실성','Conscientiousness', big5.C, big5Interp('C', big5.C)],
    ['정서 안정성','Emotional Stability', stable, big5Interp('N', big5.N)],
    ['개방성','Openness', big5.O, big5Interp('O', big5.O)]
  ];
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-3">${_T('Big5 차원별 상세 해석','Big5 Dimension-by-Dimension Interpretation')}</h3>
      <div class="space-y-3 text-sm">
        ${rows.map(function(r){var ko=r[0],en=r[1],sc=Math.round(r[2]),txt=r[3],b=big5Band(sc);return `
          <div>
            <div class="flex items-center justify-between mb-1">
              <strong>${_pl5?en:ko} <span class="text-slate-400 font-normal text-xs">${_pl5?'':en}</span></strong>
              <span class="flex items-center gap-2"><span class="text-xs font-bold" style="color:${b.c}">${b.t}</span><span class="text-slate-500 text-xs w-9 text-right">${sc}${_T('점','')}</span></span>
            </div>
            <div class="h-1.5 rounded-full bg-slate-100 overflow-hidden mb-1"><div class="h-1.5 rounded-full" style="width:${sc}%;background:${b.c}"></div></div>
            <span class="text-slate-600 leading-relaxed">${txt}</span>
          </div>`;}).join('')}
      </div>
      <p class="text-xs text-slate-500 mt-3">${_T('점수는 본인 응답을 0–100으로 환산한 값이며 또래와 비교한 위치가 아닙니다. 높고 낮음에 우열은 없습니다.','Scores convert your own answers to a 0\u2013100 scale; they are not a position compared with peers. Higher or lower does not mean better or worse.')}</p>
    </div>`;
}

function renderRiasecDetailed(riasec) {
  if (!riasec) return '';
  var _plr=(window.aipiaCurrentLang==='en');
  const sorted = Object.entries(riasec).sort((a,b)=>b[1]-a[1]);
  const rVals = sorted.map(e=>e[1]);
  const rMax = Math.max.apply(null, rVals), rMin = Math.min.apply(null, rVals);
  const allTiedR = (rMax - rMin) <= 5;
  const topBand = sorted.filter(e => (rMax - e[1]) <= 5).map(e=>e[0]);
  const codeBlock = allTiedR
    ? _T('<strong>뚜렷한 우세 없음 · 균형·혼합형</strong> — 여섯 영역 점수 차이가 크지 않아(측정오차 이내) 특정 3개 유형을 대표로 뽑지 않았습니다. 아래 영역별 점수를 고르게 살펴보세요.', '<strong>No clear lead \u00b7 Balanced/mixed type</strong> \u2014 the scores across the six areas are close enough (within measurement error) that we did not single out 3 representative types. Take a look at the scores for each area below.')
    : (topBand.length >= 4
        ? _T('<strong>뚜렷한 우세 없음 · 균형·혼합형</strong> — 상위권 점수가 비슷해 3개만 대표로 뽑기 어렵습니다. 아래 영역별 점수를 참고하세요.', '<strong>No clear lead \u00b7 Balanced/mixed type</strong> \u2014 the top scores are close enough that picking just 3 representative types is difficult. See the scores for each area below.')
        : _T('<strong>Holland 코드: ', '<strong>Holland Code: ') + (topBand.length>=2 ? topBand.slice(0,3).join('/') : sorted.slice(0,3).map(e=>e[0]).join('')) + _T('</strong> (상위 유형 조합) — 이 조합은 실제 진로 분야 매칭에 자주 활용됩니다.', '</strong> (top type combination) \u2014 this combination is often used in real career-field matching.'));
  var _riasecLbl = _plr ? {R:'Realistic (R)',I:'Investigative (I)',A:'Artistic (A)',S:'Social (S)',E:'Enterprising (E)',C:'Conventional (C)'} : {R:'현실형 R',I:'탐구형 I',A:'예술형 A',S:'사회형 S',E:'진취형 E',C:'관습형 C'};
  var _riasecInterp = _plr ? RIASEC_INTERPRETATIONS_EN : RIASEC_INTERPRETATIONS;
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-3">${_T('RIASEC 진로 흥미 상세','RIASEC Career Interest Details')}</h3>
      <div class="bg-emerald-50 rounded-lg p-3 mb-3 text-sm">
        ${codeBlock}
      </div>
      <div class="space-y-2 text-sm">
        ${sorted.map(e => `<div><strong>${_riasecLbl[e[0]]}: ${e[1]}${_T('점','')}</strong><br><span class="text-slate-600 text-xs">${_riasecInterp[e[0]]}</span></div>`).join('')}
      </div>
    </div>`;
}

function renderVIADetailed(via) {
  if (!via) return '';
  const _vr = viaRank(via);
  if (!_vr) return '';
  const sorted = _vr.items;
  const hi = function(i){ return i<5 && !_vr.flat; };
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-3">${_T('24 강점 전체 순위','All 24 Strengths Ranked')}</h3>
      <div class="grid sm:grid-cols-2 gap-2 text-sm">
        ${sorted.map((it, i) => `
          <div class="flex items-center gap-2 py-1.5 ${hi(i)?'bg-emerald-50':''} rounded px-2">
            <span class="text-xs text-slate-400 w-12 whitespace-nowrap">${viaRankLabel(it)}</span>
            <span class="flex-1 ${hi(i)?'font-semibold':''}">${_viaName(it.k)}</span>
            <div class="w-16 bg-slate-100 h-1.5 rounded-full overflow-hidden"><div class="bg-emerald-500 h-1.5" style="width:${Math.round(it.raw/5*100)}%"></div></div>
            <span class="text-xs text-slate-500 w-24 text-right whitespace-nowrap">${it.raw}/5 · ${viaLevelLabel(it.level)}</span>
          </div>`).join('')}
      </div>
      <p class="text-xs text-slate-500 mt-3">${_vr.flat ? viaRankNote(_vr, 5) : _T('상위 5개 강점(녹색 표시)을 일상에서 의도적으로 활용해보세요.','Try deliberately using your top 5 strengths (shown in green) in everyday life.') + ' ' + viaRankNote(_vr, 5)}</p>
    </div>`;
}

function renderCareerDetailed(type, audience) {
  var _plc=(window.aipiaCurrentLang==='en');
  let html = '<div class="bg-white rounded-2xl border border-slate-200 p-4"><h3 class="font-semibold text-sm mb-3">'+_T('추천 진로 상세 (커리어넷 데이터 기반)','Recommended Careers in Detail (based on CareerNet data)')+'</h3>';
  type.careers.forEach((c, i) => {
    const info = typeof getCareerInfo === 'function' ? getCareerInfo(c) : null;
    const infoEn = (_plc && typeof CAREER_DATABASE_EN !== 'undefined') ? CAREER_DATABASE_EN[c] : null;
    const dispTitle = (infoEn && infoEn.title) ? infoEn.title : c;
    html += `<div class="border-b border-slate-100 last:border-0 py-3">
      <div class="flex items-center gap-2 mb-1">
        <span class="text-amber-500 text-sm">${'★'.repeat(Math.max(0,5-i)).padEnd(5,'☆')}</span>
        <strong class="text-sm">${dispTitle}</strong>
      </div>`;
    if (info) {
      var d = infoEn || info;
      html += `<p class="text-xs text-slate-600 mb-2">${d.description}</p>
        <div class="grid sm:grid-cols-2 gap-2 text-xs">
          <div><strong>${_T('필요 역량:','Skills needed:')}</strong> ${d.skills.join(', ')}</div>
          <div><strong>${_T('연봉:','Salary:')}</strong> ${d.salary}</div>
          <div><strong>${_T('전망:','Outlook:')}</strong> ${d.growth}</div>
          <div><strong>${_T('관련 학과:','Related majors:')}</strong> ${d.relatedMajors.join(', ')}</div>
        </div>`;
      if (d.license) html += `<div class="mt-2 text-xs"><strong>${_T('관련 자격증:','Related certifications:')}</strong> ${d.license.join(', ')}</div>`;
    }
    html += '</div>';
  });
  html += '</div>';

  // 자격증 추천
  if (typeof LICENSE_BY_TYPE !== 'undefined' && LICENSE_BY_TYPE[type.code]) {
    var _licList = (_plc && typeof LICENSE_BY_TYPE_EN !== 'undefined' && LICENSE_BY_TYPE_EN[type.code]) ? LICENSE_BY_TYPE_EN[type.code] : LICENSE_BY_TYPE[type.code];
    var _licCodes = _piaLicCodes(LICENSE_BY_TYPE[type.code]);
    html += `<div class="bg-white rounded-2xl border border-slate-200 p-4 mt-5">
      <h3 class="font-semibold text-sm mb-3">${_typeField(type,'name')}${_T('에 적합한 자격증 (한국산업인력공단)',' \u2014 Suitable Certifications (Human Resources Development Service of Korea)')}</h3>
      <div class="flex flex-wrap gap-2">
        ${_licList.map(l => `<span class="bg-violet-100 text-violet-900 px-3 py-1 rounded-full text-xs">${l}</span>`).join('')}
      </div>
      ${_licCodes.length ? `<div class="pia-lic-sched" data-lic='${JSON.stringify(_licCodes).replace(/'/g, '&#39;')}' style="margin-top:10px;font-size:12px;color:#475569;line-height:1.6">${_T('시험 일정 불러오는 중…','Loading exam dates…')}</div>` : ''}
    </div>`;
    if (_licCodes.length) { setTimeout(piaFillLicSched, 0); setTimeout(piaFillLicSched, 1500); }
  }
  return html;
}

// -----------------------------------------------------------------
//  추천 자격증 → 종목별 다음 시험 일정
//  종목코드: 한국산업인력공단 국가자격 종목 목록(data.go.kr 15003024, 2026-09-26 조회)
//            — 목록 API 는 http 전용이라 결과지에서 부르지 않고 필요한 종목만 여기 고정한다.
//  일정: 국가자격 시험일정 조회 서비스(15074408, jmCd 로 종목별 조회) — 서버 프록시(task=fwd)가 키를 붙인다.
//  시험이 없는 자격(사회복지사 2급 등)·타 기관 시행(빅데이터분석기사 등)은 코드가 없어 표시하지 않는다.
// -----------------------------------------------------------------
const LICENSE_JMCD = {
  '컴퓨터그래픽스운용기능사': { c: '7796', g: 'T', now: '컴퓨터그래픽기능사' },
  '웹디자인기능사':          { c: '7798', g: 'T', now: '웹디자인개발기능사' },
  '컬러리스트산업기사':      { c: '2982', g: 'T' },
  '정보처리기능사':          { c: '6921', g: 'T' },
  '정보처리기능사(입문)':    { c: '6921', g: 'T' },
  '정보처리산업기사':        { c: '2290', g: 'T' },
  '청소년상담사':            { c: '9754', g: 'S', now: '2급 청소년상담사' },
  '경영지도사':              { c: '9705', g: 'S', now: '경영지도사 1차' },
  '직업상담사 2급':          { c: '9511', g: 'T' },
  '전기기능사':              { c: '7780', g: 'T' },
  '조리기능사':              { c: '7910', g: 'T', now: '한식조리기능사' },
  '가구제작기능사':          { c: '7140', g: 'T' },
  '품질경영기사':            { c: '1500', g: 'T' },
  '한국어교원':              { c: '9660', g: 'S', now: '한국어교육능력검정시험' }
};
function _piaLicCodes(list) {
  var out = [], seen = {};
  (list || []).forEach(function (l) {
    var n = String(l || '').split(' (')[0].trim(), m = LICENSE_JMCD[n];
    if (m && !seen[m.c]) { seen[m.c] = 1; out.push({ n: m.now || n, c: m.c, g: m.g }); }
  });
  return out;
}
var _piaSchedCache = {};
function _piaSchedFetch(code, g) {
  var key = g + code;
  if (_piaSchedCache[key]) return _piaSchedCache[key];
  var y = new Date().getFullYear();
  var one = function (yy) {   // 최신 회차가 앞에 온다. 한 페이지 최대 50건
    var u = 'https://apis.data.go.kr/B490007/qualExamSchd/getQualExamSchdList?numOfRows=50&pageNo=1&dataFormat=json'
      + '&qualgbCd=' + g + '&jmCd=' + code + '&implYy=' + yy;
    return fetch(PIA_CHAT_PROXY + '&task=fwd&url=' + encodeURIComponent(u))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var it = d && d.body && d.body.items;
        if (it && it.item) it = it.item;
        return Array.isArray(it) ? it : (it ? [it] : []);
      })
      .catch(function (e) { console.error('[pia] 시험일정 조회 실패', code, e); return null; });
  };
  var p = Promise.all([one(y), one(y + 1)]).then(function (a) {
    if (a[0] === null && a[1] === null) { delete _piaSchedCache[key]; return null; }   // 실패는 캐시하지 않는다
    return (a[0] || []).concat(a[1] || []);
  });
  _piaSchedCache[key] = p;
  return p;
}
function _piaYmd(s) {
  s = String(s || '');
  if (!/^\d{8}$/.test(s)) return '';
  var m = +s.slice(4, 6), d = +s.slice(6, 8);
  return _T(m + '월 ' + d + '일', ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][m - 1] + ' ' + d);
}
function _piaNextRound(items) {
  // 반환: { r, kind: 'doc'(다음 필기/1차) | 'prac'(필기는 끝, 실기 남음) } 또는 null
  var now = new Date();
  var t = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
  var doc = null, prac = null;
  items.forEach(function (it) {
    var de = +(it.docExamStartDt || 0), re = +(it.docRegEndDt || 0), pe = +(it.pracExamStartDt || 0);
    if (de && de >= t &&
        (!doc || de < +doc.docExamStartDt || (de === +doc.docExamStartDt && re > +(doc.docRegEndDt || 0)))) doc = it;
    if (pe && pe >= t && (!prac || pe < +prac.pracExamStartDt)) prac = it;
  });
  if (doc) return { r: doc, kind: 'doc' };
  if (prac) return { r: prac, kind: 'prac' };
  return null;
}
function _piaRoundLabel(r) {
  var d = String(r.description || ''), m = d.match(/\((\d{4})년도\s*(제?\d+회[^)]*)\)/);
  var s = m ? (m[1] + '년 ' + m[2].replace(/^(\d)/, '제$1')) : (r.implYy + '년 제' + r.implSeq + '회');
  return _T(s, r.implYy + ' Round ' + r.implSeq);
}
function piaFillLicSched() {
  var els = document.querySelectorAll('.pia-lic-sched:not([data-done])');
  if (!els.length) return;
  Array.prototype.forEach.call(els, function (el) { el.setAttribute('data-done', '1'); });
  var qnetF = function () { return '<div style="color:#94a3b8;margin-top:2px">' + _T('정확한 일정·원서접수는 Q-Net(q-net.or.kr)에서 확인하세요. 다음 해 일정은 보통 연말에 공고됩니다.', 'Confirm exact dates and apply at Q-Net (q-net.or.kr). Next year\'s schedule is usually announced at year-end.') + '</div>'; };
  Array.prototype.forEach.call(els, function (el) {
    var lic = [];
    try { lic = JSON.parse(el.getAttribute('data-lic') || '[]'); } catch (e) { lic = []; }
    Promise.all(lic.map(function (x) { return _piaSchedFetch(x.c, x.g); })).then(function (res) { piaDomBatch(function () {
      if (res.every(function (r) { return r === null; })) { el.innerHTML = qnetF(); return; }
      var rows = lic.map(function (x, i) {
        var items = res[i], name = '<strong>' + x.n + '</strong> ';
        if (items === null) return '<li>' + name + _T('일정을 불러오지 못했습니다', 'schedule unavailable') + '</li>';
        var nx = _piaNextRound(items);
        if (!nx) return '<li>' + name + _T('올해 남은 시험이 없습니다', 'no remaining exams this year') + '</li>';
        var r = nx.r;
        if (nx.kind === 'doc') {
          return '<li>' + name + _piaRoundLabel(r)
            + ' · ' + _T('접수 ', 'Registration ') + _piaYmd(r.docRegStartDt) + (r.docRegEndDt ? '~' + _piaYmd(r.docRegEndDt) : '')
            + ' · ' + _T('시험 ', 'Exam ') + _piaYmd(r.docExamStartDt) + '</li>';
        }
        return '<li>' + name + _T('필기는 끝났고 ', 'written exam is over; ') + _piaRoundLabel(r) + ' '
          + _T('실기 ', 'practical ') + _piaYmd(r.pracExamStartDt) + _T('부터', '') + '</li>';
      });
      el.setAttribute('data-state', 'ok');
      el.innerHTML = '<div style="font-weight:600;margin-bottom:2px">' + _T('다음 시험 일정 (한국산업인력공단)', 'Next exam dates (HRD Korea)') + '</div>'
        + '<ul style="list-style:disc;padding-left:18px;margin:0">' + rows.join('') + '</ul>' + qnetF();
    }); });
  });
}

// 청중별 액션 가이드
function renderAudienceActions(audience, type) {
  if (!type) type = (typeof inferIntegratedType === 'function' ? (inferIntegratedType() || {}) : {});
  var _c0 = (type.careers && type.careers[0]) || '';
  var _tn = _typeField(type,'name');
  if (audience === 'student') {
    if (selfIsAdult()) return _T(`
      <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
        <h3 class="font-semibold text-sky-900 mb-3">이번 주 추천 활동</h3>
        <ul class="text-sm text-sky-900 space-y-2 list-decimal pl-5">
          <li>강점을 살리는 활동 한 가지 시도하기 (${_c0} 관련 자료·영상)</li>
          <li>관심 있는 콘텐츠 1편 + 짧은 감상 메모</li>
          <li>가까운 사람과 짧은 대화 먼저 시작해 보기</li>
          <li>하루 한 번 감정을 한 단어로 표현해 보기</li>
          <li>부담스러운 일을 메모로 정리해 보기</li>
        </ul>
      </div>
      <div class="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-emerald-900 mb-2">다음 단계</h3>
        <ul class="text-sm text-emerald-900 space-y-1.5">
          <li>· 더 정확한 결과를 위해 미완료 검사를 진행해 보세요.</li>
          <li>· 방향이 막연하면 ${_c0} 관련 자료를 한 편 살펴보세요.</li>
          <li>· 더 깊이 살펴보고 싶다면 예담 톡과 자유롭게 대화해 보세요.</li>
          <li>· 어려움이 있으면 가까운 전문기관의 도움을 받아도 좋습니다.</li>
        </ul>
      </div>`, `
      <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
        <h3 class="font-semibold text-sky-900 mb-3">Recommended Activities This Week</h3>
        <ul class="text-sm text-sky-900 space-y-2 list-decimal pl-5">
          <li>Try one activity that builds on your strengths (material/videos related to ${_c0})</li>
          <li>One piece of content you're interested in + a short reflection note</li>
          <li>Start a short conversation with someone close to you</li>
          <li>Express your feelings in one word, once a day</li>
          <li>Jot down anything that feels burdensome</li>
        </ul>
      </div>
      <div class="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-emerald-900 mb-2">Next Steps</h3>
        <ul class="text-sm text-emerald-900 space-y-1.5">
          <li>\u00b7 Complete any unfinished assessments for more accurate results.</li>
          <li>\u00b7 If your direction feels unclear, take a look at material related to ${_c0}.</li>
          <li>\u00b7 If you'd like to explore further, feel free to chat freely with YEDAM Talk.</li>
          <li>\u00b7 If you're struggling, it's okay to get help from a professional support service nearby.</li>
        </ul>
      </div>`);
    return _T(`
      <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
        <h3 class="font-semibold text-sky-900 mb-3">이번 주 너에게 추천하는 활동</h3>
        <ul class="text-sm text-sky-900 space-y-2 list-decimal pl-5">
          <li>너의 강점을 살리는 활동을 한 가지 시도해보기 (${_c0} 관련 영상·책)</li>
          <li>좋아하는 콘텐츠 1편 + 짧은 감상 메모</li>
          <li>친구 1명과 짧은 대화 먼저 시작해보기</li>
          <li>하루 한 번 감정을 한 단어로 표현해보기</li>
          <li>부담스러운 일을 그림·메모로 정리</li>
          <li>가족과 5분 함께 대화</li>
        </ul>
      </div>
      <div class="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-emerald-900 mb-2">다음 단계</h3>
        <ul class="text-sm text-emerald-900 space-y-1.5">
          <li>· 더 정확한 결과를 위해 미완료 검사를 진행해보세요.</li>
          <li>· 진로가 막연하면 ${_c0} 직업 영상이나 책을 1편 보기.</li>
          <li>· 자유대화로 마음을 더 깊이 살펴보고 싶다면 예담 톡과 대화하기.</li>
          <li>· 어려움이 있으면 학교 상담선생님이나 1388에 연락해도 좋아.</li>
        </ul>
      </div>`, `
      <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
        <h3 class="font-semibold text-sky-900 mb-3">Recommended Activities for You This Week</h3>
        <ul class="text-sm text-sky-900 space-y-2 list-decimal pl-5">
          <li>Try one activity that builds on your strengths (videos/books related to ${_c0})</li>
          <li>One piece of content you like + a short reflection note</li>
          <li>Start a short conversation with a friend first</li>
          <li>Express your feelings in one word, once a day</li>
          <li>Turn anything that feels burdensome into a drawing or note</li>
          <li>Talk with your family for 5 minutes</li>
        </ul>
      </div>
      <div class="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-emerald-900 mb-2">Next Steps</h3>
        <ul class="text-sm text-emerald-900 space-y-1.5">
          <li>\u00b7 Complete any unfinished assessments for more accurate results.</li>
          <li>\u00b7 If your career direction feels unclear, watch a video or read a book about ${_c0}.</li>
          <li>\u00b7 If you want to explore your feelings more, chat freely with YEDAM Talk.</li>
          <li>\u00b7 If you're struggling, it's okay to reach out to your school counselor or call 1388.</li>
        </ul>
      </div>`);
  }
  if (audience === 'parent') {
    return _T(`
      <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
        <h3 class="font-semibold text-sky-900 mb-3">집에서 이렇게 도와주세요</h3>
        <ul class="text-sm text-sky-900 space-y-2 list-disc pl-5">
          <li>자녀가 그린 그림이나 만든 결과물을 "잘했네"보다 <strong>"이건 어떻게 생각한 거야?"</strong>라고 물어봐 주세요.</li>
          <li>부담스러운 상황 앞두고 "준비 잘 했지?" 대신 <strong>"오늘 어떻게 할 계획이야?"</strong>로 물어주세요.</li>
          <li>친구 갈등을 얘기하면 해결책보다 <strong>"네 마음은 어땠어?"</strong>로 시작해 주세요.</li>
          <li>${_c0} 같은 진로 관심사가 있다면 <strong>"네가 좋아하는 게 누군가에게 도움이 될 수 있어"</strong>라는 한마디를 가끔 해주세요.</li>
        </ul>
      </div>
      <div class="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-amber-900 mb-3">학부모 2주 코칭 플랜</h3>
        <ol class="text-sm text-amber-900 space-y-1.5 list-decimal pl-5">
          <li><strong>1주차:</strong> 강점 1개 칭찬 + 감정이름 말하기 연습 (하루 3분)</li>
          <li><strong>2주차:</strong> 성장 포인트 1개만 선택해 작은 행동 점검 (하루 1회)</li>
          <li>점검 질문: "오늘은 어제보다 1% 나아진 점이 있었어?"</li>
          <li>주의: 한 번에 여러 개 시도하지 말고 천천히 진행하세요.</li>
        </ol>
      </div>
      <div class="bg-violet-50 border border-violet-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-violet-900 mb-2">자녀와의 대화 예시문</h3>
        <ul class="text-sm text-violet-900 space-y-2 leading-relaxed">
          <li>"오늘 학교에서 가장 신경 쓰였던 게 뭐였어? 한 가지만 들려줘."</li>
          <li>"네 결과지를 봤어. 이 부분이 정말 너답다고 생각했어 — 어떻게 생각해?"</li>
          <li>"엄마/아빠도 너만할 때 비슷한 고민이 있었어. 같이 천천히 찾아보자."</li>
          <li>"진로는 평생 한 가지일 필요 없어. 이번 학기엔 ${_c0}${_piaJ(_c0,'을','를')} 한 번 살펴볼까?"</li>
        </ul>
      </div>`, `
      <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
        <h3 class="font-semibold text-sky-900 mb-3">Ways to Help at Home</h3>
        <ul class="text-sm text-sky-900 space-y-2 list-disc pl-5">
          <li>When your child shows you a drawing or something they made, instead of "good job," try asking <strong>"What made you think of this?"</strong></li>
          <li>Before something stressful, instead of "Are you ready?" try asking <strong>"What's your plan for today?"</strong></li>
          <li>When they mention a conflict with a friend, start with <strong>"How did that make you feel?"</strong> instead of jumping to solutions.</li>
          <li>If they show interest in a career like ${_c0}, occasionally say <strong>"What you love could help someone else too."</strong></li>
        </ul>
      </div>
      <div class="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-amber-900 mb-3">2-Week Parent Coaching Plan</h3>
        <ol class="text-sm text-amber-900 space-y-1.5 list-decimal pl-5">
          <li><strong>Week 1:</strong> Praise one strength + practice naming emotions (3 minutes a day)</li>
          <li><strong>Week 2:</strong> Pick just one growth point and check in on a small action (once a day)</li>
          <li>Check-in question: "Was there anything today that was 1% better than yesterday?"</li>
          <li>Note: Don't try several things at once \u2014 take it slowly.</li>
        </ol>
      </div>
      <div class="bg-violet-50 border border-violet-200 rounded-2xl p-4 mt-5">
        <h3 class="font-semibold text-violet-900 mb-2">Sample Conversation Starters with Your Child</h3>
        <ul class="text-sm text-violet-900 space-y-2 leading-relaxed">
          <li>"What was on your mind the most at school today? Just tell me one thing."</li>
          <li>"I looked at your report. This part really seemed like you \u2014 what do you think?"</li>
          <li>"I had similar worries when I was your age. Let's figure it out together, slowly."</li>
          <li>"Your career doesn't have to be just one thing for life. Want to explore ${_c0} this term?"</li>
        </ul>
      </div>`);
  }
  // teacher
  var _pairNote = _T(type.code==='EM-CO'||type.code==='RE-CO'?'다른 유형 학생과 짝이 되어 매개 역할':'유사 유형 1명과 함께해 안정감 확보', type.code==='EM-CO'||type.code==='RE-CO'?'pairing with a student of a different type to play a mediating role':'pairing with one similarly-typed student for a sense of stability');
  var _taskNote = _T(type.code==='CR-EX'||type.code==='EX-CR'||type.code==='AR-EX'?'시각자료·창작물로 표현할 수 있는 형식 권장':'구조화된 양식이나 단계별 과제 권장', type.code==='CR-EX'||type.code==='EX-CR'||type.code==='AR-EX'?'a format that lets them express themselves through visuals or creative work is recommended':'a structured format or step-by-step tasks are recommended');
  var _selNote = _T(type.code==='EX-CR'||type.code==='AR-EX'?'감정조절·자기표현':'대인관계·자기인식', type.code==='EX-CR'||type.code==='AR-EX'?'emotional regulation and self-expression':'interpersonal relationships and self-awareness');
  return _T(`
    <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
      <h3 class="font-semibold text-sky-900 mb-3">교사용 학급 운영 가이드</h3>
      <ul class="text-sm text-sky-900 space-y-2 list-disc pl-5">
        <li><strong>모둠 배치:</strong> ${_tn} 학생은 ${_pairNote}하면 좋습니다.</li>
        <li><strong>발표·과제:</strong> ${_taskNote}.</li>
        <li><strong>SEL 콘텐츠 매핑:</strong> 에듀넷 사회정서교육 144종 중 ${_selNote} 영역을 우선 활용.</li>
        <li><strong>위험 신호 시:</strong> 보호자 공유 → Wee클래스 연계 → 필요 시 1388/1577-0199 안내.</li>
      </ul>
    </div>
    <div class="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-5">
      <h3 class="font-semibold text-amber-900 mb-3">학부모 면담 시 활용 포인트</h3>
      <ul class="text-sm text-amber-900 space-y-1.5">
        <li>· 학생의 강점을 먼저 구체적으로 전달하세요.</li>
        <li>· 성장 포인트는 부담 없이 1개만, 가정에서 함께 해볼 활동으로 제시.</li>
        <li>· ${_c0} 같은 진로 관심사를 부모와 공유해 가정 협력 유도.</li>
        <li>· 결과 해석 등급(검사 완료도·응답 성실도)을 함께 설명해 단편적 해석 방지.</li>
      </ul>
    </div>
    <div class="bg-rose-50 border border-rose-200 rounded-2xl p-4 mt-5">
      <h3 class="font-semibold text-rose-900 mb-2">정서 모니터링 (CES-D / PHQ-A / GAD-7 결과 참조)</h3>
      <p class="text-sm text-rose-900 mb-2">HIGH 시 즉시 대응 매뉴얼:</p>
      <ol class="text-sm text-rose-900 list-decimal pl-5 space-y-1">
        <li>학생과 1:1 대화로 안전 확인 (자해·자살 의도 직접 질문 가능)</li>
        <li>보호자 즉시 연락 + 공동 대응 계획 수립</li>
        <li>Wee클래스 의뢰 또는 1388·1577-0199·109 채널 안내</li>
        <li>학교 위기관리위원회 보고</li>
      </ol>
    </div>`, `
    <div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
      <h3 class="font-semibold text-sky-900 mb-3">Classroom Management Guide for Teachers</h3>
      <ul class="text-sm text-sky-900 space-y-2 list-disc pl-5">
        <li><strong>Group placement:</strong> It works well to place a ${_tn} student ${_pairNote}.</li>
        <li><strong>Presentations/assignments:</strong> ${_taskNote}.</li>
        <li><strong>SEL content mapping:</strong> Among EDUNET's 144 social-emotional learning resources, prioritize the ${_selNote} area.</li>
        <li><strong>If warning signs appear:</strong> Share with guardian \u2192 refer to Wee Class \u2192 direct to 1388/1577-0199 if needed.</li>
      </ul>
    </div>
    <div class="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-5">
      <h3 class="font-semibold text-amber-900 mb-3">Points to Use During Parent Conferences</h3>
      <ul class="text-sm text-amber-900 space-y-1.5">
        <li>\u00b7 Share the student's strengths first, with specifics.</li>
        <li>\u00b7 Present just one growth point, framed as something to try together at home, without pressure.</li>
        <li>\u00b7 Share career interests like ${_c0} with parents to encourage support at home.</li>
        <li>\u00b7 Explain the reliability grade together to avoid a one-sided interpretation.</li>
      </ul>
    </div>
    <div class="bg-rose-50 border border-rose-200 rounded-2xl p-4 mt-5">
      <h3 class="font-semibold text-rose-900 mb-2">Emotional Monitoring (see CES-D / PHQ-A / GAD-7 results)</h3>
      <p class="text-sm text-rose-900 mb-2">Immediate response manual if HIGH:</p>
      <ol class="text-sm text-rose-900 list-decimal pl-5 space-y-1">
        <li>Confirm safety through a 1:1 conversation with the student (directly asking about self-harm/suicidal intent is acceptable)</li>
        <li>Contact the guardian immediately and establish a joint response plan</li>
        <li>Refer to the Wee Class or direct to 1388 / 1577-0199 / 109</li>
        <li>Report to the school's crisis management committee</li>
      </ol>
    </div>`);
}

// 메인 상세 렌더링 함수
let currentAudience = 'student';

function renderMiCard() {
  const sc = state.results.mi && state.results.mi.scores;
  if (!sc) return '';
  var _plm=(window.aipiaCurrentLang==='en');
  const labels = _plm ? { verbal:'Linguistic', logical:'Logical-Math', spatial:'Spatial', musical:'Musical', bodily:'Bodily-Kinesthetic', interpersonal:'Interpersonal', intrapersonal:'Intrapersonal', naturalist:'Naturalist' } : { verbal:'언어', logical:'논리수학', spatial:'공간', musical:'음악', bodily:'신체운동', interpersonal:'대인', intrapersonal:'자기성찰', naturalist:'자연' };
  const rows = Object.keys(labels).filter(function(k){ return sc[k]!=null; }).sort(function(a,b){ return sc[b]-sc[a]; }).map(function(k){
    const v = sc[k];
    return '<div class="flex items-center gap-3 py-1.5"><span class="text-sm w-16">'+labels[k]+'</span>'
      + '<div class="flex-1 bg-slate-100 rounded-full h-2 overflow-hidden"><div class="h-2 rounded-full" style="width:'+v+'%;background:#788c5d"></div></div>'
      + '<span class="text-xs text-slate-500 w-8 text-right">'+v+'</span></div>';
  }).join('');
  return '<div class="mt-5 bg-white rounded-2xl border border-slate-200 p-4"><h3 class="font-semibold text-sm mb-2">'+_T('다중지능(MI) 8지능 (자가평가)','Multiple Intelligences (MI) \u2014 8 Types (Self-assessment)')+'</h3>' + rows + '<p class="text-xs text-slate-500 mt-2">'+_T('가드너 다중지능 이론 기반 자가평가입니다. 참고용이며 IQ 검사가 아닙니다.','Based on Gardner\'s theory of multiple intelligences. For reference only \u2014 this is not an IQ test.')+'</p></div>';
}

function renderLearnCard() {
  const sc = state.results.learn && state.results.learn.scores;
  if (!sc) return '';
  var _pll=(window.aipiaCurrentLang==='en');
  const labels = _pll ? { korean:'Korean', math:'Math', english:'English', social:'Social Studies', science:'Science', arts:'Arts', pe:'P.E.' } : { korean:'국어', math:'수학', english:'영어', social:'사회', science:'과학', arts:'예술', pe:'체육' };
  const rows = Object.keys(labels).filter(function(k){ return sc[k]!=null; }).sort(function(a,b){ return sc[b]-sc[a]; }).map(function(k){
    const v = sc[k];
    return '<div class="flex items-center gap-3 py-1.5"><span class="text-sm w-12">'+labels[k]+'</span>'
      + '<div class="flex-1 bg-slate-100 rounded-full h-2 overflow-hidden"><div class="h-2 rounded-full" style="width:'+v+'%;background:#6a9bcc"></div></div>'
      + '<span class="text-xs text-slate-500 w-8 text-right">'+v+'</span></div>';
  }).join('');
  return '<div class="mt-5 bg-white rounded-2xl border border-slate-200 p-4"><h3 class="font-semibold text-sm mb-2">'+_T('분야별 학습·역량 (자가평가)','Subject-by-Subject Learning & Ability (Self-assessment)')+'</h3>' + rows + '<p class="text-xs text-slate-500 mt-2">'+_T('스스로 평가한 분야별 흥미·자신감입니다. 실제 성적·능력과 다를 수 있어요.','This reflects your own self-rated interest and confidence in each subject, which may differ from actual grades or ability.')+'</p></div>';
}

function renderExtraScales() {
  const w = state.results.who5 && state.results.who5.scores;
  const r = state.results.rses && state.results.rses.scores;
  if (!w && !r) return '';
  var _ple=(window.aipiaCurrentLang==='en');
  let rows = '';
  if (w) { var wLv = _ple ? (w.level==='양호'?'Good':(w.level==='낮음(돌봄 권장)'?'Low (support recommended)':w.level)) : w.level; rows += '<div class="flex justify-between text-sm py-1 border-b border-slate-100"><span>'+_T('WHO-5 웰빙','WHO-5 Well-Being')+'</span><span class="text-slate-600">' + w.pct + ' / 100 \u00b7 ' + wLv + '</span></div>'; }
  if (r) { var rLv = _ple ? (r.level==='높음'?'High':(r.level==='보통'?'Moderate':(r.level==='낮음'?'Low':r.level))) : r.level; rows += '<div class="flex justify-between text-sm py-1"><span>'+_T('자존감(RSES)','Self-Esteem (RSES)')+'</span><span class="text-slate-600">' + r.total + ' / 40 \u00b7 ' + rLv + '</span></div>'; }
  return '<div class="mt-5 bg-white rounded-2xl border border-slate-200 p-4"><h3 class="font-semibold text-sm mb-2">'+_T('추가 검사 — 웰빙·자존감','Additional Assessments \u2014 Well-Being & Self-Esteem')+'</h3>' + rows + '<p class="text-xs text-slate-500 mt-2">'+_T('WHO-5는 정서적 웰빙(높을수록 양호), RSES는 자아존중감 수준입니다. 참고용 선별이며 진단이 아닙니다.','WHO-5 measures emotional well-being (higher is better), and RSES measures self-esteem. These are reference screenings, not diagnoses.')+'</p></div>';
}

function audienceTheme(a) {
  if (a === 'parent') return { emoji:'👨‍👩‍👧', title:_T('학부모용 · 자녀 이해 리포트','For Parents \u00b7 Understanding Your Child Report'), sub:_T('자녀의 성향을 이해하고 가정에서 도울 방법을 중심으로 정리했습니다.','Focused on understanding your child\'s tendencies and how you can help at home.'), bg:'#eef3f9', bd:'#c4d8ec', fg:'#2c4a6b' };
  if (a === 'teacher') return { emoji:'🏫', title:_T('교사용 · 지도 참고 자료','For Teachers \u00b7 Guidance Reference Material'), sub:_T('객관적 근거(신뢰도·규준)와 생활지도·상담 활용 정보를 제공합니다.','Provides objective evidence (reliability, norms) plus information for classroom guidance and counseling.'), bg:'#fbf1ec', bd:'#eccfc1', fg:'#8a3d22' };
  if (selfIsAdult()) return { emoji:'🌱', title:_T('본인용 · 성장 리포트','For You \u00b7 Growth Report'), sub:_T('당신의 강점과 가능성을 중심으로 이해하기 쉽게 정리했습니다.','Organized to be easy to understand, focused on your strengths and possibilities.'), bg:'#f1f4ea', bd:'#cdd9b8', fg:'#3a4630' };
  return { emoji:'🌱', title:_T('학생 본인용 · 성장 리포트','For You \u00b7 Growth Report'), sub:_T('너의 강점과 가능성을 중심으로 쉽고 따뜻하게 풀어 썼어.','Written simply and warmly, focused on your strengths and possibilities.'), bg:'#f1f4ea', bd:'#cdd9b8', fg:'#3a4630' };
}
function audienceBanner(a) {
  const t = audienceTheme(a);
  return `<div class="rounded-2xl border p-4 mb-5" style="background:${t.bg};border-color:${t.bd}">
    <div class="flex items-center gap-3">
      <div class="text-3xl">${t.emoji}</div>
      <div><div class="font-bold" style="color:${t.fg}">${t.title}</div>
      <div class="text-xs mt-0.5" style="color:${t.fg}">${t.sub}</div></div>
    </div>
  </div>`;
}
function audienceScreeningNote(a) {
  const cesd = state.results.cesd && state.results.cesd.scores;
  const phqa = state.results.phqa && state.results.phqa.scores;
  const gad  = state.results.gad  && state.results.gad.scores;
  if (!cesd && !phqa && !gad) return '';
  const anyHigh = (cesd&&cesd.level==='HIGH')||(phqa&&phqa.level==='HIGH')||(gad&&gad.level==='HIGH')||(phqa&&phqa.selfHarm>0);
  if (a === 'student') {
    return `<div class="mt-5 rounded-2xl border border-emerald-200 bg-emerald-50 p-4">
      <h3 class="font-semibold text-sm mb-2">🌤️ ${_T('오늘의 마음 체크', "Today's Mood Check")}</h3>
      <p class="text-sm text-slate-700 leading-relaxed">${anyHigh?_T('요즘 마음이 조금 무거운 것 같아요. 그건 약한 게 아니라 도움을 받을 때라는 신호예요. 혼자 두지 말고 믿을 수 있는 사람이나 상담 전화(청소년 1388 · 성인 1577-0199)에 이야기해 봐요.',"It looks like things have felt a bit heavy lately. That's not a weakness \u2014 it's a sign that it's time to get some support. Please don't go through it alone; talk to someone you trust, or call a counseling line (youth: 1388 \u00b7 adult: 1577-0199)."):_T('지금 마음 상태는 대체로 안정적이에요. 그래도 힘든 날엔 언제든 주변 사람이나 상담 전화(1388 · 1577-0199)에 이야기할 수 있어요.',"Your emotional state looks generally stable right now. Even so, on hard days you can always talk to someone close to you or call a counseling line (1388 \u00b7 1577-0199).")}</p>
    </div>`;
  }
  if (a === 'parent') {
    const rows = [];
    if (cesd) rows.push([_T('CES-D 우울','CES-D Depression'), cesd.total+' / 30', cesd.level]);
    if (phqa) rows.push([_T('PHQ-A 우울','PHQ-A Depression'), phqa.total+' / 27', phqa.level]);
    if (gad)  rows.push([_T('GAD-7 불안','GAD-7 Anxiety'), gad.total+' / 21', gad.level]);
    return `<div class="mt-5 rounded-2xl border border-sky-200 bg-sky-50 p-4">
      <h3 class="font-semibold text-sm mb-2">${_T('자녀 정서 스크리닝 안내', "Your Child's Emotional Screening")}</h3>
      <p class="text-xs text-slate-600 mb-2">${_T('참고용 선별 결과이며 진단이 아닙니다.','This is a reference screening result, not a diagnosis.')} ${anyHigh?_T('<strong>도움이 필요한 신호</strong>가 있어 전문기관 상담을 권장드립니다.','There are <strong>signs that support may be needed</strong>, so we recommend consulting a professional service.'):_T('대체로 양호한 범위입니다.','The results are generally within a healthy range.')}</p>
      ${rows.map(r=>`<div class="flex justify-between text-sm py-1 border-b border-sky-100 last:border-0"><span>${r[0]}</span><span class="text-slate-600">${r[1]} \u00b7 ${r[2]}</span></div>`).join('')}
      <p class="text-xs text-slate-500 mt-2">${_T('가정에서는 평가보다 공감을 먼저, 수면·식사·생활리듬을 함께 살펴주세요. 청소년상담 1388.','At home, lead with empathy rather than judgment, and keep an eye on sleep, meals, and daily routine together. Youth counseling: 1388.')}</p>
    </div>`;
  }
  const rows = [];
  if (cesd) rows.push(['CES-D-10', cesd.total+' / 30', cesd.level]);
  if (phqa) rows.push(['PHQ-A', phqa.total+' / 27', phqa.level + (phqa.selfHarm>0?_T(' · 자해문항 양성',' \u00b7 Self-harm item positive'):'')]);
  if (gad)  rows.push(['GAD-7', gad.total+' / 21', gad.level]);
  return `<div class="mt-5 rounded-2xl border ${anyHigh?'border-rose-300 bg-rose-50':'border-slate-200 bg-white'} p-4">
    <h3 class="font-semibold text-sm mb-2">${_T('정서 스크리닝 상세 (교사용)','Emotional Screening Details (for Teachers)')}</h3>
    ${rows.map(r=>`<div class="flex justify-between text-sm py-1 border-b border-slate-100 last:border-0"><span>${r[0]}</span><span class="text-slate-600">${r[1]} \u00b7 <strong>${r[2]}</strong></span></div>`).join('')}
    <p class="text-xs ${anyHigh?'text-rose-700':'text-slate-500'} mt-2">${anyHigh?_T('HIGH/자해 신호 — 보호자 공유 및 Wee클래스 연계, 학교 위기관리 매뉴얼에 따른 조치를 권장합니다.', "HIGH / self-harm signal detected \u2014 sharing with the guardian, referral to the Wee Class, and action per the school's crisis management manual are recommended."):_T('유의 수준 이하 · 정기 관찰 권장.','Below the level of concern \u00b7 routine monitoring is recommended.')} ${_T('위기 시','In a crisis, call')} 1577-0199 / 109.</p>
  </div>`;
}

let _aiSumSig = null, _aiSumCache = {};
/* AI 요약 캐시는 대상+언어별 — 한국어로 만든 요약이 영어 화면에 재사용되던 문제 방지 */
function _aiSumKey(audience){ return audience + '|' + ((window.aipiaCurrentLang==='en') ? 'en' : 'ko'); }
function _piaMostlyHangul(t){ var s=String(t||''); var h=(s.match(/[\uAC00-\uD7A3]/g)||[]).length, a=(s.match(/[A-Za-z]/g)||[]).length; return h > 10 && h > a * 0.3; }
function aiSummarySignature(d){ const b=d.big5||{}, r=d.riasec||{}; return [d.type&&d.type.code,b.E,b.A,b.C,b.N,b.O,r.R,r.I,r.A,r.S,r.E,r.C].join('|'); }
function localSummary(audience, d){
  const t=d.type||{};
  if(window.aipiaCurrentLang==='en'){
    var _n=(typeof _typeField==='function'?_typeField(t,'name'):t.name)||'Growth', _d=(typeof _typeField==='function'?_typeField(t,'desc'):t.desc)||'';
    if(audience==='parent') return `Your child appears to be a '${_n}' type. ${_d} Acknowledge specific strengths first, and work on one growth point at a time together.`;
    if(audience==='teacher') return `The student is a '${_n}' type. ${_d} Strength-based roles and observation-focused guidance work well; check emotional signals regularly.`;
    return `You are a '${_n}' type. ${_d} Use your strengths on purpose once a day and they will shine even more.`;
  }
  if(audience==='parent') return `자녀는 '${t.name||'성장형'}' 성향으로 보입니다. ${t.desc||''} 강점을 먼저 구체적으로 인정해 주시고, 성장 포인트는 한 번에 한 가지씩 함께 시도해 보세요.`;
  if(audience==='teacher') return `학생은 '${t.name||'성장형'}' 유형입니다. ${t.desc||''} 강점 기반 역할 부여와 관찰 중심 지도가 효과적이며, 정서 신호는 정기적으로 점검해 주세요.`;
  if(typeof selfIsAdult==='function' && selfIsAdult()) return `'${t.name||'성장형'}' 유형으로 보입니다. ${t.desc||''} 자신의 강점을 하루 한 번 의도적으로 활용해 보시면 더욱 빛날 것입니다.`;
  return `너는 '${t.name||'성장형'}' 유형이야. ${t.desc||''} 너의 강점을 하루 한 번 의도적으로 써보면 훨씬 더 빛날 거야.`;
}
function buildSummaryPrompt(audience, d){
  const b=d.big5, r=d.riasec, v=d.via, t=d.type;
  const vtop = viaTopKeys(v, 3).join(', ');
  const rtop = r ? Object.entries(r).sort((a,b)=>b[1]-a[1]).slice(0,3).map(e=>e[0]).join('') : '';
  const lines=[];
  lines.push(`통합유형: ${(t&&t.name)||''} (${(t&&t.code)||''})`);
  if(b) lines.push(`Big5 — 외향 ${b.E}, 우호 ${b.A}, 성실 ${b.C}, 정서안정 ${100-b.N}, 개방 ${b.O}`);
  if(rtop) lines.push(`흥미(RIASEC) 상위: ${rtop}` + ' (' + Object.entries(r).sort((a,b)=>b[1]-a[1]).slice(0,3).map(e=>e[0]+' '+Math.round(e[1])+'점').join(', ') + ')');
  if(vtop) lines.push(`대표 강점: ${vtop}`);
  else if(v) lines.push('대표 강점: 강점 문항에 모두 같은 점수로 응답해 우열을 가릴 수 없음(강점 단정 금지)');
  try{ var _rl=calcReliability(); if(_rl&&_rl.validity&&(_rl.validity.grade==='주의'||_rl.validity.grade==='낮음')) lines.push('응답 성실도: '+_rl.validity.grade+' — 결과를 단정하지 말고 참고용임과 천천히 다시 응답하기를 부드럽게 권할 것'); }catch(_){}
  var _ab=(state.results&&state.results.conv&&state.results.conv.abuse)||0;
  if(_ab>0) lines.push(`대화 태도: 자유대화 중 부적절·공격적 표현이 ${_ab}회 감지됨(지도 시 참고).`);
  const who = audience==='parent'?'학부모':audience==='teacher'?'교사':(selfIsAdult()?'본인':'학생 본인');
  const tone = audience==='parent'?'정중한 존댓말로, 자녀 이해와 가정에서의 지원 팁을 담아':audience==='teacher'?'객관적이고 전문적인 어조로, 생활지도·상담 활용 포인트를 담아':(selfIsAdult()?'정중한 존댓말로, 강점과 도움이 될 점을 담아':'따뜻한 반말로, 강점과 격려를 담아');
  /* [2026-11-02] 대화 신뢰성 ③ — 문장마다 점수 근거 */
  const _evInstr = (window.aipiaCurrentLang==='en') ? 'In every sentence, cite one score from the data above as "N points". ' : '문장마다 위 데이터의 점수 하나를 "N점" 형태로 근거로 넣어(예: 외향 72점). 점수에 없는 숫자는 쓰지 마. ';
  const langInstr = (window.aipiaCurrentLang==='en') ? 'Write only in English.' : '한국어로만.';
  return `다음은 한 응답자의 인적성 검사 요약 데이터야.\n${lines.join('\n')}\n\n이 데이터를 바탕으로 ${who}에게 전하는 종합 해석을 ${tone} 3~4문장으로 작성해줘. 과장·의료적 진단 표현은 피하고, 구체적 강점과 실천 제안 한 가지를 포함해. ${_evInstr}${langInstr}`;
}
/* [2026-09-26] AI 응답 표시 — 모델이 마크다운(##, **, - 목록)으로 답하면 textContent 로는
   기호가 그대로 보였다. 먼저 HTML 을 전부 이스케이프한 뒤 제목·굵게·목록만 태그로 바꾼다.
   (링크·이미지·HTML 은 만들지 않는다 — 응답에 섞인 태그는 글자로만 보인다) */
function _piaMdSafe(src){
  var t=String(src==null?'':src).replace(/\r\n?/g,'\n');
  function esc(x){ return x.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function inline(x){
    return esc(x)
      .replace(/\*\*([^*\n]+?)\*\*/g,'<strong>$1</strong>')
      .replace(/__([^_\n]+?)__/g,'<strong>$1</strong>')
      .replace(/\*\*|__/g,'')                      /* 짝이 안 맞는 굵게 기호는 지운다 */
      .replace(/(^|[\s(])\*([^*\n]+?)\*(?=[\s).,!?]|$)/g,'$1$2');   /* *기울임* → 글자만 */
  }
  var out=[], list=null;
  function close(){ if(list){ out.push('</'+list+'>'); list=null; } }
  t.split('\n').forEach(function(line){
    var m;
    if((m=line.match(/^\s{0,3}#{1,6}\s+(.*?)\s*#*\s*$/))){ close(); out.push('<strong style="display:block;margin:.35em 0 .15em">'+inline(m[1])+'</strong>'); }
    else if((m=line.match(/^\s*[-*•]\s+(.*)$/))){ if(list!=='ul'){ close(); out.push('<ul style="list-style:disc;margin:.2em 0 .2em 1.3em;padding:0">'); list='ul'; } out.push('<li>'+inline(m[1])+'</li>'); }
    else if((m=line.match(/^\s*\d{1,2}[.)]\s+(.*)$/))){ if(list!=='ol'){ close(); out.push('<ol style="list-style:decimal;margin:.2em 0 .2em 1.3em;padding:0">'); list='ol'; } out.push('<li>'+inline(m[1])+'</li>'); }
    else if(!line.trim()){ close(); var pv=out.length?out[out.length-1]:''; if(pv && pv!=='<br>' && !/^<\/[uo]l>$|^<strong style="display:block/.test(pv)) out.push('<br>'); }
    else { close(); out.push(inline(line)+'<br>'); }
  });
  close();
  while(out.length && out[out.length-1]==='<br>') out.pop();
  var h=out.join('');
  return h.replace(/<br>$/,'');
}
/* 응답이 토큰 한도로 문장 중간에서 끊겼으면 마지막 완결 문장까지만 남긴다.
   남는 분량이 너무 적으면(30% 미만) 자르지 않고 말줄임표만 붙인다. 마지막 줄이 목록이면 그대로 둔다. */
function _piaTrimSentence(src){
  var s=String(src==null?'':src).replace(/\s+$/,'');
  if(!s) return s;
  var lines=s.split('\n'), last=lines[lines.length-1];
  if(/^\s*([-*•]|\d{1,2}[.)])\s/.test(last) || /^\s{0,3}#/.test(last)) return s;
  if(/[.!?。！？…~]["'”’)\]*]*$/.test(s)) return s;
  var re=/[.!?。！？…]["'”’)\]*]*(?=\s|$)/g, m, end=-1;
  while((m=re.exec(s))){ if(/\d/.test(s.charAt(m.index-1))) continue; end=m.index+m[0].length; }  /* '2.' 같은 번호는 문장 끝이 아니다 */
  /* 목록·제목 줄은 마침표가 없어도 완결된 단위로 본다 — 그 줄 끝도 자를 수 있는 자리 */
  var pos=0; for(var li=0; li<lines.length-1; li++){ pos+=lines[li].length; if(/^\s*([-*•]|\d{1,2}[.)])\s|^\s{0,3}#/.test(lines[li]) && pos>end) end=pos; pos+=1; }
  if(end>0 && end>=s.length*0.3) return s.slice(0,end).replace(/\s+$/,'');
  return s+'…';
}
/* [2026-11-02 성능 2차] 결과지에 뒤늦게 오는 조각(AI 종합 요약·상담 예시·자격증 일정·자체 α·백분위·커리어넷·위키·상담 연락처)의
   DOM 반영을 한 묶음으로 — 조각 하나가 들어올 때마다 쪽 넘김(yd-pager-pia)이 결과지 전체를 다시 재서(CPU 4x 0.8~1.2초) 그만큼 멈췄다.
   마지막 조각 뒤 300ms(첫 조각 뒤 최대 1500ms)에 한 번에 쓴다. 인쇄(piaPrintReport)는 먼저 piaDomFlush() 로 밀린 조각을 다 쓴다. */
var _piaDomQ = [], _piaDomT = 0, _piaDomT0 = 0;
function piaDomFlush(){
  if (_piaDomT) { clearTimeout(_piaDomT); _piaDomT = 0; }
  _piaDomT0 = 0;
  var q = _piaDomQ.splice(0);
  for (var i = 0; i < q.length; i++) { try { q[i](); } catch (e) { console.warn('[결과지] 묶음 반영 실패', e); } }
}
function piaDomBatch(fn){
  if (typeof fn !== 'function') return;
  _piaDomQ.push(fn);
  var now = Date.now(); if (!_piaDomT0) _piaDomT0 = now;
  if (_piaDomT) clearTimeout(_piaDomT);
  _piaDomT = setTimeout(piaDomFlush, Math.max(0, Math.min(300, _piaDomT0 + 1500 - now)));
}
window.piaDomFlush = piaDomFlush; window.piaDomBatch = piaDomBatch;
async function fillAiSummary(audience, d){
  const card = el('ai-summary-card');
  if(!card) return;
  const sig = aiSummarySignature(d);
  if(sig !== _aiSumSig){ _aiSumSig = sig; _aiSumCache = {}; }
  function render(text, src){
    card.innerHTML = '<div class="flex items-center justify-between mb-1"><div class="font-bold text-violet-900">' + (src==='ai' ? _T('🤖 AI가 쓴 참고 문장 — 아래 점수가 기준입니다','🤖 AI-written reference text \u2014 the scores below are the basis') : _T('📋 점수 기반 종합 요약','📋 Score-based summary')) + '</div>'
      + '<span class="pill ' + (src==='ai'?'bg-emerald-100 text-emerald-800':'bg-slate-200 text-slate-700') + ' text-[10px] whitespace-nowrap">' + (src==='ai'?_T('AI 생성','AI Generated'):_T('기본 요약','Basic Summary')) + '</span></div>'
      + '<div class="text-sm text-slate-700 leading-relaxed" id="ai-sum-body"></div>'
      + '<button id="ai-sum-regen" class="mt-2 text-xs text-violet-700 hover:underline">' + _T('↻ 다시 생성','↻ Regenerate') + '</button>'
      + (window.aipiaCurrentLang==='en' ? '' : '<button id="ai-sum-translate" class="mt-2 ml-3 text-xs text-sky-700 hover:underline">🌐 영어로</button>');
    var _asb=el('ai-sum-body'); if(_asb) _asb.innerHTML=_piaMdSafe(text);
    const btn = el('ai-sum-regen');
    if(btn) btn.addEventListener('click', function(){ delete _aiSumCache[_aiSumKey(audience)]; card.innerHTML='<div class="text-xs text-violet-900">' + _T('🤖 다시 생성 중…','🤖 Regenerating…') + '</div>'; fillAiSummary(audience, d); });
    const tb = el('ai-sum-translate');
    if(tb) tb.addEventListener('click', async function(){
      tb.textContent='번역 중…';
      try {
        const q = String(text).replace(/[#*_]+/g,'').slice(0,480);
        const r = await fetch(PIA_CHAT_PROXY + '&task=tr&langpair=ko%7Cen&q=' + encodeURIComponent(q));
        const j = await r.json();
        const en = j && j.responseData && j.responseData.translatedText;
        if(en){ const p=document.createElement('p'); p.className='text-xs text-slate-500 mt-2 italic'; p.textContent='EN: ' + en; card.appendChild(p); tb.remove(); }
        else { tb.textContent='🌐 번역 실패'; }
      } catch(e){ tb.textContent='🌐 번역 실패'; }
    });
  }
  if(_aiSumCache[_aiSumKey(audience)]){ render(_aiSumCache[_aiSumKey(audience)], 'ai'); return; }
  const sys = (window.aipiaCurrentLang==='en')
    ? 'You are a friendly assistant who explains assessment results simply. Answer only in English, in a warm and accurate tone.'
    : '너는 검사 결과를 쉽게 풀어주는 친근한 도우미야. 한국어(한글)로만, 밝고 따뜻하고 정확하게 답해. 한자·외국 문자 금지.';
  const prompt = buildSummaryPrompt(audience, d);
  let out = null;
  try {
    const mode = (state.cfg && state.cfg.mode) || 'LOCAL';
    // [엔진 우선순위] AI 종합 요약도 워커(자동 무료·6공급자 회전)를 먼저 사용 → 키 한도(429) 노출 방지
    out = await callLLMFree(prompt, sys, null, { max_tokens: 700 });
    // 워커가 비었을 때만, 사용자가 직접 넣은 키 엔진을 최후 폴백
    if((!out || !out.trim()) && (mode !== 'LOCAL' && mode !== 'AUTO_FREE')) { out = await callLLM(prompt, sys); }
    // 한자·외국문자 혼입 방지: 1회 재생성 → 실패 시 정제
    if(window.aipiaCurrentLang!=='en' && out && out.trim() && typeof _isKoreanReply==='function' && !_isKoreanReply(out)){
      var _kr2=null; try{ _kr2=await callLLMFree(prompt, sys+'\n\n[중요] 직전 답에 한글이 아닌 문자가 섞였다. 한자·외국어를 모두 빼고 자연스러운 한국어로만 다시 써.'); }catch(e){}
      if(_kr2 && _kr2.trim() && _isKoreanReply(_kr2)) out=_kr2;
      else if(typeof _stripForeign==='function') out=_stripForeign(out);
    }
  } catch(e) { out = null; }
  /* [2026-09-26] 영어 모드인데 한국어로 답하면 1회 재요청, 그래도 한국어면 영어 기본 요약 */
    if(window.aipiaCurrentLang==='en' && out && _piaMostlyHangul(out)){
      var _en2=null; try{ _en2=await callLLMFree(prompt, sys+'\n\nIMPORTANT: Your previous answer was not in English. Reply again in English only.'); }catch(e){}
      out=(_en2 && !_piaMostlyHangul(_en2)) ? _en2 : null;
    }
  if(out && out.trim()){
    out = _piaTrimSentence(out.trim());
    /* [2026-11-02] 결과지 신뢰성 ①-4: AI 문장 속 숫자·흥미 1순위·성격 높낮이를 실제 점수와 대조한다.
       하나라도 어긋나면 AI 문장을 버리고 점수 기반 요약을 보인다(js/pia-ai-check.js). */
    try{
      if (typeof window.piaAiTextCheck === 'function'){
        var _ck = window.piaAiTextCheck(out, { big5: d.big5, riasec: d.riasec, type: d.type,
          typeNames: (typeof PIA_TYPES !== 'undefined' && Array.isArray(PIA_TYPES)) ? PIA_TYPES.map(function(t){ return t && t.name; }) : [] });
        if (!_ck.ok){ if (!window.__piaAiMismatchLogged){ window.__piaAiMismatchLogged = 1; console.warn('AI 해석 대조 불일치', _ck.reasons); } out = null; }
      }
      /* [2026-11-02] 대화 신뢰성 ③ — 근거(점수 'N점' 또는 학생 말 인용)가 없는 문장은 뺀다. 남는 문장이 2개 미만이면 점수 기반 요약 */
      if (out && window.piaAiTextCheck && typeof window.piaAiTextCheck.evidence === 'function'){
        var _ev = window.piaAiTextCheck.evidence(out, { said: [], big5: d.big5, riasec: d.riasec, via: d.via, grit: state.results.grit && state.results.grit.scores });
        if (_ev && !_ev.ok) out = (_ev.kept.length >= 2) ? _ev.kept.join(' ') : null;
      }
    }catch(e){}
  }
  if(out && out.trim()){ _aiSumCache[_aiSumKey(audience)] = out; piaDomBatch(function(){ if (document.body.contains(card)) render(out, 'ai'); }); }
  else { piaDomBatch(function(){ if (document.body.contains(card)) render(localSummary(audience, d), 'local'); }); }
}

function renderStudentBrief(via, type) {
  const top = viaTopKeys(via, 3);
  const _vr = viaRank(via);
  return '<div class="bg-white rounded-2xl border border-slate-200 p-4">'
    + '<h3 class="font-semibold text-sm mb-2">나의 핵심 강점</h3>'
    + (top.length ? '<div class="flex flex-wrap gap-2 mb-2">' + top.map(function(t){return '<span class="pill bg-emerald-100 text-emerald-800">'+_viaName(t)+'</span>';}).join('') + '</div>' : '')
    + (_vr && _vr.flat ? '<p class="text-xs text-amber-700 mb-2">' + viaRankNote(_vr, 3) + '</p>' : '')
    + '<p class="text-sm text-slate-700 leading-relaxed">너는 <strong>' + ((type&&type.name)||'성장형') + '</strong>! ' + ((type&&type.desc)||'') + ' 위 강점을 하루 한 번 의도적으로 써보면 더 빛날 거야.</p>'
    + '<p class="text-xs text-slate-400 mt-2">더 자세한 분석은 부모님·선생님용 결과지에서 볼 수 있어요.</p>'
    + '</div>';
}
function counselLocal(d) {
  const t = d.type || {};
  const strengths = (d.viaTop || []).slice(0,2).join('·') || '강점';
  let s = '교사: "' + (d.sid||'OO') + ' 학생은 검사에서 \'' + (t.name||'성장형') + '\' 유형으로 나왔어요. ' + (t.desc||'') + '"\n'
    + '부모: "그렇군요. 집에서는 무엇을 도와주면 좋을까요?"\n'
    + '교사: "먼저 ' + strengths + ' 같은 강점을 구체적으로 칭찬해 주세요. 성장 포인트는 한 번에 한 가지만 부드럽게 권해보시는 걸 추천드립니다."\n'
    + '부모: "진로는 어떻게 이야기하면 좋을까요?"\n'
    + '교사: "정답을 정하기보다, 아이가 흥미를 보인 분야를 함께 탐색해 보시는 게 좋아요. 아이 속도를 존중해 주세요."';
  if (d.anyHigh) s += '\n교사: "정서 선별에서 주의가 필요한 신호가 있어, 필요하시면 Wee클래스·청소년상담 1388 연계도 함께 안내드리겠습니다."';
  return s;
}
function buildCounselPrompt(d) {
  const t = d.type || {}, b = d.big5;
  let info = '학생 통합유형: ' + (t.name||'') + ' (' + (t.desc||'') + ').';
  if (b) info += ' Big5 외향' + b.E + '/우호' + b.A + '/성실' + b.C + '/정서안정' + (100-b.N) + '/개방' + b.O + '.';
  if (d.viaTop && d.viaTop.length) info += ' 대표강점: ' + d.viaTop.join(', ') + '.';
  info += d.anyHigh ? ' 정서 선별에서 주의(HIGH) 신호 있음.' : ' 정서 선별은 대체로 양호.';
  const langInstr2 = (window.aipiaCurrentLang==='en') ? 'Write only in English, keeping the "Teacher:" / "Parent:" labels in English.' : '"교사:"와 "부모:" 라벨을 번갈아 붙여 한국어로만.';
  return '다음 검사 결과에 맞춰, 담임 교사가 학부모 상담에서 바로 활용할 수 있는 대화 예시를 만들어줘.\n' + info
    + '\n\n' + langInstr2 + ' 5~7줄로, 강점 인정 → 가정 지원 제안 → (필요시) 정서 지원 안내 흐름으로 써줘. 진단·단정 표현은 피하고 따뜻하고 구체적으로.';
}
async function fillCounselScript(d) {
  const card = el('counsel-card');
  if (!card) return;
  function render(text, src) {
    card.innerHTML = '<div class="flex items-center justify-between mb-1"><div class="font-bold text-amber-900">' + _T('🗣️ 결과 맞춤 학부모 상담 예시','🗣️ Sample Parent-Teacher Conference Script') + '</div>'
      + '<span class="pill ' + (src==='ai'?'bg-emerald-100 text-emerald-800':'bg-slate-200 text-slate-700') + ' text-[10px]">' + (src==='ai'?_T('AI 생성','AI Generated'):_T('기본 예시','Sample Script')) + '</span></div>'
      + '<div class="text-sm text-slate-700 leading-relaxed" id="counsel-body"></div>'
      + '<button id="counsel-regen" class="mt-2 text-xs text-amber-800 hover:underline">' + _T('↻ 다시 생성','↻ Regenerate') + '</button>';
    var _cb=el('counsel-body'); if(_cb) _cb.innerHTML=_piaMdSafe(text);
    const b = el('counsel-regen');
    if (b) b.addEventListener('click', function(){ card.innerHTML='<div class="text-xs text-amber-900">' + _T('🗣️ 다시 생성 중…','🗣️ Regenerating…') + '</div>'; fillCounselScript(d); });
  }
  let out = null;
  const _counselSys = (window.aipiaCurrentLang==='en')
    ? 'You are an assistant helping a school counselor. Write only in English, warmly and practically.'
    : '너는 학교 상담교사를 돕는 도우미야. 반드시 한국어로만 작성하고, 중국어·영어·다른 언어나 메타설명을 절대 쓰지 마. 따뜻하고 실용적으로.';
  try { out = await callLLMFree(buildCounselPrompt(d), _counselSys, null, { max_tokens: 900 }); } catch(e) { out = null; }
  if (window.aipiaCurrentLang==='en' && out && _piaMostlyHangul(out)) {
    var _c2=null; try { _c2 = await callLLMFree(buildCounselPrompt(d), _counselSys + '\n\nIMPORTANT: English only.'); } catch(e) {}
    out = (_c2 && !_piaMostlyHangul(_c2)) ? _c2 : null;
  }
  piaDomBatch(function(){
    if (!document.body.contains(card)) return;
    if (out && out.trim() && (window.aipiaCurrentLang==='en' || _counselKoreanOK(out))) render(_piaTrimSentence(out.trim()), 'ai');
    else if (window.aipiaCurrentLang==='en') render('Teacher: Thank you for coming in. Your child shows real strengths, and we see them at school too.\nParent: Thank you, that is good to hear.\nTeacher: At home, praising the process more than the result will help a lot.\nTeacher: If you notice any changes in mood, let us talk anytime — we will support them together.', 'local');
    else render(counselLocal(d), 'local');
  });
}
// AI 출력이 한국어로 깨끗한지 검증 — 중국어(한자)·비한국어 혼입 시 거부
function _counselKoreanOK(t){
  if(!t) return false;
  var cjk=(t.match(/[一-鿿]/g)||[]).length;   // 중국어 한자
  var han=(t.match(/[가-힣]/g)||[]).length;   // 한글 음절
  if(cjk>2) return false;      // 한자 다수 → 중국어 혼입으로 판단, 거부
  if(han<30) return false;     // 한글이 지나치게 적음 → 거부
  if(/[぀-ヿ]/.test(t)) return false; // 일본어 가나 혼입 거부
  return true;
}

function renderDetailedResult() {
  var _plD = (window.aipiaCurrentLang === 'en');
  const big5 = state.results.big5.scores;
  const riasec = state.results.riasec.scores;
  const via = state.results.via.scores;
  const reliability = calcReliability();
  const type = inferIntegratedType();
  const sid = state.studentId || 'S001';

  const greetingEl = el('audience-greeting');
  if (greetingEl) greetingEl.innerHTML = audienceGreeting(currentAudience, type, sid);
  const guideEl = el('audience-guide');
  if (guideEl) { guideEl.classList.remove('hidden'); guideEl.innerHTML = audienceGuide(currentAudience, type, reliability); }

  const big5C   = big5   ? piaAcc(_T('🧠 성격 5요인(Big5) 상세 보기','🧠 View Big5 Personality Detail'), renderBig5Detailed(big5)) : '';
  const riasecC = riasec ? piaAcc(_T('🧭 RIASEC 진로 흥미 상세 보기','🧭 View RIASEC Career Interest Detail'), renderRiasecDetailed(riasec)) : '';
  const viaC    = via    ? piaAcc(_T('💎 24개 강점(VIA) 전체 순위 보기','💎 View Full VIA 24-Strengths Ranking'), renderVIADetailed(via)) : '';
  const careerC = piaAcc(_T('💼 추천 진로 상세 보기 (커리어넷 데이터)','💼 View Recommended Career Detail (Career.net Data)'), renderCareerDetailed(type, currentAudience));
  const actionsC= piaAcc(_T('✅ 맞춤 실천 가이드 보기','✅ View Personalized Action Guide'), renderAudienceActions(currentAudience, type), { open: true });
  const _cesd = state.results.cesd.scores, _phqa = state.results.phqa.scores, _gad = state.results.gad.scores;
  const anyHigh = (_cesd && _cesd.level==='HIGH') || (_phqa && _phqa.level==='HIGH') || (_gad && _gad.level==='HIGH') || (_phqa && _phqa.selfHarm>0);
  const viaTop = viaTopKeys(via, 3);

  // ===== 청중별로 구성·순서·강조를 다르게 =====
  let detailedHTML = audienceBanner(currentAudience);
  detailedHTML += '<div id="ai-summary-card" class="rounded-2xl border border-violet-200 bg-violet-50 p-4 mb-5"><div class="text-xs text-violet-900">' + _T('🤖 AI 종합 해석 생성 중…','🤖 Generating AI comprehensive interpretation…') + '</div></div>';
  if (currentAudience === 'student') {
    // 강점 먼저 → 흥미 → 성격 → 진로 → 실천 → 마음체크
    // 아이에게는 핵심만 간략히 (상세 표는 부모·교사용에서)
    detailedHTML += renderStudentBrief(via, type) + actionsC + audienceScreeningNote('student');
  } else if (currentAudience === 'parent') {
    // 성격 이해 → 흥미 → 강점 → 진로 → 정서안내 → 가정 실천
    detailedHTML += big5C + riasecC + viaC + careerC + audienceScreeningNote('parent') + actionsC;
  } else {
    // 교사: 근거(신뢰도) → 차원 상세 → 진로 → 정서 상세 → 지도 액션
    var _vgL = (reliability.validity && (reliability.validity.gradeLabel||reliability.validity.grade));
    detailedHTML += `<div class="rounded-2xl border border-slate-200 bg-white p-4">
        <h3 class="font-semibold text-sm mb-2">${_T('결과 해석 등급·근거','Interpretation Grade & Basis')}</h3>
        <p class="text-sm text-slate-700">${_T('해석 등급 ','Interpretation Grade ')}<strong>${reliability.grade}</strong> (${reliability.label})${piaRelFrag(reliability, true)} ${_T('· 완료 검사: ','\u00b7 Completed Tests: ')}${(reliability.completed&&reliability.completed.join(', '))||_T('없음','None')}${reliability.screening&&reliability.screening.length?_T(' · 스크리닝: ',' \u00b7 Screening: ')+reliability.screening.join(', '):''}</p>
        ${reliability.validity && reliability.validity.reason ? '<p class="text-xs text-slate-500 mt-1">'+_T('응답 성실도 근거: ','Response validity basis: ')+reliability.validity.reason+'</p>' : ''}
        ${reliability.capped ? '<p class="text-xs text-amber-700 mt-1">'+_T('해석 등급은 검사 완료도('+reliability.completionGrade+')에 응답 성실도 결과로 상한을 둔 값입니다(주의 → 최대 B, 낮음 → 최대 C).','The interpretation grade is the completion grade ('+reliability.completionGrade+') capped by response validity (Caution \u2192 at most B, Low \u2192 at most C).')+'</p>' : ''}
        <p class="text-xs text-slate-500 mt-1">${_T('점수는 본인 응답을 0–100으로 환산한 값(또래 비교 아님)이며, 학생 평가·서열화 도구가 아닙니다. 24 강점은 강점당 1문항이라 1~5 원점수와 본인 안에서의 상대 순위로 표시합니다.','Scores convert the student\'s own answers to a 0\u2013100 scale (not a peer comparison); this is not a tool for ranking or evaluating students. The 24 strengths use one item each, so they are shown as raw 1\u20135 scores and a within-person rank.')}</p>
      </div>` + big5C + riasecC + viaC + careerC + audienceScreeningNote('teacher') + '<div id="counsel-card" class="mt-5 rounded-2xl border border-amber-200 bg-amber-50 p-4"><div class="text-xs text-amber-900">' + _T('🗣️ 결과 맞춤 학부모 상담 예시 생성 중…','🗣️ Generating a personalized parent counseling script…') + '</div></div>' + actionsC;
  }

  /* [2026-10-04] AI 대화에서 보인 관심·강점(정리본, 원문 없음). 대화는 끝났는데 정리가 아직 없으면 한 번만 만들어 다시 그린다. */
  try {
    var _csHtml = renderConvSummaryCard();
    if (_csHtml) detailedHTML += piaAcc(_T('💬 AI 대화에서 보인 관심·강점 보기', '💬 View interests & strengths from the AI conversation'), _csHtml, { open: true });
    else if (state.results.conv.turns >= 12 && !window.__piaConvSumTried && !/[?&]sample=1/.test(location.search)) {   /* 샘플 미리보기에서는 AI 를 부르지 않는다 */
      window.__piaConvSumTried = true;
      aiSummarizeConv().then(function (r) { if (r) { try { renderDetailedResult(); } catch (e) { console.error('[결과지] 다시 그리기 실패', e); } } });
    }
  } catch (e) { console.error('[결과지] 대화 정리 표시 실패', e); }

  /* [2026-11-02] 대화 신뢰성 — 주제별 해석·근거 인용·검사 대조·재현 일치·대화 성실도(pia-chat-trust.js). 해석이 아직 없으면 한 번만 만든다. */
  try {
    if (window.piaChatTrust && state.results.conv && state.results.conv.turns >= 12) {
      var _ctHtml = renderConvTrustCard();
      if (_ctHtml) detailedHTML += piaAcc(_T('🧭 AI 대화 해석(근거·검사 대조) 보기', '🧭 View AI conversation interpretation (evidence & test check)'), _ctHtml, { open: true });
      else if (!window.__piaChatTrustTried && !/[?&]sample=1/.test(location.search)) {
        window.__piaChatTrustTried = true;
        piaChatTrustInterpret().then(function (r) { if (r) { try { renderDetailedResult(); } catch (e) { console.error('[결과지] 다시 그리기 실패', e); } } });
      }
    }
  } catch (e) { console.error('[결과지] 대화 해석 표시 실패', e); }

  // 자유대화 발화 원문 인용 — 본인(student) 화면에만 노출한다(그것도 기본 접힘).
  // 학생이 대화 중에 쓴 원문 그대로를 넘기는 것이라, 학부모·교사 공유본에는
  // 기본적으로 포함하지 않는다. (QA 2026-08-22: "학부모/교사 공유본은 기본 제외")
  const transcript = state.results.conv.transcript || [];
  /* [2026-11-02] 자유대화 위기 신호 → 선생님용 '상담 필요' 알림. 원문은 넣지 않는다(차례 수만). */
  if (currentAudience === 'teacher') { try { var _cz = piaConvCounselNeed(); if (_cz) detailedHTML = '<div role="alert" class="pia-counsel-need mt-3 mb-3 rounded-2xl border-2 border-rose-300 bg-rose-50 p-4 text-sm text-rose-900"><strong class="block mb-1">' + _T('⚠ 상담 필요', '⚠ Counseling needed') + '</strong>' + _T('AI 자유대화 중 안전 위험 신호가 ', 'Safety risk signals were detected ') + _cz.count + _T('차례 감지되어 위기 안내(1388·109)를 했습니다. ', ' time(s) during the AI chat and crisis guidance (1388/109) was given. ') + (_cz.selfharm ? _T('자해·자살 관련 신호가 포함되어 있습니다. ', 'This includes self-harm/suicide-related signals. ') : '') + _T('오늘 안에 학생과 직접 면담하고, 학교 위기관리 절차(Wee클래스·보호자 연계)를 확인해 주세요.', "Please talk with the student in person today and follow the school's crisis procedure (Wee Class, guardian).") + '<div data-pia-counsel-contacts>' + piaCounselContactsHTML(null) + '</div></div>' + detailedHTML; setTimeout(piaCounselNoticeFill, 0); } catch (e) { console.error('[결과지] 상담 필요 알림 실패', e); } }
  if (currentAudience === 'teacher') { var _abz = (state.results.conv.transcript||[]).filter(function(t){ return t && (t.abusive || t.risk==='HIGH'); }); if (_abz.length) { var _abq = _abz.map(function(t){ var _tag = t.abusive ? _T('[욕설]','[Profanity]') : _T('[민감]','[Sensitive]'); return '<blockquote class="border-l-4 border-rose-400 pl-3 py-1 italic text-rose-700 text-sm mb-2"><b>'+_tag+'</b> "'+_escHtml(t.msg||'')+'"</blockquote>'; }).join(''); detailedHTML += piaAcc(_T('⚠️ 부적절·민감 발화 기록 (교사 확인용)','⚠️ Inappropriate/Sensitive Speech Log (For Teacher Review)'), '<div class="bg-white rounded-2xl border border-rose-200 p-4"><h3 class="font-semibold text-sm mb-3 text-rose-700">'+_T('욕설·비방·민감 발화 ','Profanity/insults/sensitive speech: ')+_abz.length+_T('건','instances')+'</h3>'+_abq+'<p class="text-xs text-slate-500 mt-2">'+_T('대화 중 감지된 부적절·민감 표현입니다.','Inappropriate or sensitive expressions detected during the conversation.')+'</p></div>'); } }
  if (transcript.length > 0 && currentAudience === 'student') {
    const quotes = transcript.slice(0,3).map(t => `<blockquote class="border-l-4 border-slate-300 pl-3 py-1 italic text-slate-700 text-sm mb-2">"${_escHtml(t.msg)}"</blockquote>`).join('');
    detailedHTML += piaAcc(_T('💬 자유대화 발화 인용 보기 (분석 근거)','💬 View Free Conversation Quotes (Analysis Basis)'), `<div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-3">${_T('자유대화 발화 인용 (분석 근거)','Free Conversation Quotes (Analysis Basis)')}</h3>
      ${quotes}
      <p class="text-xs text-slate-500 mt-2">${_T('실제 응답자의 발화에서 분석 근거를 직접 확인할 수 있습니다.',"You can directly verify the analysis basis from the respondent's actual statements.")}</p>
    </div>`);
  }

  detailedHTML += piaAcc(_T('📚 분야별 학습·역량(자가평가) 보기','📚 View Subject Learning & Competency (Self-Assessment)'), renderLearnCard(), { mt: false });
  detailedHTML += piaAcc(_T('🧩 다중지능(MI) 8지능 보기','🧩 View Multiple Intelligences (MI) — 8 Types'), renderMiCard(), { mt: false });
  detailedHTML += piaAcc(_T('🌤️ 웰빙·자존감 추가척도 보기','🌤️ View Well-Being & Self-Esteem Additional Scales'), renderExtraScales(), { mt: false });
  var _vgL2 = (reliability.validity && (reliability.validity.gradeLabel||reliability.validity.grade));
  var _audLbl = currentAudience==='student' ? (selfIsAdult() ? _T('본인용(일반)','Self (General)') : _T('학생 본인용','For the Student')) : currentAudience==='parent' ? _T('학부모용','For Parents') : _T('선생님용','For Teachers');
  var _issuedDate = _plD ? new Date().toLocaleString('en-US') : new Date().toLocaleString('ko-KR');
  detailedHTML += `<div class="mt-5 bg-slate-50 border border-slate-200 rounded-2xl p-4 text-xs text-slate-600">
    <strong>${_T('고지사항:','Notice:')}</strong> ${_T('본 검사는 의료·임상 진단이 아닌 교육·진로·자기이해를 위한 참고용 성장분석 도구입니다.','This assessment is not a medical or clinical diagnosis. It is a reference growth-analysis tool for education, career guidance, and self-understanding.')}
    ${_T('위험 신호 감지 시 즉시 학교 상담교사, 청소년상담 1388, 정신건강위기 1577-0199, 자살예방상담 109 등을 이용해 주세요.','If warning signs are detected, please contact your school counselor, Youth Counseling 1388, Mental Health Crisis 1577-0199, or Suicide Prevention 109 right away.')}
    <br><br>
    <strong>${_T('발급일:','Issued:')}</strong> ${_issuedDate} · <strong>${selfIsAdult()?_T('응시자ID','Examinee ID'):_T('학생ID','Student ID')}:</strong> ${_escHtml(sid)} · <strong>${_T('대상:','Audience:')}</strong> ${_audLbl} · <strong>${_T('신뢰도:','Reliability:')}</strong> ${reliability.grade} (${reliability.label})${reliability.capped ? _T(' · 검사 완료도 ',' \u00b7 Completion ')+reliability.completionGrade : ''}${reliability.validity && reliability.validity.grade && reliability.validity.grade!=='-' ? _T(' · <strong>응답 성실도:</strong> ',' \u00b7 <strong>Response Validity:</strong> ')+_vgL2 : ''}
  </div>`;

  let container = el('detailed-result');
  if (!container) {
    container = document.createElement('div');
    container.id = 'detailed-result';
    container.className = 'space-y-0';
    const safe = el('safety-banner');
    const parent = safe?.parentNode;
    if (parent) parent.appendChild(container);
  }
  container.innerHTML = detailedHTML;
  try { fillAiSummary(currentAudience, { big5:big5, riasec:riasec, via:via, type:type, reliability:reliability }); } catch(e) {}
  if (currentAudience === 'teacher') { try { fillCounselScript({ type:type, big5:big5, viaTop:viaTop, anyHigh:anyHigh, sid:sid }); } catch(e) {} }
}

// 텍스트 형식 결과지 생성 (다운로드용)
function buildResultText() {
  var _plX = (window.aipiaCurrentLang === 'en');
  const big5 = state.results.big5.scores;
  const riasec = state.results.riasec.scores;
  const via = state.results.via.scores;
  const grit = state.results.grit.scores;
  const cesd = state.results.cesd.scores;
  const phqa = state.results.phqa.scores;
  const gad = state.results.gad.scores;
  const reliability = calcReliability();
  const type = inferIntegratedType();
  const sid = state.studentId || 'S001';
  const _tName = (typeof _typeField==='function') ? _typeField(type,'name') : type.name;
  const _tDesc = (typeof _typeField==='function') ? _typeField(type,'desc') : type.desc;

  const audienceTitle = currentAudience === 'student' ? (selfIsAdult()?_T('본인용(일반)','Self (General)'):_T('학생 본인용','For the Student')) : currentAudience === 'parent' ? _T('학부모용','For Parents') : _T('선생님용','For Teachers');

  const lines = [];
  lines.push('========================================');
  lines.push(_T('  예담 톡 통합 검사 결과지 (','  YEDAM Talk Integrated Assessment Report (') + audienceTitle + ')');
  lines.push('========================================');
  lines.push(_T('발급일: ','Issued: ') + (_plX ? new Date().toLocaleString('en-US') : new Date().toLocaleString('ko-KR')));
  lines.push(_T('학생ID: ','Student ID: ') + sid);
  lines.push(_T('해석 등급: ','Interpretation grade: ') + `${reliability.grade} (${reliability.label})` + _T(' · 검사 완료도 ',' \u00b7 Completion ') + reliability.completionGrade);
  if (reliability.validity && reliability.validity.grade && reliability.validity.grade !== '-') lines.push(_T('응답 성실도: ','Response Validity: ') + `${reliability.validity.gradeLabel||reliability.validity.grade}${reliability.validity.reason?' \u2014 '+reliability.validity.reason:''}`);
  lines.push(_T('완료 검사: ','Completed Tests: ') + (reliability.completed.join(', ') || _T('없음','None')));
  lines.push(_T('정서 스크리닝: ','Emotional Screening: ') + (reliability.screening.join(', ') || _T('미실시','Not conducted')));
  lines.push('');
  lines.push(_T('■ 통합 16유형','■ Integrated 16 Types'));
  lines.push(`  ${type.icon} ${_tName} (${type.code})`);
  lines.push(`  ${_tDesc}`);
  lines.push('');
  if (big5) {
    lines.push(_T('■ Big5 성격 5요인 (IPIP-50)','■ Big5 Personality Factors (IPIP-50)'));
    lines.push(_T('  외향성(E): ','  Extraversion (E): ') + `${big5.E}${_T('점',' pts')} \u2014 ${big5Interp('E', big5.E)}`);
    lines.push(_T('  우호성(A): ','  Agreeableness (A): ') + `${big5.A}${_T('점',' pts')} \u2014 ${big5Interp('A', big5.A)}`);
    lines.push(_T('  성실성(C): ','  Conscientiousness (C): ') + `${big5.C}${_T('점',' pts')} \u2014 ${big5Interp('C', big5.C)}`);
    lines.push(_T('  정서안정: ','  Emotional Stability: ') + `${100-big5.N}${_T('점',' pts')} \u2014 ${big5Interp('N', big5.N)}`);
    lines.push(_T('  개방성(O): ','  Openness (O): ') + `${big5.O}${_T('점',' pts')} \u2014 ${big5Interp('O', big5.O)}`);
    lines.push('');
  }
  if (riasec) {
    const sorted = Object.entries(riasec).sort((a,b)=>b[1]-a[1]);
    lines.push(_T('■ RIASEC 진로 흥미','■ RIASEC Career Interest'));
    lines.push(_T('  Holland 코드: ','  Holland Code: ') + sorted.slice(0,3).map(e=>e[0]).join(''));
    sorted.forEach(e => lines.push(`  ${e[0]}: ${e[1]}${_T('점',' pts')}`));
    lines.push('');
  }
  if (via) {
    const _vr = viaRank(via);
    lines.push(_T('■ 24 강점 (상위 10, 1~5점 · 본인 평균 대비 수준)','■ 24 Strengths (Top 10, 1\u20135 \u00b7 level vs. your own average)'));
    if (_vr) _vr.items.slice(0,10).forEach((it) => lines.push(`  ${viaRankLabel(it)} ${_viaName(it.k)} (${it.raw}/5 \u00b7 ${viaLevelLabel(it.level)})`));
    if (_vr && viaRankNote(_vr, 10)) lines.push('  ※ ' + viaRankNote(_vr, 10));
    lines.push('');
  }
  if (grit) {
    lines.push(_T('■ 끈기·근면 척도','■ Grit & Perseverance Scale'));
    lines.push(_T('  전체: ','  Overall: ') + `${grit.overall}` + _T(' / 끈기: ',' / Perseverance: ') + `${grit.perseverance}` + _T(' / 열정 일관성: ',' / Consistency of Passion: ') + `${grit.passion}`);
    lines.push('');
  }
  if (cesd || phqa || gad) {
    lines.push(_T('■ 정서 스크리닝','■ Emotional Screening'));
    if (cesd) lines.push(_T('  CES-D-10 우울: ','  CES-D-10 Depression: ') + `${cesd.total}${_T('점',' pts')} (${cesd.level})`);
    if (phqa) lines.push(_T('  PHQ-A 청소년 우울: ','  PHQ-A Youth Depression: ') + `${phqa.total}${_T('점',' pts')} (${phqa.level})${phqa.selfHarm>0?_T(' ⚠ 자해 신호',' \u26a0 Self-harm signal'):''}`);
    if (gad) lines.push(_T('  GAD-7 불안: ','  GAD-7 Anxiety: ') + `${gad.total}${_T('점',' pts')} (${gad.level})`);
    lines.push('');
  }
  lines.push(_T('■ 추천 진로 (PIA 16유형 + RIASEC 기반)','■ Recommended Careers (Based on PIA 16 Types + RIASEC)'));
  type.careers.forEach((c, i) => {
    var _infoEn = (_plX && typeof CAREER_DATABASE_EN!=='undefined') ? CAREER_DATABASE_EN[c] : null;
    lines.push(`  ${i+1}. ${_infoEn ? _infoEn.title : c}`);
    const info = _infoEn || (typeof getCareerInfo === 'function' ? getCareerInfo(c) : null);
    if (info) {
      lines.push(`     - ${info.description}`);
      lines.push(_T('     - 연봉: ','     - Salary: ') + info.salary);
      lines.push(_T('     - 관련 학과: ','     - Related Majors: ') + (info.relatedMajors||info.majors||[]).join(', '));
    }
  });
  lines.push('');
  var _licTbl = (_plX && typeof LICENSE_BY_TYPE_EN!=='undefined') ? LICENSE_BY_TYPE_EN : LICENSE_BY_TYPE;
  if (typeof _licTbl !== 'undefined' && _licTbl[type.code]) {
    lines.push(_T('■ 추천 자격증: ','■ Recommended Certifications: ') + _licTbl[type.code].join(', '));
    lines.push('');
  }
  lines.push(_T('■ 안전 안내','■ Safety Notice'));
  lines.push(_T('  본 검사는 의료·임상 진단이 아닌 참고용 성장분석 도구입니다.','  This assessment is not a medical or clinical diagnosis; it is a reference growth-analysis tool.'));
  lines.push(_T('  · 자살예방 109 · 정신건강위기 1577-0199 · 청소년상담 1388','  \u00b7 Suicide Prevention 109 \u00b7 Mental Health Crisis 1577-0199 \u00b7 Youth Counseling 1388'));
  lines.push(_T('  · Wee클래스(학교) · 카카오톡 청소년상담1388','  \u00b7 Wee Class (School) \u00b7 KakaoTalk Youth Counseling 1388'));
  lines.push('');
  lines.push('========================================');
  lines.push(_T('  예담 톡 성장교육 플랫폼 v3.2','  YEDAM Talk Growth Education Platform v3.2'));
  lines.push('========================================');

  return lines.join('\n');
}

// 결과지 인쇄/저장/복사 버튼 핸들러
function initResultActions() {
  const printBtn = el('result-print');
  const dlHtmlBtn = el('result-download-html');
  const dlTxtBtn = el('result-download-txt');
  const copyBtn = el('result-copy');

  if (printBtn) printBtn.addEventListener('click', () => piaPrintAsk());
  if (dlTxtBtn) dlTxtBtn.addEventListener('click', () => {
    const text = buildResultText();
    const blob = new Blob([text], { type:'text/plain;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `AI_PIA_결과지_${state.studentId||'S001'}_${currentAudience}_${Date.now()}.txt`;
    a.click();
  });
  if (dlHtmlBtn) dlHtmlBtn.addEventListener('click', () => {
    const html = `<!doctype html><html lang="ko"><head><meta charset="utf-8"><title>예담 톡 결과지</title>
      <style>body{font-family:'맑은 고딕',sans-serif;max-width:780px;margin:20px auto;padding:20px;line-height:1.6;color:#222}
      h1{color:#1F4E79}h2{color:#2E75B6;border-bottom:1px solid #ccc;padding-bottom:5px}
      .meta{background:#f7f8fa;padding:10px;border-radius:8px}pre{white-space:pre-wrap;font-family:inherit}</style>
      </head><body><h1>예담 톡 통합 검사 결과지</h1><pre>${buildResultText()}</pre></body></html>`;
    const blob = new Blob([html], { type:'text/html;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `AI_PIA_결과지_${state.studentId||'S001'}_${currentAudience}_${Date.now()}.html`;
    a.click();
  });
  if (copyBtn) copyBtn.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(buildResultText());
      copyBtn.textContent = '✓ 복사됨';
      setTimeout(() => copyBtn.textContent = '📋 복사', 2000);
    } catch(e) { alert('복사 실패: ' + e.message); }
  });

  // Audience 전환
  document.querySelectorAll('.aud-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      var _a=btn.dataset.audience;
      if(!audAllowed(_a)){ alert(_audKoName(_a)+' 화면은 해당 역할(로그인)로만 볼 수 있습니다.\n마이페이지에서 회원 유형을 설정하세요.'); return; }
      currentAudience = _a;
      document.querySelectorAll('.aud-btn').forEach(b => b.setAttribute('aria-selected', b === btn));
      renderDetailedResult();
    });
  });
}

// showView 확장 — result 진입 시 detailed 렌더링
const _origShow2 = showView;
showView = function(name) {
  _origShow2(name);
  if (name === 'result') {
    renderDetailedResult();
  }
};

initResultActions();

// =================================================================
//  TIPOSS 스타일 평가 분석 그래프 (참고)
//  - 개인 vs 소속평균(학급) vs 전체평균(예시)
//  - 평가항목별 인성점수·지능점수 막대
//  - 역량(현재) vs 기량(직무 적합도)
// =================================================================

// 시뮬레이션용 기준 평균 (실제 운영 시 누적 DB 기반)
/* [2026-11-02] 결과지 신뢰성: 학급·전체 평균을 고정 예시값(REFERENCE_NORMS)으로 그리던 비교 그래프 함수를 지웠다.
   (2026-09-20 부터 호출은 없었다.) 또래 비교는 실제 이용자 n≥30 일 때 /api/percentile 경로로만 보인다. */
// renderDetailedResult 확장: TIPOSS 스타일 그래프도 함께 렌더
const _origDetailed = renderDetailedResult;
renderDetailedResult = function() {
  _origDetailed();
  try{ piaRenderIssueFoot(); }catch(e){}
  /* [2026-09-20] TIPOSS 비교차트 제거 — 학급·전체 평균이 하드코딩 예시(REFERENCE_NORMS)라
     실제 비교가 아니었다. 함수 본체(renderTipossStyleCharts)는 두었다. 실 집계가 붙으면 되살린다. */
};

// =================================================================
//  결과지 대폭 확장 — 10개 신규 섹션
// =================================================================

// 인성교육진흥법 8대 덕목
const INSEONG_8 = [
  { name:'예(禮)', desc:'타인을 존중하고 예의를 지키는 마음', mapping:['우호','VIA-친절'] },
  { name:'효(孝)', desc:'부모·가족을 사랑하고 공경하는 마음', mapping:['우호','VIA-사랑'] },
  { name:'정직(正直)', desc:'거짓 없이 진실하게 행동하는 자세', mapping:['VIA-정직','성실'] },
  { name:'책임(責任)', desc:'맡은 일을 끝까지 해내는 자세', mapping:['성실','VIA-끈기'] },
  { name:'존중(尊重)', desc:'타인의 가치와 다양성을 인정하는 태도', mapping:['우호','VIA-공정'] },
  { name:'배려(配慮)', desc:'타인을 헤아리고 도우려는 마음', mapping:['우호','VIA-친절'] },
  { name:'소통(疏通)', desc:'서로의 생각과 감정을 나누는 능력', mapping:['외향','VIA-사회지능'] },
  { name:'협동(協同)', desc:'함께 목표를 이루기 위해 협력하는 자세', mapping:['우호','VIA-협력'] }
];

// 가드너 다중지능 8지능
const MULTI_INTEL = [
  { name:'언어 지능', icon:'📖', desc:'언어로 표현·이해·설득하는 능력', from:['VIA-학습열정','VIA-창의'] },
  { name:'논리·수학 지능', icon:'🔢', desc:'논리적 추론과 수학적 사고력', from:['Big5-O','VIA-판단'] },
  { name:'공간 지능', icon:'🗺️', desc:'시각적·공간적 정보 처리 능력', from:['RIASEC-A'] },
  { name:'음악 지능', icon:'🎵', desc:'리듬·음정·음색에 대한 감수성', from:['RIASEC-A','VIA-심미안'] },
  { name:'신체·운동 지능', icon:'🏃', desc:'몸을 통한 표현과 운동 능력', from:['RIASEC-R'] },
  { name:'대인 지능', icon:'🤝', desc:'타인의 감정·의도를 이해하는 능력', from:['VIA-사회지능','RIASEC-S'] },
  { name:'자기성찰 지능', icon:'🧘', desc:'자신의 내면을 이해하는 능력', from:['VIA-통찰','Big5-O'] },
  { name:'자연 지능', icon:'🌿', desc:'자연과 생물에 대한 이해', from:['RIASEC-I','VIA-호기심'] }
];

// 학습 스타일 VARK
const VARK_STYLES = [
  { code:'V', name:'시각형 (Visual)', icon:'👁️', desc:'그림·도표·다이어그램으로 학습이 잘 됨', tips:'마인드맵·인포그래픽·동영상 활용', from:['RIASEC-A','Big5-O'] },
  { code:'A', name:'청각형 (Auditory)', icon:'👂', desc:'듣기·토론·강의로 학습이 잘 됨', tips:'팟캐스트·강의·소그룹 토론 활용', from:['Big5-E','VIA-사회지능'] },
  { code:'R', name:'읽기/쓰기형 (Read/Write)', icon:'✏️', desc:'책·노트·텍스트로 학습이 잘 됨', tips:'독서·요약·자기 정리 노트', from:['Big5-O','VIA-학습열정'] },
  { code:'K', name:'실습형 (Kinesthetic)', icon:'🤲', desc:'직접 해보면서 학습이 잘 됨', tips:'실험·체험·역할극·메이커 활동', from:['RIASEC-R','Big5-C'] }
];

// 14일 학부모 코칭 플랜
const PARENT_14DAY = [
  { d:1, title:'결과지 함께 읽기', action:'자녀와 5~10분, 강점만 먼저 강조' },
  { d:2, title:'감정 단어 카드', action:'오늘 기분 한 단어로 표현하기' },
  { d:3, title:'성공 경험 기록', action:'올해 가장 뿌듯했던 일 3가지 적기' },
  { d:4, title:'관심 분야 탐색', action:'추천 진로 1개 관련 영상 함께 보기' },
  { d:5, title:'대화 시간 5분', action:'학교 이야기 짧게, 비판 없이 듣기' },
  { d:6, title:'산책 또는 운동', action:'30분 함께, 휴대폰 없이' },
  { d:7, title:'1주차 리뷰', action:'이번 주 가장 좋았던 순간 말하기' },
  { d:8, title:'성장 포인트 1개 선택', action:'결과지 성장 포인트 중 1개만 골라 시작' },
  { d:9, title:'작은 행동 실천', action:'선택한 성장 포인트의 1cm 행동' },
  { d:10, title:'독서·콘텐츠 추천', action:'PIA 추천 콘텐츠 1편 같이 시청' },
  { d:11, title:'친구 관계 점검', action:'친한 친구 1명 안부 묻기' },
  { d:12, title:'스트레스 환기', action:'좋아하는 활동 30분, 자녀와 함께' },
  { d:13, title:'미래 그려보기', action:'10년 후 나의 모습 한 문장으로' },
  { d:14, title:'2주차 리뷰', action:'한 달 후 다시 검사해 변화 확인 약속' }
];

// 12주 교사 학급 운영 가이드
const TEACHER_12WK = [
  { wk:1, title:'학급 분포 분석', action:'학생 16유형 분포 확인, 모둠 4유형 균등 배치' },
  { wk:2, title:'개별 면담 1라운드', action:'유형별 면담 우선순위 (감성·내향 우선)' },
  { wk:3, title:'시각자료 발표', action:'창의·자유유형 강점 살리는 발표 형식 도입' },
  { wk:4, title:'학급 강점 칭찬', action:'학급 공통 강점 1개 공개 칭찬' },
  { wk:5, title:'SEL 콘텐츠 5분', action:'에듀넷 사회정서교육 콘텐츠 매주 5분' },
  { wk:6, title:'위험 신호 모니터링', action:'CES-D·PHQ-A 결과 MEDIUM 이상 추적' },
  { wk:7, title:'학부모 1차 안내', action:'PIA 결과지 가정통신문 + 상담 신청' },
  { wk:8, title:'진로 콘텐츠 도입', action:'학생 RIASEC 상위 분야 영상 시청' },
  { wk:9, title:'모둠 재구성', action:'1차 모둠 평가 후 재배치' },
  { wk:10, title:'개별 면담 2라운드', action:'1차 면담 후 변화 확인' },
  { wk:11, title:'학급 반성 활동', action:'학생 스스로 한 학기 정리' },
  { wk:12, title:'결과 재검사·다음 학기', action:'2차 PIA 검사로 성장 확인' }
];

// 학년별 진학·진로 로드맵
// 초등 저학년(초3·초4)용 — 중학교 진학은 아직 멀어 '중1 준비'로 묶지 않는다.
// (QA 2026-08-22 P0-5: 초3 사용자에게 '중1 준비'가 뜨는 학년 계산 오류 수정)
const ROADMAP_ELEM_LOW = [
  '여러 분야를 두루 경험하며 좋아하는 것 찾아보기',
  '매일 20분씩 책 읽는 습관 만들기',
  '친구들과 함께하는 활동으로 사회성 기르기',
  'PIA 검사 결과로 나의 강점과 흥미 알아보기'
];

const ROADMAP_BY_GRADE = {
  중1: ['자유학기제 활용 — 다양한 직업 체험','관심 분야 1개 정해 책 5권 읽기','PIA 검사 결과로 강점 파악'],
  중2: ['고교 진학 정보 수집','희망 진로 분야 3개 좁히기','학교 동아리 적극 참여'],
  중3: ['고교 유형 선택 (일반·특목·특성화)','내신 관리 + 자기소개서 초안','PIA 재검사로 진로 재확인'],
  고1: ['선택과목 신중히 결정','관심 학과 5개 후보 정하기','대학·학과 정보 탐색'],
  고2: ['수시·정시 전략 수립','관심 학과 3개로 좁히기','관련 교내 활동 적극'],
  고3: ['최종 진학 결정','면접·자기소개서 준비','PIA 결과지 면접 활용']
};

// 성인·대학생용 진로·커리어 단계 로드맵 (학년 대신 시점 기준)
const ROADMAP_ADULT = {
  '현재 (자기점검)': ['PIA 결과로 강점·가치·흥미 정리','현재 역량과 목표 직무의 차이(갭) 파악','한 줄 커리어 비전 작성'],
  '단기 (3~6개월)': ['핵심 강점을 살릴 실전 과제·프로젝트 1개 시작','부족 역량 1개 학습 계획(강좌·자격증·독서)','이력서·포트폴리오·프로필 최신화'],
  '중기 (1~2년)': ['목표 분야 네트워킹·멘토 확보','이직·전환·창업 등 경로 구체화','성과를 수치로 기록해 포트폴리오 축적'],
  '장기 (3~5년)': ['전문성 심화 또는 분야 확장 결정','일·삶의 균형과 가치 정렬 재점검','PIA 재검사로 성향·목표 변화 확인']
};

// 추천 도서·영상·앱 (16유형별)
const RECOMMENDATIONS_BY_TYPE = {
  'EX-CR': {
    books:['데미안 (헤르만 헤세)','감정수업 (강신주)','연금술사 (파울로 코엘료)'],
    videos:['웹툰 작가가 되는 길 (KOCW)','내 마음 그리기 (EBS 다큐)'],
    apps:['SketchBook','ibisPaint','Procreate','감정 기록 다이어리'],
    activities:['하루 4컷 만화','감정 일기','북클럽']
  },
  'CR-EX': {
    books:['이상한 나라의 앨리스','코스모스 (칼 세이건)','메이커스 (크리스 앤더슨)'],
    videos:['TED 창의력','메이커 페어 영상'],
    apps:['Notion','Pinterest','Tinkercad'],
    activities:['브레인스토밍','메이커 활동','웹툰 창작']
  },
  'LO-AN': {
    books:['넛지','생각의 탄생','사피엔스'],
    videos:['Veritasium','과학동아 영상'],
    apps:['Khan Academy','Wolfram Alpha','Brilliant'],
    activities:['알고리즘 문제','과학 실험','독서 토론']
  },
  'EM-CO': {
    books:['아낌없이 주는 나무','비폭력 대화','함께라서 좋은 우리'],
    videos:['공감 콘텐츠','상담사 인터뷰'],
    apps:['감정 일기 앱','상담 챗봇'],
    activities:['또래상담','독서모임','봉사활동']
  },
  'EX-LE': {
    books:['그릿','아주 작은 습관의 힘','데일 카네기 인간관계론'],
    videos:['창업 다큐','TED 리더십'],
    apps:['Trello','Notion','Forest 집중'],
    activities:['프로젝트 리딩','동아리 회장','창업 체험']
  },
  'QT-RS': {
    books:['고요한 마음의 힘','나는 무엇을 원하는가','수도자처럼 생각하기'],
    videos:['철학 강의','심리학 다큐'],
    apps:['독서 기록 앱','명상 앱'],
    activities:['혼자 독서','산책','글쓰기']
  },
  // 기타 유형은 기본 추천
  'default': {
    books:['데미안','어린 왕자','연금술사'],
    videos:['진로 인터뷰 시리즈 (KOCW)'],
    apps:['Notion','Khan Academy','Forest'],
    activities:['독서','관심 분야 탐색','진로 체험']
  }
};

// 위기 대응 SOP (선생님용)
const CRISIS_SOP = [
  { level:1, title:'관찰 (위험도 LOW)', actions:['평소와 다른 변화 기록','정기 면담','학부모 일반 소통'] },
  { level:2, title:'개입 (위험도 MEDIUM)', actions:['1:1 면담 즉시 실시','Wee클래스 의뢰','학부모 통화 + 가정 협력'] },
  { level:3, title:'위기 대응 (위험도 HIGH)', actions:['보호자 즉시 연락','학교 위기관리위 보고','외부 전문기관 연계 (1577-0199, 1388)'] },
  { level:4, title:'긴급 (자해·자살 신호)', actions:['절대 혼자 두지 않음','즉시 109/1577-0199 통화','응급실 동행 또는 보호자 인계'] }
];

// =================================================================
//  렌더링 함수들
// =================================================================
const INSEONG_8_EN = {
  '예(禮)':'Respecting others and maintaining courteous manners',
  '효(孝)':"Loving and honoring one's parents and family",
  '정직(正直)':'Acting truthfully, without deception',
  '책임(責任)':'Following through and completing what one is entrusted with',
  '존중(尊重)':'Recognizing the worth and diversity of others',
  '배려(配慮)':'Being mindful of others and wanting to help them',
  '소통(疏通)':'The ability to share thoughts and feelings with one another',
  '협동(協同)':'Working together with others toward a shared goal'
};
const MULTI_INTEL_EN = {
  '언어 지능':{ name:'Linguistic Intelligence', desc:'The ability to express, understand, and persuade through language' },
  '논리·수학 지능':{ name:'Logical-Mathematical Intelligence', desc:'Logical reasoning and mathematical thinking ability' },
  '공간 지능':{ name:'Spatial Intelligence', desc:'The ability to process visual and spatial information' },
  '음악 지능':{ name:'Musical Intelligence', desc:'Sensitivity to rhythm, pitch, and tone' },
  '신체·운동 지능':{ name:'Bodily-Kinesthetic Intelligence', desc:'Expression and physical ability through the body' },
  '대인 지능':{ name:'Interpersonal Intelligence', desc:"The ability to understand others' emotions and intentions" },
  '자기성찰 지능':{ name:'Intrapersonal Intelligence', desc:"The ability to understand one's own inner self" },
  '자연 지능':{ name:'Naturalist Intelligence', desc:'Understanding of nature and living things' }
};
const VARK_STYLES_EN = {
  V:{ name:'Visual', desc:'Learns well through pictures, charts, and diagrams', tips:'Use mind maps, infographics, and videos' },
  A:{ name:'Auditory', desc:'Learns well through listening, discussion, and lectures', tips:'Use podcasts, lectures, and small-group discussion' },
  R:{ name:'Read/Write', desc:'Learns well through books, notes, and text', tips:'Reading, summarizing, and keeping your own notes' },
  K:{ name:'Kinesthetic', desc:'Learns well by doing things hands-on', tips:'Experiments, hands-on experiences, role-play, and maker activities' }
};
const PARENT_14DAY_EN = [
  { d:1, title:'Read the Report Together', action:"Spend 5\u201310 minutes with your child, highlighting strengths first" },
  { d:2, title:'Emotion Word Cards', action:"Express today's mood in one word" },
  { d:3, title:'Record a Success', action:'Write down 3 things you felt proud of this year' },
  { d:4, title:'Explore an Interest', action:'Watch a video together related to one recommended career' },
  { d:5, title:'5 Minutes of Conversation', action:'Listen briefly to school stories, without criticism' },
  { d:6, title:'Walk or Exercise', action:'30 minutes together, no phones' },
  { d:7, title:'Week 1 Review', action:'Talk about the best moment of this week' },
  { d:8, title:'Pick One Growth Point', action:'Choose just one growth point from the report to start on' },
  { d:9, title:'Practice a Small Action', action:'Take a small step on the chosen growth point' },
  { d:10, title:'Reading/Content Recommendation', action:'Watch one recommended PIA content piece together' },
  { d:11, title:'Check In on Friendships', action:'Ask about one close friend' },
  { d:12, title:'Stress Relief', action:'30 minutes of a favorite activity, with your child' },
  { d:13, title:'Envision the Future', action:'Describe yourself in 10 years in one sentence' },
  { d:14, title:'Week 2 Review', action:'Agree to retest in a month to check for changes' }
];
const TEACHER_12WK_EN = [
  { wk:1, title:'Analyze Class Distribution', action:'Check the distribution of the 16 student types; balance groups across 4 types each' },
  { wk:2, title:'Round 1 Individual Interviews', action:'Prioritize interviews by type (emotional/introverted types first)' },
  { wk:3, title:'Visual Presentations', action:"Introduce presentation formats that showcase creative/free types' strengths" },
  { wk:4, title:'Praise Class Strengths', action:'Publicly praise one class-average (example) strength' },
  { wk:5, title:'5-Minute SEL Content', action:'Weekly 5 minutes of EDUNET social-emotional learning content' },
  { wk:6, title:'Monitor Warning Signs', action:'Track CES-D/PHQ-A results at MEDIUM or above' },
  { wk:7, title:'First Parent Notice', action:'Send home the PIA report + counseling request form' },
  { wk:8, title:'Introduce Career Content', action:"Watch videos on students' top RIASEC areas" },
  { wk:9, title:'Regroup Teams', action:'Reassign groups after the first group evaluation' },
  { wk:10, title:'Round 2 Individual Interviews', action:'Check for changes since the first interview' },
  { wk:11, title:'Class Reflection Activity', action:'Have students reflect on the semester themselves' },
  { wk:12, title:'Retest & Next Semester', action:'Confirm growth with a second PIA assessment' }
];
const ROADMAP_ELEM_LOW_EN = [
  'Try a range of activities to find what you enjoy',
  'Build a daily reading habit of 20 minutes',
  'Build social skills through activities with friends',
  'Learn your strengths and interests from your PIA results'
];
const ROADMAP_BY_GRADE_EN = {
  중1: ['Make the most of the free-semester program \u2014 try out various jobs','Pick one area of interest and read 5 books about it','Learn your strengths from your PIA results'],
  중2: ['Gather information about high school options','Narrow down your desired career field to 3 options','Actively participate in school clubs'],
  중3: ['Choose a high school type (general/specialized/vocational)','Manage your grades + draft a personal statement','Retake PIA to reconfirm your career direction'],
  고1: ['Choose your elective subjects carefully','Narrow down 5 candidate majors of interest','Explore information on universities and majors'],
  고2: ['Develop your early-admission/regular-admission strategy','Narrow down to 3 majors of interest','Actively pursue related in-school activities'],
  고3: ['Finalize your college choice','Prepare for interviews and your personal statement','Use your PIA report in interviews']
};
const ROADMAP_ADULT_EN = {
  'Now (Self-Assessment)': ['Use your PIA results to organize your strengths, values, and interests','Identify the gap between your current abilities and your target role','Write a one-line career vision statement'],
  'Short-term (3\u20136 months)': ['Start one hands-on project that showcases your core strengths','Make a learning plan for one skill gap (course, certification, reading)','Update your resume, portfolio, and profile'],
  'Mid-term (1\u20132 years)': ['Build a network and find mentors in your target field','Develop a concrete plan for a career move, transition, or startup','Track your achievements with numbers to build your portfolio'],
  'Long-term (3\u20135 years)': ['Decide whether to deepen your expertise or broaden your field','Reassess your work-life balance and values alignment','Retest with PIA to check how your tendencies and goals have changed']
};
const RECOMMENDATIONS_BY_TYPE_EN = {
  'EX-CR': { books:['Demian (Hermann Hesse)','Lessons on Emotion (Kang Shin-ju \u2014 Korean philosophy essays on emotion)','The Alchemist (Paulo Coelho)'],
    videos:['How to Become a Webtoon Artist (KOCW \u2014 Korean online course)','Drawing My Mind (EBS documentary)'],
    apps:['SketchBook','ibisPaint','Procreate','Emotion journal app'], activities:['4-panel daily comic','Emotion journaling','Book club'] },
  'CR-EX': { books:["Alice's Adventures in Wonderland",'Cosmos (Carl Sagan)','Makers (Chris Anderson)'],
    videos:['TED Talks on creativity','Maker Faire videos'], apps:['Notion','Pinterest','Tinkercad'], activities:['Brainstorming sessions','Maker activities','Webtoon creation'] },
  'LO-AN': { books:['Nudge (Richard Thaler & Cass Sunstein)','Sparks of Genius (Root-Bernstein)','Sapiens (Yuval Noah Harari)'],
    videos:['Veritasium','Science Donga videos (Korean science magazine)'], apps:['Khan Academy','Wolfram Alpha','Brilliant'], activities:['Algorithm problems','Science experiments','Book discussions'] },
  'EM-CO': { books:['The Giving Tree','Nonviolent Communication (Marshall Rosenberg)','Better Together (Korean essay collection on community)'],
    videos:['Empathy-focused content','Counselor interviews'], apps:['Emotion journal app','Counseling chatbot'], activities:['Peer counseling','Book club','Volunteering'] },
  'EX-LE': { books:['Grit (Angela Duckworth)','Atomic Habits (James Clear)','How to Win Friends and Influence People (Dale Carnegie)'],
    videos:['Startup documentaries','TED Talks on leadership'], apps:['Trello','Notion','Forest (focus app)'], activities:['Leading a project','Club president role','Startup experience programs'] },
  'QT-RS': { books:['The Power of Silence (Korean essay on stillness)','What Do I Really Want (Korean self-reflection book)','Think Like a Monk (Jay Shetty)'],
    videos:['Philosophy lectures','Psychology documentaries'], apps:['Reading log app','Meditation app'], activities:['Solo reading','Walking','Journaling'] },
  'default': { books:['Demian','The Little Prince','The Alchemist'], videos:['Career Interview Series (KOCW)'], apps:['Notion','Khan Academy','Forest'], activities:['Reading','Exploring areas of interest','Career experience programs'] }
};
const CRISIS_SOP_EN = [
  { level:1, title:'Observation (Risk Level: LOW)', actions:['Record any changes from usual behavior','Regular check-ins','General communication with parents'] },
  { level:2, title:'Intervention (Risk Level: MEDIUM)', actions:['Conduct a 1:1 conversation immediately','Refer to the Wee Class','Call the parent + coordinate home support'] },
  { level:3, title:'Crisis Response (Risk Level: HIGH)', actions:['Contact the guardian immediately','Report to the school crisis management committee','Refer to outside professional services (1577-0199, 1388)'] },
  { level:4, title:'Emergency (self-harm/suicide signals)', actions:['Never leave the student alone','Call 109/1577-0199 immediately','Accompany to the ER or hand off to a guardian'] }
];

function renderInseong8(big5, via) {
  const scores = INSEONG_8.map(d => {
    let s = 60;
    if (d.mapping.includes('우호') && big5) s = (s + big5.A) / 2;
    if (d.mapping.includes('성실') && big5) s = (s + big5.C) / 2;
    if (d.mapping.includes('외향') && big5) s = (s + big5.E) / 2;
    d.mapping.forEach(m => {
      if (m.startsWith('VIA-') && via) {
        const key = m.split('-')[1];
        if (via[key]) s = (s + via[key]) / 2;
      }
    });
    return { ...d, score: Math.round(s) };
  });
  var _plI=(window.aipiaCurrentLang==='en');
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('인성교육진흥법 8대 덕목 진단','Character Education Act \u2014 8 Core Virtues Assessment')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('「인성교육진흥법」 제2조 핵심 덕목과 검사 결과의 매핑입니다.','A mapping between the core virtues in Article 2 of the Character Education Promotion Act and your assessment results.')}</p>
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
        ${scores.map(s => `
          <div class="bg-slate-50 rounded-lg p-3 text-center">
            <div class="text-xs text-slate-500 mb-1">${s.name}</div>
            <div class="text-2xl font-bold text-indigo-700">${s.score}</div>
            <div class="text-xs text-slate-600 mt-1 leading-tight">${_plI?(INSEONG_8_EN[s.name]||s.desc):s.desc}</div>
          </div>`).join('')}
      </div>
    </div>`;
}

function renderMultiIntel(big5, via, riasec) {
  var _plM=(window.aipiaCurrentLang==='en');
  const scores = MULTI_INTEL.map(mi => {
    let s = 60, n = 0;
    mi.from.forEach(src => {
      if (src.startsWith('Big5-') && big5) {
        const k = src.split('-')[1]; if (big5[k]) { s += big5[k]; n++; }
      }
      if (src.startsWith('VIA-') && via) {
        const k = src.split('-')[1]; if (via[k]) { s += via[k]; n++; }
      }
      if (src.startsWith('RIASEC-') && riasec) {
        const k = src.split('-')[1]; if (riasec[k]) { s += riasec[k]; n++; }
      }
    });
    var enD = MULTI_INTEL_EN[mi.name];
    return { ...mi, dispName:(_plM&&enD)?enD.name:mi.name, dispDesc:(_plM&&enD)?enD.desc:mi.desc, score: Math.round(n > 0 ? s/(n+1) : 60) };
  });
  const sorted = [...scores].sort((a,b) => b.score - a.score);
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('가드너 다중지능(MI) 8지능 분석','Gardner Multiple Intelligences (MI) \u2014 8-Type Analysis')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('검사 결과를 기반으로 추정한 8가지 지능 영역 점수입니다. 상위 2~3개가 ','Estimated scores for 8 intelligence areas based on your assessment results. The top 2\u20133 are ')}${(typeof selfIsAdult==='function'&&selfIsAdult())?_T('본인','your'):_T('학생','the student\'s')}${_T('의 강점 지능입니다.',' strength intelligences.')}</p>
      <div class="space-y-2">
        ${sorted.map((mi, i) => `
          <div class="flex items-center gap-3 ${i<3 ? 'bg-indigo-50' : ''} rounded-lg px-3 py-2">
            <span class="text-2xl">${mi.icon}</span>
            <div class="flex-1">
              <div class="text-sm font-semibold">${mi.dispName} ${i<3?'<span class="text-xs text-indigo-700">★ '+_T('상위','Top')+'</span>':''}</div>
              <div class="text-xs text-slate-600">${mi.dispDesc}</div>
            </div>
            <div class="w-32 bg-slate-100 h-2 rounded-full overflow-hidden">
              <div class="bg-indigo-500 h-2" style="width:${mi.score}%"></div>
            </div>
            <span class="text-sm font-bold w-8 text-right">${mi.score}</span>
          </div>`).join('')}
      </div>
    </div>`;
}

function renderVARK(big5, via, riasec) {
  var _plV=(window.aipiaCurrentLang==='en');
  const scores = VARK_STYLES.map(v => {
    let s = 60, n = 0;
    v.from.forEach(src => {
      if (src.startsWith('Big5-') && big5) { const k = src.split('-')[1]; if (big5[k]) { s += big5[k]; n++; } }
      if (src.startsWith('VIA-') && via) { const k = src.split('-')[1]; if (via[k]) { s += via[k]; n++; } }
      if (src.startsWith('RIASEC-') && riasec) { const k = src.split('-')[1]; if (riasec[k]) { s += riasec[k]; n++; } }
    });
    var enV = VARK_STYLES_EN[v.code];
    return { ...v, dispName:(_plV&&enV)?enV.name:v.name, dispDesc:(_plV&&enV)?enV.desc:v.desc, dispTips:(_plV&&enV)?enV.tips:v.tips, score: Math.round(n>0?s/(n+1):60) };
  });
  const maxScore = Math.max.apply(null, scores.map(v => v.score));
  const minScore = Math.min.apply(null, scores.map(v => v.score));
  const tiedTop = scores.filter(v => (maxScore - v.score) <= 5);
  const allTied = (maxScore - minScore) <= 5;
  const topLabel = allTied
    ? _T('뚜렷한 우세 없음 · 네 방식을 고르게 탐색 중','No clear preference \u00b7 exploring all four styles evenly')
    : (tiedTop.length >= 2 ? _T('공동 우세 · ','Tied lead \u00b7 ') + tiedTop.map(v=>v.dispName).join(' \u00b7 ') : tiedTop[0].dispName);
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('학습 스타일 진단 (VARK)','Learning Style Assessment (VARK)')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('에게 효과적인 학습 방식을 추정합니다. ','Estimated learning style that works well for ')==_T('에게 효과적인 학습 방식을 추정합니다. ','Estimated learning style that works well for ')?'':''}${_plV?('Estimated learning style that works well for '+((typeof selfIsAdult==='function'&&selfIsAdult())?'you':'the student')+'. '+(allTied?'':'Dominant style: ')):(((typeof selfIsAdult==='function'&&selfIsAdult())?'본인':'학생')+'에게 효과적인 학습 방식을 추정합니다. '+(allTied?'':'우세 스타일: '))}<strong>${topLabel}</strong></p>
      ${allTied?'<p class="text-[11px] text-amber-700 mb-3">⚠ '+_T('네 영역 점수 차이가 크지 않아 특정 방식을 대표로 뽑지 않았습니다. 아래 점수를 참고해 여러 방식을 함께 시도해보세요.','The scores across the four styles are close enough that no single style stands out. Use the scores below as a guide and try a mix of styles.')+'</p>':''}
      <div class="grid sm:grid-cols-2 gap-3">
        ${scores.map(v => `
          <div class="${(!allTied && tiedTop.indexOf(v)>=0)?'bg-amber-50 border-amber-200':'bg-slate-50 border-slate-200'} border rounded-lg p-3">
            <div class="flex items-center gap-2 mb-1">
              <span class="text-2xl">${v.icon}</span>
              <strong class="text-sm">${v.dispName}</strong>
              <span class="ml-auto text-sm font-bold">${v.score}</span>
            </div>
            <div class="text-xs text-slate-600 mb-1">${v.dispDesc}</div>
            <div class="text-xs text-slate-500 italic">💡 ${v.dispTips}</div>
          </div>`).join('')}
      </div>
    </div>`;
}

function renderParent14Day() {
  var _plan = (window.aipiaCurrentLang==='en') ? PARENT_14DAY_EN : PARENT_14DAY;
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('학부모 14일 코칭 플랜','14-Day Parent Coaching Plan')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('하루 10~15분, 무리하지 않고 꾸준히 진행하세요.','Spend 10\u201315 minutes a day \u2014 go at a steady, comfortable pace.')}</p>
      <div class="grid sm:grid-cols-2 gap-2">
        ${_plan.map(d => `
          <div class="flex gap-3 items-start bg-slate-50 rounded-lg p-3">
            <span class="bg-indigo-600 text-white text-xs font-bold rounded-full w-7 h-7 flex items-center justify-center flex-shrink-0">${d.d}</span>
            <div class="text-xs">
              <div class="font-semibold text-slate-900">${d.title}</div>
              <div class="text-slate-600 mt-1">${d.action}</div>
            </div>
          </div>`).join('')}
      </div>
    </div>`;
}

function renderTeacher12Wk() {
  var _plan = (window.aipiaCurrentLang==='en') ? TEACHER_12WK_EN : TEACHER_12WK;
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('교사 12주 학급 운영 가이드','12-Week Classroom Management Guide for Teachers')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('한 학기를 PIA 결과 기반으로 체계적으로 운영하기 위한 주차별 가이드입니다.','A week-by-week guide for running the semester systematically based on PIA results.')}</p>
      <div class="space-y-2">
        ${_plan.map(w => `
          <div class="flex gap-3 items-start border-l-4 border-emerald-400 bg-slate-50 rounded-r-lg p-3">
            <span class="text-xs font-bold text-emerald-700 w-12 flex-shrink-0">W${w.wk}</span>
            <div class="text-sm flex-1">
              <strong>${w.title}</strong>
              <span class="text-xs text-slate-600 ml-2">— ${w.action}</span>
            </div>
          </div>`).join('')}
      </div>
    </div>`;
}

function _rmCard(grade, actions){
  return `<div class="bg-violet-50 rounded-lg p-3">
    <strong class="text-sm text-violet-900">${grade}</strong>
    <ul class="text-xs text-violet-900 mt-1 space-y-0.5 ml-4 list-disc">
      ${actions.map(a => `<li>${a}</li>`).join('')}
    </ul></div>`;
}
function renderRoadmap() {
  var _plR=(window.aipiaCurrentLang==='en');
  var adult = (typeof selfIsAdult==='function' && selfIsAdult());
  if (adult) {
    var _adultTbl = _plR ? ROADMAP_ADULT_EN : ROADMAP_ADULT;
    return `<div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('진로·커리어 단계 로드맵','Career Stage Roadmap')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('현재 점검부터 장기 목표까지, 성인·대학생을 위한 커리어 단계 로드맵입니다.','A career-stage roadmap for adults and college students, from where you are now to your long-term goals.')}</p>
      <div class="space-y-2">${Object.entries(_adultTbl).map(([k,a])=>_rmCard(k,a)).join('')}</div></div>`;
  }
  var g = String((state.profile && state.profile.grade) || '').trim();
  var keys = Object.keys(ROADMAP_BY_GRADE); // 중1..고3
  var roadTbl = _plR ? ROADMAP_BY_GRADE_EN : ROADMAP_BY_GRADE;
  var elemLow = _plR ? ROADMAP_ELEM_LOW_EN : ROADMAP_ELEM_LOW;

  if (g === '초3' || g === '초4') {
    return `<div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">🧭 ${_T('지금 시기에 좋은 활동','Good Activities for This Stage')}</h3>
      <p class="text-xs text-slate-500 mb-3">${_T('본인 학년(<b>'+g+'</b>)에 맞춘 지금 할 일입니다. 중학교 진학까지는 아직 여유가 있어, 지금은 다양한 경험을 쌓는 시기예요.','Here\'s what to do now, matched to your grade (<b>'+g+'</b>). Middle school is still a ways off, so this is a time to build a variety of experiences.')}</p>
      <div class="bg-slate-50 rounded-lg p-3 border border-slate-200">
        <ul class="text-xs text-slate-700 space-y-0.5 ml-4 list-disc">${elemLow.map(a=>`<li>${a}</li>`).join('')}</ul>
      </div>
    </div>`;
  }

  var cur = keys.indexOf(g) >= 0 ? g : (g === '초5' || g === '초6' ? '중1' : null);
  if (!cur) {
    return `<div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('학년별 진학·진로 로드맵','Grade-by-Grade Academic & Career Roadmap')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('학년 정보가 없어 전체 단계를 표시합니다. (학년을 입력하면 본인 학년만 표시됩니다)','No grade information is available, so all stages are shown. (Enter your grade to see only your stage.)')}</p>
      <div class="space-y-2">${Object.entries(roadTbl).map(([k,a])=>_rmCard(k,a)).join('')}</div></div>`;
  }
  var idx = keys.indexOf(cur);
  var next = idx+1 < keys.length ? keys[idx+1] : null;
  var isElem = /초/.test(g);
  var curLabel = isElem ? _T(g + ' → 다가올 ' + cur + ' 준비', g + ' \u2192 Preparing for ' + cur) : _T(cur + ' · 현재 학년', cur + ' \u00b7 Current Grade');
  var nextBlock = next
    ? `<div class="mt-3"><p class="text-[11px] text-slate-400 mb-1">${_T('다음 단계 미리보기 · ','Next Stage Preview \u00b7 ')}${next}</p>
        <div class="bg-slate-50 rounded-lg p-3"><ul class="text-xs text-slate-600 ml-4 list-disc space-y-0.5">${roadTbl[next].map(a=>`<li>${a}</li>`).join('')}</ul></div></div>`
    : `<div class="mt-3"><p class="text-[11px] text-slate-400">${_T('다음 단계 · 고3 이후는 대학 진학·전공 심화 로드맵으로 이어집니다.','Next Stage \u00b7 After grade 12, this continues into a college and major-focused roadmap.')}</p></div>`;
  return `<div class="bg-white rounded-2xl border border-violet-200 p-4">
    <h3 class="font-semibold text-sm mb-1">🧭 ${_T('나의 진학·진로 로드맵','My Academic & Career Roadmap')}</h3>
    <p class="text-xs text-slate-500 mb-3">${_T('본인 학년(<b>'+(g||cur)+'</b>)에 맞춘 지금 할 일입니다.','Here\'s what to do now, matched to your grade (<b>'+(g||cur)+'</b>).')}</p>
    <div class="bg-violet-100 rounded-lg p-3 border border-violet-200">
      <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px"><span class="pill bg-violet-600 text-white text-[11px] font-bold">${_T('현재','Now')}</span><strong class="text-sm text-violet-900">${curLabel}</strong></div>
      <ul class="text-xs text-violet-900 mt-1 space-y-0.5 ml-4 list-disc">${roadTbl[cur].map(a=>`<li>${a}</li>`).join('')}</ul>
    </div>
    ${nextBlock}
  </div>`;
}

function renderRecommendations(typeCode) {
  var _plR2=(window.aipiaCurrentLang==='en');
  const r = (_plR2 ? (RECOMMENDATIONS_BY_TYPE_EN[typeCode] || RECOMMENDATIONS_BY_TYPE_EN['default']) : (RECOMMENDATIONS_BY_TYPE[typeCode] || RECOMMENDATIONS_BY_TYPE['default']));
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('유형별 추천 콘텐츠 큐레이션','Type-Based Recommended Content')}</h3>
      <p class="text-xs text-slate-500 mb-4">${(typeof selfIsAdult==='function'&&selfIsAdult())?_T('회원님의','Books, videos, apps, and activities matched to your'):_T('학생의',"Books, videos, apps, and activities matched to the student's")}${_plR2?' type and interests.':' 유형과 흥미에 맞춘 도서·영상·앱·활동입니다.'}</p>
      <div class="grid sm:grid-cols-2 gap-3">
        <div class="bg-amber-50 rounded-lg p-3">
          <strong class="text-sm">📚 ${_T('추천 도서','Recommended Books')}</strong>
          <ul class="text-xs text-slate-700 mt-1 space-y-0.5 ml-4 list-disc">
            ${r.books.map(b => `<li>${b}</li>`).join('')}
          </ul>
        </div>
        <div class="bg-rose-50 rounded-lg p-3">
          <strong class="text-sm">🎬 ${_T('추천 영상','Recommended Videos')}</strong>
          <ul class="text-xs text-slate-700 mt-1 space-y-0.5 ml-4 list-disc">
            ${r.videos.map(v => `<li>${v}</li>`).join('')}
          </ul>
        </div>
        <div class="bg-emerald-50 rounded-lg p-3">
          <strong class="text-sm">📱 ${_T('추천 앱','Recommended Apps')}</strong>
          <ul class="text-xs text-slate-700 mt-1 space-y-0.5 ml-4 list-disc">
            ${r.apps.map(a => `<li>${a}</li>`).join('')}
          </ul>
        </div>
        <div class="bg-sky-50 rounded-lg p-3">
          <strong class="text-sm">🎯 ${_T('추천 활동','Recommended Activities')}</strong>
          <ul class="text-xs text-slate-700 mt-1 space-y-0.5 ml-4 list-disc">
            ${r.activities.map(a => `<li>${a}</li>`).join('')}
          </ul>
        </div>
      </div>
    </div>`;
}

function renderCrisisSOP() {
  var _sop = (window.aipiaCurrentLang==='en') ? CRISIS_SOP_EN : CRISIS_SOP;
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('선생님용 위기 대응 SOP (4단계)','Crisis Response SOP for Teachers (4 Levels)')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('정서 위험도에 따른 단계별 대응 매뉴얼입니다.','A staged response manual based on emotional risk level.')}</p>
      <div class="space-y-3">
        ${_sop.map(s => {
          const bg = s.level === 1 ? 'bg-emerald-50 border-emerald-200' : s.level === 2 ? 'bg-amber-50 border-amber-200' : s.level === 3 ? 'bg-orange-50 border-orange-200' : 'bg-rose-50 border-rose-300';
          return `
            <div class="${bg} border-l-4 rounded-r-lg p-3">
              <div class="text-sm font-bold">Lv${s.level}. ${s.title}</div>
              <ul class="text-xs text-slate-700 mt-1 space-y-0.5 ml-4 list-disc">
                ${s.actions.map(a => `<li>${a}</li>`).join('')}
              </ul>
            </div>`;
        }).join('')}
      </div>
    </div>`;
}

/* [2026-11-02] 결과지 신뢰성 ①-3: 척도별 α 를 우리 이용자 자료로 — 결과 API /api/scale-stats.
   한 검사의 모든 하위척도가 n≥100 이고 α≥0.70 이면 '자체 α', 아니면 문헌값으로 표시한다(2026-11-02 실측 α 가 낮아 이 기준을 둠). */
var __piaScaleStats = null, __piaScaleStatsTried = false;
function piaLoadScaleStats(){
  if (__piaScaleStatsTried) return; __piaScaleStatsTried = true;
  try{
    var ac = (typeof AbortController!=='undefined') ? new AbortController() : null;
    var to = setTimeout(function(){ try{ ac && ac.abort(); }catch(e){} }, 4000);
    fetch('https://api.yedam.kr/api/scale-stats', ac ? { signal: ac.signal } : {})
      .then(function(r){ clearTimeout(to); return r.ok ? r.json() : null; })
      .then(function(j){ if (j && j.ok && j.scales) { __piaScaleStats = j.scales; piaDomBatch(piaRefreshAlphaCells); } })
      .catch(function(e){ clearTimeout(to); console.warn('척도 통계(자체 α) 조회 실패 — 문헌값 사용', e && e.message); });
  }catch(e){}
}
function _piaOwnAlpha(key){
  var st = __piaScaleStats; if (!st || !key) return null;
  var ks = Object.keys(st).filter(function(k){ return k === key || k.indexOf(key + '.') === 0; });
  if (!ks.length) return null;
  var n = Infinity, sum = 0, cnt = 0;
  for (var i = 0; i < ks.length; i++){ var x = st[ks[i]]; if (!x || typeof x.n !== 'number') return null; n = Math.min(n, x.n);
    if (typeof x.alpha !== 'number' || x.alpha < 0.70) return null; sum += x.alpha; cnt++; }   /* 낮거나 음수인 자체 α 는 결과지에 쓰지 않는다(문헌값 유지) */
  if (!cnt || n < 100) return null;
  return { alpha: sum / cnt, n: n };
}
function _piaAlphaCell(s){
  var lit = String(s.alpha);
  if (!s.key) return lit;
  var own = _piaOwnAlpha(s.key);
  if (own) return '<span data-alpha-key="' + s.key + '" data-alpha-lit="' + lit + '">' + _T('자체 α ','own \u03b1 ') + own.alpha.toFixed(2).replace(/^0/, '') + ' <small>(n=' + own.n + ')</small></span>';
  return '<span data-alpha-key="' + s.key + '" data-alpha-lit="' + lit + '">' + lit + ' <small class="text-slate-400">(' + _T('문헌값', 'literature') + ')</small></span>';
}
function piaRefreshAlphaCells(){
  /* [2026-11-02 성능] 내용이 같은 칸은 갈아 끼우지 않는다 — 칸을 바꾸면 쪽 넘김(ydp)이 결과지 전체를 다시 재서(수백 ms~수 초) 화면이 멈춘다 */
  try{ document.querySelectorAll('[data-alpha-key]').forEach(function(e){ var t = document.createElement('div');
    t.innerHTML = _piaAlphaCell({ key: e.getAttribute('data-alpha-key'), alpha: e.getAttribute('data-alpha-lit') }); if (t.firstChild && t.firstChild.outerHTML === e.outerHTML) return; e.replaceWith(t.firstChild); }); }catch(e){}
}

function renderReliabilityStats() {
  piaLoadScaleStats();
  var _plS=(window.aipiaCurrentLang==='en');
  const r = calcReliability();
  const all = [
    { key:'big5', name:'IPIP Big5-50', done:!!state.results.big5.scores, alpha:'.85', validity:_T('IPIP 학술 검증','IPIP academic validation') },
    { key:'riasec', name:'RIASEC 30', done:!!state.results.riasec.scores, alpha:'.82', validity:_T('Holland 이론 기반','Based on Holland theory') },
    { key:'via', name:_T('24 강점','24 Strengths'), done:!!state.results.via.scores, alpha:'.78', validity:_T('IPIP-VIA 24강점(공개)','IPIP-VIA 24 Strengths (open)') },
    { key:'grit', name:_T('끈기·근면 8','Grit 8'), done:!!state.results.grit.scores, alpha:'.84', validity:'IPIP Industriousness ('+_T('공개','open')+')' },
    { key:'sjt', name:'SJT 30', done:state.results.sjt.answers.length>=15, alpha:'.76', validity:_T('행동 예측 검사','Behavioral prediction test') },
    { name:_T('자유대화','Free Conversation'), done:state.results.conv.turns >= 12, alpha:_T('정성평가','Qualitative'), validity:_T('질적 자료 — 신뢰도계수(α) 미산출','Qualitative data \u2014 no Cronbach\'s \u03b1 computed') },
    { key:'cesd', name:'CES-D-10', done:!!state.results.cesd.scores, alpha:'.85', validity:_T('정서 스크리닝','Emotional screening') },
    { key:'phqa', name:'PHQ-A', done:!!state.results.phqa.scores, alpha:'.83', validity:_T('청소년 우울 선별(비진단)','Youth depression screening (non-diagnostic)') },
    { key:'gad', name:'GAD-7', done:!!state.results.gad.scores, alpha:'.89', validity:_T('불안 평가','Anxiety assessment') }
  ];
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('측정 신뢰도 — 척도별 내적 일관성(α)','Measurement Reliability \u2014 Internal Consistency (\u03b1) by Scale')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('해석 등급: ','Interpretation grade: ')}<strong>${r.grade}</strong> (${r.label})${piaRelFrag(r, true)} \u00b7 ${_T('완료: ','Completed: ')}${r.completed.length}/6 ${_T('정량',' quantitative')} + ${r.screening.length}/3 ${_T('정서',' emotional')}</p>
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-slate-50 text-xs">
            <tr><th class="text-left p-2">${_T('검사 도구','Assessment Tool')}</th><th class="p-2">${_T('완료','Done')}</th><th class="p-2">Cronbach α <span class="font-normal text-slate-400">(${_T('자체 n≥100 · 아니면 문헌값','own data n\u2265100, else literature')})</span></th><th class="text-left p-2">${_T('학술 근거','Academic Basis')}</th></tr>
          </thead>
          <tbody>
            ${all.map(s => `
              <tr class="border-b border-slate-100">
                <td class="p-2 font-medium text-xs">${s.name}</td>
                <td class="text-center p-2"><span class="pill ${s.done?'bg-emerald-100 text-emerald-800':'bg-slate-100 text-slate-500'}">${s.done?'✓':'—'}</span></td>
                <td class="text-center p-2 text-slate-600 text-xs">${_piaAlphaCell(s)}</td>
                <td class="p-2 text-xs text-slate-600">${s.validity}</td>
              </tr>`).join('')}
          </tbody>
        </table>
      </div>
    </div>`;
}

function renderResultUsageGuide(audience) {
  /* 2026-09-02: audience 를 받아놓고 쓰지 않아 학생·학부모·선생님 칸이 세 개 다 나왔다.
     학생 결과지에는 학생 몫만, 학부모 결과지에는 학부모 몫만 싣는다. */
  var _plU = (window.aipiaCurrentLang === 'en');
  var aduG = (typeof selfIsAdult === 'function' && selfIsAdult());
  var aud = audience || 'student';
  var 본인 = _plU ? (aduG ? 'You' : 'The student') : (aduG ? '본인' : '학생 본인');
  var 칸 = _plU ? {
    student: {
      제목: 본인, 색: 'violet',
      항목: ['Intentionally use your strengths in daily life',
             'Try working on just one growth point',
             aduG ? 'Retest after some time to check for changes' : 'Retest next semester to check for changes',
             aduG ? 'Remember 1577-0199 and professional counseling channels if needed' : 'Remember 1388 and the Wee Class support channel']
    },
    parent: {
      제목: 'Parent', 색: 'emerald',
      항목: ['Follow the 14-day coaching plan',
             'Praise strengths first',
             "Respect your child's own pace on career decisions",
             'Use 1577-0199 immediately if you notice warning signs']
    },
    teacher: {
      제목: 'Teacher', 색: 'amber',
      항목: ['Use the 12-week classroom guide',
             'Vary group placement and presentation formats',
             'Use as material for parent conferences',
             'Familiarize yourself with the crisis response SOP manual']
    }
  } : {
    student: {
      제목: 본인, 색: 'violet',
      항목: ['강점을 일상에서 의도적으로 활용',
             '성장 포인트는 한 가지만 시도',
             aduG ? '일정 기간 후 재검사로 변화 확인' : '다음 학기에 재검사로 변화 확인',
             aduG ? '필요 시 1577-0199·전문 상담 채널 기억' : '1388·Wee클래스 도움 채널 기억']
    },
    parent: {
      제목: '학부모', 색: 'emerald',
      항목: ['14일 코칭 플랜 실천',
             '강점 위주로 칭찬',
             '진로는 자녀 페이스 존중',
             '위험 신호 시 즉시 1577-0199 활용']
    },
    teacher: {
      제목: '선생님', 색: 'amber',
      항목: ['12주 학급 운영 가이드 활용',
             '모둠 배치·발표 형식 차별화',
             '학부모 면담 자료로 활용',
             '위기 대응 SOP 매뉴얼 숙지']
    }
  };
  var c = 칸[aud] || 칸.student;
  var 항목HTML = c.항목.map(function(t){
    return '<li>' + _escHtml(t) + '</li>';
  }).join('');
  return `
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-1">${_T('이 결과지 활용 안내','How to Use This Report')}</h3>
      <p class="text-xs text-slate-500 mb-4">${_T('결과지를 가장 효과적으로 활용하는 방법입니다.','The most effective way to use this report.')}</p>
      <div class="bg-${c.색}-50 rounded-lg p-3 text-xs">
        <strong class="text-${c.색}-900">${_escHtml(c.제목)}</strong>
        <ul class="mt-1 space-y-0.5 ml-4 list-disc text-${c.색}-900">${항목HTML}</ul>
      </div>
    </div>`;
}

function renderSourcesAppendix() {
  return ''; /* 출처/저작권은 관리자(results-admin)로 이전 — 학생 화면 비표시 */
  return `
    <div class="bg-slate-50 border border-slate-200 rounded-2xl p-4">
      <h3 class="font-semibold text-sm mb-2 text-slate-800">검사 도구 출처 및 저작권</h3>
      <ul class="text-xs text-slate-600 space-y-1.5 ml-4 list-disc">
        <li><strong>IPIP Big5-50</strong>: International Personality Item Pool (ipip.ori.org) — public domain, Goldberg 1992</li>
        <li><strong>RIASEC</strong>: Holland RIASEC 모델 · O*NET Interest Profiler (U.S. DOL, CC BY 4.0) 기반</li>
        <li><strong>24 강점</strong>: IPIP-VIA Character Scales — Public Domain (ipip.ori.org)</li>
        <li><strong>끈기·근면</strong>: IPIP Industriousness/Perseverance — Public Domain</li>
        <li><strong>SJT</strong>: 예담 톡 자체 개발 30 시나리오</li>
        <li><strong>CES-D-10</strong>: Center for Epidemiologic Studies Depression Scale — public domain</li>
        <li><strong>PHQ-A</strong>: Patient Health Questionnaire for Adolescents — free for use</li>
        <li><strong>GAD-7</strong>: Generalized Anxiety Disorder 7-item Scale — free for use</li>
        <li><strong>인성 8대 덕목</strong>: 「인성교육진흥법」 제2조 (예·효·정직·책임·존중·배려·소통·협동)</li>
        <li><strong>다중지능(MI)</strong>: Howard Gardner의 Theory of Multiple Intelligences</li>
        <li><strong>VARK</strong>: Neil Fleming Learning Styles Model</li>
        <li><strong>진로 정보</strong>: 커리어넷 OpenAPI(교육부·한국직업능력연구원), 워크넷(고용노동부)</li>
        <li><strong>상담 자원</strong>: 청소년상담 1388 (여성가족부), Wee 프로젝트 (교육부), 정신건강위기 1577-0199 (국립정신건강센터)</li>
      </ul>
      <p class="text-xs text-slate-500 mt-3 leading-relaxed border-t border-slate-200 pt-3">
        본 결과지는 의료·임상 진단이 아닌 교육·진로·자기이해를 위한 참고용 도구이며,
        결과 해석에 의문이 있으시면 학교 상담교사·Wee클래스·전문 상담사에게 문의하세요.
      </p>
    </div>`;
}

// 메인 확장 렌더링
// ===== 정확도 고도화 헬퍼 =====
// 척도별 내적합치도(α) — 공개 규준 근사값. SEM = SD·√(1-α), SD는 0~100 척도에서 15 가정.
var REL_ALPHA = { big5:0.84, grit:0.82, riasec:0.86, via:0.78, learn:0.80, mi:0.80 };
function calcCI(score, alpha){
  var sd=15, a=(typeof alpha==='number'?alpha:0.80);
  var sem=sd*Math.sqrt(Math.max(0,1-a));
  var ci=1.96*sem; // 95% 신뢰구간
  return { lo:Math.max(0,Math.round(score-ci)), hi:Math.min(100,Math.round(score+ci)), sem:Math.round(sem*10)/10 };
}
// Kelley 추정 진점수 + 추정오차 기반 95% CI (단일검사 측정오차의 정석 처리)
// T̂ = M + ρ(X−M) : 신뢰도가 낮을수록 평균(50)으로 수축(회귀). SEest = SD√(ρ(1−ρ)).
function trueScoreCI(observed, alpha){
  var sd=15, M=50, a=(typeof alpha==='number'?alpha:0.80);
  var T = M + a*(observed - M);
  var seEst = sd*Math.sqrt(Math.max(0, a*(1-a)));
  var ci = 1.96*seEst;
  return { t:Math.round(T), lo:Math.max(0,Math.round(T-ci)), hi:Math.min(100,Math.round(T+ci)), se:Math.round(seEst*10)/10, shrink:Math.round(observed-T) };
}
// 실제 이용자 백분위 (Local PostgreSQL · PRODUCTION 비테스트 집계, n>=30일 때만 사용)
// 표본이 모자라면 백분위를 보이지 않는다. 예전의 정규분포 N(50,15) 가정 추정(pctFromScore)은
// 가상의 모집단과 비교하는 고정 비교값이라 2026-09-27 OWNER 결정('고정·예시 비교값 금지')에 따라 뺐다.
var _piaRealNorms=null, _piaNormsTried=false;
function piaLoadRealNorms(){
  try{
    var R=state.results, sc={};
    function set(k,v){ if(typeof v==='number'&&isFinite(v)) sc[k]=Math.round(v); }
    if(R.big5.scores){ set('big5.E',R.big5.scores.E); set('big5.A',R.big5.scores.A); set('big5.C',R.big5.scores.C); set('big5.N',R.big5.scores.N); set('big5.O',R.big5.scores.O); }
    if(R.grit.scores) set('grit.overall',R.grit.scores.overall);
    if(R.riasec.scores){ ['R','I','A','S','E','C'].forEach(function(k){ set('riasec.'+k, R.riasec.scores[k]); }); }
    if(!Object.keys(sc).length) return;
    /* 백분위 모집단은 Local PostgreSQL 의 실제 이용자(PRODUCTION · is_test=false)뿐이다.
       테스트 · QA · 이관 데이터는 서버가 모집단에서 제외한다. (P1-C) */
    var _pctBase = (function(){
      try{ var o=(localStorage.getItem('pia_api_base')||'').trim();
           if(o) return o.replace(/\/+$/,''); }catch(e){}
      return 'https://api.yedam.kr';
    })();
    fetch(_pctBase+'/api/percentile', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ scores: sc })
    }).then(function(r){ return r.json(); })
      .then(function(j){
        if(!j || !j.ok) return;
        _piaRealNorms = { n:j.n||0, pct:j.pct||{}, ready:!!j.ready,
                          minN:j.minN||30, message:j.message||'' };
        if(_piaRealNorms.ready){ piaDomBatch(function(){ try{ if (document.getElementById('extended-sections')) renderExtendedSections(); }catch(e){} }); }
      })
      .catch(function(e){ console.error('백분위 모집단 조회 실패', e); });
  }catch(e){}
}
// 응답편향: 묵종(예-편향)·극단·중앙·부정 응답 스타일 탐지 (1~5 리커트 풀)
function calcResponseStyle(){
  try{
    var R=state.results, pools=['big5','grit','learn','mi','via'], vals=[];
    pools.forEach(function(k){ var a=(R[k]&&R[k].answers)||[]; a.forEach(function(x){ if(x>=1&&x<=5) vals.push(x); }); });
    var n=vals.length; if(n<20) return { grade:'-', gradeLabel:'-', n:n };
    function p(f){ return vals.filter(f).length/n; }
    var ext=p(function(v){return v===1||v===5;});
    var mid=p(function(v){return v===3;});
    var acq=p(function(v){return v>=4;});
    var dis=p(function(v){return v<=2;});
    var flags=[];
    if(acq>0.78) flags.push(_T('긍정편향','positivity bias'));
    if(dis>0.78) flags.push(_T('부정편향','negativity bias'));
    if(ext>0.65) flags.push(_T('극단응답','extreme responding'));
    if(mid>0.55) flags.push(_T('중앙편중','midpoint bias'));
    var grade=flags.length>=2?'주의':flags.length===1?'경미':'양호';
    var gradeLabel=_T(grade, grade==='주의'?'Caution':grade==='경미'?'Mild':'Good');
    return { grade:grade, gradeLabel:gradeLabel, n:n, ext:ext, mid:mid, acq:acq, dis:dis, flags:flags };
  }catch(e){ return { grade:'-', gradeLabel:'-' }; }
}
// 정서안정 지수(0~100) — 정서검사로 신경증 교차검증용
function emotionStabilityIndex(){
  try{
    var R=state.results, parts=[];
    if(R.cesd.scores&&typeof R.cesd.scores.total==='number') parts.push(100-Math.min(100,R.cesd.scores.total/30*100));
    if(R.gad.scores&&typeof R.gad.scores.total==='number') parts.push(100-Math.min(100,R.gad.scores.total/21*100));
    if(R.phqa.scores&&typeof R.phqa.scores.total==='number') parts.push(100-Math.min(100,R.phqa.scores.total/27*100));
    if(R.who5.scores&&typeof R.who5.scores.pct==='number') parts.push(R.who5.scores.pct);
    if(R.rses.scores&&typeof R.rses.scores.total==='number') parts.push(Math.max(0,Math.min(100,(R.rses.scores.total-10)/30*100)));
    if(!parts.length) return null;
    return Math.round(parts.reduce(function(a,b){return a+b;},0)/parts.length);
  }catch(e){ return null; }
}
// ===== 결과 정확도(0~100) 단일 산출 — 여러 화면이 같은 값을 참조하도록 공용화 =====
// (QA 2026-08-22 P0-1: 신뢰도가 낮아도 MBTI형·직업순위·95%CI·VARK·인성덕목·로드맵을
//  단정적으로 보여주던 문제. 이 함수의 total<50('보강 필요')을 단일 기준선으로 삼는다.)
function piaAccuracyScore(){
  try{
    var R=state.results;
    var b=R.big5.scores, g=R.grit.scores, ri=R.riasec.scores, vi=R.via.scores;
    function band(d){ return d<15?{t:_T('일치','Match'),c:'#15803d'}:d<30?{t:_T('보통','Moderate'),c:'#b45309'}:{t:_T('주의','Caution'),c:'#b91c1c'}; }
    function add(checks,name,v1,v2){ if(typeof v1==='number'&&typeof v2==='number'){ var d=Math.abs(v1-v2); var x=band(d); checks.push({name:name,d:d,t:x.t,c:x.c}); } }
    var checks=[];
    if(b&&g) add(checks,_T('성실성 ↔ 끈기·근면','Conscientiousness \u2194 Grit'), b.C, g.overall);
    if(b&&ri) add(checks,_T('외향성 ↔ 진취·사회(RIASEC)','Extraversion \u2194 Enterprising/Social (RIASEC)'), b.E, (ri.E+ri.S)/2);
    if(g&&vi&&vi['끈기']!=null) add(checks,_T('끈기·근면 ↔ 강점(끈기)','Grit \u2194 Strength (Perseverance)'), g.overall, vi['끈기']);
    if(b&&ri) add(checks,_T('개방성 ↔ 예술·탐구(RIASEC)','Openness \u2194 Artistic/Investigative (RIASEC)'), b.O, (ri.A+ri.I)/2);
    if(b&&ri) add(checks,_T('친화성 ↔ 사회형(RIASEC)','Agreeableness \u2194 Social (RIASEC)'), b.A, ri.S);
    var esi=emotionStabilityIndex();
    if(b&&esi!=null) add(checks,_T('정서안정 ↔ 정서검사(우울·불안 등)','Emotional Stability \u2194 Emotional Screening (depression, anxiety, etc.)'), 100-b.N, esi);
    var core=[R.conv.turns >= 12,!!b,!!ri,!!vi,!!g]; var nDone=core.filter(Boolean).length;
    var vgrade='-'; var rel=null; try{ rel=calcReliability(); if(rel&&rel.validity) vgrade=rel.validity.grade; }catch(_){}
    var rs=calcResponseStyle();
    var cn=0; try{ cn=(JSON.parse(localStorage.getItem('pia_cn_results')||'[]')).length; }catch(_){}
    var consistOK=checks.filter(function(c){return c.t===_T('일치','Match');}).length;
    // 0~100 종합 정확도 (데이터30 + 성실도25 + 응답스타일15 + 일관성20 + 공식검사10)
    var sData=Math.round(Math.min(nDone,5)/5*30);
    var sVal=(vgrade==='양호'?25:vgrade==='주의'?12:vgrade==='낮음'?0:10);
    var sStyle=(rs.grade==='양호'?15:rs.grade==='경미'?8:rs.grade==='주의'?0:8);
    var sCons=checks.length?Math.round(consistOK/checks.length*20):10;
    var sCn=(cn>0?10:0);
    var total=sData+sVal+sStyle+sCons+sCn;
    var grade=total>=80?_T('매우 높음','Very High'):total>=65?_T('높음','High'):total>=50?_T('보통','Moderate'):_T('보강 필요','Needs Improvement');
    var gColor=total>=80?'#097b38':total>=65?'#0369a1':total>=50?'#ae4e02':'#b91c1c';   /* 알약은 자기 색 10% 틴트 위 글자 — #15803d 4.30→#097b38 4.60 · #b45309 4.31→#ae4e02 4.60 (hue 유지) */
    return { total:total, grade:grade, color:gColor, nDone:nDone, vgrade:vgrade, vgradeLabel:(rel&&rel.validity&&rel.validity.gradeLabel)||vgrade, rs:rs, cn:cn, checks:checks, consistOK:consistOK,
      // 50점 미만('보강 필요')이면 정밀 결과(유형·순위·CI·로드맵)를 억제한다.
      sufficient: total>=50 };
  }catch(e){ return { total:0, grade:'-', color:'#94a3b8', nDone:0, vgrade:'-', vgradeLabel:'-', rs:{grade:'-',gradeLabel:'-'}, cn:0, checks:[], consistOK:0, sufficient:false }; }
}
// 결과지 전역에서 쓰는 짧은 판정: 정밀 결과를 보여줘도 되는가
function piaResultSufficient(){ return piaAccuracyScore().sufficient; }

function renderAccuracyPanel(){
  try{
    var acc=piaAccuracyScore();
    var checks=acc.checks, nDone=acc.nDone, vgradeLabel=acc.vgradeLabel, rs=acc.rs, cn=acc.cn, consistOK=acc.consistOK, total=acc.total, grade=acc.grade, gColor=acc.color;
    var b=state.results.big5.scores, g=state.results.grit.scores;
    var rows=checks.map(function(c){ return '<tr style="border-top:1px solid #f1f1ee"><td style="padding:4px 6px 4px 0;font-size:12px">'+c.name+'</td><td style="padding:4px 6px;font-size:12px;color:'+c.c+';font-weight:700;text-align:center;white-space:nowrap">'+c.t+'</td><td style="padding:4px 0;font-size:12px;color:#999;text-align:right;white-space:nowrap">'+Math.round(c.d)+_T('점차',' pts diff')+'</td></tr>'; }).join('');
    rows='<div class="pia-xscroll" style="overflow-x:auto;-webkit-overflow-scrolling:touch;max-width:100%"><table style="width:100%;border-collapse:collapse;table-layout:fixed"><colgroup><col><col style="width:54px"><col style="width:64px"></colgroup>'+rows+'</table></div>';
    if(!checks.length) rows='<div style="font-size:12px;color:#888">'+_T('교차검증할 검사(Big5·끈기·RIASEC·강점·정서)를 더 완료하면 일관성 점검이 표시됩니다.','Complete more assessments (Big5, Grit, RIASEC, Strengths, Emotional) to see a consistency check.')+'</div>';
    var ciRows='';
    if(!acc.sufficient){
      ciRows='<div style="font-size:12px;color:#b91c1c;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:8px 10px">📏 '+_T('결과 정확도가 '+total+'/100으로 기준(50점) 미만이라 95% 신뢰구간·백분위를 표시하지 않습니다. 검사를 더 완료하거나 다시 응답하면 표시됩니다.','Your result accuracy is '+total+'/100, below the 50-point threshold, so the 95% confidence interval and percentile are not shown. Complete more assessments or respond again to see them.')+'</div>';
    } else {
      var ciItems=[];
      if(b){ ciItems.push([_T('외향성','Extraversion'),b.E,'big5','big5.E',false],[_T('성실성','Conscientiousness'),b.C,'big5','big5.C',false],[_T('정서안정','Emotional Stability'),100-b.N,'big5','big5.N',true],[_T('개방성','Openness'),b.O,'big5','big5.O',false]); }
      if(g&&typeof g.overall==='number') ciItems.push([_T('끈기·근면','Grit'),g.overall,'grit','grit.overall',false]);
      var realOn=!!(_piaRealNorms&&_piaRealNorms.ready&&_piaRealNorms.pct);
      var ciRowsInner=ciItems.map(function(it){
        var ts=trueScoreCI(it[1],REL_ALPHA[it[2]]);
        var real=null;
        if(realOn&&_piaRealNorms.pct[it[3]]!=null){ var rp=_piaRealNorms.pct[it[3]]; real=it[4]?(100-rp):rp; }
        var pc=real, top=(real!=null?100-real:null);
        var src=(real!=null?_T('YEDAM 실제 이용자 '+_piaRealNorms.n+'명 기준','YEDAM actual users, n='+_piaRealNorms.n):'');
        var shrink=(ts.shrink!==0?' <span style="color:#94a3b8">('+_T('관측 '+Math.round(it[1]),'observed '+Math.round(it[1]))+')</span>':'');
        return '<tr style="border-top:1px solid #f1f1ee"><td style="padding:4px 6px 4px 0;font-size:12px;font-weight:600;white-space:nowrap">'+it[0]+'</td><td style="padding:4px 6px;font-size:12px;white-space:nowrap"><b>'+ts.t+_T('점','')+'</b>'+shrink+'</td><td style="padding:4px 6px;font-size:12px;color:#64748b;white-space:nowrap">'+_T('95% 구간 ','95% range ')+ts.lo+'~'+ts.hi+' (±'+ts.se+')</td><td style="padding:4px 0;font-size:12px;color:'+(real!=null?'#15803d':'#6e6b60')+';text-align:right;white-space:nowrap">'+(real!=null?(top<=50?_T('상위 ','top ')+top:_T('하위 ','bottom ')+pc)+'% <span style="color:#6e6b60">('+src+')</span>':_T('백분위 표시 안 함','Percentile not shown'))+'</td></tr>'; }).join('');
      var _pctNote = realOn ? '' :
        ('<div style="font-size:11px;color:#92400e;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:6px 8px;margin-bottom:6px">'
         + _T('비교 가능한 실제 이용자 표본이 아직 충분하지 않습니다.','Not enough real-user samples for comparison yet.')
         + ' '
         + _T('그래서 백분위(상위 %)는 표시하지 않습니다. 95% 구간은 본인 응답의 측정오차만 반영합니다.','So percentiles (top %) are not shown. The 95% range reflects only the measurement error of your own responses.')
         + '</div>');
      /* 칸마다 nowrap 이라 폰(390px)에서 표가 518~574px 로 넓어져 문서 전체가 가로로 넘쳤다
         (html 이 overflow-x:hidden 이라 옆으로 밀어 볼 수도 없었다). 표만 가로 스크롤되게 감싼다. (2026-09-26) */
      ciRows=ciRowsInner?(_pctNote+'<div class="pia-xscroll" role="region" tabindex="0" aria-label="'+_T('척도별 95% 구간 표 (가로로 밀어 보기)','Scale 95% range table (scroll horizontally)')+'" style="overflow-x:auto;-webkit-overflow-scrolling:touch;max-width:100%"><table style="width:100%;border-collapse:collapse">'+ciRowsInner+'</table></div>'):_pctNote;
    }
    var rsColor=rs.grade==='양호'?'bg-emerald-100 text-emerald-800':rs.grade==='경미'?'bg-amber-100 text-amber-800':rs.grade==='주의'?'bg-rose-100 text-rose-800':'bg-slate-100 text-slate-500';
    var rsFlagsStr = (rs.flags&&rs.flags.length)?('('+rs.flags.join('\u00b7')+')'):'';
    return '<div class="bg-white rounded-2xl border border-slate-200 p-4">'
      +'<h3 class="font-semibold text-sm mb-1">🎯 '+_T('결과 정확도 점검 (고도화)','Result Accuracy Check (Advanced)')+'</h3>'
      +'<p class="text-xs text-slate-500 mb-3">'+_T('데이터 충분성·응답 성실도·응답편향·교차 일관성·공식검사를 종합한 신뢰 지표입니다. 모든 점수는 측정오차를 포함하니 아래 <b>신뢰구간(범위)</b>으로 해석하세요.','A composite reliability indicator combining data sufficiency, response validity, response bias, cross-consistency, and official assessments. All scores include measurement error, so interpret them using the <b>confidence interval (range)</b> below.')+'</p>'
      +'<div style="display:flex;align-items:center;gap:12px;margin-bottom:10px">'
      +'<div style="font-size:30px;font-weight:800;color:'+gColor+';line-height:1">'+total+'<span style="font-size:14px;color:#94a3b8">/100</span></div>'
      +'<div><span class="pill font-bold" style="background:'+gColor+'1a;color:'+gColor+'">'+_T('종합 정확도: ','Overall Accuracy: ')+grade+'</span></div></div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px">'
      +'<span class="pill bg-slate-100 text-slate-700">'+_T('데이터 충분성 ','Data Sufficiency ')+nDone+'/5</span>'
      +'<span class="pill bg-slate-100 text-slate-700">'+_T('응답 성실도 ','Response Validity ')+vgradeLabel+'</span>'
      +'<span class="pill '+rsColor+'">'+_T('응답편향 ','Response Bias ')+rs.gradeLabel+rsFlagsStr+'</span>'
      +'<span class="pill '+(cn>0?'bg-emerald-100 text-emerald-800':'bg-slate-100 text-slate-500')+'">'+_T('공식검사 교차검증 ','Official Test Cross-check ')+(cn>0?cn+_T('건 ✓',' \u2713'):_T('없음','None'))+'</span>'
      +'</div>'
      +(ciRows?'<div style="border-top:1px solid #eee;padding-top:6px;margin-bottom:6px"><div style="font-size:11px;color:#666;margin-bottom:4px">📏 '+_T('진점수 추정(95% 신뢰구간)·백분위 — 신뢰도로 보정한 진점수 최선추정치이며(관측치는 괄호), 범위 안의 값으로 해석하세요. 백분위는 YEDAM 실제 이용자 표본이 충분할 때만 표시합니다','Estimated true score (95% confidence interval) and percentile \u2014 the best estimate of the true score adjusted for reliability (observed value in parentheses); interpret it as a range. Percentiles are shown only when there are enough real YEDAM users.')+'</div>'+ciRows+'</div>':'')
      +'<div style="border-top:1px solid #eee;padding-top:6px"><div style="font-size:11px;color:#666;margin-bottom:4px">🔗 '+_T('교차 일관성 — 서로 관련된 검사끼리 결과가 일치하는지 (','Cross-consistency \u2014 whether related assessments agree with each other (')+consistOK+'/'+checks.length+_T(' 일치)',' match)')+'</div>'+rows+'</div>'
      +((checks.length&&consistOK<checks.length)?'<p class="text-[11px] text-amber-700 mt-2">⚠ '+_T('일부 검사 간 결과 차이가 있습니다. 천천히 다시 응답하면 정확도가 올라갑니다.','There are some differences between related assessments. Responding again more carefully can improve accuracy.')+'</p>':(checks.length?'<p class="text-[11px] text-emerald-700 mt-2">✓ '+_T('관련 검사들이 서로 일치해 결과 신뢰도가 높습니다.','Related assessments agree with each other, so result reliability is high.')+'</p>':''))
      +((rs.flags&&rs.flags.length)?'<p class="text-[11px] text-rose-700 mt-1">⚠ '+_T('응답 패턴('+rs.flags.join('·')+')이 감지돼 일부 점수가 실제보다 높거나 낮게 나타날 수 있습니다.','A response pattern ('+rs.flags.join('\u00b7')+') was detected, which may make some scores appear higher or lower than they actually are.')+'</p>':'')
      +'</div>';
  }catch(e){ return ''; }
}
function renderCareernetCard(){
  var arr=[]; try{ arr=JSON.parse(localStorage.getItem('pia_cn_results')||'[]'); }catch(_){}
  if(!arr || !arr.length) return '';
  var rows=arr.slice().sort(function(a,b){return b.ts-a.ts;}).map(function(x){
    var d=''; try{ d=new Date(x.ts).toLocaleDateString(window.aipiaCurrentLang==='en'?'en-US':'ko-KR'); }catch(_){}
    return '<div style="display:flex;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid #eef2ff">'
      +'<b style="min-width:150px;font-size:13px;color:#3730a3">'+x.name+'</b>'
      +'<span style="color:#888;font-size:11px">'+d+'</span>'
      +'<a href="'+x.url+'" target="_blank" rel="noopener" style="margin-left:auto;color:#2563eb;font-weight:700;font-size:12px">'+_T('공식 결과 보기 ↗','View Official Result \u2197')+'</a></div>';
  }).join('');
  var vr=''; try{ var rel=calcReliability(); if(rel&&rel.validity&&rel.validity.grade&&rel.validity.grade!=='-') vr=_T(' · 응답 성실도 ',' \u00b7 Response Validity ')+(rel.validity.gradeLabel||rel.validity.grade); }catch(_){}
  return '<div class="bg-white rounded-2xl border border-indigo-200 p-4">'
    +'<h3 class="font-semibold text-sm mb-1">🧭 '+_T('커리어넷 공식 진로심리검사 (교차검증)','CareerNet Official Career Psychology Test (Cross-check)')+'</h3>'
    +'<p class="text-xs text-slate-500 mb-3">'+_T('교육부·한국직업능력연구원 <b>국가 표준화 검사</b> 결과입니다. 예담 톡의 추정 결과를 공인 검사로 <b>교차 확인</b>해 정확도를 높입니다.',"This is a result from a <b>nationally standardized test</b> by the Ministry of Education and the Korea Research Institute for Vocational Education & Training. Cross-checking YEDAM Talk's estimated results against this official test improves accuracy.")+vr+'</p>'
    +rows
    +'<p class="text-[11px] text-indigo-700 mt-2">✓ '+_T('공인검사 '+arr.length+'건 반영 — AI 추정과 표준화 점수를 함께 보면 해석이 더 정확합니다.','Reflects '+arr.length+' official test result(s) \u2014 interpretation is more accurate when AI estimates are viewed alongside standardized scores.')+'</p></div>';
}
// ===== AI 상담 결과지 + 나이스(NEIS) 연동 =====
window.piaSafeCopy=window.piaSafeCopy||function(text,btn,okLabel,failLabel){
  /* 키오스크 등 클립보드 권한이 막힌 기기 대응.
     · 프라미스 거부를 반드시 처리한다 (미처리시 전역 오류 토스트가 떠서 사용자가 오류로 오인).
     · 실패하면 execCommand 폴백 → 그래도 안 되면 '복사 안 됨'을 정직하게 표시. */
  text=String(text==null?'':text);
  function legacy(){ try{ var ta=document.createElement('textarea'); ta.value=text; ta.setAttribute('readonly',''); ta.style.cssText='position:fixed;left:-9999px;top:0'; document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0,text.length); var ok=document.execCommand('copy'); document.body.removeChild(ta); return ok; }catch(e){ return false; } }
  function done(ok){ if(btn){ var o=btn.getAttribute('data-orig-label')||btn.textContent; if(!btn.getAttribute('data-orig-label')) btn.setAttribute('data-orig-label',o); btn.textContent= ok?(okLabel||'복사됨 \u2713'):(failLabel||'복사 안 됨 \u2014 길게 눌러 복사'); setTimeout(function(){ btn.textContent=btn.getAttribute('data-orig-label'); },ok?1600:2600); } if(!ok&&window.console) console.error('클립보드 복사 실패(권한 차단 가능)'); return ok; }
  if(navigator.clipboard&&navigator.clipboard.writeText){ return navigator.clipboard.writeText(text).then(function(){ return done(true); },function(){ return done(legacy()); }); }
  return Promise.resolve(done(legacy()));
};
window.piaCopy=window.piaCopy||function(id,btn){ try{ var el=document.getElementById(id); var t=el.innerText||el.textContent||''; window.piaSafeCopy(t,btn); }catch(e){} };
window.piaCopyAll=window.piaCopyAll||function(ids,labels,btn){ try{
  var parts=[]; ids=ids||[]; labels=labels||[];
  for(var i=0;i<ids.length;i++){ var el=document.getElementById(ids[i]); if(!el)continue; var t=(el.innerText||el.textContent||'').trim(); if(!t)continue; parts.push('■ '+(labels[i]||'')+'\n'+t); }
  var text=parts.join('\n\n');
  window.piaSafeCopy(text,btn,'전체 복사됨 \u2713');
}catch(e){} };
// NEIS byte(한글 3, 그 외 1) 계산 + 실시간 카운터 + 값 복사
window.piaNbyte=window.piaNbyte||function(t){ t=String(t||''); var b=0; for(var i=0;i<t.length;i++){ var c=t.charCodeAt(i); b+=((c>=0x1100&&c<=0x11FF)||(c>=0x3130&&c<=0x318F)||(c>=0xAC00&&c<=0xD7A3)||(c>=0x3400&&c<=0x9FFF)||(c>=0xF900&&c<=0xFAFF))?3:1; } return b; };
window.piaNiceCount=window.piaNiceCount||function(el,maxByte,cntId){ try{ var t=el.value||''; var ch=t.length; var by=window.piaNbyte(t); var over=maxByte&&by>maxByte; var s=document.getElementById(cntId); if(s){ s.innerHTML='('+ch+'자 · '+by+'byte'+(maxByte?' / 최대 '+maxByte+'byte':'')+(over?' · <b>초과!</b>':'')+')'; s.style.color=over?'#b91c1c':'#94a3b8'; } if(el){ el.style.borderColor=over?'#f5a3a3':'#e0e5ff'; } }catch(e){} };
window.piaCopyVal=window.piaCopyVal||function(id,btn){ try{ var el=document.getElementById(id); var t=(el&&(el.value!=null?el.value:el.innerText))||''; window.piaSafeCopy(t,btn); }catch(e){} };
window.piaCopyAllVal=window.piaCopyAllVal||function(ids,labels,btn){ try{ var parts=[]; for(var i=0;i<ids.length;i++){ var el=document.getElementById(ids[i]); if(!el||el.offsetParent===null)continue; var t=((el.value!=null?el.value:el.innerText)||'').trim(); if(!t)continue; parts.push('■ '+(labels[i]||'')+'\n'+t); } window.piaSafeCopy(parts.join('\n\n'),btn,'전체 복사됨 \u2713'); }catch(e){} };
window.piaNiceGrade=window.piaNiceGrade||function(v){ try{ var don=document.getElementById('nice-fld-dongari'); if(don) don.style.display=(v==='elem')?'none':''; var bong=document.getElementById('nice-fld-bongsa'); if(bong) bong.style.display=(v==='elem'||v==='high1')?'none':''; var jl=document.getElementById('nice-lbl-jayul'); if(jl) jl.textContent=(v==='high1'||v==='high')?'창의적 체험활동 — 자율·자치활동 특기사항':'창의적 체험활동 — 자율활동 특기사항'; }catch(e){} };
var _RIA={R:'실재형(현장·기술)',I:'탐구형(분석·연구)',A:'예술형(창의·표현)',S:'사회형(대인·협력)',E:'진취형(주도·설득)',C:'관습형(체계·정확)'};
function _topN(obj,n){ try{ return Object.keys(obj||{}).map(function(k){return [k,Number(obj[k])];}).filter(function(x){return isFinite(x[1]);}).sort(function(a,b){return b[1]-a[1];}).slice(0,n); }catch(e){ return []; } }
function _band(v,hi,mid){ return v>=hi?'상':v>=mid?'중':'하'; }
function _emotionNote(){ var R=state.results, flags=[]; try{
  if(R.cesd.scores&&R.cesd.scores.level&&R.cesd.scores.level!=='LOW') flags.push('우울 선별');
  if(R.gad.scores&&R.gad.scores.level&&/HIGH|MEDIUM/.test(R.gad.scores.level)) flags.push('불안 선별');
  if(R.phqa.scores&&R.phqa.scores.level&&/HIGH|MEDIUM/.test(R.phqa.scores.level)) flags.push('우울(PHQ)');
  if(R.who5.scores&&R.who5.scores.pct!=null&&R.who5.scores.pct<50) flags.push('정서적 웰빙 낮음');
}catch(e){}
  return flags; }
function renderCounselReport(){
  try{
    var R=state.results, b=R.big5.scores, vi=R.via.scores, ri=R.riasec.scores, g=R.grit.scores;
    var learn=R.learn.scores, mi=R.mi.scores;
    var type=null; try{ type=inferIntegratedType(); }catch(e){}
    var adult=(typeof selfIsAdult==='function'&&selfIsAdult());
    var who=adult?'회원님':'학생';
    var parts=[];
    // 강점
    var strengths=[];
    var vt=viaTopKeys(vi,3); if(vt.length) strengths=vt;
    else if(b){ var bt=[['외향성',b.E],['개방성',b.O],['성실성',b.C],['친화성',b.A]].sort(function(a,c){return c[1]-a[1];}); strengths=[bt[0][0],bt[1][0]]; }
    // 흥미·진로
    var rt=_topN(ri,2), riLabel=rt.map(function(x){return _RIA[x[0]]||x[0];}).join(' · ');
    // 학습
    var lt=_topN(learn,1), lw=learn?_topN(learn,99):[]; var learnLow=lw.length?lw[lw.length-1]:null;
    var gritBand = g&&typeof g.overall==='number'? _band(g.overall,67,45):null;
    var gritTxt = gritBand==='상'?'목표를 향해 끈기 있게 노력하는':gritBand==='중'?'꾸준함을 갖춘':'관심 분야에서 몰입할 때 집중하는';
    var emo=_emotionNote();

    // Big5 차원 기반 지도 함의 (교사 관점)
    function _bd(v,hiT){ return v>=(hiT||60)?'상':v>=45?'중':'하'; }
    var dimTips=[];
    if(b){
      var E=_bd(b.E), A=_bd(b.A), C=_bd(b.C), S=_bd(100-b.N), O=_bd(b.O);
      if(E==='상') dimTips.push('외향성이 높아 발표·모둠 리더·또래 멘토 역할에서 에너지를 얻습니다. 표현 기회를 적극 부여하세요.');
      else if(E==='하') dimTips.push('내향적 성향으로 대집단 발표에 부담을 느낄 수 있어, 소규모·글쓰기·1:1 발표 등 대안 통로를 마련해 주세요.');
      if(C==='상') dimTips.push('성실성이 높아 자기주도 과제·장기 프로젝트를 맡기면 책임감 있게 완수합니다.');
      else if(C==='하') dimTips.push('계획·마무리에 지원이 필요하므로 과제를 작은 단위로 쪼개고 중간 점검을 함께 해 주세요.');
      if(A==='상') dimTips.push('친화성이 높아 갈등 중재·배려 역할에 적합하나, 자기 의견을 눌러 참지 않도록 발언 기회를 보장해 주세요.');
      if(S==='하') dimTips.push('정서 기복에 민감할 수 있어, 결과보다 과정을 인정하는 피드백과 예측 가능한 학급 루틴이 안정에 도움이 됩니다.');
      if(O==='상') dimTips.push('개방성이 높아 새로운 주제·창의 과제·탐구 활동에서 몰입도가 높습니다.');
    }
    // 다중지능 상위
    var miTop=(typeof mi==='object'&&mi)?_topN(mi,2).map(function(x){return _piaMiLabel(x[0]);}):[];

    parts.push('<div style="font-size:13.5px;line-height:1.75;color:#2b2b28">');
    // 1. 종합 소견
    parts.push('<p style="margin-bottom:10px"><b>■ 종합 소견</b><br>'+who+_piaJ(who,'은','는')+' '+(type&&type.name?('<b>'+type.name+'</b> 유형으로, '+(type.desc||'')+' 이 특성을 학급 활동·진로 지도에 연결하면 강점이 잘 발현됩니다.'):'검사 결과를 종합할 때 균형 잡힌 성향을 보입니다.')+'</p>');
    // 2. 강점 프로파일 & 학급 활용
    if(strengths.length){
      parts.push('<p style="margin-bottom:4px"><b>■ 강점 프로파일 &amp; 학급 활용</b><br>대표 강점: <b>'+strengths.join(' · ')+'</b></p>');
      parts.push('<ul style="margin:0 0 10px 16px;padding:0;font-size:13px;color:#3d3d3a">'
        +'<li>강점을 드러낼 <b>역할·과제</b>를 우선 배정해 자기효능감을 키워 주세요(예: '+strengths[0]+' 관련 발표·프로젝트 리더).</li>'
        +(dimTips.length?dimTips.map(function(t){return '<li>'+t+'</li>';}).join(''):'')
        +'</ul>');
    }
    // 3. 흥미·진로 지도
    if(rt.length) parts.push('<p style="margin-bottom:10px"><b>■ 흥미·진로 지도</b><br><b>'+riLabel+'</b> 성향이 뚜렷합니다. 관련 직업·학과를 함께 탐색하고, 동아리·체험·독서 등 <b>구체적 경험</b>과 연결해 진로 목표를 단계적으로 구체화하도록 지도해 주세요.'+(miTop.length?(' 다중지능상 <b>'+miTop.join(', ')+'</b>'+_piaJ(miTop[miTop.length-1],'이','가','이')+' 두드러져 해당 방식의 학습·표현이 효과적입니다.'):'')+'</p>');
    // 4. 학습·태도 지도
    var lline=''; if(lt.length) lline+='<b>'+_piaSubjLabel(lt[0][0])+'</b> 역량이 우수해 이를 발판 삼은 심화 과제가 효과적입니다. '; if(learnLow&&learnLow[1]<55) lline+='<b>'+_piaSubjLabel(learnLow[0])+'</b>'+_piaJ(_piaSubjLabel(learnLow[0]),'은','는')+' 단계적 목표 설정과 즉각적 격려로 성장이 기대됩니다.';
    parts.push('<p style="margin-bottom:10px"><b>■ 학습·태도 지도</b><br>'+gritTxt+' 모습이 관찰됩니다. '+(lline||'전반적으로 균형 잡힌 학습 태도를 보이므로 현재 습관을 지지·강화해 주세요.')+'</p>');
    // 5. 정서·생활 지도
    if(emo.length) parts.push('<p style="margin-bottom:10px"><b>■ 정서·생활 지도 (관찰 권장)</b><br><span style="color:#9a3412"><b>'+emo.join(' · ')+'</b> 신호가 확인됩니다. 진단이 아닌 <b>선별</b> 결과입니다. 비난·평가보다 <b>공감과 정서적 지지</b>를 먼저 제공하고, 지속·악화 시 보호자 공유 및 <b>Wee클래스·청소년상담 1388</b> 연계를 권장합니다. 자해·위기 신호 감지 시 학교 위기관리 매뉴얼에 따라 즉시 조치하세요.</span></p>');
    else parts.push('<p style="margin-bottom:10px"><b>■ 정서·생활</b><br>정서 선별 지표가 대체로 안정적입니다. 현재의 안정감을 유지하도록 지지적 환경을 이어가 주세요.</p>');
    // 6. 학부모 상담 시 전달 포인트 (교사 전용 · 학부모가 기분좋게 받아들이도록)
    var _s0=strengths[0]||'아이만의 강점', _s1=strengths[1]||'', _riFirst=(rt.length?riLabel.split(' · ')[0]:'관심 분야');
    parts.push('<p style="margin-bottom:4px"><b>■ 학부모 상담 시 전달 포인트 <span style="font-size:11px;color:#9a3412">(교사용 · 대외 비공개)</span></b></p>'
      +'<p style="font-size:12.5px;color:#64748b;margin:0 0 6px">아래 문장은 <b>선생님이 학부모께 말할 때</b> 쓰는 예시입니다. 강점→성장→가정협력 순서로, 아이를 아끼는 마음이 전해지도록 구성했습니다. 그대로 읽어도 좋고 상황에 맞게 다듬어 쓰세요.</p>'
      +'<div style="background:#f0f7f2;border:1px solid #cfe6d6;border-radius:10px;padding:11px;font-size:13px;color:#2b3b2f;line-height:1.75;margin-bottom:8px">'
      +'<p style="margin-bottom:6px">“어머니(아버님), <b>OO</b>이는 <b>'+_s0+'</b>'+(_s1?(_piaJ(_s0,'과','와','과')+' <b>'+_s1+'</b>'):'')+_piaJ(_s1||_s0,'이','가','이')+' 참 돋보이는 아이예요. 학교에서도 '+_riFirst+' 활동을 할 때 눈빛이 달라지고 몰입하는 모습이 인상적입니다.”</p>'
      +'<p style="margin-bottom:6px">“이 강점을 살려서 앞으로 '+_riFirst+' 쪽 경험을 조금씩 넓혀 주시면, 아이가 자기 색깔을 더 또렷하게 찾아갈 거예요. 가정에서는 결과보다 <b>과정을 함께 기뻐해</b> 주시는 것만으로도 큰 힘이 됩니다.”</p>'
      +'<p style="margin-bottom:0">“'+(emo.length?'요즘 마음이 조금 무거워 보이는 순간도 있는데, 이건 문제가 아니라 <b>도움을 청하는 신호</b>예요. 학교에서도 따뜻하게 살피겠습니다. 가정에서도 편하게 이야기 들어주시면, 저희가 함께 도울 수 있어요.':'정서·생활도 안정적이고 친구들과도 잘 지냅니다. 지금처럼 아이를 믿고 지지해 주시면 충분합니다. 변화가 보이면 언제든 함께 이야기 나눠요.')+'”</p>'
      +'</div>'
      +'<ul style="margin:0 0 6px 16px;padding:0;font-size:12.5px;color:#3d3d3a">'
      +'<li><b>이렇게</b>: 구체적 장면과 함께 강점을 먼저, 성장 가능성으로 마무리 — 학부모가 안심하고 협력하게 됩니다.</li>'
      +'<li><b>피하기</b>: “부족하다·못한다·문제가 있다” 같은 단정, 검사 수치·진단명 언급, 다른 아이와 비교. 결핍이 아닌 <b>성장의 언어</b>로 전하세요.</li>'
      +'</ul>');
    // 7. 상담 제언 (구체 액션)
    parts.push('<p style="margin-bottom:2px"><b>■ 상담 제언 (실행 아이디어)</b></p><ul style="margin:0 0 4px 16px;padding:0;font-size:13px;color:#3d3d3a">'
      +'<li>강점('+(strengths[0]||'대표 강점')+') 활용 역할·과제 부여 → 자기효능감 강화</li>'
      +'<li>'+(rt.length?riLabel.split(' · ')[0]+' 관련 진로 체험·멘토 연계':'관심 분야 탐색 지원')+'</li>'
      +'<li>'+(learnLow&&learnLow[1]<55?_piaSubjLabel(learnLow[0])+' 보완을 위한 단계별 목표·중간 점검':'현재 학습 습관 지지·심화 과제 제공')+'</li>'
      +'<li>'+(emo.length?'정기 정서 관찰 및 지지, 필요 시 전문 상담 연계':'긍정적 태도를 지지·격려하며 성장 관찰')+'</li>'
      +'</ul>');
    // 8. 다음 상담까지 관찰 포인트
    parts.push('<p style="margin-bottom:2px"><b>■ 다음 상담까지 관찰 포인트</b></p><ul style="margin:0 0 4px 16px;padding:0;font-size:12.5px;color:#64748b">'
      +'<li>강점 발현 상황(어떤 활동에서 몰입·주도했는지)</li>'
      +'<li>학습 태도 변화(과제 완수·집중 지속 시간)</li>'
      +(emo.length?'<li>정서 신호의 빈도·강도 변화, 또래 관계</li>':'<li>또래 관계·수업 참여의 일관성</li>')
      +'</ul>');
    parts.push('</div>');

    return '<div class="bg-white rounded-2xl border border-violet-200 p-4">'
      +'<h3 class="font-semibold text-sm mb-1">🧑‍🏫 AI 상담 소견서 (교사 지도용)</h3>'
      +'<p class="text-xs text-slate-500 mb-3">검사 결과를 <b>교사·지도자 관점</b>에서 종합한 상세 소견입니다. 강점 활용·학급 운영·진로/정서 지도·학부모 상담 포인트를 담았으며, 최종 판단·기록은 교사가 관찰과 함께 검토·수정하세요.</p>'
      +'<div id="counsel-body">'+parts.join('')+'</div>'
      +'<div class="mt-3"><button data-act=\'[["piaCopy","counsel-body","@this"]]\' class="pill bg-violet-600 text-white font-bold" style="border:0;cursor:pointer;padding:6px 14px">📋 소견 복사</button></div>'
      +'</div>';
  }catch(e){ return ''; }
}
function renderNiceCard(){
  try{
    var R=state.results, b=R.big5.scores, vi=R.via.scores, ri=R.riasec.scores, g=R.grit.scores, learn=R.learn.scores;
    var vt=viaTopKeys(vi,2);
    var rt=_topN(ri,2), riTop=rt.length?(_RIA[rt[0][0]]||'').replace(/\(.*\)/,''):'';
    var lt=_topN(learn,1);
    var gritBand=g&&typeof g.overall==='number'?_band(g.overall,67,45):null;
    function _bat(w){ if(!w)return false; var c=w.charCodeAt(w.length-1); return c>=44032&&c<=55203?((c-44032)%28!==0):false; }
    var s1=''; if(vt.length>=2){ s1=vt[0]+(_bat(vt[0])?'과 ':'와 ')+vt[1]+' 강점이 돋보이며, '; } else if(vt.length===1){ s1=vt[0]+' 강점이 돋보이며, '; }
    var s2=riTop?(riTop+' 분야에 흥미와 적성을 보이며, '):'';
    var s3=gritBand==='상'?'목표를 세우면 끝까지 해내려는 끈기가 관찰됨. ':gritBand==='중'?'주어진 과제를 꾸준히 수행하는 성실한 태도를 지님. ':'관심 있는 활동에 몰입하는 모습이 나타남. ';
    var s4=lt.length?(_piaSubjLabel(lt[0][0])+' 역량이 돋보여 관련 활동에서 적극적으로 참여함. '):'';
    // 행동특성 및 종합의견(행발) 초안 — 개조식(명사형 종결)·관찰 기반, 검사 수치·진단 표현 배제
    var haeng='성실하고 긍정적인 태도로 학교생활에 충실히 참여함. '+s1+s2+s3+s4+'교우 관계가 원만하고 배려심이 있어 급우들과 협력적으로 지냄. 자신의 강점을 살려 꾸준히 성장하는 모습이 기대되며, 다양한 경험과 도전을 통해 잠재력을 더욱 발휘할 수 있도록 지속적인 관심과 격려가 필요함.';
    var _today=(function(){ try{ var d=new Date(); return d.getFullYear()+'. '+(d.getMonth()+1)+'. '+d.getDate()+'.'; }catch(e){ return ''; } })();
    var _emoNeed=(function(){ try{ var cd=state.results.cesd&&state.results.cesd.scores,pq=state.results.phqa&&state.results.phqa.scores,gd=state.results.gad&&state.results.gad.scores; return [cd,pq,gd].some(function(x){return x&&(x.level==='HIGH'||x.level==='MEDIUM');})||(pq&&pq.selfHarm>0); }catch(e){ return false; } })();
    // 나이스 상담관리 화면 형식(상담일자/영역/방법/내용/조치) — 줄바꿈 텍스트(붙여넣기용)
    var sang='[상담일자] '+_today+'\n'
      +'[상담영역] 성격·진로'+(_emoNeed?'·정서':'')+'\n'
      +'[상담방법] 인·적성 검사 결과 기반 개별상담\n'
      +'[상담내용] 대표 강점은 '+(vt.join(', ')||'—')+'이며, '+(riTop||'관심')+' 분야에 흥미를 보임. '+(gritBand==='상'?'목표를 향해 끈기 있게 노력하는 편임. ':gritBand==='중'?'과제를 꾸준히 수행하는 태도를 지님. ':'몰입할 활동을 함께 탐색할 필요가 있음. ')+'강점을 활용한 학습·진로 계획 수립을 논의하고, 관심 분야의 체험활동과 독서를 안내함.\n'
      +'[조치사항] 강점 활용 과제 부여 및 진로 체험 연계. '+(_emoNeed?'정서 영역 주의 관찰, 보호자 안내 및 Wee클래스·청소년상담 1388 연계 예정.':'정서·생활 영역 지속 관찰.');
    var jinro='자신의 흥미와 적성에 대한 이해를 바탕으로 '+(riTop||'관심')+' 분야에 꾸준한 관심을 가지고 관련 직업·학과 정보를 탐색함. '+(vt.length?(vt.join(', ')+' 강점을 진로와 연결하려는 노력이 관찰됨. '):'')+'관심 분야의 체험활동과 독서를 통해 진로 목표를 구체화해 나감.';
    var changche='학급 및 자율 활동에 성실히 참여하며 맡은 역할을 책임감 있게 수행함. '+(vt.length?(vt[0]+' 강점을 발휘하여 모둠 활동에서 협력적인 태도를 보임. '):'')+'규칙을 준수하고 자기 관리에 힘쓰는 모범적인 생활 태도를 보임.';
    var dongari=(vt.length?(vt[0]+' 강점을 바탕으로 '):'')+'관심 분야 동아리 활동에 자발적으로 참여하여 맡은 역할을 성실히 수행함. 부원들과 협력하여 활동을 기획·운영하고, 꾸준한 참여로 관련 역량을 신장함.';
    // 학년 자동 판별: elem(초등)/mid(중)/high1(고1)/high(고2·3)
    var _g=(function(){ try{ var gr=String((state.profile&&state.profile.grade)||''); if(/초|elem/i.test(gr)) return 'elem'; if(/고\s*1(?!\d)|고1|1학년.*고|high\s*1/i.test(gr)) return 'high1'; if(/고|high/i.test(gr)) return 'high'; if(/중|mid/i.test(gr)) return 'mid'; }catch(e){} return 'mid'; })();
    var _donHide=(_g==='elem'), _jLbl=(_g==='high1'||_g==='high')?'창의적 체험활동 — 자율·자치활동 특기사항':'창의적 체험활동 — 자율활동 특기사항';
    function _cnt(t,mx){ var by=(window.piaNbyte?window.piaNbyte(t):0); var over=by>mx; return '<span'+(over?' style="color:#b91c1c"':'')+'>('+String(t).length+'자 · '+by+'byte / 최대 '+mx+'byte'+(over?' · 초과!':'')+')</span>'; }
    // 편집형 입력칸: textarea + 실시간 글자수/byte + 개별 복사
    function _fld(id,label,text,mx,wrapId){
      return '<div'+(wrapId?(' id="'+wrapId+'"'):'')+(wrapId==='nice-fld-dongari'&&_donHide?' style="display:none"':'')+' style="margin-top:13px">'
        +'<div style="font-size:12px;font-weight:700;color:#3730a3;margin:0 0 4px;display:flex;justify-content:space-between;align-items:center;gap:8px">'
        +'<span id="'+(id==='nice-changche'?'nice-lbl-jayul':id+'-lbl')+'">'+label+'</span>'
        +'<span id="'+id+'-cnt" style="font-weight:400;color:#94a3b8;font-size:11px">'+_cnt(text,mx)+'</span></div>'
        +'<textarea id="'+id+'" aria-labelledby="'+(id==='nice-changche'?'nice-lbl-jayul':id+'-lbl')+'" data-act-input=\'[["piaNiceCount","@this",'+mx+',"'+id+'-cnt"]]\' spellcheck="false" style="width:100%;min-height:92px;font-size:13px;line-height:1.7;color:#222;background:#f5f7ff;border:1px solid #e0e5ff;border-radius:10px;padding:11px;resize:vertical;font-family:inherit;box-sizing:border-box">'+_escHtml(text)+'</textarea>'
        +'<button data-act=\'[["piaCopyVal","'+id+'","@this"]]\' class="pill bg-indigo-600 text-white font-bold mt-2" style="border:0;cursor:pointer;padding:6px 14px">📋 이 항목 복사</button>'
        +'</div>';
    }
    var gradeSel='<div style="display:flex;align-items:center;gap:8px;margin:6px 0 4px"><span style="font-size:12px;font-weight:700;color:#3730a3">학교급</span>'
      +'<select data-act-change="piaNiceGrade" data-arg-value aria-label="학교급" style="font:inherit;font-size:12.5px;border:1px solid #e0e5ff;border-radius:8px;padding:5px 8px;background:#fff">'
      +'<option value="elem"'+(_g==='elem'?' selected':'')+'>초등학교</option>'
      +'<option value="mid"'+(_g==='mid'?' selected':'')+'>중학교</option>'
      +'<option value="high1"'+(_g==='high1'?' selected':'')+'>고등학교 1학년</option>'
      +'<option value="high"'+(_g==='high'?' selected':'')+'>고등학교 2·3학년</option>'
      +'</select><span style="font-size:11px;color:#94a3b8">선택하면 항목·명칭이 학교급에 맞게 바뀝니다</span></div>';
    return '<div class="bg-white rounded-2xl border border-indigo-200 p-4">'
      +'<h3 class="font-semibold text-sm mb-1">🏫 나이스(NEIS) 입력 도우미 — 담임교사 입력 항목</h3>'
      +'<p class="text-xs text-slate-500 mb-2">4세대 나이스 화면에 <b>붙여넣는</b> 초안입니다. <b>담임교사 입력 항목</b>(행동특성 및 종합의견 · 창의적 체험활동 · 상담기록)만 담았고, 모두 <b>개조식(명사형 종결)</b>·관찰 기반이며 검사 수치·진단 표현은 넣지 않았습니다. 칸을 <b>직접 수정</b>할 수 있고 글자수·byte가 실시간 표시됩니다(나이스 기준 <b>한글 3byte</b>). 아래 <b>전체 복사</b> 또는 항목별 복사 후 해당 칸에 붙여넣고 기재요령에 맞게 검토하세요.</p>'
      +gradeSel
      +'<button data-act=\'[["piaCopyAllVal",["nice-haeng","nice-jinro","nice-changche","nice-dongari","nice-sang"],["행동특성 및 종합의견","진로활동 특기사항","자율(자치)활동 특기사항","동아리활동 특기사항","상담기록"],"@this"]]\' class="pill bg-indigo-700 text-white font-bold mb-1" style="border:0;cursor:pointer;padding:9px 16px;font-size:13px">📋 전체 문구 한 번에 복사</button>'
      +_fld('nice-haeng','행동특성 및 종합의견',haeng,1500)
      +_fld('nice-jinro','창의적 체험활동 — 진로활동 특기사항',jinro,2100)
      +_fld('nice-changche',_jLbl,changche,1500)
      +_fld('nice-dongari','창의적 체험활동 — 동아리활동 특기사항',dongari,1500,'nice-fld-dongari')
      +_fld('nice-sang','상담기록 (나이스 상담관리 형식)',sang,1500)
      +'<p class="text-[11px] text-slate-400 mt-3">※ 분량 상한은 기재요령 기준 참고값(행동특성 및 종합의견·자율·동아리 500자, 진로 700자 ≈ 한글 500·700자 × 3byte)입니다. 학년·연도별 기재요령을 우선하세요.<br>※ 나이스 개방 API는 학교정보·학사일정만 제공하며, 학생 생기부·상담기록은 개인정보·보안상 외부 자동 연동이 불가합니다. 본 기능은 규정 준수 하의 <b>문구 생성·복사</b>입니다.</p>'
      +'</div>';
  }catch(e){ return ''; }
}
function renderTeacherToolkit(){
  try{
    var R=state.results, b=R.big5.scores, vi=R.via.scores, ri=R.riasec.scores, g=R.grit.scores;
    var vt=viaTopKeys(vi,2);
    var rt=_topN(ri,1), riTop=rt.length?(_RIA[rt[0][0]]||'').replace(/\(.*\)/,''):'';
    var emo=_emotionNote();
    var out='<div class="bg-white rounded-2xl border border-slate-200 p-4">';
    out+='<h3 class="font-semibold text-sm mb-1">🧰 교사 도구모음 (담임·상담용)</h3>';
    out+='<p class="text-xs text-slate-500 mb-3">검사 결과 기반으로 상담·기록·학부모 대응을 돕는 즉시 활용 도구입니다.</p>';
    if(emo.length){ out+='<div style="background:#fdecec;border:1px solid #f5b5b5;border-radius:10px;padding:11px;margin-bottom:10px"><b style="color:#b91c1c">🚨 정서 관찰 권장 — '+emo.join(' · ')+'</b><div style="font-size:12.5px;color:#7a3b1a;margin-top:6px;line-height:1.65"><b>대응 절차(SOP)</b><br>1) 비공개·안전한 공간에서 라포 형성 후 안부·감정 확인<br>2) 자·타해 위험 신호 시 즉시 관리자·보호자 보고<br>3) Wee클래스(학교)·청소년 1388·정신건강 1577-0199 연계<br>4) 정기 관찰·후속 면담 기록. ※ 본 결과는 진단이 아닌 <b>선별</b>입니다.</div></div>'; }
    else { out+='<div style="background:#eef7ee;border:1px solid #cde3cd;border-radius:10px;padding:9px;margin-bottom:10px;font-size:12.5px;color:#356635">✔ 정서 선별 지표 안정적 — 정기 관찰 유지</div>'; }
    var qs=[];
    if(vt.length) qs.push('"'+vt[0]+'" 강점을 최근 언제 발휘했나요? 그때 기분은 어땠나요?');
    if(riTop) qs.push(riTop+' 분야에 끌리는 이유를 이야기해줄래요?');
    qs.push('요즘 학교생활에서 가장 즐거운 일과 힘든 일은 무엇인가요?');
    qs.push('1년 뒤·3년 뒤 어떤 모습이면 좋겠어요?');
    qs.push(emo.length?'마음이 힘들 때 누구에게 이야기하나요? 도움이 필요하면 언제든 선생님에게 말해도 돼요.':'스스로 더 성장하고 싶은 부분이 있다면요?');
    out+='<div id="tt-q" style="font-size:13px;line-height:1.75;color:#222"><b>■ 맞춤 상담 질문</b><br>'+qs.map(function(q,i){return (i+1)+'. '+q;}).join('<br>')+'</div>';
    out+='<button data-act=\'[["piaCopy","tt-q","@this"]]\' class="pill bg-slate-800 text-white font-bold mt-2" style="border:0;cursor:pointer;padding:6px 14px">📋 질문 복사</button>';
    var parent='[학부모 상담 참고자료]\n○ 자녀 강점: '+(vt.join(', ')||'—')+'\n○ 관심·진로: '+(riTop||'—')+'\n○ 가정 코칭: 강점을 인정·격려하고, 관심 분야의 경험(체험·독서)을 함께 찾아보세요.'+(emo.length?'\n○ 정서: 따뜻한 지지가 필요한 시기입니다. 필요 시 전문 상담(청소년 1388)을 함께 고려해 주세요.':'');
    out+='<div style="font-size:12px;font-weight:700;color:#333;margin:12px 0 4px">학부모 상담 자료</div>';
    out+='<div id="tt-parent" style="white-space:pre-line;font-size:12.5px;line-height:1.6;color:#222;background:#faf9f5;border:1px solid #eee;border-radius:10px;padding:11px">'+parent+'</div>';
    out+='<button data-act=\'[["piaCopy","tt-parent","@this"]]\' class="pill bg-slate-800 text-white font-bold mt-2" style="border:0;cursor:pointer;padding:6px 14px">📋 자료 복사</button>';
    var tr=(R.conv&&R.conv.transcript)||[];
    if(tr.length){ var d=''; try{ d=new Date().toLocaleDateString('ko-KR'); }catch(_){} var topics=(R.conv&&R.conv.topics&&Object.keys(R.conv.topics))||[];
      var _cs2=(R.conv&&R.conv.summary)||null, _csLine=(_cs2&&_cs2.interests&&_cs2.interests.length)?('\n○ 대화에서 보인 관심: '+_cs2.interests.join(', ')+((_cs2.wants&&_cs2.wants.length)?(' / 해 보고 싶은 것: '+_cs2.wants.join(', ')):'')):'';
      var log='[상담일지] '+d+'\n○ 방식: AI 자유대화 '+((R.conv&&R.conv.turns)||0)+'회'+(topics.length?('\n○ 주요 화제: '+topics.slice(0,5).join(', ')):'')+_csLine+'\n○ 소견: 대화에 성실히 참여함. 위 AI 상담 소견서 참조.';
      out+='<div style="font-size:12px;font-weight:700;color:#333;margin:12px 0 4px">상담일지 초안 (자유대화 기반)</div>';
      out+='<div id="tt-log" style="white-space:pre-line;font-size:12.5px;line-height:1.6;color:#222;background:#faf9f5;border:1px solid #eee;border-radius:10px;padding:11px">'+log+'</div>';
      out+='<button data-act=\'[["piaCopy","tt-log","@this"]]\' class="pill bg-slate-800 text-white font-bold mt-2" style="border:0;cursor:pointer;padding:6px 14px">📋 일지 복사</button>'; }
    out+='<div style="font-size:12px;font-weight:700;color:#333;margin:12px 0 4px">생기부 연동 (예담 톡 고유)</div>';
    out+='<div style="font-size:12.5px;color:#555;background:#eef7ee;border:1px solid #cde3cd;border-radius:10px;padding:10px">검사에서 나타난 <b>강점 '+(vt.join(', ')||'—')+'</b>을 생기부 문장 도우미로 보내 개조식 초안을 바로 만듭니다.</div>';
    out+='<div class="mt-2"><button data-act="piaSendToRecord" class="pill text-white font-bold" style="background:#788c5d;border:0;cursor:pointer;padding:7px 16px">✍️ 이 강점으로 생기부 문장 만들기</button></div>';
    out+='<div class="mt-3"><button data-act="?@print" class="pill bg-white text-slate-700 font-bold" style="border:1px solid #ccc;cursor:pointer;padding:6px 14px">🖨 결과지 인쇄·PDF 저장</button></div>';
    out+='</div>';
    return out;
  }catch(e){ return ''; }
}
/* 검사 강점 → 생기부 키워드 브릿지 (같은 도메인 localStorage 공유) */
var _VIA2KW={ '창의':'창의성','호기심':'탐구심','판단':'문제해결력','학습열정':'자기주도','통찰':'의사소통','용기':'긍정적태도','끈기':'끈기','정직':'정직','활력':'긍정적태도','사랑':'배려','친절':'배려','사회지능':'의사소통','협력':'협력','공정':'정직','리더십':'리더십','용서':'배려','겸손':'성실','신중':'책임감','자기조절':'성실','심미안':'예술성','감사':'긍정적태도','희망':'긍정적태도','유머':'의사소통','영성':'긍정적태도' };
function _piaRecKeywords(){
  var kws=[], raw=[];
  try{
    var vi=state.results.via.scores;
    if(vi){ raw=viaTopKeys(vi,6); }
  }catch(e){}
  // VIA 없으면 Big5 상위 성향으로 대체
  if(!raw.length){
    try{
      var b=state.results.big5.scores;
      if(b){ var map={openness:['창의성','탐구심'],conscientiousness:['성실','책임감'],extraversion:['발표력','리더십'],agreeableness:['배려','협력'],O:['창의성','탐구심'],C:['성실','책임감'],E:['발표력','리더십'],A:['배려','협력']};
        _topN(b,3).forEach(function(x){ (map[x[0]]||[]).forEach(function(k){raw.push(k);}); }); }
    }catch(e){}
  }
  // VIA 라벨 → 생기부 키워드 매핑(중복 제거)
  var seen={};
  raw.forEach(function(f){ var k=_VIA2KW[f]||f; if(!seen[k]){seen[k]=1; kws.push(k);} });
  return kws.slice(0,6);
}
window.piaSendToRecord=function(){
  try{
    var kws=_piaRecKeywords();
    if(!kws.length){ alert('강점 검사(VIA) 결과가 없어 키워드를 추출하지 못했습니다.\n강점 검사를 먼저 진행하거나 생기부 도우미에서 직접 선택하세요.'); }
    var nm=(state.profile&&state.profile.name)?state.profile.name:'';
    var gr=(state.profile&&state.profile.grade)?state.profile.grade:'';
    var payload={ name:nm, grade:gr, keywords:kws, at:Date.now() };
    try{ localStorage.setItem('pia_rec_bridge', JSON.stringify(payload)); }catch(e){}
    window.open('../teacher-writing.html','_blank');
  }catch(e){ try{ window.open('../teacher-writing.html','_blank'); }catch(_){} }
};
/* ── 결과지 보강(v3.9): 기존 점수를 재해석한 새 페이지. 문항·점수식 무변경, 데이터 없으면 '' 반환 ── */
function _piaTopEntries(obj,n){ try{ return Object.entries(obj||{}).filter(function(e){return typeof e[1]==='number';}).sort(function(a,b){return b[1]-a[1];}).slice(0,n||5); }catch(e){ return []; } }
function renderStrengthCoaching(){
  try{
    var sc=(state.results.via&&state.results.via.scores)||null; if(!sc) return '';
    var top=viaTopKeys(sc,5).map(function(k){ return [k, sc[k]]; }); if(!top.length) return '';
    var TIP={'창의':'새로운 방식으로 문제를 푸는 기회를 찾아보세요 — 자유 주제 발표, 아이디어 노트.','호기심':'낯선 분야를 매주 하나씩 파보세요 — 다큐·전시·현장체험.','판단':'결정 전에 근거 3가지를 적어 비교하는 습관을 들여보세요.','학습열정':'관심 주제를 스스로 깊게 파는 자기주도 프로젝트를 잡아보세요.','통찰':'배운 것을 다른 사람에게 설명하며 큰 그림을 정리해 보세요.','용기':'어렵지만 옳은 선택을 연습해 보세요 — 발표 자원, 의견 말하기.','끈기':'큰 목표를 작은 단계로 쪼개 매일 조금씩 완주해 보세요.','정직':'약속·마감을 지키는 작은 신뢰를 쌓아보세요.','활력':'몸을 쓰는 활동으로 에너지를 발산하고 팀 분위기를 살려보세요.','열정':'몸을 쓰는 활동으로 에너지를 발산하고 팀 분위기를 살려보세요.','사랑':'가까운 사람에게 고마움을 자주 표현해 보세요.','친절':'주변의 어려움을 먼저 살피고 작은 도움을 건네보세요.','사회지능':'상대의 감정을 읽고 배려하는 대화를 연습해 보세요.','협동':'모둠 활동에서 역할을 나누고 조율하는 경험을 쌓아보세요.','팀워크':'모둠 활동에서 역할을 나누고 조율하는 경험을 쌓아보세요.','공정':'규칙을 공평하게 적용하는 상황을 주도해 보세요.','리더십':'작은 모임의 진행·정리를 맡아보세요.','용서':'갈등 후 관계를 회복하는 대화를 시도해 보세요.','겸손':'피드백을 열린 마음으로 받아 성장에 써보세요.','신중':'중요한 일은 계획을 세우고 위험을 미리 점검해 보세요.','자기조절':'집중·휴식 시간을 정해 루틴으로 만들어 보세요.','감상':'좋은 작품·자연을 음미하고 느낀 점을 기록해 보세요.','심미안':'좋은 작품·자연을 음미하고 느낀 점을 기록해 보세요.','감사':'하루 3가지 감사한 일을 적어보세요.','희망':'이루고 싶은 모습을 구체적으로 그리고 한 걸음씩 실행해 보세요.','유머':'분위기를 밝히는 역할로 팀의 긴장을 풀어보세요.','영성':'삶의 의미와 가치를 돌아보는 시간을 가져보세요.'};
    var rows=top.map(function(e,i){ var name=e[0]; var tip=TIP[name]||'이 강점을 살릴 활동을 찾아 꾸준히 실천해 보세요.'; return '<div style="display:flex;gap:10px;padding:9px 0;border-bottom:1px solid #eee"><div style="flex:0 0 26px;height:26px;border-radius:8px;background:#687b4d;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px">'+(i+1)+'</div><div style="flex:1"><b style="color:#3a4a2a">'+name+'</b><div style="font-size:12px;color:#555;margin-top:2px">'+tip+'</div></div></div>'; }).join('');
    return '<div class="rounded-2xl border p-4" style="background:#f6f8f2;border-color:#d7e0c8"><h2 class="text-lg font-bold" style="color:#3a4a2a">🌱 나의 대표 강점 실천 코칭</h2><p class="text-xs" style="color:#5a6b45;margin:2px 0 8px">가장 높게 나온 강점 5가지를 학교·일상에서 이렇게 살려보세요.</p>'+rows+'</div>';
  }catch(e){ return ''; }
}
function renderConvInsight(){
  try{
    var c=state.results.conv; if(!c||!c.turns||c.turns<2) return '';
    var top=_piaTopEntries(c.topics,3).map(function(e){return e[0];});
    var topicTxt= top.length? ('주로 <b>'+top.join(' · ')+'</b> 이야기에 관심을 보였어요.') : '다양한 주제로 편안하게 대화를 이어갔어요.';
    return '<div class="rounded-2xl border p-4" style="background:#eef3fb;border-color:#c9dbf0"><h2 class="text-lg font-bold" style="color:#2c4a6b">💬 자유대화에서 본 나</h2><p class="text-xs" style="color:#3f5b78;margin:2px 0 8px">AI와 '+c.turns+'번 대화를 주고받았어요. '+topicTxt+'</p><p style="font-size:12px;color:#41597a;line-height:1.7">자유대화는 정답이 없는 편안한 이야기로, 관심사와 표현 방식을 살펴보는 참고 자료예요. 위 내용은 대화 흐름을 요약한 것이며 성격을 단정하지 않습니다.</p></div>';
  }catch(e){ return ''; }
}
function render90DayPlan(){
  try{
    var t=(typeof inferIntegratedType==='function')?inferIntegratedType():null;
    var career=(t&&t.careers&&t.careers.length)?t.careers.slice(0,3).join(' · '):'관심 분야';
    function box(title,color,items){ return '<div style="flex:1;min-width:150px;border:1px solid '+color+';border-radius:12px;padding:10px"><div style="font-weight:700;color:'+color+';font-size:13px;margin-bottom:6px">'+title+'</div>'+items.map(function(x){return '<div style="font-size:11.5px;color:#444;padding:3px 0;display:flex;gap:6px"><span>☐</span><span>'+x+'</span></div>';}).join('')+'</div>'; }
    var b1=box('진로 탐색','#c4623f',['추천 진로군('+career+') 중 하나를 골라 관련 직업 1개 조사','그 분야의 인물·영상 3개 찾아보기','학교 동아리·활동과 연결해보기']);
    var b2=box('학습 습관','#4376b6',['약한 과목 1개, 주 3회 30분 루틴 만들기','오답노트·복습 방법 하나 정착시키기','집중·휴식 시간 정해 지키기']);
    var b3=box('강점 활용','#687b4d',['대표 강점 1개를 쓸 활동에 참여하기','강점을 살린 작은 성취 기록하기','친구·가족에게 강점 피드백 받기']);
    var b4=box('마음 관리','#7c6bb0',['수면·운동·식사 규칙 하나 지키기','스트레스 풀 나만의 방법 정하기','힘들 땐 믿을 어른에게 이야기하기']);
    return '<div class="rounded-2xl border p-4" style="background:#fff;border-color:#e3ddcf"><h2 class="text-lg font-bold" style="color:#b45309">🗓️ 90일 성장 실행 플랜</h2><p class="text-xs" style="color:#8a6d3b;margin:2px 0 10px">결과를 행동으로 옮기는 3개월 체크리스트예요. 하나씩 실천하며 칸을 채워보세요.</p><div style="display:flex;flex-wrap:wrap;gap:8px">'+b1+b2+b3+b4+'</div></div>';
  }catch(e){ return ''; }
}
function renderScaleGuide(){
  try{
    var rows=[['IPIP Big-Five-50','성격 5요인(개방성·성실성·외향성·우호성·신경성)','Goldberg(1992), IPIP'],['RIASEC','Holland 진로 흥미 6유형','Holland(1997)'],['VIA 강점','24개 성격강점','Peterson &amp; Seligman(2004)'],['Grit','끈기·근면','Duckworth(2007)'],['다중지능(MI)','8지능 자가평가','Gardner(1983)'],['CES-D / PHQ-A / GAD-7','정서 스크리닝(참고용)','Radloff(1977) 외'],['WHO-5 / RSES','웰빙·자존감','WHO(1998), Rosenberg(1965)']];
    var tr=rows.map(function(r){return '<tr><td style="padding:5px 8px;border-bottom:1px solid #eee;font-weight:600">'+r[0]+'</td><td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:11.5px">'+r[1]+'</td><td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:10.5px;color:#888">'+r[2]+'</td></tr>';}).join('');
    return '<div class="rounded-2xl border p-4" style="background:#fbfaf7;border-color:#e6e1d5"><h2 class="text-lg font-bold" style="color:#4a4a45">📚 검사 개요와 해석 안내</h2><p class="text-xs" style="color:#7a7565;margin:2px 0 8px">이 결과지는 아래 도구를 통합해 구성했습니다.</p><table style="width:100%;border-collapse:collapse;font-size:12.5px"><thead><tr><th style="text-align:left;padding:5px 8px;background:#f1eee6">검사</th><th style="text-align:left;padding:5px 8px;background:#f1eee6">측정 내용</th><th style="text-align:left;padding:5px 8px;background:#f1eee6">근거</th></tr></thead><tbody>'+tr+'</tbody></table><p style="font-size:11px;color:#9a8f7a;margin-top:8px;line-height:1.6">※ 본 결과는 자기보고식 참고 자료로, 의학적·심리학적 <b>진단이 아닙니다</b>. 정서 지표에서 도움이 필요하다고 느끼면 전문기관·상담선생님과 상의하세요.</p></div>';
  }catch(e){ return ''; }
}
function renderExtendedSections() {
  const big5 = state.results.big5.scores;
  const via = state.results.via.scores;
  const riasec = state.results.riasec.scores;
  const type = inferIntegratedType();
  // 결과 정확도 50/100 미만이면 유형에 근거한 정밀 결과(인성덕목·VARK·추천콘텐츠·로드맵)를
  // 통째로 숨기고 재검사 유도 카드 하나로 대체한다. (QA 2026-08-22 P0-1)
  const _acc = (typeof piaAccuracyScore==='function') ? piaAccuracyScore() : { sufficient:true, total:100 };

  let container = el('extended-sections');
  if (!container) {
    container = document.createElement('div');
    container.id = 'extended-sections';
    container.className = 'space-y-5 mt-5';
    // tiposs-charts는 아코디언(#tiposs-charts-acc)으로 감싸져 있으므로 그 아코디언 뒤에 붙인다.
    const tipossAcc = el('tiposs-charts-acc');
    if (tipossAcc) tipossAcc.parentNode.appendChild(container);
    else {
      const detailed = el('detailed-result');
      if (detailed) detailed.appendChild(container);
    }
  }

  container.innerHTML = `
    <div class="bg-gradient-to-r from-indigo-50 to-violet-50 border border-violet-200 rounded-2xl p-4">
      <h2 class="text-lg font-bold text-violet-900">심층 분석 — 추가 참고 자료</h2>
      <p class="text-xs text-violet-700 mt-1">기본 검사 결과를 바탕으로 다양한 이론을 적용한 종합 분석입니다. 의학적·심리학적 진단이 아닌 참고 자료입니다.</p>
    </div>
    ${(function(){ try{ var v=calcReliability().validity; if(v&&(v.grade==='낮음'||v.grade==='주의')){ var low=v.grade==='낮음'; return '<div class="rounded-2xl border p-3" style="background:'+(low?'#fdecec':'#fff7ed')+';border-color:'+(low?'#f5b5b5':'#fed7aa')+'"><b style="color:'+(low?'#b91c1c':'#9a3412')+'">⚠ 응답 성실도: '+v.grade+'</b><div style="font-size:12px;color:#7a3b1a;margin-top:3px">'+(v.reason||'')+' 더 정확한 결과를 위해 천천히 다시 검사하는 것을 권장합니다.</div></div>'; } }catch(_){} return ''; })()}
    ${_acc.sufficient ? '' : (
      '<div class="rounded-2xl border p-4" style="background:#fef2f2;border-color:#fecaca">'
      + '<h3 class="font-semibold text-sm mb-1" style="color:#b91c1c">📋 결과 사용 가능 여부: 보강 필요</h3>'
      + '<p class="text-xs" style="color:#7a3b1a;line-height:1.6">현재 응답만으로는 인성 8대 덕목·학습유형(VARK)·유형별 추천 콘텐츠·진학 로드맵처럼 유형에 근거한 결과를 확정하기 어렵습니다(결과 정확도 ' + _acc.total + '/100, 기준 50점 미만). 아래 검사를 더 완료하거나 천천히 다시 응답하면 표시됩니다.</p>'
      + '<button data-act="?showView" data-arg="via" class="mt-2 text-xs bg-rose-600 text-white px-3 py-1.5 rounded-lg">검사 이어하기 →</button>'
      + '</div>'
    )}
    ${_acc.sufficient ? ((typeof selfIsAdult==='function'&&selfIsAdult())?'':piaAcc('🧬 성격 8요인(인성) 상세 보기', renderInseong8(big5, via), { mt:false, open:true })) : ''}
    ${_acc.sufficient ? piaAcc('🎨 학습유형(VARK) 상세 보기', renderVARK(big5, via, riasec), { mt:false }) : ''}
    ${_acc.sufficient ? piaAcc('🎯 유형별 추천 콘텐츠 보기', renderRecommendations(type.code), { mt:false }) : ''}
    ${_acc.sufficient ? piaAcc('🗺️ 진학·진로 로드맵 보기', renderRoadmap(), { mt:false }) : ''}
    ${(currentAudience === 'parent' && audAllowed('parent')) ? piaAcc('📅 학부모 14일 실천 플랜 보기', renderParent14Day(), { mt:false }) : ''}
    ${(currentAudience === 'teacher' && audAllowed('teacher')) ? piaAcc('🏫 교사 12주 지도 플랜 보기', renderTeacher12Wk(), { mt:false }) + piaAcc('🚨 위기대응 매뉴얼(SOP) 보기', renderCrisisSOP(), { mt:false }) : ''}
    ${(currentAudience==='teacher'&&audAllowed('teacher'))?piaAcc('🗣️ 상담 리포트 보기', renderCounselReport(), { mt:false }):''}
    ${(currentAudience==='teacher'&&audAllowed('teacher'))?piaAcc('🧰 교사 지도 툴킷 보기', renderTeacherToolkit(), { mt:false }):''}
    ${(currentAudience==='teacher'&&audAllowed('teacher'))?piaAcc('🏷️ NICE 연계 카드 보기', renderNiceCard(), { mt:false }):''}
    ${piaAcc('📈 결과 정확도 상세 패널 보기', renderAccuracyPanel(), { mt:false })}
    ${piaAcc('💪 강점 코칭 가이드 보기', renderStrengthCoaching(), { mt:false })}
    ${piaAcc('💬 자유대화 인사이트 보기', renderConvInsight(), { mt:false })}
    ${piaAcc('🗓️ 90일 성장 플랜 보기', render90DayPlan(), { mt:false })}
    ${piaAcc('📏 척도 해석 가이드 보기', renderScaleGuide(), { mt:false })}
    ${piaAcc('🔗 커리어넷 연계 정보 보기', renderCareernetCard(), { mt:false })}
    ${piaAcc('📖 결과 활용 가이드 보기', renderResultUsageGuide(currentAudience), { mt:false })}
    ${piaAcc('🧮 측정 신뢰도(척도별 α) 상세 보기', renderReliabilityStats(), { mt:false })}
  `;
  if(!_piaNormsTried){ _piaNormsTried=true; try{ piaLoadRealNorms(); }catch(e){} }
}

// renderDetailedResult 추가 확장
const _origDet2 = renderDetailedResult;
renderDetailedResult = function() {
  _origDet2();
  try { renderExtendedSections(); } catch(e) { console.warn('확장 섹션 렌더 실패:', e); }
  try { if(typeof piaSyncAudButtons==='function') piaSyncAudButtons(); } catch(e){}
};

// =================================================================
//  v3.7 — 종합 강화 모듈
// =================================================================

// ---- 학생 프로필 입력 모달 ----
var KIOSK_SCHOOL=(function(){try{var u=new URL(location.href);var qs=u.searchParams.get('school');if(qs){localStorage.setItem('kioskSchool',qs);}return localStorage.getItem('kioskSchool')||'';}catch(e){return '';}})();function piaNameVoice(){var SR=window.SpeechRecognition||window.webkitSpeechRecognition;var btn=document.getElementById('pf-name-mic');if(!SR){alert('이 브라우저는 음성 인식을 지원하지 않습니다. 직접 입력해 주세요.');return;}try{var r=new SR();r.lang='ko-KR';r.continuous=false;r.interimResults=false;var orig=btn.textContent;btn.textContent='듣는 중...';btn.disabled=true;r.onresult=function(ev){var tr=(ev.results[0][0].transcript||'').trim();if(tr)document.getElementById('pf-name').value=tr;};r.onerror=function(ev){if(ev.error==='not-allowed'||ev.error==='service-not-allowed'){alert('마이크 사용이 허용되지 않았습니다. 직접 입력해 주세요.');}};r.onend=function(){btn.textContent=orig;btn.disabled=false;};r.start();}catch(e){btn.disabled=false;alert('음성 인식을 시작할 수 없습니다.');}}
/* 단체/키오스크 시작 화면: 학년 선택 대상별 안내 스크립트 + TTS 자동 낭독 */
var PIA_GROUP_GUIDE = {
  elemLow: '자, 우리 다 같이 재미있는 검사를 시작할 거예요. 이건 시험이 아니에요. 잘하고 못하고가 없어요. 문제를 읽고 내 마음이랑 가장 비슷한 걸 콕 누르면 돼요. 옆 친구랑 이야기하지 말고 나만 생각하면서 천천히 하면 돼요. 잘 모르겠으면 손을 번쩍 들어요. 선생님이 도와줄 거예요. 자, 시작 버튼을 눌러 볼까요?',
  elemHigh: '이제 다 같이 나를 알아보는 검사를 시작할게요. 시험이 아니니까 정답은 없어요. 문항을 읽고 지금 내 마음에 가장 가까운 걸 솔직하게 고르면 돼요. 친구와 답을 비교하지 말고 조용히 나에게 집중해 주세요. 너무 서두르지 않아도 괜찮아요. 하다가 궁금한 게 있으면 손을 들어 주세요. 준비됐으면 시작 버튼을 눌러 볼까요?',
  mid: '지금부터 다 같이 나를 알아보는 검사를 시작하겠습니다. 시험이 아니라 내 성격과 강점을 알아보는 시간이라 정답도 오답도 없어요. 각 문항에서 지금 내 마음에 가장 가까운 것을 솔직하게 골라 주세요. 옆 사람과 답을 비교하지 말고 자기 속도로 진행하면 됩니다. 화면이 멈추거나 궁금한 점이 있으면 조용히 손을 들어 주세요. 준비됐으면 시작 버튼을 눌러 시작하겠습니다.',
  adult: '지금부터 나를 이해하기 위한 검사를 시작하겠습니다. 점수를 매기는 시험이 아니라 성향과 강점을 확인하는 과정이므로 정답은 없습니다. 각 문항에서 현재 자신에게 가장 가까운 항목을 솔직하게 선택해 주세요. 주변과 비교하지 말고 본인 속도에 맞춰 진행하시면 됩니다. 진행 중 문제가 있으면 조용히 손을 들어 알려 주세요. 준비되셨으면 시작 버튼을 눌러 주세요.'
};
function piaGuideBucket(g){
  g = String(g||'');
  if(g==='초3'||g==='초4') return 'elemLow';
  if(g==='초5'||g==='초6') return 'elemHigh';
  if(g==='중1'||g==='중2'||g==='중3') return 'mid';
  return 'adult'; /* 고1~고3·대학생·성인 */
}
function piaGuideSpeak(){
  try{
    var sel=document.getElementById('pf-grade'); if(!sel||!sel.value) return;
    var txt=PIA_GROUP_GUIDE[piaGuideBucket(sel.value)]; if(!txt) return;
    if(typeof window.piaSpeak==='function'){ window.piaSpeak(txt); return; }
    if('speechSynthesis' in window){
      var u=new SpeechSynthesisUtterance(txt); u.lang='ko-KR';
      u.rate = /초/.test(sel.value)?0.9:0.95; u.pitch=1.05;
      try{ if(typeof window.piaApplyVoice==='function') window.piaApplyVoice(u); }catch(_e){}
      speechSynthesis.cancel(); speechSynthesis.speak(u);
    }
  }catch(e){ if(window.console) console.error('안내 음성 오류:', e); }
}
function piaRenderGuide(g){
  try{
    var box=document.getElementById('pf-guide'); if(!box) return;
    if(!g){ box.style.display='none'; return; }
    var body=document.getElementById('pf-guide-text');
    if(body) body.textContent = PIA_GROUP_GUIDE[piaGuideBucket(g)] || '';
    box.style.display='block';
    piaGuideSpeak(); /* 학년 선택(사용자 제스처) 시 자동 낭독 */
  }catch(e){ if(window.console) console.error('안내 표시 오류:', e); }
}
/* 홈의 "단체(반) 검사 시작" 진입 → 단체모드 시작 화면(학년 선택+안내 낭독+반 코드) */
function startGroupTest(){
  try{ window._piaGroupMode = true; }catch(_e){}
  try{ if('speechSynthesis' in window && !window.__ttsPrimed){ var _w=new SpeechSynthesisUtterance(' '); _w.volume=0; speechSynthesis.speak(_w); speechSynthesis.resume(); window.__ttsPrimed=true; } }catch(_e){}
  try{ state.profile = null; if(typeof save==='function') save(); }catch(_e){}
  try{
    ensureStudentProfile().then(function(){
      try{ if(typeof renderHome==='function') renderHome(); }catch(_e){}
      try{ if(typeof showView==='function') showView('home'); }catch(_e){}
    });
  }catch(e){ if(window.console) console.error('단체 검사 시작 오류:', e); }
}
/* ── 단체 검사 실시간 세션 클라이언트 (Phase 1+2) ──
   진행률 폴링 upsert + 관제신호(멈춤·공지·개별메시지) 수신 + 이어하기 */
(function(){
  var SS_KEY='pia_group_sess', POLL_MS=8000;
  var _timer=null, _lastBroadcast='', _lastDM='', _joinAt=0, _overlay=null;
  function sb(cb){ try{ if(typeof _piaEnsureSB==='function'){ _piaEnsureSB().then(function(c){ if(c&&c.rpc) cb(c); }); } }catch(e){} }
  function curView(){ try{ var s=document.querySelector('section[data-view]:not(.hidden)'); return s?s.dataset.view:''; }catch(e){ return ''; } }
  var LBL={chat:'AI 자유대화',big5:'성격(Big5)',riasec:'흥미(RIASEC)',via:'강점(VIA)',grit:'끈기(Grit)',sjt:'상황판단(SJT)',cesd:'정서',phqa:'정서',gad:'정서',who5:'정서',rses:'자존감',learn:'학습',mi:'다중지능',home:'검사 메뉴',fullreport:'결과지',result:'결과지'};
  function straightFlag(){
    try{
      var arrs=[state.results.big5&&state.results.big5.answers, state.results.riasec&&state.results.riasec.answers];
      for(var a=0;a<arrs.length;a++){ var ans=arrs[a]||[]; var run=1,mx=1; for(var i=1;i<ans.length;i++){ if(ans[i]!=null&&ans[i]===ans[i-1]){run++; if(run>mx)mx=run;} else run=1; } if(mx>=12) return true; }
    }catch(e){}
    return false;
  }
  function compute(){
    var done=0; try{ done=Object.keys(getCompletedTests()).length; }catch(e){}
    var total=9, pct=Math.max(0,Math.min(100,Math.round(done/total*100)));
    var reqDone=false; try{ reqDone=(typeof missingRequired==='function')&&missingRequired().length===0; }catch(e){}
    var flags=[];
    if(straightFlag()) flags.push('straight');
    if(_joinAt && done>=1){ var perMin=((Date.now()-_joinAt)/60000)/done; if(perMin<1.0) flags.push('fast'); }
    return { current:LBL[curView()]||curView()||'준비', done:done, total:total, percent:pct, status:(reqDone?'done':'active'), flags:flags.join(',') };
  }
  function overlay(show,msg){
    if(show){
      if(!_overlay){ _overlay=document.createElement('div'); _overlay.style.cssText='position:fixed;inset:0;background:rgba(3,105,161,.94);color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:99999;text-align:center;padding:24px;font-weight:800;gap:8px'; _overlay.classList.add('pia-print-hide'); document.body.appendChild(_overlay); }
      _overlay.innerHTML='<div style="font-size:44px">✋</div><div style="font-size:20px">'+(msg||'선생님이 잠시 멈췄어요')+'</div><div style="font-size:13px;font-weight:500;opacity:.9;margin-top:4px">잠깐 기다려 주세요</div><button type="button" id="pia-sess-ovclose" style="margin-top:14px;background:rgba(255,255,255,.2);color:#fff;border:1px solid rgba(255,255,255,.55);border-radius:10px;padding:8px 16px;font-size:13px;font-weight:700;cursor:pointer">✕ 닫기</button>';
      _overlay.style.display='flex';
      try{ var _b=document.getElementById('pia-sess-ovclose'); if(_b) _b.onclick=function(){ overlay(false); }; }catch(e){}
    } else if(_overlay){ _overlay.style.display='none'; }
  }
  function toast(msg){ try{ if(typeof window.showToast==='function') window.showToast(msg); else if(window.PIA&&PIA.toast) PIA.toast(msg); else if(window.console) console.error(msg); }catch(e){} }
  function handleControl(r){
    if(!r) return;
    var st=r.o_session_status||'open';
    if(st==='paused') overlay(true,'선생님이 잠시 멈췄어요');
    else if(st==='closed'){ overlay(false); toast('검사가 종료되었습니다. 수고했어요!'); try{ if(typeof window.piaSessionLeave==='function') window.piaSessionLeave(); else { stop(); window.PIA_SESS=null; try{ sessionStorage.removeItem('pia_group_sess'); }catch(_e){} } }catch(e){} }
    else overlay(false);
    var bc=r.o_broadcast||''; if(bc && bc!==_lastBroadcast){ _lastBroadcast=bc; toast('📢 '+bc); } if(!bc) _lastBroadcast='';
    var dm=r.o_dm||''; if(dm && dm!==_lastDM){ _lastDM=dm; toast('💬 선생님: '+dm); }
  }
  /* GATE YEDAM-SECURITY-ANON-RPC — join_secret(세션 자격) 취급.
     sessionStorage/메모리에만 보관한다. URL·console·analytics 로 내보내지 않는다. */
  function persistSecret(sec){
    try{
      if(!window.PIA_SESS || !sec) return;
      window.PIA_SESS.secret = sec;
      sessionStorage.setItem(SS_KEY, JSON.stringify(window.PIA_SESS));
    }catch(e){ if(window.console) console.error('세션 자격 저장 실패'); }
  }
  function clearSecret(){
    try{ if(window.PIA_SESS){ window.PIA_SESS.secret = null; delete window.PIA_SESS.secret; } }catch(e){}
    try{ if(window.PIA_SESS) sessionStorage.setItem(SS_KEY, JSON.stringify(window.PIA_SESS)); }catch(e){}
  }
  function handleUpsertError(e){
    var msg = '';
    try{ msg = String((e && (e.message || e.msg || e.details)) || ''); }catch(_e){}
    if(msg.indexOf('IDENTITY_MISMATCH') >= 0){
      stop();
      clearSecret();
      toast('세션 자격 확인에 실패했어요. 참여 코드를 다시 입력해 주세요.');
      if(window.console) console.error('진행률 전송 실패: 세션 자격 불일치');
      return;
    }
    if(window.console) console.error('진행률 전송 실패:', e);
  }
  function tick(){
    if(!window.PIA_SESS) return;
    /* Local(YEDAM Backend) 세션은 Supabase 진행률 RPC 대상이 아니다. */
    if(window.PIA_SESS.local) return;
    var p=compute(), s=window.PIA_SESS;
    sb(function(c){
      c.rpc('pia_progress_upsert',{ p_code:s.code, p_student_key:s.key, p_name:(state.profile&&state.profile.name)||'익명', p_grade:(state.profile&&state.profile.grade)||'', p_class:(state.profile&&state.profile.class)||'', p_current:p.current, p_done:p.done, p_total:p.total, p_percent:p.percent, p_status:p.status, p_flags:p.flags, p_join_secret:(s.secret||null) })
       .then(function(r){
         try{
           if(r && r.error){ handleUpsertError(r.error); return; }
           var row = r && r.data && r.data[0];
           if(row && row.o_join_secret){ persistSecret(row.o_join_secret); }
           handleControl(row);
         }catch(e){ if(window.console) console.error('진행률 처리 실패:', e); }
       })
       .catch(function(e){ handleUpsertError(e); });
    });
  }
  function start(){ if(_timer) return; _joinAt=Date.now(); tick(); _timer=setInterval(tick, POLL_MS); }
  function stop(){ if(_timer){ clearInterval(_timer); _timer=null; } }
  window.piaSessionJoin=function(code){
    code=String(code||'').trim().toUpperCase(); if(!code) return;
    var joinLocal = (typeof window._piaExamJoinLocal==='function')
      ? window._piaExamJoinLocal(code) : Promise.resolve(null);
    joinLocal.then(function(d){
      if(d && d.sessionId){
        /* Local 세션. 기관·학급은 서버가 이미 정했다. 화면은 알 필요가 없다. */
        var key=((state.profile&&state.profile.name)||'익명')+'#'+Math.random().toString(36).slice(2,6);
        window.PIA_SESS={ code:code, key:key, title:d.title, sessionId:d.sessionId, local:true };
        try{ sessionStorage.setItem(SS_KEY, JSON.stringify(window.PIA_SESS)); }catch(e){}
        toast('✅ 단체 검사에 연결됐어요'+(d.title?(' ('+d.title+')'):''));
        return;
      }
      /* 예전 Supabase 세션 (하위호환) */
      sb(function(c){
        c.rpc('pia_session_by_code',{p_code:code}).then(function(r){
          var d2=r&&r.data&&r.data[0];
          if(!d2||!d2.session_id){ toast('세션 코드를 찾지 못했어요. 코드를 다시 확인해 주세요.'); return; }
          var key=((state.profile&&state.profile.name)||'익명')+'#'+Math.random().toString(36).slice(2,6);
          window.PIA_SESS={ code:code, key:key, title:d2.title };
          try{ sessionStorage.setItem(SS_KEY, JSON.stringify(window.PIA_SESS)); }catch(e){}
          /* [2026-11-02 기관·반 연결] 세션을 연 기관 — pia_session_org(새 RPC). 없거나 실패하면 조용히 넘어간다(서버도 따로 확인). */
          try{ var _sp=state.profile; c.rpc('pia_session_org',{p_code:code}).then(function(r2){
            try{ var o=r2&&!r2.error&&r2.data&&r2.data[0]; if(o&&o.org_id&&_sp&&state.profile===_sp&&!_sp.orgId){ window._piaClassOrgId=o.org_id; _sp.orgId=String(o.org_id); _sp.orgName=_sp.orgName||o.org_name||''; if(typeof save==='function')save(); } }catch(e){}
          }).catch(function(){}); }catch(e){}
          toast('✅ 단체 검사에 연결됐어요'+(d2.title?(' ('+d2.title+')'):''));
          start();
        }).catch(function(e){ console.error('세션 조회 실패:', e); });
      });
    });
  };
  window.piaSessionLeave=function(){ stop(); clearSecret(); window.PIA_SESS=null; try{ sessionStorage.removeItem(SS_KEY); }catch(e){} };
  try{ var _o=showView; showView=function(n){ _o(n); if(window.PIA_SESS) setTimeout(tick,300); }; }catch(e){}
  /* 새로고침/중단 후 이어하기: 세션 있으면 자동 재연결(초기화 지연) */
  setTimeout(function(){ try{ var raw=sessionStorage.getItem(SS_KEY); if(raw){ var s=JSON.parse(raw); if(s&&s.code&&s.key){ window.PIA_SESS=s; start(); } } }catch(e){} }, 1600);
})();
function ensureStudentProfile() {
  if (state.profile && state.profile.name) return Promise.resolve();
  return new Promise(resolve => {
    var _grp = !!window._piaGroupMode;
    var _hdr = _grp ? '🧑‍🏫 단체(반) 검사 시작' : '👋 안녕하세요!';
    var _sub = _grp ? '선생님 안내에 따라 <b>학년·학교·반 코드</b>를 입력하고 시작하세요. 학년을 선택하면 안내 음성이 자동으로 나옵니다.' : '검사를 시작하기 전 알려주세요. <b>이름·학년·학교를 모두 입력</b>해야 시작할 수 있어요. (반/그룹은 선택)';
    const modal = document.createElement('div');
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;'; modal.classList.add('pia-print-hide');
    modal.innerHTML = `
      <div class="bg-white rounded-2xl p-6 max-w-md w-full">
        <h2 class="text-lg font-bold mb-2">${_hdr}</h2>
        <p class="text-sm text-slate-600 mb-4">${_sub}</p>
        <div class="space-y-3">
          <label class="block">
            <span class="text-xs text-slate-600">이름 또는 별명 <span style="color:#dc2626">*</span></span>
            <div style="display:flex;gap:8px;align-items:center"><input id="pf-name" class="flex-1 min-w-0 border border-slate-300 rounded-lg px-3 py-2 text-sm" placeholder="예: 서연 또는 S001" /><button type="button" id="pf-name-mic" data-act="piaNameVoice" style="white-space:nowrap;border:1px solid #cbd5e1;background:#f1f5f9;border-radius:10px;padding:8px 12px;font-size:12px;font-weight:700">🎤 말하기</button></div>
          </label>
          <div class="grid grid-cols-2 gap-3">
            <label class="block">
              <span class="text-xs text-slate-600">학년 <span style="color:#dc2626">*</span></span>
              <select id="pf-grade" data-act-change="piaRenderGuide" data-arg-value class="w-full mt-1 border border-slate-300 rounded-lg px-3 py-2 text-sm">
                <option value="">선택</option>
                <option>초3</option><option>초4</option><option>초5</option><option>초6</option>
                <option>중1</option><option>중2</option><option>중3</option>
                <option>고1</option><option>고2</option><option>고3</option>
                <option data-i18n="grade.univ">대학생</option><option>성인</option>
              </select>
            </label>
            <label class="block">
              <span class="text-xs text-slate-600">반/그룹 (선택)</span>
              <select id="pf-class" class="w-full mt-1 border border-slate-300 rounded-lg px-3 py-2 text-sm"><option value="">선택 안 함</option><option>1반</option><option>2반</option><option>3반</option><option>4반</option><option>5반</option><option>6반</option><option>7반</option><option>8반</option><option>9반</option><option>10반</option><option>11반</option><option>12반</option><option>13반</option><option>14반</option><option>15반</option><option>16반</option><option>17반</option><option>18반</option><option>19반</option><option>20반</option><option>A조</option><option>B조</option><option>C조</option><option>D조</option><option>E조</option><option>기타</option></select>
            </label>
          </div>
          <label class="block">
            <span class="text-xs text-slate-600">학교/기관 <span style="color:#dc2626">*</span></span>
            <input id="pf-school" class="w-full mt-1 border border-slate-300 rounded-lg px-3 py-2 text-sm" placeholder="예: 샛별중학교" />
          </label>
          <label class="block" style="display:${_grp?'block':'none'}">
            <span class="text-xs text-slate-600">단체 세션 코드 <span style="color:#0369a1;font-weight:700">(선생님이 불러줘요)</span></span>
            <input id="pf-sesscode" inputmode="latin" autocapitalize="characters" class="w-full mt-1 border border-sky-300 bg-sky-50 rounded-lg px-3 py-2 text-sm font-mono tracking-widest uppercase" placeholder="예: 4A9C2A" />
            <span class="text-[11px] text-slate-400">실시간 단체 검사일 때만 입력해요. 선생님 화면에 내 진행이 보여요.</span>
          </label>
          <label class="block">
            <span class="text-xs text-slate-600">반 코드 (선택)</span>
            <input id="pf-orgcode" class="w-full mt-1 border border-slate-300 rounded-lg px-3 py-2 text-sm" placeholder="선생님이 준 6자리 코드 (있으면 입력)" />
            <span class="text-[11px] text-slate-400">입력 시 담당 선생님 반에 결과가 자동 연결됩니다.</span>
          </label>
        </div>
        <div id="pf-guide" style="display:none;margin-top:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:12px;padding:14px 16px">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:6px">
            <span style="font-size:12px;font-weight:800;color:#0369a1">📢 단체 검사 안내 (선생님 대신 읽어드려요)</span>
            <button type="button" data-act="piaGuideSpeak" style="white-space:nowrap;border:1px solid #7dd3fc;background:#e0f2fe;color:#0369a1;border-radius:9px;padding:5px 11px;font-size:12px;font-weight:700">🔊 다시 듣기</button>
          </div>
          <p id="pf-guide-text" style="font-size:13px;line-height:1.7;color:#0c4a6e;margin:0"></p>
        </div>
        <div class="flex gap-2 mt-4">
          <button id="pf-skip" class="flex-1 bg-slate-100 py-2 rounded-lg text-sm">익명으로 시작</button>
          <button id="pf-save" class="flex-1 bg-slate-900 text-white py-2 rounded-lg text-sm font-semibold">시작</button>
        </div>
        <!-- 2026-09-02: 나가기가 없어 단체 검사를 잘못 누르면 빠져나올 수 없었다 -->
        <button id="pf-cancel" class="w-full mt-2 py-2 rounded-lg text-sm text-slate-500 border border-slate-200">← 홈으로 돌아가기</button>
        <p class="text-xs text-slate-400 mt-3 text-center">로그인 시 결과는 보안 서버에 저장됩니다. 자세한 내용은 동의 화면을 참고하세요.</p>
      </div>`;
    document.body.appendChild(modal);
    try{
      var _cx=document.getElementById('pf-cancel');
      if(_cx) _cx.onclick=function(){
        try{ window._piaGroupMode=false; }catch(e){}
        try{ modal.remove(); }catch(e){}
        try{ if(typeof renderHome==='function') renderHome(); }catch(e){}
        try{ if(typeof showView==='function') showView('home'); }catch(e){}
        /* 프로필을 만들지 않았으므로 대기 중인 약속은 그대로 둔다 —
           다음에 검사를 누르면 이 모달이 다시 뜬다. */
      };
    }catch(e){ console.error('프로필 모달 나가기 연결 실패', e); }
    (function(){try{if(KIOSK_SCHOOL){var sEl=document.getElementById('pf-school');if(sEl){sEl.value=KIOSK_SCHOOL;sEl.readOnly=true;sEl.style.background='#f0fdf4';sEl.style.color='#166534';sEl.style.fontWeight='700';}}}catch(e){}})(); const close = (anon=false) => {
      try{ window._piaGroupMode=false; }catch(_e){}
      state.profile = anon ? { name:'익명', grade:'', class:'', school:'', createdAt: Date.now() } : {
        name: el('pf-name').value.trim() || '익명',
        grade: el('pf-grade').value,
        class: el('pf-class').value.trim(),
        school: el('pf-school').value.trim(),
        createdAt: Date.now()
      };
      state.studentId = state.profile.name;
      /* 반 코드 → 기관 연결(있으면).
         [2026-11-02 기관·반 연결] 확인 결과를 메모리(window._piaClassOrgId)에만 두던 탓에 새로고침·이어하기 뒤 연결이 사라지고,
         확인 실패·지연 때는 입력한 코드 자체가 결과에 남지 않았다(운영 결과 전부 기관 없음).
         → 입력값은 곧바로 profile.orgCodeInput 에 남기고(서버가 다시 확인), 확인되면 orgCode·orgName·orgId 를 프로필에 저장한다. */
      try{
        var _oc=(el('pf-orgcode')&&el('pf-orgcode').value||'').trim().toUpperCase().replace(/\s+/g,'');
        if(_oc){
          state.profile.orgCodeInput=_oc;
          if(typeof _piaEnsureSB==='function'){
            var _prof=state.profile;
            _piaEnsureSB().then(function(sb){ if(!sb||!sb.rpc) return;
              sb.rpc('pia_org_by_code',{p_code:_oc}).then(function(r){
                try{
                  if(state.profile!==_prof) return;   /* 그 사이 다른 학생으로 바뀌었으면 붙이지 않는다 */
                  var d=r&&r.data&&r.data[0];
                  if(d&&d.org_id){ window._piaClassOrgId=d.org_id; _prof.orgCode=_oc; _prof.orgName=d.org_name||''; _prof.orgId=String(d.org_id); if(typeof save==='function')save(); }
                  else if(r&&!r.error&&typeof window.showToast==='function'){ window.showToast(_T('반 코드를 찾지 못했어요. 선생님께 코드를 다시 확인해 주세요. (검사는 그대로 진행돼요)','Class code not found. Please check it with your teacher. (You can continue the test.)')); }
                }catch(e){ console.error('반 코드 확인 처리 실패', e); }
              }).catch(function(e){ console.error('반 코드 확인 실패', e); });
            });
          }
        }
      }catch(e){ console.error('반 코드 연결 실패', e); }
      save();
      try{ var _sc=(el('pf-sesscode')&&el('pf-sesscode').value||'').trim(); if(_sc && !anon && typeof window.piaSessionJoin==='function'){ window.piaSessionJoin(_sc); } }catch(_e){ if(window.console) console.error('세션 참여 오류:', _e); }
      modal.remove();
      renderProfileBar();
      resolve();
    };
    el('pf-save').addEventListener('click', () => close(false));
    el('pf-skip').addEventListener('click', () => close(true));
  });
}

// ---- 학생 전환/초기화 ----
function freshResults() {
  return {
    big5:{answers:[],scores:null}, riasec:{answers:[],scores:null}, via:{answers:[],scores:null},
    grit:{answers:[],scores:null}, cesd:{answers:[],scores:null}, phqa:{answers:[],scores:null},
    gad:{answers:[],scores:null}, who5:{answers:[],scores:null}, rses:{answers:[],scores:null}, learn:{answers:[],scores:null}, mi:{answers:[],scores:null},
    riasec60:{answers:[],scores:null},
    sjt:{answers:[],dims:{},order:[],adaptive:false},
    conv:{turns:0,dims:{},riskHist:[],topics:{},transcript:[],abuse:0}
  };
}
function editProfile() {
  // 이름·학년만 다시 입력 (검사 데이터는 유지)
  state.profile = null; save();
  ensureStudentProfile().then(function(){ if (typeof renderHome==='function') renderHome(); });
}
/* 필수 3종만 되돌린다. 선택 검사(via·grit·learn 등) 결과는 그대로 둔다 —
   학생이 대화를 다시 하고 싶다고 해서 이미 마친 선택 검사까지 날리면
   같은 문항을 또 풀어야 한다. 초기값은 freshResults() 에서 가져와
   구조가 바뀌어도 여기와 어긋나지 않게 한다. */
/* 완료 화면(AIPIA-03/06) 공용 마크업.
   예전에는 문항 완료와 대화 완료가 서로 다른 화면이었다 —
   대화 쪽은 말풍선 아래에 작은 버튼 두 개만 붙였다.
   시안은 둘 다 같은 완료 화면이므로 여기서 한 번만 만든다.
   opts = { 제목, 부제, 안내, 다음id, 다음라벨 } */
function piaDoneHTML(opts) {
  var o = opts || {};
  var P = window.PIA;
  var _pldh = (window.aipiaCurrentLang === 'en');
  var 단계 = [];
  try { 단계 = (typeof REQUIRED_TESTS !== 'undefined') ? REQUIRED_TESTS : []; } catch (e) { 단계 = []; }

  /* REQUIRED_TESTS 의 label 은 내부 명칭이라 화면 말과 다르다.
     홈·문항 화면과 같은 말로 맞춘다. */
  var 이름 = _pldh
    ? { chat:'AI Chat', big5:'My Personality', riasec:'Career Interests' }
    : { chat:'AI와 대화', big5:'나의 성격', riasec:'진로 흥미' };
  var 완료수 = 0;
  var 칸 = '';
  for (var i = 0; i < 단계.length; i++) {
    var t = 단계[i], dn = false;
    try { dn = !!t.done(); } catch (e) {}
    if (dn) 완료수++;
    var 현재 = (!dn && t.id === o.다음id);
    var cls = dn ? 'done' : (현재 ? 'now' : 'lock');
    칸 += '<div class="pia-dstep pia-dstep--' + cls + '">'
        + '<span class="pia-dstep__n">' + (dn ? '\u2713' : (i + 1)) + '</span>'
        + '<span class="pia-dstep__t">' + (이름[t.id] || t.label) + '</span>'
        + '</div>';
  }

  var 다음버튼 = o.다음id
    ? P.btn((_pldh?'Next: ':'다음: ') + o.다음라벨, "showView('" + o.다음id + "')", 'primary', { cta: 1, arrow: 1 })
    : P.btn((_pldh?'View Full Report':'통합 결과 보기'), "showView('result')", 'primary', { cta: 1, arrow: 1 });

  return '<div class="pia"><section class="pia-sec pia-done">'
    + '<div class="pia-done__mark" aria-hidden="true">'
    +   '<span class="pia-done__ck">\u2713</span>'
    +   '<img class="pia-done__fox" src="' + (window.PIA_BOT_HERO || '/images/pia-fox-hero.webp') + '" alt="" loading="eager" fetchpriority="high" decoding="async">'
    + '</div>'
    + '<h2 class="pia-done__t">' + (o.제목 || (_pldh?'Assessment complete':'검사를 마쳤어요')) + '</h2>'
    + (o.부제 ? '<p class="pia-done__sub">' + o.부제 + '</p>' : '')
    + (o.안내 ? '<p class="pia-done__d">' + o.안내 + '</p>' : '')
    + '<div class="pia-done__hr"><span>' + (_pldh?'Required Assessments ':'필수 검사 ') + 완료수 + '/' + (단계.length || 3) + (_pldh?' done':' 완료') + '</span></div>'
    + '<div class="pia-dsteps">' + 칸 + '</div>'
    + 다음버튼
    + P.btn((_pldh?'Back to Menu':'검사 메뉴로'), "showView('home')", 'secondary')
    + '<p class="pia-done__auto" aria-live="polite">'
    +   (o.다음id ? (_pldh?'Moving on to the next assessment shortly':'잠시 후 자동으로 다음 검사로 이동해요') : (_pldh?'Moving to your report shortly':'잠시 후 자동으로 결과지로 이동해요'))
    + '</p>'
    + '</section></div>';
}
try { window.piaDoneHTML = piaDoneHTML; } catch (e) {}

/* 대화 화면의 'AI 답변 음성 재생' 토글.
   설정은 원래 숨은 체크박스(#chat-tts)에 있었다 — 학생이 끌 방법이 없었다.
   버튼은 그 체크박스를 그대로 조작해, 기존 재생 로직은 손대지 않는다. */
/* 마이크와 '답변 보내기' 를 한 줄 2열로 세운다.
   마크업상 마이크는 입력 상자 안(.pia-say), 보내기는 그 아래 별도 줄에 있다.
   float 로 맞추면 높이가 달라질 때 어긋나므로 DOM 에서 같은 부모로 옮긴다. */
function piaMountSendRow() {
  try {
    var mic = document.getElementById('chat-mic');
    var row = document.querySelector('section[data-view="chat"] .pia-sendrow');
    if (!mic || !row || mic.parentElement === row) return;
    row.insertBefore(mic, row.firstChild);
  } catch (e) {
    console.error('전송 줄 배치 실패:', e);
  }
}
try {
  window.piaMountSendRow = piaMountSendRow;
  if (document.readyState !== 'loading') piaMountSendRow();
  document.addEventListener('DOMContentLoaded', piaMountSendRow);
  setTimeout(piaMountSendRow, 600);
} catch (e) {}

function piaToggleChatTts() {
  try {
    var cb = document.getElementById('chat-tts');
    var btn = document.getElementById('chat-tts-btn');
    var lab = document.getElementById('chat-tts-label');
    if (!cb) return;
    cb.checked = !cb.checked;
    try { cb.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    if (!cb.checked) { try { if (window.piaStopSpeak) piaStopSpeak(); } catch (e) {} }
    if (btn) btn.setAttribute('aria-pressed', cb.checked ? 'true' : 'false');
    if (lab) lab.textContent = 'AI 답변 음성 재생 ' + (cb.checked ? '켜짐' : '꺼짐');
  } catch (e) {
    console.error('음성 재생 토글 실패:', e);
  }
}
try { window.piaToggleChatTts = piaToggleChatTts; } catch (e) {}

function piaRestartRequired() {
  try {
    if (!confirm('필수 검사 3종을 다시 시작할까요?\nAI와 대화·나의 성격·진로 흥미의 답안이 지워집니다.\n(선택 검사 결과는 그대로 유지됩니다)')) return;
    var 초기 = freshResults();
    for (const k of ['conv', 'big5', 'riasec']) {
      state.results[k] = 초기[k];
    }
    save();
    /* state 는 리셋됐지만 '대화 진행 12/12' 표시(#chat-turn)는 다음 메시지를
       보낼 때만 갱신되던 별도 DOM 이라, 리셋 직후엔 이전 학생의 숫자가 그대로
       남아 '초기화가 안 된다'로 보였다. 리셋과 동시에 화면 표시도 지운다. */
    try{
      var _tc=document.getElementById('chat-turn'); if(_tc) _tc.textContent=_turnLabel(0);
      if(typeof renderChatStarter==='function') renderChatStarter();
    }catch(_e){}
    if (typeof renderHome === 'function') renderHome();
    /* 홈에 머물면 '그래서 어디서 다시 시작하지?' 를 한 번 더 찾아야 한다.
       초기화했으면 곧장 1단계(AI와 대화)로 데려간다. */
    if (typeof piaStartFlow === 'function') piaStartFlow();
    else if (typeof showView === 'function') showView('home');
  } catch (e) {
    console.error('필수 검사 다시하기 실패:', e);
    if (typeof toast === 'function') toast('다시 시작하지 못했어요. 잠시 후 다시 시도해 주세요.');
    else alert('다시 시작하지 못했어요. 잠시 후 다시 시도해 주세요.');
  }
}
try { window.piaRestartRequired = piaRestartRequired; } catch(e) {}

function newStudent(옵션) {
  var _바로 = !!(옵션 && 옵션.바로시작);
  /* 홈의 '검사 새로 시작하기' 는 다음 학생으로 넘기는 정상 동선이라 확인창 없이 바로 간다.
     인자 없이 부르는 경로(무입력 자동 초기화 등)는 확인을 유지한다. */
  if (!_바로 && !confirm('새 학생을 시작할까요?\n현재 학생의 검사 답안·결과·대화가 모두 초기화됩니다. (엔진 설정은 유지)')) return;
  /* 백업(다운로드) 확인창은 없앴다. 키오스크에서 학생이 바뀔 때마다
     '저장할까요?'가 한 번 더 뜨면 다음 학생이 눌러야 할 버튼이 늘고,
     실수로 눌러 앞 학생 파일이 기기에 남는다. 초기화는 그냥 초기화한다. */
  state.results = freshResults();
  state.profile = null;
  try{ sessionStorage.removeItem(PROFILE_KEY); }catch(e){}
  state.studentId = 'S001';
  currentAudience = 'student';
  // 공용 기기 보호: 새 학생 시작 시 교사 동의생략 플래그 해제 → 학생 동의 절차 정상 복원
  /* 공용 기기 보호. 예전에는 pia_aud_teacher 를 localStorage 에서 지웠는데
     실제로는 sessionStorage 에 쓰고 있어서 아무것도 안 지워졌다.
     그리고 열람 코드(pia_v3_paircode)가 남아 한 키오스크의 모든 학생이
     같은 코드를 갖게 되어, 학부모가 남의 자녀 결과를 볼 수 있었다. */
  try{
    ['pia_v3_paircode','pia_aud_teacher','pia_v3_consent','pia_sb_rows',
     'pia_admin_outbox','pia_view_record','pia_v3_profile',
     'pia_rec_bridge'].forEach(function(k){
      try{ localStorage.removeItem(k); }catch(e){}
      try{ sessionStorage.removeItem(k); }catch(e){}
    });
  }catch(e){}
  try { _aiSumCache = {}; _aiSumSig = null; } catch(e) {}
  /* 이전 학생의 공유(QR) 토큰이 남아 있으면 새 학생 결과가 그 링크로 나간다. */
  try { _piaShareToken = null; _piaShareTokenPII = false; } catch(e) {}
  save();
  /* 대화 진행 카운터 DOM은 state 리셋과 별개라 이전 학생의 턴수가 남는다.
     리셋과 동시에 화면 표시도 지운다. (2026-09-04) */
  try{
    var _tc=document.getElementById('chat-turn'); if(_tc) _tc.textContent=_turnLabel(0);
    var _tcn=document.getElementById('chat-turn-n'); if(_tcn) _tcn.textContent='0';
    var _tcp=document.getElementById('chat-turn-pct'); if(_tcp) _tcp.textContent='0%';
    var _tcb=document.getElementById('chat-turn-bar'); if(_tcb){ _tcb.style.width='0%'; var _pr=_tcb.parentNode; if(_pr&&_pr.setAttribute) _pr.setAttribute('aria-valuenow',0); }
  }catch(_e){}
  // 결과 화면 잔여 컨테이너 정리
  ['detailed-result','extended-sections','tiposs-charts'].forEach(function(id){ const e=document.getElementById(id); if(e) e.innerHTML=''; });
  if (typeof destroyCharts==='function') { try { destroyCharts(); } catch(e){} }
  /* 누르는 즉시 홈으로 되돌린다. 예전에는 프로필 입력이 끝난 뒤에야 홈을 그려서,
     프로필 모달 뒤에 앞 학생의 대화 화면(예: '대화 진행 13/12', 잠긴 입력창)이
     그대로 남아 있었다. 그래서 '초기화가 안 된다'로 보였다. */
  function _홈으로() {
    try {
      if (typeof renderHome==='function') renderHome();
      if (typeof showView==='function') showView('home');
    } catch(e) { console.error('홈 복귀 실패:', e); }
  }
  _홈으로();
  /* 홈에 머물면 '그래서 어디서 시작하지?' 를 한 번 더 눌러야 한다.
     초기화했으면 '검사 시작하기' 를 누른 것과 같은 자리(동의 화면)로 바로 보낸다.
     이름·학년은 동의 다음 단계에서 받으므로 여기서 모달을 띄우지 않는다. */
  if (_바로 && typeof piaStartFlow === 'function') {
    try { piaStartFlow(); return; }
    catch (e) { console.error('검사 새로 시작 실패:', e); }
  }
  /* 옛 '안녕하세요!' 모달(ensureStudentProfile)은 부르지 않는다.
     정보 입력은 동의 다음 단계인 setup 화면 하나로 일원화했다.
     초기화 후에는 홈만 보여주고, 다음 학생이 '검사 시작하기' 를 누르면
     동의 → 정보 입력 순서로 정상 진행된다. */
  _홈으로();
}

// ---- 학생 칩 (검사 화면 '← 홈' 줄 오른쪽) ----
/* 예전에는 헤더 아래에 가로 바를 깔고 이름·자동저장·이름수정·새학생(초기화)을
   모두 담았다. 홈 첫 화면이 시안보다 한 줄 내려앉고, 공용 키오스크에서
   학생 이름이 계속 노출됐다. 지금은 검사 화면에서만, 이름 칩 하나만 띄운다. */
function renderProfileBar() {
  try {
    var 옛 = document.getElementById('profile-bar');
    if (옛 && 옛.parentNode) 옛.parentNode.removeChild(옛);   /* 캐시된 옛 바 정리 */
    piaMountWhoChip();
  } catch (e) { console.error('학생 칩 표시 실패:', e); }
}

function piaWhoChipHtml() {
  var p = (typeof state !== 'undefined' && state.profile) ? state.profile : null;
  if (!p || !p.name) return '';
  var 이름 = _escHtml(p.name);
  var 뒤 = [];
  if (p.grade) 뒤.push(_escHtml(p.grade));
  if (p.class) 뒤.push(_escHtml(p.class));
  return '<span class="pia-who" title="' + 이름 + '">'
       + '<span class="pia-who__av" aria-hidden="true">' + _escHtml(p.name.slice(0, 1)) + '</span>'
       + '<span class="pia-who__nm">' + 이름 + '</span>'
       + (뒤.length ? '<span class="pia-who__sub">' + 뒤.join(' · ') + '</span>' : '')
       + '</span>';
}

/* '← 홈' 버튼을 flex 줄로 감싸고 그 오른쪽 끝에 칩을 붙인다.
   섹션마다 한 번만 감싸고, 이후에는 칩 내용만 갈아 끼운다. */
function piaMountWhoChip() {
  var html = piaWhoChipHtml();
  var 섹션들 = document.querySelectorAll('section[data-view] .pia-back');
  for (const 뒤로 of 섹션들) {
    try {
      var 뷰 = 뒤로.closest('section[data-view]');
      if (!뷰 || 뷰.getAttribute('data-view') === 'home') continue;
      var 줄 = 뒤로.parentElement;
      if (!줄 || !줄.classList.contains('pia-topbar')) {
        줄 = document.createElement('div');
        줄.className = 'pia-topbar';
        뒤로.parentNode.insertBefore(줄, 뒤로);
        줄.appendChild(뒤로);
      }
      /* 가운데 화면 이름도 이 줄 안에 있어야 가운데로 온다.
         마크업상으로는 줄 바깥에 있어서 옮겨 넣는다. */
      var 제목 = 뷰.querySelector('.pia-topbar__t');
      if (제목 && 제목.parentElement !== 줄) 줄.appendChild(제목);

      var 칩 = 줄.querySelector('.pia-who');
      if (!html) { if (칩) 칩.remove(); continue; }
      if (칩) 칩.outerHTML = html; else 줄.insertAdjacentHTML('beforeend', html);
    } catch (e) { console.error('학생 칩 부착 실패:', e); }
  }
}
try { window.piaMountWhoChip = piaMountWhoChip; } catch (e) {}

/* 화면이 바뀔 때마다 칩을 최신 상태로 다시 붙인다.
   MutationObserver 는 2026-08-22 프리즈 전례가 있어 쓰지 않고 showView 를 감싼다. */
(function () {
  try {
    if (window.__piaWhoHooked || typeof window.showView !== 'function') return;
    window.__piaWhoHooked = true;
    var 원래 = window.showView;
    window.showView = function (n) {
      var r = 원래.apply(this, arguments);
      try { piaMountWhoChip(); } catch (e) { console.error('학생 칩 갱신 실패:', e); }
      return r;
    };
  } catch (e) { console.error('showView 후킹 실패:', e); }
})();

// ---- 검사 별 즉시 미니 해석 ----
function showMiniInterpretation(testKey) {
  const interp = {
    big5: (s) => s ? `검사 완료! 가장 높은 차원: ${getTopBig5(s)}. 5개 차원이 모두 측정되었습니다.` : '',
    riasec: (s) => s ? `Holland 코드: ${getRiasecCode(s)} — 진로 흥미가 명확히 파악되었습니다.` : '',
    via: (s) => s ? `당신의 상위 강점 3개: ${getTopVIA(s).join(', ')}.` : '',
    grit: (s) => s ? `끈기·근면 종합: ${s.overall}점 — ${s.overall>=70?'장기 목표 추구 강함':s.overall>=50?'균형 잡힌 끈기':'단기 흥미가 다양함'}` : '',
    sjt: () => 'SJT 30 시나리오 완료! 행동 예측 데이터를 통합 분석에 반영합니다.',
    cesd: (s) => s ? `우울 스크리닝: ${s.level} (${s.total}/30). ${s.level==='HIGH'?'전문가 상담 권장.':'특별한 신호 없음.'}` : '',
    phqa: (s) => s ? `청소년 우울 ${s.level}. ${s.selfHarm>0?'⚠ 즉시 1577-0199 또는 1388 연락.':'안전 신호 없음.'}` : '',
    gad: (s) => s ? `불안 ${s.level} (${s.total}/21). ${s.level==='HIGH'?'정서 안정 활동 권장.':'안정 범위.'}` : '',
    conv: () => '자유대화 완료! AI가 대화에서 추출한 신호를 통합 결과에 반영합니다.'
  };
  const fn = interp[testKey];
  if (!fn) return '';
  const scores = state.results[testKey]?.scores || (testKey==='conv'?true:null);
  return fn(scores);
}

function getTopBig5(s) {
  const arr = [['외향성',s.E],['우호성',s.A],['성실성',s.C],['정서안정',100-s.N],['개방성',s.O]];
  arr.sort((a,b)=>b[1]-a[1]);
  return `${arr[0][0]} (${arr[0][1]}점)`;
}
function getRiasecCode(s) {
  return Object.entries(s).sort((a,b)=>b[1]-a[1]).slice(0,3).map(e=>e[0]).join('');
}
function getTopVIA(s) {
  return Object.entries(s).sort((a,b)=>b[1]-a[1]).slice(0,3).map(e=>e[0]);
}

// ---- 검사 완료 즉시 토스트 알림 ----
function showCompletionToast(testKey) {
  const text = showMiniInterpretation(testKey);
  if (!text) return;
  const toast = document.createElement('div');
  toast.style.cssText = 'position:fixed;top:24px;right:24px;background:white;border:2px solid #10B981;border-radius:14px;padding:14px 18px;max-width:380px;box-shadow:0 8px 30px rgba(0,0,0,.15);z-index:999;animation:slideIn .3s ease;pointer-events:none;';
  toast.innerHTML = `
    <div class="flex items-start gap-2" style="pointer-events:auto">
      <span class="text-emerald-600 text-xl">✓</span>
      <div>
        <div class="font-bold text-sm mb-1">검사 완료!</div>
        <div class="text-xs text-slate-700 leading-relaxed">${text}</div>
        <div class="text-xs text-slate-500 mt-2"><a data-act="showView" data-arg="home" class="cursor-pointer underline">← 다음 검사 →</a> · <a data-act="showView" data-arg="result" class="cursor-pointer underline">현재까지 결과</a></div>
      </div>
      <button data-act=\'[["@remove",2]]\' class="text-slate-400 hover:text-slate-700">×</button>
    </div>`;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 8000);
}

// ---- 데이터 백업/복원 ----
function exportAllData() {
  const data = {
    version: 'v3.7',
    exportedAt: new Date().toISOString(),
    profile: state.profile,
    results: state.results,
    meta: state.meta
  };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type:'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `AI_PIA_백업_${(state.profile?.name||'anon')}_${Date.now()}.json`;
  a.click();
}

function importAllData(file) {
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = JSON.parse(e.target.result);
      if (data.profile) state.profile = data.profile;
      if (data.results) state.results = data.results;
      if (data.meta) state.meta = data.meta;
      if (data.profile?.name) state.studentId = data.profile.name;
      save();
      alert("백업이 복원되었습니다. 페이지를 새로고침합니다.");
      location.reload();
    } catch(err) { alert("복원 실패: " + err.message); }
  };
  reader.readAsText(file);
}

// ---- 응답 시간 추적 ----
function trackResponseTime(testKey, ms) {
  if (!state.responseTimes) state.responseTimes = {};
  if (!state.responseTimes[testKey]) state.responseTimes[testKey] = [];
  state.responseTimes[testKey].push(ms);
  save();
}

function calcResponseReliability(testKey) {
  const arr = state.responseTimes?.[testKey] || [];
  if (arr.length < 5) return { reliable: true, reason: "데이터 부족" };
  const avg = arr.reduce((s,v)=>s+v,0) / arr.length;
  const tooFast = arr.filter(t => t < 800).length;
  if (avg < 1500) return { reliable: false, reason: "응답이 너무 빠릅니다. 한 번 더 검사를 권장합니다." };
  if (tooFast > arr.length * 0.4) return { reliable: false, reason: "40% 이상의 응답이 1초 이하입니다." };
  return { reliable: true, reason: "응답 패턴 양호" };
}

// ---- 항상 보이는 진행률 인디케이터 ----
function renderHeaderProgress() {
  let bar = el("header-progress");
  if (!bar) {
    bar = document.createElement("div");
    bar.id = "header-progress";
    bar.className = "hidden sm:flex items-center gap-2 text-xs";
    const nav = el("topNav");
    if (nav) nav.parentNode.insertBefore(bar, nav);
  }
  const counts = {
    big5: state.results.big5?.answers?.length || 0,
    riasec: state.results.riasec?.answers?.length || 0,
    via: state.results.via?.answers?.length || 0,
    grit: state.results.grit?.answers?.length || 0,
    sjt: state.results.sjt?.answers?.length || 0,
    conv: state.results.conv?.turns || 0,
    cesd: state.results.cesd?.answers?.length || 0,
    phqa: state.results.phqa?.answers?.length || 0,
    gad: state.results.gad?.answers?.length || 0,
    who5: state.results.who5?.answers?.length || 0,
    rses: state.results.rses?.answers?.length || 0,
    learn: state.results.learn?.answers?.length || 0,
    mi: state.results.mi?.answers?.length || 0
  };
  const totals = { big5:50, riasec:30, via:24, grit:8, sjt:(typeof sjtSet==='function'?sjtSet().length:30), conv:8, cesd:10, phqa:9, gad:7, who5:5, rses:10, learn:14, mi:16 };
  const _tot = Object.keys(totals).length;
  const done = Object.entries(counts).filter(([k,v]) => v >= totals[k]).length;
  bar.innerHTML = `<span class="text-slate-500">진행</span><div class="w-24 h-1.5 bg-slate-200 rounded-full overflow-hidden"><div class="h-full bg-emerald-500" style="width:${Math.round(done/_tot*100)}%"></div></div><span class="font-semibold">${done}/${_tot}</span>`;
}

// ---- 검사 히스토리 스냅샷 ----
function saveSnapshot() {
  if (!state.history) state.history = [];
  const type = inferIntegratedType();
  const rel = calcReliability();
  state.history.push({ t: Date.now(), type: type.name, code: type.code, grade: rel.grade });
  if (state.history.length > 20) state.history.shift();
  save();
}

// ---- 진입 격려 메시지 ----
const ENCOURAGEMENTS = [
  "편안한 마음으로 시작해보세요. 정답은 없습니다.",
  "솔직하게 답할수록 결과가 정확해집니다.",
  "한 문항씩 천천히, 부담 없이 진행하세요.",
  "진행 상황은 자동 저장됩니다. 잠시 쉬어도 괜찮습니다.",
  "직감으로 답해도 좋습니다.",
  "당신의 응답에 옳고 그름은 없어요."
];

function showStartEncouragement(testKey) {
  const msg = ENCOURAGEMENTS[Math.floor(Math.random()*ENCOURAGEMENTS.length)];
  const banner = document.createElement("div");
  banner.style.cssText = "position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:white;border:2px solid #7C3AED;border-radius:14px;padding:10px 18px;max-width:360px;box-shadow:0 8px 20px rgba(0,0,0,.12);z-index:999;text-align:center;pointer-events:none;";
  banner.innerHTML = `<div class="text-xs text-violet-900">💡 ${msg}</div>`;
  document.body.appendChild(banner);
  setTimeout(() => banner.remove(), 5000);
}

// ---- 자동 저장 인디케이터 ----
function blinkAutosave() {
  /* 2026-08-31 QA: 전역 el 이 덮여 있어도 전송이 멈추지 않게 직접 찾는다 */
  const i = document.getElementById("autosave-indicator");
  if (!i) return;
  i.textContent = "💾 저장 중...";
  i.style.color = "#F59E0B";
  setTimeout(() => {
    i.textContent = "💾 자동 저장됨";
    i.style.color = "#10B981";
  }, 600);
}

// ===== 결과 관리자 서버 전송 (Netlify API) =====
/* 결과 API 기본 주소.
   2026-08-08 Netlify → IDC 자체 서버(Cloudflare Tunnel)로 이전.
   localStorage.pia_api_base 가 있으면 그 값이 우선하므로,
   문제가 생기면 아래 한 줄로 즉시 되돌릴 수 있다.
     localStorage.setItem('pia_api_base','https://brilliant-macaron-4b3ed2.netlify.app') */
const PIA_API_DEFAULT = 'https://api.yedam.kr';
function piaApiBase(){
  try{ const o=(localStorage.getItem('pia_api_base')||'').trim();
    /* localStorage 는 누구나 쓸 수 있으므로 덮어쓰기를 그대로 믿지 않는다.
       허용 범위는 주소를 따로 적어두지 않고 PIA_API_DEFAULT 와 현재 페이지에서
       끌어낸다 — 서버를 옮길 때 PIA_API_DEFAULT 한 줄만 고치면 된다. */
    let b = PIA_API_DEFAULT;
    if (o) {
      let host = '';
      try { const u = new URL(o); if (u.protocol === 'https:') host = u.hostname; } catch(e) {}
      const allowed = [];
      for (const ref of [PIA_API_DEFAULT, location.origin]) {
        try { allowed.push(new URL(ref).hostname); } catch(e) {}
      }
      // 기본 API 와 같은 등록도메인(예: yedam.kr)이면 하위 호스트도 허용한다.
      const root = (h) => h.split('.').slice(-2).join('.');
      const ok = allowed.some(a => host === a || root(host) === root(a));
      if (ok) b = o;
      else if (host) console.error('[보안] 허용되지 않은 결과 API 주소를 무시했습니다:', o);
    }
    if(!b || b.indexOf('__')===0) return ''; return b.replace(/\/+$/,''); }
  catch(e){ return ''; }
}
function _piaDoneCount(){
  let n=0; try{ const R=state.results;
    ['big5','riasec','via','grit','cesd','phqa','gad','who5','rses','learn','mi'].forEach(k=>{ if(R[k]&&R[k].scores) n++; });
    if(R.sjt&&R.sjt.answers&&R.sjt.answers.length>=10) n++;
  }catch(e){} return n;
}
function getPairCode(){
  /* P0 수정: 열람 코드는 서버가 저장 응답으로 발급한다(pia_results.pair_code).
     브라우저 localStorage 코드(pia_v3_paircode)는 한 기기의 모든 학생이 공유하므로 쓰지 않는다. */
  try{ var c=(state&&state.profile&&state.profile.pairCode)||''; if(/^[A-Z0-9]{6}$/.test(c)) return c; }catch(e){}
  return '';
}
/* [2026-11-02 E2-E] 시연 모드 — 주소에 ?demo=1 을 붙이면 켜지고(?demo=0 끄기) 이 탭을 닫을 때까지 유지된다.
   이 모드에서 저장한 결과는 demo:true 로 보내 서버가 is_test 로 표시한다 → 척도 통계·백분위·기술문서에서 처음부터 빠진다.
   결과 자체는 그대로 저장·조회된다(결과지·열람코드 정상). */
function piaDemoMode(){
  try{
    var q=new URLSearchParams(piaEffectiveSearch()).get('demo');
    if(q==='1') sessionStorage.setItem('pia_demo','1'); else if(q==='0') sessionStorage.removeItem('pia_demo');
    return sessionStorage.getItem('pia_demo')==='1';
  }catch(e){ return false; }
}
try{ window.piaDemoMode = piaDemoMode; }catch(e){}
(function(){
  function badge(){ try{ if(!piaDemoMode()||document.getElementById('pia-demo-badge')||!document.body) return;
    var b=document.createElement('div'); b.id='pia-demo-badge'; b.className='pia-demo-badge no-print'; b.setAttribute('role','status');
    b.textContent=_T('시연 모드 · 통계 제외','Demo mode · excluded from stats'); document.body.appendChild(b); }catch(e){} }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',badge); else badge();
})();
function buildAdminRecord(){
  let type='', rel='', _relObj=null, validity='';
  try{ type=(inferIntegratedType()||{}).name||''; }catch(e){}
  try{ _relObj=calcReliability()||{}; rel=_relObj.grade||''; validity=(_relObj.validity&&_relObj.validity.grade)||''; }catch(e){}
  const p=state.profile||{};
  const id=((state.studentId||'S')+'_'+(p.createdAt||'anon'));
  return { id, name:p.name||'익명', grade:p.grade||'', klass:p.class||'', school:p.school||'',
    type, reliability:rel, validity:validity, validityDetail:(_relObj&&_relObj.validity)||null, doneCount:_piaDoneCount(),
    version:'v3.7', exportedAt:new Date().toISOString(), pairCode:(getPairCode()||null),
    demo:(piaDemoMode()||undefined),
    /* [2026-11-02 기관·반 연결] 단체 세션으로 응시했다는 근거 — 서버가 세션 코드로 기관을 확인한다(orglink.js). 이름은 sessionCode 와 겹치지 않게 둔다. */
    examSession:(function(){ try{ var ss=window.PIA_SESS; return (ss&&ss.code)?{ code:String(ss.code).toUpperCase(), local:!!ss.local }:undefined; }catch(e){ return undefined; } })(),
    results:state.results, meta:state.meta, profile:p,
    summary:(function(){ var s={}; try{ var t=inferIntegratedType(); s.type=t&&t.name||''; }catch(e){}
      try{ var rl=calcReliability(); s.reliability=rl&&rl.grade||''; }catch(e){}
      try{ var cd=state.results.cesd&&state.results.cesd.scores, pq=state.results.phqa&&state.results.phqa.scores, gd=state.results.gad&&state.results.gad.scores;
        var warn=false; [cd,pq,gd].forEach(function(x){ if(x&&(x.level==='HIGH'||x.level==='MEDIUM'))warn=true; });
        if(pq&&pq.selfHarm>0)warn=true;
        s.emotion = (cd||pq||gd)?(warn?'주의':'정상'):''; }catch(e){}
      return s; })() };
}

// ---- Supabase 회원 결과 자동 저장(로그인 시) ----
var _piaSB=null;
function _piaEnsureSB(){
  return new Promise(function(res){
    if(_piaSB){res(_piaSB);return;}
    function mk(){ try{ _piaSB=window.supabase.createClient('https://ushtyxnmqclzgdnynusm.supabase.co','sb_publishable_3PiMntSUB0kufZ9Wrvp0mA_a1Ump102'); }catch(e){ _piaSB=null; } res(_piaSB); }
    if(window.supabase&&window.supabase.createClient){ mk(); return; }
    var sc=document.createElement('script'); sc.src='/vendor/supabase-js-2.112.1.umd.js';
    sc.onload=mk; sc.onerror=function(){ res(null); }; document.head.appendChild(sc);
  });
}
function piaSaveSupabase(rec){
  _piaEnsureSB().then(function(sb){
    if(!sb) return;
    sb.auth.getSession().then(function(r){
      var ses=r&&r.data&&r.data.session; if(!ses) return; // 비로그인은 저장 안 함
      var uid=ses.user.id;
      var map={}; try{ map=JSON.parse(localStorage.getItem('pia_sb_rows')||'{}'); }catch(e){}
      var row={ user_id:uid, pair_code:(rec.pairCode||null), data:rec };
      /* [2026-11-02] 반 코드로 확인된 기관 — 메모리 값이 없으면(새로고침·이어하기) 프로필에 저장된 값을 쓴다 */
      try{ var _oid=window._piaClassOrgId||(rec.profile&&rec.profile.orgId)||null; if(_oid) row.org_id=_oid; }catch(e){}
      var rowId=map[rec.id];
      if(rowId){
        sb.from('results').update(row).eq('id',rowId).then(function(u){ if(u&&u.error){ delete map[rec.id]; try{localStorage.setItem('pia_sb_rows',JSON.stringify(map));}catch(e){} } });
      } else {
        sb.from('results').insert(row).select('id').single().then(function(ins){
          if(ins&&ins.data&&ins.data.id){ map[rec.id]=ins.data.id; try{ localStorage.setItem('pia_sb_rows',JSON.stringify(map)); }catch(e){} }
        });
      }
    });
  });
}

// ---- RBAC: 로그인 역할로 허용 audience 결정 ----
var PIA_ALLOWED_AUD=['student'];
function audAllowed(a){
  // 미리보기·관리자 진입(sample/print)에서는 역할과 무관하게 허용 (가짜 데이터)
  try{ if(typeof _piaSkipGate==='function' && _piaSkipGate()) return true; }catch(e){}
  /* 열람코드로 연 결과지는 서버가 코드를 검증했으므로, 그 레코드가 허용한
     대상까지는 열어 준다. 이 목록은 piaViewRecord() 가 정하며 선생님용은
     실제 역할이 있을 때만 들어간다. audience 는 화면 맥락일 뿐 인증·인가가
     아니므로, 여기서 허용하는 것은 '어떤 관점의 문구를 보여줄지' 까지다. */
  try{ if(Array.isArray(window.__piaRecordAllow) && window.__piaRecordAllow.indexOf(a)>=0) return true; }catch(e){}
  return PIA_ALLOWED_AUD.indexOf(a)>=0;
}
function _audKoName(a){ return a==='teacher'?'선생님용':a==='parent'?'학부모용':'본인용'; }
function piaSyncAudButtons(){
  try{ document.querySelectorAll('.aud-btn').forEach(function(b){
    var a=b.dataset.audience; var ok=audAllowed(a);
    b.disabled=!ok;
    /* 권한이 없으면 감춘다. 회색 버튼만 늘어놔도 누를 수 없어 혼란만 준다.
       단 지금 보고 있는 대상은 어떤 경우에도 남겨 둔다. */
    b.style.display=(ok || a===currentAudience) ? '' : 'none';
    b.style.opacity=ok?'':'0.45'; b.style.cursor=ok?'':'not-allowed';
    b.title=ok?'':(_audKoName(a)+' 화면은 해당 역할로 로그인해야 볼 수 있습니다');
    // 현재 시점과 하이라이트 동기화
    b.setAttribute('aria-selected', (a===currentAudience)?'true':'false');
  }); }catch(e){}
  /* 학부모·선생님용을 이미 볼 수 있는 사람에게까지 "인증으로 제공"이라고
     안내할 이유가 없다. 열람 권한이 없을 때만 남긴다. */
  try{
    var note=document.getElementById('aud-auth-note');
    if(note){
      var 열람가능 = audAllowed('teacher') || audAllowed('parent');
      note.style.display = 열람가능 ? 'none' : '';
    }
  }catch(e){}
}
function piaLoadRole(){
  /* [2026-09-26 성능] 저장된 세션이 없으면 아래 '세션 없음' 갈래와 결과가 같다(PIA_ALLOWED_AUD 는 처음부터 ['student']).
     supabase-js 를 받지 않고 버튼 동기화만 한다. 함수는 _piaIsStaff 위에 있다(호이스팅). */
  try{ if(!_piaMayHaveSession()){ PIA_ALLOWED_AUD=['student']; piaSyncAudButtons(); return; } }catch(e){}
  try{ _piaEnsureSB().then(function(sb){ if(!sb){ piaSyncAudButtons(); return; }
    sb.auth.getSession().then(function(r){
      var ses=r&&r.data&&r.data.session;
      if(!ses){ PIA_ALLOWED_AUD=['student']; piaSyncAudButtons(); return; }
      sb.rpc('pia_my_profile').then(function(res){
        try{
          var d=res&&res.data&&res.data[0];
          if(d&&d.allowed&&d.allowed.length){ PIA_ALLOWED_AUD=d.allowed; }
          window.PIA_ROLE=d?d.role:'individual'; window.PIA_ROLE_STATUS=d?d.role_status:'active';
          // 통합 관리 버튼은 운영자·기관장에게만 노출
          try{ var _ab=document.getElementById('btn-admin'); if(_ab && (window.PIA_ROLE==='super_admin'||window.PIA_ROLE==='org_admin')) _ab.style.display=''; }catch(e){}
        }catch(e){}
        if(!audAllowed(currentAudience)){ currentAudience='student'; }
        piaSyncAudButtons();
        try{ if(typeof renderDetailedResult==='function' && document.getElementById('detailed-result')) renderDetailedResult(); }catch(e){}
      }, function(){ piaSyncAudButtons(); });
    });
  }); }catch(e){ piaSyncAudButtons(); }
}
try{ if(document.readyState!=='loading'){ setTimeout(piaLoadRole,300); } else { window.addEventListener('DOMContentLoaded', function(){ setTimeout(piaLoadRole,300); }); } }catch(e){}

/* [2026-09-26] 결과 저장 403 처리 (#417 저장 소유권 검사 후속)
   - 'result scope mismatch': 같은 기록 번호가 이미 다른 소유(로그인·세션)로 저장돼 있다.
     예) 로그인 없이 시작해 저장된 뒤 도중에 로그인·세션 참여 → 같은 번호로는 덮어쓸 수 없다.
     이때는 번호에 꼬리표를 붙인 새 기록으로 저장하고, 이후 저장도 그 번호를 쓰도록 기억한다(결과 유실 방지).
   - 'invalid bearer': 로그인 토큰이 만료·손상 → 토큰 없이(익명 경로) 한 번 더 보낸다. */
function _piaIdRemap(id){ try{ var m=JSON.parse(localStorage.getItem('pia_id_remap')||'{}'); return m[id]||id; }catch(e){ return id; } }
function _piaIdRemapSet(from, to){ try{ var m=JSON.parse(localStorage.getItem('pia_id_remap')||'{}'); m[from]=to; localStorage.setItem('pia_id_remap', JSON.stringify(m)); }catch(e){ console.error('[pia] 기록 번호 전환 저장 실패', e); } }
function _piaPostResult(base, h, rec, _depth){
  _depth=_depth||0;
  var mapped=_piaIdRemap(rec.id);
  var body=(mapped!==rec.id)?Object.assign({}, rec, {id:mapped, originalId:rec.id}):rec;
  if(h && _piaTicket.v && h['x-ingest-token']===_piaTicket.v) _piaTicket.uses++;
  return fetch((base||'')+'/api/results',{method:'POST',headers:h,body:JSON.stringify(body)}).then(function(r){
    if(r.ok) return r.json();
    /* 저장 증표 거절(만료·재사용 상한 등) → 티켓을 새로 받아 한 번만 더 보낸다. */
    if(r.status===401 && _depth<1){
      return r.json().catch(function(){ return {}; }).then(function(j){
        if(!j || j.error!=='ingest ticket required') throw new Error('http 401 '+((j&&j.error)||''));
        _piaTicket.v=''; _piaTicket.exp=0; _piaTicket.uses=0;
        return _piaEnsureTicket().then(function(){
          var h2=Object.assign({}, h), t=_piaIngestHeaders()['x-ingest-token'];
          if(t) h2['x-ingest-token']=t; else delete h2['x-ingest-token'];
          return _piaPostResult(base, h2, rec, _depth+1);
        });
      });
    }
    if(r.status!==403 || _depth>1) throw new Error('http '+r.status);
    return r.json().catch(function(){ return {}; }).then(function(j){
      var err=(j&&j.error)||'';
      if(err==='invalid bearer'){
        var h2=Object.assign({}, h); delete h2.Authorization; delete h2.authorization;
        console.error('[pia] 로그인 토큰 거부 — 익명 저장으로 재시도');
        return _piaPostResult(base, h2, rec, _depth+1);
      }
      if(err==='result scope mismatch'){
        var nid=String(body.id).slice(0,150)+'-r'+Date.now().toString(36);
        _piaIdRemapSet(rec.id, nid);
        console.error('[pia] 기존 기록과 소유가 달라 새 기록으로 저장합니다:', nid);
        try{ if(typeof toast==='function') toast(_T('로그인 상태가 바뀌어 결과를 새 기록으로 저장했어요.','Your sign-in changed, so the result was saved as a new record.')); }catch(e){}
        return _piaPostResult(base, h, rec, _depth+1);
      }
      throw new Error('http 403 '+err);
    });
  });
}
let _adminSig='';
function sendResultToAdmin(opts){
  opts=opts||{};
  /* 조회 경로에서 들어온 호출은 무조건 막는다. 예약 단계에서 이미 걸러지지만,
     다른 곳에서 직접 부르더라도 사본이 생기지 않도록 한 겹 더 둔다. */
  if(_piaIsViewOnly()) return;
  const rec=buildAdminRecord();
  if(!opts.force && rec.doneCount<1) return;
  const sig=rec.id+'|'+rec.doneCount+'|'+rec.type+'|'+rec.reliability;
  if(!opts.force && sig===_adminSig) return;
  const base=piaApiBase();
  _adminSig=sig;
  try{ piaSaveSupabase(rec); }catch(e){}
  _piaEnsureTicket()
    .then(()=> window._piaScopedHeaders())
    .then(h => _piaPostResult(base, h, rec))
    .then(j=>{
      _piaKeepIssuedCode(rec, j);
      if(opts.toast){ try{ toast('결과가 관리자 서버에 저장되었습니다.'); }catch(e){} }
    })
    .catch(e=>{ console.error('[pia] 결과 서버 저장 실패 — 나중에 다시 보냄', e && e.message); _adminSig=''; _piaOutboxPut(rec); });
}
/* 저장 증표(티켓).
   저장 직전에 서버가 발급한 시한부 티켓을 받아 x-ingest-token 헤더로 함께 보낸다.
   티켓이 만료됐거나 서버가 받아 주지 않으면(401) 새 티켓을 받아 한 번 더 보낸다.
   티켓을 받지 못했을 때만 설치 때 기기에 넣어 둔 토큰(localStorage.pia_ingest_token)을 쓴다. */
var _piaTicket = { v: '', exp: 0, uses: 0 };
var _piaTicketPending = null;

function _piaEnsureTicket(){
  var now = Date.now();
  /* 만료 1분 전, 또는 한 티켓으로 80번 보냈으면 새로 받는다(서버 상한 100). */
  if (_piaTicket.v && now < _piaTicket.exp - 60000 && _piaTicket.uses < 80) return Promise.resolve();
  if (_piaTicketPending) return _piaTicketPending;

  var base = piaApiBase() || '';
  _piaTicketPending = fetch(base + '/api/results?ticket=1')
    .then(function(r){ return r.json(); })
    .then(function(j){
      if (j && j.ok && j.ticket) {
        _piaTicket.v = j.ticket;
        _piaTicket.exp = now + (j.ttl || 1800) * 1000;
        _piaTicket.uses = 0;
      }
    })
    .catch(function(e){ console.error('저장 티켓 발급 실패:', e); })
    .then(function(){ _piaTicketPending = null; });
  return _piaTicketPending;
}

/* 저장 요청에 붙일 범위 헤더.
     x-pia-exam-code : 참여 중인 검사세션 코드
     Authorization   : Supabase 로그인 토큰 (서버가 서명을 검증한다)
   org_id / class_id / teacher_id 는 절대 보내지 않는다. 서버가 정한다. */
window._piaScopedHeaders = function(){
  var h = _piaIngestHeaders();
  try{
    var ss = window.PIA_SESS;
    /* [2026-11-02] Local(YEDAM Backend) 세션일 때만 보낸다. 예전 Supabase 세션 코드를 보내면 서버가 그 세션을 못 찾거나
       (비로그인) 'login required' 로 저장 자체를 403 거절해 결과가 서버에 남지 않았다. 예전 세션은 본문 examSession 으로 알린다. */
    if(ss && ss.code && ss.local) h['x-pia-exam-code'] = String(ss.code).toUpperCase();
  }catch(e){ console.error('세션 코드 확인 실패', e); }
  if(typeof _piaEnsureSB !== 'function') return Promise.resolve(h);
  return _piaEnsureSB().then(function(sb){
    if(!sb || !sb.auth) return h;
    return sb.auth.getSession().then(function(r){
      var ses = r && r.data && r.data.session;
      if(ses && ses.access_token) h['Authorization'] = 'Bearer ' + ses.access_token;
      return h;
    });
  }).catch(function(e){ console.error('로그인 토큰 확인 실패', e); return h; });
};

/* Local(YEDAM Backend) 검사세션 참여.
   성공하면 서버가 이 학생을 세션의 기관에 등록한다.
   응답에는 organization_id 가 들어 있지 않다. */
window._piaExamJoinLocal = function(code){
  var base = piaApiBase() || '';
  return window._piaScopedHeaders().then(function(h){
    if(!h['Authorization']) return null;   // 비로그인은 Local 세션 참여 불가
    return fetch(base + '/api/session/join', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Authorization':h['Authorization'] },
      body: JSON.stringify({ code: code,
                             grade:(state.profile&&state.profile.grade)||'',
                             klass:(state.profile&&state.profile.klass)||'' })
    }).then(function(r){ return r.json(); })
      .then(function(j){ return (j && j.ok && j.session) ? j.session : null; });
  }).catch(function(e){ console.error('세션 참여 실패', e); return null; });
};

function _piaIngestHeaders(){
  var h = {'Content-Type':'text/plain;charset=UTF-8'};
  if(_piaTicket.v && Date.now() < _piaTicket.exp){ h['x-ingest-token'] = _piaTicket.v; return h; }
  try{
    var t = (localStorage.getItem('pia_ingest_token')||'').trim();
    if(t) h['x-ingest-token'] = t;
  }catch(e){ console.error('ingest 토큰 조회 실패:', e); }
  return h;
}

/* P0: 서버가 발급한 열람 코드를 "지금 화면의 학생" 프로필에만 보관한다.
   rec.id 는 studentId_createdAt 이므로 현재 프로필과 대조할 수 있다. */
function _piaKeepIssuedCode(rec, j){
  try{
    if(!j || !j.ok || !state || !state.profile) return;
    var curId=((state.studentId||'S')+'_'+((state.profile||{}).createdAt||'anon'));
    if(!rec || rec.id!==curId) return;
    var changed=false;
    if(j.pairCode && /^[A-Z0-9]{6}$/.test(j.pairCode) && state.profile.pairCode!==j.pairCode){ state.profile.pairCode=j.pairCode; changed=true; }
    if(j.id && state.profile.resultId!==j.id){ state.profile.resultId=String(j.id); changed=true; }
    /* [2026-11-02] 진본 확인용 — 서버가 정한 저장 시각(savedAt)만 쓴다 */
    if(j.savedAt && state.profile.savedAt!==j.savedAt){ state.profile.savedAt=String(j.savedAt); changed=true; window.__piaVerify=null; window.__piaVerifyBusy=0; }
    if(changed && typeof save==='function') save();
    try{ window.__piaRecMeta = { id: String(state.profile.resultId || j.id), savedAt: state.profile.savedAt || null }; if (typeof piaRenderIssueFoot === 'function') piaRenderIssueFoot(); }catch(_v){}
  }catch(e){ console.error('열람 코드 보관 실패', e); }
}
function _piaOutboxPut(rec){
  try{ const ob=JSON.parse(localStorage.getItem('pia_admin_outbox')||'[]');
    const i=ob.findIndex(x=>x.id===rec.id); if(i>=0)ob[i]=rec; else ob.push(rec);
    localStorage.setItem('pia_admin_outbox',JSON.stringify(ob.slice(-50))); }catch(e){}
}
function flushAdminOutbox(){
  const base=piaApiBase();
  let ob; try{ ob=JSON.parse(localStorage.getItem('pia_admin_outbox')||'[]'); }catch(e){ return; }
  if(!ob.length) return;
  /* 밀린 결과 재전송도 티켓을 먼저 확보한 뒤에 보낸다. */
  _piaEnsureTicket().then(()=> window._piaScopedHeaders()).then(h =>
    Promise.all(ob.map(rec=>_piaPostResult(base, h, rec)
      .then(j=>{ try{ _piaKeepIssuedCode(rec, j); }catch(e){} return true; })
      .catch(()=>false)))
      .then(res=>{ if(res.length && res.every(Boolean)) localStorage.removeItem('pia_admin_outbox'); })
  );
}
let _adminSyncTimer=null;
/* 조회 전용 모드 판정.
   기존 결과를 '열어 보는' 경로에서는 저장이 일어나면 안 된다.
   piaViewRecord() 가 남의 결과를 state 에 채우면 save() 후킹이
   그걸 새 검사로 오해해 POST 해 버렸다(READ 가 WRITE 를 유발).
   주소로 먼저 판정하는 이유는 플래그가 세워지기 전에 save() 가
   먼저 돌 수 있어서다. 플래그는 보조 수단으로만 쓴다. */
function _piaIsViewOnly(){
  try{
    if(window.__piaViewOnly===true) return true;
    var q=new URLSearchParams(piaEffectiveSearch());
    if(q.get('view')==='record' || q.get('view')==='records') return true;  // 학부모·관리자 열람
    if(q.get('s')) return true;                                             // 공유 링크 열람
    if(q.get('sample')==='1' || location.hash==='#sample') return true;     // 샘플 미리보기
    if(q.get('print')==='items' || q.get('paper')==='1') return true;       // 인쇄용
  }catch(e){}
  return false;
}
function scheduleAdminSync(){
  if(_piaIsViewOnly()) return;                 /* 조회 모드에서는 예약 자체를 하지 않는다 */
  if(_adminSyncTimer) return;
  _adminSyncTimer=setTimeout(()=>{ _adminSyncTimer=null; try{ sendResultToAdmin(); }catch(e){} }, 1500);
}
try{ window.addEventListener('load',()=>setTimeout(flushAdminOutbox,2500)); }catch(e){}

// ---- save 후킹 ----
const _origSave2 = save;
save = function() {
  _origSave2();
  blinkAutosave();
  try{ scheduleAdminSync(); }catch(e){}
};

// ---- showView 후킹 ----
const _origShow3 = showView;
showView = function(name) {
  _origShow3(name);
  renderHeaderProgress();
  if (["big5","riasec","via","grit","sjt","cesd","phqa","gad","chat"].includes(name)) {
    if (Math.random() < 0.5) showStartEncouragement(name);
  }
  if (name === "result") setTimeout(saveSnapshot, 1500);
};

// ---- 설정에 백업/복원 UI 추가 ----
function addBackupRestoreUI() {
  if (el("backup-restore-section")) return;
  const settings = document.querySelector("section[data-view=settings]");
  if (!settings) return;
  const div = document.createElement("div");
  div.id = "backup-restore-section";
  div.className = "border-t border-slate-200 pt-4 mt-4";
  div.innerHTML = '<h3 class="font-semibold text-sm mb-3">데이터 백업 및 복원</h3>' +
    '<p class="text-xs text-slate-500 mb-3">검사 결과를 JSON으로 백업하거나 복원할 수 있습니다.</p>' +
    '<div class="flex gap-2 flex-wrap">' +
    '<button data-act="exportAllData" class="bg-emerald-600 text-white px-4 py-2 rounded-lg text-sm">💾 백업 내보내기</button>' +
    '<label class="bg-sky-600 text-white px-4 py-2 rounded-lg text-sm cursor-pointer">📂 복원<input type="file" accept=".json" class="hidden" data-act-change="piaImportFile" data-arg-self /></label>' +
    '<button data-act="piaResetAllData" class="bg-rose-600 text-white px-4 py-2 rounded-lg text-sm">🗑 모두 삭제</button>' +
    '</div>';
  settings.appendChild(div);
}

// ---- 초기화 후킹 ----
window.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    addBackupRestoreUI();
    renderHeaderProgress();
    if (state.profile) renderProfileBar();
    /* v2: 홈 → 동의 → 정보입력 플로우 */
    /* 교사 계정이어도 첫 화면은 홈. 결과는 홈에서 직접 선택한다.
       (키오스크에 교사 플래그가 남아 결과지가 먼저 뜨던 문제) */
  }, 200);
});

window.exportAllData = exportAllData;
window.importAllData = importAllData;
window.ensureStudentProfile = ensureStudentProfile;
window.newStudent = newStudent;
window.editProfile = editProfile;

// =================================================================
//  v3.8 — 서비스급 종합 보강
// =================================================================

// ---- 게이미피케이션: 포인트 & 뱃지 시스템 ----
const BADGES = [
  { id:'first_step', name:'첫 발걸음', icon:'🌱', desc:'첫 검사를 완료했어요', cond:s => Object.keys(getCompletedTests()).length >= 1 },
  { id:'three_tests', name:'탐험가', icon:'🗺️', desc:'3개 검사 완료', cond:s => Object.keys(getCompletedTests()).length >= 3 },
  { id:'all_essential', name:'필수 마스터', icon:'⭐', desc:'필수 검사 4개 모두 완료', cond:s => ['big5','riasec','via','chat'].every(k => isTestDone(k)) },
  { id:'all_done', name:'완주자', icon:'🏆', desc:'9개 검사 모두 완료', cond:s => Object.keys(getCompletedTests()).length >= 9 },
  { id:'chatter', name:'대화의 달인', icon:'💬', desc:'자유대화 10턴 완료', cond:s => state.results.conv.turns >= 10 },
  { id:'reliable', name:'해석 등급 A+', icon:'🛡️', desc:'해석 등급 A+ 달성(검사 완료도·응답 성실도)', cond:s => calcReliability().grade === 'A+' },
  { id:'growth_seeker', name:'성장의 씨앗', icon:'🌿', desc:'학부모 14일 코칭 시작', cond:s => false }, // 수동 트리거
  { id:'safety_aware', name:'마음 챙김', icon:'❤️', desc:'정서 스크리닝 3종 완료', cond:s => ['cesd','phqa','gad'].every(k => isTestDone(k)) },
  { id:'reformer', name:'재도전', icon:'🔄', desc:'검사를 다시 진행', cond:s => (state.history?.length||0) >= 2 },
];
const BADGES_EN = {
  first_step:'First Step', three_tests:'Explorer', all_essential:'Essentials Master', all_done:'Finisher',
  chatter:'Conversation Pro', reliable:'A+ Reliability', growth_seeker:'Seed of Growth',
  safety_aware:'Mindful Check', reformer:'Retaker'
};

function getCompletedTests() {
  const done = {};
  ['big5','riasec','via','grit','sjt','cesd','phqa','gad'].forEach(k => {
    if (isTestDone(k)) done[k] = true;
  });
  if (state.results.conv.turns >= 12) done.conv = true;
  return done;
}
function isTestDone(k) {
  const totals = { big5:50, riasec:30, via:24, grit:8, sjt:30, cesd:10, phqa:9, gad:7 };
  // 자유대화는 화면 이동 키가 'chat', 진행도 저장 키가 'conv'로 서로 다르다.
  // 이 불일치 때문에 8/8을 마쳐도 '다음 추천 검사: 자유대화'가 계속 떴다.
  // (QA 2026-08-22 P0: 완료 검사 상태 계산 오류)
  if (k === 'conv' || k === 'chat') return state.results.conv.turns >= 12;
  return state.results[k]?.answers?.length >= totals[k];
}
function getEarnedBadges() {
  return BADGES.filter(b => b.cond());
}
function getPoints() {
  const done = Object.keys(getCompletedTests()).length;
  const conv = state.results.conv.turns;
  const badges = getEarnedBadges().length;
  return done * 100 + conv * 10 + badges * 50;
}
function getLevel() {
  const pts = getPoints();
  return Math.floor(pts / 200) + 1;
}

function renderGamification() {
  const pts = getPoints();
  const lvl = getLevel();
  const badges = getEarnedBadges();
  const nextLevel = lvl * 200;
  const progress = Math.min(100, Math.round((pts % 200) / 200 * 100));
  return `
    <div class="bg-gradient-to-br from-violet-100 to-pink-100 rounded-2xl border border-violet-200 p-4">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-3">
          <div class="w-14 h-14 rounded-full bg-white grid place-items-center text-2xl font-bold text-violet-700 shadow">${lvl}</div>
          <div>
            <div class="text-xs text-violet-700">${_T('레벨','Level')}</div>
            <div class="text-lg font-bold text-violet-900">Lv.${lvl} ${_T('성장 탐험가','Growth Explorer')}</div>
          </div>
        </div>
        <div class="text-right">
          <div class="text-2xl font-bold text-violet-700">${pts.toLocaleString()}</div>
          <div class="text-xs text-violet-700">${_T('포인트','Points')}</div>
        </div>
      </div>
      <div class="w-full bg-white rounded-full h-2 overflow-hidden mb-1">
        <div class="bg-gradient-to-r from-violet-500 to-pink-500 h-2" style="width:${progress}%"></div>
      </div>
      <div class="text-xs text-violet-700 mb-3">${_T('다음 레벨까지 '+(200 - (pts % 200))+'점', (200 - (pts % 200))+' points to next level')}</div>
      <div class="text-xs font-semibold text-violet-900 mb-2">🏅 ${_T('획득 뱃지','Badges Earned')} (${badges.length}/${BADGES.length})</div>
      <div class="flex flex-wrap gap-2">
        ${BADGES.map(b => {
          const earned = badges.find(x => x.id === b.id);
          return `<div class="flex items-center gap-1 px-2 py-1 rounded-lg ${earned?'bg-amber-100 text-amber-900':'bg-white text-slate-400'} text-xs" title="${b.desc}">
            <span>${b.icon}</span><span class="${earned?'font-semibold':''}">${_T(b.name, BADGES_EN[b.id]||b.name)}</span>
          </div>`;
        }).join('')}
      </div>
    </div>`;
}

// ---- AI 코치 일일 메시지 (검사 결과 기반) ----
function getDailyCoachMessage() {
  const type = inferIntegratedType();
  const day = new Date().getDate();
  const messages = {
    'CR-EX': [
      '오늘 떠오른 아이디어 하나를 메모해두세요. 작은 씨앗이 큰 나무가 됩니다.',
      '새로운 것을 시도해보세요. 10분만이라도 평소와 다른 활동을 해보세요.',
      '당신의 호기심은 강점이에요. 오늘 가장 궁금한 것 하나를 찾아보세요.'
    ],
    'EX-CR': [
      '오늘 감정을 한 단어로 표현해보세요. 그림이나 글로 남겨도 좋아요.',
      '좋아하는 음악을 들으며 5분만 자기 시간을 가져보세요.',
      '당신의 섬세함은 누군가에게 위로가 됩니다.'
    ],
    'LO-AN': [
      '오늘 풀어본 문제 중 가장 흥미로운 것 하나를 곱씹어보세요.',
      '논리 퍼즐이나 수학 문제 1개를 시도해보세요.',
      '깊이 있는 분석은 당신의 강점입니다.'
    ],
    'EM-CO': [
      '친구나 가족에게 따뜻한 한마디를 건네보세요.',
      '오늘 누군가의 이야기를 진심으로 들어주세요.',
      '당신의 공감 능력은 세상을 따뜻하게 만들어요.'
    ],
    'default': [
      '오늘 하루 한 가지만 잘하면 충분해요.',
      '강점을 살리는 작은 행동 하나를 시도해보세요.',
      '자기 자신에게 따뜻한 말을 건네는 것을 잊지 마세요.'
    ]
  };
  const messages_en = {
    'CR-EX': [
      'Jot down one idea that came to you today. Small seeds grow into big trees.',
      'Try something new. Spend even 10 minutes on an activity outside your routine.',
      'Your curiosity is a strength. Find one thing you\'re most curious about today.'
    ],
    'EX-CR': [
      'Try describing today\'s feeling in one word. A drawing or a few written lines work too.',
      'Take 5 minutes for yourself while listening to music you like.',
      'Your sensitivity brings comfort to someone.'
    ],
    'LO-AN': [
      'Reflect on the most interesting problem you solved today.',
      'Try one logic puzzle or math problem.',
      'Deep analysis is your strength.'
    ],
    'EM-CO': [
      'Offer a warm word to a friend or family member today.',
      'Truly listen to someone\'s story today.',
      'Your empathy makes the world warmer.'
    ],
    'default': [
      'Doing just one thing well today is enough.',
      'Try one small action that plays to your strengths.',
      'Don\'t forget to speak kindly to yourself.'
    ]
  };
  const useEn = (typeof window !== 'undefined' && window.aipiaCurrentLang === 'en');
  const pool = (useEn ? messages_en : messages)[type.code] || (useEn ? messages_en : messages)['default'];
  return pool[day % pool.length];
}

function renderDailyCoach() {
  if (Object.keys(getCompletedTests()).length === 0) return '';
  const msg = getDailyCoachMessage();
  const _dcEn = (typeof window !== 'undefined' && window.aipiaCurrentLang === 'en');
  return `
    <div class="bg-gradient-to-r from-sky-50 to-emerald-50 border border-sky-200 rounded-2xl p-4">
      <div class="flex items-start gap-3">
        <div class="text-3xl">🤖</div>
        <div class="flex-1">
          <div class="text-xs text-sky-700 mb-1">${_T('AI 코치 피아','AI Coach Pia')} · ${new Date().toLocaleDateString(_dcEn?'en-US':'ko-KR')}</div>
          <p class="text-sm text-slate-800 leading-relaxed mb-2">"${msg}"</p>
          <div class="text-xs text-sky-600">${_T('매일 자동 생성되는 맞춤 코칭 메시지입니다.','A personalized coaching message generated automatically every day.')}</div>
        </div>
      </div>
    </div>`;
}

// ---- 자기소개서 자동 생성 ----
function generateSelfIntro() {
  const type = inferIntegratedType();
  const via = state.results.via.scores;
  const _vt = viaTopKeys(via, 3, true);
  const topStrengths = _vt.length >= 3 ? _vt : ['창의','공감','책임'];
  const name = state.profile?.name || '저';
  const grade = state.profile?.grade || '학생';
  const careers = type.careers.slice(0,2).join(', ');
  return `안녕하세요, ${grade} ${name}입니다.

저는 예담 톡 통합 검사에서 ${type.name}(${type.code}) 유형으로 분류되었으며, ${type.desc}

저의 가장 큰 강점은 ${topStrengths[0]}·${topStrengths[1]}·${topStrengths[2]}입니다. ${topStrengths[0]}을 활용해 평소 학교 생활과 학습에서 자기 색깔을 만들어가고 있으며, 친구·가족과의 관계에서도 ${topStrengths[1]} 능력을 발휘하려 노력합니다.

앞으로 ${careers} 분야에 관심을 가지고 진로를 탐색하고 있습니다. 이 분야는 제가 가진 ${type.name}의 강점이 가장 잘 발휘될 수 있는 영역이라고 생각합니다.

성장 포인트로는 자기주장과 표현력을 더 키우는 것을 목표로 하고 있으며, 작은 행동부터 단계적으로 도전해 나가고 있습니다.

앞으로도 자기 이해를 깊이 있게 해나가며, 좋아하는 일과 잘하는 일이 일치하는 방향으로 진로를 만들어가고 싶습니다. 감사합니다.`;
}

function showSelfIntroModal() {
  const text = generateSelfIntro();
  const modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;';
  modal.innerHTML = `
    <div class="bg-white rounded-2xl p-6 max-w-2xl w-full max-h-[80vh] flex flex-col">
      <div class="flex justify-between items-center mb-3">
        <h2 class="text-lg font-bold">📝 AI 자동 생성 자기소개서</h2>
        <button data-act=\'[["@remove",".fixed,[style*=fixed]"]]\' class="text-slate-400 hover:text-slate-700 text-xl">×</button>
      </div>
      <p class="text-xs text-slate-500 mb-3">검사 결과를 기반으로 자기소개서 초안을 자동 생성했습니다. 자유롭게 수정하여 활용하세요.</p>
      <textarea id="self-intro-text" class="flex-1 border border-slate-300 rounded-lg p-3 text-sm leading-relaxed min-h-[300px] font-mono">${text}</textarea>
      <div class="flex gap-2 mt-3 flex-wrap">
        <button data-act="piaCopySelfIntro" data-arg-self class="bg-slate-900 text-white px-4 py-2 rounded-lg text-sm" data-i18n="report.copy">📋 복사</button>
        <button data-act="piaDownloadSelfIntro" class="bg-emerald-600 text-white px-4 py-2 rounded-lg text-sm">💾 다운로드</button>
        <button data-act=\'[["@remove",".fixed,[style*=fixed]"]]\' class="bg-slate-100 px-4 py-2 rounded-lg text-sm ml-auto">닫기</button>
      </div>
    </div>`;
  document.body.appendChild(modal);
}

// ---- 다크 모드 토글 ----
function applyDarkMode(on) {
  if (on) {
    document.documentElement.style.filter = 'invert(1) hue-rotate(180deg)';
    document.querySelectorAll('img, canvas').forEach(e => e.style.filter = 'invert(1) hue-rotate(180deg)');
    sessionStorage.setItem('pia_v3_dark', '1');
  } else {
    document.documentElement.style.filter = '';
    document.querySelectorAll('img, canvas').forEach(e => e.style.filter = '');
    sessionStorage.removeItem('pia_v3_dark');
  }
}
function toggleDarkMode() {
  const on = !document.documentElement.style.filter;
  applyDarkMode(on);
}

// ---- 약관 동의 모달 ----
function showConsentModalIfNeeded() {
  if (sessionStorage.getItem('pia_v3_consent') === '1') return Promise.resolve();
  return new Promise(resolve => {
    const modal = document.createElement('div');
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.7);display:flex;align-items:center;justify-content:center;z-index:1001;padding:20px;';
    modal.innerHTML = `
      <div class="bg-white rounded-2xl p-6 max-w-lg w-full max-h-[86vh] overflow-y-auto">
        <h2 class="text-lg font-bold mb-1">📜 서비스 이용 및 개인정보 수집·이용 동의</h2>
        <p class="text-xs text-slate-600 mb-4">예담 톡 검사를 시작하려면 아래 필수 항목에 동의해 주세요. 동의하지 않을 권리가 있으나, 필수 항목 미동의 시 서비스 이용이 제한됩니다.</p>
        <div class="space-y-3 text-sm">
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" id="c-privacy" class="mt-1" />
            <span><strong>[필수] 개인정보 수집·이용 동의</strong>
              <details class="text-xs text-slate-500 mt-1"><summary class="cursor-pointer text-sky-600">수집 항목·목적·보유기간 보기</summary>
                <div class="mt-1 leading-relaxed">· <b>수집 항목</b>: 이름(또는 별명), 학년, 학교/기관, 검사 응답·결과<br>· <b>수집·이용 목적</b>: 검사 결과 제공·해석, 진로·상담 지원, 서비스 개선·통계<br>· <b>보유·이용 기간</b>: 회원 탈퇴 시 또는 목적 달성 시까지(관련 법령에 따른 보존 예외)<br>· <b>저장 위치</b>: 로그인 이용 시 결과가 <b>보안 서버(Supabase)</b>에 저장됩니다. 비로그인 시 기기에만 임시 저장됩니다.<br>· <b>제3자 제공</b>: 원칙적으로 제공하지 않으며, 법령상 의무 또는 이용자 동의가 있는 경우에 한합니다.</div></details></span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" id="c-sensitive" class="mt-1" />
            <span><strong>[필수] 민감정보(정서 선별) 처리 동의</strong><br><span class="text-xs text-slate-500">정서 선별(CES-D·PHQ-A·GAD-7)은 <b>선택 참여</b>이며, 참여 시 관련 응답이 위 목적으로 처리됩니다. 의료·임상 진단이 아닙니다.</span></span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" id="c-minor" class="mt-1" />
            <span><strong>[필수] 연령·법정대리인 확인</strong><br><span class="text-xs text-slate-500">본인은 <b>만 14세 이상</b>이거나, 만 14세 미만인 경우 <b>법정대리인(보호자)의 동의</b>를 받았음을 확인합니다.</span></span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" id="c-terms" class="mt-1" />
            <span><strong>[필수] 이용약관 동의</strong><br><span class="text-xs text-slate-500">본 서비스는 교육·자기이해 목적이며 의료 진단이 아닙니다. 결과는 참고용입니다.</span></span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer">
            <input type="checkbox" id="c-safety" class="mt-1" />
            <span><strong>[필수] 안전 신호 자동 안내 동의</strong><br><span class="text-xs text-slate-500">자해·자살 등 위기 신호 감지 시 1388·1577-0199·109 채널을 자동 안내합니다.</span></span>
          </label>
          <label class="flex items-start gap-2 cursor-pointer border-t border-slate-200 pt-2">
            <input type="checkbox" id="c-all" class="mt-1" />
            <span><strong>전체 동의</strong> <span class="text-xs text-slate-500">(위 필수 항목 모두 동의)</span></span>
          </label>
        </div>
        <button id="consent-cancel" type="button" data-act="piaExitGroupHome" class="w-full mt-4 py-3 rounded-lg text-sm text-slate-500 border border-slate-200">← 홈으로 돌아가기</button>
        <button id="consent-confirm" class="w-full mt-2 bg-slate-900 text-white py-3 rounded-lg text-sm font-semibold opacity-50 cursor-not-allowed" disabled>동의하고 시작하기</button>
      </div>`;
    document.body.appendChild(modal);

    const reqs = ['c-privacy','c-sensitive','c-minor','c-terms','c-safety'];
    const update = () => {
      const ok = reqs.every(id => document.getElementById(id).checked);
      const btn = document.getElementById('consent-confirm');
      btn.disabled = !ok;
      btn.className = `w-full mt-4 ${ok?'bg-slate-900 cursor-pointer':'bg-slate-400 cursor-not-allowed opacity-50'} text-white py-3 rounded-lg text-sm font-semibold`;
    };
    document.querySelectorAll('input[type=checkbox]').forEach(cb => cb.addEventListener('change', update));
    document.getElementById('c-all').addEventListener('change', e => {
      reqs.forEach(id => document.getElementById(id).checked = e.target.checked);
      update();
    });
    document.getElementById('consent-confirm').addEventListener('click', () => {
      sessionStorage.setItem('pia_v3_consent', '1');
      try{
        var rec = { at:new Date().toISOString(), v:'consent-2026-07', items:{privacy:true,sensitive:true,minorOrGuardian:true,terms:true,safety:true} };
        localStorage.setItem('pia_consent', JSON.stringify(rec));
        // 로그인 시 서버에도 동의 이력 기록(있으면)
        if(typeof _piaEnsureSB==='function'){ _piaEnsureSB().then(function(sb){ if(sb&&sb.rpc){ try{ sb.rpc('pia_log_consent',{ payload: rec }); }catch(e){} } }); }
      }catch(e){}
      modal.remove();
      resolve();
    });
  });
}

// ---- 결과지 QR 코드 공유 (개인정보 미포함·로컬 생성) ----
function _piaLoadQRLib(){
  return new Promise(function(resolve){
    if(window.QRCode){ resolve(true); return; }
    var s=document.createElement('script');
    s.src='/vendor/qrcode-1.0.0.min.js';
    s.onload=function(){ resolve(!!window.QRCode); };
    s.onerror=function(){ resolve(false); };
    document.head.appendChild(s);
  });
}
/* ── 결과지 QR 공유 (2026-08-22) ──────────────────────────────
   기존에는 QR이 접속 주소만 담아서, 찍으면 검사 시작 화면만 떴다.
   이제 결과 스냅샷을 서버에 익명 저장(90일 만료)하고 그 토큰을 QR에 담아
   다른 기기에서도 결과지를 그대로 볼 수 있게 한다.
   비로그인(키오스크·단체) 학생도 동일하게 동작한다. */
var _piaShareToken = null;   /* 같은 세션에서 재발급 방지 */
var _piaShareTokenPII = false; /* 캐시된 토큰이 개인정보 포함본인지 — 옵션이 바뀌면 재발급해야 한다 */

// 공유(QR) 결과는 링크만 있으면 누구나 열 수 있고 90일간 유지된다 — 인쇄물이
// 유출되거나 링크가 전달되면 그대로 노출된다. 그래서 기본값은 이름·학교·반과
// 자유대화 원문을 뺀다. 정말 필요하면 공유창에서 사용자가 직접 켤 수 있다.
// (QA 2026-08-22: "공유본 기본값에서 이름·학교·반·대화원문 제외")
function _piaShareSanitizeResults(results){
  try{
    var r = JSON.parse(JSON.stringify(results || {}));
    if (r.conv && Array.isArray(r.conv.transcript)) {
      r.conv.transcript = r.conv.transcript.map(function(t){
        return { risk: t.risk, topic: t.topic, t: t.t }; // 원문(msg/reply)은 제외, 통계만 유지
      });
    }
    /* 우울·불안 선별척도는 링크만 있으면 90일간 누구나 열 수 있는 익명 공유본에
       담지 않는다. 개인정보 포함으로 명시적으로 발급할 때만 들어간다.
       (2026-08-31 보안검토: "익명 요약"이라면서 임상척도가 실려 있었음) */
    ['cesd','phqa','gad','who5','rses'].forEach(function(k){ try{ delete r[k]; }catch(e){} });
    return r;
  }catch(e){ return results; }
}
function piaShareCreate(includePII){
  includePII = !!includePII;
  return new Promise(function(resolve, reject){
    // 개인정보 포함 여부가 이전 발급과 다르면 캐시를 쓰지 않고 새로 만든다.
    if(_piaShareToken && _piaShareTokenPII === includePII){ resolve(_piaShareToken); return; }
    var rec;
    try{ rec = buildAdminRecord(); }
    catch(e){ reject(new Error('결과를 모으지 못했습니다.')); return; }
    if(!rec || !rec.results){ reject(new Error('아직 저장할 결과가 없습니다.')); return; }
    /* QR로 넘길 때는 화면 표시에 필요한 것만 담는다.
       includePII 를 명시적으로 켜지 않으면 이름·학교·반·대화원문은 제외한다. */
    var payload = {
      v: 'share1',
      createdAt: new Date().toISOString(),
      name: includePII ? (rec.name || '') : '',
      grade: rec.grade || '', klass: includePII ? (rec.klass || '') : '',
      school: includePII ? (rec.school || '') : '', type: rec.type || '',
      reliability: rec.reliability || '', validity: rec.validity || '',
      results: includePII ? rec.results : _piaShareSanitizeResults(rec.results),
      profile: includePII ? rec.profile : { grade: (rec.profile&&rec.profile.grade)||'' },
      meta: rec.meta, summary: rec.summary
    };
    _piaEnsureSB().then(function(sb){
      if(!sb || !sb.rpc){ reject(new Error('서버에 연결하지 못했습니다.')); return; }
      var org = null; try{ org = window._piaClassOrgId || null; }catch(e){}
      sb.rpc('pia_share_create', { p_data: payload, p_org: org }).then(function(r){
        if(r && r.error){ console.error('공유 토큰 발급 실패:', r.error); reject(new Error('공유 링크를 만들지 못했습니다.')); return; }
        var t = r && r.data;
        if(!t){ reject(new Error('공유 링크를 만들지 못했습니다.')); return; }
        _piaShareToken = t; _piaShareTokenPII = includePII; resolve(t);
      }, function(e){ console.error('공유 토큰 발급 실패:', e); reject(new Error('서버 응답이 없습니다.')); });
    });
  });
}

function piaShareUrl(token){
  return location.origin + location.pathname + '?s=' + encodeURIComponent(token);
}

function piaOpenSharedResult(token){
  try{ window.__piaViewOnly = true; }catch(_f){}   /* 공유 링크 열람도 열람 전용 */
  if(!token) return;
  /* [2026-10-29] 열람 전용 화면 표식 — js/pia-share-pre.js 가 못 돌았어도(예: 캐시된 옛 HTML) 대시보드가 숨는다 */
  try{ document.documentElement.classList.add('pia-shareview'); }catch(_f){}
  if(!document.getElementById('pia-share-pre-style')){
    try{
      var _ps = document.createElement('style'); _ps.id = 'pia-share-pre-style';
      _ps.textContent = 'html.pia-shareview details.pia-tools,html.pia-shareview #service-hub,html.pia-shareview #pia-result-head [data-act="showView"][data-arg="home"]{display:none!important}';
      document.head.appendChild(_ps);
    }catch(_f){}
  }
  var box = document.createElement('div');
  box.id = 'pia-share-loading';
  box.style.cssText = 'position:fixed;inset:0;background:#faf9f5;display:flex;align-items:center;justify-content:center;z-index:9999;font-weight:700;color:#3d3d3a';
  box.textContent = '결과지를 불러오는 중…';
  document.body.appendChild(box);
  try{ document.documentElement.classList.remove('pia-share-wait'); }catch(_f){}   /* 머리말 덮개 → 같은 모양의 box 로 바톤 터치 */

  function fail(msg){
    box.innerHTML = '<div style="text-align:center;max-width:340px;padding:20px;line-height:1.7">'
      + '<div style="font-size:34px;margin-bottom:10px">🔍</div>'
      + '<div style="font-weight:800;margin-bottom:6px">' + msg + '</div>'
      + '<div style="font-size:13px;color:#6b6b66;font-weight:500">QR은 발급일로부터 90일간만 열람할 수 있습니다.</div>'
      + '<button data-act="@path" style="margin-top:16px;padding:10px 18px;border:0;border-radius:10px;background:#141413;color:#fff;font-weight:700;cursor:pointer">검사 홈으로</button>'
      + '</div>';
  }

  /* [2026-10-29] 머리말에서 미리 시작한 조회(window.__piaSharePre)가 있으면 그 응답을 쓰고, 없거나 실패하면 예전 경로(supabase-js) */
  var _pre = window.__piaSharePre;
  var _preP = (_pre && _pre.then) ? _pre.then(function(r){ return (r && r.ok) ? { data: r.data } : null; }, function(){ return null; }) : Promise.resolve(null);
  _preP.then(function(pr){
    if(pr) return { rpc: function(){ return Promise.resolve(pr); } };
    return _piaEnsureSB();
  }).then(function(sb){
    if(!sb || !sb.rpc){ fail('서버에 연결하지 못했습니다.'); return; }
    sb.rpc('pia_share_get', { p_token: token }).then(function(r){
      if(r && r.error){ console.error('공유 결과 조회 실패:', r.error); fail('결과를 불러오지 못했습니다.'); return; }
      var d = r && r.data;
      if(!d || !d.results){ fail('만료되었거나 없는 결과입니다.'); return; }
      try{
        /* 공유본(익명)에는 우울·불안 척도 등이 빠져 있다(2026-08-31). 빈 틀 위에 얹어야 열람 화면이 그 항목을 읽다가 멈추지 않는다. */
        state.results = Object.assign(freshResults(), d.results || {});
        state.profile = d.profile || { name:d.name||'', grade:d.grade||'', class:d.klass||'', school:d.school||'', createdAt: Date.now() };
        if(d.meta) state.meta = d.meta;
        state.studentId = d.name || '';
        window._piaShareViewOnly = true;
        try{ currentAudience = 'student'; }catch(e){}
        if(typeof renderResult==='function') renderResult();
        if(typeof renderDetailedResult==='function') renderDetailedResult();
        if(typeof renderExtendedSections==='function') renderExtendedSections();
        if(typeof showView==='function') showView('result');
        piaShareViewBanner(d);
        piaShareSwipe();
        /* 대시보드를 숨겼으니 쪽 수를 다시 센다(첫 쪽 = 결과지 본문) */
        try{ if(window.YDScreenPager && YDScreenPager.refresh) YDScreenPager.refresh(); }catch(_f){}
        /* 다른 스크립트가 load 때 홈으로 되돌렸다면 결과 화면으로 다시 */
        window.addEventListener('load', function(){ setTimeout(function(){
          try{
            var _v = document.querySelector('section[data-view]:not(.hidden)');
            if(!_v || _v.dataset.view !== 'result'){ showView('result'); }
            if(window.YDScreenPager && YDScreenPager.refresh) YDScreenPager.refresh();
          }catch(_f){}
        }, 250); }, { once:true });
      }catch(e){ console.error('공유 결과 적용 실패:', e); fail('결과를 표시하지 못했습니다.'); return; }
      try{ box.remove(); }catch(e){}
    }, function(e){ console.error('공유 결과 조회 실패:', e); fail('서버 응답이 없습니다.'); });
  });
}

/* 열람 모드임을 알리는 상단 띠 — 이 화면에서 검사를 이어갈 수 없다는 걸 분명히 */
function piaShareViewBanner(d){
  if(document.getElementById('pia-share-banner')) return;
  var when = '';
  try{ if(d && d.createdAt) when = new Date(d.createdAt).toLocaleDateString('ko-KR'); }catch(e){}
  var b = document.createElement('div');
  b.id = 'pia-share-banner';
  b.style.cssText = 'position:sticky;top:0;z-index:900;background:#141413;color:#fff;padding:9px 14px;font-size:13px;font-weight:700;display:flex;gap:10px;align-items:center;justify-content:center;flex-wrap:wrap';
  b.innerHTML = '<span>📄 결과지 열람 모드' + (when ? ' · ' + when + ' 검사' : '') + '</span>';
  document.body.insertBefore(b, document.body.firstChild);
}

/* [2026-10-29] 공유 열람 화면 — 좌우 스와이프로 쪽 넘김(하단 ‹ 이전 / 다음 › 단추는 그대로 둔다).
   키오스크(html.kiosk-on)는 제외. 세로 스크롤·핀치 확대·입력칸·차트(canvas)·가로로 스크롤되는 표 위에서는 반응하지 않는다. */
function piaShareSwipe(){
  if(window.__piaShareSwipeOn) return;
  try{ if(document.documentElement.classList.contains('kiosk-on')) return; }catch(_f){}
  window.__piaShareSwipeOn = true;
  var x0 = 0, y0 = 0, t0 = 0, armed = false;
  function blocked(el){
    for(var n = el; n && n.nodeType === 1 && n !== document.documentElement; n = n.parentElement){
      if(/^(INPUT|TEXTAREA|SELECT|CANVAS)$/.test(n.tagName)) return true;
      if(n.isContentEditable || n.id === 'ydp-bar' || (n.hasAttribute && n.hasAttribute('data-no-swipe'))) return true;
      if(n.scrollWidth > n.clientWidth + 2){
        var ox = ''; try{ ox = getComputedStyle(n).overflowX; }catch(_f){}
        if(ox === 'auto' || ox === 'scroll') return true;
      }
    }
    return false;
  }
  document.addEventListener('touchstart', function(e){
    armed = false;
    if(!document.documentElement.classList.contains('pia-shareview')) return;
    if(!e.touches || e.touches.length !== 1) return;
    if(blocked(e.target)) return;
    var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); armed = true;
  }, { passive:true });
  document.addEventListener('touchcancel', function(){ armed = false; }, { passive:true });
  document.addEventListener('touchend', function(e){
    if(!armed) return; armed = false;
    try{ if(window.visualViewport && visualViewport.scale > 1.02) return; }catch(_f){}
    try{ var sel = window.getSelection && String(window.getSelection()); if(sel) return; }catch(_f){}
    var t = e.changedTouches && e.changedTouches[0]; if(!t) return;
    var dx = t.clientX - x0, dy = t.clientY - y0;
    if(Date.now() - t0 > 1000) return;
    if(Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var b = document.querySelector('#ydp-bar ' + (dx < 0 ? '.ydp-next' : '.ydp-prev'));
    if(b && !b.disabled) b.click();
  }, { passive:true });
}

function showShareModal() {
  /* 2026-08-22: QR을 찍으면 결과가 바로 뜨도록 변경.
     발급 전까지는 접속 주소를 임시로 쓰고, 토큰이 나오면 QR·버튼을 갈아끼운다. */
  const url = location.href.split('#')[0];
  const modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;';
  modal.innerHTML = `
    <div class="bg-white rounded-2xl p-6 max-w-md w-full">
      <div class="flex justify-between items-center mb-3">
        <h2 class="text-lg font-bold">🔗 결과 공유</h2>
        <button data-act=\'[["@remove",".fixed,[style*=fixed]"]]\' class="text-slate-400 text-xl">×</button>
      </div>
      <div class="bg-slate-50 rounded-lg p-4 mb-3 text-center">
        <div id="pia-qr-box" class="mx-auto mb-2 inline-flex items-center justify-center" style="width:200px;height:200px;font-size:12px;color:#64748b">공유 링크 만드는 중…</div>
        <p class="text-xs text-slate-600" id="pia-qr-note">휴대폰 카메라로 QR을 찍으면 결과지가 그대로 열립니다.</p>
      </div>
      <label class="flex items-start gap-2 text-xs text-slate-600 mb-3 bg-amber-50 border border-amber-200 rounded-lg p-3 cursor-pointer">
        <input type="checkbox" id="pia-share-pii" class="mt-0.5" />
        <span><b>이름·학교·반·자유대화 원문 포함</b> — 기본은 제외됩니다(익명 요약만 공유). 이 링크는 90일간 누구나 열람할 수 있으니, 정말 필요할 때만 켜 주세요.</span>
      </label>
      <div class="space-y-2">
        <button id="pia-share-copy" disabled class="w-full bg-slate-900 text-white py-2 rounded-lg text-sm disabled:opacity-50">🔗 링크 복사</button>
        <button id="pia-share-send" disabled class="w-full bg-emerald-600 text-white py-2 rounded-lg text-sm disabled:opacity-50">📱 공유하기</button>
      </div>
    </div>`;
  document.body.appendChild(modal);
  var box=modal.querySelector('#pia-qr-box');
  var note=modal.querySelector('#pia-qr-note');
  var bCopy=modal.querySelector('#pia-share-copy');
  var bSend=modal.querySelector('#pia-share-send');
  var cbPII=modal.querySelector('#pia-share-pii');

  function paintQR(target){
    _piaLoadQRLib().then(function(ok){
      if(!box) return;
      if(ok && window.QRCode){
        try{ box.innerHTML=''; new QRCode(box,{text:target,width:200,height:200,correctLevel:QRCode.CorrectLevel.M}); return; }catch(e){}
      }
      box.innerHTML='<div style="font-size:12px;color:#64748b;padding:12px">QR 생성을 불러오지 못했습니다.<br>아래 <b>링크 복사</b>를 이용하세요.</div>';
    });
  }
  function wire(target){
    function showLink(){ if(note && note.innerHTML.indexOf('직접 복사')===-1) note.innerHTML='<span style="color:#b45309">이 기기에서는 자동 복사가 막혀 있어요.</span> QR을 스캔하시거나 아래 주소를 길게 눌러 직접 복사해 주세요.<br><span style="word-break:break-all;font-size:11px;user-select:all">'+target+'</span>'; }
    if(bCopy){ bCopy.disabled=false; bCopy.onclick=function(){ window.piaSafeCopy(target,bCopy,'\u2713 링크 복사됨').then(function(ok){ if(!ok) showLink(); }); }; }
    if(bSend){ bSend.disabled=false; bSend.onclick=function(){
      if(navigator.share){ navigator.share({title:'예담 톡 결과', url:target}).catch(function(e){
        if(e && e.name==='AbortError') return; /* 사용자가 공유창을 닫은 것 — 정상 */
        if(window.console) console.error('공유 실패:', e);
        window.piaSafeCopy(target,bSend,'\u2713 링크 복사됨').then(function(ok){ if(!ok) showLink(); });
      }); }
      else { window.piaSafeCopy(target,bSend,'\u2713 링크 복사됨').then(function(ok){ if(!ok) showLink(); }); }
    }; }
  }
  function issue(includePII){
    if(box) box.innerHTML='공유 링크 만드는 중…';
    if(bCopy) bCopy.disabled=true; if(bSend) bSend.disabled=true;
    piaShareCreate(includePII).then(function(token){
      var target=piaShareUrl(token);
      paintQR(target); wire(target);
      if(note) note.innerHTML=(includePII
        ? '<span style="color:#b45309"><b>이름·학교·반·대화원문 포함</b>으로 공유됩니다.</span><br>'
        : '이름·학교·반·대화원문은 <b>제외</b>된 익명 요약이 공유됩니다.<br>')
        + '<b>발급일로부터 90일간</b> 열람할 수 있어요. 링크를 아는 사람은 결과를 볼 수 있으니 공유에 주의해 주세요.';
    }).catch(function(e){
      console.error('결과 공유 링크 발급 실패:', e);
      paintQR(url); wire(url);
      if(note) note.innerHTML='<span style="color:#b45309">결과를 서버에 올리지 못해 접속 주소만 담았습니다.</span><br>이 QR로는 결과가 열리지 않으니, 결과지는 인쇄·PDF로 저장해 주세요.';
    });
  }
  if(cbPII) cbPII.onchange=function(){ issue(cbPII.checked); };
  issue(false); // 기본값: 개인정보·대화원문 제외
}

// ---- 요금제 안내 (서비스 모델) ----
function showPricingModal() {
  const plans = [
    { name:'무료', price:'0원', badge:'', features:['검사 9종 모두', '학생 본인용 결과지', '기본 차트', '로컬 저장만'], cta:'현재 이용 중' },
    { name:'베이직', price:'월 4,900원', badge:'학생 추천', features:['무료 모든 기능', '학부모용 결과지 PDF', 'AI 코치 일일 메시지', '클라우드 백업', '검사 히스토리 무제한'], cta:'30일 무료 체험' },
    { name:'프로', price:'월 9,900원', badge:'가성비', features:['베이직 모든 기능', '자기소개서 자동 생성', '진로상담 1회/월', 'LLM API 호출 1,000회', 'QR 공유'], cta:'시작하기' },
    { name:'스쿨', price:'학교당 협의', badge:'B2G', features:['학급/학년/학교 통계', '교사 대시보드', '학부모 일괄 알림', 'API 통합', '전담 매니저'], cta:'문의하기' }
  ];
  const modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;overflow:auto';
  modal.innerHTML = `
    <div class="bg-white rounded-2xl p-6 max-w-5xl w-full">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-bold">💎 요금제 안내</h2>
        <button data-act=\'[["@remove",".fixed,[style*=fixed]"]]\' class="text-slate-400 text-2xl">×</button>
      </div>
      <p class="text-sm text-slate-600 mb-5">학생·학부모·교사·학교 각 대상별 요금제입니다.</p>
      <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        ${plans.map((p,i) => `
          <div class="border-2 ${i===1?'border-violet-400 relative':'border-slate-200'} rounded-2xl p-4">
            ${p.badge?`<div class="absolute -top-3 left-1/2 -translate-x-1/2 bg-violet-500 text-white text-xs px-3 py-1 rounded-full">${p.badge}</div>`:''}
            <div class="text-sm text-slate-500 mb-1">${p.name}</div>
            <div class="text-2xl font-bold mb-3">${p.price}</div>
            <ul class="text-xs space-y-1.5 mb-4">
              ${p.features.map(f=>`<li class="flex gap-1.5"><span class="text-emerald-500">✓</span><span>${f}</span></li>`).join('')}
            </ul>
            <button class="w-full ${i===0?'bg-slate-100 text-slate-500':'bg-slate-900 text-white'} py-2 rounded-lg text-sm" ${i===0?'disabled':''}>${p.cta}</button>
          </div>`).join('')}
      </div>
      <p class="text-xs text-slate-500 mt-4 text-center">※ 본 화면은 시뮬레이션이며 실제 결제는 진행되지 않습니다.</p>
    </div>`;
  document.body.appendChild(modal);
}

// ---- 도움말 챗봇 ----
const FAQ = [
  { q:'검사는 무료인가요?', a:'네, 모든 9종 검사가 무료입니다. 베이직 요금제는 추가 기능을 위한 것입니다.' },
  { q:'결과는 어디에 저장되나요?', a:'모든 데이터는 브라우저 로컬에만 저장되며 외부 서버로 전송되지 않습니다.' },
  { q:'다시 검사할 수 있나요?', a:'네, 언제든지 검사 메뉴에서 "다시 검사" 버튼으로 재시도할 수 있습니다.' },
  { q:'학부모용 결과지는 어떻게 받나요?', a:'결과지 화면에서 "학부모용" 탭을 선택한 후 인쇄·다운로드하시면 됩니다.' },
  { q:'자해·자살 신호가 감지되면 어떻게 되나요?', a:'즉시 화면에 1388, 1577-0199, 109 등 안전 채널이 표시됩니다.' },
  { q:'학교에서 단체로 사용할 수 있나요?', a:'네, 스쿨 요금제로 학급·학교 단위 통계 및 교사 대시보드를 제공합니다.' },
  { q:'결과가 정확한가요?', a:'학술 검증된 IPIP·RIASEC·VIA 등의 도구를 사용하지만, 의료·임상 진단이 아닌 참고용입니다.' },
  { q:'언어를 바꿀 수 있나요?', a:'현재는 한국어만 지원하며, 영어 버전은 준비 중입니다.' }
];

function showHelpChatbot() {
  const modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;bottom:24px;right:24px;background:white;border:1px solid #cbd5e1;border-radius:16px;width:340px;max-height:500px;box-shadow:0 10px 40px rgba(0,0,0,.15);z-index:999;display:flex;flex-direction:column';
  modal.innerHTML = `
    <div class="bg-violet-600 text-white p-3 rounded-t-2xl flex justify-between items-center">
      <div class="flex items-center gap-2">
        <span class="text-xl">💁</span>
        <strong class="text-sm">도움말 챗봇</strong>
      </div>
      <button data-act=\'[["@remove",".fixed,[style*=fixed]"]]\' class="text-white text-xl">×</button>
    </div>
    <div class="p-3 overflow-y-auto flex-1" style="max-height:400px">
      <div class="text-xs text-slate-500 mb-2">자주 묻는 질문을 클릭해보세요</div>
      <div class="space-y-2" id="faq-list">
        ${FAQ.map((f,i) => `
          <div class="border border-slate-200 rounded-lg p-2 text-xs cursor-pointer hover:bg-slate-50" data-act=\'[["@toggle",".answer","hidden"]]\'>
            <strong class="text-slate-900">Q. ${f.q}</strong>
            <div class="answer hidden mt-2 text-slate-600 leading-relaxed">A. ${f.a}</div>
          </div>`).join('')}
      </div>
      <div class="mt-3 p-2 bg-violet-50 rounded-lg text-xs text-violet-900">
        💡 더 궁금한 점은 도움 요청 화면의 1388·Wee클래스로 문의해주세요.
      </div>
    </div>`;
  document.body.appendChild(modal);
}

// ---- 다음 검사 추천 ----
function getNextRecommendedTest() {
  const order = ['chat','via','big5','grit','riasec','sjt','cesd','phqa','gad'];
  for (const k of order) {
    if (!isTestDone(k)) return k;
  }
  return null;
}

function renderNextRecommendation() {
  const next = getNextRecommendedTest();
  const _nrEn = (typeof window !== 'undefined' && window.aipiaCurrentLang === 'en');
  if (!next) {
    return `<div class="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 text-center">
      <div class="text-2xl mb-2">🎉</div>
      <strong class="text-emerald-900">${_T('모든 검사를 완료했습니다!','You\'ve completed all assessments!')}</strong>
      <p class="text-xs text-emerald-700 mt-1">${_T('통합 결과지에서 종합 분석을 확인해보세요.','Check your comprehensive analysis in the integrated report.')}</p>
      <button data-act="showView" data-arg="result" class="mt-3 bg-emerald-600 text-white px-4 py-2 rounded-lg text-sm">${_T('결과 보기 →','View Results →')}</button>
    </div>`;
  }
  const names = { chat:'자유대화', via:'24 강점', big5:'IPIP Big5-50', grit:'끈기·근면', riasec:'RIASEC 진로 흥미', sjt:'SJT 상황 판단', cesd:'CES-D-10 우울', phqa:'PHQ-A 청소년 우울', gad:'GAD-7 불안' };
  const names_en = { chat:'Free Chat', via:'24 Strengths', big5:'IPIP Big5-50', grit:'Grit & Diligence', riasec:'RIASEC Career Interests', sjt:'SJT Situational Judgment', cesd:'CES-D-10 Depression', phqa:'PHQ-A Adolescent Depression', gad:'GAD-7 Anxiety' };
  return `<div class="bg-sky-50 border border-sky-200 rounded-2xl p-4">
    <div class="text-xs text-sky-700 mb-1">${_T('다음 추천 검사','Next Recommended Assessment')}</div>
    <div class="flex items-center justify-between">
      <strong class="text-sky-900">${(_nrEn?names_en:names)[next]}</strong>
      <button data-act="showView" data-arg="${next}" class="bg-sky-600 text-white px-3 py-1.5 rounded-lg text-xs">${_T('시작 →','Start →')}</button>
    </div>
  </div>`;
}

// ---- 결과지 상단에 v3.8 신규 카드 통합 ----
function injectServiceFeatures() {
  const safe = el('safety-banner');
  if (!safe) return;
  let hub = el('service-hub');
  if (!hub) {
    hub = document.createElement('div');
    hub.id = 'service-hub';
    hub.className = 'space-y-4 no-print';
    safe.parentNode.insertBefore(hub, safe.nextSibling);
  }
  hub.innerHTML = `
    ${renderDailyCoach()}
    ${renderGamification()}
    ${renderNextRecommendation()}
    <div class="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 class="font-semibold text-sm mb-3">🎁 ${_T('서비스 기능','Service Features')}</h3>
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-2">
        <button data-act="showSelfIntroModal" class="bg-violet-50 hover:bg-violet-100 border border-violet-200 rounded-lg p-3 text-left">
          <div class="mb-1 text-violet-600"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9z"></path><path d="M14 3v6h6"></path><path d="M9 13h6"></path><path d="M9 17h4"></path></svg></div>
          <strong class="text-sm block">${_T('자기소개서 생성','Generate Self-Intro')}</strong>
          <span class="text-xs text-slate-500">${_T('AI 자동 작성','AI Auto-Draft')}</span>
        </button>
        <button data-act="showShareModal" class="bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded-lg p-3 text-left">
          <div class="mb-1 text-emerald-600"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.07 0l2-2a5 5 0 0 0-7.07-7.07l-1 1"></path><path d="M14 11a5 5 0 0 0-7.07 0l-2 2a5 5 0 0 0 7.07 7.07l1-1"></path></svg></div>
          <strong class="text-sm block">${_T('결과 공유','Share Results')}</strong>
          <span class="text-xs text-slate-500">${_T('QR · 링크','QR / Link')}</span>
        </button>
        <button data-act="showPricingModal" class="bg-amber-50 hover:bg-amber-100 border border-amber-200 rounded-lg p-3 text-left">
          <div class="mb-1 text-amber-600"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12.59 2.59a2 2 0 0 0-1.42-.59H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.41l8 8a2 2 0 0 0 2.82 0l7.17-7.17a2 2 0 0 0 0-2.82z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg></div>
          <strong class="text-sm block">${_T('요금제 안내','Pricing')}</strong>
          <span class="text-xs text-slate-500">${_T('4단계 플랜','4-Tier Plans')}</span>
        </button>
        <button data-act="showHelpChatbot" class="bg-sky-50 hover:bg-sky-100 border border-sky-200 rounded-lg p-3 text-left">
          <div class="mb-1 text-sky-600"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></div>
          <strong class="text-sm block">${_T('도움말','Help')}</strong>
          <span class="text-xs text-slate-500">${_T('FAQ 챗봇','FAQ Chatbot')}</span>
        </button>
      </div>
    </div>
  `;
}

// ---- showView 후킹: 결과 진입 시 서비스 기능 주입 ----
const _origShow4 = showView;
showView = function(name) {
  _origShow4(name);
  if (name === 'result') {
    setTimeout(injectServiceFeatures, 100);
  }
};

// ---- 헤더에 다크모드/도움말 버튼 추가 ----
function injectGlobalActions() {
  if (el('global-actions')) return;
  const nav = el('topNav');
  if (!nav) return;
  const div = document.createElement('div');
  div.id = 'global-actions';
  div.className = 'flex items-center gap-1';
  div.innerHTML = `
    <button data-act="showPricingModal" class="p-2 text-xs hover:bg-slate-100 rounded-lg" title="요금제">💎</button>
    <button data-act="showHelpChatbot" class="p-2 text-xs hover:bg-slate-100 rounded-lg" title="도움말">💁</button>
    <button data-act="toggleDarkMode" class="p-2 text-xs hover:bg-slate-100 rounded-lg" title="다크모드">🌓</button>
  `;
  nav.appendChild(div);
}

/* 인쇄용·샘플은 가짜 데이터라 열어 둬도 되지만,
   view=record 와 #sample 은 실제 학생 데이터를 여는 경로라 제외한다. */
function _piaSkipGate(){ try{ var q=new URLSearchParams(piaEffectiveSearch()); return q.get('print')==='items' || q.get('paper')==='1' || q.get('sample')==='1'; }catch(e){ return false; } }
function _piaIsStaffSync(){
  // 동기 신호만으로 교사 판정(모달 즉시 억제용): URL 파라미터·기기 플래그·역할
  try{
    var q=new URLSearchParams(piaEffectiveSearch());
    if(q.get('aud')==='teacher' || q.get('staff')==='1') return true;
    if(sessionStorage.getItem('pia_aud_teacher')==='1') return true;
    var STAFF=['org_member','org_admin','super_admin'];
    if(window.PIA_ROLE && STAFF.indexOf(window.PIA_ROLE)>=0) return true;
  }catch(e){}
  return false;
}
/* 이 기기에 Supabase 로그인 세션이 남아 있을 수 있는가(sb-<ref>-auth-token 키, 또는 로그인 복귀 주소).
   localStorage 를 못 읽으면 판단할 수 없으므로 true(예전처럼 확인한다). */
function _piaMayHaveSession(){
  try{
    for(var i=0;i<localStorage.length;i++){ var k=localStorage.key(i); if(k && /^sb-.+-auth-token/.test(k)) return true; }
  }catch(e){ return true; }
  return /[#&?](access_token|refresh_token|code|error_description)=/.test(location.href);
}
async function _piaIsStaff(){
  // 교사/기관/운영자(선생님도우미 전체)는 개인정보 동의 불필요
  try{
    var q=new URLSearchParams(piaEffectiveSearch());
    // 선생님도우미로 한 번 진입하면 이 기기에서 계속 동의 생략(파라미터 유실·새로고침 대비)
    if(q.get('aud')==='teacher' || q.get('staff')==='1'){ try{ sessionStorage.setItem('pia_aud_teacher','1'); }catch(e){} return true; }
    try{ if(sessionStorage.getItem('pia_aud_teacher')==='1') return true; }catch(e){}
    var STAFF=['org_member','org_admin','super_admin'];
    if(window.PIA_ROLE) return STAFF.indexOf(window.PIA_ROLE)>=0;
    /* [2026-09-26 성능] 저장된 Supabase 세션이 없으면 아래 getSession 은 어차피 null 이다.
       그 확인 하나 때문에 첫 화면마다 supabase-js(210KB)를 받아 실행하던 것을 건너뛴다. */
    if(!_piaMayHaveSession()) return false;
    var sb=await _piaEnsureSB(); if(!sb) return false;
    var s=await sb.auth.getSession(); if(!(s&&s.data&&s.data.session)) return false;
    var res=await sb.rpc('pia_my_profile'); var d=res&&res.data&&res.data[0];
    window.PIA_ROLE=d?d.role:window.PIA_ROLE;
    return d && STAFF.indexOf(d.role)>=0;
  }catch(e){ return false; }
}
// ---- 초기화 ----
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(async () => {
    if (sessionStorage.getItem('pia_v3_dark') === '1') applyDarkMode(true);
    var _isStaff=false; try{ _isStaff=await _piaIsStaff(); }catch(e){}
    /* v2: 동의는 홈 → 검사 시작하기 이후 consent 화면에서 진행 */
    injectGlobalActions();
  }, 100);
});

window.showSelfIntroModal = showSelfIntroModal;
window.showShareModal = showShareModal;
window.showPricingModal = showPricingModal;
window.showHelpChatbot = showHelpChatbot;
window.toggleDarkMode = toggleDarkMode;

// =================================================================
//  v3.9 — 모바일 자유대화 음성 우선 시작
// =================================================================

function isMobile() {
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)
    || window.innerWidth < 768;
}

// 모바일에서 자유대화 진입 시 음성 시작 안내 모달
/* [FIX 2026-10-21 kiosk C5] mic icon as inline SVG instead of emoji glyph (mic/rec/stop).
   Kiosk OS without an emoji font renders the glyph as an empty box. SVG does not depend on fonts. */
window.__piaMicHTML = function(label, stop){
  var ic = stop
    ? '<svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="currentColor" aria-hidden="true" focusable="false" style="vertical-align:-0.25em"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>'
    : '<svg viewBox="0 0 24 24" width="1.3em" height="1.3em" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="vertical-align:-0.25em"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0"/><path d="M12 18v4"/></svg>';
  return ic + (label ? '<span>' + label + '</span>' : '');
};
function showMobileVoiceStarter() {
  if (el('mobile-voice-modal')) return;
  const modal = document.createElement('div');
  modal.id = 'mobile-voice-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.7);display:flex;align-items:center;justify-content:center;z-index:998;padding:20px;';
  modal.innerHTML = `
    <div class="bg-white rounded-2xl p-6 max-w-sm w-full text-center">
      <div class="mb-4 animate-pulse" style="font-size:60px;line-height:1;display:flex;justify-content:center">${window.__piaMicHTML()}</div>
      <h2 class="text-xl font-bold mb-2">음성으로 시작해요</h2>
      <p class="text-sm text-slate-600 mb-5 leading-relaxed">
        말로 대화하는 것이 가장 편해요.<br>
        아래 버튼을 누르고 편하게 이야기해보세요.
      </p>
      <div class="space-y-2">
        <button id="mv-start-voice" class="w-full bg-rose-500 hover:bg-rose-600 text-white py-4 rounded-2xl text-base font-bold shadow-lg flex items-center justify-center gap-2">
          <span class="text-2xl" style="display:inline-flex">${window.__piaMicHTML()}</span>
          <span>음성으로 시작</span>
        </button>
        <button id="mv-start-text" class="w-full bg-slate-100 text-slate-700 py-3 rounded-2xl text-sm">
          텍스트로 시작
        </button>
      </div>
      <p class="text-xs text-slate-400 mt-4">마이크 권한을 허용해주세요</p>
    </div>`;
  document.body.appendChild(modal);

  el('mv-start-voice').addEventListener('click', () => {
    modal.remove();
    // 음성 입력 버튼 즉시 트리거
    setTimeout(() => {
      const micBtn = el('chat-mic');
      if (micBtn) {
        micBtn.click();
        // TTS도 자동 켜기 (옵션)
        const tts = el('chat-tts');
        if (tts && !tts.checked) tts.checked = true;
      }
    }, 400);
  });
  el('mv-start-text').addEventListener('click', () => {
    modal.remove();
    setTimeout(() => {
      const input = el('chat-input');
      if (input) input.focus();
    }, 200);
  });
}

// 모바일에서 채팅 화면 진입 시 음성 버튼을 더 크게 + 강조
function enhanceMobileChat() {
  const micBtn = el('chat-mic');
  if (!micBtn) return;
  if (isMobile()) {
    // 모바일에선 음성 버튼을 크고 눈에 띄게
    micBtn.style.cssText = 'padding:14px 20px;font-size:20px;background:#F43F5E;color:white;border-radius:16px;font-weight:bold;box-shadow:0 4px 14px rgba(244,63,94,.3);';
    micBtn.innerHTML = window.__piaMicHTML('\uB9D0\uD558\uAE30');

    // 송신 버튼은 조금 작게
    const sendBtn = el('chat-send');
    if (sendBtn) {
      sendBtn.style.cssText = 'padding:14px 16px;font-size:14px;';
    }

    // 입력창 placeholder 변경
    const input = el('chat-input');
    if (input) {
      input.placeholder = '음성 또는 텍스트로 시작하세요';
    }

    // 음성 안내 텍스트 추가
    let hint = el('chat-mobile-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.id = 'chat-mobile-hint';
      hint.className = 'text-center text-xs text-rose-700 mt-2 font-medium';
      hint.innerHTML = (window.aipiaCurrentLang === 'en') ? '\ud83d\udc46 Tap the voice button to start speaking' : '👆 음성 버튼을 눌러 말하기 시작 (한국어 인식)';
      const inputArea = micBtn.closest('.px-4');
      if (inputArea) inputArea.appendChild(hint);
    }
  }
}

// showView 후킹 - chat 진입 시
const _origShow5 = showView;
showView = function(name) {
  _origShow5(name);
  /* 자유대화에서 음성 자동 시작을 어디까지 띄울지.

     예전에는 isMobile() 일 때만 "음성으로 시작해요" 유도 화면을 띄웠다.
     그런데 키오스크는 화면이 커서 모바일로 안 잡힌다(실측: dev-forced).
     그래서 키오스크에서는 유도가 아예 안 뜨고 텍스트 입력만 남았다 —
     MOM 은 화면에 들어가면 바로 마이크를 켜는데 PIA 는 안 켜진 것이다.

     키오스크는 손으로 타자 치기 어렵고, 배치 파일이 마이크 권한을 미리
     허용해 둔다(--use-fake-ui-for-media-stream). 음성이 기본이어야 한다.
     그래서 모바일뿐 아니라 키오스크에서도 유도 화면을 띄운다. */
  var wantVoice = (typeof isMobile === 'function' && isMobile())
               || (typeof _isKioskDevice === 'function' && _isKioskDevice());
  if (name === 'chat' && wantVoice) {
    setTimeout(() => {
      enhanceMobileChat();
      // 첫 진입 시(턴=0)에만 음성 시작 모달 노출
      if (state.results.conv.turns === 0) {
        showMobileVoiceStarter();
      }
    }, 200);
  } else if (name === 'chat') {
    // 데스크탑에서도 모바일 같은 너비면 적용
    setTimeout(enhanceMobileChat, 200);
  }
};

// 마이크 권한 사전 요청 (모바일에서 유저 인터랙션 시점에)
let _micStream = null;
// 마이크 스트림을 대화 세션 동안 1회만 확보해 재사용(발화마다 재요청 방지)
// ===== 음성 활동 감지(VAD) — 사람 목소리 에너지에만 반응, 노이즈 차단 =====
let _vadCtx=null,_vadAnalyser=null,_vadBuf=null,_vadPeak=0,_vadRAF=null; const _VAD_FLOOR=0.035;
function startVAD(stream){
  try{
    if(_vadCtx) return;
    const AC=window.AudioContext||window.webkitAudioContext; if(!AC) return;
    _vadCtx=new AC();
    const src=_vadCtx.createMediaStreamSource(stream);
    _vadAnalyser=_vadCtx.createAnalyser(); _vadAnalyser.fftSize=512; _vadAnalyser.smoothingTimeConstant=0.4;
    src.connect(_vadAnalyser); _vadBuf=new Uint8Array(_vadAnalyser.fftSize);
    const loop=function(){ if(!_vadAnalyser) return; _vadAnalyser.getByteTimeDomainData(_vadBuf); let sum=0; for(let i=0;i<_vadBuf.length;i++){ const v=(_vadBuf[i]-128)/128; sum+=v*v; } const rms=Math.sqrt(sum/_vadBuf.length); if(rms>_vadPeak) _vadPeak=rms; _vadRAF=requestAnimationFrame(loop); };
    loop();
  }catch(e){}
}
function resetVADPeak(){ _vadPeak=0; }
function vadHasVoice(){ if(!_vadAnalyser) return true; return _vadPeak>=_VAD_FLOOR; } // 분석 불가 환경에선 차단 안 함
function stopVAD(){ if(_vadRAF) cancelAnimationFrame(_vadRAF); _vadRAF=null; if(_vadCtx){ try{ _vadCtx.close(); }catch(e){} } _vadCtx=null; _vadAnalyser=null; _vadPeak=0; }

async function ensureMicStream() {
  try {
    if (_micStream && _micStream.getTracks().some(function(t){ return t.readyState === 'live'; })) return true;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return false;
    _micStream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, channelCount: 1 } });
    try { startVAD(_micStream); } catch(e) {}
    return true;
  } catch(e) {
    console.warn('마이크 권한:', e.message);
    return false;
  }
}
function releaseMicStream() {
  try { stopVAD(); } catch(e) {}
  if (_micStream) { try { _micStream.getTracks().forEach(function(t){ t.stop(); }); } catch(e) {} _micStream = null; }
}
async function preRequestMicPermission() { return ensureMicStream(); }

// 검사 메뉴에서 자유대화 카드 클릭 시 모바일이면 권한 사전 요청
window.addEventListener('click', async (e) => {
  /* [CSP 2026-09-29] onclick 속성 → data-act/data-arg 로 옮김. 옛 속성도 함께 본다. */
  const btn = e.target.closest('button[onclick*="chat"],button[data-arg*="chat"],button[data-act*="chat"]');
  if (btn && isMobile() && state.results.conv.turns === 0) {
    await preRequestMicPermission();
  }
});

window.isMobile = isMobile;
window.showMobileVoiceStarter = showMobileVoiceStarter;

// =================================================================
//  v3.9.1 — 모바일 음성 인식 race condition 패치
// =================================================================

// 전역 recognition 인스턴스 관리 (중복 시작 방지)
let _globalRecognition = null;
let _globalRecording = false;
let _micWant = false; // 마이크 핸즈프리(한 번 켜면 자동 재시작)
let _globalRestartTimer = null;

function getRecognition() {
  if (_globalRecognition) return _globalRecognition;
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return null;
  const rec = new SR();
  rec.lang = (window._chatLang) || (navigator.language) || 'ko-KR';
  rec.interimResults = true;
  rec.continuous = false;
  rec.maxAlternatives = 1;
  _globalRecognition = rec;
  return rec;
}

// 안전한 음성 인식 시작 (이미 시작된 경우 대기 후 재시도)
/* [바인딩 규칙 2026-09-28] 이 함수는 클래식 스크립트 최상위 선언이라 전역 객체(window)의
   속성이다. 그래서 이 파일 안의 맨이름 호출 safeStartRecognition() 도 매번 window 값을
   다시 읽는다 — 아래 재정의를 우회하지 않는다. 최종 승자(마지막 대입):
     1) 이 선언(pia-main.js 로드 시)
     2) kiosk.js '마이크 push-to-talk' 래퍼(__ptt) — DOMContentLoaded/250ms 폴링으로 덮음.
        kiosk-on 여부와 무관하게 모든 기기에 적용. #chat-mic 조작(__micArm) 후 15초 내 1회만 통과.
     3) pia-screenparam.js — ?screen= 검수 모드에서만 DOMContentLoaded+600ms 에 no-op 로 덮음.
   이 함수를 IIFE/모듈 안으로 옮기거나 let/const 로 바꾸면 위 래퍼가 내부 호출을 못 잡는다. */
async function safeStartRecognition() {
  const rec = getRecognition();
  if (!rec) {
    /* [FIX] 자동 재시작 경로에서 alert 이 반복되면 화면이 잠긴다. 안내만 띄운다. */
    try{ var _ms0=el('chat-mic-status'); if(_ms0) _ms0.textContent='이 브라우저는 음성 인식을 지원하지 않아요. 글로 입력해 주세요.'; }catch(e){}
    try{ _micWant = false; }catch(e){}
    return false;
  }
  if (_globalRecording) {
    // 이미 진행 중이면 일단 중지하고 재시도
    try { rec.stop(); } catch(e) {}
    _globalRecording = false;
    await new Promise(r => setTimeout(r, 400));
  }
  if (typeof window!=='undefined' && window.isSecureContext === false) { const ms=el('chat-mic-status'); if(ms) ms.textContent='⚠ 보안(HTTPS) 연결에서만 마이크가 동작합니다.'; return false; }
  var _touchNotKiosk = (!document.documentElement.classList.contains('kiosk-on')) && !!(window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches);
  if (isMobile() || _touchNotKiosk) {
    // 모바일·터치태블릿(iPad 포함): SpeechRecognition이 마이크를 직접 점유하도록 보유 스트림 해제(동시 점유 충돌 방지)
    try { if (typeof releaseMicStream === 'function') releaseMicStream(); } catch(e) {}
    // getUserMedia 해제 직후 곧바로 start 하면 기기가 마이크를 아직 안 놓아 'aborted' 가 난다. 잠깐 기다린다.
    await new Promise(function(r){ setTimeout(r, 300); });
  } else {
            try { if (typeof releaseMicStream === 'function') releaseMicStream(); } catch(e) {}
            await new Promise(function(r){ setTimeout(r, 300); });
  }
  try {
    try { rec.lang = (window._chatLang) || (navigator.language) || 'ko-KR'; } catch(e) {}
    rec.start();
    _globalRecording = true;
    return true;
  } catch(err) {
    if (err.name === 'InvalidStateError' || /already started/i.test(err.message)) {
      // 한 번 더 stop 후 재시도
      try { rec.stop(); } catch(e) {}
      _globalRecording = false;
      await new Promise(r => setTimeout(r, 600));
      try {
        rec.start();
        _globalRecording = true;
        return true;
      } catch(e2) {
        console.warn('safeStartRecognition 재시도 실패:', e2.message);
        return false;
      }
    }
    if (err.name === 'NotAllowedError') {
      alert('마이크 권한이 거부되었습니다. 브라우저 설정에서 마이크 권한을 허용해주세요.');
      return false;
    }
    console.warn('safeStartRecognition 실패:', err.message);
    return false;
  }
}

function safeStopRecognition() {
  _micWant = false;
  if (!_globalRecognition) return;
  try { _globalRecognition.stop(); } catch(e) {}
  _globalRecording = false;
}

/* 마이크·음성을 한 번에 확실히 끈다.
   예전에는 화면을 떠나도 인식기가 살아 있어, 검사 문항을 푸는 내내
   마이크가 켜진 채 주변 대화를 계속 받아 적고 있었다. */
window.piaStopMic = function(reason){
  try{ _micWant = false; }catch(e){}
  try{ if (window._piaMicRetryTimer){ clearTimeout(window._piaMicRetryTimer); window._piaMicRetryTimer=null; } }catch(e){}
  try{
    if (_globalRecognition){
      _globalRecognition.onend = null;      /* 자동 재시작 고리를 먼저 끊는다 */
      if (_globalRecognition.abort) _globalRecognition.abort();
      else if (_globalRecognition.stop) _globalRecognition.stop();
    }
  }catch(e){}
  try{ _globalRecording = false; }catch(e){}
  try{ if (typeof releaseMicStream === 'function') releaseMicStream(); }catch(e){}
  try{ if ('speechSynthesis' in window) speechSynthesis.cancel(); }catch(e){}
  try{ window.__gttsPlaying = false; }catch(e){}
};
try{
  document.addEventListener('visibilitychange', function(){ if (document.hidden) window.piaStopMic('hidden'); });
  window.addEventListener('pagehide', function(){ window.piaStopMic('pagehide'); });
}catch(e){}

// 채팅 화면 진입 시 micBtn에 신규 핸들러 강제 부착 (기존 핸들러 제거)
function rebindMicButton() {
  const micBtn = el('chat-mic');
  const micStatus = el('chat-mic-status');
  const messageInput = el('chat-input');
  const sendBtn = el('chat-send');
  if (!micBtn) return;

  // 기존 핸들러 제거를 위해 노드 복제 후 교체
  const newBtn = micBtn.cloneNode(true);
  micBtn.parentNode.replaceChild(newBtn, micBtn);

  const rec = getRecognition();
  if (!rec) {
    newBtn.disabled = true;
    newBtn.title = '이 브라우저는 음성 인식을 지원하지 않습니다 (Chrome/Safari 권장).';
    if (micStatus) micStatus.textContent = '⚠ 음성 입력 미지원';
    return;
  }

  // 이벤트 핸들러 재정의 (기존이 있다면 덮어쓰기)
  rec.onresult = (e) => {
    /* [FIX 2026-08-22] AI 음성 안내가 스피커로 나가는 동안 마이크가 그 소리를 그대로
       받아 학생 답변으로 입력되는 되먹임(에코)이 있었다. 스피커 재생 중(또는 종료 직후
       0.8초)에는 인식 결과를 버린다. 헤드셋이 아닌 교실 PC에서 특히 심하다. */
    try{
      var _sp = (('speechSynthesis' in window) && speechSynthesis.speaking) || !!window.__gttsPlaying;
      if (_sp) { window.__ttsEchoUntil = Date.now() + 800; }
      if (_sp || (window.__ttsEchoUntil && Date.now() < window.__ttsEchoUntil)) {
        if (micStatus) micStatus.textContent = '안내 음성 중에는 잠시 듣지 않아요';
        return;   /* 에코 무시 */
      }
    }catch(_e){}
    let finalText = '', interimText = '';
    for (let i = e.resultIndex; i < e.results.length; i++) {
      const r = e.results[i];
      if (r.isFinal) { var _c=r[0].confidence; var _mob=(typeof isMobile==='function'&&isMobile()); var passConf=!(typeof _c==='number'&&_c>0&&_c<0.4); var passVad=_mob||(typeof vadHasVoice!=='function')||vadHasVoice(); if(passConf&&passVad) finalText += r[0].transcript; }
      else interimText += r[0].transcript;
    }
    if (interimText && micStatus) micStatus.textContent = '듣는 중: ' + interimText.slice(0, 30);
    if (finalText) {
      messageInput.value = finalText.trim();
      if (micStatus) micStatus.textContent = '인식 완료';
    }
  };
  rec.onend = () => {
    _globalRecording = false;
    newBtn.innerHTML = window.__piaMicHTML();
    newBtn.classList.remove('animate-pulse');
    if (isMobile()) {
      newBtn.style.background = '#F43F5E';
      newBtn.innerHTML = window.__piaMicHTML('\uB9D0\uD558\uAE30');
    } else {
      newBtn.style.background = '';
    }
    if (messageInput.value.trim()) {
      setTimeout(() => sendBtn?.click(), 200);
    } else if (micStatus) {
      micStatus.textContent = _micWant ? '계속 듣는 중…' : '';
    }
    // 핸즈프리: 사용자가 켜둔 상태면 자동 재시작 (TTS 재생 중엔 대기)
    /* [FIX 2026-08-22] onerror 에는 백오프·5회 상한이 있는데 onend 에는 없었다.
       마이크가 소리를 못 잡으면 onend 만 계속 발생 → 0.7초마다 무한 재시작 →
       인식기 생성이 쌓여 메인스레드를 잡고 '응답 없는 페이지'가 됐다.
       발화 없이 끝난 연속 재시작을 세어 상한을 두고, 간격도 점점 늘린다. */
    if (_micWant) {
      var _got = !!messageInput.value.trim();
      if (_got) { window._piaEndLoop = 0; }
      else { window._piaEndLoop = (window._piaEndLoop || 0) + 1; }
      /* [안전장치 2] 짧은 시간에 onend 가 몰아치면(예: 마이크 미인식) 즉시 중단.
         Chrome 은 7초 무음이면 자동으로 onend 를 쏘므로 조용한 교실에서 폭주하기 쉽다.
         (알려진 함정: onend 안에서 start() 를 부르면 브라우저가 멈추거나 죽는다) */
      var _nowE = Date.now();
      if (!_got) {
        if (_nowE - (window._piaEndFirstAt || _nowE) > 60000) { window._piaEndFirstAt = _nowE; window._piaEndLoop = 1; }
        else if (!window._piaEndFirstAt) { window._piaEndFirstAt = _nowE; }
        var _fast = (_nowE - (window._piaEndLastAt || 0)) < 1200;   /* 1.2초 내 재발생 */
        window._piaEndLastAt = _nowE;
        window._piaEndFast = _fast ? ((window._piaEndFast || 0) + 1) : 0;
      } else { window._piaEndFast = 0; window._piaEndFirstAt = 0; }
      if (!_got && (window._piaEndLoop > 8 || window._piaEndFast >= 3)) {
        try{ window.piaStopMic('end-loop'); }catch(e){ _micWant = false; }
        if (micStatus) micStatus.textContent = '음성이 계속 감지되지 않아 글 입력으로 바꿨어요.';
      } else {
        var _delay = _got ? 1800 : Math.min(6000, 700 * Math.pow(1.6, Math.max(0,(window._piaEndLoop||1) - 1)));
        clearTimeout(window._piaEndTimer);
        window._piaEndTimer = setTimeout(function(){
          if (_micWant && !_globalRecording && !(('speechSynthesis' in window) && speechSynthesis.speaking) && !window.__gttsPlaying) {
            safeStartRecognition();
          }
        }, _delay);
      }
    }
  };
  rec.onerror = (e) => {
    _globalRecording = false;
    newBtn.innerHTML = window.__piaMicHTML();
    newBtn.classList.remove('animate-pulse');
    if (isMobile()) {
      newBtn.style.background = '#F43F5E';
      newBtn.innerHTML = window.__piaMicHTML('\uB9D0\uD558\uAE30');
    }
    if (e.error === 'no-speech') {
      if (micStatus) micStatus.textContent = _micWant ? '계속 듣는 중…' : '음성이 감지되지 않았어요. 다시 시도해주세요.';
    } else if (e.error === 'not-allowed' || e.error === 'service-not-allowed') {
      _micWant = false;
      if (micStatus) micStatus.textContent = '⚠ 마이크 권한 거부됨';
    } else if (e.error === 'aborted') {
      if (micStatus) micStatus.textContent = '';
    } else {
      if (micStatus) micStatus.textContent = '오류: ' + e.error;
    }
    /* 핸즈프리 재시작.
       마이크가 없거나(audio-capture) 학교 방화벽이 음성 서버를 막으면(network)
       오류가 즉시 나므로, 예전 코드는 0.5초마다 영원히 재시도했다.
       치명적 오류는 바로 포기하고, 나머지는 간격을 늘리며 5회까지만 시도한다. */
    var _fatal = (e.error==='not-allowed' || e.error==='service-not-allowed' || e.error==='audio-capture');
    if (_fatal) {
      window.piaStopMic(e.error);
      if (micStatus) micStatus.textContent =
        (e.error==='audio-capture') ? '마이크를 찾지 못했어요. 글로 입력해 주세요.'
                                    : '마이크를 쓸 수 없어요. 글로 입력해 주세요.';
    } else if (_micWant) {
      window._piaMicRetry = (window._piaMicRetry||0) + 1;
      if (window._piaMicRetry > 5) {
        window.piaStopMic('retry-exhausted');
        if (micStatus) micStatus.textContent = '음성 인식이 계속 끊겨서 글 입력으로 바꿨어요.';
      } else {
        var _wait = Math.min(8000, 500 * Math.pow(2, window._piaMicRetry - 1));
        window._piaMicRetryTimer = setTimeout(function(){
          if (_micWant && !_globalRecording && !(('speechSynthesis' in window) && speechSynthesis.speaking) && !window.__gttsPlaying) { safeStartRecognition(); }
        }, _wait);
      }
    }
  };
  rec.onstart = () => {
    window._piaMicRetry = 0;   /* 한 번 성공했으면 백오프를 처음으로 되돌린다 */
    _globalRecording = true;
    newBtn.textContent = '⏹';
    newBtn.classList.add('animate-pulse');
    newBtn.style.background = '#DC2626';
    if (micStatus) micStatus.textContent = '듣는 중... 말씀하세요';
  };

  newBtn.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    try {
      if (window._piaRec2) { try { window._piaRec2.stop(); } catch(_e){} return; }
      /* [FIX 2026-09-28] '음성으로 시작'(safeStartRecognition)으로 전역 인식기가 듣는 중에 이 버튼을
         누르면 _piaRec2 가 하나 더 떠 인식기 두 개가 동시에 돌았다. 또 버튼 클릭이 연 __micArm 15초 창이
         열린 채라, 전역 onend/onerror 의 자동 재시작이 kiosk.js push-to-talk 래퍼를 1회 통과해 다시 켜졌다.
         아래에서 _micWant=true 로 다시 세우므로 safeStopRecognition 만으로는 비동기 onend 가 재시작한다.
         그래서 재시작 타이머를 지우고, 전역 인식기의 핸들러를 잠시 떼어 abort 한 뒤 onend 1회에 되돌린다. */
      _micWant = false;
      try { clearTimeout(window._piaEndTimer); clearTimeout(window._piaMicRetryTimer); window._piaMicRetryTimer = null; } catch(_e){}
      if (_globalRecording && _globalRecognition) {
        var _g = _globalRecognition, _gh = { r: _g.onresult, e: _g.onerror, n: _g.onend };
        _g.onresult = null; _g.onerror = null;
        _g.onend = function(){ _g.onresult = _gh.r; _g.onerror = _gh.e; _g.onend = _gh.n; };
        try { if (_g.abort) _g.abort(); else _g.stop(); } catch(_e){}
        _globalRecording = false;
      }
      var SRc = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SRc) { if(micStatus) micStatus.textContent='음성 입력 미지원'; return; }
      var r = new SRc();
      r.lang='ko-KR'; r.continuous=false; r.interimResults=true; r.maxAlternatives=1; /* [2026-10-01] 중간 결과로 말 끝 앞당기기(pia-bargein.js piaEndpoint) */
      window._piaRec2 = r; _globalRecording = true; _micWant = true;
      try { messageInput.value=''; } catch(_e){}
      newBtn.textContent='⏹';
      try { newBtn.classList.add('animate-pulse'); newBtn.style.background='#DC2626'; } catch(_e){}
      if (micStatus) micStatus.textContent='듣는 중... 말씀하세요';
      r.onresult=function(ev){ try{ var t='', fin=true; for(var i=0;i<ev.results.length;i++){ t+=ev.results[i][0].transcript; if(!ev.results[i].isFinal) fin=false; } t=(t||'').trim(); if(t){ messageInput.value=t; if(micStatus) micStatus.textContent= fin ? '인식 완료' : ('듣는 중: '+t.slice(0,30)); } }catch(_e){} };
      try{ if(typeof window.piaEndpoint==='function') window.piaEndpoint(r); }catch(_e){ console.error('[mic] 말 끝 앞당기기 연결 실패', _e); }
      r.onerror=function(ev){ if(micStatus) micStatus.textContent = (ev&&(ev.error==='not-allowed'||ev.error==='service-not-allowed')) ? '마이크 권한을 허용해 주세요' : '다시 한 번 눌러 말씀해 주세요'; };
      r.onend=function(){ window._piaRec2=null; _globalRecording=false; newBtn.textContent='🎙'; try{ newBtn.classList.remove('animate-pulse'); newBtn.style.background=''; }catch(_e){} /*pia-autosend*/ /* [2026-09-30] send() 는 다른 클로저 안의 함수라 여기서는 typeof send==='undefined' 였다 → 말하고 나서 '답변 보내기'를 또 눌러야 했다. 보내기 버튼을 눌러 같은 경로로 보낸다(지연 300→60ms). */ try{ if(messageInput&&messageInput.value&&messageInput.value.trim()){ setTimeout(function(){ try{ var _sb=el('chat-send'); if(_sb&&!_sb.disabled) _sb.click(); else if(typeof send==='function') send(); }catch(e){ console.error(e); } },60); } }catch(e){ console.error(e); } };
      r.start();
    } catch(err) {
      window._piaRec2=null; _globalRecording=false;
      try{ newBtn.textContent='🎙'; newBtn.classList.remove('animate-pulse'); newBtn.style.background=''; if(micStatus) micStatus.textContent='다시 한 번 눌러 주세요'; }catch(_e){}
    }
  });
}

// 모바일 음성 시작 모달의 "음성으로 시작" 클릭 핸들러를 안전하게 교체
const _origShowMobileVoice = showMobileVoiceStarter;
showMobileVoiceStarter = function() {
  _origShowMobileVoice();
  // 안전 핸들러로 교체
  setTimeout(() => {
    const startVoiceBtn = el('mv-start-voice');
    if (startVoiceBtn) {
      const newBtn = startVoiceBtn.cloneNode(true);
      startVoiceBtn.parentNode.replaceChild(newBtn, startVoiceBtn);
      newBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        // 모달 닫기
        const modal = el('mobile-voice-modal');
        if (modal) modal.remove();

        // TTS 자동 ON
        const tts = el('chat-tts');
        if (tts && !tts.checked) tts.checked = true;

        // 안전한 시작 (약간 지연)
        await new Promise(r => setTimeout(r, 500));
        /* 2026-09-24 kiosk.js 는 __micArm() 없이 부른 safeStartRecognition 을 거부한다(push-to-talk).
           이 버튼 클릭이 사용자 조작이므로 시작 직전에 시작 권한을 연다. */
        if (typeof window.__micArm === 'function') window.__micArm();
        const ok = await safeStartRecognition();
        if (!ok) {
          const micStatus = el('chat-mic-status');
          if (micStatus) {
            micStatus.innerHTML = '⚠ 음성 시작 실패. <button type="button" class="underline">다시 시도</button>';
            /* 2026-09-24 '다시 시도'도 사용자 조작이므로 시작 권한을 연 뒤 시작한다(인라인 onclick 은 권한 없이 불러 항상 실패했다). */
            const retryBtn = micStatus.querySelector('button');
            if (retryBtn) retryBtn.addEventListener('click', () => {
              if (typeof window.__micArm === 'function') window.__micArm();
              safeStartRecognition();
            });
          }
        }
      });
    }
    const startTextBtn = el('mv-start-text');
    if (startTextBtn) {
      startTextBtn.addEventListener('click', () => {
        const modal = el('mobile-voice-modal');
        if (modal) modal.remove();
        setTimeout(() => el('chat-input')?.focus(), 200);
      });
    }
  }, 100);
};

// showView 후킹 — chat 진입 시 항상 mic 버튼 재바인딩
const _origShow6 = showView;
showView = function(name) {
  _origShow6(name);
  if (name === 'chat') {
    setTimeout(() => { rebindMicButton(); }, 0);
  }
};

// v3.10 — 키오스크/데스크탑 등 자유대화 진입 시 마이크 자동 시작
// (모바일 첫 진입은 기존 showMobileVoiceStarter 선택 모달을 그대로 사용)
// [주의 2026-09-28] kiosk.js push-to-talk 래퍼가 __micArm() 없는 호출을 막으므로
// kiosk.js 를 싣는 페이지(aipia/test.html)에서는 이 자동 시작이 실제로는 동작하지 않는다
// (false 반환 + 콘솔 '[MIC] 마이크 버튼을 누른 경우에만…').
const _origShow7 = showView;
showView = function(name) {
  _origShow7(name);
  if (name === 'chat') {
    setTimeout(() => {
      /* 저사양 POS 키오스크는 진입 자동 마이크 획득(getUserMedia+AudioContext+실시간 FFT+음성인식)만으로도 CPU가 막혀 '응답 없는 페이지'가 뜬다. 키오스크·터치기기·모바일 첫진입은 자동시작하지 않고 '음성으로 시작' 탭으로만 시작한다(1회 clean start). 데스크톱(마우스)만 자동시작 유지. */
      var _kioskOrTouch = (typeof _isKioskDevice==='function' && _isKioskDevice()) || !!(window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches);
      const skipAuto = (isMobile() && state.results.conv.turns === 0) || _kioskOrTouch;
      if (!skipAuto && !_globalRecording && !window.__micPushToTalk) { /* 2026-09-28: kiosk.js push-to-talk 이 켜져 있으면 자동 시작은 늘 막히므로 시도하지 않음(콘솔 오류 제거) */
        _micWant = true;
        safeStartRecognition();
      }
    }, 350);
  }
};

/* 전역 공개(최상위 선언이라 이미 window 속성 — 명시용). 재정의 순서는 위 '바인딩 규칙' 참고. */
window.safeStartRecognition = safeStartRecognition;
window.safeStopRecognition = safeStopRecognition;(function(){function _vscore(v){var n=(v.name||'');var sc=0;if(v.localService===false)sc+=12;if(/google/i.test(n))sc+=7;if(/neural|natural|wavenet|premium/i.test(n))sc+=6;if(/yuna|heami|sunhi|sora|seoyeon|nari|jiyoon|jenny|aria|female|여성|여자/i.test(n))sc+=9;if(/injoon|namjun|jihun|male|남성|남자/i.test(n))sc-=6;if(/ko[-_]?kr/i.test(v.lang||''))sc+=2;if(/microsoft/i.test(n))sc+=1;return sc;}window.piaPickVoice=function(){try{if(!('speechSynthesis' in window))return null;var vs=speechSynthesis.getVoices()||[];var _plang=(window.aipiaCurrentLang==='en')?'en':'ko';var pool=vs.filter(function(v){return ((v.lang||'').replace('_','-').toLowerCase()).indexOf(_plang)===0;});if(!pool.length)return null;var saved='';try{saved=localStorage.getItem(_plang==='en'?'pia_v3_voice_en':'pia_v3_voice')||'';}catch(e){}var s=pool.filter(function(v){return v.voiceURI===saved;})[0];if(s)return s;pool.sort(function(a,b){return _vscore(b)-_vscore(a);});return pool[0]||null;}catch(e){return null;}};window.piaVoiceRate=function(){try{var g=(window.state&&state.profile&&state.profile.grade)||'';return /초/.test(g)?0.9:0.95;}catch(e){return 0.95;}};window.piaApplyVoice=function(u){try{var v=window.piaPickVoice();if(v)u.voice=v;u.lang=(window.aipiaCurrentLang==='en')?'en-US':'ko-KR';u.rate=window.piaVoiceRate();u.pitch=1.05;}catch(e){}return u;};try{if('speechSynthesis' in window&&typeof speechSynthesis.addEventListener==='function'){speechSynthesis.addEventListener('voiceschanged',function(){try{window.piaPickVoice();}catch(e){}});}}catch(e){}})();(function(){var _homeGreeted=false,_fallbackArmed=false,_fbHandler=null;var GREET='안녕하세요! 저는 AI 피아예요. 편하게 이야기해 주세요. 정답은 없어요.';function _isHome(){try{var s=document.querySelector('section[data-view]:not(.hidden)');return !!s&&s.dataset.view==='chat';}catch(e){return false;}}function _eligible(){try{if(!(window.PIA&&window.PIA.ttsOn))return false;}catch(e){return false;}try{if(typeof getCompletedTests==='function'&&Object.keys(getCompletedTests()).length>0)return false;}catch(e){}return true;}function _disarm(){if(!_fallbackArmed)return;_fallbackArmed=false;['click','keydown'].forEach(function(evt){document.removeEventListener(evt,_fbHandler,true);});}function _speak(){if(_homeGreeted)return;if(!_isHome())return;var 문구=GREET;try{var _gb=document.getElementById('chat-greet-bubble');if(_gb&&_gb.textContent&&_gb.textContent.trim())문구=_gb.textContent.trim();}catch(e){}try{if(typeof window.piaSpeak==='function'){window.piaSpeak(문구,function(){_homeGreeted=true;_disarm();});return;}if(!('speechSynthesis' in window))return;var u=new SpeechSynthesisUtterance((window._ttsClean?window._ttsClean(문구):문구));if(typeof window.piaApplyVoice==='function'){window.piaApplyVoice(u);}else{u.lang='ko-KR';u.rate=0.95;u.pitch=1.05;}u.onstart=function(){_homeGreeted=true;_disarm();};speechSynthesis.cancel();speechSynthesis.speak(u);}catch(e){}}function _arm(){if(_fallbackArmed||_homeGreeted)return;_fallbackArmed=true;_fbHandler=function(){setTimeout(_speak,0);};/* [2026-09-28] 탭·키 입력만 — 스크롤(pointerdown·touchstart)마다 인사를 다시 시도하던 것 방지 */['click','keydown'].forEach(function(evt){document.addEventListener(evt,_fbHandler,true);});}function _trigger(){if(_homeGreeted||!_eligible())return;_arm();setTimeout(_speak,1600);}var _origShow8=showView;showView=function(name){_origShow8(name);if(name==='chat')_trigger();};function _boot(){}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',_boot);}else{_boot();}})();(function(){var _mon=null,_ac=null,_an=null,_buf=null,_raf=null,_peak=0,_devLabel='',_silentSince=0,_uiEl=null,_watch=null;function _log(){try{console.log.apply(console,['[MIC]'].concat([].slice.call(arguments)));}catch(e){}}/* 예전에는 여기서 잡음 게이트를 통째로 무력화해 복도 소음까지 받아 적었다. 원래 판정을 쓴다. */function _score(d){var l=(d.label||'').toLowerCase();var s=0;if(/usb/.test(l))s+=10;if(/headset|헤드셋|earphone|이어폰|mic/.test(l))s+=5;if(/external|외장/.test(l))s+=4;if(/array/.test(l))s+=2;if(/internal|built-?in|내장/.test(l))s-=5;return s;}async function _pick(){try{if(!navigator.mediaDevices||!navigator.mediaDevices.enumerateDevices)return null;var ds=await navigator.mediaDevices.enumerateDevices();var ins=ds.filter(function(d){return d.kind==='audioinput'&&d.deviceId&&d.deviceId!=='communications';});if(!ins.length)return null;var saved=null;try{saved=localStorage.getItem('pia_mic_device');}catch(e){}if(saved){var m=ins.filter(function(d){return d.deviceId===saved;})[0];if(m)return m;}ins.sort(function(a,b){return _score(b)-_score(a);});return ins[0];}catch(e){return null;}}function _ui(){if(_uiEl&&document.body.contains(_uiEl))return _uiEl;var st=document.getElementById('chat-mic-status');if(!st||!st.parentNode)return null;var d=document.createElement('div');d.id='pia-mic-diag';d.style.cssText='font-size:11px;color:#6b7280;margin-top:4px;line-height:1.5';st.parentNode.insertBefore(d,st.nextSibling);_uiEl=d;return d;}function _render(){var d=_ui();if(!d)return;var lvl=Math.min(100,Math.round(_peak*900));var bar='<span style="display:inline-block;width:70px;height:6px;background:#e5e7eb;border-radius:3px;vertical-align:middle;overflow:hidden"><span style="display:block;height:6px;width:'+lvl+'%;background:'+(lvl>6?'#788c5d':'#d1d5db')+'"></span></span>';var warn='';if(_silentSince&&Date.now()-_silentSince>7000){warn='<div style="color:#c4623f;margin-top:2px">⚠ 마이크에서 소리가 들어오지 않습니다. Windows 소리 설정에서 사용할 마이크를 <b>기본 장치</b>로 지정해 주세요.</div>';}d.innerHTML='🎙 '+(_devLabel||'기본 마이크')+' '+bar+warn;}function _stopMon(){if(_raf)cancelAnimationFrame(_raf);_raf=null;if(_ac){try{_ac.close();}catch(e){}}_ac=null;_an=null;_peak=0;if(_mon){try{_mon.getTracks().forEach(function(t){t.stop();});}catch(e){}}_mon=null;if(_watch){clearInterval(_watch);_watch=null;}}async function _startMon(){try{if(_mon)return true;if(!navigator.mediaDevices||!navigator.mediaDevices.getUserMedia)return false;var dev=await _pick();var c={echoCancellation:true,noiseSuppression:true,autoGainControl:true,channelCount:1};if(dev&&dev.deviceId)c.deviceId={ideal:dev.deviceId};_mon=await navigator.mediaDevices.getUserMedia({audio:c});var tr=_mon.getAudioTracks()[0];_devLabel=(tr&&tr.label)||(dev&&dev.label)||'';_log('사용 마이크:',_devLabel);var AC=window.AudioContext||window.webkitAudioContext;if(AC){_ac=new AC();var src=_ac.createMediaStreamSource(_mon);_an=_ac.createAnalyser();_an.fftSize=512;_an.smoothingTimeConstant=0.3;src.connect(_an);_buf=new Uint8Array(_an.fftSize);var loop=function(){if(!_an)return;_an.getByteTimeDomainData(_buf);var s=0;for(var i=0;i<_buf.length;i++){var v=(_buf[i]-128)/128;s+=v*v;}var rms=Math.sqrt(s/_buf.length);_peak=_peak*0.85+rms*0.15;if(rms>0.012){_silentSince=0;}else if(!_silentSince){_silentSince=Date.now();}_raf=requestAnimationFrame(loop);};loop();}_silentSince=Date.now();if(!_watch)_watch=setInterval(_render,500);_render();return true;}catch(e){_log('모니터 실패',e&&e.message);return false;}}try{if(navigator.mediaDevices&&navigator.mediaDevices.addEventListener){navigator.mediaDevices.addEventListener('devicechange',function(){_log('장치 변경 감지');var onChat=(function(){try{var s=document.querySelector('section[data-view]:not(.hidden)');return !!s&&s.dataset.view==='chat';}catch(e){return false;}})();if(!onChat)return;_stopMon();setTimeout(function(){_startMon();try{if(window._micWantProxy!==false&&typeof safeStopRecognition==='function'&&typeof safeStartRecognition==='function'){safeStartRecognition();}}catch(e){}},600);});}}catch(e){}var _o=showView;showView=function(n){_o(n);if(n==='chat'){/* 모바일: 이 레벨 모니터가 getUserMedia로 마이크를 점유하면 안드로이드 크롬에서 SpeechRecognition 이 aborted 로 즉시 끝난다. 모니터는 키오스크(Windows 기본장치 안내)용이므로 폰·태블릿(iPad 포함)에서는 띄우지 않는다. iPad 는 Mac UA 라 isMobile 이 false 이므로, 실제 Windows 키오스크(kiosk-on)가 아니면서 터치기기(coarse)면 모두 차단한다. */var _realKiosk=document.documentElement.classList.contains('kiosk-on');var _touch=!!(window.matchMedia&&window.matchMedia('(any-pointer: coarse)').matches);if(!_realKiosk&&(((typeof isMobile==='function')&&isMobile())||_touch)){return;}/* 시각 마이크 레벨 모니터(_startMon)는 저사양 POS 키오스크에서 getUserMedia+AudioContext+연속 rAF+500ms DOM 갱신이 화면맞춤 옵저버와 되먹임되어 '응답 없는 페이지'로 멈추게 했다. 음성인식 자동시작만 남기고 모니터는 띄우지 않는다. */var tries=0;var iv=setInterval(function(){tries++;var cur=(function(){try{var s=document.querySelector('section[data-view]:not(.hidden)');return !!s&&s.dataset.view==='chat';}catch(e){return false;}})();if(!cur||tries>6){clearInterval(iv);return;}try{if(!_globalRecording&&!(('speechSynthesis' in window)&&speechSynthesis.speaking)){/* 진입 시 자동 재시도(1.5초×6회)로 마이크·인식을 중첩 획득하면 저사양 POS 키오스크가 '응답 없는 페이지'로 멈춘다. 자동시작을 빼고 '음성으로 시작' 탭 또는 마이크 버튼으로 한 번만 시작한다. */}}catch(e){}},1500);}else{_stopMon();}};window.piaMicDiag=function(){return{device:_devLabel,peak:_peak,silentMs:_silentSince?Date.now()-_silentSince:0};};window.piaSetMic=async function(id){try{localStorage.setItem('pia_mic_device',id);}catch(e){}_stopMon();await _startMon();return _devLabel;};window.piaListMics=async function(){var ds=await navigator.mediaDevices.enumerateDevices();return ds.filter(function(d){return d.kind==='audioinput';}).map(function(d){return{id:d.deviceId,label:d.label};});};})();


// ===== 결과지 JS =====

// ---- 레인보우 바 마커 삽입 ----
function insertMarker(barId, score, label, cssClass, offset) {
  const bar = document.getElementById(barId);
  if (!bar) return;
  const pct = Math.min(Math.max(score, 0), 100);

  // 점수 마커
  const m = document.createElement('div');
  m.className = 'score-marker';
  m.style.left = pct + '%';
  m.innerHTML = '<div class="score-marker-circle">' + score + '</div>';
  bar.appendChild(m);

  // 평균 레이블
  if (label) {
    const lbl = document.createElement('div');
    lbl.className = 'avg-label ' + (cssClass || '');
    lbl.style.left = (pct + (offset || 0)) + '%';
    lbl.textContent = label;
    bar.appendChild(lbl);
  }
}

// ════════════════════════════════════════════════
// sessionStorage 동적 데이터 로드 시스템
// ════════════════════════════════════════════════
const GRADE_THRESHOLDS = [
  {min:85,cls:'grade-A-plus',label:'A+'},
  {min:75,cls:'grade-A',label:'A'},
  {min:65,cls:'grade-B-plus',label:'B+'},
  {min:55,cls:'grade-B',label:'B'},
  {min:45,cls:'grade-C',label:'C'},
  {min:0, cls:'grade-D',label:'D'}
];
function getGrade(sc){return GRADE_THRESHOLDS.find(g=>sc>=g.min)||GRADE_THRESHOLDS[5];}
function gradeHtml(sc){const g=getGrade(sc);return `<span class="grade-box ${g.cls}">${g.label}</span>`;}

// 기본 샘플 데이터 (sessionStorage가 없을 때)
const DEFAULT_DATA = {
  name:'홍길동', school:'한국중학교', grade:'2학년 3반', num:'15번',
  gender:'남', age:14, testDate:'2026-06-13T09:30:00', t16:'INFJ',
  career:'A형(예술)', risk:'low',
  scores:{
    P1:85,P2:64,P3:78,P4:91,P5:70,P6:56,P7:82,P8:75,P9:68,
    personality:72, miIndex:72,
    intel:{verbal:92,logical:75,spatial:62,musical:78,bodily:83,interpersonal:88,intrapersonal:70,naturalist:72},
    riasec:{R:42,I:58,A:87,S:71,E:35,C:29},
    aptitude:{인문:82,자연:64,예능:75,체육:80},
    subjects:{korean:88,math:65,english:82,social:80,science:68,arts:76,pe:84}
  }
};

function loadPiaData(){
  try{
    const id = sessionStorage.getItem('pia_current_id');
    const all = JSON.parse(sessionStorage.getItem('pia_results')||'[]');
    if(id && all.length>0){
      const found=all.find(s=>s.id===id)||all[all.length-1];
      if(found) return found;
    }
  }catch(e){}
  /* [2026-09-26] 예전에는 여기서 DEFAULT_DATA(홍길동·한국중학교·72점)를 돌려줬다.
     pia_results 를 쓰는 곳이 없어 사실상 늘 이 가짜 값이 결과지 본문(2~10쪽)을 채웠다.
     이제는 실제 결과(mapAiPiaToResultData)로 채우도록 null 을 돌려준다. */
  return null;
}

function setGB(id, v){ const e=document.getElementById(id); if(e){ const g=getGrade(v); e.textContent=g.label; e.className='grade-box '+g.cls; } }
function pDimDesc(label, v){
  const band = v>=75?'high':v>=50?'mid':'low';
  const T={
    '공감':{high:'타인의 감정과 입장을 깊이 이해하고 잘 공감합니다. 관계 형성의 큰 자산입니다.',mid:'상황에 따라 공감하며 관계를 맺습니다. 경청을 조금 더 연습하면 좋습니다.',low:'사실·논리를 더 중시하는 편입니다. 상대의 감정을 한 번 더 살피면 관계가 부드러워집니다.'},
    '자기통제':{high:'충동을 잘 조절하고 목표를 위해 인내하는 힘이 강합니다.',mid:'자기통제는 평균 수준입니다. 잠시 멈추기·호흡 조절 연습이 도움이 됩니다.',low:'즉각적 욕구를 조절하기 어려울 때가 있습니다. 작은 규칙과 멈춤 연습을 권합니다.'},
    '도덕성':{high:'옳고 그름의 기준이 분명하고 공정함에 민감합니다.',mid:'도덕적 판단이 무난한 수준입니다.',low:'상황에 따라 기준이 흔들릴 수 있어, 함께 규칙을 정해보면 좋습니다.'},
    '사회성':{high:'또래와 자연스럽게 어울리고 친화력이 높습니다.',mid:'사회성은 평균 수준으로 익숙한 사이에서 편안해합니다.',low:'소수와 깊게 지내는 편입니다. 작은 모임부터 천천히 넓혀보세요.'},
    '책임감':{high:'맡은 일을 끝까지 성실히 해냅니다.',mid:'책임감은 평균 수준이며 마무리 점검 습관이 도움이 됩니다.',low:'마무리·꾸준함이 과제입니다. 작은 체크리스트가 도움이 됩니다.'},
    '정서안정':{high:'스트레스 상황에서도 비교적 침착함을 유지합니다.',mid:'정서 안정은 평균 수준입니다. 규칙적인 생활이 도움이 됩니다.',low:'스트레스에 민감할 수 있어 규칙적 수면·운동·감정 표현이 도움이 됩니다.'}
  };
  const T_EN={
    '공감':{high:"Deeply understands and empathizes with others' feelings and perspectives. A major asset for building relationships.",mid:'Empathizes depending on the situation. A bit more practice with active listening would help.',low:"Tends to value facts and logic more. Taking an extra moment to consider the other person's feelings will smooth out relationships."},
    '자기통제':{high:'Regulates impulses well and shows strong perseverance toward goals.',mid:'Self-control is at an average level. Practicing a brief pause or breathing control would help.',low:'Sometimes finds it hard to regulate immediate urges. Small rules and pause practice are recommended.'},
    '도덕성':{high:'Has clear standards for right and wrong and is sensitive to fairness.',mid:'Moral judgment is at a reasonably solid level.',low:'Standards may shift depending on the situation; setting rules together would help.'},
    '사회성':{high:'Mixes naturally with peers and shows strong sociability.',mid:'Sociability is at an average level, feeling comfortable in familiar company.',low:'Tends to keep close ties with a few people. Try broadening out gradually starting with small groups.'},
    '책임감':{high:'Follows through on responsibilities diligently to the end.',mid:'Responsibility is at an average level; a habit of double-checking completion would help.',low:'Follow-through and consistency are areas to work on. A small checklist would help.'},
    '정서안정':{high:'Stays relatively calm even under stressful situations.',mid:'Emotional stability is at an average level. A regular routine would help.',low:'May be sensitive to stress; regular sleep, exercise, and emotional expression would help.'}
  };
  const useEn=(typeof window!=='undefined' && window.aipiaCurrentLang==='en');
  const src = useEn ? T_EN : T;
  return (src[label]&&src[label][band]) || '';
}

function adaptReportForAdult(){
  try{
    if(!(typeof selfIsAdult==='function'&&selfIsAdult())) return;
    var root=document.getElementById('pia-report'); if(!root) return;
    var pairs=[
      ['학교 상담실 또는 Wee 클래스를 적극 활용하세요.','정신건강복지센터·전문 상담기관(1577-0199)을 활용하세요.'],
      ['담당교사·부모님께 드리는 종합 코멘트','본인을 위한 종합 코멘트'],
      ['뛰어난 학생입니다','뛰어난 분입니다'],
      ['학교 상담 교사와의 정기 면담','전문 상담기관과의 정기 상담'],
      ['과도한 스마트폰·게임 사용을 제한하고','과도한 디지털 사용을 조절하고'],
      ['청소년 우울','우울(PHQ)']
    ];
    var wk=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while(n=wk.nextNode()){ var t=n.nodeValue, o=t;
      for(var i=0;i<pairs.length;i++){ if(t.indexOf(pairs[i][0])>=0) t=t.split(pairs[i][0]).join(pairs[i][1]); }
      if(t!==o) n.nodeValue=t;
    }
  }catch(e){}
}
/* 생기부 소견 복사(교사용) */
function _piaFallbackCopy(t){ try{ var ta=document.createElement('textarea'); ta.value=t; ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); if(window.showToast)showToast('생기부 소견을 복사했어요.'); }catch(e){ if(window.console) console.error('복사 실패:', e); } }
function piaCopyNokyeon(){
  try{
    var el0=document.getElementById('rep-nokyeon'); var t=el0?el0.textContent:'';
    if(!t){ if(window.showToast)showToast('복사할 소견이 없습니다.'); return; }
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(t).then(function(){ if(window.showToast)showToast('생기부 소견을 복사했어요.'); }, function(){ _piaFallbackCopy(t); }); }
    else { _piaFallbackCopy(t); }
  }catch(e){ if(window.console) console.error('복사 오류:', e); }
}
/* 재검사 추이 — 로컬 state.history(같은 기기/계정) 기반 */
function piaRenderTrend(){
  try{
    var wrap=document.getElementById('rep-trend-wrap'); if(!wrap) return;
    var h=((window.state&&state.history)||[]).slice();
    if(h.length<2){ wrap.style.display='none'; return; }
    var host=document.getElementById('rep-trend'); if(!host) return;
    var last=h.slice(-4), base=h.length-last.length;
    var html='<table class="data-table"><tr><th style="width:60px;">회차</th><th>검사일</th><th>통합유형</th><th>학년</th></tr>';
    last.forEach(function(x,i){ var dt=''; try{ dt=new Date(x.t).toLocaleDateString('ko-KR',{year:'2-digit',month:'2-digit',day:'2-digit'}); }catch(e){}
      html+='<tr><td>'+(base+i+1)+'회</td><td class="note">'+dt+'</td><td class="row-head">'+((x.type||x.code)||'-')+'</td><td>'+(x.grade||'')+'</td></tr>'; });
    html+='</table>';
    var a=last[last.length-2], b=last[last.length-1], note='';
    if(a&&b){ note=(a.type===b.type)
      ? '이전 검사와 통합유형이 <b>유지</b>되어 안정적인 성향을 보입니다.'
      : '이전(<b>'+(a.type||'-')+'</b>) 대비 통합유형이 <b>'+(b.type||'-')+'</b>'+_piaJ(b.type||'-','으로','로','(으)로')+' 변화했습니다. 최근 결과를 중심으로 진로를 탐색해 보세요.'; }
    host.innerHTML=html+(note?'<p style="font-size:11px;color:#555;margin-top:6px;">'+note+'</p>':'');
    wrap.style.display='block';
  }catch(e){ if(window.console) console.error('재검사 추이 렌더 오류:', e); }
}
/* 우리 반 평균 대비(참여자 규준) — pia_org_averages RPC
   [2026-09-27] 최소 인원 10명 — 미국 주 교육청 다수(39개 주)가 쓰는 최소 보고 인원(NCES SLDS 기술 브리프
   2011-603 권고값)과 같다. 10명 미만이면 평균 대신 "비교 데이터가 충분하지 않습니다"만 보인다.
   표시할 때는 항상 "(n명 기준)"을 붙인다. 가짜·예시 평균은 어떤 경로에서도 쓰지 않는다. */
var PIA_NORM_MIN_N = 10;
function piaRenderClassNorm(){
  try{
    var wrap=document.getElementById('rep-classnorm-wrap'); if(!wrap) return;
    var host=document.getElementById('rep-classnorm');
    var code=''; try{ code=(state.profile&&state.profile.orgCode)||''; }catch(e){}
    var ri=(state.results.riasec&&state.results.riasec.scores)||null;
    if(!code || !ri || !host || typeof _piaEnsureSB!=='function'){ wrap.style.display='none'; return; }
    function _few(){
      host.innerHTML='<p class="pia-norm-few" style="font-size:11px;color:#666;margin:2px 0 0;">'
        +_T('비교 데이터가 충분하지 않습니다. 같은 학급 코드 응시자가 '+PIA_NORM_MIN_N+'명 이상이 되면 반 평균을 보여 드립니다.',
            'Not enough comparison data yet. The class average appears once '+PIA_NORM_MIN_N+' or more students have taken the test with the same class code.')+'</p>';
      wrap.style.display='block';
    }
    _piaEnsureSB().then(function(sb){ if(!sb||!sb.rpc){ wrap.style.display='none'; return; }
      sb.rpc('pia_org_averages',{p_code:code}).then(function(r){
        /* 조회 자체가 실패하면(오프라인·권한) 인원을 모르므로 아무 말도 하지 않는다. */
        if(!r || r.error){ wrap.style.display='none'; return; }
        var d=r.data&&r.data[0];
        var n=d?Number(d.n)||0:0;
        if(!d || n<PIA_NORM_MIN_N){ _few(); return; }
        var rows=[['R',_T('실재형','Realistic'),d.ria_r],['I',_T('탐구형','Investigative'),d.ria_i],['A',_T('예술형','Artistic'),d.ria_a],['S',_T('사회형','Social'),d.ria_s],['E',_T('진취형','Enterprising'),d.ria_e],['C',_T('관습형','Conventional'),d.ria_c]];
        var html='<table class="data-table"><tr><th style="width:96px;">'+_T('진로흥미','Interest')+'</th><th data-i18n="th.myScore">'+_T('내 점수','My score')+'</th><th>'+_T('우리 반 평균('+n+'명 기준)','Class average (n='+n+')')+'</th><th>'+_T('비교','Comparison')+'</th></tr>';
        rows.forEach(function(x){
          var mine=Math.round(ri[x[0]]||0);
          var avg=(x[2]!=null&&isFinite(Number(x[2])))?Math.round(Number(x[2])):null;
          var cmp=(avg==null)?'—':(mine>avg+3?_T('▲ 높음','▲ Higher'):(mine<avg-3?_T('▼ 낮음','▼ Lower'):_T('≈ 비슷','≈ Similar')));
          html+='<tr><td class="row-head">'+x[1]+'('+x[0]+')</td><td>'+mine+'</td><td>'+(avg==null?'—':avg)+'</td><td>'+cmp+'</td></tr>';
        });
        html+='</table>';
        host.innerHTML=html; wrap.style.display='block';
      }).catch(function(e){ if(window.console) console.error('반 평균 조회 오류:', e); wrap.style.display='none'; });
    });
  }catch(e){ if(window.console) console.error('반 평균 렌더 오류:', e); }
}
/* 학교급 밴드 판정 (초저/초고/중/고/대학·성인) */
function piaGradeBand(){
  try{
    var g=String((state.profile&&state.profile.grade)||(state.cfg&&state.cfg.grade)||'');
    if(/대학|성인|일반|adult|univ/i.test(g)) return 'adult';
    if(/고[123]|고등|high/i.test(g)) return 'high';
    if(/중[123]|중등|mid/i.test(g)) return 'mid';
    if(/초\s*[56]/.test(g)) return 'elemHigh';
    if(/초|elem/i.test(g)) return 'elemLow';
    return 'mid';
  }catch(e){ return 'mid'; }
}
var PIA_GRADE_BANNER = {
  elemLow:'🌱 <b>초등 저학년용</b> · 쉽고 재미있게 나를 알아본 결과예요. 부모님·선생님과 함께 봐요. 정답은 없어요!',
  elemHigh:'🌱 <b>초등 고학년용</b> · 내가 좋아하는 것과 잘하는 것을 알아봤어요. 관심 분야를 넓게 탐색해 보세요.',
  mid:'📘 <b>중학생용</b> · 나의 흥미·성향을 이해하고 진로를 탐색하는 데 활용해 보세요.',
  high:'🎓 <b>고등학생용</b> · 계열·선택과목·진로 설계에 활용하세요. 흥미·적성·성적을 함께 고려하세요.',
  adult:'💼 <b>대학·성인용</b> · 직무역량과 진로 방향 중심의 요약입니다.'
};
var PIA_GRADE_BANNER_EN = {
  elemLow:'🌱 <b>For Lower Elementary</b> · A fun, easy look at yourself. Please view it together with your parents or teacher. There are no right or wrong answers!',
  elemHigh:'🌱 <b>For Upper Elementary</b> · Discover what you like and what you\'re good at. Explore your interests broadly.',
  mid:'📘 <b>For Middle School Students</b> · Use this to understand your interests and personality and explore career paths.',
  high:'🎓 <b>For High School Students</b> · Use this for track selection, elective subjects, and career planning. Consider your interests, aptitude, and grades together.',
  adult:'💼 <b>For College Students & Adults</b> · A summary focused on job competencies and career direction.'
};
/* 초등: 딱딱한 용어를 친근하게 치환 (adaptReportForAdult 와 동일 패턴) */
function adaptReportByGrade(){
  try{
    var band=piaGradeBand();
    var root=document.getElementById('pia-report'); if(!root) return;
    var pairs=null;
    if(band==='elemLow'||band==='elemHigh'){
      pairs=[
        ['추천 학과·직업 (진로흥미 RIASEC 기반)','내가 좋아할 만한 일 (흥미 기반)'],
        ['추천 계열·학과','관심 분야'],
        ['관련 직업','해볼 수 있는 일'],
        ['진로흥미 유형','좋아하는 활동 유형'],
        ['담당교사·부모님께 드리는 종합 코멘트','부모님·선생님께 드리는 이야기']
      ];
    }
    if(!pairs) return;
    var wk=document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while(n=wk.nextNode()){ var t=n.nodeValue, o=t;
      for(var i=0;i<pairs.length;i++){ if(t.indexOf(pairs[i][0])>=0) t=t.split(pairs[i][0]).join(pairs[i][1]); }
      if(t!==o) n.nodeValue=t;
    }
  }catch(e){ if(window.console) console.error('급별 문구 적용 오류:', e); }
}
function populateResult(d){
  const sc = d.scores || {};
  // ── 표지 ──
  /* 검사 데이터가 없으면 검사자 프로필로 자동 채움 */
  var _pf=(typeof state!=='undefined'&&state&&state.profile)?state.profile:{};
  var _nm=d.name||_pf.name||'-';
  var _sc=d.school||_pf.school||'-';
  var _gr=(((d.grade||_pf.grade||'')+' '+(d.class||_pf.class||'')).replace(/\s+/g,' ').trim())||'-';
  setText('cover-name', _nm);
  setText('cover-school', _sc);
  setText('cover-grade', _gr);
  setText('cover-date', (d.testDate?fmtDate(d.testDate):fmtDate(new Date().toISOString())));
  setText('cover-issue', fmtDate(new Date().toISOString()));
  setText('cover-org', _sc);
  setText('footer-org', _sc);
  setText('footer-issue', fmtDate(new Date().toISOString()));
  try{
    var _ds=new Date(); var _ymd=''+_ds.getFullYear()+String(_ds.getMonth()+1).padStart(2,'0')+String(_ds.getDate()).padStart(2,'0');
    var _sstr=String(_nm)+_ymd+String(_sc), _hh=0; for(var _ii=0;_ii<_sstr.length;_ii++){ _hh=((_hh<<5)-_hh+_sstr.charCodeAt(_ii))|0; }
    setText('footer-serial', 'PIA-'+_ymd+'-'+('0000'+(Math.abs(_hh)%10000)).slice(-4));
  }catch(e){}

  // ── 학생 정보 테이블 ──
  document.querySelectorAll('[data-pia="name"]').forEach(el=>el.textContent=_nm);
  document.querySelectorAll('[data-pia="school"]').forEach(el=>el.textContent=_sc);
  document.querySelectorAll('[data-pia="grade"]').forEach(el=>el.textContent=(d.grade||_pf.grade||'-'));
  document.querySelectorAll('[data-pia="testDate"]').forEach(el=>el.textContent=fmtDate(d.testDate));
  document.querySelectorAll('[data-pia="gender"]').forEach(el=>el.textContent=d.gender||'');
  document.querySelectorAll('[data-pia="age"]').forEach(el=>el.textContent=d.age?(d.age+_T('세',' yrs')):'');

  // ── P1~P9 게이지 업데이트 ──
  ['P1','P2','P3','P4','P5','P6','P7','P8','P9'].forEach(p=>{
    const v = sc[p]||70;
    const arc = 188.5*(1-v/100);
    document.querySelectorAll(`[data-gauge="${p}"]`).forEach(path=>{
      path.setAttribute('stroke-dashoffset', arc.toFixed(1));
      const g = getGrade(v);
      path.setAttribute('stroke', gradeColor(g.label));
    });
    document.querySelectorAll(`[data-gauge-score="${p}"]`).forEach(el=>el.textContent=v);
    document.querySelectorAll(`[data-gauge-grade="${p}"]`).forEach(el=>{el.textContent=getGrade(v).label+_T(' 등급',' Grade');});
  });

  // ── 레인보우 바 (인성 종합) ──
  /* 여러 번 불려도(인쇄할 때마다 다시 채운다) 마커가 쌓이지 않게 먼저 걷어낸다. */
  ['rainbow-bar-1','rainbow-bar-iq'].forEach(function(id){ var b=document.getElementById(id); if(b) b.querySelectorAll('.score-marker,.avg-label').forEach(function(m){ m.remove(); }); });
  insertMarker('rainbow-bar-1', sc.personality||72, null);
  /* [2026-09-27] CLASS 68 · SCHOOL 65 고정 마커 제거 — 실제 집계가 아닌 숫자를 비교처럼 보여 줬다.
     규준 비교는 실제 규준 집단에 근거해야 한다(AERA·APA·NCME Standards 5장). 실측 반 평균은
     piaRenderClassNorm(n≥PIA_NORM_MIN_N)에서만 인원 수와 함께 보인다. */

  // ── 다중지능 자가평가 막대 ──
  const iqV = sc.miIndex;
  const iqBar = document.getElementById('rainbow-bar-iq');
  if(iqBar && iqV!=null){
    const pm=document.createElement('div');
    pm.className='score-marker';
    pm.style.left=Math.max(0,Math.min(100,iqV))+'%';   /* miIndex 는 0~100 자가평가 평균 — IQ(70~130) 눈금에 놓으면 48점이 맨 왼쪽에 박혔다 */
    pm.innerHTML='<div class="score-marker-circle" style="font-size:9px;">'+iqV+'</div>';
    iqBar.appendChild(pm);
  }

  // ── P요약 테이블 업데이트 ──
  const pTbl = document.getElementById('p-summary-table');
  if(pTbl){
    const rows = pTbl.querySelectorAll('tr:not(:first-child)');
    const pKeys=['P1','P2','P3','P4','P5','P6','P7','P8','P9'];
    rows.forEach((row,i)=>{
      const p=pKeys[i]; if(!p)return;
      const v=sc[p]||70;
      const cells=row.querySelectorAll('td');
      if(cells[2])cells[2].textContent=v;
      // 미니바
      const fill=row.querySelector('.mini-bar-fill');
      if(fill){fill.style.width=v+'%';fill.style.background=gradeColor(getGrade(v).label);}
      // 등급박스
      const gb=row.querySelector('.grade-box');
      if(gb){const g=getGrade(v);gb.className='grade-box '+g.cls;gb.textContent=g.label;}
    });
  }

  // ── 다중지능 바 (page6) ──
  document.querySelectorAll('[data-intel]').forEach(el=>{
    const k=el.getAttribute('data-intel');
    const v=sc.intel?.[k]||70;
    const fill=el.querySelector('.prog-bar-fill');
    const val=el.querySelector('.prog-bar-val');
    if(fill)fill.style.width=v+'%';
    if(val)val.textContent=v;
    // 점수 셀(2번째 td) 업데이트
    const tds=el.querySelectorAll('td');
    if(tds[1])tds[1].textContent=v;
    // 등급 박스 업데이트
    const gb=el.querySelector('.grade-box');
    if(gb){const g=getGrade(v);gb.className='grade-box '+g.cls;gb.textContent=g.label;}
  });

  // ── [전수검토] 다중지능 종합표: 최고/최저 영역·등급·상위% ──
  (function(){
    var labels={verbal:_T('언어적 지능','Linguistic Intelligence'),logical:_T('논리·수학 지능','Logical-Mathematical Intelligence'),spatial:_T('공간 지능','Spatial Intelligence'),musical:_T('음악 지능','Musical Intelligence'),bodily:_T('신체·운동 지능','Bodily-Kinesthetic Intelligence'),interpersonal:_T('대인 지능','Interpersonal Intelligence'),intrapersonal:_T('자기성찰 지능','Intrapersonal Intelligence'),naturalist:_T('자연 지능','Naturalist Intelligence')};
    var it=sc.intel||{}; var ents=Object.keys(labels).filter(function(k){return it[k]!=null;}).map(function(k){return [k,it[k]];});
    if(ents.length){ ents.sort(function(a,b){return b[1]-a[1];}); var hi=ents[0],lo=ents[ents.length-1];
      setText('intel-top-dom', labels[hi[0]]+' ('+getGrade(hi[1]).label+')');
      setText('intel-bot-dom', labels[lo[0]]+' ('+getGrade(lo[1]).label+')'); }
    /* [2026-09-26] miIndex 는 다중지능 자가평가 문항 평균(0~100)이다. 예전에는 IQ(평균 100·표준편차 15)로
       보고 '상위 %' 를 계산해 48점이 'C · 상위 95%' 로 찍혔다. 다른 점수와 같은 등급표(getGrade)를 쓰고
       근거 없는 백분위는 싣지 않는다. */
    var q=(sc.miIndex==null)?70:sc.miIndex;
    var _gq=getGrade(q), lab=_gq.label, cls=_gq.cls;
    var ge=el('intel-iq-grade'); if(ge){ge.textContent=lab+_T(' · 자가평가',' · Self-rated');ge.className='grade-box '+cls;}
    setText('intel-rb-iq', q+_T('점','pts'));
    var rg=el('intel-rb-g'); if(rg){rg.textContent=lab;rg.className='grade-box '+cls;}
  })();

  // ── [전수검토] 레이더 축 숫자·표 (P차원) ──
  (function(){
    var ax=[sc.P7,sc.P6,sc.P2,sc.P5,sc.P4];
    ax.forEach(function(v,i){ if(v==null)return; setText('rdx-'+(i+1), v);
      var tr=document.querySelector('[data-radaxis="'+i+'"]'); if(tr){ var tds=tr.querySelectorAll('td'); if(tds[2])tds[2].textContent=v;
        var g=tr.querySelector('.grade-box'); if(g){var gg=getGrade(v);g.className='grade-box '+gg.cls;g.textContent=gg.label;} } });
  })();

  // ── [전수검토] 계열 적성 세부표 받은점수 ──
  (function(){
    var it=sc.intel||{}; var P5=sc.P5||70;
    var SUB={hum1:it.verbal,hum2:it.interpersonal,hum3:it.logical,nat1:it.logical,nat2:it.spatial,nat3:it.naturalist,art1:it.musical,art2:it.spatial,pe1:it.bodily,pe2:Math.round(((it.bodily||70)+P5)/2)};
    document.querySelectorAll('[data-aptrow]').forEach(function(tr){
      var v=SUB[tr.getAttribute('data-aptrow')]; if(v==null)return; v=Math.round(v);
      var got=tr.querySelector('[data-aptgot]'); if(got)got.textContent=v;
      var bar=tr.querySelector('.dual-bar-got'); if(bar)bar.style.width=v+'%';
      var g=tr.querySelector('.grade-box'); if(g){var gg=getGrade(v);g.className='grade-box '+gg.cls;g.textContent=gg.label;}
    });
  })();

  // ── [전수검토] page2 인성 종합 점수 행 ──
  (function(){
    var v=sc.personality||72;
    var t=document.querySelector('[data-p2pers]'); if(t)t.textContent=v;
    var br=document.querySelector('[data-p2persbar]'); if(br){var f=br.querySelector('.prog-bar-fill'); if(f)f.style.width=v+'%'; var pv=br.querySelector('.prog-bar-val'); if(pv)pv.textContent=v;}
    var g=document.querySelector('[data-p2persg]'); if(g){var gg=getGrade(v);g.className='grade-box '+gg.cls;g.textContent=gg.label;}
  })();

  // ── 과목별 학습역량 ──
  document.querySelectorAll('[data-subject]').forEach(el=>{
    const k=el.getAttribute('data-subject');
    const v=sc.subjects?.[k]||70;
    // 레인보우 마커 위치 + 텍스트
    const marker=el.querySelector('.rb-marker');
    if(marker){marker.style.left=v+'%';marker.textContent=v;}
    // 점수 셀
    const scTd=el.querySelector('[data-sc]');
    if(scTd)scTd.textContent=v;
    // 등급 박스
    const gb=el.querySelector('.grade-box');
    if(gb){const g=getGrade(v);gb.className='grade-box '+g.cls;gb.textContent=g.label;}
  });

  // ── 종합 결론 업데이트 ──
  const pAvg = sc.personality||72;
  const topRiasec = sc.riasec ? Object.entries(sc.riasec).sort((a,b)=>b[1]-a[1]) : [['A',87]];
  const rMap = {R:'현실형',I:'탐구형',A:'예술형',S:'사회형',E:'사업형',C:'관습형'};

  // ── 발급일 ──
  setText('cover-issue', fmtDate(new Date().toISOString()));
  // ── 표지 배지: 응답자 유형 · 대상 ──
  (function(){
    var aud=(typeof currentAudience!=='undefined')?currentAudience:'student';
    var isA=(typeof selfIsAdult==='function'&&selfIsAdult());
    var audW=aud==='parent'?_T('학부모용','For Parents'):aud==='teacher'?_T('선생님용','For Teachers'):(isA?_T('본인용(일반)','For Self (General)'):_T('학생 본인용','For Student'));
    var respW=isA?_T('일반(성인)','General (Adult)'):_T('학생','Student');
    setText('cover-badge-txt', respW+' · '+audW);
  })();
  // ── 학교급별 안내 배너 ──
  (function(){
    try{ var b=el('rep-grade-banner'); if(b){ var band=piaGradeBand(); var txt=(window.aipiaCurrentLang==='en'?PIA_GRADE_BANNER_EN:PIA_GRADE_BANNER)[band]; if(txt){ b.innerHTML=txt; b.style.display='block'; } else { b.style.display='none'; } } }catch(e){}
  })();
  // ── 인성 종합 점수 ──
  const _pv = sc.personality||72;
  setText('rep-pers-score', _pv); setGB('rep-pers-grade', _pv);
  // ── 인성 차원 해석문(P1~P6) 점수 기반 + 결론문 ──
  const _PLAB={P1:'공감',P2:'자기통제',P3:'도덕성',P4:'사회성',P5:'책임감',P6:'정서안정'};
  document.querySelectorAll('[data-desc]').forEach(function(el){
    const k=el.getAttribute('data-desc');
    if(_PLAB[k]) el.textContent = pDimDesc(_PLAB[k], sc[k]||70);
  });
  // ── 다중지능 자가평가 ──
  setText('intel-iq', (sc.miIndex==null?_T('미실시','Not taken'):sc.miIndex+_T('점 / 100',' pts / 100')));
  // ── 종합결론 표 ──
  const _subj=sc.subjects||{}; const _sv=Object.values(_subj); const _subjAvg=_sv.length?Math.round(_sv.reduce((a,b)=>a+b,0)/_sv.length):70;
  const _apt=sc.aptitude||{}; const _av=Object.values(_apt); const _aptAvg=_av.length?Math.round(_av.reduce((a,b)=>a+b,0)/_av.length):70;
  const _overall=Math.round((_pv+_aptAvg+_subjAvg)/3);
  setText('cc-pers-sc', _pv); setGB('cc-pers-gr', _pv);
  setText('cc-iq-sc', (sc.miIndex==null?_T('미실시','Not taken'):sc.miIndex+_T('점 / 100',' pts / 100')));
  (function(){ var q=(sc.miIndex==null)?70:sc.miIndex; var g=el('cc-iq-gr'); if(g){ var gg=getGrade(q); g.textContent=gg.label; g.className='grade-box '+gg.cls; } })();
  setText('cc-apt-sc', _aptAvg); setGB('cc-apt-gr', _aptAvg);
  setText('cc-learn-sc', _subjAvg); setGB('cc-learn-gr', _subjAvg);
  setText('cc-all-sc', _overall); setGB('cc-all-gr', _overall);
  // ── 결론 해석문 (강점 과목 기반) ──
  const _cel=document.querySelector('[data-desc="concl"]');
  if(_cel){
    const _lab=_T({korean:'국어',math:'수학',english:'영어',social:'사회',science:'과학',arts:'예술',pe:'체육'},{korean:'Korean',math:'Math',english:'English',social:'Social Studies',science:'Science',arts:'Arts',pe:'P.E.'});
    const _top=Object.entries(_subj).sort(function(a,b){return b[1]-a[1];}).slice(0,2).map(function(e){return _lab[e[0]]||e[0];});
    _cel.textContent=_T((d.name||'학생')+' 학생은 '+(_top.join('·')||'강점 과목')+' 영역에서 상대적으로 높은 역량을 보입니다. 강점을 중심으로 진로를 설계하고, 약한 영역은 작은 목표부터 차근차근 보완하길 권장합니다.', (d.name||'The student')+' shows relatively strong competency in '+(_top.join(', ')||'their strength subjects')+'. We recommend designing a career path around these strengths, and steadily reinforcing weaker areas starting with small, achievable goals.');
  }
  // ── 항목 헤더 배지(P1~P9) 점수 동기화 ──
  for (let _n=1; _n<=9; _n++){ const _e=document.querySelector('[data-headgrade="P'+_n+'"]'); if(_e){ const _v=sc['P'+_n]||70; const _g=getGrade(_v); _e.textContent=_g.label+'  '+_v+_T('점',' pts'); _e.className='grade-box '+_g.cls; } }
  // ── 정서 스크리닝(page9) 실측 바인딩 ──
  (function(){
    function bl(lv){ return lv==='HIGH'?_T('높음','High'):lv==='MEDIUM'?_T('주의','Caution'):lv==='LOW'?_T('경도','Mild'):_T('정상','Normal'); }
    function bc(lv){ return lv==='HIGH'?'grade-D':lv==='MEDIUM'?'grade-C':lv==='LOW'?'grade-B-plus':'grade-A'; }
    function setRow(idS, idG, val, max, lv){ const e=el(idS); if(e) e.textContent = (val!=null) ? (val+' / '+max) : '미실시'; const g=el(idG); if(g){ if(val!=null){ g.textContent=bl(lv); g.className='grade-box '+bc(lv); } else { g.textContent='—'; g.className='grade-box'; } } }
    const cz=state.results.cesd.scores, pz=state.results.phqa.scores, gz=state.results.gad.scores;
    setRow('sc-cesd','sc-cesd-g', cz?cz.total:null, 30, cz&&cz.level);
    setRow('sc-phqa','sc-phqa-g', pz?pz.total:null, 27, pz&&pz.level);
    setRow('sc-gad','sc-gad-g', gz?gz.total:null, 21, gz&&gz.level);
  })();
  // ── 진로 추천 Top5(page10) 통합유형 기반 ──
  (function(){
    let _t=null; try{ _t=inferIntegratedType(); }catch(e){}
    const cs=_t?_typeField(_t,'careers'):[];
    for(let k=0;k<5;k++){ const e=el('top5-'+(k+1)); if(e && cs[k]) e.textContent=cs[k]; }
  })();
  // ── 추천 학과·직업 리스트 + 동적 3단 코멘트 (RIASEC 실측 기반) ──
  (function(){
    try{
      var _plr=(window.aipiaCurrentLang==='en');
      var rn={R:_T('현실형','Realistic'),I:_T('탐구형','Investigative'),A:_T('예술형','Artistic'),S:_T('사회형','Social'),E:_T('진취형','Enterprising'),C:_T('관습형','Conventional')};
      var order = (sc.riasec ? Object.entries(sc.riasec).sort(function(a,b){return b[1]-a[1];}).map(function(e){return e[0];}) : ['A','S','E']);
      var c1=(_plr && typeof RIASEC_CAREER_EN!=='undefined') ? RIASEC_CAREER_EN[order[0]] : RIASEC_CAREER[order[0]];
      var c2=(_plr && typeof RIASEC_CAREER_EN!=='undefined') ? RIASEC_CAREER_EN[order[1]] : RIASEC_CAREER[order[1]];
      var host=el('rep-career-list');
      if(host && c1){
        function uniq(a){ return a.filter(function(v,i){return a.indexOf(v)===i;}); }
        function chips(a){ return a.map(function(x){return '<span style="display:inline-block;background:#f3ebe1;border-radius:6px;padding:2px 8px;margin:2px 3px;font-size:11px;">'+x+'</span>';}).join(''); }
        var majors=uniq(c1.majors.slice(0,6).concat(c2?c2.majors.slice(0,3):[]));
        /* 개설 대학 수(대학알리미) — 한국어 학과명이 키, 영어 모드는 같은 순번의 영어 이름으로 표시 */
        var _k1=RIASEC_CAREER[order[0]], _k2=RIASEC_CAREER[order[1]], _mlab={};
        [[_k1,c1],[_k2,c2]].forEach(function(p){ if(p[0]&&p[1]) p[0].majors.forEach(function(k,i){ _mlab[k]=p[1].majors[i]||k; }); });
        var _mkeys=uniq((_k1?_k1.majors.slice(0,6):[]).concat(_k2?_k2.majors.slice(0,3):[]));
        var _uattr=function(o){ return JSON.stringify(o).replace(/&/g,'&amp;').replace(/'/g,'&#39;'); };
        setTimeout(piaFillUniv, 0); setTimeout(piaFillUniv, 1500);
        /* 추천 자격증 · 다음 시험(인쇄용 결과지에도 싣는다) — 통합 유형 기준, 일정은 piaFillLicSched 가 채운다 */
        var _repT=null; try{ _repT=inferIntegratedType(); }catch(e){}
        var _repLic=(_repT && typeof LICENSE_BY_TYPE!=='undefined' && LICENSE_BY_TYPE[_repT.code]) ? LICENSE_BY_TYPE[_repT.code] : [];
        var _repLicShow=(_plr && _repT && typeof LICENSE_BY_TYPE_EN!=='undefined' && LICENSE_BY_TYPE_EN[_repT.code]) ? LICENSE_BY_TYPE_EN[_repT.code] : _repLic;
        var _repLicCodes=(typeof _piaLicCodes==='function') ? _piaLicCodes(_repLic) : [];
        if(_repLicCodes.length){ setTimeout(piaFillLicSched, 0); setTimeout(piaFillLicSched, 1500); }
        var jobs=uniq(c1.jobs.slice(0,7).concat(c2?c2.jobs.slice(0,4):[]));
        host.innerHTML='<table class="data-table">'
          +'<tr><th style="width:96px;">'+_T('진로흥미 유형','Career Interest Type')+'</th><td style="text-align:left;"><b>'+rn[order[0]]+'('+order[0]+')</b>'+(c2?' · '+rn[order[1]]+'('+order[1]+')':'')+_T(' 중심 · ',' focused · ')+'<b>'+c1.track+'</b></td></tr>'
          +'<tr><th>'+_T('추천 계열·학과','Recommended Fields/Majors')+'</th><td style="text-align:left;">'+chips(majors)+'</td></tr>'
          +'<tr class="pia-univ-row" data-keys=\''+_uattr(_mkeys)+'\' data-labels=\''+_uattr(_mlab)+'\'><th>'+_T('개설 대학','Universities')+'</th><td style="text-align:left;font-size:11px;color:#475569;">'+_T('불러오는 중…','Loading…')+'</td></tr>'
          +(_repLic.length ? '<tr><th>'+_T('추천 자격증','Certifications')+'</th><td style="text-align:left;">'+chips(_repLicShow)+(_repLicCodes.length ? '<div class="pia-lic-sched" data-lic=\''+_uattr(_repLicCodes)+'\' style="margin-top:4px;font-size:11px;color:#475569;line-height:1.6">'+_T('시험 일정 불러오는 중…','Loading exam dates…')+'</div>' : '')+'</td></tr>' : '')
          +'<tr><th>'+_T('관련 직업','Related Jobs')+'</th><td style="text-align:left;">'+chips(jobs)+'</td></tr></table>'
          +'<p style="font-size:10px;color:#888;margin-top:4px;">'+_T('※ 진로흥미(Holland RIASEC) 상위 유형 기반 예시입니다. 실제 진학·취업은 흥미·적성·성적·가치관을 함께 고려하세요.','&#8251; This is an example based on your top Holland RIASEC interest types. For actual education/career decisions, also consider your interests, aptitude, grades, and values.')+'</p>';
      }
      // 동적 3단 코멘트
      var nm=(d&&d.name)||_T('학생','the student');
      var st=el('cmt-strength');
      var _riasecInterp=(_plr && typeof RIASEC_INTERPRETATIONS_EN!=='undefined') ? RIASEC_INTERPRETATIONS_EN : RIASEC_INTERPRETATIONS;
      if(st && c1){ st.textContent = _T(nm+' 학생은 '+rn[order[0]]+' 흥미가 두드러집니다. '+(RIASEC_INTERPRETATIONS[order[0]]||'')+' 관련 활동·동아리·독서 기회를 늘려 강점을 키워 주세요.', nm+' shows a strong '+rn[order[0]]+' interest. '+(_riasecInterp[order[0]]||'')+' Increase related activities, clubs, and reading opportunities to build on this strength.'); }
      var im=el('cmt-improve');
      if(im){
        var lvl=null; try{ var cz=state.results.cesd.scores,pz=state.results.phqa.scores,gz=state.results.gad.scores;
          [cz,pz,gz].forEach(function(x){ if(x&&(x.level==='HIGH'||x.level==='MEDIUM')) lvl=x.level; }); }catch(e){}
        if(lvl){ im.textContent=_T('최근 정서(기분·불안) 문항에서 '+(lvl==='HIGH'?'다소 높은':'약간의')+' 주의 신호가 보입니다. 규칙적 수면·운동과 함께, 필요하면 학교 상담 선생님과의 정기 면담을 권장합니다. (진단이 아닌 참고 신호입니다.)', 'Recent emotional (mood/anxiety) items show a '+(lvl==='HIGH'?'somewhat elevated':'slight')+' caution signal. Along with regular sleep and exercise, a periodic check-in with a school counselor is recommended if needed. (This is a reference signal, not a diagnosis.)'); }
        else { im.textContent=_T('약한 영역은 작은 목표부터 차근차근 보완하도록 돕고, 규칙적 생활 습관과 관심 분야 경험으로 자신감을 키워 주세요.', 'Help strengthen weaker areas step by step starting with small goals, and build confidence through regular habits and experiences in areas of interest.'); }
      }
      var ca=el('cmt-caution');
      if(ca && c1){ ca.textContent=_T('진로는 '+c1.track+' 계열을 중심으로 넓게 탐색하되, 흥미·적성·성적·가치관을 함께 고려하도록 안내해 주세요. 한 가지 결과로 진로를 단정하지 않는 것이 중요합니다.', 'Guide career exploration broadly around the '+c1.track+' track, while also considering interests, aptitude, grades, and values together. It is important not to lock in a career path based on a single result.'); }
    }catch(e){ if(window.console) console.error('진로 추천 렌더 오류:', e); }
  })();
  try{ piaFillIp60Report(); }catch(e){ console.error('흥미 심화(시범) 결과지 칸 실패', e); }   /* [E2-A] */
  // ── 생활기록부 진로활동 소견(교사용) 자동 생성 ──
  (function(){
    try{
      var wrap=el('rep-nokyeon-wrap'); if(!wrap) return;
      var isTeacher=(typeof currentAudience!=='undefined' && currentAudience==='teacher');
      wrap.style.display = isTeacher ? 'block' : 'none';
      if(!isTeacher) return;
      var host=el('rep-nokyeon'); if(!host) return;
      var _plr2=(window.aipiaCurrentLang==='en');
      var rn={R:_T('실재형','Realistic'),I:_T('탐구형','Investigative'),A:_T('예술형','Artistic'),S:_T('사회형','Social'),E:_T('진취형','Enterprising'),C:_T('관습형','Conventional')};
      var ri=state.results.riasec.scores, vi=state.results.via.scores, gr=state.results.grit.scores;
      var order = ri ? Object.entries(ri).sort(function(a,b){return b[1]-a[1];}).map(function(e){return e[0];}) : ['A'];
      var c1=(_plr2 && typeof RIASEC_CAREER_EN!=='undefined') ? RIASEC_CAREER_EN[order[0]] : RIASEC_CAREER[order[0]];
      var strengths = viaTopKeys(vi, 3).map(function(k){ return _viaName(k); });
      var parts=[];
      if(c1){ parts.push(_T('진로흥미검사에서 '+rn[order[0]]+'('+order[0]+') 유형이 우세하게 나타나 '+c1.track+' 분야에 흥미와 적성을 보이며, '+c1.jobs.slice(0,2).join('·')+' 등을 관심 진로로 탐색함.', 'The career interest test shows a dominant '+rn[order[0]]+'('+order[0]+') type, indicating interest and aptitude in the '+c1.track+' field, with '+c1.jobs.slice(0,2).join(', ')+' explored as career interests.')); }
      if(strengths.length){ parts.push(_T(strengths.join('·')+' 강점이 두드러지며, 이를 바탕으로 학급 활동에서 긍정적인 태도를 보임.', 'Notable strengths in '+strengths.join(', ')+', reflected in a positive attitude during class activities.')); }
      if(gr){ var ov=gr.overall||0; parts.push(ov>=70?_T('목표를 정하면 끝까지 노력하는 끈기가 관찰됨.','Shows perseverance in following through once a goal is set.'):_T('관심 분야에 대한 꾸준함과 자기주도적 학습 태도를 기르도록 지도가 필요함.','Would benefit from guidance in building consistency and self-directed learning habits in areas of interest.')); }
      if(c1){ parts.push(_T(c1.track+' 관련 동아리·독서·체험 활동을 통해 진로 역량을 심화할 것을 권장함.','Recommend deepening career competency through clubs, reading, and hands-on activities related to '+c1.track+'.')); }
      host.textContent = parts.length ? parts.join(' ') : _T('검사 결과가 충분하지 않아 소견 초안을 생성하지 못했습니다. 진로흥미(RIASEC)·강점(VIA) 검사를 완료하면 자동 생성됩니다.', 'Insufficient test results to generate a draft note. This will be generated automatically once the Career Interest (RIASEC) and Strengths (VIA) tests are completed.');
    }catch(e){ if(window.console) console.error('생기부 소견 생성 오류:', e); }
  })();
  // ── 계열 적성(page7) 실측 바인딩 ──
  (function(){
    const ap = sc.aptitude || {};
    function band(v){ return v>=80?{l:_T('A · 매우 적합','A · Excellent Fit'),c:'grade-A'}:v>=70?{l:_T('B+ · 적합','B+ · Good Fit'),c:'grade-B-plus'}:v>=60?{l:_T('B · 보통','B · Moderate'),c:'grade-B'}:{l:_T('C · 보완 필요','C · Needs Improvement'),c:'grade-C'}; }
    const m={hum:'인문',nat:'자연',art:'예능',pe:'체육'};
    Object.keys(m).forEach(function(k){ const v=ap[m[k]]; if(v==null) return; setText('apt-'+k+'-sc', v); const b=band(v); const g=el('apt-'+k+'-g'); if(g){ g.textContent=b.l; g.className='grade-box '+b.c; } });
    const top=Object.entries(ap).sort(function(a,b){return b[1]-a[1];})[0];
    if(top){
      var trackEn={'인문':'Humanities','자연':'Sciences','예능':'Arts','체육':'Physical Education'};
      const e=el('apt-top'); if(e) e.textContent=_T(top[0]+'계', (trackEn[top[0]]||top[0]));
      var fields={'인문':'언어·인문·사회·미디어','자연':'수리·과학·공학·IT','예능':'예술·디자인·음악·미디어','체육':'체육·스포츠·건강·여가'};
      var fieldsEn={'인문':'Language, Humanities, Social Studies & Media','자연':'Math, Science, Engineering & IT','예능':'Arts, Design & Media','체육':'Physical Education, Sports & Wellness'};
      var de=el('apt-top-desc'); if(de) de.textContent=_T('계열별 적성 점수를 종합한 결과 '+top[0]+' 계열 적성이 가장 높게 나타났습니다. '+(fields[top[0]]||'')+' 분야를 중심으로 진로를 탐색해 보세요.', 'Based on your combined track aptitude scores, the '+(trackEn[top[0]]||top[0])+' track shows the strongest aptitude. Consider exploring career paths centered on '+(fieldsEn[top[0]]||'')+'.');
    }
  })();
  // ── 학습 세부역량(page8) 추정 바인딩 ──
  (function(){
    const b=state.results.big5.scores||{}, gr=state.results.grit.scores||{}, it=sc.intel||{};
    function av(){ var a=[].slice.call(arguments).filter(function(x){return x!=null&&!isNaN(x);}); return a.length?Math.round(a.reduce(function(s,x){return s+x;},0)/a.length):70; }
    function setLS(key,v){ const tr=document.querySelector('[data-lskill="'+key+'"]'); if(!tr)return; const tds=tr.querySelectorAll('td'); if(tds[1])tds[1].textContent=v; const f=tr.querySelector('.prog-bar-fill'); if(f)f.style.width=v+'%'; const vv=tr.querySelector('.prog-bar-val'); if(vv)vv.textContent=v; const g=tr.querySelector('.grade-box'); if(g){var gg=getGrade(v); g.textContent=gg.label; g.className='grade-box '+gg.cls;} }
    setLS('focus', av(b.C, gr.overall));
    setLS('memory', av(b.O, it.verbal));
    setLS('meta', av(it.intrapersonal, b.O));
    setLS('motiv', av(gr.overall, b.C));
    setLS('selfdir', av(b.C, gr.perseverance));
  })();
  // 뒤로가기 버튼 표시
  const backBtn=document.getElementById('btn-back-student');
  if(backBtn)backBtn.style.display='inline-flex';
  try{ adaptReportForAdult(); }catch(e){}
  try{ adaptReportByGrade(); }catch(e){}
  try{ piaRenderClassNorm(); }catch(e){}
  try{ piaRenderTrend(); }catch(e){}
}

function setText(id, val){const el=document.getElementById(id);if(el)el.textContent=val;}
function fmtDate(iso){if(!iso)return '';const d=new Date(iso);return _T(d.getFullYear()+'년 '+(d.getMonth()+1)+'월 '+d.getDate()+'일', (d.getMonth()+1)+'/'+d.getDate()+'/'+d.getFullYear());}
function gradeColor(label){
  return {'A':'#00897b','A+':'#1565c0','B+':'#43a047','B':'#f9a825','C':'#ef6c00','D':'#e53935'}[label]||'#d97757';
}

// 인성 종합 점수 바 (기본값, populateResult로 덮어씀)
function iqPct(iq){return Math.min(Math.max((iq-70)/60*100,0),100);}

// 오각형 레이더 공통 함수
function buildRadar(svgId, scores){
  const svg=document.getElementById(svgId);
  if(!svg)return;
  const cx=130,cy=130,maxR=90;
  const angles=scores.map((_,i)=>-Math.PI/2+(2*Math.PI*i)/5);
  const gridG=svg.querySelector('#grid-lines');
  if(gridG) gridG.innerHTML='';
  [0.33,0.66,1.0].forEach(ratio=>{
    const pts=angles.map(a=>{const r=maxR*ratio;return (cx+r*Math.cos(a)).toFixed(1)+','+(cy+r*Math.sin(a)).toFixed(1);});
    const poly=document.createElementNS('http://www.w3.org/2000/svg','polygon');
    poly.setAttribute('points',pts.join(' '));poly.setAttribute('fill','none');
    poly.setAttribute('stroke',ratio===1.0?'#999':'#ddd');poly.setAttribute('stroke-width','0.8');
    if(gridG)gridG.appendChild(poly);
    angles.forEach(a=>{const line=document.createElementNS('http://www.w3.org/2000/svg','line');line.setAttribute('x1',cx);line.setAttribute('y1',cy);line.setAttribute('x2',(cx+maxR*Math.cos(a)).toFixed(1));line.setAttribute('y2',(cy+maxR*Math.sin(a)).toFixed(1));line.setAttribute('stroke','#ddd');line.setAttribute('stroke-width','0.8');if(gridG)gridG.appendChild(line);});
  });
  const dataPts=scores.map((s,i)=>{const r=maxR*s/100;return (cx+r*Math.cos(angles[i])).toFixed(1)+','+(cy+r*Math.sin(angles[i])).toFixed(1);});
  const dataPoly=svg.querySelector('#radar-data')||svg.getElementById('radar-data');
  if(dataPoly)dataPoly.setAttribute('points',dataPts.join(' '));
  // 기존 점 제거 후 재그리기
  svg.querySelectorAll('circle.rdot').forEach(c=>c.remove());
  scores.forEach((s,i)=>{const r=maxR*s/100;const dot=document.createElementNS('http://www.w3.org/2000/svg','circle');dot.setAttribute('cx',(cx+r*Math.cos(angles[i])).toFixed(1));dot.setAttribute('cy',(cy+r*Math.sin(angles[i])).toFixed(1));dot.setAttribute('r','4');dot.setAttribute('fill','#d97757');dot.setAttribute('class','rdot');svg.appendChild(dot);});
}

// ── 페이지 로드 시 실행 ──
document.addEventListener('DOMContentLoaded', function(){
  if (typeof hasAnyResult === 'function' && !hasAnyResult()) return; // 검사 전 샘플 렌더 방지
  const d0 = loadPiaData();
  if (!d0) { try{ piaFillReportBody(); }catch(e){ console.error('결과지 본문 채우기 실패', e); } return; }
  populateResult(d0);
  // 오각형 레이더 (데이터 기반)
  const sc = d0.scores||{};
  buildRadar('radar-svg',[
    sc.P7||70, sc.P6||70, sc.P2||70, sc.P5||70, sc.P4||70
  ]);
});

// ── 오각형 레이더 SVG (하위호환) ──
(function() {
  const svg = document.getElementById('radar-svg');
  if (!svg) return;

  const cx = 130, cy = 130, maxR = 90;
  const scores = [82, 78, 65, 85, 91]; // DOMContentLoaded에서 덮어씀
  const angles = scores.map((_, i) => -Math.PI / 2 + (2 * Math.PI * i) / 5);

  // 그리드 (3단계)
  const gridG = svg.getElementById('grid-lines') || svg.querySelector('#grid-lines');
  [0.33, 0.66, 1.0].forEach(ratio => {
    const pts = angles.map(a => {
      const r = maxR * ratio;
      return (cx + r * Math.cos(a)).toFixed(1) + ',' + (cy + r * Math.sin(a)).toFixed(1);
    });
    const poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    poly.setAttribute('points', pts.join(' '));
    poly.setAttribute('fill', 'none');
    poly.setAttribute('stroke', ratio === 1.0 ? '#999' : '#ddd');
    poly.setAttribute('stroke-width', '0.8');
    gridG.appendChild(poly);

    // 세로선 (축선)
    angles.forEach(a => {
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', cx); line.setAttribute('y1', cy);
      line.setAttribute('x2', (cx + maxR * Math.cos(a)).toFixed(1));
      line.setAttribute('y2', (cy + maxR * Math.sin(a)).toFixed(1));
      line.setAttribute('stroke', '#ddd'); line.setAttribute('stroke-width', '0.8');
      gridG.appendChild(line);
    });
  });

  // 데이터 폴리곤
  const dataPts = scores.map((s, i) => {
    const r = maxR * s / 100;
    return (cx + r * Math.cos(angles[i])).toFixed(1) + ',' + (cy + r * Math.sin(angles[i])).toFixed(1);
  });
  const dataPoly = svg.getElementById('radar-data');
  if(dataPoly) dataPoly.setAttribute('points', dataPts.join(' '));

  // 점수 점
  scores.forEach((s, i) => {
    const r = maxR * s / 100;
    const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    dot.setAttribute('cx', (cx + r * Math.cos(angles[i])).toFixed(1));
    dot.setAttribute('cy', (cy + r * Math.sin(angles[i])).toFixed(1));
    dot.setAttribute('r', '4');
    dot.setAttribute('fill', '#d97757');
    svg.appendChild(dot);
  });
})();

// ===== 브릿지 =====

// =================================================================
//  AI-PIA v3 → 결과지 데이터 변환 브릿지
// =================================================================
function mapAiPiaToResultData() {
  const big5   = state.results.big5.scores   || {};
  const riasec = state.results.riasec.scores || {};
  const via    = state.results.via.scores    || {};
  const grit   = state.results.grit.scores   || {};

  const avg = (...vals) => {
    const v = vals.filter(x => x != null && !isNaN(x));
    return v.length ? Math.round(v.reduce((s,x)=>s+x,0)/v.length) : 70;
  };
  const clamp = v => Math.min(100, Math.max(0, Math.round(v)));

  // P1~P9 계산
  const P1 = clamp(avg(big5.A, via['친절'], riasec.S));          // 공감
  const P2 = clamp(avg(big5.C, grit.perseverance));                  // 자기통제
  const P3 = clamp(avg(via['정직'], via['공정'], big5.A));    // 도덕성
  const P4 = clamp(avg(big5.E, riasec.S, riasec.E));                 // 사회성
  const P5 = clamp(avg(big5.C, via['끈기'], grit.overall));       // 책임감
  const P6 = clamp(avg(100-(big5.N||50), grit.overall));              // 정서안정
  const P7 = clamp(avg(riasec.E, big5.E, big5.A));                   // 리더십
  const P8 = clamp(avg(big5.O, riasec.A, via['창의']));           // 창의성
  const P9 = clamp(avg(grit.overall,
    (riasec && Object.keys(riasec).length) ? Math.max.apply(null, Object.values(riasec)) : 70));               // 진로성숙

  const personality = clamp(avg(P1,P2,P3,P4,P5,P6,P7,P8,P9));

  // 다중지능
  const intel = (state.results.mi && state.results.mi.scores) ? state.results.mi.scores : {
    verbal:       clamp(avg(big5.O, riasec.A, riasec.I)),
    logical:      clamp(avg(big5.O, riasec.I, big5.C)),
    spatial:      clamp(avg(riasec.R, riasec.A)),
    musical:      clamp(avg(riasec.A, via['감사'])),
    bodily:       clamp(avg(riasec.R, big5.E)),
    interpersonal:clamp(avg(big5.E, big5.A, riasec.S)),
    intrapersonal:clamp(avg(100-(big5.N||50), big5.O)),
    naturalist:   clamp(avg(riasec.R, riasec.I))
  };

  const type = inferIntegratedType();
  const meta = state.meta || {};

  return {
    id: state.studentId || 'S001',
    /* 이름·학교·학년은 meta 에 없으면 기본정보(state.profile)에서 가져온다 —
       결론·코멘트 문장이 '학생 학생은' 으로 나가지 않게. */
    name: meta.name || (state.profile && state.profile.name) || '',
    school: meta.school || (state.profile && state.profile.school) || '',
    grade: meta.grade || (state.profile && state.profile.grade) || '',
    gender: meta.gender || '',
    age: meta.age || null,
    testDate: ((meta&&meta.startedAt)? new Date(meta.startedAt).toISOString() : new Date().toISOString()),
    t16: type ? type.code : '',
    career: type ? (type.careers||[])[0]||'' : '',
    risk: 'low',
    scores: {
      P1,P2,P3,P4,P5,P6,P7,P8,P9,
      personality,
      /* 주의: 이 값은 지능검사 점수가 아니라 다중지능 자가평가 문항의 평균이다.
         IQ 척도로 환산하면 "자신감 있는 응답 = 높은 지능"으로 오독되므로 0~100 원지표를 그대로 쓴다. */
      miIndex: (function(){ var vv=Object.values(intel); if(!vv.length) return null;
        return Math.round(vv.reduce(function(s,x){return s+x;},0)/vv.length); })(),
      intel,
      riasec: riasec,
      aptitude: (function(){
        var subj=(state.results.learn&&state.results.learn.scores)||null;
        var it=intel||{};
        return {
          '인문': clamp(subj? avg(subj.korean,subj.english,subj.social,riasec.A,riasec.S) : avg(riasec.A,riasec.S,it.verbal,it.interpersonal)),
          '자연': clamp(subj? avg(subj.math,subj.science,riasec.I,it.logical) : avg(riasec.I,it.logical,it.naturalist)),
          '예능': clamp(subj? avg(subj.arts,riasec.A,it.spatial,it.musical) : avg(riasec.A,it.spatial,it.musical)),
          '체육': clamp(subj? avg(subj.pe,riasec.R,it.bodily,big5.E) : avg(riasec.R,it.bodily,big5.E))
        };
      })(),
      subjects: (state.results.learn && state.results.learn.scores) ? state.results.learn.scores : {
        korean:  clamp(avg(riasec.A, big5.O, big5.A)),
        math:    clamp(avg(riasec.I, big5.O, big5.C)),
        english: clamp(avg(riasec.A, riasec.I, big5.O)),
        social:  clamp(avg(riasec.S, big5.A, big5.E)),
        science: clamp(avg(riasec.I, riasec.R, big5.O)),
        arts:    clamp(avg(riasec.A, big5.O)),
        pe:      clamp(avg(riasec.R, big5.E))
      }
    }
  };
}

/* [2026-09-26] 인쇄 결과지 본문(#pia-report 2~10쪽)을 현재 응시자의 실제 결과로 채운다.
   예전에는 populateResult 가 '전체 결과지' 화면을 열 때만 불려서, 인쇄 버튼·열람코드·
   관리자 일괄 인쇄·샘플 경로 모두 표지만 실제 이름이고 본문은 test.html 에 박힌
   고정값(홍길동·한국중학교·인성 72점)이 그대로 나갔다.
   - 결과가 하나도 없으면 아무것도 하지 않는다(false).
   - 채운 뒤 내용이 바뀐 요소의 data-en/data-ko 를 지운다. 이 두 속성은 결과지
     언어 전환(pia-report-i18n.js)이 innerHTML 을 통째로 되돌리는 원본이라, 남겨 두면
     언어를 바꾸는 순간 고정 예시 문구(Hong Gil-dong …)로 되돌아간다.
     populateResult 는 _T() 로 현재 언어 문구를 직접 쓰므로 그 원본이 필요 없다. */
/* 한국어 조사 고르기 (2026-09-26)
   _piaJ(단어, a, b[, 영어모드 원문]) → 조사만 돌려준다. 받침이 있으면 a(은·이·을·과·으로), 없으면 b.
   '으로/로' 는 ㄹ 받침이면 '로'. 한글로 끝나지 않으면 'a(b)' 로 둘 다 적는다.
   영어 모드에서는 원래 쓰던 글자(orig, 없으면 'a(b)')를 그대로 돌려준다 — 교사용 소견처럼
   한국어로 만든 뒤 pia-report-en.js 사전으로 번역하는 문장이 사전 키와 계속 맞게 하려는 것. */
function _piaJ(word, a, b, orig){
  if(window.aipiaCurrentLang==='en') return (orig!=null) ? orig : (a+'('+b+')');
  var w=String(word==null?'':word).replace(/<[^>]*>/g,'').trim(), c=w.charCodeAt(w.length-1);
  if(!(c>=0xAC00 && c<=0xD7A3)) return a+'('+b+')';
  var jong=(c-0xAC00)%28;
  if(a==='으로') return (jong===0||jong===8) ? b : a;
  return jong ? a : b;
}
function _piaJosa(word, a, b){ return String(word==null?'':word)+_piaJ(word, a, b); }
/* 과목·다중지능 키(korean·logical…)를 화면 라벨로 — 교사용 문장에 키가 그대로 찍혔다 */
function _piaSubjLabel(k){ var m=_T({korean:'국어',math:'수학',english:'영어',social:'사회',science:'과학',arts:'예술',pe:'체육'},{korean:'Korean',math:'Math',english:'English',social:'Social Studies',science:'Science',arts:'Arts',pe:'P.E.'}); return m[k]||k; }
function _piaMiLabel(k){ var m=_T({verbal:'언어 지능',logical:'논리·수학 지능',spatial:'공간 지능',musical:'음악 지능',bodily:'신체·운동 지능',interpersonal:'대인관계 지능',intrapersonal:'자기성찰 지능',naturalist:'자연친화 지능'},{verbal:'Linguistic',logical:'Logical-Mathematical',spatial:'Spatial',musical:'Musical',bodily:'Bodily-Kinesthetic',interpersonal:'Interpersonal',intrapersonal:'Intrapersonal',naturalist:'Naturalist'}); return m[k]||k; }
/* populateResult 가 손대지 않던 2~3쪽의 고정 예시값을 실제 점수에 맞춘다. (2026-09-26)
   - 항목별 요약표의 '점수 그래프' 숫자(막대 길이만 바뀌고 숫자는 85·64… 그대로였다)
   - 응답 신뢰도 행(88점 고정) → 결과 정확도 종합 점수(piaAccuracyScore)
   - 종합 의견 장점·권장사항 → 점수 상·하위 차원으로 생성
   - 항목 카드의 '상태 판독' 칸과 강점/주의 상자 → 등급에 맞춘다
     (C 등급인데 '매우 양호', '강점 영역: 탁월' 로 찍히던 모순) */
function _piaFillReportFixedBits(root, sc){
  var PK=['P1','P2','P3','P4','P5','P6','P7','P8','P9'];
  var LAB={P1:_T('공감 능력','Empathy'),P2:_T('자기통제','Self-Control'),P3:_T('도덕성','Morality'),P4:_T('사회성','Sociability'),P5:_T('책임감','Responsibility'),P6:_T('정서안정','Emotional Stability'),P7:_T('리더십','Leadership'),P8:_T('창의성','Creativity'),P9:_T('진로성숙','Career Maturity')};
  function v(p){ var x=sc[p]; return (x==null||isNaN(x))?70:Math.round(x); }
  /* 요약표 막대 옆 숫자 */
  var pTbl=document.getElementById('p-summary-table');
  if(pTbl){ pTbl.querySelectorAll('tr:not(:first-child)').forEach(function(row,i){ var p=PK[i]; if(!p) return; var sp=row.querySelector('.mini-bar-wrap > span'); if(sp) sp.textContent=v(p); }); }
  /* 응답 신뢰도 */
  var acc=null; try{ acc=(typeof piaAccuracyScore==='function')?piaAccuracyScore():null; }catch(e){ acc=null; }
  var rel=root.querySelector('[data-p2rel]');
  if(rel && acc && typeof acc.total==='number'){
    var t=Math.max(0,Math.min(100,Math.round(acc.total)));
    rel.textContent=t;
    var rb=root.querySelector('[data-p2relbar]'); if(rb){ var f=rb.querySelector('.prog-bar-fill'); if(f) f.style.width=t+'%'; var pv=rb.querySelector('.prog-bar-val'); if(pv) pv.textContent=t; }
    var rg=root.querySelector('[data-p2relg]'); if(rg){ var g=getGrade(t); rg.className='grade-box '+g.cls; rg.textContent=g.label; }
  }
  /* 종합 의견 */
  var ord=PK.slice(0,9).sort(function(a,b){ return v(b)-v(a); });
  var hi=ord.slice(0,2), lo=ord.slice(-2).reverse();
  var cs=root.querySelector('[data-p2cmt="strength"]');
  if(cs) cs.textContent=_T(
    LAB[hi[0]]+'('+v(hi[0])+'점)·'+LAB[hi[1]]+'('+v(hi[1])+'점) 영역이 상대적으로 높게 나타났습니다. 이 강점을 살릴 수 있는 역할과 활동을 맡겨 보세요.',
    LAB[hi[0]]+' ('+v(hi[0])+' pts) and '+LAB[hi[1]]+' ('+v(hi[1])+' pts) are relatively strong. Offer roles and activities that make use of these strengths.');
  var ci=root.querySelector('[data-p2cmt="improve"]');
  if(ci) ci.textContent=_T(
    LAB[lo[0]]+'('+v(lo[0])+'점)·'+LAB[lo[1]]+'('+v(lo[1])+'점) 영역은 상대적으로 낮습니다. 작은 목표부터 꾸준히 연습하도록 격려하고 지도해 주세요.',
    LAB[lo[0]]+' ('+v(lo[0])+' pts) and '+LAB[lo[1]]+' ('+v(lo[1])+' pts) are relatively lower. Encourage steady practice starting with small goals.');
  /* 정서 스크리닝 해석 칸 — 등급만 바뀌고 문구는 '양호합니다' 로 고정돼 있었다 */
  (function(){
    function word(lv){ return lv==='HIGH'?_T('도움이 필요한 신호입니다. 보호자와 공유하고 Wee클래스·청소년상담 1388 등 전문 상담 연계를 권장합니다.','A sign that support may be needed. Share with the guardian and connect to professional counseling (e.g., Wee Class, 1388).')
      :lv==='MEDIUM'?_T('주의 신호가 있습니다. 정기적으로 살펴보고 필요하면 상담 선생님과 이야기해 보세요.','Some warning signs. Check in regularly and talk with a school counselor if needed.')
      :lv==='LOW'?_T('생활 리듬·수면을 가볍게 관찰해 주세요.','Keep a light eye on daily rhythm and sleep.')
      :_T('유의 수준 이하로 안정적입니다.','Below the clinical threshold; stable.'); }
    [['sc-cesd','cesd'],['sc-phqa','phqa'],['sc-gad','gad']].forEach(function(x){
      var e=document.getElementById(x[0]); var tr=e&&e.closest('tr'); if(!tr) return;
      var z=state.results[x[1]]&&state.results[x[1]].scores; var c=tr.cells[tr.cells.length-1];
      if(c) c.textContent = z ? word(z.level) : '\u2014';
    });
  })();
  /* 진로 추천 Top5 — 통합유형 직업이 3~4개뿐이라 4·5위와 '관련 계열·적합 근거' 칸이
     고정 예시(언론인·음악 치료사 / 언어지능 A+ …)로 남았다. 실측 근거로 채운다. */
  (function(){
    var ty=null; try{ ty=inferIntegratedType(); }catch(e){}
    var tyName=ty?_typeField(ty,'name'):'';
    var rows=[];
    (ty?_typeField(ty,'careers'):[]).forEach(function(c){ rows.push({job:c, track:_T(tyName+' 유형', tyName+' type'), why:_T('통합유형 \u2018'+tyName+'\u2019 대표 직업', 'Representative job for the \u2018'+tyName+'\u2019 type')}); });
    var ri=sc.riasec||{}; var ord2=Object.keys(ri).sort(function(a,b){ return ri[b]-ri[a]; });
    var rn={R:_T('현실형','Realistic'),I:_T('탐구형','Investigative'),A:_T('예술형','Artistic'),S:_T('사회형','Social'),E:_T('진취형','Enterprising'),C:_T('관습형','Conventional')};
    var CAR=(window.aipiaCurrentLang==='en' && typeof RIASEC_CAREER_EN!=='undefined') ? RIASEC_CAREER_EN : (typeof RIASEC_CAREER!=='undefined'?RIASEC_CAREER:{});
    for(var oi=0; oi<ord2.length && rows.length<5; oi++){
      var cc=CAR[ord2[oi]]; if(!cc||!cc.jobs) continue;
      for(var ji=0; ji<cc.jobs.length && rows.length<5; ji++){
        var j=cc.jobs[ji]; if(rows.some(function(r){ return r.job===j; })) continue;
        rows.push({job:j, track:cc.track||'', why:_T('진로흥미 '+rn[ord2[oi]]+'('+ord2[oi]+') '+Math.round(ri[ord2[oi]])+'점', 'Career interest '+rn[ord2[oi]]+' ('+ord2[oi]+') '+Math.round(ri[ord2[oi]])+' pts')});
      }
    }
    for(var k=0;k<5;k++){
      var c1=document.getElementById('top5-'+(k+1)); var tr=c1&&c1.closest('tr'); if(!tr) continue;
      var r=rows[k];
      c1.textContent = r ? r.job : '\u2014';
      if(tr.cells[2]) tr.cells[2].textContent = r ? r.track : '\u2014';
      if(tr.cells[3]) tr.cells[3].textContent = r ? r.why : '\u2014';
    }
  })();
  /* 종합 결론 표의 '비고' 칸 — 점수·등급만 바뀌고 비고는 '언어·대인지능 탁월/인문계열 최적합' 고정이었다 */
  (function(){
    function note(id, txt){ var e=document.getElementById(id); var tr=e&&e.closest('tr'); var c=tr&&tr.cells[tr.cells.length-1]; if(c&&txt) c.textContent=txt; }
    var hiP=ord[0], loP=ord[ord.length-1];
    note('cc-pers-sc', _T(LAB[hiP]+' 강점, '+LAB[loP]+' 보완 필요', LAB[hiP]+' is a strength; '+LAB[loP]+' needs support'));
    var it=sc.intel||{}, mk=Object.keys(it).filter(function(k){ return it[k]!=null; }).sort(function(a,b){ return it[b]-it[a]; });
    if(mk.length) note('cc-iq-sc', _T(_piaMiLabel(mk[0])+' 우세', _piaMiLabel(mk[0])+' is strongest'));
    var ap=sc.aptitude||{}, ak=Object.keys(ap).sort(function(a,b){ return ap[b]-ap[a]; });
    var trEn={'인문':'Humanities','자연':'Sciences','예능':'Arts','체육':'Physical Education'};
    if(ak.length) note('cc-apt-sc', _T(ak[0]+'계열 적합도가 가장 높음', 'Best fit: '+(trEn[ak[0]]||ak[0])+' track'));
    var sj=sc.subjects||{}, sk=Object.keys(sj).sort(function(a,b){ return sj[b]-sj[a]; });
    if(sk.length>=2) note('cc-learn-sc', _T(_piaSubjLabel(sk[0])+'·'+_piaSubjLabel(sk[1])+' 강세', 'Strong in '+_piaSubjLabel(sk[0])+' & '+_piaSubjLabel(sk[1])));
    if(ak.length) note('cc-all-sc', _T(ak[0]+'계열 중심으로 진로 탐색 권장', 'Explore careers around the '+(trEn[ak[0]]||ak[0])+' track'));
  })();
  /* 항목 카드: 상태 판독 칸 + 강점/주의 상자 */
  function stateWord(x){ var g=getGrade(x).label; return g==='A+'?_T('매우 양호','Very good'):(g==='A'||g==='B+')?_T('양호','Good'):g==='B'?_T('보통','Average'):g==='C'?_T('주의','Caution'):_T('관심 필요','Needs attention'); }
  PK.forEach(function(p){
    var hg=root.querySelector('[data-headgrade="'+p+'"]'); if(!hg) return;
    var card=hg.closest('.item-card'); if(!card) return;
    var x=v(p);
    var tb=card.querySelector('table.data-table');
    if(tb && tb.rows.length>=2){
      var ths=tb.rows[0].cells, col=-1;
      for(var i=0;i<ths.length;i++){ var k=ths[i].getAttribute('data-i18n')||''; if(k==='th.stateRead'||k==='th.state') col=i; }
      var cell=(col>=0)?tb.rows[1].cells[col]:null; if(cell) cell.textContent=stateWord(x);
    }
    var box=card.querySelector('.alert-box');
    if(box){
      if(!box.hasAttribute('data-orig-pos')) box.setAttribute('data-orig-pos', /e8f5e9/i.test(box.getAttribute('style')||'') ? 'strength' : 'caution');
      var pos=box.getAttribute('data-orig-pos'), band=x>=75?'high':(x<55?'low':'mid');
      var match=(pos==='strength'&&band==='high')||(pos==='caution'&&band==='low');
      if(!match){
        box.innerHTML='';
        var st=document.createElement('strong');
        var msg=document.createTextNode('');
        if(band==='high'){ st.textContent=_T('※ 강점 : ','※ Strength: '); msg.nodeValue=_T(LAB[p]+' 점수가 높은 편입니다('+x+'점). 이 강점을 살리는 역할을 맡겨 보세요.', LAB[p]+' is relatively high ('+x+' pts). Try roles that use this strength.'); box.setAttribute('style','background:#e8f5e9;border-color:#a5d6a7;color:#1b5e20;'); }
        else if(band==='low'){ st.textContent=_T('※ 주의 : ','※ Caution: '); msg.nodeValue=_T(LAB[p]+' 점수가 낮은 편입니다('+x+'점). 관심을 갖고 지켜봐 주시고, 필요하면 상담 선생님과 이야기해 보세요.', LAB[p]+' is relatively low ('+x+' pts). Keep an eye on it and talk with a counselor if needed.'); box.removeAttribute('style'); }
        else { st.textContent=_T('※ 참고 : ','※ Note: '); msg.nodeValue=_T(_piaJosa(LAB[p],'은','는')+' 평균 수준입니다('+x+'점). 작은 목표로 꾸준히 연습하면 더 성장할 수 있습니다.', LAB[p]+' is at an average level ('+x+' pts). Steady practice with small goals will help it grow.'); box.setAttribute('style','background:#f5f5f4;border-color:#d6d3d1;color:#44403c;'); }
        box.appendChild(st); box.appendChild(msg);
      }
    }
  });
}
function piaFillReportBody(){
  if (typeof hasAnyResult === 'function' && !hasAnyResult()) return false;
  var root = document.getElementById('pia-report'); if (!root) return false;
  var before = [];
  root.querySelectorAll('[data-en]').forEach(function(e){ before.push([e, e.innerHTML]); });
  var d = mapAiPiaToResultData();
  populateResult(d);
  var sc = d.scores || {};
  try{ buildRadar('radar-svg',[sc.P7||70, sc.P6||70, sc.P2||70, sc.P5||70, sc.P4||70]); }catch(e){ console.error('레이더 그리기 실패', e); }
  try{ _piaFillReportFixedBits(root, sc); }catch(e){ console.error('결과지 고정 문구 채우기 실패', e); }
  before.forEach(function(p){ if (p[0].innerHTML !== p[1]) { p[0].removeAttribute('data-en'); p[0].removeAttribute('data-ko'); } });
  return true;
}

// E: 전체 검사 완료 여부 — 13종 전부 끝나야 통합 결과지 권장.
function missingAllTests(){
  var R = state.results;
  var dc = (typeof _likertDoneCount==='function') ? _likertDoneCount : function(k){ var a=(R[k]&&R[k].answers)||[]; var n=0; for(var i=0;i<a.length;i++){if(a[i]!==undefined&&a[i]!==null)n++;} return n; };
  var defs = [
    { id:'big5',   label:'IPIP Big5-50',     done:function(){ return dc('big5')>=50; } },
    { id:'riasec', label:_T('RIASEC 진로흥미','RIASEC Career Interest'),  done:function(){ return dc('riasec')>=30; } },
    { id:'via',    label:_T('VIA 성격강점','VIA Character Strengths'),     done:function(){ return dc('via')>=24; } },
    { id:'grit',   label:_T('Grit 끈기','Grit'),        done:function(){ return dc('grit')>=8; } },
    { id:'sjt',    label:_T('SJT 상황판단','SJT Situational Judgment'),     done:function(){ return (R.sjt&&R.sjt.answers&&R.sjt.answers.length>=15); } },
    { id:'cesd',   label:_T('CES-D 우울','CES-D Depression'),       done:function(){ return !!(R.cesd&&R.cesd.scores); } },
    { id:'phqa',   label:_T('PHQ-A 우울','PHQ-A Depression'),       done:function(){ return !!(R.phqa&&R.phqa.scores); } },
    { id:'gad',    label:_T('GAD-7 불안','GAD-7 Anxiety'),       done:function(){ return !!(R.gad&&R.gad.scores); } },
    { id:'who5',   label:_T('WHO-5 웰빙','WHO-5 Well-Being'),       done:function(){ return !!(R.who5&&R.who5.scores); } },
    { id:'rses',   label:_T('RSES 자존감','RSES Self-Esteem'),      done:function(){ return !!(R.rses&&R.rses.scores); } },
    { id:'learn',  label:_T('학습역량','Learning Competency'),         done:function(){ return dc('learn')>=14; } },
    { id:'mi',     label:_T('다중지능(MI)','Multiple Intelligences (MI)'),     done:function(){ return dc('mi')>=16; } },
    { id:'conv',   label:_T('자유대화','Free Conversation'),         done:function(){ return (R.conv&&R.conv.turns >= 12); } }
  ];
  return defs.filter(function(t){ var ok=false; try{ ok=t.done(); }catch(e){} return !ok; });
}

function openFullReport() {
  const _miss = (typeof missingRequired==='function') ? missingRequired() : [];
  if (_miss.length > 0) {
    var _m1=_T('필수 검사(','You can view the full report after completing all required tests (') + _miss.map(function(t){return t.label;}).join(', ') + _T(')를 모두 마친 뒤 전체 결과지를 볼 수 있어요.',').');
    if(window.showToast) showToast(_m1); else console.error(_m1);
    console.error('[전체 결과지] 필수 검사 미완료:', _miss.map(function(t){return t.id;}));
    showView('result');
    return;
  }
  // E: 전체 검사 완료 게이트 — 미완료면 남은 목록 안내. 그래도 보길 원하면 진행(영구 차단 X).
  var _missAll = (typeof missingAllTests==='function') ? missingAllTests() : [];
  if (_missAll.length > 0) {
    var _names = _missAll.map(function(t){ return t.label; }).join(', ');
    var _m2=_T('전체 결과지는 모든 검사를 마쳐야 열려요. 남은 검사 '+_missAll.length+'개: '+_names,'The full report unlocks once you finish every test. '+_missAll.length+' remaining: '+_names);
    if(window.showToast) showToast(_m2); else console.error(_m2);
    console.error('[전체 결과지] 남은 검사:', _missAll.map(function(t){return t.id;}));
    showView('result'); return;
  }
  showView('fullreport');
  setTimeout(()=>{
    /* populateResult 가 이미 인성 종합 마커를 넣는다. 여기서 또 넣으면 마커가 두 벌 찍혔다. */
    try{ piaFillReportBody(); }catch(e){ console.error('결과지 본문 채우기 실패', e); }
    var _fw=document.getElementById('fullreport-wrap'); if(_fw && _fw.scrollTo) _fw.scrollTo(0,0);
  }, 80);
}



/* [CSP 2026-09-29] 인라인 이벤트 속성(onclick=…)에 들어 있던 식을 함수로 옮김 — 버튼은 data-act 로 부른다(web/csp-actions.js). */
window.piaPrintCoverOnly = function(){ document.querySelectorAll('.page').forEach(function(p, i){ p.style.display = i === 0 ? '' : 'none'; }); };
window.piaPrintShowAll = function(){ document.querySelectorAll('.page').forEach(function(p){ p.style.display = ''; }); };
window.piaImportFile = function(inp){ if (inp && inp.files && inp.files[0]) importAllData(inp.files[0]); };
window.piaResetAllData = function(){
  if (!confirm('모든 데이터를 삭제할까요?')) return;
  try { Object.keys(localStorage).forEach(function(k){ if (k.indexOf('pia_v3_') === 0) localStorage.removeItem(k); }); } catch (e) {}
  sessionStorage.clear(); location.reload();
};
window.piaCopySelfIntro = function(btn){ var t = document.getElementById('self-intro-text'); window.piaSafeCopy(t ? t.value : '', btn, '\u2713 복사됨'); };
window.piaDownloadSelfIntro = function(){
  var el = document.getElementById('self-intro-text'); var t = el ? el.value : '';
  var nm = '학생'; try { nm = (state.profile && state.profile.name) || '학생'; } catch (e) {}
  var b = new Blob([t], { type: 'text/plain;charset=utf-8' }); var a = document.createElement('a');
  a.href = URL.createObjectURL(b); a.download = '자기소개서_' + nm + '.txt'; a.click();
};
window.piaExitGroupHome = function(){ try { window._piaGroupMode = false; } catch (e) {} try { showView('home'); } catch (e) {} };
